
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("aUeuo", function(module, exports) {
"use strict";
var $7b146facd02643f3$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7b146facd02643f3$var$React = $7b146facd02643f3$var$__importStar((parcelRequire("acw62")));

var $9W56x = parcelRequire("9W56x");
/**
 * Adds ability to scroll to a child component with an ID corresponding to a URL hash ID
 */ var $7b146facd02643f3$var$HashLinkObserver = function(_a) {
    var isPageLoading = _a.isPageLoading, _b = _a.smoothScroll, smoothScroll = _b === void 0 ? true : _b;
    var scrollIntoViewOptions = smoothScroll ? {
        behavior: 'smooth'
    } : undefined;
    /**
     * If there is a hash ID in the URL scroll to the corresponding element if it exists, otherwise:
     *  - create a new observer to check for the element when the DOM changes (loads)
     *  - set a timeout that will disconnect the observer
     */ $7b146facd02643f3$var$React.useEffect(function() {
        var OBSERVER_TIMEOUT_MS = 5000;
        var hash = window.location.hash;
        var loadingObserver;
        var observerTimeout;
        if (!hash || isPageLoading) return;
        var elementId = hash.slice(1);
        var element = document.getElementById(elementId);
        if (element) {
            element.setAttribute('tabindex', '-1');
            element.scrollIntoView(scrollIntoViewOptions);
            element.focus();
            return;
        }
        // If there is a hash ID but no element, re-check after each DOM mutation
        loadingObserver = new MutationObserver(function(_, observer) {
            var missingElement = document.getElementById(elementId);
            if (missingElement) {
                missingElement.setAttribute('tabindex', '-1');
                missingElement.scrollIntoView(scrollIntoViewOptions);
                missingElement.focus();
                $9W56x.resetLoadingObserver(observer, observerTimeout);
            }
        });
        loadingObserver.observe(document, {
            childList: true,
            subtree: true
        });
        // Disconnect the observer after `OBSERVER_TIMEOUT_MS`
        observerTimeout = window.setTimeout(function() {
            return $9W56x.disconnectMutationObserver(loadingObserver);
        }, OBSERVER_TIMEOUT_MS);
        return function() {
            $9W56x.resetLoadingObserver(loadingObserver, observerTimeout);
        };
    }, [
        window.location.href,
        isPageLoading
    ]);
    return null;
};
module.exports.default = $7b146facd02643f3$var$HashLinkObserver;

});
parcelRegister("9W56x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.disconnectMutationObserver = function(observer) {
    if (observer) observer.disconnect();
};
module.exports.resetLoadingObserver = function(loadingObserver, observerTimeout) {
    module.exports.disconnectMutationObserver(loadingObserver);
    window.clearTimeout(observerTimeout);
};

});


parcelRegister("eXyb6", function(module, exports) {
"use strict";
var $ae41166bcbd66e1e$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $ae41166bcbd66e1e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae41166bcbd66e1e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ae41166bcbd66e1e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $ae41166bcbd66e1e$var$ALL_INITIALIZERS = [];
var $ae41166bcbd66e1e$var$READY_INITIALIZERS = [];
function $ae41166bcbd66e1e$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $ae41166bcbd66e1e$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $ae41166bcbd66e1e$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $ae41166bcbd66e1e$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $ae41166bcbd66e1e$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $ae41166bcbd66e1e$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $ae41166bcbd66e1e$var$render(loaded, props) {
    return $acw62.createElement($ae41166bcbd66e1e$var$resolve(loaded), props);
}
function $ae41166bcbd66e1e$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $ae41166bcbd66e1e$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $ae41166bcbd66e1e$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $ae41166bcbd66e1e$var$READY_INITIALIZERS.push(function() {
        if ($ae41166bcbd66e1e$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $ae41166bcbd66e1e$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $ae41166bcbd66e1e$var$_classCallCheck(this, LoadableComponent);
            var _this = $ae41166bcbd66e1e$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $acw62.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($acw62.Component), _class.contextTypes = {
        loadable: $c9Z8w.shape({
            report: $c9Z8w.func.isRequired
        })
    }, _temp;
}
function $ae41166bcbd66e1e$var$Loadable(opts) {
    return $ae41166bcbd66e1e$var$createLoadableComponent($ae41166bcbd66e1e$var$load, opts);
}
function $ae41166bcbd66e1e$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $ae41166bcbd66e1e$var$createLoadableComponent($ae41166bcbd66e1e$var$loadMap, opts);
}
$ae41166bcbd66e1e$var$Loadable.Map = $ae41166bcbd66e1e$var$LoadableMap;
var $ae41166bcbd66e1e$var$Capture = function(_React$Component2) {
    $ae41166bcbd66e1e$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $ae41166bcbd66e1e$var$_classCallCheck(this, Capture);
        return $ae41166bcbd66e1e$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $acw62.Children.only(this.props.children);
    };
    return Capture;
}($acw62.Component);
$ae41166bcbd66e1e$var$Capture.propTypes = {
    report: $c9Z8w.func.isRequired
};
$ae41166bcbd66e1e$var$Capture.childContextTypes = {
    loadable: $c9Z8w.shape({
        report: $c9Z8w.func.isRequired
    }).isRequired
};
$ae41166bcbd66e1e$var$Loadable.Capture = $ae41166bcbd66e1e$var$Capture;
function $ae41166bcbd66e1e$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $ae41166bcbd66e1e$var$flushInitializers(initializers);
    });
}
$ae41166bcbd66e1e$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $ae41166bcbd66e1e$var$flushInitializers($ae41166bcbd66e1e$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$ae41166bcbd66e1e$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $ae41166bcbd66e1e$var$flushInitializers($ae41166bcbd66e1e$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $ae41166bcbd66e1e$var$Loadable;

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});




parcelRegister("imDot", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.MetaContext = void 0;

var $d5e8d6dc3f3450a1$var$_react = $d5e8d6dc3f3450a1$var$_interopRequireWildcard((parcelRequire("acw62")));
function $d5e8d6dc3f3450a1$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $d5e8d6dc3f3450a1$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d5e8d6dc3f3450a1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d5e8d6dc3f3450a1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d5e8d6dc3f3450a1$var$_typeof(obj);
}
function $d5e8d6dc3f3450a1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d5e8d6dc3f3450a1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d5e8d6dc3f3450a1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d5e8d6dc3f3450a1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d5e8d6dc3f3450a1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d5e8d6dc3f3450a1$var$_possibleConstructorReturn(self, call) {
    if (call && ($d5e8d6dc3f3450a1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d5e8d6dc3f3450a1$var$_assertThisInitialized(self);
}
function $d5e8d6dc3f3450a1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d5e8d6dc3f3450a1$var$_getPrototypeOf(o) {
    $d5e8d6dc3f3450a1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d5e8d6dc3f3450a1$var$_getPrototypeOf(o);
}
function $d5e8d6dc3f3450a1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d5e8d6dc3f3450a1$var$_setPrototypeOf(subClass, superClass);
}
function $d5e8d6dc3f3450a1$var$_setPrototypeOf(o, p) {
    $d5e8d6dc3f3450a1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d5e8d6dc3f3450a1$var$_setPrototypeOf(o, p);
}
var $d5e8d6dc3f3450a1$var$MetaContext = (0, $d5e8d6dc3f3450a1$var$_react.createContext)({});
/** context class which passes extract fuunction to MetaTags Component **/ module.exports.MetaContext = $d5e8d6dc3f3450a1$var$MetaContext;
var $d5e8d6dc3f3450a1$var$MetaContextProviderWrapper = /*#__PURE__*/ function(_Component) {
    $d5e8d6dc3f3450a1$var$_inherits(MetaContextProviderWrapper, _Component);
    function MetaContextProviderWrapper() {
        $d5e8d6dc3f3450a1$var$_classCallCheck(this, MetaContextProviderWrapper);
        return $d5e8d6dc3f3450a1$var$_possibleConstructorReturn(this, $d5e8d6dc3f3450a1$var$_getPrototypeOf(MetaContextProviderWrapper).apply(this, arguments));
    }
    $d5e8d6dc3f3450a1$var$_createClass(MetaContextProviderWrapper, [
        {
            key: "render",
            value: function render() {
                return $d5e8d6dc3f3450a1$var$_react.default.createElement($d5e8d6dc3f3450a1$var$MetaContext.Provider, {
                    value: {
                        extract: this.props.extract
                    }
                }, $d5e8d6dc3f3450a1$var$_react.Children.only(this.props.children));
            }
        }
    ]);
    return MetaContextProviderWrapper;
}($d5e8d6dc3f3450a1$var$_react.Component);
var $d5e8d6dc3f3450a1$var$_default = $d5e8d6dc3f3450a1$var$MetaContextProviderWrapper;
module.exports.default = $d5e8d6dc3f3450a1$var$_default;

});

parcelRegister("9aJ2W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ad7fd7ea5a1acdc$var$_react = $6ad7fd7ea5a1acdc$var$_interopRequireWildcard((parcelRequire("acw62")));

var $6ad7fd7ea5a1acdc$var$_reactDom = $6ad7fd7ea5a1acdc$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $jMeyL = parcelRequire("jMeyL");

var $imDot = parcelRequire("imDot");
function $6ad7fd7ea5a1acdc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6ad7fd7ea5a1acdc$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $6ad7fd7ea5a1acdc$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6ad7fd7ea5a1acdc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6ad7fd7ea5a1acdc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6ad7fd7ea5a1acdc$var$_typeof(obj);
}
function $6ad7fd7ea5a1acdc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6ad7fd7ea5a1acdc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6ad7fd7ea5a1acdc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6ad7fd7ea5a1acdc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6ad7fd7ea5a1acdc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6ad7fd7ea5a1acdc$var$_possibleConstructorReturn(self, call) {
    if (call && ($6ad7fd7ea5a1acdc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6ad7fd7ea5a1acdc$var$_assertThisInitialized(self);
}
function $6ad7fd7ea5a1acdc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6ad7fd7ea5a1acdc$var$_getPrototypeOf(o) {
    $6ad7fd7ea5a1acdc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6ad7fd7ea5a1acdc$var$_getPrototypeOf(o);
}
function $6ad7fd7ea5a1acdc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6ad7fd7ea5a1acdc$var$_setPrototypeOf(subClass, superClass);
}
function $6ad7fd7ea5a1acdc$var$_setPrototypeOf(o, p) {
    $6ad7fd7ea5a1acdc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6ad7fd7ea5a1acdc$var$_setPrototypeOf(o, p);
}
function $6ad7fd7ea5a1acdc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/** An wrapper component to wrap element which need to shifted to head **/ var $6ad7fd7ea5a1acdc$var$MetaTags = /*#__PURE__*/ function(_Component) {
    $6ad7fd7ea5a1acdc$var$_inherits(MetaTags, _Component);
    function MetaTags() {
        $6ad7fd7ea5a1acdc$var$_classCallCheck(this, MetaTags);
        return $6ad7fd7ea5a1acdc$var$_possibleConstructorReturn(this, $6ad7fd7ea5a1acdc$var$_getPrototypeOf(MetaTags).apply(this, arguments));
    }
    $6ad7fd7ea5a1acdc$var$_createClass(MetaTags, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.temporaryElement = document.createElement('div');
                this.handleChildrens();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(oldProps) {
                if (oldProps.children !== this.props.children) this.handleChildrens();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.temporaryElement) $6ad7fd7ea5a1acdc$var$_reactDom.default.unmountComponentAtNode(this.temporaryElement);
            }
        },
        {
            key: "extractChildren",
            value: function extractChildren() {
                var extract = this.context.extract;
                var children = this.props.children;
                if (!children) return;
                if (extract) extract(children);
            }
        },
        {
            key: "handleChildrens",
            value: function handleChildrens() {
                var _this = this;
                var children = this.props.children;
                if (this.context.extract || !children) return;
                var headComponent = $6ad7fd7ea5a1acdc$var$_react.default.createElement("div", {
                    className: "react-head-temp"
                }, children);
                $6ad7fd7ea5a1acdc$var$_reactDom.default.render(headComponent, this.temporaryElement, function() {
                    var childStr = _this.temporaryElement.innerHTML; //if html is not changed return
                    if (_this.lastChildStr === childStr) return;
                    _this.lastChildStr = childStr;
                    var tempHead = _this.temporaryElement.querySelector('.react-head-temp'); // .react-head-temp might not exist when triggered from async action
                    if (tempHead === null) return;
                    var childNodes = Array.prototype.slice.call(tempHead.children);
                    var head = document.head;
                    var headHtml = head.innerHTML; //filter children remove if children has not been changed
                    childNodes = childNodes.filter(function(child) {
                        return headHtml.indexOf(child.outerHTML) === -1;
                    }); //create clone of childNodes
                    childNodes = childNodes.map(function(child) {
                        return child.cloneNode(true);
                    }); //remove duplicate title and meta from head
                    childNodes.forEach(function(child) {
                        var tag = child.tagName.toLowerCase();
                        if (tag === 'title') {
                            var title = (0, $jMeyL.getDuplicateTitle)();
                            if (title) (0, $jMeyL.removeChild)(head, title);
                        } else if (child.id) {
                            // if the element has id defined remove the existing element with that id
                            var elm = (0, $jMeyL.getDuplicateElementById)(child);
                            if (elm) (0, $jMeyL.removeChild)(head, elm);
                        } else if (tag === 'meta') {
                            var meta = (0, $jMeyL.getDuplicateMeta)(child);
                            if (meta) (0, $jMeyL.removeChild)(head, meta);
                        } else if (tag === 'link' && child.rel === 'canonical') {
                            var link = (0, $jMeyL.getDuplicateCanonical)(child);
                            if (link) (0, $jMeyL.removeChild)(head, link);
                        }
                    });
                    (0, $jMeyL.appendChild)(document.head, childNodes);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                this.extractChildren();
                return null;
            }
        }
    ]);
    return MetaTags;
}($6ad7fd7ea5a1acdc$var$_react.Component);
$6ad7fd7ea5a1acdc$var$_defineProperty($6ad7fd7ea5a1acdc$var$MetaTags, "contextType", $imDot.MetaContext);
var $6ad7fd7ea5a1acdc$var$_default = $6ad7fd7ea5a1acdc$var$MetaTags;
module.exports.default = $6ad7fd7ea5a1acdc$var$_default;
module.exports = module.exports.default;

});
parcelRegister("jMeyL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filterAndArrangeTags = $e65dcb4a37fce20a$var$filterAndArrangeTags;
module.exports.getDuplicateTitle = $e65dcb4a37fce20a$var$getDuplicateTitle;
module.exports.getDuplicateCanonical = $e65dcb4a37fce20a$var$getDuplicateCanonical;
module.exports.getDuplicateElementById = $e65dcb4a37fce20a$var$getDuplicateElementById;
module.exports.getDuplicateMeta = $e65dcb4a37fce20a$var$getDuplicateMeta;
module.exports.appendChild = $e65dcb4a37fce20a$var$appendChild;
module.exports.removeChild = $e65dcb4a37fce20a$var$removeChild;
function $e65dcb4a37fce20a$var$_toConsumableArray(arr) {
    return $e65dcb4a37fce20a$var$_arrayWithoutHoles(arr) || $e65dcb4a37fce20a$var$_iterableToArray(arr) || $e65dcb4a37fce20a$var$_nonIterableSpread();
}
function $e65dcb4a37fce20a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $e65dcb4a37fce20a$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $e65dcb4a37fce20a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var $e65dcb4a37fce20a$var$camelCaseProps = [
    'itemProp'
];
var $e65dcb4a37fce20a$var$uniqueIdentifiersI = [
    'property',
    'name',
    'itemprop'
];
var $e65dcb4a37fce20a$var$uniqueIdentifiers = $e65dcb4a37fce20a$var$uniqueIdentifiersI.concat($e65dcb4a37fce20a$var$camelCaseProps); //case sensitive props is defined in case anyone defined the lowercase prop
var $e65dcb4a37fce20a$var$uniqueIdentifiersAll = $e65dcb4a37fce20a$var$uniqueIdentifiers.concat([
    'id'
]);
/**
  Note:
  1. In server side we will add meta tags and title at last after fitering
  2. In client we will match and replace meta tagString
  3. For now we will not support link and other tags properly, they can be added but we will not check for uniqueness and will not decide placement
**/ function $e65dcb4a37fce20a$var$filterOutMetaWithId(metas) {
    metas = Array.prototype.slice.call(metas || []);
    return metas.filter(function(meta) {
        return !meta.id;
    });
}
function $e65dcb4a37fce20a$var$filterAndArrangeTags(headElms) {
    var title = null;
    var canonicalLink = null;
    var metas = [];
    var rest = [];
    headElms.forEach(function(elm) {
        var type = elm.type, props = elm.props;
        if (type === 'title') title = elm;
        else if (type === 'link' && props.rel === 'canonical') canonicalLink = elm;
        else if (type === 'meta') metas.push(elm);
        else rest.push(elm);
    });
    return [
        title
    ].concat($e65dcb4a37fce20a$var$_toConsumableArray($e65dcb4a37fce20a$var$removeDuplicateMetas(metas)), [
        canonicalLink
    ], rest);
}
function $e65dcb4a37fce20a$var$removeDuplicateMetas(metas) {
    var addedMeta = {}; //initialize all the identifiers with empty array
    $e65dcb4a37fce20a$var$uniqueIdentifiersAll.forEach(function(identifier) {
        addedMeta[identifier] = [];
    });
    var filteredMetas = [];
    var _loop = function _loop(i) {
        var meta = metas[i];
        var id = meta.props.id;
        var addMeta = false; //if has id and element with id is not present than always add meta
        if (id) addMeta = !addedMeta.id[id]; //for any other unique identifier check if meta already available with same identifier which doesn't have id
        else addMeta = $e65dcb4a37fce20a$var$uniqueIdentifiers.filter(function(identifier) {
            var identifierValue = meta.props[identifier];
            var existing = addedMeta[identifier][identifierValue];
            return existing && !existing.props.id;
        }).length === 0;
        if (addMeta) {
            filteredMetas.unshift(meta); //add meta as added
            $e65dcb4a37fce20a$var$uniqueIdentifiersAll.forEach(function(identifier) {
                var identifierValue = meta.props[identifier];
                if (identifierValue) addedMeta[identifier][identifierValue] = meta;
            });
        }
    };
    for(var i = metas.length - 1; i >= 0; i--)_loop(i);
    return filteredMetas;
}
function $e65dcb4a37fce20a$var$getDuplicateTitle() {
    return document.head.querySelectorAll('title');
}
function $e65dcb4a37fce20a$var$getDuplicateCanonical() {
    return document.head.querySelectorAll('link[rel="canonical"]');
}
function $e65dcb4a37fce20a$var$getDuplicateElementById(_ref) {
    var id = _ref.id;
    return id && document.head.querySelector("#".concat(id));
}
function $e65dcb4a37fce20a$var$getDuplicateMeta(meta) {
    var head = document.head; //for any other unique identifier check if metas already available with same identifier which doesn't have id
    return $e65dcb4a37fce20a$var$uniqueIdentifiersI.reduce(function(duplicates, identifier) {
        var identifierValue = meta.getAttribute(identifier);
        return identifierValue ? duplicates.concat($e65dcb4a37fce20a$var$filterOutMetaWithId(head.querySelectorAll("[".concat(identifier, " = \"").concat(identifierValue, "\"]")))) : duplicates;
    }, []);
} //function to append childrens on a parent
function $e65dcb4a37fce20a$var$appendChild(parent, childrens) {
    if (childrens.length === undefined) childrens = [
        childrens
    ];
    var docFrag = document.createDocumentFragment(); //we used for loop instead of forEach because childrens can be array like object
    for(var i = 0, ln = childrens.length; i < ln; i++)docFrag.appendChild(childrens[i]);
    parent.appendChild(docFrag);
}
function $e65dcb4a37fce20a$var$removeChild(parent, childrens) {
    if (childrens.length === undefined) childrens = [
        childrens
    ];
    for(var i = 0, ln = childrens.length; i < ln; i++)parent.removeChild(childrens[i]);
}

});


parcelRegister("itGkt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d73bc5250ae224bd$var$_react = $d73bc5250ae224bd$var$_interopRequireWildcard((parcelRequire("acw62")));

var $d73bc5250ae224bd$var$_meta_tags = $d73bc5250ae224bd$var$_interopRequireDefault((parcelRequire("9aJ2W")));
function $d73bc5250ae224bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d73bc5250ae224bd$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $d73bc5250ae224bd$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d73bc5250ae224bd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d73bc5250ae224bd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d73bc5250ae224bd$var$_typeof(obj);
}
function $d73bc5250ae224bd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d73bc5250ae224bd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d73bc5250ae224bd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d73bc5250ae224bd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d73bc5250ae224bd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d73bc5250ae224bd$var$_possibleConstructorReturn(self, call) {
    if (call && ($d73bc5250ae224bd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d73bc5250ae224bd$var$_assertThisInitialized(self);
}
function $d73bc5250ae224bd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d73bc5250ae224bd$var$_getPrototypeOf(o) {
    $d73bc5250ae224bd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d73bc5250ae224bd$var$_getPrototypeOf(o);
}
function $d73bc5250ae224bd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d73bc5250ae224bd$var$_setPrototypeOf(subClass, superClass);
}
function $d73bc5250ae224bd$var$_setPrototypeOf(o, p) {
    $d73bc5250ae224bd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d73bc5250ae224bd$var$_setPrototypeOf(o, p);
}
var $d73bc5250ae224bd$var$ReactTitle = /*#__PURE__*/ function(_Component) {
    $d73bc5250ae224bd$var$_inherits(ReactTitle, _Component);
    function ReactTitle() {
        $d73bc5250ae224bd$var$_classCallCheck(this, ReactTitle);
        return $d73bc5250ae224bd$var$_possibleConstructorReturn(this, $d73bc5250ae224bd$var$_getPrototypeOf(ReactTitle).apply(this, arguments));
    }
    $d73bc5250ae224bd$var$_createClass(ReactTitle, [
        {
            key: "render",
            value: function render() {
                return $d73bc5250ae224bd$var$_react.default.createElement($d73bc5250ae224bd$var$_meta_tags.default, null, $d73bc5250ae224bd$var$_react.default.createElement("title", null, this.props.title));
            }
        }
    ]);
    return ReactTitle;
}($d73bc5250ae224bd$var$_react.Component);
var $d73bc5250ae224bd$var$_default = $d73bc5250ae224bd$var$ReactTitle;
module.exports.default = $d73bc5250ae224bd$var$_default;
module.exports = module.exports.default;

});

parcelRegister("8z6CC", function(module, exports) {
module.exports = new URL("Frame.3f96fd66.svg", import.meta.url).toString();

});

parcelRegister("6AQqg", function(module, exports) {
module.exports = new URL("Frame-1.7ad6bcfd.svg", import.meta.url).toString();

});

parcelRegister("5DSUi", function(module, exports) {
module.exports = new URL("Frame-2.65c33ab1.svg", import.meta.url).toString();

});

parcelRegister("8jhGt", function(module, exports) {
module.exports = new URL("Frame-3.fedca028.svg", import.meta.url).toString();

});

parcelRegister("5rSQu", function(module, exports) {
module.exports = new URL("Frame-4.a5bb7c8d.svg", import.meta.url).toString();

});

parcelRegister("iCD5j", function(module, exports) {
module.exports = new URL("What do you need to achieve your top priorities_ v1.65f55ff7.svg", import.meta.url).toString();

});

parcelRegister("fj9zO", function(module, exports) {
module.exports = new URL("What areas are actively trying to improve and just maintain in the next 12 months_ v1.5427d6df.svg", import.meta.url).toString();

});

parcelRegister("1FUBr", function(module, exports) {
module.exports = new URL("Col.5c8064f8.svg", import.meta.url).toString();

});

parcelRegister("jEPIq", function(module, exports) {
module.exports = new URL("What capabilities are your your top priorities to apply to different scopes_ v1.8d24db33.svg", import.meta.url).toString();

});

parcelRegister("1oJsB", function(module, exports) {
module.exports = new URL("combined.f637b25d.svg", import.meta.url).toString();

});

parcelRegister("h5vKV", function(module, exports) {
module.exports = new URL("Frame-6.17d4bfe5.svg", import.meta.url).toString();

});

parcelRegister("jYXsX", function(module, exports) {
module.exports = new URL("Frame-7.78e0fbe2.svg", import.meta.url).toString();

});

parcelRegister("lAdfU", function(module, exports) {
module.exports = new URL("Frame-8.935ea0f9.svg", import.meta.url).toString();

});

parcelRegister("gI6p9", function(module, exports) {
module.exports = new URL("Practitioners applying FinOps to AI are looking to \u201CUnderstand Cost\u201D and \u201CQuantify Value\u201D like additional infrastructure areas v1.02a798fa.svg", import.meta.url).toString();

});

parcelRegister("fEaot", function(module, exports) {
module.exports = new URL("Frame-5.be899fe1.svg", import.meta.url).toString();

});

parcelRegister("4kbyH", function(module, exports) {
'use strict';
module.exports = '3.14.0';

});

var $c39799eac5a15342$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["izUj7","index.0509314f.js","ec9LB","Saas.c9b6742c.svg","bh55r","Frame.3f96fd66.svg","2YlbA","Frame-1.7ad6bcfd.svg","hPAcz","Frame-2.65c33ab1.svg","3dHqf","Frame-3.fedca028.svg","1ADl0","Frame-4.a5bb7c8d.svg","2U4Rp","What do you need to achieve your top priorities_ v1.65f55ff7.svg","he7dE","What areas are actively trying to improve and just maintain in the next 12 months_ v1.5427d6df.svg","iJKAK","Col.5c8064f8.svg","iRU1U","What capabilities are your your top priorities to apply to different scopes_ v1.8d24db33.svg","3OO59","combined.f637b25d.svg","4B5z2","Frame-6.17d4bfe5.svg","5KRkh","Frame-7.78e0fbe2.svg","bvTCA","Frame-8.935ea0f9.svg","6mmxq","Practitioners applying FinOps to AI are looking to \u201CUnderstand Cost\u201D and \u201CQuantify Value\u201D like additional infrastructure areas v1.02a798fa.svg","4olvs","Frame-5.be899fe1.svg","6DLp3","Fix top left.28e39702.svg","3UIq0","Fix Bottom right.635459ac.svg"]'));

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;




var $acw62 = parcelRequire("acw62");
var $046f159811fdd774$exports = {};
"use strict";
var $046f159811fdd774$var$__importDefault = $046f159811fdd774$exports && $046f159811fdd774$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($046f159811fdd774$exports, "__esModule", {
    value: true
});

var $046f159811fdd774$var$HashLinkObserver_1 = $046f159811fdd774$var$__importDefault((parcelRequire("aUeuo")));
var $bec25ccd2f362c97$exports = {};
"use strict";
var $bec25ccd2f362c97$var$__importDefault = $bec25ccd2f362c97$exports && $bec25ccd2f362c97$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $bec25ccd2f362c97$var$__importStar = $bec25ccd2f362c97$exports && $bec25ccd2f362c97$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty($bec25ccd2f362c97$exports, "__esModule", {
    value: true
});

var $bec25ccd2f362c97$var$react_loadable_1 = $bec25ccd2f362c97$var$__importDefault((parcelRequire("eXyb6")));

var $bec25ccd2f362c97$var$AsyncHashLinkObserver = $bec25ccd2f362c97$var$react_loadable_1.default({
    loader: function() {
        return Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("aUeuo")));
        }).then(function(res) {
            return $bec25ccd2f362c97$var$__importStar(res);
        });
    },
    loading: function() {
        return null;
    }
});
$bec25ccd2f362c97$exports.default = $bec25ccd2f362c97$var$AsyncHashLinkObserver;


$046f159811fdd774$exports.AsyncHashLinkObserver = $bec25ccd2f362c97$exports.default;
$046f159811fdd774$exports.default = $046f159811fdd774$var$HashLinkObserver_1.default;


var $535c31c3ebc09f91$exports = {};
"use strict";
Object.defineProperty($535c31c3ebc09f91$exports, "__esModule", {
    value: true
});
Object.defineProperty($535c31c3ebc09f91$exports, "MetaTagsContext", {
    enumerable: true,
    get: function get() {
        return $535c31c3ebc09f91$var$_meta_tags_context.default;
    }
});
Object.defineProperty($535c31c3ebc09f91$exports, "MetaTags", {
    enumerable: true,
    get: function get() {
        return $535c31c3ebc09f91$var$_meta_tags.default;
    }
});
Object.defineProperty($535c31c3ebc09f91$exports, "ReactTitle", {
    enumerable: true,
    get: function get() {
        return $535c31c3ebc09f91$var$_react_title.default;
    }
});
$535c31c3ebc09f91$exports.default = void 0;

var $535c31c3ebc09f91$var$_meta_tags_context = $535c31c3ebc09f91$var$_interopRequireDefault((parcelRequire("imDot")));

var $535c31c3ebc09f91$var$_meta_tags = $535c31c3ebc09f91$var$_interopRequireDefault((parcelRequire("9aJ2W")));

var $535c31c3ebc09f91$var$_react_title = $535c31c3ebc09f91$var$_interopRequireDefault((parcelRequire("itGkt")));
function $535c31c3ebc09f91$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $535c31c3ebc09f91$var$_default = $535c31c3ebc09f91$var$_meta_tags.default;
$535c31c3ebc09f91$exports.default = $535c31c3ebc09f91$var$_default;


var $f4f9eb1d87bccaf3$exports = {};
$f4f9eb1d87bccaf3$exports = new URL("Saas.c9b6742c.svg", import.meta.url).toString();




var $acw62 = parcelRequire("acw62");
const $4f70e481f18f162f$var$N = ({ root: t, rootMargin: u, threshold: a, onChangeActiveId: d })=>{
    const [c, g] = (0, $acw62.useState)(null), n = (0, $acw62.useRef)([]);
    return (0, $acw62.useEffect)(()=>{
        const b = (s)=>{
            s.forEach((e)=>{
                const k = e.target.getAttribute("id"), o = n.current.find((h)=>h.id === k);
                o && (o.ratio = e.isIntersecting ? e.intersectionRatio : 0);
            });
            const i = Math.max(...n.current.map((e)=>e.ratio), 0.1), r = n.current.find((e)=>e.ratio === i);
            g(r && r.id), r && r.id && c !== r.id && typeof d == "function" && d(r.id, c);
        }, m = {
            root: t,
            rootMargin: u,
            threshold: a
        }, p = new IntersectionObserver(b, m);
        return n.current.forEach(({ id: s })=>{
            const i = document.getElementById(s);
            i && p.observe(i);
        }), ()=>{
            p.disconnect();
        };
    }, [
        n,
        t,
        u,
        a
    ]), {
        idsRef: n,
        activeLink: c
    };
}, $4f70e481f18f162f$var$O = (t)=>t.scrollHeight > t.clientHeight || t.scrollWidth > t.clientWidth ? t : t.parentElement ? $4f70e481f18f162f$var$O(t.parentElement) : document.scrollingElement || document.documentElement, $4f70e481f18f162f$export$2e2bcd8739ae039 = ({ activeClass: t = "", activeAttr: u = !1, offsetTop: a = 0, offsetLeft: d = 0, behavior: c = "smooth", root: g = null, rootMargin: n = "0px", threshold: b = [
    0,
    0.25,
    0.5,
    0.75,
    1
], onClickEach: m = null, onChangeActiveId: p = null, children: s = null })=>{
    const { idsRef: i, activeLink: r } = $4f70e481f18f162f$var$N({
        root: g,
        rootMargin: n,
        threshold: b,
        onChangeActiveId: p
    }), e = (k)=>(0, $acw62.Children).map(k, (o)=>{
            const { type: h, props: l } = o, { href: y, className: x, onClick: I } = l || {};
            if (h === $4f70e481f18f162f$export$2e2bcd8739ae039) return o;
            if (h === "a" && y && y.startsWith("#")) {
                const v = y.slice(1), L = v === r;
                return i.current.find((f)=>f.id === v) || i.current.push({
                    id: v,
                    ratio: 0
                }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(o, {
                    className: L ? [
                        x,
                        t
                    ].join(" ") : x,
                    "data-active": u ? L : null,
                    onClick: (f)=>{
                        f.preventDefault(), typeof I == "function" && I(f);
                        const R = document.getElementById(v), E = $4f70e481f18f162f$var$O(R), S = ()=>{
                            E.scrollTo({
                                top: R.offsetTop - E.offsetTop - a,
                                left: R.offsetLeft - E.offsetLeft - d,
                                behavior: c
                            });
                        };
                        typeof m == "function" ? m(f, S, E) : S();
                    }
                });
            }
            return l && l.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(o, {
                ...l,
                children: e(l.children)
            }) : o;
        });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: e(s)
    });
};

















function $05850e1a23ee861e$export$b94310965bed44e6() {
    const [mobileNavActive, setMobileNavActive] = (0, $acw62.useState)(false);
    const toggleClass = ()=>{
        setMobileNavActive(!mobileNavActive);
    };
    if (!!window.location.hash && !isNaN(window.location.hash.replace('#', ''))) window.location.href = '/library/' + window.location.hash;
    window.addEventListener("load", function() {
        if (window.location.hash) setTimeout(function() {
            const target = document.querySelector(window.location.hash);
            if (target) target.scrollIntoView({
                behavior: "smooth"
            });
        }, 100);
    });
    const frame1 = (parcelRequire("8z6CC"));
    const frame2 = (parcelRequire("6AQqg"));
    const frame3 = (parcelRequire("5DSUi"));
    const frame4 = (parcelRequire("8jhGt"));
    const frame5 = (parcelRequire("5rSQu"));
    const frame6 = (parcelRequire("iCD5j"));
    const frame7 = (parcelRequire("fj9zO"));
    const frame8 = (parcelRequire("1FUBr"));
    const frame9 = (parcelRequire("jEPIq"));
    const frame10 = (parcelRequire("1oJsB"));
    const frame11 = (parcelRequire("h5vKV"));
    const frame12 = (parcelRequire("jYXsX"));
    const frame13 = (parcelRequire("lAdfU"));
    const frame14 = (parcelRequire("gI6p9"));
    const frame15 = (parcelRequire("fEaot"));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $535c31c3ebc09f91$exports.MetaTags), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meta", {
                        name: "description",
                        content: "Read the latest State of FinOps Report to discover the latest findings and trends within the FinOps discipline."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meta", {
                        property: "og:url",
                        content: "https://data.finops.org"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meta", {
                        property: "og:description",
                        content: "Read the latest State of FinOps Report to discover the latest findings and trends within the FinOps discipline."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.finops.org/wp-content/uploads/2025/02/State-Of-FinOps-2025-Report-Meta-v2.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($046f159811fdd774$exports))), {
                smoothScroll: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "home-hero hidden lg:block",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "inner lg:flex",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    children: "State Of FinOps"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "2025 Report"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    width: "172",
                                    height: "32",
                                    viewBox: "0 0 172 32",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M2.2155 10.436H7.3815C8.4255 10.436 9.2415 10.73 9.8295 11.318C10.4295 11.906 10.7295 12.692 10.7295 13.676C10.7295 14.144 10.6635 14.54 10.5315 14.864C10.3995 15.188 10.2315 15.458 10.0275 15.674C9.8235 15.878 9.6015 16.034 9.3615 16.142C9.1215 16.238 8.8995 16.304 8.6955 16.34V16.448C8.9235 16.46 9.1755 16.52 9.4515 16.628C9.7395 16.736 10.0095 16.91 10.2615 17.15C10.5135 17.378 10.7235 17.678 10.8915 18.05C11.0715 18.41 11.1615 18.848 11.1615 19.364C11.1615 19.88 11.0775 20.36 10.9095 20.804C10.7535 21.248 10.5315 21.632 10.2435 21.956C9.9555 22.28 9.6135 22.538 9.2175 22.73C8.8215 22.91 8.3895 23 7.9215 23H2.2155V10.436ZM3.7275 21.668H7.4535C8.1015 21.668 8.6115 21.506 8.9835 21.182C9.3555 20.846 9.5415 20.36 9.5415 19.724V19.112C9.5415 18.476 9.3555 17.996 8.9835 17.672C8.6115 17.336 8.1015 17.168 7.4535 17.168H3.7275V21.668ZM3.7275 15.872H7.2015C7.8015 15.872 8.2695 15.722 8.6055 15.422C8.9415 15.122 9.1095 14.69 9.1095 14.126V13.514C9.1095 12.95 8.9415 12.518 8.6055 12.218C8.2695 11.918 7.8015 11.768 7.2015 11.768H3.7275V15.872ZM19.3795 13.712H20.8015L16.6435 25.16C16.5355 25.436 16.4275 25.664 16.3195 25.844C16.2115 26.036 16.0795 26.186 15.9235 26.294C15.7675 26.402 15.5695 26.48 15.3295 26.528C15.1015 26.576 14.8195 26.6 14.4835 26.6H13.7455V25.34H15.2035L15.9055 23.36L12.4315 13.712H13.8715L16.1035 20.03L16.5355 21.542H16.6255L17.1295 20.03L19.3795 13.712ZM23.7359 23.216C23.3519 23.216 23.0699 23.12 22.8899 22.928C22.7219 22.736 22.6379 22.484 22.6379 22.172V21.938C22.6379 21.626 22.7219 21.374 22.8899 21.182C23.0699 20.99 23.3519 20.894 23.7359 20.894C24.1199 20.894 24.3959 20.99 24.5639 21.182C24.7439 21.374 24.8339 21.626 24.8339 21.938V22.172C24.8339 22.484 24.7439 22.736 24.5639 22.928C24.3959 23.12 24.1199 23.216 23.7359 23.216ZM23.7359 15.818C23.3519 15.818 23.0699 15.722 22.8899 15.53C22.7219 15.338 22.6379 15.086 22.6379 14.774V14.54C22.6379 14.228 22.7219 13.976 22.8899 13.784C23.0699 13.592 23.3519 13.496 23.7359 13.496C24.1199 13.496 24.3959 13.592 24.5639 13.784C24.7439 13.976 24.8339 14.228 24.8339 14.54V14.774C24.8339 15.086 24.7439 15.338 24.5639 15.53C24.3959 15.722 24.1199 15.818 23.7359 15.818Z",
                                            fill: "white"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                            clipPath: "url(#clip0_5328_15501)",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M88.1624 13.5157V0.768066H95.7602V2.11889H89.6967V6.39237H95.2306V7.7441H89.6967V13.5157H88.1624Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M98.3534 1.88089C98.2298 1.89311 98.1051 1.87931 97.9871 1.8404C97.8692 1.80148 97.7607 1.7383 97.6687 1.65492C97.5244 1.49184 97.4491 1.27909 97.4586 1.06153V0.822009C97.4493 0.604349 97.5246 0.39154 97.6687 0.22817C97.8663 0.0800579 98.1066 0 98.3536 0C98.6006 0 98.8409 0.0800579 99.0385 0.22817C99.1824 0.391661 99.2577 0.604384 99.2487 0.822009V1.05927C99.258 1.2768 99.1827 1.48948 99.0385 1.65266C98.9466 1.7364 98.8381 1.79997 98.7201 1.83928C98.6021 1.87858 98.4772 1.89276 98.3534 1.88089ZM97.6226 4.09129H99.0842V13.5159H97.6226V4.09129Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M100.764 13.5161V4.09153H102.226V5.60866H102.299C102.507 5.10787 102.844 4.67122 103.276 4.34325C103.773 4.0071 104.366 3.84196 104.966 3.87279C105.396 3.8518 105.826 3.92513 106.225 4.08767C106.624 4.2502 106.983 4.498 107.276 4.81372C107.883 5.56126 108.186 6.51004 108.125 7.47108V13.5161H106.664V7.71377C106.664 6.01721 105.952 5.16908 104.527 5.16939C104.24 5.16871 103.955 5.20563 103.678 5.27921C103.415 5.34747 103.165 5.45879 102.938 5.60866C102.723 5.75068 102.544 5.94201 102.418 6.1668C102.285 6.4109 102.219 6.68545 102.226 6.96311V13.5161H100.764Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M115.23 13.7353C114.463 13.7468 113.701 13.6007 112.992 13.3059C112.335 13.0245 111.754 12.5928 111.294 12.0455C110.797 11.4376 110.428 10.7355 110.209 9.9815C109.94 9.05948 109.81 8.1021 109.826 7.14156C109.81 6.18381 109.939 5.22918 110.209 4.3102C110.431 3.55735 110.8 2.85594 111.294 2.24667C111.752 1.69482 112.334 1.25968 112.992 0.977195C114.426 0.404737 116.025 0.404737 117.458 0.977195C118.121 1.25789 118.707 1.6932 119.166 2.24667C119.661 2.85609 120.031 3.5574 120.253 4.3102C120.523 5.22875 120.653 6.18287 120.638 7.1402C120.653 8.10071 120.524 9.05805 120.255 9.98015C120.034 10.7341 119.665 11.4361 119.168 12.0441C118.706 12.5931 118.121 13.025 117.46 13.3046C116.754 13.5982 115.995 13.7447 115.23 13.7353ZM115.23 12.3831C115.75 12.3885 116.266 12.2889 116.746 12.0902C117.202 11.8997 117.61 11.6119 117.942 11.2469C118.287 10.8635 118.551 10.4147 118.719 9.92727C118.908 9.37294 119.001 8.79021 118.993 8.2045V6.07816C119.001 5.49245 118.908 4.90972 118.719 4.35539C118.551 3.86792 118.287 3.41915 117.942 3.03575C117.61 2.67092 117.202 2.38325 116.746 2.19289C115.773 1.80122 114.687 1.80122 113.714 2.19289C113.259 2.38313 112.85 2.67082 112.518 3.03575C112.173 3.41903 111.909 3.86784 111.742 4.35539C111.552 4.90972 111.46 5.49245 111.468 6.07816V8.2045C111.46 8.79021 111.552 9.37294 111.742 9.92727C111.909 10.4148 112.173 10.8636 112.518 11.2469C112.85 11.612 113.259 11.8998 113.714 12.0902C114.195 12.2888 114.71 12.3883 115.23 12.3826V12.3831Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M122.061 4.09117H123.523V5.60831H123.595C123.799 5.06639 124.174 4.60605 124.664 4.2977C125.177 4.00304 125.762 3.85601 126.353 3.87289C126.903 3.86536 127.446 3.9841 127.942 4.21997C128.418 4.45164 128.833 4.78914 129.157 5.20654C129.511 5.66977 129.772 6.19687 129.926 6.75893C130.11 7.42486 130.199 8.11349 130.19 8.80438C130.199 9.49542 130.11 10.1842 129.926 10.8503C129.772 11.4123 129.511 11.9394 129.157 12.4027C128.833 12.8199 128.417 13.1573 127.942 13.3888C127.446 13.625 126.903 13.7439 126.353 13.7363C125.772 13.7627 125.196 13.6105 124.703 13.3001C124.21 12.9897 123.824 12.5361 123.597 12H123.524V17.1687H122.062L122.061 4.09117ZM125.952 12.4384C126.314 12.4572 126.677 12.3972 127.014 12.2626C127.352 12.1279 127.656 11.9218 127.906 11.6583C128.397 11.0928 128.652 10.3599 128.618 9.61153V7.99587C128.652 7.24745 128.397 6.51454 127.906 5.94907C127.656 5.68562 127.352 5.47948 127.014 5.34483C126.677 5.21017 126.314 5.1502 125.952 5.16903C125.633 5.16664 125.316 5.21235 125.011 5.30461C124.733 5.38606 124.471 5.51313 124.235 5.68062C124.021 5.83323 123.844 6.03047 123.714 6.25864C123.588 6.47947 123.522 6.7296 123.523 6.98399V10.5091C123.517 10.7933 123.583 11.0743 123.714 11.3266C123.841 11.5642 124.019 11.7709 124.235 11.9322C124.468 12.1042 124.731 12.2317 125.011 12.3082C125.317 12.3956 125.634 12.4394 125.952 12.4384Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M134.967 13.7354C134.202 13.7619 133.444 13.5886 132.766 13.2328C132.171 12.8943 131.652 12.4373 131.241 11.8901L132.28 11.05C132.612 11.4843 133.028 11.8476 133.504 12.1183C133.986 12.3761 134.527 12.5051 135.074 12.493C135.59 12.5239 136.1 12.3825 136.527 12.0912C136.675 11.9667 136.797 11.814 136.885 11.642C136.974 11.47 137.027 11.282 137.043 11.0891C137.058 10.8962 137.035 10.7022 136.974 10.5184C136.914 10.3345 136.818 10.1645 136.691 10.0182C136.333 9.70188 135.88 9.51253 135.403 9.47951L134.655 9.36969C134.244 9.31545 133.84 9.22068 133.449 9.08678C133.104 8.96935 132.78 8.79657 132.49 8.57519C132.218 8.36412 131.999 8.09196 131.851 7.78069C131.691 7.42505 131.614 7.03787 131.625 6.64815C131.615 6.22911 131.703 5.81353 131.88 5.4338C132.045 5.0941 132.285 4.7971 132.584 4.56609C132.903 4.32451 133.266 4.14779 133.654 4.04592C134.088 3.92714 134.537 3.86859 134.987 3.87192C135.652 3.84981 136.313 3.98775 136.914 4.27415C137.439 4.54829 137.902 4.9273 138.275 5.38771L137.307 6.26446C137.025 5.88983 136.657 5.58932 136.234 5.38892C135.811 5.18852 135.345 5.09426 134.877 5.11429C134.386 5.07869 133.897 5.2176 133.498 5.50657C133.344 5.63744 133.222 5.80178 133.142 5.98703C133.061 6.17228 133.024 6.37353 133.033 6.57539C133.016 6.76878 133.051 6.9631 133.132 7.13918C133.214 7.31527 133.34 7.46705 133.498 7.57958C133.91 7.8226 134.367 7.97814 134.841 8.03649L135.571 8.14585C136.39 8.20623 137.17 8.5224 137.8 9.04972C138.021 9.28119 138.194 9.55504 138.307 9.85481C138.42 10.1546 138.471 10.4741 138.457 10.7942C138.476 11.2007 138.403 11.6062 138.241 11.9797C138.08 12.3533 137.835 12.6849 137.526 12.9494C136.794 13.5093 135.886 13.7882 134.967 13.7354Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M88.1624 31.7808V19.0322H95.7602V20.3821H89.6967V24.6574H95.2306V26.0092H89.6967V31.7808H88.1624Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M101.174 32.0001C100.578 32.0076 99.9862 31.8894 99.4386 31.653C98.922 31.4269 98.4632 31.087 98.0963 30.6588C97.7102 30.2009 97.4153 29.6734 97.2277 29.1046C96.8137 27.7816 96.8137 26.3637 97.2277 25.0408C97.4137 24.4691 97.7083 23.9388 98.0954 23.4789C98.4622 23.0506 98.9211 22.7107 99.4377 22.4847C99.9854 22.2485 100.577 22.1303 101.173 22.1376C101.766 22.1298 102.355 22.2481 102.899 22.4847C103.414 22.7137 103.872 23.0532 104.241 23.4789C104.633 23.9368 104.931 24.4676 105.118 25.0408C105.533 26.3637 105.533 27.7817 105.118 29.1046C104.93 29.6742 104.632 30.2016 104.241 30.657C103.872 31.0826 103.414 31.422 102.899 31.6512C102.355 31.8885 101.767 32.0074 101.174 32.0001ZM101.174 30.7035C101.529 30.7175 101.884 30.66 102.216 30.5345C102.549 30.4089 102.853 30.2179 103.11 29.9727C103.379 29.6712 103.584 29.3183 103.713 28.9353C103.842 28.5522 103.891 28.147 103.859 27.7442V26.393C103.891 25.9902 103.842 25.585 103.713 25.202C103.584 24.819 103.379 24.466 103.11 24.1645C102.575 23.6935 101.887 23.4336 101.174 23.4336C100.461 23.4336 99.7729 23.6935 99.2379 24.1645C98.9688 24.4659 98.7637 24.8189 98.635 25.2019C98.5063 25.585 98.4566 25.9902 98.4891 26.393V27.7442C98.4565 28.147 98.5061 28.5523 98.6349 28.9353C98.7636 29.3184 98.9688 29.6713 99.2379 29.9727C99.4952 30.218 99.7992 30.409 100.132 30.5346C100.464 30.6601 100.819 30.7176 101.174 30.7035Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M112.772 30.2644H112.699C112.597 30.4876 112.478 30.7024 112.342 30.9066C112.2 31.12 112.024 31.3093 111.822 31.467C111.596 31.6389 111.343 31.7704 111.073 31.8556C110.742 31.9579 110.397 32.0067 110.05 32.0002C109.619 32.0209 109.188 31.9475 108.787 31.7851C108.387 31.6227 108.026 31.3752 107.731 31.0598C107.118 30.3149 106.811 29.3648 106.872 28.402V22.3564H108.333V28.1588C108.333 29.8554 109.051 30.7036 110.488 30.7036C110.775 30.7042 111.06 30.6673 111.338 30.5938C111.598 30.5266 111.845 30.4152 112.068 30.2644C112.279 30.1199 112.455 29.9288 112.58 29.7058C112.714 29.4559 112.78 29.1755 112.772 28.8923V22.3564H114.233V31.7811H112.772V30.2644Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M116.278 31.7808V22.3562H117.74V23.8734H117.813C118.021 23.3727 118.358 22.936 118.79 22.6079C119.287 22.2716 119.88 22.1065 120.479 22.1375C120.91 22.1166 121.34 22.19 121.739 22.3524C122.138 22.5149 122.496 22.7625 122.79 23.078C123.397 23.8255 123.7 24.7746 123.639 25.7358V31.7808H122.178V25.9785C122.178 24.2825 121.466 23.4342 120.041 23.4336C119.754 23.4331 119.469 23.4701 119.191 23.5439C118.928 23.612 118.679 23.7233 118.452 23.8734C118.237 24.0155 118.058 24.2068 117.931 24.4315C117.799 24.6755 117.733 24.9499 117.74 25.2273V31.7804L116.278 31.7808Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M131.804 30.2639H131.73C131.5 30.798 131.114 31.2498 130.621 31.5596C130.129 31.8695 129.555 32.023 128.974 31.9998C128.424 32.0075 127.881 31.8888 127.385 31.6527C126.91 31.4213 126.494 31.0837 126.17 30.6661C125.816 30.2032 125.555 29.676 125.402 29.1137C125.049 27.773 125.049 26.3636 125.402 25.0229C125.556 24.4607 125.816 23.9335 126.17 23.4705C126.494 23.053 126.91 22.7155 127.385 22.4839C127.881 22.248 128.424 22.1293 128.974 22.1368C129.565 22.12 130.15 22.2672 130.663 22.5621C131.153 22.8704 131.529 23.3308 131.732 23.8727H131.805V18.2646H133.266V31.7806H131.805L131.804 30.2639ZM129.375 30.7032C129.692 30.7046 130.009 30.6614 130.315 30.5748C130.595 30.4982 130.858 30.3706 131.091 30.1984C131.307 30.037 131.485 29.8301 131.612 29.5923C131.743 29.3405 131.809 29.0597 131.804 28.7757V25.2506C131.805 24.9962 131.738 24.7459 131.612 24.5253C131.482 24.2972 131.304 24.1 131.091 23.9472C130.855 23.7799 130.593 23.6529 130.315 23.5712C130.01 23.4781 129.693 23.4315 129.375 23.433C129.012 23.4142 128.649 23.4742 128.312 23.6091C127.974 23.7439 127.67 23.9502 127.42 24.2139C126.929 24.7792 126.674 25.512 126.708 26.2602V27.8754C126.674 28.624 126.929 29.357 127.42 29.9227C127.67 30.1862 127.974 30.3925 128.312 30.5272C128.649 30.6619 129.012 30.722 129.375 30.7032Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M142.652 31.7808C142.436 31.802 142.217 31.7735 142.013 31.6976C141.809 31.6216 141.625 31.5001 141.475 31.3424C141.227 31.0257 141.072 30.6465 141.027 30.2469H140.936C140.76 30.7917 140.398 31.2572 139.914 31.562C139.4 31.8644 138.811 32.0161 138.215 32C137.369 32.0518 136.535 31.7768 135.886 31.2317C135.606 30.9646 135.387 30.6404 135.244 30.2812C135.1 29.9219 135.036 29.536 135.054 29.1496C135.034 28.7542 135.113 28.36 135.284 28.0028C135.454 27.6455 135.711 27.3365 136.032 27.1037C136.683 26.6286 137.697 26.3912 139.073 26.3915H140.936V25.4609C140.955 25.1813 140.916 24.9007 140.822 24.6368C140.727 24.3729 140.579 24.1313 140.387 23.9271C139.917 23.5382 139.314 23.3482 138.707 23.3974C138.201 23.3792 137.702 23.5128 137.273 23.7811C136.881 24.0458 136.553 24.3951 136.314 24.8034L135.437 23.9818C135.719 23.4431 136.142 22.9915 136.661 22.6757C137.301 22.2953 138.036 22.1082 138.78 22.137C139.742 22.0769 140.692 22.3756 141.446 22.9753C141.767 23.27 142.018 23.632 142.182 24.0354C142.346 24.4387 142.419 24.8734 142.395 25.3082V30.4837H143.473V31.7808H142.652ZM138.452 30.758C138.791 30.7613 139.129 30.7183 139.456 30.6301C139.737 30.5559 140.003 30.4321 140.241 30.2645C140.448 30.1198 140.623 29.9332 140.753 29.7168C140.873 29.5121 140.936 29.2786 140.934 29.0412V27.4888H138.998C138.364 27.4433 137.73 27.5693 137.162 27.8535C136.98 27.962 136.83 28.1177 136.729 28.3042C136.627 28.4908 136.578 28.7012 136.587 28.9133V29.2965C136.576 29.5035 136.617 29.7098 136.705 29.8976C136.792 30.0854 136.924 30.249 137.089 30.3744C137.488 30.6497 137.968 30.7847 138.452 30.758Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M147.257 31.781C147.044 31.7963 146.83 31.7661 146.63 31.6923C146.43 31.6185 146.248 31.5028 146.096 31.353C145.826 31.0439 145.685 30.6424 145.704 30.2322V23.6534H144.151V22.3563H145.028C145.144 22.3698 145.261 22.3598 145.372 22.3268C145.483 22.2939 145.587 22.2388 145.677 22.1647C145.812 21.9703 145.874 21.7339 145.85 21.4981V19.7446H147.165V22.3563H149.229V23.6534H147.165V30.4839H149.083V31.781H147.257Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M152.253 20.146C152.13 20.1578 152.005 20.1436 151.887 20.1043C151.769 20.065 151.66 20.0014 151.569 19.9178C151.424 19.7544 151.349 19.5416 151.358 19.3239V19.0867C151.349 18.869 151.424 18.6562 151.569 18.4928C151.766 18.3447 152.007 18.2646 152.253 18.2646C152.5 18.2646 152.741 18.3447 152.938 18.4928C153.082 18.6563 153.158 18.869 153.149 19.0867V19.3239C153.158 19.5416 153.082 19.7543 152.938 19.9178C152.846 20.0014 152.738 20.0649 152.62 20.1042C152.502 20.1435 152.377 20.1577 152.253 20.146ZM151.523 22.3559H152.984V31.7805H151.523V22.3559Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M158.781 31.9998C158.185 32.0072 157.593 31.889 157.046 31.6527C156.529 31.4268 156.07 31.0868 155.704 30.6584C155.318 30.2012 155.023 29.6742 154.836 29.106C154.422 27.7831 154.422 26.3652 154.836 25.0423C155.022 24.4705 155.316 23.9402 155.704 23.4804C156.07 23.0519 156.529 22.7119 157.046 22.4861C157.593 22.25 158.185 22.1318 158.781 22.139C159.374 22.1312 159.962 22.2495 160.507 22.4861C161.022 22.715 161.48 23.0545 161.849 23.4804C162.241 23.9384 162.539 24.4691 162.726 25.0423C163.14 26.3652 163.14 27.7831 162.726 29.106C162.538 29.6756 162.24 30.2029 161.849 30.6584C161.48 31.0842 161.022 31.4236 160.507 31.6527C159.963 31.8895 159.374 32.0078 158.781 31.9998ZM158.781 30.7032C159.136 30.7171 159.49 30.6597 159.823 30.5341C160.156 30.4086 160.46 30.2176 160.717 29.9724C160.986 29.671 161.191 29.318 161.32 28.935C161.449 28.5519 161.498 28.1467 161.466 27.7439V26.3926C161.498 25.9898 161.449 25.5847 161.32 25.2016C161.191 24.8186 160.986 24.4656 160.717 24.1642C160.182 23.6932 159.494 23.4334 158.781 23.4334C158.068 23.4334 157.38 23.6932 156.845 24.1642C156.576 24.4656 156.371 24.8186 156.242 25.2016C156.114 25.5847 156.064 25.9898 156.096 26.3926V27.7439C156.064 28.1467 156.113 28.5519 156.242 28.935C156.371 29.318 156.576 29.671 156.845 29.9724C157.102 30.2176 157.406 30.4087 157.739 30.5342C158.071 30.6598 158.426 30.7172 158.781 30.7032Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M164.186 31.7808V22.3562H165.648V23.8734H165.72C165.929 23.3727 166.266 22.9362 166.697 22.6079C167.195 22.2716 167.788 22.1065 168.387 22.1375C168.818 22.1166 169.247 22.19 169.646 22.3524C170.045 22.5149 170.404 22.7625 170.697 23.078C171.305 23.8255 171.608 24.7745 171.547 25.7358V31.7808H170.086V25.9785C170.086 24.2825 169.374 23.4342 167.949 23.4336C167.662 23.4331 167.376 23.4701 167.099 23.5439C166.836 23.612 166.586 23.7234 166.36 23.8734C166.144 24.0155 165.966 24.2068 165.839 24.4315C165.707 24.6755 165.641 24.9499 165.648 25.2273V31.7804L164.186 31.7808Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M62.4302 31.781L50.4526 25.0857V11.3193L62.4302 18.0143V31.781Z",
                                                    fill: "#00C693"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M66.5256 31.781L78.5032 25.0857V11.3193L66.5256 18.0143V31.781Z",
                                                    fill: "#00C693"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M64.4761 0.767578L52.5076 7.87241L64.4761 14.5624L76.4446 7.87241L64.4761 0.767578Z",
                                                    fill: "#00C693"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                id: "clip0_5328_15501",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                    width: "121.094",
                                                    height: "32",
                                                    fill: "white",
                                                    transform: "translate(50.4526)"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        className: 'w-full lg:hidden',
                        viewBox: "0 0 320 243",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                clipPath: "url(#clip0_5592_7363)",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        width: "320",
                                        height: "243",
                                        fill: "#00281D"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        width: "320",
                                        height: "243",
                                        fill: "url(#paint0_linear_5592_7363)",
                                        fillOpacity: "0.3"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        width: "203",
                                        height: "71",
                                        transform: "translate(58.5 48)",
                                        fill: "#004F3B"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M90.852 102.576C87.972 102.576 85.524 102.064 83.508 101.04C81.524 100.016 79.812 98.672 78.372 97.008L82.644 92.88C83.796 94.224 85.076 95.248 86.484 95.952C87.924 96.656 89.508 97.008 91.236 97.008C93.188 97.008 94.66 96.592 95.652 95.76C96.644 94.896 97.14 93.744 97.14 92.304C97.14 91.184 96.82 90.272 96.18 89.568C95.54 88.864 94.34 88.352 92.58 88.032L89.412 87.552C82.724 86.496 79.38 83.248 79.38 77.808C79.38 76.304 79.652 74.944 80.196 73.728C80.772 72.512 81.588 71.472 82.644 70.608C83.7 69.744 84.964 69.088 86.436 68.64C87.94 68.16 89.636 67.92 91.524 67.92C94.052 67.92 96.26 68.336 98.148 69.168C100.036 70 101.652 71.232 102.996 72.864L98.676 76.944C97.844 75.92 96.836 75.088 95.652 74.448C94.468 73.808 92.98 73.488 91.188 73.488C89.364 73.488 87.988 73.84 87.06 74.544C86.164 75.216 85.716 76.176 85.716 77.424C85.716 78.704 86.084 79.648 86.82 80.256C87.556 80.864 88.74 81.312 90.372 81.6L93.492 82.176C96.884 82.784 99.38 83.872 100.98 85.44C102.612 86.976 103.428 89.136 103.428 91.92C103.428 93.52 103.14 94.976 102.564 96.288C102.02 97.568 101.204 98.688 100.116 99.648C99.06 100.576 97.748 101.296 96.18 101.808C94.644 102.32 92.868 102.576 90.852 102.576ZM115.032 102C112.92 102 111.304 101.456 110.184 100.368C109.096 99.248 108.552 97.664 108.552 95.616V81.84H104.856V76.944H106.776C107.704 76.944 108.328 76.736 108.648 76.32C109 75.872 109.176 75.216 109.176 74.352V70.08H114.696V76.944H119.832V81.84H114.696V97.104H119.448V102H115.032ZM141.593 102C140.249 102 139.177 101.616 138.377 100.848C137.609 100.048 137.129 98.992 136.937 97.68H136.649C136.233 99.312 135.385 100.544 134.105 101.376C132.825 102.176 131.241 102.576 129.353 102.576C126.793 102.576 124.825 101.904 123.449 100.56C122.073 99.216 121.385 97.424 121.385 95.184C121.385 92.592 122.313 90.672 124.169 89.424C126.025 88.144 128.665 87.504 132.089 87.504H136.361V85.68C136.361 84.272 135.993 83.184 135.257 82.416C134.521 81.648 133.337 81.264 131.705 81.264C130.265 81.264 129.097 81.584 128.201 82.224C127.337 82.832 126.601 83.568 125.993 84.432L122.345 81.168C123.273 79.728 124.505 78.576 126.041 77.712C127.577 76.816 129.609 76.368 132.137 76.368C135.529 76.368 138.105 77.136 139.865 78.672C141.625 80.208 142.505 82.416 142.505 85.296V97.104H145.001V102H141.593ZM131.417 98.112C132.793 98.112 133.961 97.808 134.921 97.2C135.881 96.592 136.361 95.696 136.361 94.512V91.2H132.425C129.225 91.2 127.625 92.224 127.625 94.272V95.088C127.625 96.112 127.945 96.88 128.585 97.392C129.257 97.872 130.201 98.112 131.417 98.112ZM155.61 102C153.498 102 151.882 101.456 150.762 100.368C149.674 99.248 149.13 97.664 149.13 95.616V81.84H145.434V76.944H147.354C148.282 76.944 148.906 76.736 149.226 76.32C149.578 75.872 149.754 75.216 149.754 74.352V70.08H155.274V76.944H160.41V81.84H155.274V97.104H160.026V102H155.61ZM173.68 102.576C171.824 102.576 170.16 102.272 168.688 101.664C167.248 101.024 166.016 100.144 164.992 99.024C164 97.872 163.232 96.496 162.688 94.896C162.144 93.264 161.872 91.44 161.872 89.424C161.872 87.44 162.128 85.648 162.64 84.048C163.184 82.448 163.952 81.088 164.944 79.968C165.936 78.816 167.152 77.936 168.592 77.328C170.032 76.688 171.664 76.368 173.488 76.368C175.44 76.368 177.136 76.704 178.576 77.376C180.016 78.048 181.2 78.96 182.128 80.112C183.056 81.264 183.744 82.608 184.192 84.144C184.672 85.648 184.912 87.264 184.912 88.992V91.008H168.256V91.632C168.256 93.456 168.768 94.928 169.792 96.048C170.816 97.136 172.336 97.68 174.352 97.68C175.888 97.68 177.136 97.36 178.096 96.72C179.088 96.08 179.968 95.264 180.736 94.272L184.048 97.968C183.024 99.408 181.616 100.544 179.824 101.376C178.064 102.176 176.016 102.576 173.68 102.576ZM173.584 80.976C171.952 80.976 170.656 81.52 169.696 82.608C168.736 83.696 168.256 85.104 168.256 86.832V87.216H178.528V86.784C178.528 85.056 178.096 83.664 177.232 82.608C176.4 81.52 175.184 80.976 173.584 80.976ZM211.197 102.576C208.989 102.576 206.989 102.208 205.197 101.472C203.405 100.736 201.869 99.632 200.589 98.16C199.341 96.688 198.365 94.88 197.661 92.736C196.957 90.592 196.605 88.096 196.605 85.248C196.605 82.432 196.957 79.952 197.661 77.808C198.365 75.632 199.341 73.808 200.589 72.336C201.869 70.864 203.405 69.76 205.197 69.024C206.989 68.288 208.989 67.92 211.197 67.92C213.405 67.92 215.405 68.288 217.197 69.024C218.989 69.76 220.525 70.864 221.805 72.336C223.085 73.808 224.061 75.632 224.733 77.808C225.437 79.952 225.789 82.432 225.789 85.248C225.789 88.096 225.437 90.592 224.733 92.736C224.061 94.88 223.085 96.688 221.805 98.16C220.525 99.632 218.989 100.736 217.197 101.472C215.405 102.208 213.405 102.576 211.197 102.576ZM211.197 96.96C213.597 96.96 215.501 96.16 216.909 94.56C218.349 92.96 219.069 90.72 219.069 87.84V82.656C219.069 79.776 218.349 77.536 216.909 75.936C215.501 74.336 213.597 73.536 211.197 73.536C208.797 73.536 206.877 74.336 205.437 75.936C204.029 77.536 203.325 79.776 203.325 82.656V87.84C203.325 90.72 204.029 92.96 205.437 94.56C206.877 96.16 208.797 96.96 211.197 96.96ZM231.081 81.792H227.385V76.944H231.081V73.344C231.081 71.136 231.657 69.44 232.809 68.256C233.993 67.072 235.721 66.48 237.993 66.48H242.361V71.376H237.225V76.944H242.361V81.792H237.225V102H231.081V81.792Z",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        width: "183",
                                        height: "65",
                                        transform: "translate(68.5 103)",
                                        fill: "#004F3B"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M90.436 148V114.496H111.988V120.112H96.772V128.224H110.02V133.84H96.772V148H90.436ZM118.827 119.296C117.547 119.296 116.619 119.008 116.043 118.432C115.499 117.856 115.227 117.12 115.227 116.224V115.264C115.227 114.368 115.499 113.632 116.043 113.056C116.619 112.48 117.547 112.192 118.827 112.192C120.075 112.192 120.987 112.48 121.563 113.056C122.139 113.632 122.427 114.368 122.427 115.264V116.224C122.427 117.12 122.139 117.856 121.563 118.432C120.987 119.008 120.075 119.296 118.827 119.296ZM115.755 122.944H121.899V148H115.755V122.944ZM127.021 148V122.944H133.165V127.12H133.405C133.917 125.776 134.717 124.656 135.805 123.76C136.925 122.832 138.461 122.368 140.413 122.368C143.005 122.368 144.989 123.216 146.365 124.912C147.741 126.608 148.429 129.024 148.429 132.16V148H142.285V132.784C142.285 130.992 141.965 129.648 141.325 128.752C140.685 127.856 139.629 127.408 138.157 127.408C137.517 127.408 136.893 127.504 136.285 127.696C135.709 127.856 135.181 128.112 134.701 128.464C134.253 128.784 133.885 129.2 133.597 129.712C133.309 130.192 133.165 130.768 133.165 131.44V148H127.021ZM166.776 148.576C164.568 148.576 162.568 148.208 160.776 147.472C158.984 146.736 157.448 145.632 156.168 144.16C154.92 142.688 153.944 140.88 153.24 138.736C152.536 136.592 152.184 134.096 152.184 131.248C152.184 128.432 152.536 125.952 153.24 123.808C153.944 121.632 154.92 119.808 156.168 118.336C157.448 116.864 158.984 115.76 160.776 115.024C162.568 114.288 164.568 113.92 166.776 113.92C168.984 113.92 170.984 114.288 172.776 115.024C174.568 115.76 176.104 116.864 177.384 118.336C178.664 119.808 179.64 121.632 180.312 123.808C181.016 125.952 181.368 128.432 181.368 131.248C181.368 134.096 181.016 136.592 180.312 138.736C179.64 140.88 178.664 142.688 177.384 144.16C176.104 145.632 174.568 146.736 172.776 147.472C170.984 148.208 168.984 148.576 166.776 148.576ZM166.776 142.96C169.176 142.96 171.08 142.16 172.488 140.56C173.928 138.96 174.648 136.72 174.648 133.84V128.656C174.648 125.776 173.928 123.536 172.488 121.936C171.08 120.336 169.176 119.536 166.776 119.536C164.376 119.536 162.456 120.336 161.016 121.936C159.608 123.536 158.904 125.776 158.904 128.656V133.84C158.904 136.72 159.608 138.96 161.016 140.56C162.456 142.16 164.376 142.96 166.776 142.96ZM185.411 122.944H191.555V127.072H191.747C192.195 125.632 193.043 124.496 194.291 123.664C195.539 122.8 196.995 122.368 198.659 122.368C201.859 122.368 204.291 123.504 205.955 125.776C207.651 128.016 208.499 131.232 208.499 135.424C208.499 139.648 207.651 142.896 205.955 145.168C204.291 147.44 201.859 148.576 198.659 148.576C196.995 148.576 195.539 148.144 194.291 147.28C193.075 146.416 192.227 145.264 191.747 143.824H191.555V157.6H185.411V122.944ZM196.691 143.488C198.291 143.488 199.587 142.96 200.579 141.904C201.571 140.848 202.067 139.424 202.067 137.632V133.312C202.067 131.52 201.571 130.096 200.579 129.04C199.587 127.952 198.291 127.408 196.691 127.408C195.219 127.408 193.987 127.776 192.995 128.512C192.035 129.248 191.555 130.224 191.555 131.44V139.408C191.555 140.72 192.035 141.728 192.995 142.432C193.987 143.136 195.219 143.488 196.691 143.488ZM220.401 148.576C218.001 148.576 215.985 148.176 214.353 147.376C212.721 146.544 211.281 145.408 210.033 143.968L213.777 140.32C214.705 141.376 215.713 142.208 216.801 142.816C217.921 143.424 219.201 143.728 220.641 143.728C222.113 143.728 223.169 143.472 223.809 142.96C224.481 142.448 224.817 141.744 224.817 140.848C224.817 140.112 224.577 139.536 224.097 139.12C223.649 138.672 222.865 138.368 221.745 138.208L219.249 137.872C216.529 137.52 214.449 136.752 213.009 135.568C211.601 134.352 210.897 132.592 210.897 130.288C210.897 129.072 211.121 127.984 211.569 127.024C212.017 126.032 212.657 125.2 213.489 124.528C214.321 123.824 215.313 123.296 216.465 122.944C217.649 122.56 218.961 122.368 220.401 122.368C221.617 122.368 222.689 122.464 223.617 122.656C224.577 122.816 225.441 123.072 226.209 123.424C226.977 123.744 227.681 124.16 228.321 124.672C228.961 125.152 229.585 125.696 230.193 126.304L226.593 129.904C225.857 129.136 224.977 128.496 223.953 127.984C222.929 127.472 221.809 127.216 220.593 127.216C219.249 127.216 218.273 127.456 217.665 127.936C217.089 128.416 216.801 129.04 216.801 129.808C216.801 130.64 217.041 131.28 217.521 131.728C218.033 132.144 218.881 132.448 220.065 132.64L222.609 132.976C228.017 133.744 230.721 136.208 230.721 140.368C230.721 141.584 230.465 142.704 229.953 143.728C229.473 144.72 228.785 145.584 227.889 146.32C226.993 147.024 225.905 147.584 224.625 148C223.377 148.384 221.969 148.576 220.401 148.576Z",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        width: "123",
                                        height: "27",
                                        transform: "translate(98.5 168)",
                                        fill: "#FFB700"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M124.615 187H117.505V185.38L120.85 182.395C121.38 181.915 121.785 181.46 122.065 181.03C122.355 180.59 122.5 180.13 122.5 179.65V179.455C122.5 178.945 122.345 178.545 122.035 178.255C121.735 177.965 121.325 177.82 120.805 177.82C120.515 177.82 120.26 177.865 120.04 177.955C119.83 178.035 119.645 178.15 119.485 178.3C119.325 178.45 119.19 178.625 119.08 178.825C118.98 179.025 118.9 179.24 118.84 179.47L117.355 178.9C117.465 178.57 117.615 178.255 117.805 177.955C117.995 177.645 118.235 177.37 118.525 177.13C118.815 176.89 119.155 176.7 119.545 176.56C119.945 176.42 120.41 176.35 120.94 176.35C121.47 176.35 121.945 176.43 122.365 176.59C122.785 176.74 123.135 176.955 123.415 177.235C123.705 177.505 123.925 177.83 124.075 178.21C124.225 178.59 124.3 179.005 124.3 179.455C124.3 179.875 124.235 180.265 124.105 180.625C123.975 180.985 123.795 181.325 123.565 181.645C123.335 181.965 123.065 182.27 122.755 182.56C122.455 182.85 122.135 183.145 121.795 183.445L119.335 185.56H124.615V187ZM129.994 187.18C129.344 187.18 128.779 187.06 128.299 186.82C127.819 186.57 127.424 186.215 127.114 185.755C126.804 185.295 126.574 184.73 126.424 184.06C126.274 183.39 126.199 182.625 126.199 181.765C126.199 180.915 126.274 180.155 126.424 179.485C126.574 178.805 126.804 178.235 127.114 177.775C127.424 177.315 127.819 176.965 128.299 176.725C128.779 176.475 129.344 176.35 129.994 176.35C131.294 176.35 132.249 176.825 132.859 177.775C133.479 178.725 133.789 180.055 133.789 181.765C133.789 183.475 133.479 184.805 132.859 185.755C132.249 186.705 131.294 187.18 129.994 187.18ZM129.994 185.74C130.354 185.74 130.659 185.67 130.909 185.53C131.169 185.38 131.379 185.17 131.539 184.9C131.699 184.63 131.814 184.31 131.884 183.94C131.954 183.56 131.989 183.14 131.989 182.68V180.85C131.989 180.39 131.954 179.975 131.884 179.605C131.814 179.225 131.699 178.9 131.539 178.63C131.379 178.36 131.169 178.155 130.909 178.015C130.659 177.865 130.354 177.79 129.994 177.79C129.634 177.79 129.324 177.865 129.064 178.015C128.814 178.155 128.609 178.36 128.449 178.63C128.289 178.9 128.174 179.225 128.104 179.605C128.034 179.975 127.999 180.39 127.999 180.85V182.68C127.999 183.14 128.034 183.56 128.104 183.94C128.174 184.31 128.289 184.63 128.449 184.9C128.609 185.17 128.814 185.38 129.064 185.53C129.324 185.67 129.634 185.74 129.994 185.74ZM142.603 187H135.493V185.38L138.838 182.395C139.368 181.915 139.773 181.46 140.053 181.03C140.343 180.59 140.488 180.13 140.488 179.65V179.455C140.488 178.945 140.333 178.545 140.023 178.255C139.723 177.965 139.313 177.82 138.793 177.82C138.503 177.82 138.248 177.865 138.028 177.955C137.818 178.035 137.633 178.15 137.473 178.3C137.313 178.45 137.178 178.625 137.068 178.825C136.968 179.025 136.888 179.24 136.828 179.47L135.343 178.9C135.453 178.57 135.603 178.255 135.793 177.955C135.983 177.645 136.223 177.37 136.513 177.13C136.803 176.89 137.143 176.7 137.533 176.56C137.933 176.42 138.398 176.35 138.928 176.35C139.458 176.35 139.933 176.43 140.353 176.59C140.773 176.74 141.123 176.955 141.403 177.235C141.693 177.505 141.913 177.83 142.063 178.21C142.213 178.59 142.288 179.005 142.288 179.455C142.288 179.875 142.223 180.265 142.093 180.625C141.963 180.985 141.783 181.325 141.553 181.645C141.323 181.965 141.053 182.27 140.743 182.56C140.443 182.85 140.123 183.145 139.783 183.445L137.323 185.56H142.603V187ZM151.102 178H146.452L146.182 181.705H146.287C146.407 181.495 146.532 181.31 146.662 181.15C146.792 180.98 146.942 180.835 147.112 180.715C147.282 180.595 147.477 180.505 147.697 180.445C147.917 180.375 148.177 180.34 148.477 180.34C148.927 180.34 149.342 180.415 149.722 180.565C150.112 180.715 150.447 180.93 150.727 181.21C151.017 181.49 151.242 181.835 151.402 182.245C151.562 182.645 151.642 183.1 151.642 183.61C151.642 184.13 151.557 184.61 151.387 185.05C151.227 185.49 150.987 185.87 150.667 186.19C150.347 186.5 149.952 186.745 149.482 186.925C149.022 187.095 148.497 187.18 147.907 187.18C147.437 187.18 147.022 187.125 146.662 187.015C146.302 186.915 145.982 186.78 145.702 186.61C145.432 186.43 145.192 186.23 144.982 186.01C144.782 185.78 144.602 185.545 144.442 185.305L145.672 184.33C145.802 184.54 145.937 184.73 146.077 184.9C146.217 185.07 146.377 185.22 146.557 185.35C146.737 185.48 146.937 185.58 147.157 185.65C147.387 185.72 147.647 185.755 147.937 185.755C148.557 185.755 149.032 185.585 149.362 185.245C149.702 184.905 149.872 184.435 149.872 183.835V183.655C149.872 183.055 149.702 182.585 149.362 182.245C149.032 181.905 148.557 181.735 147.937 181.735C147.487 181.735 147.127 181.82 146.857 181.99C146.587 182.16 146.357 182.35 146.167 182.56L144.772 182.365L145.162 176.53H151.102V178ZM159.006 187H157.311V176.53H161.826C162.766 176.53 163.506 176.815 164.046 177.385C164.586 177.945 164.856 178.71 164.856 179.68C164.856 180.43 164.681 181.055 164.331 181.555C163.991 182.045 163.486 182.39 162.816 182.59L165.081 187H163.191L161.091 182.77H159.006V187ZM161.706 181.345C162.136 181.345 162.471 181.235 162.711 181.015C162.951 180.785 163.071 180.46 163.071 180.04V179.32C163.071 178.9 162.951 178.58 162.711 178.36C162.471 178.13 162.136 178.015 161.706 178.015H159.006V181.345H161.706ZM169.861 187.18C169.301 187.18 168.801 187.085 168.361 186.895C167.921 186.705 167.546 186.435 167.236 186.085C166.926 185.725 166.686 185.295 166.516 184.795C166.356 184.285 166.276 183.72 166.276 183.1C166.276 182.48 166.356 181.92 166.516 181.42C166.686 180.91 166.926 180.48 167.236 180.13C167.546 179.77 167.921 179.495 168.361 179.305C168.801 179.115 169.301 179.02 169.861 179.02C170.431 179.02 170.931 179.12 171.361 179.32C171.801 179.52 172.166 179.8 172.456 180.16C172.746 180.51 172.961 180.92 173.101 181.39C173.251 181.86 173.326 182.365 173.326 182.905V183.52H167.971V183.775C167.971 184.375 168.146 184.87 168.496 185.26C168.856 185.64 169.366 185.83 170.026 185.83C170.506 185.83 170.911 185.725 171.241 185.515C171.571 185.305 171.851 185.02 172.081 184.66L173.041 185.605C172.751 186.085 172.331 186.47 171.781 186.76C171.231 187.04 170.591 187.18 169.861 187.18ZM169.861 180.295C169.581 180.295 169.321 180.345 169.081 180.445C168.851 180.545 168.651 180.685 168.481 180.865C168.321 181.045 168.196 181.26 168.106 181.51C168.016 181.76 167.971 182.035 167.971 182.335V182.44H171.601V182.29C171.601 181.69 171.446 181.21 171.136 180.85C170.826 180.48 170.401 180.295 169.861 180.295ZM175.136 179.2H176.771V180.49H176.846C177.016 180.02 177.291 179.66 177.671 179.41C178.061 179.15 178.516 179.02 179.036 179.02C180.026 179.02 180.791 179.38 181.331 180.1C181.871 180.81 182.141 181.81 182.141 183.1C182.141 184.39 181.871 185.395 181.331 186.115C180.791 186.825 180.026 187.18 179.036 187.18C178.516 187.18 178.061 187.05 177.671 186.79C177.291 186.53 177.016 186.17 176.846 185.71H176.771V190H175.136V179.2ZM178.541 185.77C179.111 185.77 179.566 185.59 179.906 185.23C180.246 184.86 180.416 184.375 180.416 183.775V182.425C180.416 181.825 180.246 181.345 179.906 180.985C179.566 180.615 179.111 180.43 178.541 180.43C178.041 180.43 177.621 180.555 177.281 180.805C176.941 181.045 176.771 181.365 176.771 181.765V184.435C176.771 184.835 176.941 185.16 177.281 185.41C177.621 185.65 178.041 185.77 178.541 185.77ZM187.073 187.18C186.533 187.18 186.038 187.085 185.588 186.895C185.148 186.705 184.773 186.435 184.463 186.085C184.153 185.725 183.913 185.295 183.743 184.795C183.573 184.285 183.488 183.72 183.488 183.1C183.488 182.48 183.573 181.92 183.743 181.42C183.913 180.91 184.153 180.48 184.463 180.13C184.773 179.77 185.148 179.495 185.588 179.305C186.038 179.115 186.533 179.02 187.073 179.02C187.613 179.02 188.103 179.115 188.543 179.305C188.993 179.495 189.373 179.77 189.683 180.13C189.993 180.48 190.233 180.91 190.403 181.42C190.573 181.92 190.658 182.48 190.658 183.1C190.658 183.72 190.573 184.285 190.403 184.795C190.233 185.295 189.993 185.725 189.683 186.085C189.373 186.435 188.993 186.705 188.543 186.895C188.103 187.085 187.613 187.18 187.073 187.18ZM187.073 185.83C187.633 185.83 188.083 185.66 188.423 185.32C188.763 184.97 188.933 184.45 188.933 183.76V182.44C188.933 181.75 188.763 181.235 188.423 180.895C188.083 180.545 187.633 180.37 187.073 180.37C186.513 180.37 186.063 180.545 185.723 180.895C185.383 181.235 185.213 181.75 185.213 182.44V183.76C185.213 184.45 185.383 184.97 185.723 185.32C186.063 185.66 186.513 185.83 187.073 185.83ZM192.48 187V179.2H194.115V180.7H194.19C194.3 180.3 194.53 179.95 194.88 179.65C195.23 179.35 195.715 179.2 196.335 179.2H196.77V180.775H196.125C195.475 180.775 194.975 180.88 194.625 181.09C194.285 181.3 194.115 181.61 194.115 182.02V187H192.48ZM200.44 187C199.87 187 199.44 186.855 199.15 186.565C198.86 186.265 198.715 185.845 198.715 185.305V180.535H197.5V179.2H198.16C198.43 179.2 198.615 179.14 198.715 179.02C198.825 178.9 198.88 178.705 198.88 178.435V177.07H200.35V179.2H201.985V180.535H200.35V185.665H201.865V187H200.44Z",
                                        fill: "#00281D"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "45",
                                        y: "184",
                                        width: "27",
                                        height: "27",
                                        rx: "13.5",
                                        fill: "black",
                                        fillOpacity: "0.24"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "45.5",
                                        y: "184.5",
                                        width: "26",
                                        height: "26",
                                        rx: "13",
                                        stroke: "black",
                                        strokeOpacity: "0.08"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        clipPath: "url(#clip1_5592_7363)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M54.23 190.903C54.3459 190.729 54.541 190.625 54.75 190.625H62.25C62.459 190.625 62.6541 190.729 62.77 190.903L65.27 194.653C65.4141 194.869 65.4095 195.152 65.2586 195.363L59.0086 204.113C58.8913 204.278 58.7018 204.375 58.5 204.375C58.2982 204.375 58.1087 204.278 57.9914 204.113L51.7414 195.363C51.5905 195.152 51.5859 194.869 51.73 194.653L54.23 190.903ZM55.0845 191.875L53.4178 194.375H55.5495L56.3829 191.875H55.0845ZM57.7005 191.875L56.8671 194.375H60.1329L59.2995 191.875H57.7005ZM60.6171 191.875L61.4505 194.375H63.5822L61.9155 191.875H60.6171ZM63.5355 195.625H61.4714L60.0954 200.441L63.5355 195.625ZM58.5 201.475L60.1714 195.625H56.8286L58.5 201.475ZM55.5286 195.625L56.9046 200.441L53.4645 195.625H55.5286Z",
                                            fill: "#FF6B00"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "18",
                                        y: "48",
                                        width: "27",
                                        height: "27",
                                        rx: "13.5",
                                        fill: "black",
                                        fillOpacity: "0.24"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "18.5",
                                        y: "48.5",
                                        width: "26",
                                        height: "26",
                                        rx: "13",
                                        stroke: "black",
                                        strokeOpacity: "0.08"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        clipPath: "url(#clip2_5592_7363)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M30.875 55.2809C27.7167 55.5944 25.25 58.2592 25.25 61.5C25.25 64.7408 27.7167 67.4056 30.875 67.7191V55.2809ZM32.125 55.2809V61.2411L36.3394 65.4555C37.2215 64.3777 37.75 63.001 37.75 61.5C37.75 58.2592 35.2833 55.5944 32.125 55.2809ZM35.4555 66.3394L32.125 63.0089V67.7192C33.3821 67.5945 34.5292 67.0975 35.4555 66.3394ZM24 61.5C24 57.3579 27.3579 54 31.5 54C35.6421 54 39 57.3579 39 61.5C39 63.5709 38.1598 65.4468 36.8033 66.8033C35.4468 68.1598 33.5709 69 31.5 69C27.3579 69 24 65.6421 24 61.5Z",
                                            fill: "#FFB700"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "87",
                                        y: "17",
                                        width: "27",
                                        height: "27",
                                        rx: "13.5",
                                        fill: "black",
                                        fillOpacity: "0.24"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "87.5",
                                        y: "17.5",
                                        width: "26",
                                        height: "26",
                                        rx: "13",
                                        stroke: "black",
                                        strokeOpacity: "0.08"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        clipPath: "url(#clip3_5592_7363)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M99.875 24.2809C96.7167 24.5944 94.25 27.2592 94.25 30.5C94.25 33.9518 97.0482 36.75 100.5 36.75C102.001 36.75 103.378 36.2215 104.455 35.3394L100.058 30.9419C99.9408 30.8247 99.875 30.6658 99.875 30.5V24.2809ZM101.125 24.2808V24.875H103.228C102.581 24.5608 101.873 24.355 101.125 24.2808ZM104.963 26.125H101.125V27.375H105.914C105.65 26.9189 105.33 26.4991 104.963 26.125ZM106.464 28.625H101.125V29.875H106.719C106.676 29.4436 106.59 29.0255 106.464 28.625ZM106.719 31.125H102.009L103.259 32.375H106.464C106.59 31.9745 106.676 31.5564 106.719 31.125ZM105.914 33.625H104.509L105.339 34.4555C105.552 34.1952 105.745 33.9176 105.914 33.625ZM93 30.5C93 26.3579 96.3579 23 100.5 23C102.493 23 104.305 23.778 105.648 25.0455C106.447 25.8002 107.081 26.7293 107.489 27.7726C107.819 28.6188 108 29.539 108 30.5C108 31.461 107.819 32.3812 107.489 33.2274C107.108 34.2021 106.53 35.0771 105.803 35.8033C104.447 37.1598 102.571 38 100.5 38C96.3579 38 93 34.6421 93 30.5Z",
                                            fill: "#0080AF"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "207",
                                        y: "11",
                                        width: "27",
                                        height: "27",
                                        rx: "13.5",
                                        fill: "black",
                                        fillOpacity: "0.24"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "207.5",
                                        y: "11.5",
                                        width: "26",
                                        height: "26",
                                        rx: "13",
                                        stroke: "black",
                                        strokeOpacity: "0.08"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M218.183 22.1831C218.427 21.939 218.823 21.939 219.067 22.1831L222.375 25.4911L225.683 22.1831C225.927 21.939 226.323 21.939 226.567 22.1831C226.811 22.4271 226.811 22.8229 226.567 23.0669L222.82 26.8143L222.818 26.8157L222.818 26.8163L222.817 26.8168C222.573 27.0609 222.177 27.061 221.933 26.8169L218.625 23.5089L215.317 26.8169C215.073 27.061 214.677 27.061 214.433 26.8169C214.189 26.5729 214.189 26.1771 214.433 25.9331L218.183 22.1831Z",
                                        fill: "#00C693"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "273",
                                        y: "56",
                                        width: "27",
                                        height: "27",
                                        rx: "13.5",
                                        fill: "black",
                                        fillOpacity: "0.24"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "273.5",
                                        y: "56.5",
                                        width: "26",
                                        height: "26",
                                        rx: "13",
                                        stroke: "black",
                                        strokeOpacity: "0.08"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M292.125 64.5C291.089 64.5 290.25 65.3395 290.25 66.375C290.25 66.7296 290.348 67.0612 290.52 67.344L289.009 69.6099C288.811 69.5388 288.597 69.5 288.375 69.5C288.123 69.5 287.882 69.5498 287.663 69.6401L286.27 67.8998C286.417 67.6327 286.5 67.3261 286.5 67C286.5 65.9645 285.661 65.125 284.625 65.125C283.589 65.125 282.75 65.9645 282.75 67C282.75 67.3772 282.861 67.7284 283.053 68.0225L281.444 70.838C281.265 70.7808 281.073 70.75 280.875 70.75C279.839 70.75 279 71.5895 279 72.625C279 73.6605 279.839 74.5 280.875 74.5C281.911 74.5 282.75 73.6605 282.75 72.625C282.75 72.2478 282.639 71.8967 282.447 71.6026L284.056 68.7871C284.235 68.8442 284.427 68.875 284.625 68.875C284.877 68.875 285.118 68.8252 285.338 68.7348L286.73 70.475C286.583 70.7422 286.5 71.0489 286.5 71.375C286.5 72.4105 287.339 73.25 288.375 73.25C289.411 73.25 290.25 72.4105 290.25 71.375C290.25 71.0204 290.152 70.6888 289.981 70.406L291.491 68.1401C291.689 68.2113 291.903 68.25 292.125 68.25C293.161 68.25 294 67.4105 294 66.375C294 65.3395 293.161 64.5 292.125 64.5ZM291.5 66.375C291.5 66.0298 291.78 65.75 292.125 65.75C292.47 65.75 292.75 66.0298 292.75 66.375C292.75 66.7202 292.47 67 292.125 67C291.78 67 291.5 66.7202 291.5 66.375ZM284 67C284 66.6548 284.28 66.375 284.625 66.375C284.97 66.375 285.25 66.6548 285.25 67C285.25 67.3452 284.97 67.625 284.625 67.625C284.28 67.625 284 67.3452 284 67ZM280.25 72.625C280.25 72.2798 280.53 72 280.875 72C281.22 72 281.5 72.2798 281.5 72.625C281.5 72.9702 281.22 73.25 280.875 73.25C280.53 73.25 280.25 72.9702 280.25 72.625ZM288.375 70.75C288.03 70.75 287.75 71.0298 287.75 71.375C287.75 71.7202 288.03 72 288.375 72C288.72 72 289 71.7202 289 71.375C289 71.0298 288.72 70.75 288.375 70.75Z",
                                        fill: "#BD3BFD"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "257",
                                        y: "187",
                                        width: "27",
                                        height: "27",
                                        rx: "13.5",
                                        fill: "black",
                                        fillOpacity: "0.24"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        x: "257.5",
                                        y: "187.5",
                                        width: "26",
                                        height: "26",
                                        rx: "13",
                                        stroke: "black",
                                        strokeOpacity: "0.08"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M266.75 195.812C266.75 196.503 266.19 197.062 265.5 197.062C264.81 197.062 264.25 196.503 264.25 195.812C264.25 195.122 264.81 194.562 265.5 194.562C266.19 194.562 266.75 195.122 266.75 195.812Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M271.75 195.812C271.75 196.503 271.19 197.062 270.5 197.062C269.81 197.062 269.25 196.503 269.25 195.812C269.25 195.122 269.81 194.562 270.5 194.562C271.19 194.562 271.75 195.122 271.75 195.812Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M274.25 195.812C274.25 196.503 273.69 197.062 273 197.062C272.31 197.062 271.75 196.503 271.75 195.812C271.75 195.122 272.31 194.562 273 194.562C273.69 194.562 274.25 195.122 274.25 195.812Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M276.75 195.812C276.75 196.503 276.19 197.062 275.5 197.062C274.81 197.062 274.25 196.503 274.25 195.812C274.25 195.122 274.81 194.562 275.5 194.562C276.19 194.562 276.75 195.122 276.75 195.812Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M266.75 198.938C266.75 199.628 266.19 200.188 265.5 200.188C264.81 200.188 264.25 199.628 264.25 198.938C264.25 198.247 264.81 197.688 265.5 197.688C266.19 197.688 266.75 198.247 266.75 198.938Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M269.25 198.938C269.25 199.628 268.69 200.188 268 200.188C267.31 200.188 266.75 199.628 266.75 198.938C266.75 198.247 267.31 197.688 268 197.688C268.69 197.688 269.25 198.247 269.25 198.938Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M274.25 198.938C274.25 199.628 273.69 200.188 273 200.188C272.31 200.188 271.75 199.628 271.75 198.938C271.75 198.247 272.31 197.688 273 197.688C273.69 197.688 274.25 198.247 274.25 198.938Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M276.75 198.938C276.75 199.628 276.19 200.188 275.5 200.188C274.81 200.188 274.25 199.628 274.25 198.938C274.25 198.247 274.81 197.688 275.5 197.688C276.19 197.688 276.75 198.247 276.75 198.938Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M266.75 202.062C266.75 202.753 266.19 203.312 265.5 203.312C264.81 203.312 264.25 202.753 264.25 202.062C264.25 201.372 264.81 200.812 265.5 200.812C266.19 200.812 266.75 201.372 266.75 202.062Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M269.25 202.062C269.25 202.753 268.69 203.312 268 203.312C267.31 203.312 266.75 202.753 266.75 202.062C266.75 201.372 267.31 200.812 268 200.812C268.69 200.812 269.25 201.372 269.25 202.062Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M271.75 202.062C271.75 202.753 271.19 203.312 270.5 203.312C269.81 203.312 269.25 202.753 269.25 202.062C269.25 201.372 269.81 200.812 270.5 200.812C271.19 200.812 271.75 201.372 271.75 202.062Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M274.25 202.062C274.25 202.753 273.69 203.312 273 203.312C272.31 203.312 271.75 202.753 271.75 202.062C271.75 201.372 272.31 200.812 273 200.812C273.69 200.812 274.25 201.372 274.25 202.062Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M266.75 205.188C266.75 205.878 266.19 206.438 265.5 206.438C264.81 206.438 264.25 205.878 264.25 205.188C264.25 204.497 264.81 203.938 265.5 203.938C266.19 203.938 266.75 204.497 266.75 205.188Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M269.25 205.188C269.25 205.878 268.69 206.438 268 206.438C267.31 206.438 266.75 205.878 266.75 205.188C266.75 204.497 267.31 203.938 268 203.938C268.69 203.938 269.25 204.497 269.25 205.188Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M271.75 205.188C271.75 205.878 271.19 206.438 270.5 206.438C269.81 206.438 269.25 205.878 269.25 205.188C269.25 204.497 269.81 203.938 270.5 203.938C271.19 203.938 271.75 204.497 271.75 205.188Z",
                                        fill: "#0080AF"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M276.75 205.188C276.75 205.878 276.19 206.438 275.5 206.438C274.81 206.438 274.25 205.878 274.25 205.188C274.25 204.497 274.81 203.938 275.5 203.938C276.19 203.938 276.75 204.497 276.75 205.188Z",
                                        fill: "#0080AF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                        id: "paint0_linear_5592_7363",
                                        x1: "160",
                                        y1: "243",
                                        x2: "160",
                                        y2: "-4.94138e-06",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                stopColor: "#007758"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                offset: "1",
                                                stopColor: "#009E76",
                                                stopOpacity: "0"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                        id: "clip0_5592_7363",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            width: "320",
                                            height: "243",
                                            fill: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                        id: "clip1_5592_7363",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            width: "15",
                                            height: "15",
                                            fill: "white",
                                            transform: "translate(51 190)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                        id: "clip2_5592_7363",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            width: "15",
                                            height: "15",
                                            fill: "white",
                                            transform: "translate(24 54)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                        id: "clip3_5592_7363",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            width: "15",
                                            height: "15",
                                            fill: "white",
                                            transform: "translate(93 23)"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "sticky sticky-nav bg-green-900 border-b border-b-[rgba(255,255,255,.16)] py-3 top-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "container hidden lg:flex px-6 items-center justify-between gap-1 xl:gap-4 mx-auto",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: 'flex items-center lg:gap-3 2xl:gap-4',
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f70e481f18f162f$export$2e2bcd8739ae039), {
                                            activeClass: 'bg-[rgba(255,255,255,.24)]',
                                            id: 'mainNav',
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#overview",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)] md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "Overview"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#priorities",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)] md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "Priorities"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#scopes",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)] md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "Scopes"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#focus",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)] md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "FOCUS"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#cloud",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)] md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "Cloud Sustainability"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#intersecting",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)] md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "Intersecting Disciplines"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#ai",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)]  md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "FinOps for AI"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#conclusion",
                                                    className: 'text-lg hover:bg-[rgba(255,255,255,.24)] md:text-sm xl:text-lg px-2 py-1 rounded-xs text-white',
                                                    children: "Conclusion"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "/library",
                                        className: "btn-outline px-6 py-1",
                                        children: "Data Library"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "container relative px-6 lg:hidden mx-auto",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "/library",
                                        className: "w-full block py-2 text-center mb-4 btn-outline",
                                        children: "Data Library"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        onClick: toggleClass,
                                        className: (mobileNavActive ? 'open' : 'closed') + " mobile-nav-button",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "closed",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        width: "19",
                                                        height: "18",
                                                        viewBox: "0 0 19 18",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M3.125 5.625C3.74632 5.625 4.25 5.12132 4.25 4.5C4.25 3.87868 3.74632 3.375 3.125 3.375C2.50368 3.375 2 3.87868 2 4.5C2 5.12132 2.50368 5.625 3.125 5.625Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M6.5 3.75C6.08579 3.75 5.75 4.08579 5.75 4.5C5.75 4.91421 6.08579 5.25 6.5 5.25L16.25 5.25C16.6642 5.25 17 4.91421 17 4.5C17 4.08579 16.6642 3.75 16.25 3.75L6.5 3.75Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M6.5 8.25C6.08579 8.25 5.75 8.58579 5.75 9C5.75 9.41421 6.08579 9.75 6.5 9.75L16.25 9.75C16.6642 9.75 17 9.41421 17 9C17 8.58579 16.6642 8.25 16.25 8.25L6.5 8.25Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M5.75 13.5C5.75 13.0858 6.08579 12.75 6.5 12.75H16.25C16.6642 12.75 17 13.0858 17 13.5C17 13.9142 16.6642 14.25 16.25 14.25H6.5C6.08579 14.25 5.75 13.9142 5.75 13.5Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M4.25 9C4.25 9.62132 3.74632 10.125 3.125 10.125C2.50368 10.125 2 9.62132 2 9C2 8.37868 2.50368 7.875 3.125 7.875C3.74632 7.875 4.25 8.37868 4.25 9Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M3.125 14.625C3.74632 14.625 4.25 14.1213 4.25 13.5C4.25 12.8787 3.74632 12.375 3.125 12.375C2.50368 12.375 2 12.8787 2 13.5C2 14.1213 2.50368 14.625 3.125 14.625Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            })
                                                        ]
                                                    }),
                                                    "Contents"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "open",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 18 18",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            d: "M4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L7.9394 9.00006L3.21967 13.7198C2.92678 14.0127 2.92678 14.4876 3.21967 14.7804C3.51256 15.0733 3.98744 15.0733 4.28033 14.7804L9.00006 10.0607L13.7197 14.7803C14.0126 15.0732 14.4874 15.0732 14.7803 14.7803C15.0732 14.4874 15.0732 14.0126 14.7803 13.7197L10.0607 9.00006L14.7803 4.28044C15.0732 3.98755 15.0732 3.51268 14.7803 3.21978C14.4874 2.92689 14.0126 2.92689 13.7197 3.21978L9.00006 7.9394L4.28033 3.21967Z",
                                                            fill: "white",
                                                            fillOpacity: "0.98"
                                                        })
                                                    }),
                                                    "Close"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mobile-nav",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#overview",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "Overview"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#priorities",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "Priorities"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#scopes",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "Scopes"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#focus",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "FOCUS"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#intersecting",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "Intersecting Disciplines"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#cloud",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "Cloud Sustainability"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#ai",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "FinOps for AI"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                onClick: toggleClass,
                                                href: "#conclusion",
                                                className: 'text-lg hover:bg-[rgba(255,255,255,.24)] px-2 rounded-xs text-white',
                                                children: "Conclusion"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        id: "overview",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                className: "home-section bg-green-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "container px-6  mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "grid lg:grid-cols-12 grid-cols-1 gap-12 text-white",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: 'lg:col-span-10',
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                        children: "The 5th Annual State of FinOps survey conducted from within the FinOps Foundation community of large cloud spenders is now available. Here are takeaways from the survey which surveyed large companies responsible for over $69bn of cloud spend."
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid lg:grid-cols-2 mt-8 text-white grid-cols-1 gap-12",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "lg:col-span-2",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                                        className: "text-3xl lg:text-4xl font-normal",
                                                        children: [
                                                            "The Era of ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                                className: 'text-green-500',
                                                                children: "Cloud+"
                                                            }),
                                                            " in FinOps"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            children: [
                                                                "FinOps is as important as ever for delivering value from cloud\u2014and increasingly\u2014from other technology investments, with the majority of practices beginning to manage SaaS spend, and nearly half managing licensing. Some FinOps practices have begun to apply their capabilities to private cloud and data center scopes of spending in a ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                                        children: "\u201CCloud+\u201D"
                                                                    })
                                                                }),
                                                                " approach to FinOps."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            children: [
                                                                "While optimization continues to remain a top priority for cloud spend, ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer nofollow",
                                                                    href: "https://www.finops.org/framework/domains/understand-cloud-usage-cost/",
                                                                    children: "Understanding Costs"
                                                                }),
                                                                " and",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer nofollow",
                                                                    href: "https://www.finops.org/framework/domains/quantify-business-value/",
                                                                    children: " Quantifying Value"
                                                                }),
                                                                " (budgeting, forecasting, allocation, etc.) are being applied first to other ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer nofollow",
                                                                    href: "https://www.finops.org/framework/scopes/",
                                                                    children: "Scopes of technology"
                                                                }),
                                                                "  ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                                    children: "before "
                                                                }),
                                                                "optimization",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                                    children: " "
                                                                }),
                                                                "as companies look to get improved predictability and understanding of technology spend in addition to Cloud."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "AI spending is now managed by the majority of respondents (63% up from 31% last year) and is expected to impact all but a few FinOps practitioners in the coming year in line with the large amounts of additional investment coming across cloud, SaaS and in data-centers."
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            children: "Practitioners are now also being asked to do more with their current resources, and increasingly those running related technology management practices are merging their work with FinOps. There is a risk of being stretched thin without additional investment in areas such as upskilling, automation or staff augmentation as organizations look to increase productivity within FinOps Capabilities."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: frame1,
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                className: "home-section bg-green-900",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "container px-6  mx-auto",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid lg:grid-cols-12 text-white grid-cols-1 gap-12",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "lg:col-span-12",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "text-2xl lg:text-3xl font-normal",
                                                    children: "About the State of FinOps"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: 'lg:col-span-10',
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "The State of FinOps is an annual survey conducted by the FinOps Foundation since 2020 to collect information about key priorities, industry trends, and the direction of the FinOps practice. The survey informs a range of Foundation activities and tells the broader market how FinOps is practiced in a variety of organizations."
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "lg:col-span-12 grid grid-cols-1 lg:grid-cols-4 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        className: 'hidden max-w-full lg:block',
                                                        width: "336",
                                                        height: "208",
                                                        viewBox: "0 0 336 208",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0 12C0 5.37258 5.37258 0 12 0H324C330.627 0 336 5.37258 336 12V196C336 202.627 330.627 208 324 208H12C5.37258 208 0 202.627 0 196V12Z",
                                                                fill: "#007758"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0.5 12C0.5 5.64872 5.64873 0.5 12 0.5H324C330.351 0.5 335.5 5.64873 335.5 12V196C335.5 202.351 330.351 207.5 324 207.5H12C5.64872 207.5 0.5 202.351 0.5 196V12Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144 32C144 27.5817 147.582 24 152 24H184C188.418 24 192 27.5817 192 32V64C192 68.4183 188.418 72 184 72H152C147.582 72 144 68.4183 144 64V32Z",
                                                                fill: "#CCF4E9"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144.5 32C144.5 27.8579 147.858 24.5 152 24.5H184C188.142 24.5 191.5 27.8579 191.5 32V64C191.5 68.1421 188.142 71.5 184 71.5H152C147.858 71.5 144.5 68.1421 144.5 64V32Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                                clipPath: "url(#clip0_5592_3887)",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M163.378 36.9257C165.631 35.9855 168.117 35.7548 170.505 36.2643C172.892 36.7739 175.068 37.9996 176.74 39.7777C178.413 41.5558 179.504 43.8018 179.867 46.2159C180.23 48.6301 179.848 51.0975 178.772 53.2888C178.528 53.7846 177.929 53.9892 177.433 53.7457C176.938 53.5023 176.733 52.9031 176.976 52.4074C177.873 50.5812 178.191 48.5251 177.889 46.5133C177.586 44.5015 176.678 42.6298 175.284 41.1481C173.89 39.6663 172.077 38.6449 170.087 38.2203C168.098 37.7956 166.026 37.9879 164.149 38.7714C162.271 39.555 160.677 40.8925 159.58 42.6055C158.482 44.3184 157.934 46.3254 158.006 48.3585C158.079 50.3916 158.771 52.354 159.988 53.984C160.821 55.0988 161.872 56.0218 163.071 56.7008L162.057 53.8333C161.873 53.3126 162.146 52.7412 162.667 52.5571C163.187 52.3731 163.759 52.646 163.943 53.1667L165.887 58.6667C165.995 58.9728 165.948 59.3123 165.761 59.5774C165.573 59.8424 165.269 60 164.944 60L159 60C158.448 60 158 59.5522 158 59C158 58.4477 158.448 58 159 58L161.367 58C160.225 57.2426 159.215 56.291 158.386 55.1808C156.925 53.2248 156.095 50.8699 156.008 48.4302C155.92 45.9905 156.579 43.5821 157.896 41.5266C159.213 39.471 161.125 37.866 163.378 36.9257Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M168 40C168.552 40 169 40.4477 169 41V47.5858L172.207 50.7929C172.598 51.1834 172.598 51.8166 172.207 52.2071C171.817 52.5976 171.183 52.5976 170.793 52.2071L167.293 48.7071C167.105 48.5196 167 48.2652 167 48V41C167 40.4477 167.448 40 168 40Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M174.989 55.164C175.384 54.7783 176.017 54.786 176.403 55.1813C176.789 55.5766 176.781 56.2097 176.386 56.5954C175.991 56.9811 175.357 56.9734 174.972 56.5781C174.586 56.1828 174.594 55.5497 174.989 55.164Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M172.12 57.1211C172.623 56.8938 173.216 57.1176 173.443 57.621C173.67 58.1244 173.446 58.7166 172.943 58.9439C172.44 59.1712 171.847 58.9473 171.62 58.444C171.393 57.9406 171.617 57.3483 172.12 57.1211Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M169.827 58.9015C169.785 58.3508 169.305 57.9379 168.755 57.9793C168.204 58.0207 167.791 58.5007 167.832 59.0514C167.874 59.6022 168.354 60.0151 168.904 59.9737C169.455 59.9323 169.868 59.4522 169.827 58.9015Z",
                                                                        fill: "#009E76"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M94.2538 98H88.0538L87.6938 102.94H87.8338C87.9938 102.66 88.1604 102.413 88.3338 102.2C88.5071 101.973 88.7071 101.78 88.9338 101.62C89.1604 101.46 89.4204 101.34 89.7138 101.26C90.0071 101.167 90.3538 101.12 90.7538 101.12C91.3538 101.12 91.9071 101.22 92.4138 101.42C92.9338 101.62 93.3804 101.907 93.7538 102.28C94.1404 102.653 94.4404 103.113 94.6537 103.66C94.8671 104.193 94.9738 104.8 94.9738 105.48C94.9738 106.173 94.8604 106.813 94.6338 107.4C94.4204 107.987 94.1004 108.493 93.6738 108.92C93.2471 109.333 92.7204 109.66 92.0938 109.9C91.4804 110.127 90.7804 110.24 89.9938 110.24C89.3671 110.24 88.8138 110.167 88.3338 110.02C87.8538 109.887 87.4271 109.707 87.0538 109.48C86.6938 109.24 86.3738 108.973 86.0938 108.68C85.8271 108.373 85.5871 108.06 85.3738 107.74L87.0138 106.44C87.1871 106.72 87.3671 106.973 87.5538 107.2C87.7404 107.427 87.9538 107.627 88.1938 107.8C88.4338 107.973 88.7004 108.107 88.9938 108.2C89.3004 108.293 89.6471 108.34 90.0338 108.34C90.8604 108.34 91.4938 108.113 91.9338 107.66C92.3871 107.207 92.6138 106.58 92.6138 105.78V105.54C92.6138 104.74 92.3871 104.113 91.9338 103.66C91.4938 103.207 90.8604 102.98 90.0338 102.98C89.4338 102.98 88.9538 103.093 88.5938 103.32C88.2338 103.547 87.9271 103.8 87.6738 104.08L85.8138 103.82L86.3338 96.04H94.2538V98ZM100.526 110C99.7659 110 99.1926 109.807 98.8059 109.42C98.4193 109.02 98.2259 108.46 98.2259 107.74V101.38H96.6059V99.6H97.4859C97.8459 99.6 98.0926 99.52 98.2259 99.36C98.3726 99.2 98.4459 98.94 98.4459 98.58V96.76H100.406V99.6H102.586V101.38H100.406V108.22H102.426V110H100.526ZM104.951 95.2H107.131V101.32H107.231C107.457 100.76 107.797 100.293 108.251 99.92C108.717 99.5467 109.351 99.36 110.151 99.36C111.217 99.36 112.044 99.7133 112.631 100.42C113.231 101.113 113.531 102.107 113.531 103.4V110H111.351V103.66C111.351 102.047 110.697 101.24 109.391 101.24C109.111 101.24 108.831 101.28 108.551 101.36C108.284 101.427 108.044 101.533 107.831 101.68C107.617 101.827 107.444 102.013 107.311 102.24C107.191 102.467 107.131 102.727 107.131 103.02V110H104.951V95.2ZM130.159 110L128.899 106.22H123.679L122.459 110H120.159L124.919 96.04H127.759L132.519 110H130.159ZM126.339 98.12H126.239L124.219 104.28H128.339L126.339 98.12ZM134.521 110V99.6H136.701V101.32H136.801C137.028 100.76 137.368 100.293 137.821 99.92C138.288 99.5467 138.921 99.36 139.721 99.36C140.788 99.36 141.614 99.7133 142.201 100.42C142.801 101.113 143.101 102.107 143.101 103.4V110H140.921V103.68C140.921 102.053 140.268 101.24 138.961 101.24C138.681 101.24 138.401 101.28 138.121 101.36C137.854 101.427 137.614 101.533 137.401 101.68C137.188 101.827 137.014 102.013 136.881 102.24C136.761 102.467 136.701 102.733 136.701 103.04V110H134.521ZM146.123 110V99.6H148.303V101.32H148.403C148.629 100.76 148.969 100.293 149.423 99.92C149.889 99.5467 150.523 99.36 151.323 99.36C152.389 99.36 153.216 99.7133 153.803 100.42C154.403 101.113 154.703 102.107 154.703 103.4V110H152.523V103.68C152.523 102.053 151.869 101.24 150.563 101.24C150.283 101.24 150.003 101.28 149.723 101.36C149.456 101.427 149.216 101.533 149.003 101.68C148.789 101.827 148.616 102.013 148.483 102.24C148.363 102.467 148.303 102.733 148.303 103.04V110H146.123ZM164.024 108.28H163.944C163.851 108.533 163.724 108.78 163.564 109.02C163.417 109.26 163.224 109.473 162.984 109.66C162.757 109.833 162.477 109.973 162.144 110.08C161.824 110.187 161.451 110.24 161.024 110.24C159.944 110.24 159.104 109.893 158.504 109.2C157.917 108.507 157.624 107.513 157.624 106.22V99.6H159.804V105.94C159.804 107.553 160.471 108.36 161.804 108.36C162.084 108.36 162.357 108.327 162.624 108.26C162.891 108.18 163.124 108.067 163.324 107.92C163.537 107.773 163.704 107.587 163.824 107.36C163.957 107.133 164.024 106.867 164.024 106.56V99.6H166.204V110H164.024V108.28ZM176.946 110C176.372 110 175.932 109.84 175.626 109.52C175.319 109.187 175.132 108.767 175.066 108.26H174.966C174.766 108.913 174.399 109.407 173.866 109.74C173.332 110.073 172.686 110.24 171.926 110.24C170.846 110.24 170.012 109.96 169.426 109.4C168.852 108.84 168.566 108.087 168.566 107.14C168.566 106.1 168.939 105.32 169.686 104.8C170.446 104.28 171.552 104.02 173.006 104.02H174.886V103.14C174.886 102.5 174.712 102.007 174.366 101.66C174.019 101.313 173.479 101.14 172.746 101.14C172.132 101.14 171.632 101.273 171.246 101.54C170.859 101.807 170.532 102.147 170.266 102.56L168.966 101.38C169.312 100.793 169.799 100.313 170.426 99.94C171.052 99.5533 171.872 99.36 172.886 99.36C174.232 99.36 175.266 99.6733 175.986 100.3C176.706 100.927 177.066 101.827 177.066 103V108.22H178.166V110H176.946ZM172.546 108.58C173.226 108.58 173.786 108.433 174.226 108.14C174.666 107.833 174.886 107.427 174.886 106.92V105.42H173.046C171.539 105.42 170.786 105.887 170.786 106.82V107.18C170.786 107.647 170.939 108 171.246 108.24C171.566 108.467 171.999 108.58 172.546 108.58ZM182.522 110C181.776 110 181.216 109.813 180.842 109.44C180.482 109.053 180.302 108.52 180.302 107.84V95.2H182.482V108.22H183.922V110H182.522ZM195.072 110.24C193.899 110.24 192.899 110.027 192.072 109.6C191.259 109.173 190.559 108.6 189.972 107.88L191.532 106.42C192.025 107.02 192.565 107.473 193.152 107.78C193.752 108.087 194.432 108.24 195.192 108.24C196.085 108.24 196.759 108.04 197.212 107.64C197.665 107.24 197.892 106.7 197.892 106.02C197.892 105.473 197.732 105.04 197.412 104.72C197.092 104.4 196.525 104.16 195.712 104L194.472 103.78C193.112 103.527 192.092 103.08 191.412 102.44C190.732 101.8 190.392 100.92 190.392 99.8C190.392 99.1867 190.505 98.6333 190.732 98.14C190.972 97.6333 191.299 97.2133 191.712 96.88C192.139 96.5333 192.652 96.2667 193.252 96.08C193.852 95.8933 194.525 95.8 195.272 95.8C196.325 95.8 197.239 95.9867 198.012 96.36C198.785 96.72 199.445 97.2467 199.992 97.94L198.412 99.34C198.052 98.8733 197.612 98.5 197.092 98.22C196.572 97.94 195.925 97.8 195.152 97.8C194.352 97.8 193.732 97.96 193.292 98.28C192.852 98.6 192.632 99.0667 192.632 99.68C192.632 100.267 192.812 100.707 193.172 101C193.532 101.28 194.092 101.493 194.852 101.64L196.092 101.9C197.492 102.167 198.512 102.62 199.152 103.26C199.805 103.9 200.132 104.78 200.132 105.9C200.132 106.553 200.019 107.147 199.792 107.68C199.565 108.213 199.232 108.673 198.792 109.06C198.365 109.433 197.839 109.727 197.212 109.94C196.585 110.14 195.872 110.24 195.072 110.24ZM208.985 108.28H208.905C208.812 108.533 208.685 108.78 208.525 109.02C208.378 109.26 208.185 109.473 207.945 109.66C207.718 109.833 207.438 109.973 207.105 110.08C206.785 110.187 206.412 110.24 205.985 110.24C204.905 110.24 204.065 109.893 203.465 109.2C202.878 108.507 202.585 107.513 202.585 106.22V99.6H204.765V105.94C204.765 107.553 205.432 108.36 206.765 108.36C207.045 108.36 207.318 108.327 207.585 108.26C207.852 108.18 208.085 108.067 208.285 107.92C208.498 107.773 208.665 107.587 208.785 107.36C208.918 107.133 208.985 106.867 208.985 106.56V99.6H211.165V110H208.985V108.28ZM214.287 110V99.6H216.467V101.6H216.567C216.713 101.067 217.02 100.6 217.487 100.2C217.953 99.8 218.6 99.6 219.427 99.6H220.007V101.7H219.147C218.28 101.7 217.613 101.84 217.147 102.12C216.693 102.4 216.467 102.813 216.467 103.36V110H214.287ZM224.379 110L220.839 99.6H222.999L224.579 104.34L225.639 107.98H225.759L226.819 104.34L228.439 99.6H230.519L226.939 110H224.379ZM236.277 110.24C235.53 110.24 234.863 110.113 234.277 109.86C233.69 109.607 233.19 109.247 232.777 108.78C232.363 108.3 232.043 107.727 231.817 107.06C231.603 106.38 231.497 105.627 231.497 104.8C231.497 103.973 231.603 103.227 231.817 102.56C232.043 101.88 232.363 101.307 232.777 100.84C233.19 100.36 233.69 99.9933 234.277 99.74C234.863 99.4867 235.53 99.36 236.277 99.36C237.037 99.36 237.703 99.4933 238.277 99.76C238.863 100.027 239.35 100.4 239.737 100.88C240.123 101.347 240.41 101.893 240.597 102.52C240.797 103.147 240.897 103.82 240.897 104.54V105.36H233.757V105.7C233.757 106.5 233.99 107.16 234.457 107.68C234.937 108.187 235.617 108.44 236.497 108.44C237.137 108.44 237.677 108.3 238.117 108.02C238.557 107.74 238.93 107.36 239.237 106.88L240.517 108.14C240.13 108.78 239.57 109.293 238.837 109.68C238.103 110.053 237.25 110.24 236.277 110.24ZM236.277 101.06C235.903 101.06 235.557 101.127 235.237 101.26C234.93 101.393 234.663 101.58 234.437 101.82C234.223 102.06 234.057 102.347 233.937 102.68C233.817 103.013 233.757 103.38 233.757 103.78V103.92H238.597V103.72C238.597 102.92 238.39 102.28 237.977 101.8C237.563 101.307 236.997 101.06 236.277 101.06ZM249.573 99.6H251.673L247.293 112.06C247.173 112.407 247.033 112.7 246.873 112.94C246.726 113.193 246.546 113.393 246.333 113.54C246.133 113.7 245.886 113.813 245.593 113.88C245.299 113.96 244.953 114 244.553 114H243.293V112.22H245.053L245.653 110.46L241.873 99.6H244.053L246.133 105.72L246.733 107.98H246.833L247.493 105.72L249.573 99.6Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M136.173 139.168C135.352 139.168 134.652 139.019 134.073 138.72C133.504 138.421 133.014 138.02 132.603 137.516L133.695 136.494C134.04 136.914 134.418 137.231 134.829 137.446C135.249 137.661 135.725 137.768 136.257 137.768C136.882 137.768 137.354 137.628 137.671 137.348C137.988 137.068 138.147 136.69 138.147 136.214C138.147 135.831 138.035 135.528 137.811 135.304C137.587 135.08 137.19 134.912 136.621 134.8L135.753 134.646C134.801 134.469 134.087 134.156 133.611 133.708C133.135 133.26 132.897 132.644 132.897 131.86C132.897 131.431 132.976 131.043 133.135 130.698C133.303 130.343 133.532 130.049 133.821 129.816C134.12 129.573 134.479 129.387 134.899 129.256C135.319 129.125 135.79 129.06 136.313 129.06C137.05 129.06 137.69 129.191 138.231 129.452C138.772 129.704 139.234 130.073 139.617 130.558L138.511 131.538C138.259 131.211 137.951 130.95 137.587 130.754C137.223 130.558 136.77 130.46 136.229 130.46C135.669 130.46 135.235 130.572 134.927 130.796C134.619 131.02 134.465 131.347 134.465 131.776C134.465 132.187 134.591 132.495 134.843 132.7C135.095 132.896 135.487 133.045 136.019 133.148L136.887 133.33C137.867 133.517 138.581 133.834 139.029 134.282C139.486 134.73 139.715 135.346 139.715 136.13C139.715 136.587 139.636 137.003 139.477 137.376C139.318 137.749 139.085 138.071 138.777 138.342C138.478 138.603 138.11 138.809 137.671 138.958C137.232 139.098 136.733 139.168 136.173 139.168ZM142.272 130.418C141.955 130.418 141.721 130.343 141.572 130.194C141.432 130.045 141.362 129.853 141.362 129.62V129.382C141.362 129.149 141.432 128.957 141.572 128.808C141.721 128.659 141.955 128.584 142.272 128.584C142.589 128.584 142.818 128.659 142.958 128.808C143.098 128.957 143.168 129.149 143.168 129.382V129.62C143.168 129.853 143.098 130.045 142.958 130.194C142.818 130.343 142.589 130.418 142.272 130.418ZM141.502 131.72H143.028V139H141.502V131.72ZM145.207 139V131.72H146.733V132.924H146.803C146.962 132.532 147.2 132.205 147.517 131.944C147.844 131.683 148.287 131.552 148.847 131.552C149.594 131.552 150.173 131.799 150.583 132.294C151.003 132.779 151.213 133.475 151.213 134.38V139H149.687V134.576C149.687 133.437 149.23 132.868 148.315 132.868C148.119 132.868 147.923 132.896 147.727 132.952C147.541 132.999 147.373 133.073 147.223 133.176C147.074 133.279 146.953 133.409 146.859 133.568C146.775 133.727 146.733 133.913 146.733 134.128V139H145.207ZM156.142 139.168C155.62 139.168 155.153 139.079 154.742 138.902C154.332 138.725 153.986 138.473 153.706 138.146C153.426 137.81 153.212 137.409 153.062 136.942C152.913 136.466 152.838 135.939 152.838 135.36C152.838 134.781 152.913 134.259 153.062 133.792C153.212 133.316 153.426 132.915 153.706 132.588C153.986 132.252 154.332 131.995 154.742 131.818C155.153 131.641 155.62 131.552 156.142 131.552C156.87 131.552 157.468 131.715 157.934 132.042C158.401 132.369 158.742 132.803 158.956 133.344L157.696 133.932C157.594 133.596 157.412 133.33 157.15 133.134C156.898 132.929 156.562 132.826 156.142 132.826C155.582 132.826 155.158 133.003 154.868 133.358C154.588 133.703 154.448 134.156 154.448 134.716V136.018C154.448 136.578 154.588 137.035 154.868 137.39C155.158 137.735 155.582 137.908 156.142 137.908C156.59 137.908 156.945 137.801 157.206 137.586C157.477 137.362 157.692 137.068 157.85 136.704L159.012 137.32C158.77 137.917 158.406 138.375 157.92 138.692C157.435 139.009 156.842 139.168 156.142 139.168ZM163.239 139.168C162.716 139.168 162.25 139.079 161.839 138.902C161.428 138.725 161.078 138.473 160.789 138.146C160.5 137.81 160.276 137.409 160.117 136.942C159.968 136.466 159.893 135.939 159.893 135.36C159.893 134.781 159.968 134.259 160.117 133.792C160.276 133.316 160.5 132.915 160.789 132.588C161.078 132.252 161.428 131.995 161.839 131.818C162.25 131.641 162.716 131.552 163.239 131.552C163.771 131.552 164.238 131.645 164.639 131.832C165.05 132.019 165.39 132.28 165.661 132.616C165.932 132.943 166.132 133.325 166.263 133.764C166.403 134.203 166.473 134.674 166.473 135.178V135.752H161.475V135.99C161.475 136.55 161.638 137.012 161.965 137.376C162.301 137.731 162.777 137.908 163.393 137.908C163.841 137.908 164.219 137.81 164.527 137.614C164.835 137.418 165.096 137.152 165.311 136.816L166.207 137.698C165.936 138.146 165.544 138.505 165.031 138.776C164.518 139.037 163.92 139.168 163.239 139.168ZM163.239 132.742C162.978 132.742 162.735 132.789 162.511 132.882C162.296 132.975 162.11 133.106 161.951 133.274C161.802 133.442 161.685 133.643 161.601 133.876C161.517 134.109 161.475 134.366 161.475 134.646V134.744H164.863V134.604C164.863 134.044 164.718 133.596 164.429 133.26C164.14 132.915 163.743 132.742 163.239 132.742ZM177.953 139H171.317V137.488L174.439 134.702C174.934 134.254 175.312 133.829 175.573 133.428C175.844 133.017 175.979 132.588 175.979 132.14V131.958C175.979 131.482 175.834 131.109 175.545 130.838C175.265 130.567 174.882 130.432 174.397 130.432C174.126 130.432 173.888 130.474 173.683 130.558C173.487 130.633 173.314 130.74 173.165 130.88C173.016 131.02 172.89 131.183 172.787 131.37C172.694 131.557 172.619 131.757 172.563 131.972L171.177 131.44C171.28 131.132 171.42 130.838 171.597 130.558C171.774 130.269 171.998 130.012 172.269 129.788C172.54 129.564 172.857 129.387 173.221 129.256C173.594 129.125 174.028 129.06 174.523 129.06C175.018 129.06 175.461 129.135 175.853 129.284C176.245 129.424 176.572 129.625 176.833 129.886C177.104 130.138 177.309 130.441 177.449 130.796C177.589 131.151 177.659 131.538 177.659 131.958C177.659 132.35 177.598 132.714 177.477 133.05C177.356 133.386 177.188 133.703 176.973 134.002C176.758 134.301 176.506 134.585 176.217 134.856C175.937 135.127 175.638 135.402 175.321 135.682L173.025 137.656H177.953V139ZM182.973 139.168C182.367 139.168 181.839 139.056 181.391 138.832C180.943 138.599 180.575 138.267 180.285 137.838C179.996 137.409 179.781 136.881 179.641 136.256C179.501 135.631 179.431 134.917 179.431 134.114C179.431 133.321 179.501 132.611 179.641 131.986C179.781 131.351 179.996 130.819 180.285 130.39C180.575 129.961 180.943 129.634 181.391 129.41C181.839 129.177 182.367 129.06 182.973 129.06C184.187 129.06 185.078 129.503 185.647 130.39C186.226 131.277 186.515 132.518 186.515 134.114C186.515 135.71 186.226 136.951 185.647 137.838C185.078 138.725 184.187 139.168 182.973 139.168ZM182.973 137.824C183.309 137.824 183.594 137.759 183.827 137.628C184.07 137.488 184.266 137.292 184.415 137.04C184.565 136.788 184.672 136.489 184.737 136.144C184.803 135.789 184.835 135.397 184.835 134.968V133.26C184.835 132.831 184.803 132.443 184.737 132.098C184.672 131.743 184.565 131.44 184.415 131.188C184.266 130.936 184.07 130.745 183.827 130.614C183.594 130.474 183.309 130.404 182.973 130.404C182.637 130.404 182.348 130.474 182.105 130.614C181.872 130.745 181.681 130.936 181.531 131.188C181.382 131.44 181.275 131.743 181.209 132.098C181.144 132.443 181.111 132.831 181.111 133.26V134.968C181.111 135.397 181.144 135.789 181.209 136.144C181.275 136.489 181.382 136.788 181.531 137.04C181.681 137.292 181.872 137.488 182.105 137.628C182.348 137.759 182.637 137.824 182.973 137.824ZM194.742 139H188.106V137.488L191.228 134.702C191.723 134.254 192.101 133.829 192.362 133.428C192.633 133.017 192.768 132.588 192.768 132.14V131.958C192.768 131.482 192.623 131.109 192.334 130.838C192.054 130.567 191.671 130.432 191.186 130.432C190.915 130.432 190.677 130.474 190.472 130.558C190.276 130.633 190.103 130.74 189.954 130.88C189.805 131.02 189.679 131.183 189.576 131.37C189.483 131.557 189.408 131.757 189.352 131.972L187.966 131.44C188.069 131.132 188.209 130.838 188.386 130.558C188.563 130.269 188.787 130.012 189.058 129.788C189.329 129.564 189.646 129.387 190.01 129.256C190.383 129.125 190.817 129.06 191.312 129.06C191.807 129.06 192.25 129.135 192.642 129.284C193.034 129.424 193.361 129.625 193.622 129.886C193.893 130.138 194.098 130.441 194.238 130.796C194.378 131.151 194.448 131.538 194.448 131.958C194.448 132.35 194.387 132.714 194.266 133.05C194.145 133.386 193.977 133.703 193.762 134.002C193.547 134.301 193.295 134.585 193.006 134.856C192.726 135.127 192.427 135.402 192.11 135.682L189.814 137.656H194.742V139ZM199.763 139.168C199.156 139.168 198.629 139.056 198.181 138.832C197.733 138.599 197.364 138.267 197.075 137.838C196.785 137.409 196.571 136.881 196.431 136.256C196.291 135.631 196.221 134.917 196.221 134.114C196.221 133.321 196.291 132.611 196.431 131.986C196.571 131.351 196.785 130.819 197.075 130.39C197.364 129.961 197.733 129.634 198.181 129.41C198.629 129.177 199.156 129.06 199.763 129.06C200.976 129.06 201.867 129.503 202.437 130.39C203.015 131.277 203.305 132.518 203.305 134.114C203.305 135.71 203.015 136.951 202.437 137.838C201.867 138.725 200.976 139.168 199.763 139.168ZM199.763 137.824C200.099 137.824 200.383 137.759 200.617 137.628C200.859 137.488 201.055 137.292 201.205 137.04C201.354 136.788 201.461 136.489 201.527 136.144C201.592 135.789 201.625 135.397 201.625 134.968V133.26C201.625 132.831 201.592 132.443 201.527 132.098C201.461 131.743 201.354 131.44 201.205 131.188C201.055 130.936 200.859 130.745 200.617 130.614C200.383 130.474 200.099 130.404 199.763 130.404C199.427 130.404 199.137 130.474 198.895 130.614C198.661 130.745 198.47 130.936 198.321 131.188C198.171 131.44 198.064 131.743 197.999 132.098C197.933 132.443 197.901 132.831 197.901 133.26V134.968C197.901 135.397 197.933 135.789 197.999 136.144C198.064 136.489 198.171 136.788 198.321 137.04C198.47 137.292 198.661 137.488 198.895 137.628C199.137 137.759 199.427 137.824 199.763 137.824Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                                    id: "clip0_5592_3887",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        fill: "white",
                                                                        transform: "translate(156 36)"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        className: 'hidden max-w-full lg:block',
                                                        width: "336",
                                                        height: "208",
                                                        viewBox: "0 0 336 208",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0 12C0 5.37258 5.37258 0 12 0H324C330.627 0 336 5.37258 336 12V196C336 202.627 330.627 208 324 208H12C5.37258 208 0 202.627 0 196V12Z",
                                                                fill: "#004D69"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0.5 12C0.5 5.64872 5.64873 0.5 12 0.5H324C330.351 0.5 335.5 5.64873 335.5 12V196C335.5 202.351 330.351 207.5 324 207.5H12C5.64872 207.5 0.5 202.351 0.5 196V12Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144 32C144 27.5817 147.582 24 152 24H184C188.418 24 192 27.5817 192 32V64C192 68.4183 188.418 72 184 72H152C147.582 72 144 68.4183 144 64V32Z",
                                                                fill: "#CCE6EF"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144.5 32C144.5 27.8579 147.858 24.5 152 24.5H184C188.142 24.5 191.5 27.8579 191.5 32V64C191.5 68.1421 188.142 71.5 184 71.5H152C147.858 71.5 144.5 68.1421 144.5 64V32Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M169 51.7858C169 51.4554 168.662 51.0001 168 51.0001C166.453 51.0001 165 49.8563 165 48.2143C165 46.9361 165.88 45.96 167 45.5901V45C167 44.4477 167.448 44 168 44C168.552 44 169 44.4477 169 45V45.587C169.537 45.7628 170.011 46.0782 170.365 46.4991C170.721 46.9217 170.667 47.5525 170.244 47.9081C169.821 48.2636 169.19 48.2092 168.835 47.7866C168.667 47.5874 168.371 47.4286 168 47.4286C167.338 47.4286 167 47.8839 167 48.2143C167 48.5447 167.338 49.0001 168 49.0001C169.547 49.0001 171 50.1438 171 51.7858C171 53.064 170.12 54.0402 169 54.4101V55.0001C169 55.5524 168.552 56.0001 168 56.0001C167.448 56.0001 167 55.5524 167 55.0001V54.4131C166.463 54.2373 165.989 53.9219 165.635 53.501C165.279 53.0784 165.334 52.4476 165.756 52.092C166.179 51.7365 166.81 51.7909 167.165 52.2135C167.333 52.4127 167.629 52.5715 168 52.5715C168.662 52.5715 169 52.1162 169 51.7858Z",
                                                                fill: "#00668C"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                clipRule: "evenodd",
                                                                d: "M173 37C173.552 37 174 37.4477 174 38L174 43.2917C175.841 44.9396 177 47.3345 177 50C177 54.9706 172.971 59 168 59C163.029 59 159 54.9706 159 50C159 47.3345 160.159 44.9396 162 43.2917V38C162 37.4477 162.448 37 163 37C163.552 37 164 37.4477 164 38V41.9355C164.921 41.4776 165.933 41.1729 167 41.0549V38C167 37.4477 167.448 37 168 37C168.552 37 169 37.4477 169 38V41.0549C170.067 41.1729 171.079 41.4776 172 41.9355L172 38C172 37.4477 172.448 37 173 37ZM168 43C164.134 43 161 46.134 161 50C161 53.866 164.134 57 168 57C171.866 57 175 53.866 175 50C175 46.134 171.866 43 168 43Z",
                                                                fill: "#00668C"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M85.3444 105.48C84.851 105.48 84.411 105.42 84.0244 105.3C83.651 105.167 83.2377 104.987 82.7844 104.76C82.411 104.573 82.0444 104.413 81.6844 104.28C81.3377 104.147 80.9577 104.08 80.5444 104.08C80.2377 104.08 79.9644 104.127 79.7244 104.22C79.4977 104.313 79.231 104.467 78.9244 104.68L78.1444 103.46C78.3977 103.113 78.7177 102.833 79.1044 102.62C79.491 102.407 79.9977 102.3 80.6244 102.3C81.1177 102.3 81.551 102.367 81.9244 102.5C82.311 102.62 82.731 102.793 83.1844 103.02C83.5577 103.207 83.9177 103.367 84.2644 103.5C84.6244 103.633 85.011 103.7 85.4244 103.7C85.731 103.7 85.9977 103.653 86.2244 103.56C86.4644 103.467 86.7377 103.313 87.0444 103.1L87.8244 104.32C87.571 104.667 87.251 104.947 86.8644 105.16C86.4777 105.373 85.971 105.48 85.3444 105.48ZM94.1966 111.64V109.92C93.1832 109.84 92.3299 109.593 91.6366 109.18C90.9432 108.767 90.3432 108.26 89.8366 107.66L91.2966 106.34C91.7099 106.847 92.1566 107.253 92.6366 107.56C93.1299 107.867 93.6966 108.06 94.3366 108.14V103.66C92.8966 103.353 91.8566 102.893 91.2166 102.28C90.5766 101.653 90.2566 100.833 90.2566 99.82C90.2566 98.7533 90.6099 97.9067 91.3166 97.28C92.0232 96.6533 92.9832 96.2733 94.1966 96.14V94.4H95.8966V96.14C96.7499 96.22 97.4899 96.4333 98.1166 96.78C98.7566 97.1267 99.3099 97.6 99.7766 98.2L98.2966 99.42C98.0032 99.0333 97.6499 98.7133 97.2366 98.46C96.8366 98.1933 96.3499 98.0133 95.7766 97.92V102.02C96.5632 102.193 97.2166 102.4 97.7366 102.64C98.2566 102.88 98.6766 103.153 98.9966 103.46C99.3299 103.753 99.5699 104.1 99.7166 104.5C99.8632 104.887 99.9366 105.34 99.9366 105.86C99.9366 106.94 99.5832 107.84 98.8766 108.56C98.1832 109.28 97.1899 109.72 95.8966 109.88V111.64H94.1966ZM97.8366 106C97.8366 105.493 97.6899 105.08 97.3966 104.76C97.1032 104.427 96.5632 104.16 95.7766 103.96V108.12C96.4299 108.013 96.9366 107.773 97.2966 107.4C97.6566 107.027 97.8366 106.56 97.8366 106ZM92.3366 99.72C92.3366 100.28 92.4966 100.707 92.8166 101C93.1499 101.28 93.6566 101.513 94.3366 101.7V97.9C93.6966 97.9933 93.2032 98.1933 92.8566 98.5C92.5099 98.8067 92.3366 99.2133 92.3366 99.72ZM106.989 110.24C106.216 110.24 105.523 110.113 104.909 109.86C104.309 109.607 103.796 109.247 103.369 108.78C102.956 108.3 102.636 107.727 102.409 107.06C102.183 106.393 102.069 105.64 102.069 104.8C102.069 103.787 102.223 102.833 102.529 101.94C102.836 101.047 103.229 100.227 103.709 99.48C104.189 98.7333 104.723 98.0733 105.309 97.5C105.909 96.9133 106.496 96.4267 107.069 96.04H110.069C109.283 96.6133 108.576 97.1667 107.949 97.7C107.323 98.2333 106.776 98.78 106.309 99.34C105.843 99.9 105.449 100.493 105.129 101.12C104.823 101.747 104.583 102.433 104.409 103.18L104.549 103.22C104.696 102.94 104.863 102.68 105.049 102.44C105.249 102.187 105.476 101.967 105.729 101.78C105.996 101.593 106.296 101.447 106.629 101.34C106.963 101.233 107.349 101.18 107.789 101.18C108.376 101.18 108.916 101.28 109.409 101.48C109.916 101.68 110.349 101.973 110.709 102.36C111.083 102.733 111.369 103.187 111.569 103.72C111.783 104.253 111.889 104.847 111.889 105.5C111.889 106.207 111.769 106.853 111.529 107.44C111.303 108.013 110.976 108.507 110.549 108.92C110.123 109.333 109.603 109.66 108.989 109.9C108.389 110.127 107.723 110.24 106.989 110.24ZM106.989 108.4C107.803 108.4 108.436 108.187 108.889 107.76C109.343 107.32 109.569 106.68 109.569 105.84V105.56C109.569 104.72 109.343 104.087 108.889 103.66C108.436 103.22 107.803 103 106.989 103C106.176 103 105.543 103.22 105.089 103.66C104.636 104.087 104.409 104.72 104.409 105.56V105.84C104.409 106.68 104.636 107.32 105.089 107.76C105.543 108.187 106.176 108.4 106.989 108.4ZM123.821 101.24C123.821 102.253 123.668 103.207 123.361 104.1C123.055 104.993 122.661 105.813 122.181 106.56C121.701 107.307 121.161 107.973 120.561 108.56C119.975 109.147 119.395 109.627 118.821 110H115.821C116.608 109.427 117.315 108.873 117.941 108.34C118.568 107.807 119.115 107.26 119.581 106.7C120.048 106.14 120.435 105.547 120.741 104.92C121.061 104.293 121.308 103.607 121.481 102.86L121.341 102.82C121.195 103.1 121.021 103.367 120.821 103.62C120.635 103.86 120.408 104.073 120.141 104.26C119.888 104.447 119.595 104.593 119.261 104.7C118.928 104.807 118.541 104.86 118.101 104.86C117.515 104.86 116.968 104.76 116.461 104.56C115.968 104.36 115.535 104.073 115.161 103.7C114.801 103.313 114.515 102.86 114.301 102.34C114.101 101.807 114.001 101.207 114.001 100.54C114.001 99.8467 114.115 99.2067 114.341 98.62C114.581 98.0333 114.915 97.5333 115.341 97.12C115.768 96.7067 116.281 96.3867 116.881 96.16C117.481 95.92 118.155 95.8 118.901 95.8C119.675 95.8 120.361 95.9267 120.961 96.18C121.575 96.4333 122.088 96.8 122.501 97.28C122.928 97.7467 123.255 98.3133 123.481 98.98C123.708 99.6467 123.821 100.4 123.821 101.24ZM118.901 103.04C119.715 103.04 120.348 102.827 120.801 102.4C121.255 101.96 121.481 101.32 121.481 100.48V100.2C121.481 99.36 121.255 98.7267 120.801 98.3C120.348 97.86 119.715 97.64 118.901 97.64C118.088 97.64 117.455 97.86 117.001 98.3C116.548 98.7267 116.321 99.36 116.321 100.2V100.48C116.321 101.32 116.548 101.96 117.001 102.4C117.455 102.827 118.088 103.04 118.901 103.04ZM126.654 96.04H132.834C133.994 96.04 134.9 96.3667 135.554 97.02C136.22 97.6733 136.554 98.5467 136.554 99.64C136.554 100.16 136.48 100.607 136.334 100.98C136.187 101.34 136 101.64 135.774 101.88C135.547 102.107 135.287 102.28 134.994 102.4C134.7 102.507 134.414 102.573 134.134 102.6V102.72C134.414 102.733 134.72 102.8 135.054 102.92C135.4 103.04 135.72 103.233 136.014 103.5C136.307 103.753 136.554 104.087 136.754 104.5C136.954 104.9 137.054 105.393 137.054 105.98C137.054 106.54 136.96 107.067 136.774 107.56C136.6 108.053 136.354 108.48 136.034 108.84C135.714 109.2 135.334 109.487 134.894 109.7C134.454 109.9 133.974 110 133.454 110H126.654V96.04ZM128.914 108.06H132.794C133.38 108.06 133.84 107.907 134.174 107.6C134.507 107.293 134.674 106.853 134.674 106.28V105.6C134.674 105.027 134.507 104.587 134.174 104.28C133.84 103.973 133.38 103.82 132.794 103.82H128.914V108.06ZM128.914 101.94H132.414C132.974 101.94 133.407 101.8 133.714 101.52C134.02 101.227 134.174 100.813 134.174 100.28V99.64C134.174 99.1067 134.02 98.7 133.714 98.42C133.407 98.1267 132.974 97.98 132.414 97.98H128.914V101.94ZM149.804 110.24C147.977 110.24 146.544 109.627 145.504 108.4C144.464 107.16 143.944 105.367 143.944 103.02C143.944 101.847 144.077 100.813 144.344 99.92C144.61 99.0267 144.997 98.2733 145.504 97.66C146.01 97.0467 146.624 96.5867 147.344 96.28C148.077 95.96 148.897 95.8 149.804 95.8C151.017 95.8 152.03 96.0667 152.844 96.6C153.67 97.1333 154.317 97.92 154.784 98.96L152.884 100C152.644 99.3333 152.27 98.8067 151.764 98.42C151.27 98.02 150.617 97.82 149.804 97.82C148.724 97.82 147.877 98.1867 147.264 98.92C146.65 99.6533 146.344 100.667 146.344 101.96V104.08C146.344 105.373 146.65 106.387 147.264 107.12C147.877 107.853 148.724 108.22 149.804 108.22C150.644 108.22 151.324 108.007 151.844 107.58C152.377 107.14 152.77 106.58 153.024 105.9L154.844 107C154.377 108.013 153.724 108.807 152.884 109.38C152.044 109.953 151.017 110.24 149.804 110.24ZM159.3 110C158.553 110 157.993 109.813 157.62 109.44C157.26 109.053 157.08 108.52 157.08 107.84V95.2H159.26V108.22H160.7V110H159.3ZM166.863 110.24C166.143 110.24 165.483 110.113 164.883 109.86C164.296 109.607 163.796 109.247 163.383 108.78C162.969 108.3 162.649 107.727 162.423 107.06C162.196 106.38 162.083 105.627 162.083 104.8C162.083 103.973 162.196 103.227 162.423 102.56C162.649 101.88 162.969 101.307 163.383 100.84C163.796 100.36 164.296 99.9933 164.883 99.74C165.483 99.4867 166.143 99.36 166.863 99.36C167.583 99.36 168.236 99.4867 168.823 99.74C169.423 99.9933 169.929 100.36 170.343 100.84C170.756 101.307 171.076 101.88 171.303 102.56C171.529 103.227 171.643 103.973 171.643 104.8C171.643 105.627 171.529 106.38 171.303 107.06C171.076 107.727 170.756 108.3 170.343 108.78C169.929 109.247 169.423 109.607 168.823 109.86C168.236 110.113 167.583 110.24 166.863 110.24ZM166.863 108.44C167.609 108.44 168.209 108.213 168.663 107.76C169.116 107.293 169.343 106.6 169.343 105.68V103.92C169.343 103 169.116 102.313 168.663 101.86C168.209 101.393 167.609 101.16 166.863 101.16C166.116 101.16 165.516 101.393 165.063 101.86C164.609 102.313 164.383 103 164.383 103.92V105.68C164.383 106.6 164.609 107.293 165.063 107.76C165.516 108.213 166.116 108.44 166.863 108.44ZM180.372 108.28H180.292C180.198 108.533 180.072 108.78 179.912 109.02C179.765 109.26 179.572 109.473 179.332 109.66C179.105 109.833 178.825 109.973 178.492 110.08C178.172 110.187 177.798 110.24 177.372 110.24C176.292 110.24 175.452 109.893 174.852 109.2C174.265 108.507 173.972 107.513 173.972 106.22V99.6H176.152V105.94C176.152 107.553 176.818 108.36 178.152 108.36C178.432 108.36 178.705 108.327 178.972 108.26C179.238 108.18 179.472 108.067 179.672 107.92C179.885 107.773 180.052 107.587 180.172 107.36C180.305 107.133 180.372 106.867 180.372 106.56V99.6H182.552V110H180.372V108.28ZM192.213 108.28H192.113C191.887 108.893 191.513 109.373 190.993 109.72C190.487 110.067 189.887 110.24 189.193 110.24C187.873 110.24 186.853 109.767 186.133 108.82C185.413 107.86 185.053 106.52 185.053 104.8C185.053 103.08 185.413 101.747 186.133 100.8C186.853 99.84 187.873 99.36 189.193 99.36C189.887 99.36 190.487 99.5333 190.993 99.88C191.513 100.213 191.887 100.693 192.113 101.32H192.213V95.2H194.393V110H192.213V108.28ZM189.853 108.36C190.52 108.36 191.08 108.2 191.533 107.88C191.987 107.547 192.213 107.113 192.213 106.58V103.02C192.213 102.487 191.987 102.06 191.533 101.74C191.08 101.407 190.52 101.24 189.853 101.24C189.093 101.24 188.487 101.487 188.033 101.98C187.58 102.46 187.353 103.1 187.353 103.9V105.7C187.353 106.5 187.58 107.147 188.033 107.64C188.487 108.12 189.093 108.36 189.853 108.36ZM206.576 110.24C205.402 110.24 204.402 110.027 203.576 109.6C202.762 109.173 202.062 108.6 201.476 107.88L203.036 106.42C203.529 107.02 204.069 107.473 204.656 107.78C205.256 108.087 205.936 108.24 206.696 108.24C207.589 108.24 208.262 108.04 208.716 107.64C209.169 107.24 209.396 106.7 209.396 106.02C209.396 105.473 209.236 105.04 208.916 104.72C208.596 104.4 208.029 104.16 207.216 104L205.976 103.78C204.616 103.527 203.596 103.08 202.916 102.44C202.236 101.8 201.896 100.92 201.896 99.8C201.896 99.1867 202.009 98.6333 202.236 98.14C202.476 97.6333 202.802 97.2133 203.216 96.88C203.642 96.5333 204.156 96.2667 204.756 96.08C205.356 95.8933 206.029 95.8 206.776 95.8C207.829 95.8 208.742 95.9867 209.516 96.36C210.289 96.72 210.949 97.2467 211.496 97.94L209.916 99.34C209.556 98.8733 209.116 98.5 208.596 98.22C208.076 97.94 207.429 97.8 206.656 97.8C205.856 97.8 205.236 97.96 204.796 98.28C204.356 98.6 204.136 99.0667 204.136 99.68C204.136 100.267 204.316 100.707 204.676 101C205.036 101.28 205.596 101.493 206.356 101.64L207.596 101.9C208.996 102.167 210.016 102.62 210.656 103.26C211.309 103.9 211.636 104.78 211.636 105.9C211.636 106.553 211.522 107.147 211.296 107.68C211.069 108.213 210.736 108.673 210.296 109.06C209.869 109.433 209.342 109.727 208.716 109.94C208.089 110.14 207.376 110.24 206.576 110.24ZM214.189 99.6H216.369V101.32H216.469C216.696 100.693 217.062 100.213 217.569 99.88C218.089 99.5333 218.696 99.36 219.389 99.36C220.709 99.36 221.729 99.84 222.449 100.8C223.169 101.747 223.529 103.08 223.529 104.8C223.529 106.52 223.169 107.86 222.449 108.82C221.729 109.767 220.709 110.24 219.389 110.24C218.696 110.24 218.089 110.067 217.569 109.72C217.062 109.373 216.696 108.893 216.469 108.28H216.369V114H214.189V99.6ZM218.729 108.36C219.489 108.36 220.096 108.12 220.549 107.64C221.002 107.147 221.229 106.5 221.229 105.7V103.9C221.229 103.1 221.002 102.46 220.549 101.98C220.096 101.487 219.489 101.24 218.729 101.24C218.062 101.24 217.502 101.407 217.049 101.74C216.596 102.06 216.369 102.487 216.369 103.02V106.58C216.369 107.113 216.596 107.547 217.049 107.88C217.502 108.2 218.062 108.36 218.729 108.36ZM230.105 110.24C229.358 110.24 228.692 110.113 228.105 109.86C227.518 109.607 227.018 109.247 226.605 108.78C226.192 108.3 225.872 107.727 225.645 107.06C225.432 106.38 225.325 105.627 225.325 104.8C225.325 103.973 225.432 103.227 225.645 102.56C225.872 101.88 226.192 101.307 226.605 100.84C227.018 100.36 227.518 99.9933 228.105 99.74C228.692 99.4867 229.358 99.36 230.105 99.36C230.865 99.36 231.532 99.4933 232.105 99.76C232.692 100.027 233.178 100.4 233.565 100.88C233.952 101.347 234.238 101.893 234.425 102.52C234.625 103.147 234.725 103.82 234.725 104.54V105.36H227.585V105.7C227.585 106.5 227.818 107.16 228.285 107.68C228.765 108.187 229.445 108.44 230.325 108.44C230.965 108.44 231.505 108.3 231.945 108.02C232.385 107.74 232.758 107.36 233.065 106.88L234.345 108.14C233.958 108.78 233.398 109.293 232.665 109.68C231.932 110.053 231.078 110.24 230.105 110.24ZM230.105 101.06C229.732 101.06 229.385 101.127 229.065 101.26C228.758 101.393 228.492 101.58 228.265 101.82C228.052 102.06 227.885 102.347 227.765 102.68C227.645 103.013 227.585 103.38 227.585 103.78V103.92H232.425V103.72C232.425 102.92 232.218 102.28 231.805 101.8C231.392 101.307 230.825 101.06 230.105 101.06ZM237.138 110V99.6H239.318V101.32H239.418C239.645 100.76 239.985 100.293 240.438 99.92C240.905 99.5467 241.538 99.36 242.338 99.36C243.405 99.36 244.231 99.7133 244.818 100.42C245.418 101.113 245.718 102.107 245.718 103.4V110H243.538V103.68C243.538 102.053 242.885 101.24 241.578 101.24C241.298 101.24 241.018 101.28 240.738 101.36C240.471 101.427 240.231 101.533 240.018 101.68C239.805 101.827 239.631 102.013 239.498 102.24C239.378 102.467 239.318 102.733 239.318 103.04V110H237.138ZM255.28 108.28H255.18C254.953 108.893 254.58 109.373 254.06 109.72C253.553 110.067 252.953 110.24 252.26 110.24C250.94 110.24 249.92 109.767 249.2 108.82C248.48 107.86 248.12 106.52 248.12 104.8C248.12 103.08 248.48 101.747 249.2 100.8C249.92 99.84 250.94 99.36 252.26 99.36C252.953 99.36 253.553 99.5333 254.06 99.88C254.58 100.213 254.953 100.693 255.18 101.32H255.28V95.2H257.46V110H255.28V108.28ZM252.92 108.36C253.586 108.36 254.146 108.2 254.6 107.88C255.053 107.547 255.28 107.113 255.28 106.58V103.02C255.28 102.487 255.053 102.06 254.6 101.74C254.146 101.407 253.586 101.24 252.92 101.24C252.16 101.24 251.553 101.487 251.1 101.98C250.646 102.46 250.42 103.1 250.42 103.9V105.7C250.42 106.5 250.646 107.147 251.1 107.64C251.553 108.12 252.16 108.36 252.92 108.36Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M104.422 138.006C104.301 138.127 104.152 138.258 103.974 138.398C103.806 138.529 103.606 138.655 103.372 138.776C103.148 138.888 102.887 138.981 102.588 139.056C102.299 139.131 101.968 139.168 101.594 139.168C101.09 139.168 100.642 139.098 100.25 138.958C99.8582 138.818 99.5268 138.627 99.2562 138.384C98.9948 138.141 98.7942 137.857 98.6542 137.53C98.5235 137.194 98.4582 136.835 98.4582 136.452C98.4582 136.107 98.5095 135.799 98.6122 135.528C98.7242 135.248 98.8688 135.001 99.0462 134.786C99.2328 134.562 99.4428 134.366 99.6762 134.198C99.9188 134.021 100.176 133.857 100.446 133.708C100.138 133.381 99.8768 133.027 99.6622 132.644C99.4475 132.261 99.3402 131.851 99.3402 131.412C99.3402 131.085 99.4008 130.777 99.5222 130.488C99.6528 130.199 99.8348 129.951 100.068 129.746C100.302 129.531 100.582 129.363 100.908 129.242C101.244 129.121 101.613 129.06 102.014 129.06C102.388 129.06 102.733 129.111 103.05 129.214C103.368 129.317 103.643 129.461 103.876 129.648C104.11 129.835 104.287 130.063 104.408 130.334C104.539 130.595 104.604 130.889 104.604 131.216C104.604 131.533 104.548 131.823 104.436 132.084C104.324 132.336 104.17 132.569 103.974 132.784C103.778 132.989 103.55 133.185 103.288 133.372C103.036 133.549 102.766 133.722 102.476 133.89L104.38 135.948C104.511 135.612 104.614 135.257 104.688 134.884C104.763 134.511 104.81 134.133 104.828 133.75H106.914V135.038H105.962C105.822 135.747 105.608 136.377 105.318 136.928L107.236 139H105.332L104.422 138.006ZM102.014 130.278C101.678 130.278 101.394 130.381 101.16 130.586C100.927 130.782 100.81 131.043 100.81 131.37V131.482C100.81 131.725 100.885 131.967 101.034 132.21C101.193 132.453 101.417 132.733 101.706 133.05C102.098 132.835 102.434 132.597 102.714 132.336C102.994 132.065 103.134 131.757 103.134 131.412V131.3C103.134 130.973 103.032 130.721 102.826 130.544C102.621 130.367 102.35 130.278 102.014 130.278ZM101.776 137.866C102.168 137.866 102.514 137.801 102.812 137.67C103.111 137.539 103.372 137.357 103.596 137.124L101.216 134.562C100.862 134.758 100.572 134.977 100.348 135.22C100.134 135.463 100.026 135.794 100.026 136.214V136.396C100.026 136.844 100.18 137.203 100.488 137.474C100.796 137.735 101.226 137.866 101.776 137.866ZM114.437 140.148V138.944C113.728 138.888 113.131 138.715 112.645 138.426C112.16 138.137 111.74 137.782 111.385 137.362L112.407 136.438C112.697 136.793 113.009 137.077 113.345 137.292C113.691 137.507 114.087 137.642 114.535 137.698V134.562C113.527 134.347 112.799 134.025 112.351 133.596C111.903 133.157 111.679 132.583 111.679 131.874C111.679 131.127 111.927 130.535 112.421 130.096C112.916 129.657 113.588 129.391 114.437 129.298V128.08H115.627V129.298C116.225 129.354 116.743 129.503 117.181 129.746C117.629 129.989 118.017 130.32 118.343 130.74L117.307 131.594C117.102 131.323 116.855 131.099 116.565 130.922C116.285 130.735 115.945 130.609 115.543 130.544V133.414C116.094 133.535 116.551 133.68 116.915 133.848C117.279 134.016 117.573 134.207 117.797 134.422C118.031 134.627 118.199 134.87 118.301 135.15C118.404 135.421 118.455 135.738 118.455 136.102C118.455 136.858 118.208 137.488 117.713 137.992C117.228 138.496 116.533 138.804 115.627 138.916V140.148H114.437ZM116.985 136.2C116.985 135.845 116.883 135.556 116.677 135.332C116.472 135.099 116.094 134.912 115.543 134.772V137.684C116.001 137.609 116.355 137.441 116.607 137.18C116.859 136.919 116.985 136.592 116.985 136.2ZM113.135 131.804C113.135 132.196 113.247 132.495 113.471 132.7C113.705 132.896 114.059 133.059 114.535 133.19V130.53C114.087 130.595 113.742 130.735 113.499 130.95C113.257 131.165 113.135 131.449 113.135 131.804ZM122.832 133.246C123.439 133.246 123.887 133.12 124.176 132.868C124.465 132.607 124.61 132.275 124.61 131.874V131.776C124.61 131.328 124.47 130.987 124.19 130.754C123.91 130.511 123.532 130.39 123.056 130.39C122.589 130.39 122.193 130.497 121.866 130.712C121.539 130.917 121.264 131.207 121.04 131.58L119.99 130.67C120.139 130.455 120.307 130.25 120.494 130.054C120.681 129.858 120.9 129.69 121.152 129.55C121.404 129.401 121.689 129.284 122.006 129.2C122.323 129.107 122.687 129.06 123.098 129.06C123.555 129.06 123.98 129.116 124.372 129.228C124.764 129.34 125.1 129.508 125.38 129.732C125.66 129.947 125.879 130.213 126.038 130.53C126.197 130.838 126.276 131.188 126.276 131.58C126.276 131.888 126.225 132.168 126.122 132.42C126.029 132.672 125.893 132.896 125.716 133.092C125.548 133.279 125.347 133.433 125.114 133.554C124.89 133.675 124.652 133.764 124.4 133.82V133.89C124.68 133.946 124.941 134.039 125.184 134.17C125.436 134.291 125.655 134.455 125.842 134.66C126.029 134.856 126.173 135.094 126.276 135.374C126.388 135.645 126.444 135.957 126.444 136.312C126.444 136.741 126.36 137.133 126.192 137.488C126.024 137.833 125.786 138.132 125.478 138.384C125.179 138.636 124.815 138.832 124.386 138.972C123.957 139.103 123.481 139.168 122.958 139.168C122.501 139.168 122.099 139.117 121.754 139.014C121.409 138.921 121.101 138.795 120.83 138.636C120.569 138.468 120.335 138.281 120.13 138.076C119.934 137.861 119.761 137.642 119.612 137.418L120.774 136.508C120.895 136.704 121.021 136.886 121.152 137.054C121.292 137.213 121.446 137.353 121.614 137.474C121.791 137.586 121.987 137.675 122.202 137.74C122.426 137.805 122.678 137.838 122.958 137.838C123.555 137.838 124.013 137.698 124.33 137.418C124.647 137.129 124.806 136.732 124.806 136.228V136.13C124.806 135.626 124.638 135.243 124.302 134.982C123.966 134.721 123.49 134.59 122.874 134.59H121.838V133.246H122.832ZM135.133 139H128.497V137.488L131.619 134.702C132.113 134.254 132.491 133.829 132.753 133.428C133.023 133.017 133.159 132.588 133.159 132.14V131.958C133.159 131.482 133.014 131.109 132.725 130.838C132.445 130.567 132.062 130.432 131.577 130.432C131.306 130.432 131.068 130.474 130.863 130.558C130.667 130.633 130.494 130.74 130.345 130.88C130.195 131.02 130.069 131.183 129.967 131.37C129.873 131.557 129.799 131.757 129.743 131.972L128.357 131.44C128.459 131.132 128.599 130.838 128.777 130.558C128.954 130.269 129.178 130.012 129.449 129.788C129.719 129.564 130.037 129.387 130.401 129.256C130.774 129.125 131.208 129.06 131.703 129.06C132.197 129.06 132.641 129.135 133.033 129.284C133.425 129.424 133.751 129.625 134.013 129.886C134.283 130.138 134.489 130.441 134.629 130.796C134.769 131.151 134.839 131.538 134.839 131.958C134.839 132.35 134.778 132.714 134.657 133.05C134.535 133.386 134.367 133.703 134.153 134.002C133.938 134.301 133.686 134.585 133.397 134.856C133.117 135.127 132.818 135.402 132.501 135.682L130.205 137.656H135.133V139ZM137.157 129.228H141.483C142.295 129.228 142.93 129.457 143.387 129.914C143.854 130.371 144.087 130.983 144.087 131.748C144.087 132.112 144.036 132.425 143.933 132.686C143.83 132.938 143.7 133.148 143.541 133.316C143.382 133.475 143.2 133.596 142.995 133.68C142.79 133.755 142.589 133.801 142.393 133.82V133.904C142.589 133.913 142.804 133.96 143.037 134.044C143.28 134.128 143.504 134.263 143.709 134.45C143.914 134.627 144.087 134.861 144.227 135.15C144.367 135.43 144.437 135.775 144.437 136.186C144.437 136.578 144.372 136.947 144.241 137.292C144.12 137.637 143.947 137.936 143.723 138.188C143.499 138.44 143.233 138.641 142.925 138.79C142.617 138.93 142.281 139 141.917 139H137.157V129.228ZM138.739 137.642H141.455C141.866 137.642 142.188 137.535 142.421 137.32C142.654 137.105 142.771 136.797 142.771 136.396V135.92C142.771 135.519 142.654 135.211 142.421 134.996C142.188 134.781 141.866 134.674 141.455 134.674H138.739V137.642ZM138.739 133.358H141.189C141.581 133.358 141.884 133.26 142.099 133.064C142.314 132.859 142.421 132.569 142.421 132.196V131.748C142.421 131.375 142.314 131.09 142.099 130.894C141.884 130.689 141.581 130.586 141.189 130.586H138.739V133.358ZM150.352 130.418C150.035 130.418 149.802 130.343 149.652 130.194C149.512 130.045 149.442 129.853 149.442 129.62V129.382C149.442 129.149 149.512 128.957 149.652 128.808C149.802 128.659 150.035 128.584 150.352 128.584C150.67 128.584 150.898 128.659 151.038 128.808C151.178 128.957 151.248 129.149 151.248 129.382V129.62C151.248 129.853 151.178 130.045 151.038 130.194C150.898 130.343 150.67 130.418 150.352 130.418ZM149.582 131.72H151.108V139H149.582V131.72ZM153.287 139V131.72H154.813V132.924H154.883C155.042 132.532 155.28 132.205 155.597 131.944C155.924 131.683 156.367 131.552 156.927 131.552C157.674 131.552 158.253 131.799 158.663 132.294C159.083 132.779 159.293 133.475 159.293 134.38V139H157.767V134.576C157.767 133.437 157.31 132.868 156.395 132.868C156.199 132.868 156.003 132.896 155.807 132.952C155.621 132.999 155.453 133.073 155.303 133.176C155.154 133.279 155.033 133.409 154.939 133.568C154.855 133.727 154.813 133.913 154.813 134.128V139H153.287ZM167.755 139.168C166.934 139.168 166.234 139.019 165.655 138.72C165.086 138.421 164.596 138.02 164.185 137.516L165.277 136.494C165.622 136.914 166 137.231 166.411 137.446C166.831 137.661 167.307 137.768 167.839 137.768C168.464 137.768 168.936 137.628 169.253 137.348C169.57 137.068 169.729 136.69 169.729 136.214C169.729 135.831 169.617 135.528 169.393 135.304C169.169 135.08 168.772 134.912 168.203 134.8L167.335 134.646C166.383 134.469 165.669 134.156 165.193 133.708C164.717 133.26 164.479 132.644 164.479 131.86C164.479 131.431 164.558 131.043 164.717 130.698C164.885 130.343 165.114 130.049 165.403 129.816C165.702 129.573 166.061 129.387 166.481 129.256C166.901 129.125 167.372 129.06 167.895 129.06C168.632 129.06 169.272 129.191 169.813 129.452C170.354 129.704 170.816 130.073 171.199 130.558L170.093 131.538C169.841 131.211 169.533 130.95 169.169 130.754C168.805 130.558 168.352 130.46 167.811 130.46C167.251 130.46 166.817 130.572 166.509 130.796C166.201 131.02 166.047 131.347 166.047 131.776C166.047 132.187 166.173 132.495 166.425 132.7C166.677 132.896 167.069 133.045 167.601 133.148L168.469 133.33C169.449 133.517 170.163 133.834 170.611 134.282C171.068 134.73 171.297 135.346 171.297 136.13C171.297 136.587 171.218 137.003 171.059 137.376C170.9 137.749 170.667 138.071 170.359 138.342C170.06 138.603 169.692 138.809 169.253 138.958C168.814 139.098 168.315 139.168 167.755 139.168ZM178.418 139C178.017 139 177.709 138.888 177.494 138.664C177.28 138.431 177.149 138.137 177.102 137.782H177.032C176.892 138.239 176.636 138.585 176.262 138.818C175.889 139.051 175.436 139.168 174.904 139.168C174.148 139.168 173.565 138.972 173.154 138.58C172.753 138.188 172.552 137.661 172.552 136.998C172.552 136.27 172.814 135.724 173.336 135.36C173.868 134.996 174.643 134.814 175.66 134.814H176.976V134.198C176.976 133.75 176.855 133.405 176.612 133.162C176.37 132.919 175.992 132.798 175.478 132.798C175.049 132.798 174.699 132.891 174.428 133.078C174.158 133.265 173.929 133.503 173.742 133.792L172.832 132.966C173.075 132.555 173.416 132.219 173.854 131.958C174.293 131.687 174.867 131.552 175.576 131.552C176.519 131.552 177.242 131.771 177.746 132.21C178.25 132.649 178.502 133.279 178.502 134.1V137.754H179.272V139H178.418ZM175.338 138.006C175.814 138.006 176.206 137.903 176.514 137.698C176.822 137.483 176.976 137.199 176.976 136.844V135.794H175.688C174.634 135.794 174.106 136.121 174.106 136.774V137.026C174.106 137.353 174.214 137.6 174.428 137.768C174.652 137.927 174.956 138.006 175.338 138.006ZM186.102 139C185.7 139 185.392 138.888 185.178 138.664C184.963 138.431 184.832 138.137 184.786 137.782H184.716C184.576 138.239 184.319 138.585 183.946 138.818C183.572 139.051 183.12 139.168 182.588 139.168C181.832 139.168 181.248 138.972 180.838 138.58C180.436 138.188 180.236 137.661 180.236 136.998C180.236 136.27 180.497 135.724 181.02 135.36C181.552 134.996 182.326 134.814 183.344 134.814H184.66V134.198C184.66 133.75 184.538 133.405 184.296 133.162C184.053 132.919 183.675 132.798 183.162 132.798C182.732 132.798 182.382 132.891 182.112 133.078C181.841 133.265 181.612 133.503 181.426 133.792L180.516 132.966C180.758 132.555 181.099 132.219 181.538 131.958C181.976 131.687 182.55 131.552 183.26 131.552C184.202 131.552 184.926 131.771 185.43 132.21C185.934 132.649 186.186 133.279 186.186 134.1V137.754H186.956V139H186.102ZM183.022 138.006C183.498 138.006 183.89 137.903 184.198 137.698C184.506 137.483 184.66 137.199 184.66 136.844V135.794H183.372C182.317 135.794 181.79 136.121 181.79 136.774V137.026C181.79 137.353 181.897 137.6 182.112 137.768C182.336 137.927 182.639 138.006 183.022 138.006ZM191.489 139.168C190.668 139.168 189.968 139.019 189.389 138.72C188.82 138.421 188.33 138.02 187.919 137.516L189.011 136.494C189.357 136.914 189.735 137.231 190.145 137.446C190.565 137.661 191.041 137.768 191.573 137.768C192.199 137.768 192.67 137.628 192.987 137.348C193.305 137.068 193.463 136.69 193.463 136.214C193.463 135.831 193.351 135.528 193.127 135.304C192.903 135.08 192.507 134.912 191.937 134.8L191.069 134.646C190.117 134.469 189.403 134.156 188.927 133.708C188.451 133.26 188.213 132.644 188.213 131.86C188.213 131.431 188.293 131.043 188.451 130.698C188.619 130.343 188.848 130.049 189.137 129.816C189.436 129.573 189.795 129.387 190.215 129.256C190.635 129.125 191.107 129.06 191.629 129.06C192.367 129.06 193.006 129.191 193.547 129.452C194.089 129.704 194.551 130.073 194.933 130.558L193.827 131.538C193.575 131.211 193.267 130.95 192.903 130.754C192.539 130.558 192.087 130.46 191.545 130.46C190.985 130.46 190.551 130.572 190.243 130.796C189.935 131.02 189.781 131.347 189.781 131.776C189.781 132.187 189.907 132.495 190.159 132.7C190.411 132.896 190.803 133.045 191.335 133.148L192.203 133.33C193.183 133.517 193.897 133.834 194.345 134.282C194.803 134.73 195.031 135.346 195.031 136.13C195.031 136.587 194.952 137.003 194.793 137.376C194.635 137.749 194.401 138.071 194.093 138.342C193.795 138.603 193.426 138.809 192.987 138.958C192.549 139.098 192.049 139.168 191.489 139.168ZM202.437 139.168C201.746 139.168 201.168 139.047 200.701 138.804C200.234 138.561 199.828 138.225 199.483 137.796L200.463 136.9C200.734 137.227 201.032 137.483 201.359 137.67C201.695 137.847 202.082 137.936 202.521 137.936C202.969 137.936 203.3 137.852 203.515 137.684C203.739 137.507 203.851 137.264 203.851 136.956C203.851 136.723 203.772 136.527 203.613 136.368C203.464 136.2 203.198 136.093 202.815 136.046L202.143 135.962C201.396 135.869 200.808 135.654 200.379 135.318C199.959 134.973 199.749 134.464 199.749 133.792C199.749 133.437 199.814 133.125 199.945 132.854C200.076 132.574 200.258 132.341 200.491 132.154C200.734 131.958 201.018 131.809 201.345 131.706C201.681 131.603 202.05 131.552 202.451 131.552C203.104 131.552 203.636 131.655 204.047 131.86C204.467 132.065 204.84 132.35 205.167 132.714L204.229 133.61C204.042 133.386 203.795 133.195 203.487 133.036C203.188 132.868 202.843 132.784 202.451 132.784C202.031 132.784 201.718 132.868 201.513 133.036C201.317 133.204 201.219 133.423 201.219 133.694C201.219 133.974 201.308 134.184 201.485 134.324C201.662 134.464 201.947 134.567 202.339 134.632L203.011 134.716C203.814 134.837 204.397 135.075 204.761 135.43C205.134 135.775 205.321 136.242 205.321 136.83C205.321 137.185 205.251 137.507 205.111 137.796C204.98 138.076 204.789 138.319 204.537 138.524C204.285 138.729 203.982 138.888 203.627 139C203.272 139.112 202.876 139.168 202.437 139.168ZM207.045 131.72H208.571V132.924H208.641C208.8 132.485 209.056 132.149 209.411 131.916C209.775 131.673 210.2 131.552 210.685 131.552C211.609 131.552 212.323 131.888 212.827 132.56C213.331 133.223 213.583 134.156 213.583 135.36C213.583 136.564 213.331 137.502 212.827 138.174C212.323 138.837 211.609 139.168 210.685 139.168C210.2 139.168 209.775 139.047 209.411 138.804C209.056 138.561 208.8 138.225 208.641 137.796H208.571V141.8H207.045V131.72ZM210.223 137.852C210.755 137.852 211.18 137.684 211.497 137.348C211.814 137.003 211.973 136.55 211.973 135.99V134.73C211.973 134.17 211.814 133.722 211.497 133.386C211.18 133.041 210.755 132.868 210.223 132.868C209.756 132.868 209.364 132.985 209.047 133.218C208.73 133.442 208.571 133.741 208.571 134.114V136.606C208.571 136.979 208.73 137.283 209.047 137.516C209.364 137.74 209.756 137.852 210.223 137.852ZM218.186 139.168C217.664 139.168 217.197 139.079 216.786 138.902C216.376 138.725 216.026 138.473 215.736 138.146C215.447 137.81 215.223 137.409 215.064 136.942C214.915 136.466 214.84 135.939 214.84 135.36C214.84 134.781 214.915 134.259 215.064 133.792C215.223 133.316 215.447 132.915 215.736 132.588C216.026 132.252 216.376 131.995 216.786 131.818C217.197 131.641 217.664 131.552 218.186 131.552C218.718 131.552 219.185 131.645 219.586 131.832C219.997 132.019 220.338 132.28 220.608 132.616C220.879 132.943 221.08 133.325 221.21 133.764C221.35 134.203 221.42 134.674 221.42 135.178V135.752H216.422V135.99C216.422 136.55 216.586 137.012 216.912 137.376C217.248 137.731 217.724 137.908 218.34 137.908C218.788 137.908 219.166 137.81 219.474 137.614C219.782 137.418 220.044 137.152 220.258 136.816L221.154 137.698C220.884 138.146 220.492 138.505 219.978 138.776C219.465 139.037 218.868 139.168 218.186 139.168ZM218.186 132.742C217.925 132.742 217.682 132.789 217.458 132.882C217.244 132.975 217.057 133.106 216.898 133.274C216.749 133.442 216.632 133.643 216.548 133.876C216.464 134.109 216.422 134.366 216.422 134.646V134.744H219.81V134.604C219.81 134.044 219.666 133.596 219.376 133.26C219.087 132.915 218.69 132.742 218.186 132.742ZM223.11 139V131.72H224.636V132.924H224.706C224.864 132.532 225.102 132.205 225.42 131.944C225.746 131.683 226.19 131.552 226.75 131.552C227.496 131.552 228.075 131.799 228.486 132.294C228.906 132.779 229.116 133.475 229.116 134.38V139H227.59V134.576C227.59 133.437 227.132 132.868 226.218 132.868C226.022 132.868 225.826 132.896 225.63 132.952C225.443 132.999 225.275 133.073 225.126 133.176C224.976 133.279 224.855 133.409 224.762 133.568C224.678 133.727 224.636 133.913 224.636 134.128V139H223.11ZM235.809 137.796H235.739C235.58 138.225 235.319 138.561 234.955 138.804C234.6 139.047 234.18 139.168 233.695 139.168C232.771 139.168 232.057 138.837 231.553 138.174C231.049 137.502 230.797 136.564 230.797 135.36C230.797 134.156 231.049 133.223 231.553 132.56C232.057 131.888 232.771 131.552 233.695 131.552C234.18 131.552 234.6 131.673 234.955 131.916C235.319 132.149 235.58 132.485 235.739 132.924H235.809V128.64H237.335V139H235.809V137.796ZM234.157 137.852C234.623 137.852 235.015 137.74 235.333 137.516C235.65 137.283 235.809 136.979 235.809 136.606V134.114C235.809 133.741 235.65 133.442 235.333 133.218C235.015 132.985 234.623 132.868 234.157 132.868C233.625 132.868 233.2 133.041 232.883 133.386C232.565 133.722 232.407 134.17 232.407 134.73V135.99C232.407 136.55 232.565 137.003 232.883 137.348C233.2 137.684 233.625 137.852 234.157 137.852ZM105.533 154.38L104.595 152.42H104.553V159H102.551V149.228H104.875L107.549 153.848L108.487 155.808H108.529V149.228H110.531V159H108.207L105.533 154.38ZM112.542 153.932V152.28H119.066V153.932H112.542ZM112.542 157.18V155.528H119.066V157.18H112.542ZM124.198 159.168C123.619 159.168 123.101 159.098 122.644 158.958C122.196 158.809 121.818 158.608 121.51 158.356C121.202 158.104 120.964 157.805 120.796 157.46C120.637 157.115 120.558 156.737 120.558 156.326C120.558 155.701 120.731 155.192 121.076 154.8C121.421 154.399 121.888 154.119 122.476 153.96V153.848C122 153.671 121.608 153.4 121.3 153.036C121.001 152.672 120.852 152.205 120.852 151.636C120.852 151.263 120.922 150.917 121.062 150.6C121.211 150.283 121.426 150.012 121.706 149.788C121.995 149.555 122.345 149.377 122.756 149.256C123.176 149.125 123.657 149.06 124.198 149.06C124.739 149.06 125.215 149.125 125.626 149.256C126.046 149.377 126.396 149.555 126.676 149.788C126.965 150.012 127.18 150.283 127.32 150.6C127.469 150.917 127.544 151.263 127.544 151.636C127.544 152.205 127.39 152.672 127.082 153.036C126.783 153.4 126.396 153.671 125.92 153.848V153.96C126.508 154.119 126.975 154.399 127.32 154.8C127.665 155.192 127.838 155.701 127.838 156.326C127.838 156.737 127.754 157.115 127.586 157.46C127.427 157.805 127.194 158.104 126.886 158.356C126.578 158.608 126.195 158.809 125.738 158.958C125.29 159.098 124.777 159.168 124.198 159.168ZM124.198 157.558C124.665 157.558 125.019 157.451 125.262 157.236C125.514 157.012 125.64 156.704 125.64 156.312V156.032C125.64 155.64 125.514 155.337 125.262 155.122C125.019 154.898 124.665 154.786 124.198 154.786C123.731 154.786 123.372 154.898 123.12 155.122C122.877 155.337 122.756 155.64 122.756 156.032V156.312C122.756 156.704 122.877 157.012 123.12 157.236C123.372 157.451 123.731 157.558 124.198 157.558ZM124.198 153.246C124.646 153.246 124.987 153.143 125.22 152.938C125.453 152.723 125.57 152.434 125.57 152.07V151.846C125.57 151.482 125.453 151.197 125.22 150.992C124.987 150.777 124.646 150.67 124.198 150.67C123.75 150.67 123.409 150.777 123.176 150.992C122.943 151.197 122.826 151.482 122.826 151.846V152.07C122.826 152.434 122.943 152.723 123.176 152.938C123.409 153.143 123.75 153.246 124.198 153.246ZM132.649 159.168C132.07 159.168 131.552 159.079 131.095 158.902C130.637 158.715 130.25 158.454 129.933 158.118C129.625 157.773 129.387 157.362 129.219 156.886C129.06 156.41 128.981 155.878 128.981 155.29C128.981 154.609 129.083 153.965 129.289 153.358C129.503 152.742 129.774 152.177 130.101 151.664C130.437 151.141 130.81 150.675 131.221 150.264C131.641 149.853 132.061 149.508 132.481 149.228H135.379C134.781 149.657 134.245 150.068 133.769 150.46C133.293 150.843 132.877 151.23 132.523 151.622C132.177 152.014 131.888 152.415 131.655 152.826C131.431 153.227 131.272 153.661 131.179 154.128L131.305 154.17C131.389 153.983 131.487 153.801 131.599 153.624C131.72 153.447 131.865 153.293 132.033 153.162C132.21 153.022 132.415 152.91 132.649 152.826C132.882 152.742 133.153 152.7 133.461 152.7C133.862 152.7 134.235 152.775 134.581 152.924C134.935 153.064 135.239 153.265 135.491 153.526C135.752 153.787 135.953 154.109 136.093 154.492C136.242 154.865 136.317 155.281 136.317 155.738C136.317 156.242 136.228 156.704 136.051 157.124C135.883 157.544 135.635 157.908 135.309 158.216C134.991 158.515 134.609 158.748 134.161 158.916C133.713 159.084 133.209 159.168 132.649 159.168ZM132.649 157.53C133.115 157.53 133.479 157.404 133.741 157.152C134.002 156.891 134.133 156.522 134.133 156.046V155.794C134.133 155.318 134.002 154.954 133.741 154.702C133.479 154.441 133.115 154.31 132.649 154.31C132.182 154.31 131.818 154.441 131.557 154.702C131.295 154.954 131.165 155.318 131.165 155.794V156.046C131.165 156.522 131.295 156.891 131.557 157.152C131.818 157.404 132.182 157.53 132.649 157.53ZM138.103 159V157.306H140.735V150.754H140.609L138.621 153.358L137.277 152.308L139.615 149.228H142.835V157.306H144.907V159H138.103ZM151.696 159H149.568V149.228H154.202C154.65 149.228 155.056 149.303 155.42 149.452C155.784 149.601 156.092 149.816 156.344 150.096C156.606 150.367 156.806 150.693 156.946 151.076C157.086 151.459 157.156 151.883 157.156 152.35C157.156 153.013 157.007 153.591 156.708 154.086C156.419 154.581 155.976 154.94 155.378 155.164L157.296 159H154.93L153.222 155.416H151.696V159ZM153.936 153.624C154.254 153.624 154.501 153.545 154.678 153.386C154.865 153.218 154.958 152.975 154.958 152.658V152.042C154.958 151.725 154.865 151.487 154.678 151.328C154.501 151.16 154.254 151.076 153.936 151.076H151.696V153.624H153.936ZM161.751 159.168C161.191 159.168 160.691 159.079 160.253 158.902C159.814 158.715 159.441 158.459 159.133 158.132C158.834 157.796 158.605 157.39 158.447 156.914C158.297 156.438 158.223 155.906 158.223 155.318C158.223 154.739 158.297 154.217 158.447 153.75C158.596 153.274 158.815 152.868 159.105 152.532C159.403 152.196 159.767 151.939 160.197 151.762C160.626 151.575 161.116 151.482 161.667 151.482C162.273 151.482 162.791 151.585 163.221 151.79C163.659 151.995 164.014 152.271 164.285 152.616C164.565 152.961 164.765 153.363 164.887 153.82C165.017 154.268 165.083 154.739 165.083 155.234V155.85H160.365V155.962C160.365 156.447 160.495 156.835 160.757 157.124C161.018 157.404 161.429 157.544 161.989 157.544C162.418 157.544 162.768 157.46 163.039 157.292C163.309 157.115 163.561 156.905 163.795 156.662L164.831 157.95C164.504 158.333 164.075 158.631 163.543 158.846C163.02 159.061 162.423 159.168 161.751 159.168ZM161.709 153.008C161.289 153.008 160.957 153.148 160.715 153.428C160.481 153.699 160.365 154.063 160.365 154.52V154.632H162.941V154.506C162.941 154.058 162.838 153.699 162.633 153.428C162.437 153.148 162.129 153.008 161.709 153.008ZM169.038 159.168C168.329 159.168 167.731 159.056 167.246 158.832C166.761 158.599 166.327 158.272 165.944 157.852L167.162 156.62C167.423 156.909 167.713 157.138 168.03 157.306C168.347 157.474 168.707 157.558 169.108 157.558C169.519 157.558 169.803 157.497 169.962 157.376C170.121 157.245 170.2 157.073 170.2 156.858C170.2 156.513 169.953 156.307 169.458 156.242L168.66 156.144C167.008 155.939 166.182 155.183 166.182 153.876C166.182 153.521 166.247 153.199 166.378 152.91C166.518 152.611 166.709 152.359 166.952 152.154C167.204 151.939 167.503 151.776 167.848 151.664C168.203 151.543 168.599 151.482 169.038 151.482C169.421 151.482 169.757 151.51 170.046 151.566C170.345 151.613 170.606 151.687 170.83 151.79C171.063 151.883 171.273 152.005 171.46 152.154C171.656 152.294 171.847 152.453 172.034 152.63L170.844 153.848C170.611 153.615 170.345 153.433 170.046 153.302C169.757 153.162 169.458 153.092 169.15 153.092C168.795 153.092 168.543 153.148 168.394 153.26C168.245 153.372 168.17 153.521 168.17 153.708C168.17 153.904 168.221 154.058 168.324 154.17C168.436 154.273 168.641 154.347 168.94 154.394L169.766 154.506C171.381 154.721 172.188 155.458 172.188 156.718C172.188 157.073 172.113 157.399 171.964 157.698C171.815 157.997 171.6 158.258 171.32 158.482C171.049 158.697 170.718 158.865 170.326 158.986C169.943 159.107 169.514 159.168 169.038 159.168ZM173.601 151.65H175.673V152.882H175.743C175.845 152.471 176.079 152.135 176.443 151.874C176.816 151.613 177.241 151.482 177.717 151.482C178.65 151.482 179.355 151.809 179.831 152.462C180.307 153.115 180.545 154.067 180.545 155.318C180.545 156.569 180.307 157.525 179.831 158.188C179.355 158.841 178.65 159.168 177.717 159.168C177.474 159.168 177.245 159.131 177.031 159.056C176.816 158.991 176.62 158.897 176.443 158.776C176.275 158.645 176.13 158.496 176.009 158.328C175.887 158.151 175.799 157.964 175.743 157.768H175.673V161.8H173.601V151.65ZM177.031 157.488C177.423 157.488 177.745 157.353 177.997 157.082C178.258 156.802 178.389 156.429 178.389 155.962V154.688C178.389 154.221 178.258 153.853 177.997 153.582C177.745 153.302 177.423 153.162 177.031 153.162C176.639 153.162 176.312 153.26 176.051 153.456C175.799 153.643 175.673 153.904 175.673 154.24V156.41C175.673 156.746 175.799 157.012 176.051 157.208C176.312 157.395 176.639 157.488 177.031 157.488ZM185.1 159.168C184.559 159.168 184.074 159.079 183.644 158.902C183.224 158.725 182.865 158.468 182.566 158.132C182.277 157.796 182.053 157.39 181.894 156.914C181.736 156.438 181.656 155.906 181.656 155.318C181.656 154.73 181.736 154.198 181.894 153.722C182.053 153.246 182.277 152.845 182.566 152.518C182.865 152.182 183.224 151.925 183.644 151.748C184.074 151.571 184.559 151.482 185.1 151.482C185.642 151.482 186.122 151.571 186.542 151.748C186.972 151.925 187.331 152.182 187.62 152.518C187.919 152.845 188.148 153.246 188.306 153.722C188.465 154.198 188.544 154.73 188.544 155.318C188.544 155.906 188.465 156.438 188.306 156.914C188.148 157.39 187.919 157.796 187.62 158.132C187.331 158.468 186.972 158.725 186.542 158.902C186.122 159.079 185.642 159.168 185.1 159.168ZM185.1 157.53C185.511 157.53 185.828 157.404 186.052 157.152C186.276 156.9 186.388 156.541 186.388 156.074V154.576C186.388 154.109 186.276 153.75 186.052 153.498C185.828 153.246 185.511 153.12 185.1 153.12C184.69 153.12 184.372 153.246 184.148 153.498C183.924 153.75 183.812 154.109 183.812 154.576V156.074C183.812 156.541 183.924 156.9 184.148 157.152C184.372 157.404 184.69 157.53 185.1 157.53ZM190.021 159V151.65H192.093V152.896H192.177C192.307 152.513 192.536 152.182 192.863 151.902C193.189 151.622 193.642 151.482 194.221 151.482C194.977 151.482 195.546 151.734 195.929 152.238C196.321 152.742 196.517 153.461 196.517 154.394V159H194.445V154.562C194.445 154.086 194.37 153.736 194.221 153.512C194.071 153.279 193.805 153.162 193.423 153.162C193.255 153.162 193.091 153.185 192.933 153.232C192.774 153.269 192.629 153.335 192.499 153.428C192.377 153.521 192.279 153.638 192.205 153.778C192.13 153.909 192.093 154.063 192.093 154.24V159H190.021ZM202.869 157.768H202.799C202.743 157.964 202.654 158.151 202.533 158.328C202.411 158.496 202.262 158.645 202.085 158.776C201.917 158.897 201.721 158.991 201.497 159.056C201.282 159.131 201.058 159.168 200.825 159.168C199.891 159.168 199.187 158.841 198.711 158.188C198.235 157.525 197.997 156.569 197.997 155.318C197.997 154.067 198.235 153.115 198.711 152.462C199.187 151.809 199.891 151.482 200.825 151.482C201.301 151.482 201.721 151.613 202.085 151.874C202.458 152.135 202.696 152.471 202.799 152.882H202.869V148.64H204.941V159H202.869V157.768ZM201.511 157.488C201.903 157.488 202.225 157.395 202.477 157.208C202.738 157.012 202.869 156.746 202.869 156.41V154.24C202.869 153.904 202.738 153.643 202.477 153.456C202.225 153.26 201.903 153.162 201.511 153.162C201.119 153.162 200.792 153.302 200.531 153.582C200.279 153.853 200.153 154.221 200.153 154.688V155.962C200.153 156.429 200.279 156.802 200.531 157.082C200.792 157.353 201.119 157.488 201.511 157.488ZM209.944 159.168C209.384 159.168 208.885 159.079 208.446 158.902C208.007 158.715 207.634 158.459 207.326 158.132C207.027 157.796 206.799 157.39 206.64 156.914C206.491 156.438 206.416 155.906 206.416 155.318C206.416 154.739 206.491 154.217 206.64 153.75C206.789 153.274 207.009 152.868 207.298 152.532C207.597 152.196 207.961 151.939 208.39 151.762C208.819 151.575 209.309 151.482 209.86 151.482C210.467 151.482 210.985 151.585 211.414 151.79C211.853 151.995 212.207 152.271 212.478 152.616C212.758 152.961 212.959 153.363 213.08 153.82C213.211 154.268 213.276 154.739 213.276 155.234V155.85H208.558V155.962C208.558 156.447 208.689 156.835 208.95 157.124C209.211 157.404 209.622 157.544 210.182 157.544C210.611 157.544 210.961 157.46 211.232 157.292C211.503 157.115 211.755 156.905 211.988 156.662L213.024 157.95C212.697 158.333 212.268 158.631 211.736 158.846C211.213 159.061 210.616 159.168 209.944 159.168ZM209.902 153.008C209.482 153.008 209.151 153.148 208.908 153.428C208.675 153.699 208.558 154.063 208.558 154.52V154.632H211.134V154.506C211.134 154.058 211.031 153.699 210.826 153.428C210.63 153.148 210.322 153.008 209.902 153.008ZM214.739 159V151.65H216.811V152.896H216.895C217.026 152.513 217.255 152.182 217.581 151.902C217.908 151.622 218.361 151.482 218.939 151.482C219.695 151.482 220.265 151.734 220.647 152.238C221.039 152.742 221.235 153.461 221.235 154.394V159H219.163V154.562C219.163 154.086 219.089 153.736 218.939 153.512C218.79 153.279 218.524 153.162 218.141 153.162C217.973 153.162 217.81 153.185 217.651 153.232C217.493 153.269 217.348 153.335 217.217 153.428C217.096 153.521 216.998 153.638 216.923 153.778C216.849 153.909 216.811 154.063 216.811 154.24V159H214.739ZM225.655 159C224.937 159 224.391 158.818 224.017 158.454C223.653 158.09 223.471 157.558 223.471 156.858V153.26H222.435V151.65H222.953C223.233 151.65 223.425 151.585 223.527 151.454C223.63 151.314 223.681 151.118 223.681 150.866V149.662H225.543V151.65H226.999V153.26H225.543V157.39H226.887V159H225.655ZM230.931 159.168C230.221 159.168 229.624 159.056 229.139 158.832C228.653 158.599 228.219 158.272 227.837 157.852L229.055 156.62C229.316 156.909 229.605 157.138 229.923 157.306C230.24 157.474 230.599 157.558 231.001 157.558C231.411 157.558 231.696 157.497 231.855 157.376C232.013 157.245 232.093 157.073 232.093 156.858C232.093 156.513 231.845 156.307 231.351 156.242L230.553 156.144C228.901 155.939 228.075 155.183 228.075 153.876C228.075 153.521 228.14 153.199 228.271 152.91C228.411 152.611 228.602 152.359 228.845 152.154C229.097 151.939 229.395 151.776 229.741 151.664C230.095 151.543 230.492 151.482 230.931 151.482C231.313 151.482 231.649 151.51 231.939 151.566C232.237 151.613 232.499 151.687 232.723 151.79C232.956 151.883 233.166 152.005 233.353 152.154C233.549 152.294 233.74 152.453 233.927 152.63L232.737 153.848C232.503 153.615 232.237 153.433 231.939 153.302C231.649 153.162 231.351 153.092 231.043 153.092C230.688 153.092 230.436 153.148 230.287 153.26C230.137 153.372 230.063 153.521 230.063 153.708C230.063 153.904 230.114 154.058 230.217 154.17C230.329 154.273 230.534 154.347 230.833 154.394L231.659 154.506C233.273 154.721 234.081 155.458 234.081 156.718C234.081 157.073 234.006 157.399 233.857 157.698C233.707 157.997 233.493 158.258 233.213 158.482C232.942 158.697 232.611 158.865 232.219 158.986C231.836 159.107 231.407 159.168 230.931 159.168Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        className: 'hidden max-w-full lg:block',
                                                        width: "336",
                                                        height: "208",
                                                        viewBox: "0 0 336 208",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0 12C0 5.37258 5.37258 0 12 0H324C330.627 0 336 5.37258 336 12V196C336 202.627 330.627 208 324 208H12C5.37258 208 0 202.627 0 196V12Z",
                                                                fill: "#712398"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0.5 12C0.5 5.64872 5.64873 0.5 12 0.5H324C330.351 0.5 335.5 5.64873 335.5 12V196C335.5 202.351 330.351 207.5 324 207.5H12C5.64872 207.5 0.5 202.351 0.5 196V12Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144 32C144 27.5817 147.582 24 152 24H184C188.418 24 192 27.5817 192 32V64C192 68.4183 188.418 72 184 72H152C147.582 72 144 68.4183 144 64V32Z",
                                                                fill: "#F2D8FF"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144.5 32C144.5 27.8579 147.858 24.5 152 24.5H184C188.142 24.5 191.5 27.8579 191.5 32V64C191.5 68.1421 188.142 71.5 184 71.5H152C147.858 71.5 144.5 68.1421 144.5 64V32Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M174 51C174.552 51 175 50.5523 175 50C175 49.4477 174.552 49 174 49C173.448 49 173 49.4477 173 50C173 50.5523 173.448 51 174 51Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M175 54C175 54.5523 174.552 55 174 55C173.448 55 173 54.5523 173 54C173 53.4477 173.448 53 174 53C174.552 53 175 53.4477 175 54Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M162 47C162.552 47 163 46.5523 163 46C163 45.4477 162.552 45 162 45C161.448 45 161 45.4477 161 46C161 46.5523 161.448 47 162 47Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M163 50C163 50.5523 162.552 51 162 51C161.448 51 161 50.5523 161 50C161 49.4477 161.448 49 162 49C162.552 49 163 49.4477 163 50Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M162 43C162.552 43 163 42.5523 163 42C163 41.4477 162.552 41 162 41C161.448 41 161 41.4477 161 42C161 42.5523 161.448 43 162 43Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M167 46C167 46.5523 166.552 47 166 47C165.448 47 165 46.5523 165 46C165 45.4477 165.448 45 166 45C166.552 45 167 45.4477 167 46Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M166 51C166.552 51 167 50.5523 167 50C167 49.4477 166.552 49 166 49C165.448 49 165 49.4477 165 50C165 50.5523 165.448 51 166 51Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                clipRule: "evenodd",
                                                                d: "M157 40C157 38.3431 158.343 37 160 37H168C169.657 37 171 38.3431 171 40V45H176C177.657 45 179 46.3431 179 48V58C179 58.5523 178.552 59 178 59H158C157.448 59 157 58.5523 157 58V40ZM171 57V47H176C176.552 47 177 47.4477 177 48V57H171ZM160 39C159.448 39 159 39.4477 159 40V57H169V40C169 39.4477 168.552 39 168 39H160Z",
                                                                fill: "#972FCA"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M107.377 103.48L105.457 105.68V110H103.197V96.04H105.457V103.12H105.537L107.537 100.58L111.297 96.04H113.937L108.957 101.92L114.337 110H111.617L107.377 103.48ZM119.812 110.24C119.065 110.24 118.399 110.113 117.812 109.86C117.225 109.607 116.725 109.247 116.312 108.78C115.899 108.3 115.579 107.727 115.352 107.06C115.139 106.38 115.032 105.627 115.032 104.8C115.032 103.973 115.139 103.227 115.352 102.56C115.579 101.88 115.899 101.307 116.312 100.84C116.725 100.36 117.225 99.9933 117.812 99.74C118.399 99.4867 119.065 99.36 119.812 99.36C120.572 99.36 121.239 99.4933 121.812 99.76C122.399 100.027 122.885 100.4 123.272 100.88C123.659 101.347 123.945 101.893 124.132 102.52C124.332 103.147 124.432 103.82 124.432 104.54V105.36H117.292V105.7C117.292 106.5 117.525 107.16 117.992 107.68C118.472 108.187 119.152 108.44 120.032 108.44C120.672 108.44 121.212 108.3 121.652 108.02C122.092 107.74 122.465 107.36 122.772 106.88L124.052 108.14C123.665 108.78 123.105 109.293 122.372 109.68C121.639 110.053 120.785 110.24 119.812 110.24ZM119.812 101.06C119.439 101.06 119.092 101.127 118.772 101.26C118.465 101.393 118.199 101.58 117.972 101.82C117.759 102.06 117.592 102.347 117.472 102.68C117.352 103.013 117.292 103.38 117.292 103.78V103.92H122.132V103.72C122.132 102.92 121.925 102.28 121.512 101.8C121.099 101.307 120.532 101.06 119.812 101.06ZM133.108 99.6H135.208L130.828 112.06C130.708 112.407 130.568 112.7 130.408 112.94C130.261 113.193 130.081 113.393 129.868 113.54C129.668 113.7 129.421 113.813 129.128 113.88C128.835 113.96 128.488 114 128.088 114H126.828V112.22H128.588L129.188 110.46L125.408 99.6H127.588L129.668 105.72L130.268 107.98H130.368L131.028 105.72L133.108 99.6ZM141.288 110V108.16H143.188V97.88H141.288V96.04H147.368V97.88H145.448V108.16H147.368V110H141.288ZM150.048 110V99.6H152.228V101.32H152.328C152.555 100.76 152.895 100.293 153.348 99.92C153.815 99.5467 154.448 99.36 155.248 99.36C156.315 99.36 157.142 99.7133 157.728 100.42C158.328 101.113 158.628 102.107 158.628 103.4V110H156.448V103.68C156.448 102.053 155.795 101.24 154.488 101.24C154.208 101.24 153.928 101.28 153.648 101.36C153.382 101.427 153.142 101.533 152.928 101.68C152.715 101.827 152.542 102.013 152.408 102.24C152.288 102.467 152.228 102.733 152.228 103.04V110H150.048ZM168.19 108.28H168.09C167.863 108.893 167.49 109.373 166.97 109.72C166.463 110.067 165.863 110.24 165.17 110.24C163.85 110.24 162.83 109.767 162.11 108.82C161.39 107.86 161.03 106.52 161.03 104.8C161.03 103.08 161.39 101.747 162.11 100.8C162.83 99.84 163.85 99.36 165.17 99.36C165.863 99.36 166.463 99.5333 166.97 99.88C167.49 100.213 167.863 100.693 168.09 101.32H168.19V95.2H170.37V110H168.19V108.28ZM165.83 108.36C166.497 108.36 167.057 108.2 167.51 107.88C167.963 107.547 168.19 107.113 168.19 106.58V103.02C168.19 102.487 167.963 102.06 167.51 101.74C167.057 101.407 166.497 101.24 165.83 101.24C165.07 101.24 164.463 101.487 164.01 101.98C163.557 102.46 163.33 103.1 163.33 103.9V105.7C163.33 106.5 163.557 107.147 164.01 107.64C164.463 108.12 165.07 108.36 165.83 108.36ZM179.786 108.28H179.706C179.612 108.533 179.486 108.78 179.326 109.02C179.179 109.26 178.986 109.473 178.746 109.66C178.519 109.833 178.239 109.973 177.906 110.08C177.586 110.187 177.212 110.24 176.786 110.24C175.706 110.24 174.866 109.893 174.266 109.2C173.679 108.507 173.386 107.513 173.386 106.22V99.6H175.566V105.94C175.566 107.553 176.232 108.36 177.566 108.36C177.846 108.36 178.119 108.327 178.386 108.26C178.652 108.18 178.886 108.067 179.086 107.92C179.299 107.773 179.466 107.587 179.586 107.36C179.719 107.133 179.786 106.867 179.786 106.56V99.6H181.966V110H179.786V108.28ZM188.387 110.24C187.401 110.24 186.574 110.067 185.907 109.72C185.241 109.373 184.661 108.893 184.167 108.28L185.567 107C185.954 107.467 186.381 107.833 186.847 108.1C187.327 108.353 187.881 108.48 188.507 108.48C189.147 108.48 189.621 108.36 189.927 108.12C190.247 107.867 190.407 107.52 190.407 107.08C190.407 106.747 190.294 106.467 190.067 106.24C189.854 106 189.474 105.847 188.927 105.78L187.967 105.66C186.901 105.527 186.061 105.22 185.447 104.74C184.847 104.247 184.547 103.52 184.547 102.56C184.547 102.053 184.641 101.607 184.827 101.22C185.014 100.82 185.274 100.487 185.607 100.22C185.954 99.94 186.361 99.7267 186.827 99.58C187.307 99.4333 187.834 99.36 188.407 99.36C189.341 99.36 190.101 99.5067 190.687 99.8C191.287 100.093 191.821 100.5 192.287 101.02L190.947 102.3C190.681 101.98 190.327 101.707 189.887 101.48C189.461 101.24 188.967 101.12 188.407 101.12C187.807 101.12 187.361 101.24 187.067 101.48C186.787 101.72 186.647 102.033 186.647 102.42C186.647 102.82 186.774 103.12 187.027 103.32C187.281 103.52 187.687 103.667 188.247 103.76L189.207 103.88C190.354 104.053 191.187 104.393 191.707 104.9C192.241 105.393 192.507 106.06 192.507 106.9C192.507 107.407 192.407 107.867 192.207 108.28C192.021 108.68 191.747 109.027 191.387 109.32C191.027 109.613 190.594 109.84 190.087 110C189.581 110.16 189.014 110.24 188.387 110.24ZM197.713 110C196.953 110 196.38 109.807 195.993 109.42C195.607 109.02 195.413 108.46 195.413 107.74V101.38H193.793V99.6H194.673C195.033 99.6 195.28 99.52 195.413 99.36C195.56 99.2 195.633 98.94 195.633 98.58V96.76H197.593V99.6H199.773V101.38H197.593V108.22H199.613V110H197.713ZM202.138 110V99.6H204.318V101.6H204.418C204.565 101.067 204.871 100.6 205.338 100.2C205.805 99.8 206.451 99.6 207.278 99.6H207.858V101.7H206.998C206.131 101.7 205.465 101.84 204.998 102.12C204.545 102.4 204.318 102.813 204.318 103.36V110H202.138ZM210.894 97.74C210.441 97.74 210.108 97.6333 209.894 97.42C209.694 97.2067 209.594 96.9333 209.594 96.6V96.26C209.594 95.9267 209.694 95.6533 209.894 95.44C210.108 95.2267 210.441 95.12 210.894 95.12C211.348 95.12 211.674 95.2267 211.874 95.44C212.074 95.6533 212.174 95.9267 212.174 96.26V96.6C212.174 96.9333 212.074 97.2067 211.874 97.42C211.674 97.6333 211.348 97.74 210.894 97.74ZM209.794 99.6H211.974V110H209.794V99.6ZM219.167 110.24C218.421 110.24 217.754 110.113 217.167 109.86C216.581 109.607 216.081 109.247 215.667 108.78C215.254 108.3 214.934 107.727 214.707 107.06C214.494 106.38 214.387 105.627 214.387 104.8C214.387 103.973 214.494 103.227 214.707 102.56C214.934 101.88 215.254 101.307 215.667 100.84C216.081 100.36 216.581 99.9933 217.167 99.74C217.754 99.4867 218.421 99.36 219.167 99.36C219.927 99.36 220.594 99.4933 221.167 99.76C221.754 100.027 222.241 100.4 222.627 100.88C223.014 101.347 223.301 101.893 223.487 102.52C223.687 103.147 223.787 103.82 223.787 104.54V105.36H216.647V105.7C216.647 106.5 216.881 107.16 217.347 107.68C217.827 108.187 218.507 108.44 219.387 108.44C220.027 108.44 220.567 108.3 221.007 108.02C221.447 107.74 221.821 107.36 222.127 106.88L223.407 108.14C223.021 108.78 222.461 109.293 221.727 109.68C220.994 110.053 220.141 110.24 219.167 110.24ZM219.167 101.06C218.794 101.06 218.447 101.127 218.127 101.26C217.821 101.393 217.554 101.58 217.327 101.82C217.114 102.06 216.947 102.347 216.827 102.68C216.707 103.013 216.647 103.38 216.647 103.78V103.92H221.487V103.72C221.487 102.92 221.281 102.28 220.867 101.8C220.454 101.307 219.887 101.06 219.167 101.06ZM229.501 110.24C228.514 110.24 227.687 110.067 227.021 109.72C226.354 109.373 225.774 108.893 225.281 108.28L226.681 107C227.067 107.467 227.494 107.833 227.961 108.1C228.441 108.353 228.994 108.48 229.621 108.48C230.261 108.48 230.734 108.36 231.041 108.12C231.361 107.867 231.521 107.52 231.521 107.08C231.521 106.747 231.407 106.467 231.181 106.24C230.967 106 230.587 105.847 230.041 105.78L229.081 105.66C228.014 105.527 227.174 105.22 226.561 104.74C225.961 104.247 225.661 103.52 225.661 102.56C225.661 102.053 225.754 101.607 225.941 101.22C226.127 100.82 226.387 100.487 226.721 100.22C227.067 99.94 227.474 99.7267 227.941 99.58C228.421 99.4333 228.947 99.36 229.521 99.36C230.454 99.36 231.214 99.5067 231.801 99.8C232.401 100.093 232.934 100.5 233.401 101.02L232.061 102.3C231.794 101.98 231.441 101.707 231.001 101.48C230.574 101.24 230.081 101.12 229.521 101.12C228.921 101.12 228.474 101.24 228.181 101.48C227.901 101.72 227.761 102.033 227.761 102.42C227.761 102.82 227.887 103.12 228.141 103.32C228.394 103.52 228.801 103.667 229.361 103.76L230.321 103.88C231.467 104.053 232.301 104.393 232.821 104.9C233.354 105.393 233.621 106.06 233.621 106.9C233.621 107.407 233.521 107.867 233.321 108.28C233.134 108.68 232.861 109.027 232.501 109.32C232.141 109.613 231.707 109.84 231.201 110C230.694 110.16 230.127 110.24 229.501 110.24Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M97.6181 139V129.228H103.722V130.628H99.2001V133.344H103.218V134.744H99.2001V139H97.6181ZM106.26 130.418C105.943 130.418 105.71 130.343 105.56 130.194C105.42 130.045 105.35 129.853 105.35 129.62V129.382C105.35 129.149 105.42 128.957 105.56 128.808C105.71 128.659 105.943 128.584 106.26 128.584C106.578 128.584 106.806 128.659 106.946 128.808C107.086 128.957 107.156 129.149 107.156 129.382V129.62C107.156 129.853 107.086 130.045 106.946 130.194C106.806 130.343 106.578 130.418 106.26 130.418ZM105.49 131.72H107.016V139H105.49V131.72ZM109.196 139V131.72H110.722V132.924H110.792C110.95 132.532 111.188 132.205 111.506 131.944C111.832 131.683 112.276 131.552 112.836 131.552C113.582 131.552 114.161 131.799 114.572 132.294C114.992 132.779 115.202 133.475 115.202 134.38V139H113.676V134.576C113.676 133.437 113.218 132.868 112.304 132.868C112.108 132.868 111.912 132.896 111.716 132.952C111.529 132.999 111.361 133.073 111.212 133.176C111.062 133.279 110.941 133.409 110.848 133.568C110.764 133.727 110.722 133.913 110.722 134.128V139H109.196ZM122.651 139C122.249 139 121.941 138.888 121.727 138.664C121.512 138.431 121.381 138.137 121.335 137.782H121.265C121.125 138.239 120.868 138.585 120.495 138.818C120.121 139.051 119.669 139.168 119.137 139.168C118.381 139.168 117.797 138.972 117.387 138.58C116.985 138.188 116.785 137.661 116.785 136.998C116.785 136.27 117.046 135.724 117.569 135.36C118.101 134.996 118.875 134.814 119.893 134.814H121.209V134.198C121.209 133.75 121.087 133.405 120.845 133.162C120.602 132.919 120.224 132.798 119.711 132.798C119.281 132.798 118.931 132.891 118.661 133.078C118.39 133.265 118.161 133.503 117.975 133.792L117.065 132.966C117.307 132.555 117.648 132.219 118.087 131.958C118.525 131.687 119.099 131.552 119.809 131.552C120.751 131.552 121.475 131.771 121.979 132.21C122.483 132.649 122.735 133.279 122.735 134.1V137.754H123.505V139H122.651ZM119.571 138.006C120.047 138.006 120.439 137.903 120.747 137.698C121.055 137.483 121.209 137.199 121.209 136.844V135.794H119.921C118.866 135.794 118.339 136.121 118.339 136.774V137.026C118.339 137.353 118.446 137.6 118.661 137.768C118.885 137.927 119.188 138.006 119.571 138.006ZM125 139V131.72H126.526V132.924H126.596C126.755 132.532 126.993 132.205 127.31 131.944C127.637 131.683 128.08 131.552 128.64 131.552C129.387 131.552 129.966 131.799 130.376 132.294C130.796 132.779 131.006 133.475 131.006 134.38V139H129.48V134.576C129.48 133.437 129.023 132.868 128.108 132.868C127.912 132.868 127.716 132.896 127.52 132.952C127.334 132.999 127.166 133.073 127.016 133.176C126.867 133.279 126.746 133.409 126.652 133.568C126.568 133.727 126.526 133.913 126.526 134.128V139H125ZM135.935 139.168C135.413 139.168 134.946 139.079 134.535 138.902C134.125 138.725 133.779 138.473 133.499 138.146C133.219 137.81 133.005 137.409 132.855 136.942C132.706 136.466 132.631 135.939 132.631 135.36C132.631 134.781 132.706 134.259 132.855 133.792C133.005 133.316 133.219 132.915 133.499 132.588C133.779 132.252 134.125 131.995 134.535 131.818C134.946 131.641 135.413 131.552 135.935 131.552C136.663 131.552 137.261 131.715 137.727 132.042C138.194 132.369 138.535 132.803 138.749 133.344L137.489 133.932C137.387 133.596 137.205 133.33 136.943 133.134C136.691 132.929 136.355 132.826 135.935 132.826C135.375 132.826 134.951 133.003 134.661 133.358C134.381 133.703 134.241 134.156 134.241 134.716V136.018C134.241 136.578 134.381 137.035 134.661 137.39C134.951 137.735 135.375 137.908 135.935 137.908C136.383 137.908 136.738 137.801 136.999 137.586C137.27 137.362 137.485 137.068 137.643 136.704L138.805 137.32C138.563 137.917 138.199 138.375 137.713 138.692C137.228 139.009 136.635 139.168 135.935 139.168ZM143.032 139.168C142.509 139.168 142.043 139.079 141.632 138.902C141.221 138.725 140.871 138.473 140.582 138.146C140.293 137.81 140.069 137.409 139.91 136.942C139.761 136.466 139.686 135.939 139.686 135.36C139.686 134.781 139.761 134.259 139.91 133.792C140.069 133.316 140.293 132.915 140.582 132.588C140.871 132.252 141.221 131.995 141.632 131.818C142.043 131.641 142.509 131.552 143.032 131.552C143.564 131.552 144.031 131.645 144.432 131.832C144.843 132.019 145.183 132.28 145.454 132.616C145.725 132.943 145.925 133.325 146.056 133.764C146.196 134.203 146.266 134.674 146.266 135.178V135.752H141.268V135.99C141.268 136.55 141.431 137.012 141.758 137.376C142.094 137.731 142.57 137.908 143.186 137.908C143.634 137.908 144.012 137.81 144.32 137.614C144.628 137.418 144.889 137.152 145.104 136.816L146 137.698C145.729 138.146 145.337 138.505 144.824 138.776C144.311 139.037 143.713 139.168 143.032 139.168ZM143.032 132.742C142.771 132.742 142.528 132.789 142.304 132.882C142.089 132.975 141.903 133.106 141.744 133.274C141.595 133.442 141.478 133.643 141.394 133.876C141.31 134.109 141.268 134.366 141.268 134.646V134.744H144.656V134.604C144.656 134.044 144.511 133.596 144.222 133.26C143.933 132.915 143.536 132.742 143.032 132.742ZM157.018 138.006C156.897 138.127 156.747 138.258 156.57 138.398C156.402 138.529 156.201 138.655 155.968 138.776C155.744 138.888 155.483 138.981 155.184 139.056C154.895 139.131 154.563 139.168 154.19 139.168C153.686 139.168 153.238 139.098 152.846 138.958C152.454 138.818 152.123 138.627 151.852 138.384C151.591 138.141 151.39 137.857 151.25 137.53C151.119 137.194 151.054 136.835 151.054 136.452C151.054 136.107 151.105 135.799 151.208 135.528C151.32 135.248 151.465 135.001 151.642 134.786C151.829 134.562 152.039 134.366 152.272 134.198C152.515 134.021 152.771 133.857 153.042 133.708C152.734 133.381 152.473 133.027 152.258 132.644C152.043 132.261 151.936 131.851 151.936 131.412C151.936 131.085 151.997 130.777 152.118 130.488C152.249 130.199 152.431 129.951 152.664 129.746C152.897 129.531 153.177 129.363 153.504 129.242C153.84 129.121 154.209 129.06 154.61 129.06C154.983 129.06 155.329 129.111 155.646 129.214C155.963 129.317 156.239 129.461 156.472 129.648C156.705 129.835 156.883 130.063 157.004 130.334C157.135 130.595 157.2 130.889 157.2 131.216C157.2 131.533 157.144 131.823 157.032 132.084C156.92 132.336 156.766 132.569 156.57 132.784C156.374 132.989 156.145 133.185 155.884 133.372C155.632 133.549 155.361 133.722 155.072 133.89L156.976 135.948C157.107 135.612 157.209 135.257 157.284 134.884C157.359 134.511 157.405 134.133 157.424 133.75H159.51V135.038H158.558C158.418 135.747 158.203 136.377 157.914 136.928L159.832 139H157.928L157.018 138.006ZM154.61 130.278C154.274 130.278 153.989 130.381 153.756 130.586C153.523 130.782 153.406 131.043 153.406 131.37V131.482C153.406 131.725 153.481 131.967 153.63 132.21C153.789 132.453 154.013 132.733 154.302 133.05C154.694 132.835 155.03 132.597 155.31 132.336C155.59 132.065 155.73 131.757 155.73 131.412V131.3C155.73 130.973 155.627 130.721 155.422 130.544C155.217 130.367 154.946 130.278 154.61 130.278ZM154.372 137.866C154.764 137.866 155.109 137.801 155.408 137.67C155.707 137.539 155.968 137.357 156.192 137.124L153.812 134.562C153.457 134.758 153.168 134.977 152.944 135.22C152.729 135.463 152.622 135.794 152.622 136.214V136.396C152.622 136.844 152.776 137.203 153.084 137.474C153.392 137.735 153.821 137.866 154.372 137.866ZM168.209 130.628V139H166.627V130.628H163.715V129.228H171.121V130.628H168.209ZM174.491 139.168C173.968 139.168 173.502 139.079 173.091 138.902C172.68 138.725 172.33 138.473 172.041 138.146C171.752 137.81 171.528 137.409 171.369 136.942C171.22 136.466 171.145 135.939 171.145 135.36C171.145 134.781 171.22 134.259 171.369 133.792C171.528 133.316 171.752 132.915 172.041 132.588C172.33 132.252 172.68 131.995 173.091 131.818C173.502 131.641 173.968 131.552 174.491 131.552C175.023 131.552 175.49 131.645 175.891 131.832C176.302 132.019 176.642 132.28 176.913 132.616C177.184 132.943 177.384 133.325 177.515 133.764C177.655 134.203 177.725 134.674 177.725 135.178V135.752H172.727V135.99C172.727 136.55 172.89 137.012 173.217 137.376C173.553 137.731 174.029 137.908 174.645 137.908C175.093 137.908 175.471 137.81 175.779 137.614C176.087 137.418 176.348 137.152 176.563 136.816L177.459 137.698C177.188 138.146 176.796 138.505 176.283 138.776C175.77 139.037 175.172 139.168 174.491 139.168ZM174.491 132.742C174.23 132.742 173.987 132.789 173.763 132.882C173.548 132.975 173.362 133.106 173.203 133.274C173.054 133.442 172.937 133.643 172.853 133.876C172.769 134.109 172.727 134.366 172.727 134.646V134.744H176.115V134.604C176.115 134.044 175.97 133.596 175.681 133.26C175.392 132.915 174.995 132.742 174.491 132.742ZM182.228 139.168C181.706 139.168 181.239 139.079 180.828 138.902C180.418 138.725 180.072 138.473 179.792 138.146C179.512 137.81 179.298 137.409 179.148 136.942C178.999 136.466 178.924 135.939 178.924 135.36C178.924 134.781 178.999 134.259 179.148 133.792C179.298 133.316 179.512 132.915 179.792 132.588C180.072 132.252 180.418 131.995 180.828 131.818C181.239 131.641 181.706 131.552 182.228 131.552C182.956 131.552 183.554 131.715 184.02 132.042C184.487 132.369 184.828 132.803 185.042 133.344L183.782 133.932C183.68 133.596 183.498 133.33 183.236 133.134C182.984 132.929 182.648 132.826 182.228 132.826C181.668 132.826 181.244 133.003 180.954 133.358C180.674 133.703 180.534 134.156 180.534 134.716V136.018C180.534 136.578 180.674 137.035 180.954 137.39C181.244 137.735 181.668 137.908 182.228 137.908C182.676 137.908 183.031 137.801 183.292 137.586C183.563 137.362 183.778 137.068 183.936 136.704L185.098 137.32C184.856 137.917 184.492 138.375 184.006 138.692C183.521 139.009 182.928 139.168 182.228 139.168ZM186.551 128.64H188.077V132.924H188.147C188.306 132.532 188.544 132.205 188.861 131.944C189.188 131.683 189.631 131.552 190.191 131.552C190.938 131.552 191.516 131.799 191.927 132.294C192.347 132.779 192.557 133.475 192.557 134.38V139H191.031V134.562C191.031 133.433 190.574 132.868 189.659 132.868C189.463 132.868 189.267 132.896 189.071 132.952C188.884 132.999 188.716 133.073 188.567 133.176C188.418 133.279 188.296 133.409 188.203 133.568C188.119 133.727 188.077 133.909 188.077 134.114V139H186.551V128.64ZM194.672 139V131.72H196.198V132.924H196.268C196.427 132.532 196.665 132.205 196.982 131.944C197.309 131.683 197.752 131.552 198.312 131.552C199.059 131.552 199.637 131.799 200.048 132.294C200.468 132.779 200.678 133.475 200.678 134.38V139H199.152V134.576C199.152 133.437 198.695 132.868 197.78 132.868C197.584 132.868 197.388 132.896 197.192 132.952C197.005 132.999 196.837 133.073 196.688 133.176C196.539 133.279 196.417 133.409 196.324 133.568C196.24 133.727 196.198 133.913 196.198 134.128V139H194.672ZM205.649 139.168C205.145 139.168 204.683 139.079 204.263 138.902C203.853 138.725 203.503 138.473 203.213 138.146C202.924 137.81 202.7 137.409 202.541 136.942C202.383 136.466 202.303 135.939 202.303 135.36C202.303 134.781 202.383 134.259 202.541 133.792C202.7 133.316 202.924 132.915 203.213 132.588C203.503 132.252 203.853 131.995 204.263 131.818C204.683 131.641 205.145 131.552 205.649 131.552C206.153 131.552 206.611 131.641 207.021 131.818C207.441 131.995 207.796 132.252 208.085 132.588C208.375 132.915 208.599 133.316 208.757 133.792C208.916 134.259 208.995 134.781 208.995 135.36C208.995 135.939 208.916 136.466 208.757 136.942C208.599 137.409 208.375 137.81 208.085 138.146C207.796 138.473 207.441 138.725 207.021 138.902C206.611 139.079 206.153 139.168 205.649 139.168ZM205.649 137.908C206.172 137.908 206.592 137.749 206.909 137.432C207.227 137.105 207.385 136.62 207.385 135.976V134.744C207.385 134.1 207.227 133.619 206.909 133.302C206.592 132.975 206.172 132.812 205.649 132.812C205.127 132.812 204.707 132.975 204.389 133.302C204.072 133.619 203.913 134.1 203.913 134.744V135.976C203.913 136.62 204.072 137.105 204.389 137.432C204.707 137.749 205.127 137.908 205.649 137.908ZM212.25 139C211.727 139 211.335 138.869 211.074 138.608C210.822 138.337 210.696 137.964 210.696 137.488V128.64H212.222V137.754H213.23V139H212.25ZM217.544 139.168C217.04 139.168 216.578 139.079 216.158 138.902C215.747 138.725 215.397 138.473 215.108 138.146C214.818 137.81 214.594 137.409 214.436 136.942C214.277 136.466 214.198 135.939 214.198 135.36C214.198 134.781 214.277 134.259 214.436 133.792C214.594 133.316 214.818 132.915 215.108 132.588C215.397 132.252 215.747 131.995 216.158 131.818C216.578 131.641 217.04 131.552 217.544 131.552C218.048 131.552 218.505 131.641 218.916 131.818C219.336 131.995 219.69 132.252 219.98 132.588C220.269 132.915 220.493 133.316 220.652 133.792C220.81 134.259 220.89 134.781 220.89 135.36C220.89 135.939 220.81 136.466 220.652 136.942C220.493 137.409 220.269 137.81 219.98 138.146C219.69 138.473 219.336 138.725 218.916 138.902C218.505 139.079 218.048 139.168 217.544 139.168ZM217.544 137.908C218.066 137.908 218.486 137.749 218.804 137.432C219.121 137.105 219.28 136.62 219.28 135.976V134.744C219.28 134.1 219.121 133.619 218.804 133.302C218.486 132.975 218.066 132.812 217.544 132.812C217.021 132.812 216.601 132.975 216.284 133.302C215.966 133.619 215.808 134.1 215.808 134.744V135.976C215.808 136.62 215.966 137.105 216.284 137.432C216.601 137.749 217.021 137.908 217.544 137.908ZM228.974 139.686C228.974 140.442 228.685 141.011 228.106 141.394C227.527 141.777 226.585 141.968 225.278 141.968C224.681 141.968 224.172 141.926 223.752 141.842C223.341 141.767 223.001 141.655 222.73 141.506C222.469 141.357 222.277 141.175 222.156 140.96C222.035 140.745 221.974 140.498 221.974 140.218C221.974 139.817 222.081 139.504 222.296 139.28C222.52 139.056 222.828 138.902 223.22 138.818V138.664C222.669 138.487 222.394 138.113 222.394 137.544C222.394 137.171 222.52 136.886 222.772 136.69C223.024 136.485 223.327 136.34 223.682 136.256V136.2C223.253 135.995 222.921 135.71 222.688 135.346C222.464 134.973 222.352 134.539 222.352 134.044C222.352 133.297 222.599 132.695 223.094 132.238C223.598 131.781 224.317 131.552 225.25 131.552C225.763 131.552 226.202 131.627 226.566 131.776V131.58C226.566 131.253 226.641 131.001 226.79 130.824C226.949 130.637 227.191 130.544 227.518 130.544H228.638V131.776H227.154V132.07C227.481 132.285 227.733 132.565 227.91 132.91C228.087 133.246 228.176 133.624 228.176 134.044C228.176 134.781 227.924 135.379 227.42 135.836C226.916 136.284 226.197 136.508 225.264 136.508C224.909 136.508 224.592 136.471 224.312 136.396C224.125 136.461 223.962 136.555 223.822 136.676C223.682 136.788 223.612 136.937 223.612 137.124C223.612 137.32 223.701 137.46 223.878 137.544C224.055 137.628 224.307 137.67 224.634 137.67H226.426C227.322 137.67 227.971 137.852 228.372 138.216C228.773 138.571 228.974 139.061 228.974 139.686ZM227.546 139.854C227.546 139.602 227.448 139.401 227.252 139.252C227.065 139.103 226.72 139.028 226.216 139.028H223.752C223.416 139.224 223.248 139.504 223.248 139.868C223.248 140.167 223.365 140.405 223.598 140.582C223.841 140.769 224.247 140.862 224.816 140.862H225.768C226.953 140.862 227.546 140.526 227.546 139.854ZM225.264 135.402C225.712 135.402 226.057 135.304 226.3 135.108C226.552 134.903 226.678 134.59 226.678 134.17V133.89C226.678 133.47 226.552 133.162 226.3 132.966C226.057 132.761 225.712 132.658 225.264 132.658C224.816 132.658 224.466 132.761 224.214 132.966C223.971 133.162 223.85 133.47 223.85 133.89V134.17C223.85 134.59 223.971 134.903 224.214 135.108C224.466 135.304 224.816 135.402 225.264 135.402ZM234.644 131.72H236.114L233.048 140.442C232.964 140.685 232.866 140.89 232.754 141.058C232.651 141.235 232.525 141.375 232.376 141.478C232.236 141.59 232.063 141.669 231.858 141.716C231.653 141.772 231.41 141.8 231.13 141.8H230.248V140.554H231.48L231.9 139.322L229.254 131.72H230.78L232.236 136.004L232.656 137.586H232.726L233.188 136.004L234.644 131.72ZM90.5183 159.168C90.0143 159.168 89.5523 159.079 89.1323 158.902C88.7216 158.725 88.3716 158.473 88.0823 158.146C87.793 157.81 87.569 157.409 87.4103 156.942C87.2516 156.466 87.1723 155.939 87.1723 155.36C87.1723 154.781 87.2516 154.259 87.4103 153.792C87.569 153.316 87.793 152.915 88.0823 152.588C88.3716 152.252 88.7216 151.995 89.1323 151.818C89.5523 151.641 90.0143 151.552 90.5183 151.552C91.0223 151.552 91.4796 151.641 91.8903 151.818C92.3103 151.995 92.665 152.252 92.9543 152.588C93.2436 152.915 93.4676 153.316 93.6263 153.792C93.785 154.259 93.8643 154.781 93.8643 155.36C93.8643 155.939 93.785 156.466 93.6263 156.942C93.4676 157.409 93.2436 157.81 92.9543 158.146C92.665 158.473 92.3103 158.725 91.8903 158.902C91.4796 159.079 91.0223 159.168 90.5183 159.168ZM90.5183 157.908C91.041 157.908 91.461 157.749 91.7783 157.432C92.0956 157.105 92.2543 156.62 92.2543 155.976V154.744C92.2543 154.1 92.0956 153.619 91.7783 153.302C91.461 152.975 91.041 152.812 90.5183 152.812C89.9956 152.812 89.5756 152.975 89.2583 153.302C88.941 153.619 88.7823 154.1 88.7823 154.744V155.976C88.7823 156.62 88.941 157.105 89.2583 157.432C89.5756 157.749 89.9956 157.908 90.5183 157.908ZM97.5396 159C97.0076 159 96.6063 158.865 96.3356 158.594C96.065 158.314 95.9296 157.922 95.9296 157.418V152.966H94.7956V151.72H95.4116C95.6636 151.72 95.8363 151.664 95.9296 151.552C96.0323 151.44 96.0836 151.258 96.0836 151.006V149.732H97.4556V151.72H98.9816V152.966H97.4556V157.754H98.8696V159H97.5396ZM100.637 148.64H102.163V152.924H102.233C102.392 152.532 102.63 152.205 102.947 151.944C103.274 151.683 103.717 151.552 104.277 151.552C105.024 151.552 105.602 151.799 106.013 152.294C106.433 152.779 106.643 153.475 106.643 154.38V159H105.117V154.562C105.117 153.433 104.66 152.868 103.745 152.868C103.549 152.868 103.353 152.896 103.157 152.952C102.97 152.999 102.802 153.073 102.653 153.176C102.504 153.279 102.382 153.409 102.289 153.568C102.205 153.727 102.163 153.909 102.163 154.114V159H100.637V148.64ZM111.614 159.168C111.091 159.168 110.625 159.079 110.214 158.902C109.803 158.725 109.453 158.473 109.164 158.146C108.875 157.81 108.651 157.409 108.492 156.942C108.343 156.466 108.268 155.939 108.268 155.36C108.268 154.781 108.343 154.259 108.492 153.792C108.651 153.316 108.875 152.915 109.164 152.588C109.453 152.252 109.803 151.995 110.214 151.818C110.625 151.641 111.091 151.552 111.614 151.552C112.146 151.552 112.613 151.645 113.014 151.832C113.425 152.019 113.765 152.28 114.036 152.616C114.307 152.943 114.507 153.325 114.638 153.764C114.778 154.203 114.848 154.674 114.848 155.178V155.752H109.85V155.99C109.85 156.55 110.013 157.012 110.34 157.376C110.676 157.731 111.152 157.908 111.768 157.908C112.216 157.908 112.594 157.81 112.902 157.614C113.21 157.418 113.471 157.152 113.686 156.816L114.582 157.698C114.311 158.146 113.919 158.505 113.406 158.776C112.893 159.037 112.295 159.168 111.614 159.168ZM111.614 152.742C111.353 152.742 111.11 152.789 110.886 152.882C110.671 152.975 110.485 153.106 110.326 153.274C110.177 153.442 110.06 153.643 109.976 153.876C109.892 154.109 109.85 154.366 109.85 154.646V154.744H113.238V154.604C113.238 154.044 113.093 153.596 112.804 153.26C112.515 152.915 112.118 152.742 111.614 152.742ZM116.537 159V151.72H118.063V153.12H118.133C118.236 152.747 118.451 152.42 118.777 152.14C119.104 151.86 119.557 151.72 120.135 151.72H120.541V153.19H119.939C119.333 153.19 118.866 153.288 118.539 153.484C118.222 153.68 118.063 153.969 118.063 154.352V159H116.537ZM124.207 159.168C123.516 159.168 122.937 159.047 122.471 158.804C122.004 158.561 121.598 158.225 121.253 157.796L122.233 156.9C122.503 157.227 122.802 157.483 123.129 157.67C123.465 157.847 123.852 157.936 124.291 157.936C124.739 157.936 125.07 157.852 125.285 157.684C125.509 157.507 125.621 157.264 125.621 156.956C125.621 156.723 125.541 156.527 125.383 156.368C125.233 156.2 124.967 156.093 124.585 156.046L123.913 155.962C123.166 155.869 122.578 155.654 122.149 155.318C121.729 154.973 121.519 154.464 121.519 153.792C121.519 153.437 121.584 153.125 121.715 152.854C121.845 152.574 122.027 152.341 122.261 152.154C122.503 151.958 122.788 151.809 123.115 151.706C123.451 151.603 123.819 151.552 124.221 151.552C124.874 151.552 125.406 151.655 125.817 151.86C126.237 152.065 126.61 152.35 126.937 152.714L125.999 153.61C125.812 153.386 125.565 153.195 125.257 153.036C124.958 152.868 124.613 152.784 124.221 152.784C123.801 152.784 123.488 152.868 123.283 153.036C123.087 153.204 122.989 153.423 122.989 153.694C122.989 153.974 123.077 154.184 123.255 154.324C123.432 154.464 123.717 154.567 124.109 154.632L124.781 154.716C125.583 154.837 126.167 155.075 126.531 155.43C126.904 155.775 127.091 156.242 127.091 156.83C127.091 157.185 127.021 157.507 126.881 157.796C126.75 158.076 126.559 158.319 126.307 158.524C126.055 158.729 125.751 158.888 125.397 159C125.042 159.112 124.645 159.168 124.207 159.168ZM132.893 150.418C132.576 150.418 132.343 150.343 132.193 150.194C132.053 150.045 131.983 149.853 131.983 149.62V149.382C131.983 149.149 132.053 148.957 132.193 148.808C132.343 148.659 132.576 148.584 132.893 148.584C133.211 148.584 133.439 148.659 133.579 148.808C133.719 148.957 133.789 149.149 133.789 149.382V149.62C133.789 149.853 133.719 150.045 133.579 150.194C133.439 150.343 133.211 150.418 132.893 150.418ZM132.123 151.72H133.649V159H132.123V151.72ZM135.828 159V151.72H137.354V152.924H137.424C137.583 152.532 137.821 152.205 138.138 151.944C138.465 151.683 138.908 151.552 139.468 151.552C140.215 151.552 140.794 151.799 141.204 152.294C141.624 152.779 141.834 153.475 141.834 154.38V159H140.308V154.576C140.308 153.437 139.851 152.868 138.936 152.868C138.74 152.868 138.544 152.896 138.348 152.952C138.162 152.999 137.994 153.073 137.844 153.176C137.695 153.279 137.574 153.409 137.48 153.568C137.396 153.727 137.354 153.913 137.354 154.128V159H135.828ZM146.763 159.168C146.241 159.168 145.774 159.079 145.363 158.902C144.953 158.725 144.607 158.473 144.327 158.146C144.047 157.81 143.833 157.409 143.683 156.942C143.534 156.466 143.459 155.939 143.459 155.36C143.459 154.781 143.534 154.259 143.683 153.792C143.833 153.316 144.047 152.915 144.327 152.588C144.607 152.252 144.953 151.995 145.363 151.818C145.774 151.641 146.241 151.552 146.763 151.552C147.491 151.552 148.089 151.715 148.555 152.042C149.022 152.369 149.363 152.803 149.577 153.344L148.317 153.932C148.215 153.596 148.033 153.33 147.771 153.134C147.519 152.929 147.183 152.826 146.763 152.826C146.203 152.826 145.779 153.003 145.489 153.358C145.209 153.703 145.069 154.156 145.069 154.716V156.018C145.069 156.578 145.209 157.035 145.489 157.39C145.779 157.735 146.203 157.908 146.763 157.908C147.211 157.908 147.566 157.801 147.827 157.586C148.098 157.362 148.313 157.068 148.471 156.704L149.633 157.32C149.391 157.917 149.027 158.375 148.541 158.692C148.056 159.009 147.463 159.168 146.763 159.168ZM152.64 159C152.117 159 151.725 158.869 151.464 158.608C151.212 158.337 151.086 157.964 151.086 157.488V148.64H152.612V157.754H153.62V159H152.64ZM159.488 157.796H159.432C159.367 157.973 159.278 158.146 159.166 158.314C159.064 158.482 158.928 158.631 158.76 158.762C158.602 158.883 158.406 158.981 158.172 159.056C157.948 159.131 157.687 159.168 157.388 159.168C156.632 159.168 156.044 158.925 155.624 158.44C155.214 157.955 155.008 157.259 155.008 156.354V151.72H156.534V156.158C156.534 157.287 157.001 157.852 157.934 157.852C158.13 157.852 158.322 157.829 158.508 157.782C158.695 157.726 158.858 157.647 158.998 157.544C159.148 157.441 159.264 157.311 159.348 157.152C159.442 156.993 159.488 156.807 159.488 156.592V151.72H161.014V159H159.488V157.796ZM167.777 157.796H167.707C167.549 158.225 167.287 158.561 166.923 158.804C166.569 159.047 166.149 159.168 165.663 159.168C164.739 159.168 164.025 158.837 163.521 158.174C163.017 157.502 162.765 156.564 162.765 155.36C162.765 154.156 163.017 153.223 163.521 152.56C164.025 151.888 164.739 151.552 165.663 151.552C166.149 151.552 166.569 151.673 166.923 151.916C167.287 152.149 167.549 152.485 167.707 152.924H167.777V148.64H169.303V159H167.777V157.796ZM166.125 157.852C166.592 157.852 166.984 157.74 167.301 157.516C167.619 157.283 167.777 156.979 167.777 156.606V154.114C167.777 153.741 167.619 153.442 167.301 153.218C166.984 152.985 166.592 152.868 166.125 152.868C165.593 152.868 165.169 153.041 164.851 153.386C164.534 153.722 164.375 154.17 164.375 154.73V155.99C164.375 156.55 164.534 157.003 164.851 157.348C165.169 157.684 165.593 157.852 166.125 157.852ZM174.341 159.168C173.818 159.168 173.351 159.079 172.941 158.902C172.53 158.725 172.18 158.473 171.891 158.146C171.601 157.81 171.377 157.409 171.219 156.942C171.069 156.466 170.995 155.939 170.995 155.36C170.995 154.781 171.069 154.259 171.219 153.792C171.377 153.316 171.601 152.915 171.891 152.588C172.18 152.252 172.53 151.995 172.941 151.818C173.351 151.641 173.818 151.552 174.341 151.552C174.873 151.552 175.339 151.645 175.741 151.832C176.151 152.019 176.492 152.28 176.763 152.616C177.033 152.943 177.234 153.325 177.365 153.764C177.505 154.203 177.575 154.674 177.575 155.178V155.752H172.577V155.99C172.577 156.55 172.74 157.012 173.067 157.376C173.403 157.731 173.879 157.908 174.495 157.908C174.943 157.908 175.321 157.81 175.629 157.614C175.937 157.418 176.198 157.152 176.413 156.816L177.309 157.698C177.038 158.146 176.646 158.505 176.133 158.776C175.619 159.037 175.022 159.168 174.341 159.168ZM174.341 152.742C174.079 152.742 173.837 152.789 173.613 152.882C173.398 152.975 173.211 153.106 173.053 153.274C172.903 153.442 172.787 153.643 172.703 153.876C172.619 154.109 172.577 154.366 172.577 154.646V154.744H175.965V154.604C175.965 154.044 175.82 153.596 175.531 153.26C175.241 152.915 174.845 152.742 174.341 152.742ZM184.266 159H182.684V149.228H186.898C187.776 149.228 188.466 149.494 188.97 150.026C189.474 150.549 189.726 151.263 189.726 152.168C189.726 152.868 189.563 153.451 189.236 153.918C188.919 154.375 188.448 154.697 187.822 154.884L189.936 159H188.172L186.212 155.052H184.266V159ZM186.786 153.722C187.188 153.722 187.5 153.619 187.724 153.414C187.948 153.199 188.06 152.896 188.06 152.504V151.832C188.06 151.44 187.948 151.141 187.724 150.936C187.5 150.721 187.188 150.614 186.786 150.614H184.266V153.722H186.786ZM194.397 159.168C193.875 159.168 193.408 159.079 192.997 158.902C192.587 158.725 192.237 158.473 191.947 158.146C191.658 157.81 191.434 157.409 191.275 156.942C191.126 156.466 191.051 155.939 191.051 155.36C191.051 154.781 191.126 154.259 191.275 153.792C191.434 153.316 191.658 152.915 191.947 152.588C192.237 152.252 192.587 151.995 192.997 151.818C193.408 151.641 193.875 151.552 194.397 151.552C194.929 151.552 195.396 151.645 195.797 151.832C196.208 152.019 196.549 152.28 196.819 152.616C197.09 152.943 197.291 153.325 197.421 153.764C197.561 154.203 197.631 154.674 197.631 155.178V155.752H192.633V155.99C192.633 156.55 192.797 157.012 193.123 157.376C193.459 157.731 193.935 157.908 194.551 157.908C194.999 157.908 195.377 157.81 195.685 157.614C195.993 157.418 196.255 157.152 196.469 156.816L197.365 157.698C197.095 158.146 196.703 158.505 196.189 158.776C195.676 159.037 195.079 159.168 194.397 159.168ZM194.397 152.742C194.136 152.742 193.893 152.789 193.669 152.882C193.455 152.975 193.268 153.106 193.109 153.274C192.96 153.442 192.843 153.643 192.759 153.876C192.675 154.109 192.633 154.366 192.633 154.646V154.744H196.021V154.604C196.021 154.044 195.877 153.596 195.587 153.26C195.298 152.915 194.901 152.742 194.397 152.742ZM201.337 159C200.805 159 200.403 158.865 200.133 158.594C199.862 158.314 199.727 157.922 199.727 157.418V152.966H198.593V151.72H199.209C199.461 151.72 199.633 151.664 199.727 151.552C199.829 151.44 199.881 151.258 199.881 151.006V149.732H201.253V151.72H202.779V152.966H201.253V157.754H202.667V159H201.337ZM209.768 159C209.366 159 209.058 158.888 208.844 158.664C208.629 158.431 208.498 158.137 208.452 157.782H208.382C208.242 158.239 207.985 158.585 207.612 158.818C207.238 159.051 206.786 159.168 206.254 159.168C205.498 159.168 204.914 158.972 204.504 158.58C204.102 158.188 203.902 157.661 203.902 156.998C203.902 156.27 204.163 155.724 204.686 155.36C205.218 154.996 205.992 154.814 207.01 154.814H208.326V154.198C208.326 153.75 208.204 153.405 207.962 153.162C207.719 152.919 207.341 152.798 206.828 152.798C206.398 152.798 206.048 152.891 205.778 153.078C205.507 153.265 205.278 153.503 205.092 153.792L204.182 152.966C204.424 152.555 204.765 152.219 205.204 151.958C205.642 151.687 206.216 151.552 206.926 151.552C207.868 151.552 208.592 151.771 209.096 152.21C209.6 152.649 209.852 153.279 209.852 154.1V157.754H210.622V159H209.768ZM206.688 158.006C207.164 158.006 207.556 157.903 207.864 157.698C208.172 157.483 208.326 157.199 208.326 156.844V155.794H207.038C205.983 155.794 205.456 156.121 205.456 156.774V157.026C205.456 157.353 205.563 157.6 205.778 157.768C206.002 157.927 206.305 158.006 206.688 158.006ZM212.887 150.418C212.57 150.418 212.337 150.343 212.187 150.194C212.047 150.045 211.977 149.853 211.977 149.62V149.382C211.977 149.149 212.047 148.957 212.187 148.808C212.337 148.659 212.57 148.584 212.887 148.584C213.205 148.584 213.433 148.659 213.573 148.808C213.713 148.957 213.783 149.149 213.783 149.382V149.62C213.783 149.853 213.713 150.045 213.573 150.194C213.433 150.343 213.205 150.418 212.887 150.418ZM212.117 151.72H213.643V159H212.117V151.72ZM217.376 159C216.854 159 216.462 158.869 216.2 158.608C215.948 158.337 215.822 157.964 215.822 157.488V148.64H217.348V157.754H218.356V159H217.376ZM228.457 159C228.056 159 227.748 158.888 227.533 158.664C227.319 158.431 227.188 158.137 227.141 157.782H227.071C226.931 158.239 226.675 158.585 226.301 158.818C225.928 159.051 225.475 159.168 224.943 159.168C224.187 159.168 223.604 158.972 223.193 158.58C222.792 158.188 222.591 157.661 222.591 156.998C222.591 156.27 222.853 155.724 223.375 155.36C223.907 154.996 224.682 154.814 225.699 154.814H227.015V154.198C227.015 153.75 226.894 153.405 226.651 153.162C226.409 152.919 226.031 152.798 225.517 152.798C225.088 152.798 224.738 152.891 224.467 153.078C224.197 153.265 223.968 153.503 223.781 153.792L222.871 152.966C223.114 152.555 223.455 152.219 223.893 151.958C224.332 151.687 224.906 151.552 225.615 151.552C226.558 151.552 227.281 151.771 227.785 152.21C228.289 152.649 228.541 153.279 228.541 154.1V157.754H229.311V159H228.457ZM225.377 158.006C225.853 158.006 226.245 157.903 226.553 157.698C226.861 157.483 227.015 157.199 227.015 156.844V155.794H225.727C224.673 155.794 224.145 156.121 224.145 156.774V157.026C224.145 157.353 224.253 157.6 224.467 157.768C224.691 157.927 224.995 158.006 225.377 158.006ZM230.807 159V151.72H232.333V152.924H232.403C232.562 152.532 232.8 152.205 233.117 151.944C233.444 151.683 233.887 151.552 234.447 151.552C235.194 151.552 235.772 151.799 236.183 152.294C236.603 152.779 236.813 153.475 236.813 154.38V159H235.287V154.576C235.287 153.437 234.83 152.868 233.915 152.868C233.719 152.868 233.523 152.896 233.327 152.952C233.14 152.999 232.972 153.073 232.823 153.176C232.674 153.279 232.552 153.409 232.459 153.568C232.375 153.727 232.333 153.913 232.333 154.128V159H230.807ZM243.506 157.796H243.436C243.277 158.225 243.016 158.561 242.652 158.804C242.297 159.047 241.877 159.168 241.392 159.168C240.468 159.168 239.754 158.837 239.25 158.174C238.746 157.502 238.494 156.564 238.494 155.36C238.494 154.156 238.746 153.223 239.25 152.56C239.754 151.888 240.468 151.552 241.392 151.552C241.877 151.552 242.297 151.673 242.652 151.916C243.016 152.149 243.277 152.485 243.436 152.924H243.506V148.64H245.032V159H243.506V157.796ZM241.854 157.852C242.321 157.852 242.713 157.74 243.03 157.516C243.347 157.283 243.506 156.979 243.506 156.606V154.114C243.506 153.741 243.347 153.442 243.03 153.218C242.713 152.985 242.321 152.868 241.854 152.868C241.322 152.868 240.897 153.041 240.58 153.386C240.263 153.722 240.104 154.17 240.104 154.73V155.99C240.104 156.55 240.263 157.003 240.58 157.348C240.897 157.684 241.322 157.852 241.854 157.852ZM142.362 170.628V179H140.78V170.628H137.868V169.228H145.274V170.628H142.362ZM148.644 179.168C148.122 179.168 147.655 179.079 147.244 178.902C146.834 178.725 146.484 178.473 146.194 178.146C145.905 177.81 145.681 177.409 145.522 176.942C145.373 176.466 145.298 175.939 145.298 175.36C145.298 174.781 145.373 174.259 145.522 173.792C145.681 173.316 145.905 172.915 146.194 172.588C146.484 172.252 146.834 171.995 147.244 171.818C147.655 171.641 148.122 171.552 148.644 171.552C149.176 171.552 149.643 171.645 150.044 171.832C150.455 172.019 150.796 172.28 151.066 172.616C151.337 172.943 151.538 173.325 151.668 173.764C151.808 174.203 151.878 174.674 151.878 175.178V175.752H146.88V175.99C146.88 176.55 147.044 177.012 147.37 177.376C147.706 177.731 148.182 177.908 148.798 177.908C149.246 177.908 149.624 177.81 149.932 177.614C150.24 177.418 150.502 177.152 150.716 176.816L151.612 177.698C151.342 178.146 150.95 178.505 150.436 178.776C149.923 179.037 149.326 179.168 148.644 179.168ZM148.644 172.742C148.383 172.742 148.14 172.789 147.916 172.882C147.702 172.975 147.515 173.106 147.356 173.274C147.207 173.442 147.09 173.643 147.006 173.876C146.922 174.109 146.88 174.366 146.88 174.646V174.744H150.268V174.604C150.268 174.044 150.124 173.596 149.834 173.26C149.545 172.915 149.148 172.742 148.644 172.742ZM155.122 179C154.599 179 154.207 178.869 153.946 178.608C153.694 178.337 153.568 177.964 153.568 177.488V168.64H155.094V177.754H156.102V179H155.122ZM160.416 179.168C159.893 179.168 159.426 179.079 159.016 178.902C158.605 178.725 158.255 178.473 157.966 178.146C157.676 177.81 157.452 177.409 157.294 176.942C157.144 176.466 157.07 175.939 157.07 175.36C157.07 174.781 157.144 174.259 157.294 173.792C157.452 173.316 157.676 172.915 157.966 172.588C158.255 172.252 158.605 171.995 159.016 171.818C159.426 171.641 159.893 171.552 160.416 171.552C160.948 171.552 161.414 171.645 161.816 171.832C162.226 172.019 162.567 172.28 162.838 172.616C163.108 172.943 163.309 173.325 163.44 173.764C163.58 174.203 163.65 174.674 163.65 175.178V175.752H158.652V175.99C158.652 176.55 158.815 177.012 159.142 177.376C159.478 177.731 159.954 177.908 160.57 177.908C161.018 177.908 161.396 177.81 161.704 177.614C162.012 177.418 162.273 177.152 162.488 176.816L163.384 177.698C163.113 178.146 162.721 178.505 162.208 178.776C161.694 179.037 161.097 179.168 160.416 179.168ZM160.416 172.742C160.154 172.742 159.912 172.789 159.688 172.882C159.473 172.975 159.286 173.106 159.128 173.274C158.978 173.442 158.862 173.643 158.778 173.876C158.694 174.109 158.652 174.366 158.652 174.646V174.744H162.04V174.604C162.04 174.044 161.895 173.596 161.606 173.26C161.316 172.915 160.92 172.742 160.416 172.742ZM168.153 179.168C167.63 179.168 167.164 179.079 166.753 178.902C166.342 178.725 165.997 178.473 165.717 178.146C165.437 177.81 165.222 177.409 165.073 176.942C164.924 176.466 164.849 175.939 164.849 175.36C164.849 174.781 164.924 174.259 165.073 173.792C165.222 173.316 165.437 172.915 165.717 172.588C165.997 172.252 166.342 171.995 166.753 171.818C167.164 171.641 167.63 171.552 168.153 171.552C168.881 171.552 169.478 171.715 169.945 172.042C170.412 172.369 170.752 172.803 170.967 173.344L169.707 173.932C169.604 173.596 169.422 173.33 169.161 173.134C168.909 172.929 168.573 172.826 168.153 172.826C167.593 172.826 167.168 173.003 166.879 173.358C166.599 173.703 166.459 174.156 166.459 174.716V176.018C166.459 176.578 166.599 177.035 166.879 177.39C167.168 177.735 167.593 177.908 168.153 177.908C168.601 177.908 168.956 177.801 169.217 177.586C169.488 177.362 169.702 177.068 169.861 176.704L171.023 177.32C170.78 177.917 170.416 178.375 169.931 178.692C169.446 179.009 168.853 179.168 168.153 179.168ZM175.25 179.168C174.746 179.168 174.284 179.079 173.864 178.902C173.453 178.725 173.103 178.473 172.814 178.146C172.524 177.81 172.3 177.409 172.142 176.942C171.983 176.466 171.904 175.939 171.904 175.36C171.904 174.781 171.983 174.259 172.142 173.792C172.3 173.316 172.524 172.915 172.814 172.588C173.103 172.252 173.453 171.995 173.864 171.818C174.284 171.641 174.746 171.552 175.25 171.552C175.754 171.552 176.211 171.641 176.622 171.818C177.042 171.995 177.396 172.252 177.686 172.588C177.975 172.915 178.199 173.316 178.358 173.792C178.516 174.259 178.596 174.781 178.596 175.36C178.596 175.939 178.516 176.466 178.358 176.942C178.199 177.409 177.975 177.81 177.686 178.146C177.396 178.473 177.042 178.725 176.622 178.902C176.211 179.079 175.754 179.168 175.25 179.168ZM175.25 177.908C175.772 177.908 176.192 177.749 176.51 177.432C176.827 177.105 176.986 176.62 176.986 175.976V174.744C176.986 174.1 176.827 173.619 176.51 173.302C176.192 172.975 175.772 172.812 175.25 172.812C174.727 172.812 174.307 172.975 173.99 173.302C173.672 173.619 173.514 174.1 173.514 174.744V175.976C173.514 176.62 173.672 177.105 173.99 177.432C174.307 177.749 174.727 177.908 175.25 177.908ZM180.296 179V171.72H181.822V172.924H181.892C181.967 172.737 182.055 172.56 182.158 172.392C182.27 172.224 182.401 172.079 182.55 171.958C182.709 171.827 182.891 171.729 183.096 171.664C183.311 171.589 183.558 171.552 183.838 171.552C184.333 171.552 184.771 171.673 185.154 171.916C185.537 172.159 185.817 172.532 185.994 173.036H186.036C186.167 172.625 186.419 172.275 186.792 171.986C187.165 171.697 187.646 171.552 188.234 171.552C188.962 171.552 189.527 171.799 189.928 172.294C190.329 172.779 190.53 173.475 190.53 174.38V179H189.004V174.562C189.004 174.002 188.897 173.582 188.682 173.302C188.467 173.013 188.127 172.868 187.66 172.868C187.464 172.868 187.277 172.896 187.1 172.952C186.923 172.999 186.764 173.073 186.624 173.176C186.493 173.279 186.386 173.409 186.302 173.568C186.218 173.727 186.176 173.909 186.176 174.114V179H184.65V174.562C184.65 173.433 184.207 172.868 183.32 172.868C183.133 172.868 182.947 172.896 182.76 172.952C182.583 172.999 182.424 173.073 182.284 173.176C182.144 173.279 182.032 173.409 181.948 173.568C181.864 173.727 181.822 173.909 181.822 174.114V179H180.296ZM194.952 179.168C194.261 179.168 193.682 179.047 193.216 178.804C192.749 178.561 192.343 178.225 191.998 177.796L192.978 176.9C193.248 177.227 193.547 177.483 193.874 177.67C194.21 177.847 194.597 177.936 195.036 177.936C195.484 177.936 195.815 177.852 196.03 177.684C196.254 177.507 196.366 177.264 196.366 176.956C196.366 176.723 196.286 176.527 196.128 176.368C195.978 176.2 195.712 176.093 195.33 176.046L194.658 175.962C193.911 175.869 193.323 175.654 192.894 175.318C192.474 174.973 192.264 174.464 192.264 173.792C192.264 173.437 192.329 173.125 192.46 172.854C192.59 172.574 192.772 172.341 193.006 172.154C193.248 171.958 193.533 171.809 193.86 171.706C194.196 171.603 194.564 171.552 194.966 171.552C195.619 171.552 196.151 171.655 196.562 171.86C196.982 172.065 197.355 172.35 197.682 172.714L196.744 173.61C196.557 173.386 196.31 173.195 196.002 173.036C195.703 172.868 195.358 172.784 194.966 172.784C194.546 172.784 194.233 172.868 194.028 173.036C193.832 173.204 193.734 173.423 193.734 173.694C193.734 173.974 193.822 174.184 194 174.324C194.177 174.464 194.462 174.567 194.854 174.632L195.526 174.716C196.328 174.837 196.912 175.075 197.276 175.43C197.649 175.775 197.836 176.242 197.836 176.83C197.836 177.185 197.766 177.507 197.626 177.796C197.495 178.076 197.304 178.319 197.052 178.524C196.8 178.729 196.496 178.888 196.142 179C195.787 179.112 195.39 179.168 194.952 179.168Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        className: 'hidden max-w-full lg:block',
                                                        width: "336",
                                                        height: "208",
                                                        viewBox: "0 0 336 208",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0 12C0 5.37258 5.37258 0 12 0H324C330.627 0 336 5.37258 336 12V196C336 202.627 330.627 208 324 208H12C5.37258 208 0 202.627 0 196V12Z",
                                                                fill: "#CC9200"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0.5 12C0.5 5.64872 5.64873 0.5 12 0.5H324C330.351 0.5 335.5 5.64873 335.5 12V196C335.5 202.351 330.351 207.5 324 207.5H12C5.64872 207.5 0.5 202.351 0.5 196V12Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144 32C144 27.5817 147.582 24 152 24H184C188.418 24 192 27.5817 192 32V64C192 68.4183 188.418 72 184 72H152C147.582 72 144 68.4183 144 64V32Z",
                                                                fill: "#FFF1CC"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M144.5 32C144.5 27.8579 147.858 24.5 152 24.5H184C188.142 24.5 191.5 27.8579 191.5 32V64C191.5 68.1421 188.142 71.5 184 71.5H152C147.858 71.5 144.5 68.1421 144.5 64V32Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                                                clipPath: "url(#clip0_5592_3899)",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M159.338 43H163.678C164.073 41.5886 164.595 40.3846 165.118 39.4044C165.347 38.9744 165.577 38.587 165.796 38.2436C163.04 38.8635 160.713 40.6217 159.338 43ZM168 38.5658C167.678 39.0021 167.281 39.5986 166.882 40.3456C166.487 41.0865 166.091 41.9742 165.765 43H170.235C169.909 41.9742 169.513 41.0865 169.118 40.3456C168.719 39.5986 168.322 39.0021 168 38.5658ZM170.732 45H165.268C165.1 45.9214 165 46.9227 165 48C165 49.0773 165.1 50.0786 165.268 51H170.732C170.9 50.0786 171 49.0773 171 48C171 46.9227 170.9 45.9214 170.732 45ZM172.761 51C172.912 50.0676 173 49.0665 173 48C173 46.9335 172.912 45.9324 172.761 45H177.542C177.84 45.9461 178 46.9535 178 48C178 49.0465 177.84 50.0539 177.542 51H172.761ZM170.235 53H165.765C166.091 54.0258 166.487 54.9135 166.882 55.6544C167.281 56.4014 167.678 56.9979 168 57.4342C168.322 56.9979 168.719 56.4014 169.118 55.6544C169.513 54.9135 169.909 54.0258 170.235 53ZM165.796 57.7564C165.577 57.413 165.347 57.0256 165.118 56.5956C164.595 55.6154 164.073 54.4114 163.678 53H159.338C160.713 55.3783 163.04 57.1365 165.796 57.7564ZM158.458 51H163.239C163.088 50.0676 163 49.0665 163 48C163 46.9335 163.088 45.9324 163.239 45H158.458C158.16 45.9461 158 46.9535 158 48C158 49.0465 158.16 50.0539 158.458 51ZM170.204 57.7564C170.423 57.413 170.653 57.0256 170.882 56.5956C171.405 55.6154 171.927 54.4114 172.322 53H176.662C175.287 55.3783 172.96 57.1365 170.204 57.7564ZM176.662 43H172.322C171.927 41.5886 171.405 40.3846 170.882 39.4044C170.653 38.9744 170.423 38.587 170.204 38.2436C172.96 38.8635 175.287 40.6217 176.662 43ZM156.818 43.6362C158.563 39.1681 162.91 36 168 36C173.09 36 177.437 39.1681 179.182 43.6362C179.71 44.99 180 46.4624 180 48C180 49.5376 179.71 51.01 179.182 52.3638C177.437 56.8319 173.09 60 168 60C162.91 60 158.563 56.8319 156.818 52.3638C156.29 51.01 156 49.5376 156 48C156 46.4624 156.29 44.99 156.818 43.6362Z",
                                                                    fill: "#CC9200"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M119.49 98.04V110H117.23V98.04H113.07V96.04H123.65V98.04H119.49ZM128.464 110.24C127.744 110.24 127.084 110.113 126.484 109.86C125.898 109.607 125.398 109.247 124.984 108.78C124.571 108.3 124.251 107.727 124.024 107.06C123.798 106.38 123.684 105.627 123.684 104.8C123.684 103.973 123.798 103.227 124.024 102.56C124.251 101.88 124.571 101.307 124.984 100.84C125.398 100.36 125.898 99.9933 126.484 99.74C127.084 99.4867 127.744 99.36 128.464 99.36C129.184 99.36 129.838 99.4867 130.424 99.74C131.024 99.9933 131.531 100.36 131.944 100.84C132.358 101.307 132.678 101.88 132.904 102.56C133.131 103.227 133.244 103.973 133.244 104.8C133.244 105.627 133.131 106.38 132.904 107.06C132.678 107.727 132.358 108.3 131.944 108.78C131.531 109.247 131.024 109.607 130.424 109.86C129.838 110.113 129.184 110.24 128.464 110.24ZM128.464 108.44C129.211 108.44 129.811 108.213 130.264 107.76C130.718 107.293 130.944 106.6 130.944 105.68V103.92C130.944 103 130.718 102.313 130.264 101.86C129.811 101.393 129.211 101.16 128.464 101.16C127.718 101.16 127.118 101.393 126.664 101.86C126.211 102.313 125.984 103 125.984 103.92V105.68C125.984 106.6 126.211 107.293 126.664 107.76C127.118 108.213 127.718 108.44 128.464 108.44ZM135.673 99.6H137.853V101.32H137.953C138.18 100.693 138.547 100.213 139.053 99.88C139.573 99.5333 140.18 99.36 140.873 99.36C142.193 99.36 143.213 99.84 143.933 100.8C144.653 101.747 145.013 103.08 145.013 104.8C145.013 106.52 144.653 107.86 143.933 108.82C143.213 109.767 142.193 110.24 140.873 110.24C140.18 110.24 139.573 110.067 139.053 109.72C138.547 109.373 138.18 108.893 137.953 108.28H137.853V114H135.673V99.6ZM140.213 108.36C140.973 108.36 141.58 108.12 142.033 107.64C142.487 107.147 142.713 106.5 142.713 105.7V103.9C142.713 103.1 142.487 102.46 142.033 101.98C141.58 101.487 140.973 101.24 140.213 101.24C139.547 101.24 138.987 101.407 138.533 101.74C138.08 102.06 137.853 102.487 137.853 103.02V106.58C137.853 107.113 138.08 107.547 138.533 107.88C138.987 108.2 139.547 108.36 140.213 108.36ZM154.656 110H152.396V96.04H158.416C159.669 96.04 160.656 96.42 161.376 97.18C162.096 97.9267 162.456 98.9467 162.456 100.24C162.456 101.24 162.222 102.073 161.756 102.74C161.302 103.393 160.629 103.853 159.736 104.12L162.756 110H160.236L157.436 104.36H154.656V110ZM158.256 102.46C158.829 102.46 159.276 102.313 159.596 102.02C159.916 101.713 160.076 101.28 160.076 100.72V99.76C160.076 99.2 159.916 98.7733 159.596 98.48C159.276 98.1733 158.829 98.02 158.256 98.02H154.656V102.46H158.256ZM169.128 110.24C168.382 110.24 167.715 110.113 167.128 109.86C166.542 109.607 166.042 109.247 165.628 108.78C165.215 108.3 164.895 107.727 164.668 107.06C164.455 106.38 164.348 105.627 164.348 104.8C164.348 103.973 164.455 103.227 164.668 102.56C164.895 101.88 165.215 101.307 165.628 100.84C166.042 100.36 166.542 99.9933 167.128 99.74C167.715 99.4867 168.382 99.36 169.128 99.36C169.888 99.36 170.555 99.4933 171.128 99.76C171.715 100.027 172.202 100.4 172.588 100.88C172.975 101.347 173.262 101.893 173.448 102.52C173.648 103.147 173.748 103.82 173.748 104.54V105.36H166.608V105.7C166.608 106.5 166.842 107.16 167.308 107.68C167.788 108.187 168.468 108.44 169.348 108.44C169.988 108.44 170.528 108.3 170.968 108.02C171.408 107.74 171.782 107.36 172.088 106.88L173.368 108.14C172.982 108.78 172.422 109.293 171.688 109.68C170.955 110.053 170.102 110.24 169.128 110.24ZM169.128 101.06C168.755 101.06 168.408 101.127 168.088 101.26C167.782 101.393 167.515 101.58 167.288 101.82C167.075 102.06 166.908 102.347 166.788 102.68C166.668 103.013 166.608 103.38 166.608 103.78V103.92H171.448V103.72C171.448 102.92 171.242 102.28 170.828 101.8C170.415 101.307 169.848 101.06 169.128 101.06ZM185.282 110.98C185.282 112.06 184.868 112.873 184.042 113.42C183.215 113.967 181.868 114.24 180.002 114.24C179.148 114.24 178.422 114.18 177.822 114.06C177.235 113.953 176.748 113.793 176.362 113.58C175.988 113.367 175.715 113.107 175.542 112.8C175.368 112.493 175.282 112.14 175.282 111.74C175.282 111.167 175.435 110.72 175.742 110.4C176.062 110.08 176.502 109.86 177.062 109.74V109.52C176.275 109.267 175.882 108.733 175.882 107.92C175.882 107.387 176.062 106.98 176.422 106.7C176.782 106.407 177.215 106.2 177.722 106.08V106C177.108 105.707 176.635 105.3 176.302 104.78C175.982 104.247 175.822 103.627 175.822 102.92C175.822 101.853 176.175 100.993 176.882 100.34C177.602 99.6867 178.628 99.36 179.962 99.36C180.695 99.36 181.322 99.4667 181.842 99.68V99.4C181.842 98.9333 181.948 98.5733 182.162 98.32C182.388 98.0533 182.735 97.92 183.202 97.92H184.802V99.68H182.682V100.1C183.148 100.407 183.508 100.807 183.762 101.3C184.015 101.78 184.142 102.32 184.142 102.92C184.142 103.973 183.782 104.827 183.062 105.48C182.342 106.12 181.315 106.44 179.982 106.44C179.475 106.44 179.022 106.387 178.622 106.28C178.355 106.373 178.122 106.507 177.922 106.68C177.722 106.84 177.622 107.053 177.622 107.32C177.622 107.6 177.748 107.8 178.002 107.92C178.255 108.04 178.615 108.1 179.082 108.1H181.642C182.922 108.1 183.848 108.36 184.422 108.88C184.995 109.387 185.282 110.087 185.282 110.98ZM183.242 111.22C183.242 110.86 183.102 110.573 182.822 110.36C182.555 110.147 182.062 110.04 181.342 110.04H177.822C177.342 110.32 177.102 110.72 177.102 111.24C177.102 111.667 177.268 112.007 177.602 112.26C177.948 112.527 178.528 112.66 179.342 112.66H180.702C182.395 112.66 183.242 112.18 183.242 111.22ZM179.982 104.86C180.622 104.86 181.115 104.72 181.462 104.44C181.822 104.147 182.002 103.7 182.002 103.1V102.7C182.002 102.1 181.822 101.66 181.462 101.38C181.115 101.087 180.622 100.94 179.982 100.94C179.342 100.94 178.842 101.087 178.482 101.38C178.135 101.66 177.962 102.1 177.962 102.7V103.1C177.962 103.7 178.135 104.147 178.482 104.44C178.842 104.72 179.342 104.86 179.982 104.86ZM188.004 97.74C187.55 97.74 187.217 97.6333 187.004 97.42C186.804 97.2067 186.704 96.9333 186.704 96.6V96.26C186.704 95.9267 186.804 95.6533 187.004 95.44C187.217 95.2267 187.55 95.12 188.004 95.12C188.457 95.12 188.784 95.2267 188.984 95.44C189.184 95.6533 189.284 95.9267 189.284 96.26V96.6C189.284 96.9333 189.184 97.2067 188.984 97.42C188.784 97.6333 188.457 97.74 188.004 97.74ZM186.904 99.6H189.084V110H186.904V99.6ZM196.277 110.24C195.557 110.24 194.897 110.113 194.297 109.86C193.71 109.607 193.21 109.247 192.797 108.78C192.383 108.3 192.063 107.727 191.837 107.06C191.61 106.38 191.497 105.627 191.497 104.8C191.497 103.973 191.61 103.227 191.837 102.56C192.063 101.88 192.383 101.307 192.797 100.84C193.21 100.36 193.71 99.9933 194.297 99.74C194.897 99.4867 195.557 99.36 196.277 99.36C196.997 99.36 197.65 99.4867 198.237 99.74C198.837 99.9933 199.343 100.36 199.757 100.84C200.17 101.307 200.49 101.88 200.717 102.56C200.943 103.227 201.057 103.973 201.057 104.8C201.057 105.627 200.943 106.38 200.717 107.06C200.49 107.727 200.17 108.3 199.757 108.78C199.343 109.247 198.837 109.607 198.237 109.86C197.65 110.113 196.997 110.24 196.277 110.24ZM196.277 108.44C197.023 108.44 197.623 108.213 198.077 107.76C198.53 107.293 198.757 106.6 198.757 105.68V103.92C198.757 103 198.53 102.313 198.077 101.86C197.623 101.393 197.023 101.16 196.277 101.16C195.53 101.16 194.93 101.393 194.477 101.86C194.023 102.313 193.797 103 193.797 103.92V105.68C193.797 106.6 194.023 107.293 194.477 107.76C194.93 108.213 195.53 108.44 196.277 108.44ZM203.486 110V99.6H205.666V101.32H205.766C205.992 100.76 206.332 100.293 206.786 99.92C207.252 99.5467 207.886 99.36 208.686 99.36C209.752 99.36 210.579 99.7133 211.166 100.42C211.766 101.113 212.066 102.107 212.066 103.4V110H209.886V103.68C209.886 102.053 209.232 101.24 207.926 101.24C207.646 101.24 207.366 101.28 207.086 101.36C206.819 101.427 206.579 101.533 206.366 101.68C206.152 101.827 205.979 102.013 205.846 102.24C205.726 102.467 205.666 102.733 205.666 103.04V110H203.486ZM218.387 110.24C217.401 110.24 216.574 110.067 215.907 109.72C215.241 109.373 214.661 108.893 214.167 108.28L215.567 107C215.954 107.467 216.381 107.833 216.847 108.1C217.327 108.353 217.881 108.48 218.507 108.48C219.147 108.48 219.621 108.36 219.927 108.12C220.247 107.867 220.407 107.52 220.407 107.08C220.407 106.747 220.294 106.467 220.067 106.24C219.854 106 219.474 105.847 218.927 105.78L217.967 105.66C216.901 105.527 216.061 105.22 215.447 104.74C214.847 104.247 214.547 103.52 214.547 102.56C214.547 102.053 214.641 101.607 214.827 101.22C215.014 100.82 215.274 100.487 215.607 100.22C215.954 99.94 216.361 99.7267 216.827 99.58C217.307 99.4333 217.834 99.36 218.407 99.36C219.341 99.36 220.101 99.5067 220.687 99.8C221.287 100.093 221.821 100.5 222.287 101.02L220.947 102.3C220.681 101.98 220.327 101.707 219.887 101.48C219.461 101.24 218.967 101.12 218.407 101.12C217.807 101.12 217.361 101.24 217.067 101.48C216.787 101.72 216.647 102.033 216.647 102.42C216.647 102.82 216.774 103.12 217.027 103.32C217.281 103.52 217.687 103.667 218.247 103.76L219.207 103.88C220.354 104.053 221.187 104.393 221.707 104.9C222.241 105.393 222.507 106.06 222.507 106.9C222.507 107.407 222.407 107.867 222.207 108.28C222.021 108.68 221.747 109.027 221.387 109.32C221.027 109.613 220.594 109.84 220.087 110C219.581 110.16 219.014 110.24 218.387 110.24Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M62.9469 139V137.096H58.4109V135.738L62.3729 129.228H64.4449V135.85H65.7749V137.096H64.4449V139H62.9469ZM59.7549 135.85H62.9469V130.67H62.8489L59.7549 135.85ZM73.8894 139H67.2534V137.488L70.3754 134.702C70.8701 134.254 71.2481 133.829 71.5094 133.428C71.7801 133.017 71.9154 132.588 71.9154 132.14V131.958C71.9154 131.482 71.7708 131.109 71.4814 130.838C71.2014 130.567 70.8188 130.432 70.3334 130.432C70.0628 130.432 69.8248 130.474 69.6194 130.558C69.4234 130.633 69.2508 130.74 69.1014 130.88C68.9521 131.02 68.8261 131.183 68.7234 131.37C68.6301 131.557 68.5554 131.757 68.4994 131.972L67.1134 131.44C67.2161 131.132 67.3561 130.838 67.5334 130.558C67.7108 130.269 67.9348 130.012 68.2054 129.788C68.4761 129.564 68.7934 129.387 69.1574 129.256C69.5308 129.125 69.9648 129.06 70.4594 129.06C70.9541 129.06 71.3974 129.135 71.7894 129.284C72.1814 129.424 72.5081 129.625 72.7694 129.886C73.0401 130.138 73.2454 130.441 73.3854 130.796C73.5254 131.151 73.5954 131.538 73.5954 131.958C73.5954 132.35 73.5348 132.714 73.4134 133.05C73.2921 133.386 73.1241 133.703 72.9094 134.002C72.6948 134.301 72.4428 134.585 72.1534 134.856C71.8734 135.127 71.5748 135.402 71.2574 135.682L68.9614 137.656H73.8894V139ZM77.244 139L84.02 129.228H85.434L78.658 139H77.244ZM77.874 134.604C77.118 134.604 76.5393 134.371 76.138 133.904C75.7366 133.428 75.536 132.737 75.536 131.832C75.536 130.927 75.7366 130.241 76.138 129.774C76.5393 129.298 77.118 129.06 77.874 129.06C78.63 129.06 79.2086 129.298 79.61 129.774C80.0113 130.241 80.212 130.927 80.212 131.832C80.212 132.737 80.0113 133.428 79.61 133.904C79.2086 134.371 78.63 134.604 77.874 134.604ZM77.874 133.666C78.5366 133.666 78.868 133.185 78.868 132.224V131.44C78.868 130.479 78.5366 129.998 77.874 129.998C77.2113 129.998 76.88 130.479 76.88 131.44V132.224C76.88 133.185 77.2113 133.666 77.874 133.666ZM84.804 139.168C84.048 139.168 83.4693 138.935 83.068 138.468C82.6666 137.992 82.466 137.301 82.466 136.396C82.466 135.491 82.6666 134.805 83.068 134.338C83.4693 133.862 84.048 133.624 84.804 133.624C85.56 133.624 86.1386 133.862 86.54 134.338C86.9413 134.805 87.142 135.491 87.142 136.396C87.142 137.301 86.9413 137.992 86.54 138.468C86.1386 138.935 85.56 139.168 84.804 139.168ZM84.804 138.23C85.4666 138.23 85.798 137.749 85.798 136.788V136.004C85.798 135.043 85.4666 134.562 84.804 134.562C84.1413 134.562 83.81 135.043 83.81 136.004V136.788C83.81 137.749 84.1413 138.23 84.804 138.23ZM95.1163 133.596L94.0383 131.524H93.9963V139H92.4843V129.228H94.2483L97.4403 134.632L98.5183 136.704H98.5603V129.228H100.072V139H98.3083L95.1163 133.596ZM105.222 139.168C104.718 139.168 104.256 139.079 103.836 138.902C103.426 138.725 103.076 138.473 102.786 138.146C102.497 137.81 102.273 137.409 102.114 136.942C101.956 136.466 101.876 135.939 101.876 135.36C101.876 134.781 101.956 134.259 102.114 133.792C102.273 133.316 102.497 132.915 102.786 132.588C103.076 132.252 103.426 131.995 103.836 131.818C104.256 131.641 104.718 131.552 105.222 131.552C105.726 131.552 106.184 131.641 106.594 131.818C107.014 131.995 107.369 132.252 107.658 132.588C107.948 132.915 108.172 133.316 108.33 133.792C108.489 134.259 108.568 134.781 108.568 135.36C108.568 135.939 108.489 136.466 108.33 136.942C108.172 137.409 107.948 137.81 107.658 138.146C107.369 138.473 107.014 138.725 106.594 138.902C106.184 139.079 105.726 139.168 105.222 139.168ZM105.222 137.908C105.745 137.908 106.165 137.749 106.482 137.432C106.8 137.105 106.958 136.62 106.958 135.976V134.744C106.958 134.1 106.8 133.619 106.482 133.302C106.165 132.975 105.745 132.812 105.222 132.812C104.7 132.812 104.28 132.975 103.962 133.302C103.645 133.619 103.486 134.1 103.486 134.744V135.976C103.486 136.62 103.645 137.105 103.962 137.432C104.28 137.749 104.7 137.908 105.222 137.908ZM110.269 139V131.72H111.795V133.12H111.865C111.967 132.747 112.182 132.42 112.509 132.14C112.835 131.86 113.288 131.72 113.867 131.72H114.273V133.19H113.671C113.064 133.19 112.597 133.288 112.271 133.484C111.953 133.68 111.795 133.969 111.795 134.352V139H110.269ZM117.699 139C117.167 139 116.765 138.865 116.495 138.594C116.224 138.314 116.089 137.922 116.089 137.418V132.966H114.955V131.72H115.571C115.823 131.72 115.995 131.664 116.089 131.552C116.191 131.44 116.243 131.258 116.243 131.006V129.732H117.615V131.72H119.141V132.966H117.615V137.754H119.029V139H117.699ZM120.796 128.64H122.322V132.924H122.392C122.551 132.532 122.789 132.205 123.106 131.944C123.433 131.683 123.876 131.552 124.436 131.552C125.183 131.552 125.761 131.799 126.172 132.294C126.592 132.779 126.802 133.475 126.802 134.38V139H125.276V134.562C125.276 133.433 124.819 132.868 123.904 132.868C123.708 132.868 123.512 132.896 123.316 132.952C123.129 132.999 122.961 133.073 122.812 133.176C122.663 133.279 122.541 133.409 122.448 133.568C122.364 133.727 122.322 133.909 122.322 134.114V139H120.796V128.64ZM138.442 139L137.56 136.354H133.906L133.052 139H131.442L134.774 129.228H136.762L140.094 139H138.442ZM135.768 130.684H135.698L134.284 134.996H137.168L135.768 130.684ZM141.495 139V131.72H143.021V132.924H143.091C143.166 132.737 143.255 132.56 143.357 132.392C143.469 132.224 143.6 132.079 143.749 131.958C143.908 131.827 144.09 131.729 144.295 131.664C144.51 131.589 144.757 131.552 145.037 131.552C145.532 131.552 145.971 131.673 146.353 131.916C146.736 132.159 147.016 132.532 147.193 133.036H147.235C147.366 132.625 147.618 132.275 147.991 131.986C148.365 131.697 148.845 131.552 149.433 131.552C150.161 131.552 150.726 131.799 151.127 132.294C151.529 132.779 151.729 133.475 151.729 134.38V139H150.203V134.562C150.203 134.002 150.096 133.582 149.881 133.302C149.667 133.013 149.326 132.868 148.859 132.868C148.663 132.868 148.477 132.896 148.299 132.952C148.122 132.999 147.963 133.073 147.823 133.176C147.693 133.279 147.585 133.409 147.501 133.568C147.417 133.727 147.375 133.909 147.375 134.114V139H145.849V134.562C145.849 133.433 145.406 132.868 144.519 132.868C144.333 132.868 144.146 132.896 143.959 132.952C143.782 132.999 143.623 133.073 143.483 133.176C143.343 133.279 143.231 133.409 143.147 133.568C143.063 133.727 143.021 133.909 143.021 134.114V139H141.495ZM156.697 139.168C156.174 139.168 155.708 139.079 155.297 138.902C154.886 138.725 154.536 138.473 154.247 138.146C153.958 137.81 153.734 137.409 153.575 136.942C153.426 136.466 153.351 135.939 153.351 135.36C153.351 134.781 153.426 134.259 153.575 133.792C153.734 133.316 153.958 132.915 154.247 132.588C154.536 132.252 154.886 131.995 155.297 131.818C155.708 131.641 156.174 131.552 156.697 131.552C157.229 131.552 157.696 131.645 158.097 131.832C158.508 132.019 158.848 132.28 159.119 132.616C159.39 132.943 159.59 133.325 159.721 133.764C159.861 134.203 159.931 134.674 159.931 135.178V135.752H154.933V135.99C154.933 136.55 155.096 137.012 155.423 137.376C155.759 137.731 156.235 137.908 156.851 137.908C157.299 137.908 157.677 137.81 157.985 137.614C158.293 137.418 158.554 137.152 158.769 136.816L159.665 137.698C159.394 138.146 159.002 138.505 158.489 138.776C157.976 139.037 157.378 139.168 156.697 139.168ZM156.697 132.742C156.436 132.742 156.193 132.789 155.969 132.882C155.754 132.975 155.568 133.106 155.409 133.274C155.26 133.442 155.143 133.643 155.059 133.876C154.975 134.109 154.933 134.366 154.933 134.646V134.744H158.321V134.604C158.321 134.044 158.176 133.596 157.887 133.26C157.598 132.915 157.201 132.742 156.697 132.742ZM161.62 139V131.72H163.146V133.12H163.216C163.319 132.747 163.534 132.42 163.86 132.14C164.187 131.86 164.64 131.72 165.218 131.72H165.624V133.19H165.022C164.416 133.19 163.949 133.288 163.622 133.484C163.305 133.68 163.146 133.969 163.146 134.352V139H161.62ZM167.75 130.418C167.432 130.418 167.199 130.343 167.05 130.194C166.91 130.045 166.84 129.853 166.84 129.62V129.382C166.84 129.149 166.91 128.957 167.05 128.808C167.199 128.659 167.432 128.584 167.75 128.584C168.067 128.584 168.296 128.659 168.436 128.808C168.576 128.957 168.646 129.149 168.646 129.382V129.62C168.646 129.853 168.576 130.045 168.436 130.194C168.296 130.343 168.067 130.418 167.75 130.418ZM166.98 131.72H168.506V139H166.98V131.72ZM173.499 139.168C172.976 139.168 172.509 139.079 172.099 138.902C171.688 138.725 171.343 138.473 171.063 138.146C170.783 137.81 170.568 137.409 170.419 136.942C170.269 136.466 170.195 135.939 170.195 135.36C170.195 134.781 170.269 134.259 170.419 133.792C170.568 133.316 170.783 132.915 171.063 132.588C171.343 132.252 171.688 131.995 172.099 131.818C172.509 131.641 172.976 131.552 173.499 131.552C174.227 131.552 174.824 131.715 175.291 132.042C175.757 132.369 176.098 132.803 176.313 133.344L175.053 133.932C174.95 133.596 174.768 133.33 174.507 133.134C174.255 132.929 173.919 132.826 173.499 132.826C172.939 132.826 172.514 133.003 172.225 133.358C171.945 133.703 171.805 134.156 171.805 134.716V136.018C171.805 136.578 171.945 137.035 172.225 137.39C172.514 137.735 172.939 137.908 173.499 137.908C173.947 137.908 174.301 137.801 174.563 137.586C174.833 137.362 175.048 137.068 175.207 136.704L176.369 137.32C176.126 137.917 175.762 138.375 175.277 138.692C174.791 139.009 174.199 139.168 173.499 139.168ZM183.155 139C182.754 139 182.446 138.888 182.231 138.664C182.017 138.431 181.886 138.137 181.839 137.782H181.769C181.629 138.239 181.373 138.585 180.999 138.818C180.626 139.051 180.173 139.168 179.641 139.168C178.885 139.168 178.302 138.972 177.891 138.58C177.49 138.188 177.289 137.661 177.289 136.998C177.289 136.27 177.551 135.724 178.073 135.36C178.605 134.996 179.38 134.814 180.397 134.814H181.713V134.198C181.713 133.75 181.592 133.405 181.349 133.162C181.107 132.919 180.729 132.798 180.215 132.798C179.786 132.798 179.436 132.891 179.165 133.078C178.895 133.265 178.666 133.503 178.479 133.792L177.569 132.966C177.812 132.555 178.153 132.219 178.591 131.958C179.03 131.687 179.604 131.552 180.313 131.552C181.256 131.552 181.979 131.771 182.483 132.21C182.987 132.649 183.239 133.279 183.239 134.1V137.754H184.009V139H183.155ZM180.075 138.006C180.551 138.006 180.943 137.903 181.251 137.698C181.559 137.483 181.713 137.199 181.713 136.844V135.794H180.425C179.371 135.794 178.843 136.121 178.843 136.774V137.026C178.843 137.353 178.951 137.6 179.165 137.768C179.389 137.927 179.693 138.006 180.075 138.006ZM186.58 137.054C186.925 137.054 187.182 137.143 187.35 137.32C187.518 137.497 187.602 137.726 187.602 138.006V138.23C187.602 138.687 187.476 139.163 187.224 139.658C186.981 140.162 186.65 140.587 186.23 140.932H185.096C185.394 140.633 185.642 140.344 185.838 140.064C186.034 139.784 186.183 139.471 186.286 139.126C186.043 139.079 185.861 138.977 185.74 138.818C185.618 138.65 185.558 138.454 185.558 138.23V138.006C185.558 137.726 185.642 137.497 185.81 137.32C185.978 137.143 186.234 137.054 186.58 137.054ZM199.493 139H192.857V137.488L195.979 134.702C196.474 134.254 196.852 133.829 197.113 133.428C197.384 133.017 197.519 132.588 197.519 132.14V131.958C197.519 131.482 197.374 131.109 197.085 130.838C196.805 130.567 196.422 130.432 195.937 130.432C195.666 130.432 195.428 130.474 195.223 130.558C195.027 130.633 194.854 130.74 194.705 130.88C194.556 131.02 194.43 131.183 194.327 131.37C194.234 131.557 194.159 131.757 194.103 131.972L192.717 131.44C192.82 131.132 192.96 130.838 193.137 130.558C193.314 130.269 193.538 130.012 193.809 129.788C194.08 129.564 194.397 129.387 194.761 129.256C195.134 129.125 195.568 129.06 196.063 129.06C196.558 129.06 197.001 129.135 197.393 129.284C197.785 129.424 198.112 129.625 198.373 129.886C198.644 130.138 198.849 130.441 198.989 130.796C199.129 131.151 199.199 131.538 199.199 131.958C199.199 132.35 199.138 132.714 199.017 133.05C198.896 133.386 198.728 133.703 198.513 134.002C198.298 134.301 198.046 134.585 197.757 134.856C197.477 135.127 197.178 135.402 196.861 135.682L194.565 137.656H199.493V139ZM204.541 139.168C204 139.168 203.515 139.079 203.085 138.902C202.665 138.725 202.306 138.473 202.007 138.146C201.718 137.81 201.494 137.409 201.335 136.942C201.177 136.475 201.097 135.948 201.097 135.36C201.097 134.651 201.205 133.983 201.419 133.358C201.634 132.733 201.909 132.159 202.245 131.636C202.581 131.113 202.955 130.651 203.365 130.25C203.785 129.839 204.196 129.499 204.597 129.228H206.697C206.147 129.629 205.652 130.017 205.213 130.39C204.775 130.763 204.392 131.146 204.065 131.538C203.739 131.93 203.463 132.345 203.239 132.784C203.025 133.223 202.857 133.703 202.735 134.226L202.833 134.254C202.936 134.058 203.053 133.876 203.183 133.708C203.323 133.531 203.482 133.377 203.659 133.246C203.846 133.115 204.056 133.013 204.289 132.938C204.523 132.863 204.793 132.826 205.101 132.826C205.512 132.826 205.89 132.896 206.235 133.036C206.59 133.176 206.893 133.381 207.145 133.652C207.407 133.913 207.607 134.231 207.747 134.604C207.897 134.977 207.971 135.393 207.971 135.85C207.971 136.345 207.887 136.797 207.719 137.208C207.561 137.609 207.332 137.955 207.033 138.244C206.735 138.533 206.371 138.762 205.941 138.93C205.521 139.089 205.055 139.168 204.541 139.168ZM204.541 137.88C205.111 137.88 205.554 137.731 205.871 137.432C206.189 137.124 206.347 136.676 206.347 136.088V135.892C206.347 135.304 206.189 134.861 205.871 134.562C205.554 134.254 205.111 134.1 204.541 134.1C203.972 134.1 203.529 134.254 203.211 134.562C202.894 134.861 202.735 135.304 202.735 135.892V136.088C202.735 136.676 202.894 137.124 203.211 137.432C203.529 137.731 203.972 137.88 204.541 137.88ZM211.242 139L218.018 129.228H219.432L212.656 139H211.242ZM211.872 134.604C211.116 134.604 210.537 134.371 210.136 133.904C209.735 133.428 209.534 132.737 209.534 131.832C209.534 130.927 209.735 130.241 210.136 129.774C210.537 129.298 211.116 129.06 211.872 129.06C212.628 129.06 213.207 129.298 213.608 129.774C214.009 130.241 214.21 130.927 214.21 131.832C214.21 132.737 214.009 133.428 213.608 133.904C213.207 134.371 212.628 134.604 211.872 134.604ZM211.872 133.666C212.535 133.666 212.866 133.185 212.866 132.224V131.44C212.866 130.479 212.535 129.998 211.872 129.998C211.209 129.998 210.878 130.479 210.878 131.44V132.224C210.878 133.185 211.209 133.666 211.872 133.666ZM218.802 139.168C218.046 139.168 217.467 138.935 217.066 138.468C216.665 137.992 216.464 137.301 216.464 136.396C216.464 135.491 216.665 134.805 217.066 134.338C217.467 133.862 218.046 133.624 218.802 133.624C219.558 133.624 220.137 133.862 220.538 134.338C220.939 134.805 221.14 135.491 221.14 136.396C221.14 137.301 220.939 137.992 220.538 138.468C220.137 138.935 219.558 139.168 218.802 139.168ZM218.802 138.23C219.465 138.23 219.796 137.749 219.796 136.788V136.004C219.796 135.043 219.465 134.562 218.802 134.562C218.139 134.562 217.808 135.043 217.808 136.004V136.788C217.808 137.749 218.139 138.23 218.802 138.23ZM226.482 139V129.228H232.74V130.628H228.064V133.344H232.306V134.744H228.064V137.6H232.74V139H226.482ZM239.079 137.796H239.023C238.958 137.973 238.869 138.146 238.757 138.314C238.654 138.482 238.519 138.631 238.351 138.762C238.192 138.883 237.996 138.981 237.763 139.056C237.539 139.131 237.278 139.168 236.979 139.168C236.223 139.168 235.635 138.925 235.215 138.44C234.804 137.955 234.599 137.259 234.599 136.354V131.72H236.125V136.158C236.125 137.287 236.592 137.852 237.525 137.852C237.721 137.852 237.912 137.829 238.099 137.782C238.286 137.726 238.449 137.647 238.589 137.544C238.738 137.441 238.855 137.311 238.939 137.152C239.032 136.993 239.079 136.807 239.079 136.592V131.72H240.605V139H239.079V137.796ZM242.79 139V131.72H244.316V133.12H244.386C244.489 132.747 244.704 132.42 245.03 132.14C245.357 131.86 245.81 131.72 246.388 131.72H246.794V133.19H246.192C245.586 133.19 245.119 133.288 244.792 133.484C244.475 133.68 244.316 133.969 244.316 134.352V139H242.79ZM250.937 139.168C250.433 139.168 249.971 139.079 249.551 138.902C249.141 138.725 248.791 138.473 248.501 138.146C248.212 137.81 247.988 137.409 247.829 136.942C247.671 136.466 247.591 135.939 247.591 135.36C247.591 134.781 247.671 134.259 247.829 133.792C247.988 133.316 248.212 132.915 248.501 132.588C248.791 132.252 249.141 131.995 249.551 131.818C249.971 131.641 250.433 131.552 250.937 131.552C251.441 131.552 251.899 131.641 252.309 131.818C252.729 131.995 253.084 132.252 253.373 132.588C253.663 132.915 253.887 133.316 254.045 133.792C254.204 134.259 254.283 134.781 254.283 135.36C254.283 135.939 254.204 136.466 254.045 136.942C253.887 137.409 253.663 137.81 253.373 138.146C253.084 138.473 252.729 138.725 252.309 138.902C251.899 139.079 251.441 139.168 250.937 139.168ZM250.937 137.908C251.46 137.908 251.88 137.749 252.197 137.432C252.515 137.105 252.673 136.62 252.673 135.976V134.744C252.673 134.1 252.515 133.619 252.197 133.302C251.88 132.975 251.46 132.812 250.937 132.812C250.415 132.812 249.995 132.975 249.677 133.302C249.36 133.619 249.201 134.1 249.201 134.744V135.976C249.201 136.62 249.36 137.105 249.677 137.432C249.995 137.749 250.415 137.908 250.937 137.908ZM255.984 131.72H257.51V132.924H257.58C257.738 132.485 257.995 132.149 258.35 131.916C258.714 131.673 259.138 131.552 259.624 131.552C260.548 131.552 261.262 131.888 261.766 132.56C262.27 133.223 262.522 134.156 262.522 135.36C262.522 136.564 262.27 137.502 261.766 138.174C261.262 138.837 260.548 139.168 259.624 139.168C259.138 139.168 258.714 139.047 258.35 138.804C257.995 138.561 257.738 138.225 257.58 137.796H257.51V141.8H255.984V131.72ZM259.162 137.852C259.694 137.852 260.118 137.684 260.436 137.348C260.753 137.003 260.912 136.55 260.912 135.99V134.73C260.912 134.17 260.753 133.722 260.436 133.386C260.118 133.041 259.694 132.868 259.162 132.868C258.695 132.868 258.303 132.985 257.986 133.218C257.668 133.442 257.51 133.741 257.51 134.114V136.606C257.51 136.979 257.668 137.283 257.986 137.516C258.303 137.74 258.695 137.852 259.162 137.852ZM267.125 139.168C266.602 139.168 266.135 139.079 265.725 138.902C265.314 138.725 264.964 138.473 264.675 138.146C264.385 137.81 264.161 137.409 264.003 136.942C263.853 136.466 263.779 135.939 263.779 135.36C263.779 134.781 263.853 134.259 264.003 133.792C264.161 133.316 264.385 132.915 264.675 132.588C264.964 132.252 265.314 131.995 265.725 131.818C266.135 131.641 266.602 131.552 267.125 131.552C267.657 131.552 268.123 131.645 268.525 131.832C268.935 132.019 269.276 132.28 269.547 132.616C269.817 132.943 270.018 133.325 270.149 133.764C270.289 134.203 270.359 134.674 270.359 135.178V135.752H265.361V135.99C265.361 136.55 265.524 137.012 265.851 137.376C266.187 137.731 266.663 137.908 267.279 137.908C267.727 137.908 268.105 137.81 268.413 137.614C268.721 137.418 268.982 137.152 269.197 136.816L270.093 137.698C269.822 138.146 269.43 138.505 268.917 138.776C268.403 139.037 267.806 139.168 267.125 139.168ZM267.125 132.742C266.863 132.742 266.621 132.789 266.397 132.882C266.182 132.975 265.995 133.106 265.837 133.274C265.687 133.442 265.571 133.643 265.487 133.876C265.403 134.109 265.361 134.366 265.361 134.646V134.744H268.749V134.604C268.749 134.044 268.604 133.596 268.315 133.26C268.025 132.915 267.629 132.742 267.125 132.742ZM272.74 137.054C273.085 137.054 273.342 137.143 273.51 137.32C273.678 137.497 273.762 137.726 273.762 138.006V138.23C273.762 138.687 273.636 139.163 273.384 139.658C273.141 140.162 272.81 140.587 272.39 140.932H271.256C271.555 140.633 271.802 140.344 271.998 140.064C272.194 139.784 272.343 139.471 272.446 139.126C272.203 139.079 272.021 138.977 271.9 138.818C271.779 138.65 271.718 138.454 271.718 138.23V138.006C271.718 137.726 271.802 137.497 271.97 137.32C272.138 137.143 272.395 137.054 272.74 137.054ZM35.0562 159V157.684H37.8002V150.376H37.6882L35.4202 152.798L34.4542 151.93L36.9462 149.228H39.3542V157.684H41.7342V159H35.0562ZM49.3308 150.6H44.9908L44.7388 154.058H44.8368C44.9488 153.862 45.0654 153.689 45.1868 153.54C45.3081 153.381 45.4481 153.246 45.6068 153.134C45.7654 153.022 45.9474 152.938 46.1528 152.882C46.3581 152.817 46.6008 152.784 46.8808 152.784C47.3008 152.784 47.6881 152.854 48.0428 152.994C48.4068 153.134 48.7194 153.335 48.9808 153.596C49.2514 153.857 49.4614 154.179 49.6107 154.562C49.7601 154.935 49.8348 155.36 49.8348 155.836C49.8348 156.321 49.7554 156.769 49.5968 157.18C49.4474 157.591 49.2234 157.945 48.9248 158.244C48.6261 158.533 48.2574 158.762 47.8188 158.93C47.3894 159.089 46.8994 159.168 46.3488 159.168C45.9101 159.168 45.5228 159.117 45.1868 159.014C44.8508 158.921 44.5521 158.795 44.2908 158.636C44.0388 158.468 43.8148 158.281 43.6188 158.076C43.4321 157.861 43.2641 157.642 43.1148 157.418L44.2628 156.508C44.3841 156.704 44.5101 156.881 44.6408 157.04C44.7714 157.199 44.9208 157.339 45.0888 157.46C45.2568 157.581 45.4434 157.675 45.6488 157.74C45.8634 157.805 46.1061 157.838 46.3768 157.838C46.9554 157.838 47.3988 157.679 47.7068 157.362C48.0241 157.045 48.1828 156.606 48.1828 156.046V155.878C48.1828 155.318 48.0241 154.879 47.7068 154.562C47.3988 154.245 46.9554 154.086 46.3768 154.086C45.9568 154.086 45.6208 154.165 45.3688 154.324C45.1168 154.483 44.9021 154.66 44.7248 154.856L43.4228 154.674L43.7868 149.228H49.3308V150.6ZM53.1473 159L59.9233 149.228H61.3373L54.5613 159H53.1473ZM53.7773 154.604C53.0213 154.604 52.4426 154.371 52.0413 153.904C51.6399 153.428 51.4393 152.737 51.4393 151.832C51.4393 150.927 51.6399 150.241 52.0413 149.774C52.4426 149.298 53.0213 149.06 53.7773 149.06C54.5333 149.06 55.1119 149.298 55.5133 149.774C55.9146 150.241 56.1153 150.927 56.1153 151.832C56.1153 152.737 55.9146 153.428 55.5133 153.904C55.1119 154.371 54.5333 154.604 53.7773 154.604ZM53.7773 153.666C54.4399 153.666 54.7713 153.185 54.7713 152.224V151.44C54.7713 150.479 54.4399 149.998 53.7773 149.998C53.1146 149.998 52.7833 150.479 52.7833 151.44V152.224C52.7833 153.185 53.1146 153.666 53.7773 153.666ZM60.7073 159.168C59.9513 159.168 59.3726 158.935 58.9713 158.468C58.5699 157.992 58.3693 157.301 58.3693 156.396C58.3693 155.491 58.5699 154.805 58.9713 154.338C59.3726 153.862 59.9513 153.624 60.7073 153.624C61.4633 153.624 62.0419 153.862 62.4433 154.338C62.8446 154.805 63.0453 155.491 63.0453 156.396C63.0453 157.301 62.8446 157.992 62.4433 158.468C62.0419 158.935 61.4633 159.168 60.7073 159.168ZM60.7073 158.23C61.3699 158.23 61.7013 157.749 61.7013 156.788V156.004C61.7013 155.043 61.3699 154.562 60.7073 154.562C60.0446 154.562 59.7133 155.043 59.7133 156.004V156.788C59.7133 157.749 60.0446 158.23 60.7073 158.23ZM71.3136 159.168C70.4923 159.168 69.7923 159.019 69.2136 158.72C68.6443 158.421 68.1543 158.02 67.7436 157.516L68.8356 156.494C69.1809 156.914 69.5589 157.231 69.9696 157.446C70.3896 157.661 70.8656 157.768 71.3976 157.768C72.0229 157.768 72.4943 157.628 72.8116 157.348C73.1289 157.068 73.2876 156.69 73.2876 156.214C73.2876 155.831 73.1756 155.528 72.9516 155.304C72.7276 155.08 72.3309 154.912 71.7616 154.8L70.8936 154.646C69.9416 154.469 69.2276 154.156 68.7516 153.708C68.2756 153.26 68.0376 152.644 68.0376 151.86C68.0376 151.431 68.1169 151.043 68.2756 150.698C68.4436 150.343 68.6723 150.049 68.9616 149.816C69.2603 149.573 69.6196 149.387 70.0396 149.256C70.4596 149.125 70.9309 149.06 71.4536 149.06C72.1909 149.06 72.8303 149.191 73.3716 149.452C73.9129 149.704 74.3749 150.073 74.7576 150.558L73.6516 151.538C73.3996 151.211 73.0916 150.95 72.7276 150.754C72.3636 150.558 71.9109 150.46 71.3696 150.46C70.8096 150.46 70.3756 150.572 70.0676 150.796C69.7596 151.02 69.6056 151.347 69.6056 151.776C69.6056 152.187 69.7316 152.495 69.9836 152.7C70.2356 152.896 70.6276 153.045 71.1596 153.148L72.0276 153.33C73.0076 153.517 73.7216 153.834 74.1696 154.282C74.6269 154.73 74.8556 155.346 74.8556 156.13C74.8556 156.587 74.7763 157.003 74.6176 157.376C74.4589 157.749 74.2256 158.071 73.9176 158.342C73.6189 158.603 73.2503 158.809 72.8116 158.958C72.3729 159.098 71.8736 159.168 71.3136 159.168ZM79.4988 159.168C78.9948 159.168 78.5328 159.079 78.1128 158.902C77.7021 158.725 77.3521 158.473 77.0628 158.146C76.7734 157.81 76.5494 157.409 76.3908 156.942C76.2321 156.466 76.1528 155.939 76.1528 155.36C76.1528 154.781 76.2321 154.259 76.3908 153.792C76.5494 153.316 76.7734 152.915 77.0628 152.588C77.3521 152.252 77.7021 151.995 78.1128 151.818C78.5328 151.641 78.9948 151.552 79.4988 151.552C80.0028 151.552 80.4601 151.641 80.8708 151.818C81.2908 151.995 81.6454 152.252 81.9348 152.588C82.2241 152.915 82.4481 153.316 82.6068 153.792C82.7654 154.259 82.8448 154.781 82.8448 155.36C82.8448 155.939 82.7654 156.466 82.6068 156.942C82.4481 157.409 82.2241 157.81 81.9348 158.146C81.6454 158.473 81.2908 158.725 80.8708 158.902C80.4601 159.079 80.0028 159.168 79.4988 159.168ZM79.4988 157.908C80.0214 157.908 80.4414 157.749 80.7588 157.432C81.0761 157.105 81.2348 156.62 81.2348 155.976V154.744C81.2348 154.1 81.0761 153.619 80.7588 153.302C80.4414 152.975 80.0214 152.812 79.4988 152.812C78.9761 152.812 78.5561 152.975 78.2388 153.302C77.9214 153.619 77.7628 154.1 77.7628 154.744V155.976C77.7628 156.62 77.9214 157.105 78.2388 157.432C78.5561 157.749 78.9761 157.908 79.4988 157.908ZM88.9551 157.796H88.8991C88.8338 157.973 88.7451 158.146 88.6331 158.314C88.5305 158.482 88.3951 158.631 88.2271 158.762C88.0685 158.883 87.8725 158.981 87.6391 159.056C87.4151 159.131 87.1538 159.168 86.8551 159.168C86.0991 159.168 85.5111 158.925 85.0911 158.44C84.6805 157.955 84.4751 157.259 84.4751 156.354V151.72H86.0011V156.158C86.0011 157.287 86.4678 157.852 87.4011 157.852C87.5971 157.852 87.7885 157.829 87.9751 157.782C88.1618 157.726 88.3251 157.647 88.4651 157.544C88.6145 157.441 88.7311 157.311 88.8151 157.152C88.9085 156.993 88.9551 156.807 88.9551 156.592V151.72H90.4811V159H88.9551V157.796ZM94.6822 159C94.1502 159 93.7489 158.865 93.4782 158.594C93.2076 158.314 93.0722 157.922 93.0722 157.418V152.966H91.9382V151.72H92.5542C92.8062 151.72 92.9789 151.664 93.0722 151.552C93.1749 151.44 93.2262 151.258 93.2262 151.006V149.732H94.5982V151.72H96.1242V152.966H94.5982V157.754H96.0122V159H94.6822ZM97.7795 148.64H99.3055V152.924H99.3755C99.5342 152.532 99.7722 152.205 100.09 151.944C100.416 151.683 100.86 151.552 101.42 151.552C102.166 151.552 102.745 151.799 103.156 152.294C103.576 152.779 103.786 153.475 103.786 154.38V159H102.26V154.562C102.26 153.433 101.802 152.868 100.888 152.868C100.692 152.868 100.496 152.896 100.3 152.952C100.113 152.999 99.9448 153.073 99.7955 153.176C99.6462 153.279 99.5248 153.409 99.4315 153.568C99.3475 153.727 99.3055 153.909 99.3055 154.114V159H97.7795V148.64ZM114.963 158.006C114.842 158.127 114.693 158.258 114.515 158.398C114.347 158.529 114.147 158.655 113.913 158.776C113.689 158.888 113.428 158.981 113.129 159.056C112.84 159.131 112.509 159.168 112.135 159.168C111.631 159.168 111.183 159.098 110.791 158.958C110.399 158.818 110.068 158.627 109.797 158.384C109.536 158.141 109.335 157.857 109.195 157.53C109.065 157.194 108.999 156.835 108.999 156.452C108.999 156.107 109.051 155.799 109.153 155.528C109.265 155.248 109.41 155.001 109.587 154.786C109.774 154.562 109.984 154.366 110.217 154.198C110.46 154.021 110.717 153.857 110.987 153.708C110.679 153.381 110.418 153.027 110.203 152.644C109.989 152.261 109.881 151.851 109.881 151.412C109.881 151.085 109.942 150.777 110.063 150.488C110.194 150.199 110.376 149.951 110.609 149.746C110.843 149.531 111.123 149.363 111.449 149.242C111.785 149.121 112.154 149.06 112.555 149.06C112.929 149.06 113.274 149.111 113.591 149.214C113.909 149.317 114.184 149.461 114.417 149.648C114.651 149.835 114.828 150.063 114.949 150.334C115.08 150.595 115.145 150.889 115.145 151.216C115.145 151.533 115.089 151.823 114.977 152.084C114.865 152.336 114.711 152.569 114.515 152.784C114.319 152.989 114.091 153.185 113.829 153.372C113.577 153.549 113.307 153.722 113.017 153.89L114.921 155.948C115.052 155.612 115.155 155.257 115.229 154.884C115.304 154.511 115.351 154.133 115.369 153.75H117.455V155.038H116.503C116.363 155.747 116.149 156.377 115.859 156.928L117.777 159H115.873L114.963 158.006ZM112.555 150.278C112.219 150.278 111.935 150.381 111.701 150.586C111.468 150.782 111.351 151.043 111.351 151.37V151.482C111.351 151.725 111.426 151.967 111.575 152.21C111.734 152.453 111.958 152.733 112.247 153.05C112.639 152.835 112.975 152.597 113.255 152.336C113.535 152.065 113.675 151.757 113.675 151.412V151.3C113.675 150.973 113.573 150.721 113.367 150.544C113.162 150.367 112.891 150.278 112.555 150.278ZM112.317 157.866C112.709 157.866 113.055 157.801 113.353 157.67C113.652 157.539 113.913 157.357 114.137 157.124L111.757 154.562C111.403 154.758 111.113 154.977 110.889 155.22C110.675 155.463 110.567 155.794 110.567 156.214V156.396C110.567 156.844 110.721 157.203 111.029 157.474C111.337 157.735 111.767 157.866 112.317 157.866ZM126.196 159.168C124.918 159.168 123.914 158.739 123.186 157.88C122.458 157.012 122.094 155.757 122.094 154.114C122.094 153.293 122.188 152.569 122.374 151.944C122.561 151.319 122.832 150.791 123.186 150.362C123.541 149.933 123.97 149.611 124.474 149.396C124.988 149.172 125.562 149.06 126.196 149.06C127.046 149.06 127.755 149.247 128.324 149.62C128.903 149.993 129.356 150.544 129.682 151.272L128.352 152C128.184 151.533 127.923 151.165 127.568 150.894C127.223 150.614 126.766 150.474 126.196 150.474C125.44 150.474 124.848 150.731 124.418 151.244C123.989 151.757 123.774 152.467 123.774 153.372V154.856C123.774 155.761 123.989 156.471 124.418 156.984C124.848 157.497 125.44 157.754 126.196 157.754C126.784 157.754 127.26 157.605 127.624 157.306C127.998 156.998 128.273 156.606 128.45 156.13L129.724 156.9C129.398 157.609 128.94 158.165 128.352 158.566C127.764 158.967 127.046 159.168 126.196 159.168ZM134.145 159.168C133.623 159.168 133.156 159.079 132.745 158.902C132.335 158.725 131.985 158.473 131.695 158.146C131.406 157.81 131.182 157.409 131.023 156.942C130.874 156.466 130.799 155.939 130.799 155.36C130.799 154.781 130.874 154.259 131.023 153.792C131.182 153.316 131.406 152.915 131.695 152.588C131.985 152.252 132.335 151.995 132.745 151.818C133.156 151.641 133.623 151.552 134.145 151.552C134.677 151.552 135.144 151.645 135.545 151.832C135.956 152.019 136.297 152.28 136.567 152.616C136.838 152.943 137.039 153.325 137.169 153.764C137.309 154.203 137.379 154.674 137.379 155.178V155.752H132.381V155.99C132.381 156.55 132.545 157.012 132.871 157.376C133.207 157.731 133.683 157.908 134.299 157.908C134.747 157.908 135.125 157.81 135.433 157.614C135.741 157.418 136.003 157.152 136.217 156.816L137.113 157.698C136.843 158.146 136.451 158.505 135.937 158.776C135.424 159.037 134.827 159.168 134.145 159.168ZM134.145 152.742C133.884 152.742 133.641 152.789 133.417 152.882C133.203 152.975 133.016 153.106 132.857 153.274C132.708 153.442 132.591 153.643 132.507 153.876C132.423 154.109 132.381 154.366 132.381 154.646V154.744H135.769V154.604C135.769 154.044 135.625 153.596 135.335 153.26C135.046 152.915 134.649 152.742 134.145 152.742ZM139.069 159V151.72H140.595V152.924H140.665C140.823 152.532 141.061 152.205 141.379 151.944C141.705 151.683 142.149 151.552 142.709 151.552C143.455 151.552 144.034 151.799 144.445 152.294C144.865 152.779 145.075 153.475 145.075 154.38V159H143.549V154.576C143.549 153.437 143.091 152.868 142.177 152.868C141.981 152.868 141.785 152.896 141.589 152.952C141.402 152.999 141.234 153.073 141.085 153.176C140.935 153.279 140.814 153.409 140.721 153.568C140.637 153.727 140.595 153.913 140.595 154.128V159H139.069ZM149.206 159C148.674 159 148.272 158.865 148.002 158.594C147.731 158.314 147.596 157.922 147.596 157.418V152.966H146.462V151.72H147.078C147.33 151.72 147.502 151.664 147.596 151.552C147.698 151.44 147.75 151.258 147.75 151.006V149.732H149.122V151.72H150.648V152.966H149.122V157.754H150.536V159H149.206ZM152.303 159V151.72H153.829V153.12H153.899C154.002 152.747 154.216 152.42 154.543 152.14C154.87 151.86 155.322 151.72 155.901 151.72H156.307V153.19H155.705C155.098 153.19 154.632 153.288 154.305 153.484C153.988 153.68 153.829 153.969 153.829 154.352V159H152.303ZM162.887 159C162.486 159 162.178 158.888 161.963 158.664C161.748 158.431 161.618 158.137 161.571 157.782H161.501C161.361 158.239 161.104 158.585 160.731 158.818C160.358 159.051 159.905 159.168 159.373 159.168C158.617 159.168 158.034 158.972 157.623 158.58C157.222 158.188 157.021 157.661 157.021 156.998C157.021 156.27 157.282 155.724 157.805 155.36C158.337 154.996 159.112 154.814 160.129 154.814H161.445V154.198C161.445 153.75 161.324 153.405 161.081 153.162C160.838 152.919 160.46 152.798 159.947 152.798C159.518 152.798 159.168 152.891 158.897 153.078C158.626 153.265 158.398 153.503 158.211 153.792L157.301 152.966C157.544 152.555 157.884 152.219 158.323 151.958C158.762 151.687 159.336 151.552 160.045 151.552C160.988 151.552 161.711 151.771 162.215 152.21C162.719 152.649 162.971 153.279 162.971 154.1V157.754H163.741V159H162.887ZM159.807 158.006C160.283 158.006 160.675 157.903 160.983 157.698C161.291 157.483 161.445 157.199 161.445 156.844V155.794H160.157C159.102 155.794 158.575 156.121 158.575 156.774V157.026C158.575 157.353 158.682 157.6 158.897 157.768C159.121 157.927 159.424 158.006 159.807 158.006ZM166.791 159C166.268 159 165.876 158.869 165.615 158.608C165.363 158.337 165.237 157.964 165.237 157.488V148.64H166.763V157.754H167.771V159H166.791ZM178.753 159L177.871 156.354H174.217L173.363 159H171.753L175.085 149.228H177.073L180.405 159H178.753ZM176.079 150.684H176.009L174.595 154.996H177.479L176.079 150.684ZM181.807 159V151.72H183.333V152.924H183.403C183.478 152.737 183.566 152.56 183.669 152.392C183.781 152.224 183.912 152.079 184.061 151.958C184.22 151.827 184.402 151.729 184.607 151.664C184.822 151.589 185.069 151.552 185.349 151.552C185.844 151.552 186.282 151.673 186.665 151.916C187.048 152.159 187.328 152.532 187.505 153.036H187.547C187.678 152.625 187.93 152.275 188.303 151.986C188.676 151.697 189.157 151.552 189.745 151.552C190.473 151.552 191.038 151.799 191.439 152.294C191.84 152.779 192.041 153.475 192.041 154.38V159H190.515V154.562C190.515 154.002 190.408 153.582 190.193 153.302C189.978 153.013 189.638 152.868 189.171 152.868C188.975 152.868 188.788 152.896 188.611 152.952C188.434 152.999 188.275 153.073 188.135 153.176C188.004 153.279 187.897 153.409 187.813 153.568C187.729 153.727 187.687 153.909 187.687 154.114V159H186.161V154.562C186.161 153.433 185.718 152.868 184.831 152.868C184.644 152.868 184.458 152.896 184.271 152.952C184.094 152.999 183.935 153.073 183.795 153.176C183.655 153.279 183.543 153.409 183.459 153.568C183.375 153.727 183.333 153.909 183.333 154.114V159H181.807ZM197.009 159.168C196.486 159.168 196.019 159.079 195.609 158.902C195.198 158.725 194.848 158.473 194.559 158.146C194.269 157.81 194.045 157.409 193.887 156.942C193.737 156.466 193.663 155.939 193.663 155.36C193.663 154.781 193.737 154.259 193.887 153.792C194.045 153.316 194.269 152.915 194.559 152.588C194.848 152.252 195.198 151.995 195.609 151.818C196.019 151.641 196.486 151.552 197.009 151.552C197.541 151.552 198.007 151.645 198.409 151.832C198.819 152.019 199.16 152.28 199.431 152.616C199.701 152.943 199.902 153.325 200.033 153.764C200.173 154.203 200.243 154.674 200.243 155.178V155.752H195.245V155.99C195.245 156.55 195.408 157.012 195.735 157.376C196.071 157.731 196.547 157.908 197.163 157.908C197.611 157.908 197.989 157.81 198.297 157.614C198.605 157.418 198.866 157.152 199.081 156.816L199.977 157.698C199.706 158.146 199.314 158.505 198.801 158.776C198.287 159.037 197.69 159.168 197.009 159.168ZM197.009 152.742C196.747 152.742 196.505 152.789 196.281 152.882C196.066 152.975 195.879 153.106 195.721 153.274C195.571 153.442 195.455 153.643 195.371 153.876C195.287 154.109 195.245 154.366 195.245 154.646V154.744H198.633V154.604C198.633 154.044 198.488 153.596 198.199 153.26C197.909 152.915 197.513 152.742 197.009 152.742ZM201.932 159V151.72H203.458V153.12H203.528C203.631 152.747 203.845 152.42 204.172 152.14C204.499 151.86 204.951 151.72 205.53 151.72H205.936V153.19H205.334C204.727 153.19 204.261 153.288 203.934 153.484C203.617 153.68 203.458 153.969 203.458 154.352V159H201.932ZM208.061 150.418C207.744 150.418 207.511 150.343 207.361 150.194C207.221 150.045 207.151 149.853 207.151 149.62V149.382C207.151 149.149 207.221 148.957 207.361 148.808C207.511 148.659 207.744 148.584 208.061 148.584C208.379 148.584 208.607 148.659 208.747 148.808C208.887 148.957 208.957 149.149 208.957 149.382V149.62C208.957 149.853 208.887 150.045 208.747 150.194C208.607 150.343 208.379 150.418 208.061 150.418ZM207.291 151.72H208.817V159H207.291V151.72ZM213.81 159.168C213.288 159.168 212.821 159.079 212.41 158.902C212 158.725 211.654 158.473 211.374 158.146C211.094 157.81 210.88 157.409 210.73 156.942C210.581 156.466 210.506 155.939 210.506 155.36C210.506 154.781 210.581 154.259 210.73 153.792C210.88 153.316 211.094 152.915 211.374 152.588C211.654 152.252 212 151.995 212.41 151.818C212.821 151.641 213.288 151.552 213.81 151.552C214.538 151.552 215.136 151.715 215.602 152.042C216.069 152.369 216.41 152.803 216.624 153.344L215.364 153.932C215.262 153.596 215.08 153.33 214.818 153.134C214.566 152.929 214.23 152.826 213.81 152.826C213.25 152.826 212.826 153.003 212.536 153.358C212.256 153.703 212.116 154.156 212.116 154.716V156.018C212.116 156.578 212.256 157.035 212.536 157.39C212.826 157.735 213.25 157.908 213.81 157.908C214.258 157.908 214.613 157.801 214.874 157.586C215.145 157.362 215.36 157.068 215.518 156.704L216.68 157.32C216.438 157.917 216.074 158.375 215.588 158.692C215.103 159.009 214.51 159.168 213.81 159.168ZM223.467 159C223.066 159 222.758 158.888 222.543 158.664C222.328 158.431 222.198 158.137 222.151 157.782H222.081C221.941 158.239 221.684 158.585 221.311 158.818C220.938 159.051 220.485 159.168 219.953 159.168C219.197 159.168 218.614 158.972 218.203 158.58C217.802 158.188 217.601 157.661 217.601 156.998C217.601 156.27 217.862 155.724 218.385 155.36C218.917 154.996 219.692 154.814 220.709 154.814H222.025V154.198C222.025 153.75 221.904 153.405 221.661 153.162C221.418 152.919 221.04 152.798 220.527 152.798C220.098 152.798 219.748 152.891 219.477 153.078C219.206 153.265 218.978 153.503 218.791 153.792L217.881 152.966C218.124 152.555 218.464 152.219 218.903 151.958C219.342 151.687 219.916 151.552 220.625 151.552C221.568 151.552 222.291 151.771 222.795 152.21C223.299 152.649 223.551 153.279 223.551 154.1V157.754H224.321V159H223.467ZM220.387 158.006C220.863 158.006 221.255 157.903 221.563 157.698C221.871 157.483 222.025 157.199 222.025 156.844V155.794H220.737C219.682 155.794 219.155 156.121 219.155 156.774V157.026C219.155 157.353 219.262 157.6 219.477 157.768C219.701 157.927 220.004 158.006 220.387 158.006ZM234.879 158.006C234.758 158.127 234.609 158.258 234.431 158.398C234.263 158.529 234.063 158.655 233.829 158.776C233.605 158.888 233.344 158.981 233.045 159.056C232.756 159.131 232.425 159.168 232.051 159.168C231.547 159.168 231.099 159.098 230.707 158.958C230.315 158.818 229.984 158.627 229.713 158.384C229.452 158.141 229.251 157.857 229.111 157.53C228.981 157.194 228.915 156.835 228.915 156.452C228.915 156.107 228.967 155.799 229.069 155.528C229.181 155.248 229.326 155.001 229.503 154.786C229.69 154.562 229.9 154.366 230.133 154.198C230.376 154.021 230.633 153.857 230.903 153.708C230.595 153.381 230.334 153.027 230.119 152.644C229.905 152.261 229.797 151.851 229.797 151.412C229.797 151.085 229.858 150.777 229.979 150.488C230.11 150.199 230.292 149.951 230.525 149.746C230.759 149.531 231.039 149.363 231.365 149.242C231.701 149.121 232.07 149.06 232.471 149.06C232.845 149.06 233.19 149.111 233.507 149.214C233.825 149.317 234.1 149.461 234.333 149.648C234.567 149.835 234.744 150.063 234.865 150.334C234.996 150.595 235.061 150.889 235.061 151.216C235.061 151.533 235.005 151.823 234.893 152.084C234.781 152.336 234.627 152.569 234.431 152.784C234.235 152.989 234.007 153.185 233.745 153.372C233.493 153.549 233.223 153.722 232.933 153.89L234.837 155.948C234.968 155.612 235.071 155.257 235.145 154.884C235.22 154.511 235.267 154.133 235.285 153.75H237.371V155.038H236.419C236.279 155.747 236.065 156.377 235.775 156.928L237.693 159H235.789L234.879 158.006ZM232.471 150.278C232.135 150.278 231.851 150.381 231.617 150.586C231.384 150.782 231.267 151.043 231.267 151.37V151.482C231.267 151.725 231.342 151.967 231.491 152.21C231.65 152.453 231.874 152.733 232.163 153.05C232.555 152.835 232.891 152.597 233.171 152.336C233.451 152.065 233.591 151.757 233.591 151.412V151.3C233.591 150.973 233.489 150.721 233.283 150.544C233.078 150.367 232.807 150.278 232.471 150.278ZM232.233 157.866C232.625 157.866 232.971 157.801 233.269 157.67C233.568 157.539 233.829 157.357 234.053 157.124L231.673 154.562C231.319 154.758 231.029 154.977 230.805 155.22C230.591 155.463 230.483 155.794 230.483 156.214V156.396C230.483 156.844 230.637 157.203 230.945 157.474C231.253 157.735 231.683 157.866 232.233 157.866ZM242.472 159V157.684H245.216V150.376H245.104L242.836 152.798L241.87 151.93L244.362 149.228H246.77V157.684H249.15V159H242.472ZM253.835 159.168C253.228 159.168 252.701 159.056 252.253 158.832C251.805 158.599 251.436 158.267 251.147 157.838C250.857 157.409 250.643 156.881 250.503 156.256C250.363 155.631 250.293 154.917 250.293 154.114C250.293 153.321 250.363 152.611 250.503 151.986C250.643 151.351 250.857 150.819 251.147 150.39C251.436 149.961 251.805 149.634 252.253 149.41C252.701 149.177 253.228 149.06 253.835 149.06C255.048 149.06 255.939 149.503 256.509 150.39C257.087 151.277 257.377 152.518 257.377 154.114C257.377 155.71 257.087 156.951 256.509 157.838C255.939 158.725 255.048 159.168 253.835 159.168ZM253.835 157.824C254.171 157.824 254.455 157.759 254.689 157.628C254.931 157.488 255.127 157.292 255.277 157.04C255.426 156.788 255.533 156.489 255.599 156.144C255.664 155.789 255.697 155.397 255.697 154.968V153.26C255.697 152.831 255.664 152.443 255.599 152.098C255.533 151.743 255.426 151.44 255.277 151.188C255.127 150.936 254.931 150.745 254.689 150.614C254.455 150.474 254.171 150.404 253.835 150.404C253.499 150.404 253.209 150.474 252.967 150.614C252.733 150.745 252.542 150.936 252.393 151.188C252.243 151.44 252.136 151.743 252.071 152.098C252.005 152.443 251.973 152.831 251.973 153.26V154.968C251.973 155.397 252.005 155.789 252.071 156.144C252.136 156.489 252.243 156.788 252.393 157.04C252.542 157.292 252.733 157.488 252.967 157.628C253.209 157.759 253.499 157.824 253.835 157.824ZM260.563 159L267.339 149.228H268.753L261.977 159H260.563ZM261.193 154.604C260.437 154.604 259.859 154.371 259.457 153.904C259.056 153.428 258.855 152.737 258.855 151.832C258.855 150.927 259.056 150.241 259.457 149.774C259.859 149.298 260.437 149.06 261.193 149.06C261.949 149.06 262.528 149.298 262.929 149.774C263.331 150.241 263.531 150.927 263.531 151.832C263.531 152.737 263.331 153.428 262.929 153.904C262.528 154.371 261.949 154.604 261.193 154.604ZM261.193 153.666C261.856 153.666 262.187 153.185 262.187 152.224V151.44C262.187 150.479 261.856 149.998 261.193 149.998C260.531 149.998 260.199 150.479 260.199 151.44V152.224C260.199 153.185 260.531 153.666 261.193 153.666ZM268.123 159.168C267.367 159.168 266.789 158.935 266.387 158.468C265.986 157.992 265.785 157.301 265.785 156.396C265.785 155.491 265.986 154.805 266.387 154.338C266.789 153.862 267.367 153.624 268.123 153.624C268.879 153.624 269.458 153.862 269.859 154.338C270.261 154.805 270.461 155.491 270.461 156.396C270.461 157.301 270.261 157.992 269.859 158.468C269.458 158.935 268.879 159.168 268.123 159.168ZM268.123 158.23C268.786 158.23 269.117 157.749 269.117 156.788V156.004C269.117 155.043 268.786 154.562 268.123 154.562C267.461 154.562 267.129 155.043 267.129 156.004V156.788C267.129 157.749 267.461 158.23 268.123 158.23ZM281.908 159L281.026 156.354H277.372L276.518 159H274.908L278.24 149.228H280.228L283.56 159H281.908ZM279.234 150.684H279.164L277.75 154.996H280.634L279.234 150.684ZM287.271 159.168C286.58 159.168 286.002 159.047 285.535 158.804C285.068 158.561 284.662 158.225 284.317 157.796L285.297 156.9C285.568 157.227 285.866 157.483 286.193 157.67C286.529 157.847 286.916 157.936 287.355 157.936C287.803 157.936 288.134 157.852 288.349 157.684C288.573 157.507 288.685 157.264 288.685 156.956C288.685 156.723 288.606 156.527 288.447 156.368C288.298 156.2 288.032 156.093 287.649 156.046L286.977 155.962C286.23 155.869 285.642 155.654 285.213 155.318C284.793 154.973 284.583 154.464 284.583 153.792C284.583 153.437 284.648 153.125 284.779 152.854C284.91 152.574 285.092 152.341 285.325 152.154C285.568 151.958 285.852 151.809 286.179 151.706C286.515 151.603 286.884 151.552 287.285 151.552C287.938 151.552 288.47 151.655 288.881 151.86C289.301 152.065 289.674 152.35 290.001 152.714L289.063 153.61C288.876 153.386 288.629 153.195 288.321 153.036C288.022 152.868 287.677 152.784 287.285 152.784C286.865 152.784 286.552 152.868 286.347 153.036C286.151 153.204 286.053 153.423 286.053 153.694C286.053 153.974 286.142 154.184 286.319 154.324C286.496 154.464 286.781 154.567 287.173 154.632L287.845 154.716C288.648 154.837 289.231 155.075 289.595 155.43C289.968 155.775 290.155 156.242 290.155 156.83C290.155 157.185 290.085 157.507 289.945 157.796C289.814 158.076 289.623 158.319 289.371 158.524C289.119 158.729 288.816 158.888 288.461 159C288.106 159.112 287.71 159.168 287.271 159.168ZM292.649 150.418C292.332 150.418 292.098 150.343 291.949 150.194C291.809 150.045 291.739 149.853 291.739 149.62V149.382C291.739 149.149 291.809 148.957 291.949 148.808C292.098 148.659 292.332 148.584 292.649 148.584C292.966 148.584 293.195 148.659 293.335 148.808C293.475 148.957 293.545 149.149 293.545 149.382V149.62C293.545 149.853 293.475 150.045 293.335 150.194C293.195 150.343 292.966 150.418 292.649 150.418ZM291.879 151.72H293.405V159H291.879V151.72ZM300.918 159C300.517 159 300.209 158.888 299.994 158.664C299.78 158.431 299.649 158.137 299.602 157.782H299.532C299.392 158.239 299.136 158.585 298.762 158.818C298.389 159.051 297.936 159.168 297.404 159.168C296.648 159.168 296.065 158.972 295.654 158.58C295.253 158.188 295.052 157.661 295.052 156.998C295.052 156.27 295.314 155.724 295.836 155.36C296.368 154.996 297.143 154.814 298.16 154.814H299.476V154.198C299.476 153.75 299.355 153.405 299.112 153.162C298.87 152.919 298.492 152.798 297.978 152.798C297.549 152.798 297.199 152.891 296.928 153.078C296.658 153.265 296.429 153.503 296.242 153.792L295.332 152.966C295.575 152.555 295.916 152.219 296.354 151.958C296.793 151.687 297.367 151.552 298.076 151.552C299.019 151.552 299.742 151.771 300.246 152.21C300.75 152.649 301.002 153.279 301.002 154.1V157.754H301.772V159H300.918ZM297.838 158.006C298.314 158.006 298.706 157.903 299.014 157.698C299.322 157.483 299.476 157.199 299.476 156.844V155.794H298.188C297.134 155.794 296.606 156.121 296.606 156.774V157.026C296.606 157.353 296.714 157.6 296.928 157.768C297.152 157.927 297.456 158.006 297.838 158.006Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                                    id: "clip0_5592_3899",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        fill: "white",
                                                                        transform: "translate(156 36)"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                        className: 'lg:hidden w-full',
                                                        viewBox: "0 0 284 413",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0 9.22657C0 4.256 4.02944 0.226562 9 0.226562H127C131.971 0.226562 136 4.256 136 9.22656V179.227C136 184.197 131.971 188.227 127 188.227H9C4.02944 188.227 0 184.197 0 179.227V9.22657Z",
                                                                fill: "#007758"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0.5 9.22657C0.5 4.53215 4.30558 0.726562 9 0.726562H127C131.694 0.726562 135.5 4.53214 135.5 9.22656V179.227C135.5 183.921 131.694 187.727 127 187.727H9C4.30558 187.727 0.5 183.921 0.5 179.227V9.22657Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M50 24.2266C50 20.9129 52.6863 18.2266 56 18.2266H80C83.3137 18.2266 86 20.9129 86 24.2266V48.2266C86 51.5403 83.3137 54.2266 80 54.2266H56C52.6863 54.2266 50 51.5403 50 48.2266V24.2266Z",
                                                                fill: "#CCF4E9"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M50.5 24.2266C50.5 21.189 52.9624 18.7266 56 18.7266H80C83.0376 18.7266 85.5 21.189 85.5 24.2266V48.2266C85.5 51.2641 83.0376 53.7266 80 53.7266H56C52.9624 53.7266 50.5 51.2641 50.5 48.2266V24.2266Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                                clipPath: "url(#clip0_5592_7504)",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M64.5337 27.9209C66.2234 27.2157 68.088 27.0426 69.8786 27.4248C71.6692 27.807 73.3007 28.7262 74.5553 30.0598C75.8098 31.3934 76.6278 33.0779 76.9 34.8885C77.1722 36.6991 76.8857 38.5497 76.0787 40.1932C75.8962 40.565 75.4468 40.7184 75.0749 40.5359C74.7031 40.3533 74.5497 39.9039 74.7323 39.5321C75.4047 38.1625 75.6435 36.6204 75.4167 35.1115C75.1898 33.6027 74.5082 32.1989 73.4627 31.0876C72.4172 29.9763 71.0577 29.2103 69.5655 28.8918C68.0733 28.5733 66.5195 28.7175 65.1114 29.3051C63.7033 29.8928 62.508 30.8959 61.6849 32.1807C60.8618 33.4654 60.4501 34.9706 60.5048 36.4954C60.5595 38.0202 61.078 39.4921 61.991 40.7146C62.6155 41.5507 63.4042 42.2429 64.3032 42.7522L63.5429 40.6015C63.4048 40.211 63.6095 39.7825 64 39.6444C64.3905 39.5064 64.8191 39.711 64.9571 40.1016L66.4154 44.2266C66.4966 44.4561 66.4612 44.7108 66.3207 44.9096C66.1801 45.1084 65.9518 45.2266 65.7083 45.2266L61.25 45.2265C60.8358 45.2265 60.5 44.8907 60.5 44.4765C60.5 44.0623 60.8358 43.7265 61.25 43.7265L63.025 43.7265C62.1687 43.1585 61.4111 42.4448 60.7892 41.6122C59.6936 40.1452 59.0714 38.379 59.0058 36.5492C58.9402 34.7194 59.4342 32.9132 60.4219 31.3715C61.4096 29.8298 62.844 28.626 64.5337 27.9209Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M68 30.2266C68.4142 30.2266 68.75 30.5623 68.75 30.9766V35.9159L71.1553 38.3212C71.4482 38.6141 71.4482 39.089 71.1553 39.3819C70.8624 39.6748 70.3876 39.6748 70.0947 39.3819L67.4697 36.7569C67.329 36.6162 67.25 36.4255 67.25 36.2266V30.9766C67.25 30.5623 67.5858 30.2266 68 30.2266Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M73.2417 41.5995C73.5382 41.3103 74.013 41.3161 74.3023 41.6125C74.5916 41.909 74.5858 42.3838 74.2893 42.6731C73.9929 42.9624 73.5181 42.9566 73.2288 42.6601C72.9395 42.3637 72.9453 41.8888 73.2417 41.5995Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M71.0901 43.0674C71.4676 42.8969 71.9118 43.0648 72.0822 43.4423C72.2527 43.8198 72.0848 44.264 71.7073 44.4345C71.3298 44.6049 70.8856 44.4371 70.7151 44.0596C70.5447 43.682 70.7125 43.2378 71.0901 43.0674Z",
                                                                        fill: "#009E76"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M69.37 44.4027C69.3389 43.9896 68.9789 43.68 68.5659 43.711C68.1528 43.7421 67.8432 44.1021 67.8742 44.5151C67.9053 44.9282 68.2653 45.2379 68.6783 45.2068C69.0914 45.1758 69.401 44.8157 69.37 44.4027Z",
                                                                        fill: "#009E76"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M37.9882 73.2266H33.3382L33.0682 76.9316H33.1732C33.2932 76.7216 33.4182 76.5366 33.5482 76.3766C33.6782 76.2066 33.8282 76.0616 33.9982 75.9416C34.1682 75.8216 34.3632 75.7316 34.5832 75.6716C34.8032 75.6016 35.0632 75.5666 35.3632 75.5666C35.8132 75.5666 36.2282 75.6416 36.6082 75.7916C36.9982 75.9416 37.3332 76.1566 37.6132 76.4366C37.9032 76.7166 38.1282 77.0616 38.2882 77.4716C38.4482 77.8716 38.5282 78.3266 38.5282 78.8366C38.5282 79.3566 38.4432 79.8366 38.2732 80.2766C38.1132 80.7166 37.8732 81.0966 37.5532 81.4166C37.2332 81.7266 36.8382 81.9716 36.3682 82.1516C35.9082 82.3216 35.3832 82.4066 34.7932 82.4066C34.3232 82.4066 33.9082 82.3516 33.5482 82.2416C33.1882 82.1416 32.8682 82.0066 32.5882 81.8366C32.3182 81.6566 32.0782 81.4566 31.8682 81.2366C31.6682 81.0066 31.4882 80.7716 31.3282 80.5316L32.5582 79.5566C32.6882 79.7666 32.8232 79.9566 32.9632 80.1266C33.1032 80.2966 33.2632 80.4466 33.4432 80.5766C33.6232 80.7066 33.8232 80.8066 34.0432 80.8766C34.2732 80.9466 34.5332 80.9816 34.8232 80.9816C35.4432 80.9816 35.9182 80.8116 36.2482 80.4716C36.5882 80.1316 36.7582 79.6616 36.7582 79.0616V78.8816C36.7582 78.2816 36.5882 77.8116 36.2482 77.4716C35.9182 77.1316 35.4432 76.9616 34.8232 76.9616C34.3732 76.9616 34.0132 77.0466 33.7432 77.2166C33.4732 77.3866 33.2432 77.5766 33.0532 77.7866L31.6582 77.5916L32.0482 71.7566H37.9882V73.2266ZM42.6923 82.2266C42.1223 82.2266 41.6923 82.0816 41.4023 81.7916C41.1123 81.4916 40.9673 81.0716 40.9673 80.5316V75.7616H39.7523V74.4266H40.4123C40.6823 74.4266 40.8673 74.3666 40.9673 74.2466C41.0773 74.1266 41.1323 73.9316 41.1323 73.6616V72.2966H42.6023V74.4266H44.2373V75.7616H42.6023V80.8916H44.1173V82.2266H42.6923ZM46.0108 71.1266H47.6458V75.7166H47.7208C47.8908 75.2966 48.1458 74.9466 48.4858 74.6666C48.8358 74.3866 49.3108 74.2466 49.9108 74.2466C50.7108 74.2466 51.3308 74.5116 51.7708 75.0416C52.2208 75.5616 52.4458 76.3066 52.4458 77.2766V82.2266H50.8108V77.4716C50.8108 76.2616 50.3208 75.6566 49.3408 75.6566C49.1308 75.6566 48.9208 75.6866 48.7108 75.7466C48.5108 75.7966 48.3308 75.8766 48.1708 75.9866C48.0108 76.0966 47.8808 76.2366 47.7808 76.4066C47.6908 76.5766 47.6458 76.7716 47.6458 76.9916V82.2266H46.0108V71.1266ZM64.9169 82.2266L63.9719 79.3916H60.0569L59.1419 82.2266H57.4169L60.9869 71.7566H63.1169L66.6869 82.2266H64.9169ZM62.0519 73.3166H61.9769L60.4619 77.9366H63.5519L62.0519 73.3166ZM68.1886 82.2266V74.4266H69.8236V75.7166H69.8986C70.0686 75.2966 70.3236 74.9466 70.6636 74.6666C71.0136 74.3866 71.4886 74.2466 72.0886 74.2466C72.8886 74.2466 73.5086 74.5116 73.9486 75.0416C74.3986 75.5616 74.6236 76.3066 74.6236 77.2766V82.2266H72.9886V77.4866C72.9886 76.2666 72.4986 75.6566 71.5186 75.6566C71.3086 75.6566 71.0986 75.6866 70.8886 75.7466C70.6886 75.7966 70.5086 75.8766 70.3486 75.9866C70.1886 76.0966 70.0586 76.2366 69.9586 76.4066C69.8686 76.5766 69.8236 76.7766 69.8236 77.0066V82.2266H68.1886ZM76.8897 82.2266V74.4266H78.5247V75.7166H78.5997C78.7697 75.2966 79.0247 74.9466 79.3647 74.6666C79.7147 74.3866 80.1897 74.2466 80.7897 74.2466C81.5897 74.2466 82.2097 74.5116 82.6497 75.0416C83.0997 75.5616 83.3247 76.3066 83.3247 77.2766V82.2266H81.6897V77.4866C81.6897 76.2666 81.1997 75.6566 80.2197 75.6566C80.0097 75.6566 79.7997 75.6866 79.5897 75.7466C79.3897 75.7966 79.2097 75.8766 79.0497 75.9866C78.8897 76.0966 78.7597 76.2366 78.6597 76.4066C78.5697 76.5766 78.5247 76.7766 78.5247 77.0066V82.2266H76.8897ZM90.3159 80.9366H90.2559C90.1859 81.1266 90.0909 81.3116 89.9709 81.4916C89.8609 81.6716 89.7159 81.8316 89.5359 81.9716C89.3659 82.1016 89.1559 82.2066 88.9059 82.2866C88.6659 82.3666 88.3859 82.4066 88.0659 82.4066C87.2559 82.4066 86.6259 82.1466 86.1759 81.6266C85.7359 81.1066 85.5159 80.3616 85.5159 79.3916V74.4266H87.1509V79.1816C87.1509 80.3916 87.6509 80.9966 88.6509 80.9966C88.8609 80.9966 89.0659 80.9716 89.2659 80.9216C89.4659 80.8616 89.6409 80.7766 89.7909 80.6666C89.9509 80.5566 90.0759 80.4166 90.1659 80.2466C90.2659 80.0766 90.3159 79.8766 90.3159 79.6466V74.4266H91.9509V82.2266H90.3159V80.9366ZM100.007 82.2266C99.5771 82.2266 99.2471 82.1066 99.0171 81.8666C98.7871 81.6166 98.6471 81.3016 98.5971 80.9216H98.5221C98.3721 81.4116 98.0971 81.7816 97.6971 82.0316C97.2971 82.2816 96.8121 82.4066 96.2421 82.4066C95.4321 82.4066 94.8071 82.1966 94.3671 81.7766C93.9371 81.3566 93.7221 80.7916 93.7221 80.0816C93.7221 79.3016 94.0021 78.7166 94.5621 78.3266C95.1321 77.9366 95.9621 77.7416 97.0521 77.7416H98.4621V77.0816C98.4621 76.6016 98.3321 76.2316 98.0721 75.9716C97.8121 75.7116 97.4071 75.5816 96.8571 75.5816C96.3971 75.5816 96.0221 75.6816 95.7321 75.8816C95.4421 76.0816 95.1971 76.3366 94.9971 76.6466L94.0221 75.7616C94.2821 75.3216 94.6471 74.9616 95.1171 74.6816C95.5871 74.3916 96.2021 74.2466 96.9621 74.2466C97.9721 74.2466 98.7471 74.4816 99.2871 74.9516C99.8271 75.4216 100.097 76.0966 100.097 76.9766V80.8916H100.922V82.2266H100.007ZM96.7071 81.1616C97.2171 81.1616 97.6371 81.0516 97.9671 80.8316C98.2971 80.6016 98.4621 80.2966 98.4621 79.9166V78.7916H97.0821C95.9521 78.7916 95.3871 79.1416 95.3871 79.8416V80.1116C95.3871 80.4616 95.5021 80.7266 95.7321 80.9066C95.9721 81.0766 96.2971 81.1616 96.7071 81.1616ZM104.189 82.2266C103.629 82.2266 103.209 82.0866 102.929 81.8066C102.659 81.5166 102.524 81.1166 102.524 80.6066V71.1266H104.159V80.8916H105.239V82.2266H104.189ZM48.8996 103.407C48.0196 103.407 47.2696 103.247 46.6496 102.927C46.0396 102.607 45.5146 102.177 45.0746 101.637L46.2446 100.542C46.6146 100.992 47.0196 101.332 47.4596 101.562C47.9096 101.792 48.4196 101.907 48.9896 101.907C49.6596 101.907 50.1646 101.757 50.5046 101.457C50.8446 101.157 51.0146 100.752 51.0146 100.242C51.0146 99.8316 50.8946 99.5066 50.6546 99.2666C50.4146 99.0266 49.9896 98.8466 49.3796 98.7266L48.4496 98.5616C47.4296 98.3716 46.6646 98.0366 46.1546 97.5566C45.6446 97.0766 45.3896 96.4166 45.3896 95.5766C45.3896 95.1166 45.4746 94.7016 45.6446 94.3316C45.8246 93.9516 46.0696 93.6366 46.3796 93.3866C46.6996 93.1266 47.0846 92.9266 47.5346 92.7866C47.9846 92.6466 48.4896 92.5766 49.0496 92.5766C49.8396 92.5766 50.5246 92.7166 51.1046 92.9966C51.6846 93.2666 52.1796 93.6616 52.5896 94.1816L51.4046 95.2316C51.1346 94.8816 50.8046 94.6016 50.4146 94.3916C50.0246 94.1816 49.5396 94.0766 48.9596 94.0766C48.3596 94.0766 47.8946 94.1966 47.5646 94.4366C47.2346 94.6766 47.0696 95.0266 47.0696 95.4866C47.0696 95.9266 47.2046 96.2566 47.4746 96.4766C47.7446 96.6866 48.1646 96.8466 48.7346 96.9566L49.6646 97.1516C50.7146 97.3516 51.4796 97.6916 51.9596 98.1716C52.4496 98.6516 52.6946 99.3116 52.6946 100.152C52.6946 100.642 52.6096 101.087 52.4396 101.487C52.2696 101.887 52.0196 102.232 51.6896 102.522C51.3696 102.802 50.9746 103.022 50.5046 103.182C50.0346 103.332 49.4996 103.407 48.8996 103.407ZM59.3345 101.937H59.2745C59.2045 102.127 59.1095 102.312 58.9895 102.492C58.8795 102.672 58.7345 102.832 58.5545 102.972C58.3845 103.102 58.1745 103.207 57.9245 103.287C57.6845 103.367 57.4045 103.407 57.0845 103.407C56.2745 103.407 55.6445 103.147 55.1945 102.627C54.7545 102.107 54.5345 101.362 54.5345 100.392V95.4266H56.1695V100.182C56.1695 101.392 56.6695 101.997 57.6695 101.997C57.8795 101.997 58.0845 101.972 58.2845 101.922C58.4845 101.862 58.6595 101.777 58.8095 101.667C58.9695 101.557 59.0945 101.417 59.1845 101.247C59.2845 101.077 59.3345 100.877 59.3345 100.647V95.4266H60.9695V103.227H59.3345V101.937ZM63.3106 103.227V95.4266H64.9456V96.9266H65.0206C65.1306 96.5266 65.3606 96.1766 65.7106 95.8766C66.0606 95.5766 66.5456 95.4266 67.1656 95.4266H67.6006V97.0016H66.9556C66.3056 97.0016 65.8056 97.1066 65.4556 97.3166C65.1156 97.5266 64.9456 97.8366 64.9456 98.2466V103.227H63.3106ZM70.8796 103.227L68.2246 95.4266H69.8446L71.0296 98.9816L71.8246 101.712H71.9146L72.7096 98.9816L73.9246 95.4266H75.4846L72.7996 103.227H70.8796ZM79.8032 103.407C79.2432 103.407 78.7432 103.312 78.3032 103.122C77.8632 102.932 77.4882 102.662 77.1782 102.312C76.8682 101.952 76.6282 101.522 76.4582 101.022C76.2982 100.512 76.2182 99.9466 76.2182 99.3266C76.2182 98.7066 76.2982 98.1466 76.4582 97.6466C76.6282 97.1366 76.8682 96.7066 77.1782 96.3566C77.4882 95.9966 77.8632 95.7216 78.3032 95.5316C78.7432 95.3416 79.2432 95.2466 79.8032 95.2466C80.3732 95.2466 80.8732 95.3466 81.3032 95.5466C81.7432 95.7466 82.1082 96.0266 82.3982 96.3866C82.6882 96.7366 82.9032 97.1466 83.0432 97.6166C83.1932 98.0866 83.2682 98.5916 83.2682 99.1316V99.7466H77.9132V100.002C77.9132 100.602 78.0882 101.097 78.4382 101.487C78.7982 101.867 79.3082 102.057 79.9682 102.057C80.4482 102.057 80.8532 101.952 81.1832 101.742C81.5132 101.532 81.7932 101.247 82.0232 100.887L82.9832 101.832C82.6932 102.312 82.2732 102.697 81.7232 102.987C81.1732 103.267 80.5332 103.407 79.8032 103.407ZM79.8032 96.5216C79.5232 96.5216 79.2632 96.5716 79.0232 96.6716C78.7932 96.7716 78.5932 96.9116 78.4232 97.0916C78.2632 97.2716 78.1382 97.4866 78.0482 97.7366C77.9582 97.9866 77.9132 98.2616 77.9132 98.5616V98.6666H81.5432V98.5166C81.5432 97.9166 81.3882 97.4366 81.0782 97.0766C80.7682 96.7066 80.3432 96.5216 79.8032 96.5216ZM89.7753 95.4266H91.3503L88.0653 104.772C87.9753 105.032 87.8703 105.252 87.7503 105.432C87.6403 105.622 87.5053 105.772 87.3453 105.882C87.1953 106.002 87.0103 106.087 86.7903 106.137C86.5703 106.197 86.3103 106.227 86.0103 106.227H85.0653V104.892H86.3853L86.8353 103.572L84.0003 95.4266H85.6353L87.1953 100.017L87.6453 101.712H87.7203L88.2153 100.017L89.7753 95.4266Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M44.1297 127.353C43.5137 127.353 42.9887 127.241 42.5547 127.017C42.1277 126.793 41.7602 126.492 41.4522 126.114L42.2712 125.347C42.5302 125.662 42.8137 125.9 43.1217 126.061C43.4367 126.222 43.7937 126.303 44.1927 126.303C44.6617 126.303 45.0152 126.198 45.2532 125.988C45.4912 125.778 45.6102 125.494 45.6102 125.137C45.6102 124.85 45.5262 124.623 45.3582 124.455C45.1902 124.287 44.8927 124.161 44.4657 124.077L43.8147 123.961C43.1007 123.828 42.5652 123.594 42.2082 123.258C41.8512 122.922 41.6727 122.46 41.6727 121.872C41.6727 121.55 41.7322 121.259 41.8512 121C41.9772 120.734 42.1487 120.514 42.3657 120.339C42.5897 120.157 42.8592 120.017 43.1742 119.919C43.4892 119.821 43.8427 119.772 44.2347 119.772C44.7877 119.772 45.2672 119.87 45.6732 120.066C46.0792 120.255 46.4257 120.531 46.7127 120.895L45.8832 121.63C45.6942 121.385 45.4632 121.189 45.1902 121.042C44.9172 120.895 44.5777 120.822 44.1717 120.822C43.7517 120.822 43.4262 120.906 43.1952 121.074C42.9642 121.242 42.8487 121.487 42.8487 121.809C42.8487 122.117 42.9432 122.348 43.1322 122.502C43.3212 122.649 43.6152 122.761 44.0142 122.838L44.6652 122.974C45.4002 123.114 45.9357 123.352 46.2717 123.688C46.6147 124.024 46.7862 124.486 46.7862 125.074C46.7862 125.417 46.7267 125.729 46.6077 126.009C46.4887 126.289 46.3137 126.53 46.0827 126.733C45.8587 126.929 45.5822 127.083 45.2532 127.195C44.9242 127.3 44.5497 127.353 44.1297 127.353ZM48.7041 120.79C48.4661 120.79 48.2911 120.734 48.1791 120.622C48.0741 120.51 48.0216 120.367 48.0216 120.192V120.013C48.0216 119.838 48.0741 119.695 48.1791 119.583C48.2911 119.471 48.4661 119.415 48.7041 119.415C48.9421 119.415 49.1136 119.471 49.2186 119.583C49.3236 119.695 49.3761 119.838 49.3761 120.013V120.192C49.3761 120.367 49.3236 120.51 49.2186 120.622C49.1136 120.734 48.9421 120.79 48.7041 120.79ZM48.1266 121.767H49.2711V127.227H48.1266V121.767ZM50.9054 127.227V121.767H52.0499V122.67H52.1024C52.2214 122.376 52.3999 122.131 52.6379 121.935C52.8829 121.739 53.2154 121.641 53.6354 121.641C54.1954 121.641 54.6294 121.826 54.9374 122.197C55.2524 122.561 55.4099 123.083 55.4099 123.762V127.227H54.2654V123.909C54.2654 123.055 53.9224 122.628 53.2364 122.628C53.0894 122.628 52.9424 122.649 52.7954 122.691C52.6554 122.726 52.5294 122.782 52.4174 122.859C52.3054 122.936 52.2144 123.034 52.1444 123.153C52.0814 123.272 52.0499 123.412 52.0499 123.573V127.227H50.9054ZM59.1067 127.353C58.7147 127.353 58.3647 127.286 58.0567 127.153C57.7487 127.02 57.4897 126.831 57.2797 126.586C57.0697 126.334 56.9087 126.033 56.7967 125.683C56.6847 125.326 56.6287 124.931 56.6287 124.497C56.6287 124.063 56.6847 123.671 56.7967 123.321C56.9087 122.964 57.0697 122.663 57.2797 122.418C57.4897 122.166 57.7487 121.973 58.0567 121.84C58.3647 121.707 58.7147 121.641 59.1067 121.641C59.6527 121.641 60.1007 121.763 60.4507 122.008C60.8007 122.253 61.0562 122.579 61.2172 122.985L60.2722 123.426C60.1952 123.174 60.0587 122.974 59.8627 122.827C59.6737 122.673 59.4217 122.596 59.1067 122.596C58.6867 122.596 58.3682 122.729 58.1512 122.995C57.9412 123.254 57.8362 123.594 57.8362 124.014V124.99C57.8362 125.41 57.9412 125.753 58.1512 126.019C58.3682 126.278 58.6867 126.408 59.1067 126.408C59.4427 126.408 59.7087 126.327 59.9047 126.166C60.1077 125.998 60.2687 125.778 60.3877 125.505L61.2592 125.967C61.0772 126.415 60.8042 126.758 60.4402 126.996C60.0762 127.234 59.6317 127.353 59.1067 127.353ZM64.4293 127.353C64.0373 127.353 63.6873 127.286 63.3793 127.153C63.0713 127.02 62.8088 126.831 62.5918 126.586C62.3748 126.334 62.2068 126.033 62.0878 125.683C61.9758 125.326 61.9198 124.931 61.9198 124.497C61.9198 124.063 61.9758 123.671 62.0878 123.321C62.2068 122.964 62.3748 122.663 62.5918 122.418C62.8088 122.166 63.0713 121.973 63.3793 121.84C63.6873 121.707 64.0373 121.641 64.4293 121.641C64.8283 121.641 65.1783 121.711 65.4793 121.851C65.7873 121.991 66.0428 122.187 66.2458 122.439C66.4488 122.684 66.5993 122.971 66.6973 123.3C66.8023 123.629 66.8548 123.982 66.8548 124.36V124.791H63.1063V124.969C63.1063 125.389 63.2288 125.736 63.4738 126.009C63.7258 126.275 64.0828 126.408 64.5448 126.408C64.8808 126.408 65.1643 126.334 65.3953 126.187C65.6263 126.04 65.8223 125.841 65.9833 125.589L66.6553 126.25C66.4523 126.586 66.1583 126.856 65.7733 127.059C65.3883 127.255 64.9403 127.353 64.4293 127.353ZM64.4293 122.533C64.2333 122.533 64.0513 122.568 63.8833 122.638C63.7223 122.708 63.5823 122.806 63.4633 122.932C63.3513 123.058 63.2638 123.209 63.2008 123.384C63.1378 123.559 63.1063 123.751 63.1063 123.961V124.035H65.6473V123.93C65.6473 123.51 65.5388 123.174 65.3218 122.922C65.1048 122.663 64.8073 122.533 64.4293 122.533ZM75.4647 127.227H70.4877V126.093L72.8292 124.003C73.2002 123.667 73.4837 123.349 73.6797 123.048C73.8827 122.74 73.9842 122.418 73.9842 122.082V121.945C73.9842 121.588 73.8757 121.308 73.6587 121.105C73.4487 120.902 73.1617 120.801 72.7977 120.801C72.5947 120.801 72.4162 120.832 72.2622 120.895C72.1152 120.951 71.9857 121.032 71.8737 121.137C71.7617 121.242 71.6672 121.364 71.5902 121.504C71.5202 121.644 71.4642 121.795 71.4222 121.956L70.3827 121.557C70.4597 121.326 70.5647 121.105 70.6977 120.895C70.8307 120.678 70.9987 120.486 71.2017 120.318C71.4047 120.15 71.6427 120.017 71.9157 119.919C72.1957 119.821 72.5212 119.772 72.8922 119.772C73.2632 119.772 73.5957 119.828 73.8897 119.94C74.1837 120.045 74.4287 120.195 74.6247 120.391C74.8277 120.58 74.9817 120.808 75.0867 121.074C75.1917 121.34 75.2442 121.63 75.2442 121.945C75.2442 122.239 75.1987 122.512 75.1077 122.764C75.0167 123.016 74.8907 123.254 74.7297 123.478C74.5687 123.702 74.3797 123.916 74.1627 124.119C73.9527 124.322 73.7287 124.528 73.4907 124.738L71.7687 126.219H75.4647V127.227ZM79.2301 127.353C78.7751 127.353 78.3796 127.269 78.0436 127.101C77.7076 126.926 77.4311 126.677 77.2141 126.355C76.9971 126.033 76.8361 125.638 76.7311 125.169C76.6261 124.7 76.5736 124.164 76.5736 123.562C76.5736 122.967 76.6261 122.435 76.7311 121.966C76.8361 121.49 76.9971 121.091 77.2141 120.769C77.4311 120.447 77.7076 120.202 78.0436 120.034C78.3796 119.859 78.7751 119.772 79.2301 119.772C80.1401 119.772 80.8086 120.104 81.2356 120.769C81.6696 121.434 81.8866 122.365 81.8866 123.562C81.8866 124.759 81.6696 125.69 81.2356 126.355C80.8086 127.02 80.1401 127.353 79.2301 127.353ZM79.2301 126.345C79.4821 126.345 79.6956 126.296 79.8706 126.198C80.0526 126.093 80.1996 125.946 80.3116 125.757C80.4236 125.568 80.5041 125.344 80.5531 125.085C80.6021 124.819 80.6266 124.525 80.6266 124.203V122.922C80.6266 122.6 80.6021 122.309 80.5531 122.05C80.5041 121.784 80.4236 121.557 80.3116 121.368C80.1996 121.179 80.0526 121.035 79.8706 120.937C79.6956 120.832 79.4821 120.78 79.2301 120.78C78.9781 120.78 78.7611 120.832 78.5791 120.937C78.4041 121.035 78.2606 121.179 78.1486 121.368C78.0366 121.557 77.9561 121.784 77.9071 122.05C77.8581 122.309 77.8336 122.6 77.8336 122.922V124.203C77.8336 124.525 77.8581 124.819 77.9071 125.085C77.9561 125.344 78.0366 125.568 78.1486 125.757C78.2606 125.946 78.4041 126.093 78.5791 126.198C78.7611 126.296 78.9781 126.345 79.2301 126.345ZM88.0565 127.227H83.0795V126.093L85.421 124.003C85.792 123.667 86.0755 123.349 86.2715 123.048C86.4745 122.74 86.576 122.418 86.576 122.082V121.945C86.576 121.588 86.4675 121.308 86.2505 121.105C86.0405 120.902 85.7535 120.801 85.3895 120.801C85.1865 120.801 85.008 120.832 84.854 120.895C84.707 120.951 84.5775 121.032 84.4655 121.137C84.3535 121.242 84.259 121.364 84.182 121.504C84.112 121.644 84.056 121.795 84.014 121.956L82.9745 121.557C83.0515 121.326 83.1565 121.105 83.2895 120.895C83.4225 120.678 83.5905 120.486 83.7935 120.318C83.9965 120.15 84.2345 120.017 84.5075 119.919C84.7875 119.821 85.113 119.772 85.484 119.772C85.855 119.772 86.1875 119.828 86.4815 119.94C86.7755 120.045 87.0205 120.195 87.2165 120.391C87.4195 120.58 87.5735 120.808 87.6785 121.074C87.7835 121.34 87.836 121.63 87.836 121.945C87.836 122.239 87.7905 122.512 87.6995 122.764C87.6085 123.016 87.4825 123.254 87.3215 123.478C87.1605 123.702 86.9715 123.916 86.7545 124.119C86.5445 124.322 86.3205 124.528 86.0825 124.738L84.3605 126.219H88.0565V127.227ZM91.8219 127.353C91.3669 127.353 90.9714 127.269 90.6354 127.101C90.2994 126.926 90.0229 126.677 89.8059 126.355C89.5889 126.033 89.4279 125.638 89.3229 125.169C89.2179 124.7 89.1654 124.164 89.1654 123.562C89.1654 122.967 89.2179 122.435 89.3229 121.966C89.4279 121.49 89.5889 121.091 89.8059 120.769C90.0229 120.447 90.2994 120.202 90.6354 120.034C90.9714 119.859 91.3669 119.772 91.8219 119.772C92.7319 119.772 93.4004 120.104 93.8274 120.769C94.2614 121.434 94.4784 122.365 94.4784 123.562C94.4784 124.759 94.2614 125.69 93.8274 126.355C93.4004 127.02 92.7319 127.353 91.8219 127.353ZM91.8219 126.345C92.0739 126.345 92.2874 126.296 92.4624 126.198C92.6444 126.093 92.7914 125.946 92.9034 125.757C93.0154 125.568 93.0959 125.344 93.1449 125.085C93.1939 124.819 93.2184 124.525 93.2184 124.203V122.922C93.2184 122.6 93.1939 122.309 93.1449 122.05C93.0959 121.784 93.0154 121.557 92.9034 121.368C92.7914 121.179 92.6444 121.035 92.4624 120.937C92.2874 120.832 92.0739 120.78 91.8219 120.78C91.5699 120.78 91.3529 120.832 91.1709 120.937C90.9959 121.035 90.8524 121.179 90.7404 121.368C90.6284 121.557 90.5479 121.784 90.4989 122.05C90.4499 122.309 90.4254 122.6 90.4254 122.922V124.203C90.4254 124.525 90.4499 124.819 90.4989 125.085C90.5479 125.344 90.6284 125.568 90.7404 125.757C90.8524 125.946 90.9959 126.093 91.1709 126.198C91.3529 126.296 91.5699 126.345 91.8219 126.345Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M148 9.22657C148 4.256 152.029 0.226562 157 0.226562H275C279.971 0.226562 284 4.256 284 9.22656V179.227C284 184.197 279.971 188.227 275 188.227H157C152.029 188.227 148 184.197 148 179.227V9.22657Z",
                                                                fill: "#004D69"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M148.5 9.22657C148.5 4.53215 152.306 0.726562 157 0.726562H275C279.694 0.726562 283.5 4.53214 283.5 9.22656V179.227C283.5 183.921 279.694 187.727 275 187.727H157C152.306 187.727 148.5 183.921 148.5 179.227V9.22657Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M198 24.2266C198 20.9129 200.686 18.2266 204 18.2266H228C231.314 18.2266 234 20.9129 234 24.2266V48.2266C234 51.5403 231.314 54.2266 228 54.2266H204C200.686 54.2266 198 51.5403 198 48.2266V24.2266Z",
                                                                fill: "#CCE6EF"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M198.5 24.2266C198.5 21.189 200.962 18.7266 204 18.7266H228C231.038 18.7266 233.5 21.189 233.5 24.2266V48.2266C233.5 51.2641 231.038 53.7266 228 53.7266H204C200.962 53.7266 198.5 51.2641 198.5 48.2266V24.2266Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                                clipPath: "url(#clip1_5592_7504)",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M216.75 39.0659C216.75 38.8181 216.496 38.4766 216 38.4766C214.84 38.4766 213.75 37.6188 213.75 36.3873C213.75 35.4287 214.41 34.6965 215.25 34.4191V33.9766C215.25 33.5623 215.586 33.2266 216 33.2266C216.414 33.2266 216.75 33.5623 216.75 33.9766V34.4168C217.153 34.5487 217.508 34.7852 217.774 35.1009C218.041 35.4179 218 35.891 217.683 36.1576C217.366 36.4243 216.893 36.3835 216.626 36.0665C216.5 35.9171 216.278 35.798 216 35.798C215.504 35.798 215.25 36.1395 215.25 36.3873C215.25 36.6351 215.504 36.9766 216 36.9766C217.161 36.9766 218.25 37.8344 218.25 39.0659C218.25 40.0246 217.59 40.7567 216.75 41.0341V41.4766C216.75 41.8909 216.414 42.2266 216 42.2266C215.586 42.2266 215.25 41.8909 215.25 41.4766V41.0364C214.847 40.9045 214.492 40.668 214.226 40.3523C213.959 40.0353 214 39.5622 214.317 39.2956C214.634 39.0289 215.107 39.0697 215.374 39.3867C215.5 39.5361 215.722 39.6552 216 39.6552C216.496 39.6552 216.75 39.3137 216.75 39.0659Z",
                                                                        fill: "#00668C"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        fillRule: "evenodd",
                                                                        clipRule: "evenodd",
                                                                        d: "M219.75 27.9766C220.164 27.9766 220.5 28.3123 220.5 28.7266L220.5 32.6953C221.881 33.9313 222.75 35.7274 222.75 37.7266C222.75 41.4545 219.728 44.4766 216 44.4766C212.272 44.4766 209.25 41.4545 209.25 37.7266C209.25 35.7274 210.119 33.9313 211.5 32.6953V28.7266C211.5 28.3123 211.836 27.9766 212.25 27.9766C212.664 27.9766 213 28.3123 213 28.7266V31.6782C213.691 31.3347 214.449 31.1063 215.25 31.0178V28.7266C215.25 28.3123 215.586 27.9766 216 27.9766C216.414 27.9766 216.75 28.3123 216.75 28.7266V31.0178C217.551 31.1063 218.309 31.3347 219 31.6782L219 28.7266C219 28.3123 219.336 27.9766 219.75 27.9766ZM216 32.4766C213.101 32.4766 210.75 34.8271 210.75 37.7266C210.75 40.6261 213.101 42.9766 216 42.9766C218.899 42.9766 221.25 40.6261 221.25 37.7266C221.25 34.8271 218.899 32.4766 216 32.4766Z",
                                                                        fill: "#00668C"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M177.658 78.8366C177.288 78.8366 176.958 78.7916 176.668 78.7016C176.388 78.6016 176.078 78.4666 175.738 78.2966C175.458 78.1566 175.183 78.0366 174.913 77.9366C174.653 77.8366 174.368 77.7866 174.058 77.7866C173.828 77.7866 173.623 77.8216 173.443 77.8916C173.273 77.9616 173.073 78.0766 172.843 78.2366L172.258 77.3216C172.448 77.0616 172.688 76.8516 172.978 76.6916C173.268 76.5316 173.648 76.4516 174.118 76.4516C174.488 76.4516 174.813 76.5016 175.093 76.6016C175.383 76.6916 175.698 76.8216 176.038 76.9916C176.318 77.1316 176.588 77.2516 176.848 77.3516C177.118 77.4516 177.408 77.5016 177.718 77.5016C177.948 77.5016 178.148 77.4666 178.318 77.3966C178.498 77.3266 178.703 77.2116 178.933 77.0516L179.518 77.9666C179.328 78.2266 179.088 78.4366 178.798 78.5966C178.508 78.7566 178.128 78.8366 177.658 78.8366ZM184.297 83.4566V82.1666C183.537 82.1066 182.897 81.9216 182.377 81.6116C181.857 81.3016 181.407 80.9216 181.027 80.4716L182.122 79.4816C182.432 79.8616 182.767 80.1666 183.127 80.3966C183.497 80.6266 183.922 80.7716 184.402 80.8316V77.4716C183.322 77.2416 182.542 76.8966 182.062 76.4366C181.582 75.9666 181.342 75.3516 181.342 74.5916C181.342 73.7916 181.607 73.1566 182.137 72.6866C182.667 72.2166 183.387 71.9316 184.297 71.8316V70.5266H185.572V71.8316C186.212 71.8916 186.767 72.0516 187.237 72.3116C187.717 72.5716 188.132 72.9266 188.482 73.3766L187.372 74.2916C187.152 74.0016 186.887 73.7616 186.577 73.5716C186.277 73.3716 185.912 73.2366 185.482 73.1666V76.2416C186.072 76.3716 186.562 76.5266 186.952 76.7066C187.342 76.8866 187.657 77.0916 187.897 77.3216C188.147 77.5416 188.327 77.8016 188.437 78.1016C188.547 78.3916 188.602 78.7316 188.602 79.1216C188.602 79.9316 188.337 80.6066 187.807 81.1466C187.287 81.6866 186.542 82.0166 185.572 82.1366V83.4566H184.297ZM187.027 79.2266C187.027 78.8466 186.917 78.5366 186.697 78.2966C186.477 78.0466 186.072 77.8466 185.482 77.6966V80.8166C185.972 80.7366 186.352 80.5566 186.622 80.2766C186.892 79.9966 187.027 79.6466 187.027 79.2266ZM182.902 74.5166C182.902 74.9366 183.022 75.2566 183.262 75.4766C183.512 75.6866 183.892 75.8616 184.402 76.0016V73.1516C183.922 73.2216 183.552 73.3716 183.292 73.6016C183.032 73.8316 182.902 74.1366 182.902 74.5166ZM193.892 82.4066C193.312 82.4066 192.792 82.3116 192.332 82.1216C191.882 81.9316 191.497 81.6616 191.177 81.3116C190.867 80.9516 190.627 80.5216 190.457 80.0216C190.287 79.5216 190.202 78.9566 190.202 78.3266C190.202 77.5666 190.317 76.8516 190.547 76.1816C190.777 75.5116 191.072 74.8966 191.432 74.3366C191.792 73.7766 192.192 73.2816 192.632 72.8516C193.082 72.4116 193.522 72.0466 193.952 71.7566H196.202C195.612 72.1866 195.082 72.6016 194.612 73.0016C194.142 73.4016 193.732 73.8116 193.382 74.2316C193.032 74.6516 192.737 75.0966 192.497 75.5666C192.267 76.0366 192.087 76.5516 191.957 77.1116L192.062 77.1416C192.172 76.9316 192.297 76.7366 192.437 76.5566C192.587 76.3666 192.757 76.2016 192.947 76.0616C193.147 75.9216 193.372 75.8116 193.622 75.7316C193.872 75.6516 194.162 75.6116 194.492 75.6116C194.932 75.6116 195.337 75.6866 195.707 75.8366C196.087 75.9866 196.412 76.2066 196.682 76.4966C196.962 76.7766 197.177 77.1166 197.327 77.5166C197.487 77.9166 197.567 78.3616 197.567 78.8516C197.567 79.3816 197.477 79.8666 197.297 80.3066C197.127 80.7366 196.882 81.1066 196.562 81.4166C196.242 81.7266 195.852 81.9716 195.392 82.1516C194.942 82.3216 194.442 82.4066 193.892 82.4066ZM193.892 81.0266C194.502 81.0266 194.977 80.8666 195.317 80.5466C195.657 80.2166 195.827 79.7366 195.827 79.1066V78.8966C195.827 78.2666 195.657 77.7916 195.317 77.4716C194.977 77.1416 194.502 76.9766 193.892 76.9766C193.282 76.9766 192.807 77.1416 192.467 77.4716C192.127 77.7916 191.957 78.2666 191.957 78.8966V79.1066C191.957 79.7366 192.127 80.2166 192.467 80.5466C192.807 80.8666 193.282 81.0266 193.892 81.0266ZM206.516 75.6566C206.516 76.4166 206.401 77.1316 206.171 77.8016C205.941 78.4716 205.646 79.0866 205.286 79.6466C204.926 80.2066 204.521 80.7066 204.071 81.1466C203.631 81.5866 203.196 81.9466 202.766 82.2266H200.516C201.106 81.7966 201.636 81.3816 202.106 80.9816C202.576 80.5816 202.986 80.1716 203.336 79.7516C203.686 79.3316 203.976 78.8866 204.206 78.4166C204.446 77.9466 204.631 77.4316 204.761 76.8716L204.656 76.8416C204.546 77.0516 204.416 77.2516 204.266 77.4416C204.126 77.6216 203.956 77.7816 203.756 77.9216C203.566 78.0616 203.346 78.1716 203.096 78.2516C202.846 78.3316 202.556 78.3716 202.226 78.3716C201.786 78.3716 201.376 78.2966 200.996 78.1466C200.626 77.9966 200.301 77.7816 200.021 77.5016C199.751 77.2116 199.536 76.8716 199.376 76.4816C199.226 76.0816 199.151 75.6316 199.151 75.1316C199.151 74.6116 199.236 74.1316 199.406 73.6916C199.586 73.2516 199.836 72.8766 200.156 72.5666C200.476 72.2566 200.861 72.0166 201.311 71.8466C201.761 71.6666 202.266 71.5766 202.826 71.5766C203.406 71.5766 203.921 71.6716 204.371 71.8616C204.831 72.0516 205.216 72.3266 205.526 72.6866C205.846 73.0366 206.091 73.4616 206.261 73.9616C206.431 74.4616 206.516 75.0266 206.516 75.6566ZM202.826 77.0066C203.436 77.0066 203.911 76.8466 204.251 76.5266C204.591 76.1966 204.761 75.7166 204.761 75.0866V74.8766C204.761 74.2466 204.591 73.7716 204.251 73.4516C203.911 73.1216 203.436 72.9566 202.826 72.9566C202.216 72.9566 201.741 73.1216 201.401 73.4516C201.061 73.7716 200.891 74.2466 200.891 74.8766V75.0866C200.891 75.7166 201.061 76.1966 201.401 76.5266C201.741 76.8466 202.216 77.0066 202.826 77.0066ZM208.64 71.7566H213.275C214.145 71.7566 214.825 72.0016 215.315 72.4916C215.815 72.9816 216.065 73.6366 216.065 74.4566C216.065 74.8466 216.01 75.1816 215.9 75.4616C215.79 75.7316 215.65 75.9566 215.48 76.1366C215.31 76.3066 215.115 76.4366 214.895 76.5266C214.675 76.6066 214.46 76.6566 214.25 76.6766V76.7666C214.46 76.7766 214.69 76.8266 214.94 76.9166C215.2 77.0066 215.44 77.1516 215.66 77.3516C215.88 77.5416 216.065 77.7916 216.215 78.1016C216.365 78.4016 216.44 78.7716 216.44 79.2116C216.44 79.6316 216.37 80.0266 216.23 80.3966C216.1 80.7666 215.915 81.0866 215.675 81.3566C215.435 81.6266 215.15 81.8416 214.82 82.0016C214.49 82.1516 214.13 82.2266 213.74 82.2266H208.64V71.7566ZM210.335 80.7716H213.245C213.685 80.7716 214.03 80.6566 214.28 80.4266C214.53 80.1966 214.655 79.8666 214.655 79.4366V78.9266C214.655 78.4966 214.53 78.1666 214.28 77.9366C214.03 77.7066 213.685 77.5916 213.245 77.5916H210.335V80.7716ZM210.335 76.1816H212.96C213.38 76.1816 213.705 76.0766 213.935 75.8666C214.165 75.6466 214.28 75.3366 214.28 74.9366V74.4566C214.28 74.0566 214.165 73.7516 213.935 73.5416C213.705 73.3216 213.38 73.2116 212.96 73.2116H210.335V76.1816ZM226.003 82.4066C224.633 82.4066 223.558 81.9466 222.778 81.0266C221.998 80.0966 221.608 78.7516 221.608 76.9916C221.608 76.1116 221.708 75.3366 221.908 74.6666C222.108 73.9966 222.398 73.4316 222.778 72.9716C223.158 72.5116 223.618 72.1666 224.158 71.9366C224.708 71.6966 225.323 71.5766 226.003 71.5766C226.913 71.5766 227.673 71.7766 228.283 72.1766C228.903 72.5766 229.388 73.1666 229.738 73.9466L228.313 74.7266C228.133 74.2266 227.853 73.8316 227.473 73.5416C227.103 73.2416 226.613 73.0916 226.003 73.0916C225.193 73.0916 224.558 73.3666 224.098 73.9166C223.638 74.4666 223.408 75.2266 223.408 76.1966V77.7866C223.408 78.7566 223.638 79.5166 224.098 80.0666C224.558 80.6166 225.193 80.8916 226.003 80.8916C226.633 80.8916 227.143 80.7316 227.533 80.4116C227.933 80.0816 228.228 79.6616 228.418 79.1516L229.783 79.9766C229.433 80.7366 228.943 81.3316 228.313 81.7616C227.683 82.1916 226.913 82.4066 226.003 82.4066ZM233.125 82.2266C232.565 82.2266 232.145 82.0866 231.865 81.8066C231.595 81.5166 231.46 81.1166 231.46 80.6066V71.1266H233.095V80.8916H234.175V82.2266H233.125ZM238.797 82.4066C238.257 82.4066 237.762 82.3116 237.312 82.1216C236.872 81.9316 236.497 81.6616 236.187 81.3116C235.877 80.9516 235.637 80.5216 235.467 80.0216C235.297 79.5116 235.212 78.9466 235.212 78.3266C235.212 77.7066 235.297 77.1466 235.467 76.6466C235.637 76.1366 235.877 75.7066 236.187 75.3566C236.497 74.9966 236.872 74.7216 237.312 74.5316C237.762 74.3416 238.257 74.2466 238.797 74.2466C239.337 74.2466 239.827 74.3416 240.267 74.5316C240.717 74.7216 241.097 74.9966 241.407 75.3566C241.717 75.7066 241.957 76.1366 242.127 76.6466C242.297 77.1466 242.382 77.7066 242.382 78.3266C242.382 78.9466 242.297 79.5116 242.127 80.0216C241.957 80.5216 241.717 80.9516 241.407 81.3116C241.097 81.6616 240.717 81.9316 240.267 82.1216C239.827 82.3116 239.337 82.4066 238.797 82.4066ZM238.797 81.0566C239.357 81.0566 239.807 80.8866 240.147 80.5466C240.487 80.1966 240.657 79.6766 240.657 78.9866V77.6666C240.657 76.9766 240.487 76.4616 240.147 76.1216C239.807 75.7716 239.357 75.5966 238.797 75.5966C238.237 75.5966 237.787 75.7716 237.447 76.1216C237.107 76.4616 236.937 76.9766 236.937 77.6666V78.9866C236.937 79.6766 237.107 80.1966 237.447 80.5466C237.787 80.8866 238.237 81.0566 238.797 81.0566ZM248.929 80.9366H248.869C248.799 81.1266 248.704 81.3116 248.584 81.4916C248.474 81.6716 248.329 81.8316 248.149 81.9716C247.979 82.1016 247.769 82.2066 247.519 82.2866C247.279 82.3666 246.999 82.4066 246.679 82.4066C245.869 82.4066 245.239 82.1466 244.789 81.6266C244.349 81.1066 244.129 80.3616 244.129 79.3916V74.4266H245.764V79.1816C245.764 80.3916 246.264 80.9966 247.264 80.9966C247.474 80.9966 247.679 80.9716 247.879 80.9216C248.079 80.8616 248.254 80.7766 248.404 80.6666C248.564 80.5566 248.689 80.4166 248.779 80.2466C248.879 80.0766 248.929 79.8766 248.929 79.6466V74.4266H250.564V82.2266H248.929V80.9366ZM257.81 80.9366H257.735C257.565 81.3966 257.285 81.7566 256.895 82.0166C256.515 82.2766 256.065 82.4066 255.545 82.4066C254.555 82.4066 253.79 82.0516 253.25 81.3416C252.71 80.6216 252.44 79.6166 252.44 78.3266C252.44 77.0366 252.71 76.0366 253.25 75.3266C253.79 74.6066 254.555 74.2466 255.545 74.2466C256.065 74.2466 256.515 74.3766 256.895 74.6366C257.285 74.8866 257.565 75.2466 257.735 75.7166H257.81V71.1266H259.445V82.2266H257.81V80.9366ZM256.04 80.9966C256.54 80.9966 256.96 80.8766 257.3 80.6366C257.64 80.3866 257.81 80.0616 257.81 79.6616V76.9916C257.81 76.5916 257.64 76.2716 257.3 76.0316C256.96 75.7816 256.54 75.6566 256.04 75.6566C255.47 75.6566 255.015 75.8416 254.675 76.2116C254.335 76.5716 254.165 77.0516 254.165 77.6516V79.0016C254.165 79.6016 254.335 80.0866 254.675 80.4566C255.015 80.8166 255.47 80.9966 256.04 80.9966ZM198.548 103.407C197.668 103.407 196.918 103.247 196.298 102.927C195.688 102.607 195.163 102.177 194.723 101.637L195.893 100.542C196.263 100.992 196.668 101.332 197.108 101.562C197.558 101.792 198.068 101.907 198.638 101.907C199.308 101.907 199.813 101.757 200.153 101.457C200.493 101.157 200.663 100.752 200.663 100.242C200.663 99.8316 200.543 99.5066 200.303 99.2666C200.063 99.0266 199.638 98.8466 199.028 98.7266L198.098 98.5616C197.078 98.3716 196.313 98.0366 195.803 97.5566C195.293 97.0766 195.038 96.4166 195.038 95.5766C195.038 95.1166 195.123 94.7016 195.293 94.3316C195.473 93.9516 195.718 93.6366 196.028 93.3866C196.348 93.1266 196.733 92.9266 197.183 92.7866C197.633 92.6466 198.138 92.5766 198.698 92.5766C199.488 92.5766 200.173 92.7166 200.753 92.9966C201.333 93.2666 201.828 93.6616 202.238 94.1816L201.053 95.2316C200.783 94.8816 200.453 94.6016 200.063 94.3916C199.673 94.1816 199.188 94.0766 198.608 94.0766C198.008 94.0766 197.543 94.1966 197.213 94.4366C196.883 94.6766 196.718 95.0266 196.718 95.4866C196.718 95.9266 196.853 96.2566 197.123 96.4766C197.393 96.6866 197.813 96.8466 198.383 96.9566L199.313 97.1516C200.363 97.3516 201.128 97.6916 201.608 98.1716C202.098 98.6516 202.343 99.3116 202.343 100.152C202.343 100.642 202.258 101.087 202.088 101.487C201.918 101.887 201.668 102.232 201.338 102.522C201.018 102.802 200.623 103.022 200.153 103.182C199.683 103.332 199.148 103.407 198.548 103.407ZM204.257 95.4266H205.892V96.7166H205.967C206.137 96.2466 206.412 95.8866 206.792 95.6366C207.182 95.3766 207.637 95.2466 208.157 95.2466C209.147 95.2466 209.912 95.6066 210.452 96.3266C210.992 97.0366 211.262 98.0366 211.262 99.3266C211.262 100.617 210.992 101.622 210.452 102.342C209.912 103.052 209.147 103.407 208.157 103.407C207.637 103.407 207.182 103.277 206.792 103.017C206.412 102.757 206.137 102.397 205.967 101.937H205.892V106.227H204.257V95.4266ZM207.662 101.997C208.232 101.997 208.687 101.817 209.027 101.457C209.367 101.087 209.537 100.602 209.537 100.002V98.6516C209.537 98.0516 209.367 97.5716 209.027 97.2116C208.687 96.8416 208.232 96.6566 207.662 96.6566C207.162 96.6566 206.742 96.7816 206.402 97.0316C206.062 97.2716 205.892 97.5916 205.892 97.9916V100.662C205.892 101.062 206.062 101.387 206.402 101.637C206.742 101.877 207.162 101.997 207.662 101.997ZM216.194 103.407C215.634 103.407 215.134 103.312 214.694 103.122C214.254 102.932 213.879 102.662 213.569 102.312C213.259 101.952 213.019 101.522 212.849 101.022C212.689 100.512 212.609 99.9466 212.609 99.3266C212.609 98.7066 212.689 98.1466 212.849 97.6466C213.019 97.1366 213.259 96.7066 213.569 96.3566C213.879 95.9966 214.254 95.7216 214.694 95.5316C215.134 95.3416 215.634 95.2466 216.194 95.2466C216.764 95.2466 217.264 95.3466 217.694 95.5466C218.134 95.7466 218.499 96.0266 218.789 96.3866C219.079 96.7366 219.294 97.1466 219.434 97.6166C219.584 98.0866 219.659 98.5916 219.659 99.1316V99.7466H214.304V100.002C214.304 100.602 214.479 101.097 214.829 101.487C215.189 101.867 215.699 102.057 216.359 102.057C216.839 102.057 217.244 101.952 217.574 101.742C217.904 101.532 218.184 101.247 218.414 100.887L219.374 101.832C219.084 102.312 218.664 102.697 218.114 102.987C217.564 103.267 216.924 103.407 216.194 103.407ZM216.194 96.5216C215.914 96.5216 215.654 96.5716 215.414 96.6716C215.184 96.7716 214.984 96.9116 214.814 97.0916C214.654 97.2716 214.529 97.4866 214.439 97.7366C214.349 97.9866 214.304 98.2616 214.304 98.5616V98.6666H217.934V98.5166C217.934 97.9166 217.779 97.4366 217.469 97.0766C217.159 96.7066 216.734 96.5216 216.194 96.5216ZM221.469 103.227V95.4266H223.104V96.7166H223.179C223.349 96.2966 223.604 95.9466 223.944 95.6666C224.294 95.3866 224.769 95.2466 225.369 95.2466C226.169 95.2466 226.789 95.5116 227.229 96.0416C227.679 96.5616 227.904 97.3066 227.904 98.2766V103.227H226.269V98.4866C226.269 97.2666 225.779 96.6566 224.799 96.6566C224.589 96.6566 224.379 96.6866 224.169 96.7466C223.969 96.7966 223.789 96.8766 223.629 96.9866C223.469 97.0966 223.339 97.2366 223.239 97.4066C223.149 97.5766 223.104 97.7766 223.104 98.0066V103.227H221.469ZM235.075 101.937H235C234.83 102.397 234.55 102.757 234.16 103.017C233.78 103.277 233.33 103.407 232.81 103.407C231.82 103.407 231.055 103.052 230.515 102.342C229.975 101.622 229.705 100.617 229.705 99.3266C229.705 98.0366 229.975 97.0366 230.515 96.3266C231.055 95.6066 231.82 95.2466 232.81 95.2466C233.33 95.2466 233.78 95.3766 234.16 95.6366C234.55 95.8866 234.83 96.2466 235 96.7166H235.075V92.1266H236.71V103.227H235.075V101.937ZM233.305 101.997C233.805 101.997 234.225 101.877 234.565 101.637C234.905 101.387 235.075 101.062 235.075 100.662V97.9916C235.075 97.5916 234.905 97.2716 234.565 97.0316C234.225 96.7816 233.805 96.6566 233.305 96.6566C232.735 96.6566 232.28 96.8416 231.94 97.2116C231.6 97.5716 231.43 98.0516 231.43 98.6516V100.002C231.43 100.602 231.6 101.087 231.94 101.457C232.28 101.817 232.735 101.997 233.305 101.997Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M184.328 126.481C184.237 126.572 184.125 126.67 183.992 126.775C183.866 126.873 183.716 126.968 183.541 127.059C183.373 127.143 183.177 127.213 182.953 127.269C182.736 127.325 182.487 127.353 182.207 127.353C181.829 127.353 181.493 127.3 181.199 127.195C180.905 127.09 180.657 126.947 180.454 126.765C180.258 126.583 180.107 126.369 180.002 126.124C179.904 125.872 179.855 125.603 179.855 125.316C179.855 125.057 179.894 124.826 179.971 124.623C180.055 124.413 180.163 124.227 180.296 124.066C180.436 123.898 180.594 123.751 180.769 123.625C180.951 123.492 181.143 123.37 181.346 123.258C181.115 123.013 180.919 122.747 180.758 122.46C180.597 122.173 180.517 121.865 180.517 121.536C180.517 121.291 180.562 121.06 180.653 120.843C180.751 120.626 180.888 120.44 181.063 120.286C181.238 120.125 181.448 119.999 181.693 119.908C181.945 119.817 182.221 119.772 182.522 119.772C182.802 119.772 183.061 119.81 183.299 119.887C183.537 119.964 183.744 120.073 183.919 120.213C184.094 120.353 184.227 120.524 184.318 120.727C184.416 120.923 184.465 121.144 184.465 121.389C184.465 121.627 184.423 121.844 184.339 122.04C184.255 122.229 184.139 122.404 183.992 122.565C183.845 122.719 183.674 122.866 183.478 123.006C183.289 123.139 183.086 123.268 182.869 123.394L184.297 124.938C184.395 124.686 184.472 124.42 184.528 124.14C184.584 123.86 184.619 123.576 184.633 123.289H186.197V124.255H185.483C185.378 124.787 185.217 125.26 185 125.673L186.439 127.227H185.011L184.328 126.481ZM182.522 120.685C182.27 120.685 182.057 120.762 181.882 120.916C181.707 121.063 181.619 121.259 181.619 121.504V121.588C181.619 121.77 181.675 121.952 181.787 122.134C181.906 122.316 182.074 122.526 182.291 122.764C182.585 122.603 182.837 122.425 183.047 122.229C183.257 122.026 183.362 121.795 183.362 121.536V121.452C183.362 121.207 183.285 121.018 183.131 120.885C182.977 120.752 182.774 120.685 182.522 120.685ZM182.344 126.376C182.638 126.376 182.897 126.327 183.121 126.229C183.345 126.131 183.541 125.995 183.709 125.82L181.924 123.898C181.658 124.045 181.441 124.21 181.273 124.392C181.112 124.574 181.031 124.822 181.031 125.137V125.274C181.031 125.61 181.147 125.879 181.378 126.082C181.609 126.278 181.931 126.376 182.344 126.376ZM191.839 128.088V127.185C191.307 127.143 190.859 127.013 190.495 126.796C190.131 126.579 189.816 126.313 189.55 125.998L190.317 125.305C190.534 125.571 190.768 125.785 191.02 125.946C191.279 126.107 191.577 126.208 191.913 126.25V123.898C191.157 123.737 190.611 123.496 190.275 123.174C189.939 122.845 189.771 122.414 189.771 121.882C189.771 121.322 189.956 120.878 190.327 120.549C190.698 120.22 191.202 120.02 191.839 119.95V119.037H192.732V119.95C193.18 119.992 193.568 120.104 193.897 120.286C194.233 120.468 194.524 120.717 194.769 121.032L193.992 121.672C193.838 121.469 193.652 121.301 193.435 121.168C193.225 121.028 192.97 120.934 192.669 120.885V123.037C193.082 123.128 193.425 123.237 193.698 123.363C193.971 123.489 194.191 123.632 194.359 123.793C194.534 123.947 194.66 124.129 194.737 124.339C194.814 124.542 194.853 124.78 194.853 125.053C194.853 125.62 194.667 126.093 194.296 126.471C193.932 126.849 193.411 127.08 192.732 127.164V128.088H191.839ZM193.75 125.127C193.75 124.861 193.673 124.644 193.519 124.476C193.365 124.301 193.082 124.161 192.669 124.056V126.24C193.012 126.184 193.278 126.058 193.467 125.862C193.656 125.666 193.75 125.421 193.75 125.127ZM190.863 121.83C190.863 122.124 190.947 122.348 191.115 122.502C191.29 122.649 191.556 122.771 191.913 122.869V120.874C191.577 120.923 191.318 121.028 191.136 121.189C190.954 121.35 190.863 121.564 190.863 121.83ZM198.136 122.911C198.591 122.911 198.927 122.817 199.144 122.628C199.361 122.432 199.469 122.183 199.469 121.882V121.809C199.469 121.473 199.364 121.217 199.154 121.042C198.944 120.86 198.661 120.769 198.304 120.769C197.954 120.769 197.656 120.85 197.411 121.011C197.166 121.165 196.96 121.382 196.792 121.662L196.004 120.979C196.116 120.818 196.242 120.664 196.382 120.517C196.522 120.37 196.687 120.244 196.876 120.139C197.065 120.027 197.278 119.94 197.516 119.877C197.754 119.807 198.027 119.772 198.335 119.772C198.678 119.772 198.997 119.814 199.291 119.898C199.585 119.982 199.837 120.108 200.047 120.276C200.257 120.437 200.421 120.636 200.54 120.874C200.659 121.105 200.719 121.368 200.719 121.662C200.719 121.893 200.68 122.103 200.603 122.292C200.533 122.481 200.432 122.649 200.299 122.796C200.173 122.936 200.022 123.051 199.847 123.142C199.679 123.233 199.501 123.3 199.312 123.342V123.394C199.522 123.436 199.718 123.506 199.9 123.604C200.089 123.695 200.253 123.818 200.393 123.972C200.533 124.119 200.642 124.297 200.719 124.507C200.803 124.71 200.845 124.945 200.845 125.211C200.845 125.533 200.782 125.827 200.656 126.093C200.53 126.352 200.351 126.576 200.12 126.765C199.896 126.954 199.623 127.101 199.301 127.206C198.979 127.304 198.622 127.353 198.23 127.353C197.887 127.353 197.586 127.314 197.327 127.237C197.068 127.167 196.837 127.073 196.634 126.954C196.438 126.828 196.263 126.688 196.109 126.534C195.962 126.373 195.833 126.208 195.721 126.04L196.592 125.358C196.683 125.505 196.778 125.641 196.876 125.767C196.981 125.886 197.096 125.991 197.222 126.082C197.355 126.166 197.502 126.233 197.663 126.282C197.831 126.331 198.02 126.355 198.23 126.355C198.678 126.355 199.021 126.25 199.259 126.04C199.497 125.823 199.616 125.526 199.616 125.148V125.074C199.616 124.696 199.49 124.409 199.238 124.213C198.986 124.017 198.629 123.919 198.167 123.919H197.39V122.911H198.136ZM207.361 127.227H202.384V126.093L204.725 124.003C205.096 123.667 205.38 123.349 205.576 123.048C205.779 122.74 205.88 122.418 205.88 122.082V121.945C205.88 121.588 205.772 121.308 205.555 121.105C205.345 120.902 205.058 120.801 204.694 120.801C204.491 120.801 204.312 120.832 204.158 120.895C204.011 120.951 203.882 121.032 203.77 121.137C203.658 121.242 203.563 121.364 203.486 121.504C203.416 121.644 203.36 121.795 203.318 121.956L202.279 121.557C202.356 121.326 202.461 121.105 202.594 120.895C202.727 120.678 202.895 120.486 203.098 120.318C203.301 120.15 203.539 120.017 203.812 119.919C204.092 119.821 204.417 119.772 204.788 119.772C205.159 119.772 205.492 119.828 205.786 119.94C206.08 120.045 206.325 120.195 206.521 120.391C206.724 120.58 206.878 120.808 206.983 121.074C207.088 121.34 207.14 121.63 207.14 121.945C207.14 122.239 207.095 122.512 207.004 122.764C206.913 123.016 206.787 123.254 206.626 123.478C206.465 123.702 206.276 123.916 206.059 124.119C205.849 124.322 205.625 124.528 205.387 124.738L203.665 126.219H207.361V127.227ZM208.879 119.898H212.124C212.733 119.898 213.209 120.069 213.552 120.412C213.902 120.755 214.077 121.214 214.077 121.788C214.077 122.061 214.038 122.295 213.961 122.491C213.884 122.68 213.786 122.838 213.667 122.964C213.548 123.083 213.412 123.174 213.258 123.237C213.104 123.293 212.953 123.328 212.806 123.342V123.405C212.953 123.412 213.114 123.447 213.289 123.51C213.471 123.573 213.639 123.674 213.793 123.814C213.947 123.947 214.077 124.122 214.182 124.339C214.287 124.549 214.339 124.808 214.339 125.116C214.339 125.41 214.29 125.687 214.192 125.946C214.101 126.205 213.972 126.429 213.804 126.618C213.636 126.807 213.436 126.957 213.205 127.069C212.974 127.174 212.722 127.227 212.449 127.227H208.879V119.898ZM210.066 126.208H212.103C212.411 126.208 212.652 126.128 212.827 125.967C213.002 125.806 213.09 125.575 213.09 125.274V124.917C213.09 124.616 213.002 124.385 212.827 124.224C212.652 124.063 212.411 123.982 212.103 123.982H210.066V126.208ZM210.066 122.995H211.903C212.197 122.995 212.425 122.922 212.586 122.775C212.747 122.621 212.827 122.404 212.827 122.124V121.788C212.827 121.508 212.747 121.294 212.586 121.147C212.425 120.993 212.197 120.916 211.903 120.916H210.066V122.995ZM218.776 120.79C218.538 120.79 218.363 120.734 218.251 120.622C218.146 120.51 218.093 120.367 218.093 120.192V120.013C218.093 119.838 218.146 119.695 218.251 119.583C218.363 119.471 218.538 119.415 218.776 119.415C219.014 119.415 219.185 119.471 219.29 119.583C219.395 119.695 219.448 119.838 219.448 120.013V120.192C219.448 120.367 219.395 120.51 219.29 120.622C219.185 120.734 219.014 120.79 218.776 120.79ZM218.198 121.767H219.343V127.227H218.198V121.767ZM220.977 127.227V121.767H222.121V122.67H222.174C222.293 122.376 222.471 122.131 222.709 121.935C222.954 121.739 223.287 121.641 223.707 121.641C224.267 121.641 224.701 121.826 225.009 122.197C225.324 122.561 225.481 123.083 225.481 123.762V127.227H224.337V123.909C224.337 123.055 223.994 122.628 223.308 122.628C223.161 122.628 223.014 122.649 222.867 122.691C222.727 122.726 222.601 122.782 222.489 122.859C222.377 122.936 222.286 123.034 222.216 123.153C222.153 123.272 222.121 123.412 222.121 123.573V127.227H220.977ZM231.828 127.353C231.212 127.353 230.687 127.241 230.253 127.017C229.826 126.793 229.458 126.492 229.15 126.114L229.969 125.347C230.228 125.662 230.512 125.9 230.82 126.061C231.135 126.222 231.492 126.303 231.891 126.303C232.36 126.303 232.713 126.198 232.951 125.988C233.189 125.778 233.308 125.494 233.308 125.137C233.308 124.85 233.224 124.623 233.056 124.455C232.888 124.287 232.591 124.161 232.164 124.077L231.513 123.961C230.799 123.828 230.263 123.594 229.906 123.258C229.549 122.922 229.371 122.46 229.371 121.872C229.371 121.55 229.43 121.259 229.549 121C229.675 120.734 229.847 120.514 230.064 120.339C230.288 120.157 230.557 120.017 230.872 119.919C231.187 119.821 231.541 119.772 231.933 119.772C232.486 119.772 232.965 119.87 233.371 120.066C233.777 120.255 234.124 120.531 234.411 120.895L233.581 121.63C233.392 121.385 233.161 121.189 232.888 121.042C232.615 120.895 232.276 120.822 231.87 120.822C231.45 120.822 231.124 120.906 230.893 121.074C230.662 121.242 230.547 121.487 230.547 121.809C230.547 122.117 230.641 122.348 230.83 122.502C231.019 122.649 231.313 122.761 231.712 122.838L232.363 122.974C233.098 123.114 233.634 123.352 233.97 123.688C234.313 124.024 234.484 124.486 234.484 125.074C234.484 125.417 234.425 125.729 234.306 126.009C234.187 126.289 234.012 126.53 233.781 126.733C233.557 126.929 233.28 127.083 232.951 127.195C232.622 127.3 232.248 127.353 231.828 127.353ZM239.825 127.227C239.524 127.227 239.293 127.143 239.132 126.975C238.971 126.8 238.873 126.579 238.838 126.313H238.786C238.681 126.656 238.488 126.915 238.208 127.09C237.928 127.265 237.589 127.353 237.19 127.353C236.623 127.353 236.185 127.206 235.877 126.912C235.576 126.618 235.426 126.222 235.426 125.725C235.426 125.179 235.622 124.77 236.014 124.497C236.413 124.224 236.994 124.087 237.757 124.087H238.744V123.625C238.744 123.289 238.653 123.03 238.471 122.848C238.289 122.666 238.005 122.575 237.62 122.575C237.298 122.575 237.036 122.645 236.833 122.785C236.63 122.925 236.458 123.104 236.318 123.321L235.636 122.701C235.818 122.393 236.073 122.141 236.402 121.945C236.731 121.742 237.162 121.641 237.694 121.641C238.401 121.641 238.943 121.805 239.321 122.134C239.699 122.463 239.888 122.936 239.888 123.552V126.292H240.466V127.227H239.825ZM237.515 126.481C237.872 126.481 238.166 126.404 238.397 126.25C238.628 126.089 238.744 125.876 238.744 125.61V124.822H237.778C236.987 124.822 236.591 125.067 236.591 125.557V125.746C236.591 125.991 236.672 126.177 236.833 126.303C237.001 126.422 237.228 126.481 237.515 126.481ZM245.588 127.227C245.287 127.227 245.056 127.143 244.895 126.975C244.734 126.8 244.636 126.579 244.601 126.313H244.548C244.443 126.656 244.251 126.915 243.971 127.09C243.691 127.265 243.351 127.353 242.952 127.353C242.385 127.353 241.948 127.206 241.64 126.912C241.339 126.618 241.188 126.222 241.188 125.725C241.188 125.179 241.384 124.77 241.776 124.497C242.175 124.224 242.756 124.087 243.519 124.087H244.506V123.625C244.506 123.289 244.415 123.03 244.233 122.848C244.051 122.666 243.768 122.575 243.383 122.575C243.061 122.575 242.798 122.645 242.595 122.785C242.392 122.925 242.221 123.104 242.081 123.321L241.398 122.701C241.58 122.393 241.836 122.141 242.165 121.945C242.494 121.742 242.924 121.641 243.456 121.641C244.163 121.641 244.706 121.805 245.084 122.134C245.462 122.463 245.651 122.936 245.651 123.552V126.292H246.228V127.227H245.588ZM243.278 126.481C243.635 126.481 243.929 126.404 244.16 126.25C244.391 126.089 244.506 125.876 244.506 125.61V124.822H243.54C242.749 124.822 242.354 125.067 242.354 125.557V125.746C242.354 125.991 242.434 126.177 242.595 126.303C242.763 126.422 242.991 126.481 243.278 126.481ZM249.629 127.353C249.013 127.353 248.488 127.241 248.054 127.017C247.627 126.793 247.259 126.492 246.951 126.114L247.77 125.347C248.029 125.662 248.313 125.9 248.621 126.061C248.936 126.222 249.293 126.303 249.692 126.303C250.161 126.303 250.514 126.198 250.752 125.988C250.99 125.778 251.109 125.494 251.109 125.137C251.109 124.85 251.025 124.623 250.857 124.455C250.689 124.287 250.392 124.161 249.965 124.077L249.314 123.961C248.6 123.828 248.064 123.594 247.707 123.258C247.35 122.922 247.172 122.46 247.172 121.872C247.172 121.55 247.231 121.259 247.35 121C247.476 120.734 247.648 120.514 247.865 120.339C248.089 120.157 248.358 120.017 248.673 119.919C248.988 119.821 249.342 119.772 249.734 119.772C250.287 119.772 250.766 119.87 251.172 120.066C251.578 120.255 251.925 120.531 252.212 120.895L251.382 121.63C251.193 121.385 250.962 121.189 250.689 121.042C250.416 120.895 250.077 120.822 249.671 120.822C249.251 120.822 248.925 120.906 248.694 121.074C248.463 121.242 248.348 121.487 248.348 121.809C248.348 122.117 248.442 122.348 248.631 122.502C248.82 122.649 249.114 122.761 249.513 122.838L250.164 122.974C250.899 123.114 251.435 123.352 251.771 123.688C252.114 124.024 252.285 124.486 252.285 125.074C252.285 125.417 252.226 125.729 252.107 126.009C251.988 126.289 251.813 126.53 251.582 126.733C251.358 126.929 251.081 127.083 250.752 127.195C250.423 127.3 250.049 127.353 249.629 127.353ZM203.781 142.353C203.263 142.353 202.829 142.262 202.479 142.08C202.129 141.898 201.824 141.646 201.565 141.324L202.3 140.652C202.503 140.897 202.727 141.089 202.972 141.229C203.224 141.362 203.515 141.429 203.844 141.429C204.18 141.429 204.428 141.366 204.589 141.24C204.757 141.107 204.841 140.925 204.841 140.694C204.841 140.519 204.782 140.372 204.663 140.253C204.551 140.127 204.351 140.046 204.064 140.011L203.56 139.948C203 139.878 202.559 139.717 202.237 139.465C201.922 139.206 201.765 138.825 201.765 138.321C201.765 138.055 201.814 137.82 201.912 137.617C202.01 137.407 202.146 137.232 202.321 137.092C202.503 136.945 202.717 136.833 202.962 136.756C203.214 136.679 203.49 136.641 203.791 136.641C204.281 136.641 204.68 136.718 204.988 136.872C205.303 137.026 205.583 137.239 205.828 137.512L205.125 138.184C204.985 138.016 204.799 137.873 204.568 137.754C204.344 137.628 204.085 137.565 203.791 137.565C203.476 137.565 203.242 137.628 203.088 137.754C202.941 137.88 202.867 138.044 202.867 138.247C202.867 138.457 202.934 138.615 203.067 138.72C203.2 138.825 203.413 138.902 203.707 138.951L204.211 139.014C204.813 139.105 205.251 139.283 205.524 139.549C205.804 139.808 205.944 140.158 205.944 140.599C205.944 140.865 205.891 141.107 205.786 141.324C205.688 141.534 205.545 141.716 205.356 141.87C205.167 142.024 204.939 142.143 204.673 142.227C204.407 142.311 204.11 142.353 203.781 142.353ZM207.237 136.767H208.381V137.67H208.434C208.553 137.341 208.745 137.089 209.011 136.914C209.284 136.732 209.603 136.641 209.967 136.641C210.66 136.641 211.195 136.893 211.573 137.397C211.951 137.894 212.14 138.594 212.14 139.497C212.14 140.4 211.951 141.103 211.573 141.607C211.195 142.104 210.66 142.353 209.967 142.353C209.603 142.353 209.284 142.262 209.011 142.08C208.745 141.898 208.553 141.646 208.434 141.324H208.381V144.327H207.237V136.767ZM209.62 141.366C210.019 141.366 210.338 141.24 210.576 140.988C210.814 140.729 210.933 140.389 210.933 139.969V139.024C210.933 138.604 210.814 138.268 210.576 138.016C210.338 137.757 210.019 137.628 209.62 137.628C209.27 137.628 208.976 137.715 208.738 137.89C208.5 138.058 208.381 138.282 208.381 138.562V140.431C208.381 140.711 208.5 140.939 208.738 141.114C208.976 141.282 209.27 141.366 209.62 141.366ZM215.593 142.353C215.201 142.353 214.851 142.286 214.543 142.153C214.235 142.02 213.972 141.831 213.755 141.586C213.538 141.334 213.37 141.033 213.251 140.683C213.139 140.326 213.083 139.931 213.083 139.497C213.083 139.063 213.139 138.671 213.251 138.321C213.37 137.964 213.538 137.663 213.755 137.418C213.972 137.166 214.235 136.973 214.543 136.84C214.851 136.707 215.201 136.641 215.593 136.641C215.992 136.641 216.342 136.711 216.643 136.851C216.951 136.991 217.206 137.187 217.409 137.439C217.612 137.684 217.763 137.971 217.861 138.3C217.966 138.629 218.018 138.982 218.018 139.36V139.791H214.27V139.969C214.27 140.389 214.392 140.736 214.637 141.009C214.889 141.275 215.246 141.408 215.708 141.408C216.044 141.408 216.328 141.334 216.559 141.187C216.79 141.04 216.986 140.841 217.147 140.589L217.819 141.25C217.616 141.586 217.322 141.856 216.937 142.059C216.552 142.255 216.104 142.353 215.593 142.353ZM215.593 137.533C215.397 137.533 215.215 137.568 215.047 137.638C214.886 137.708 214.746 137.806 214.627 137.932C214.515 138.058 214.427 138.209 214.364 138.384C214.301 138.559 214.27 138.751 214.27 138.961V139.035H216.811V138.93C216.811 138.51 216.702 138.174 216.485 137.922C216.268 137.663 215.971 137.533 215.593 137.533ZM219.285 142.227V136.767H220.43V137.67H220.482C220.601 137.376 220.78 137.131 221.018 136.935C221.263 136.739 221.595 136.641 222.015 136.641C222.575 136.641 223.009 136.826 223.317 137.197C223.632 137.561 223.79 138.083 223.79 138.762V142.227H222.645V138.909C222.645 138.055 222.302 137.628 221.616 137.628C221.469 137.628 221.322 137.649 221.175 137.691C221.035 137.726 220.909 137.782 220.797 137.859C220.685 137.936 220.594 138.034 220.524 138.153C220.461 138.272 220.43 138.412 220.43 138.573V142.227H219.285ZM228.809 141.324H228.757C228.638 141.646 228.442 141.898 228.169 142.08C227.903 142.262 227.588 142.353 227.224 142.353C226.531 142.353 225.995 142.104 225.617 141.607C225.239 141.103 225.05 140.4 225.05 139.497C225.05 138.594 225.239 137.894 225.617 137.397C225.995 136.893 226.531 136.641 227.224 136.641C227.588 136.641 227.903 136.732 228.169 136.914C228.442 137.089 228.638 137.341 228.757 137.67H228.809V134.457H229.954V142.227H228.809V141.324ZM227.57 141.366C227.92 141.366 228.214 141.282 228.452 141.114C228.69 140.939 228.809 140.711 228.809 140.431V138.562C228.809 138.282 228.69 138.058 228.452 137.89C228.214 137.715 227.92 137.628 227.57 137.628C227.171 137.628 226.853 137.757 226.615 138.016C226.377 138.268 226.258 138.604 226.258 139.024V139.969C226.258 140.389 226.377 140.729 226.615 140.988C226.853 141.24 227.171 141.366 227.57 141.366ZM169.149 153.762L168.446 152.292H168.414V157.227H166.913V149.898H168.656L170.661 153.363L171.365 154.833H171.396V149.898H172.898V157.227H171.155L169.149 153.762ZM174.406 153.426V152.187H179.299V153.426H174.406ZM174.406 155.862V154.623H179.299V155.862H174.406ZM183.149 157.353C182.715 157.353 182.326 157.3 181.983 157.195C181.647 157.083 181.364 156.933 181.133 156.744C180.902 156.555 180.723 156.331 180.597 156.072C180.478 155.813 180.419 155.529 180.419 155.221C180.419 154.752 180.548 154.371 180.807 154.077C181.066 153.776 181.416 153.566 181.857 153.447V153.363C181.5 153.23 181.206 153.027 180.975 152.754C180.751 152.481 180.639 152.131 180.639 151.704C180.639 151.424 180.692 151.165 180.797 150.927C180.909 150.689 181.07 150.486 181.28 150.318C181.497 150.143 181.759 150.01 182.067 149.919C182.382 149.821 182.743 149.772 183.149 149.772C183.555 149.772 183.912 149.821 184.22 149.919C184.535 150.01 184.797 150.143 185.007 150.318C185.224 150.486 185.385 150.689 185.49 150.927C185.602 151.165 185.658 151.424 185.658 151.704C185.658 152.131 185.543 152.481 185.312 152.754C185.088 153.027 184.797 153.23 184.44 153.363V153.447C184.881 153.566 185.231 153.776 185.49 154.077C185.749 154.371 185.879 154.752 185.879 155.221C185.879 155.529 185.816 155.813 185.69 156.072C185.571 156.331 185.396 156.555 185.165 156.744C184.934 156.933 184.647 157.083 184.304 157.195C183.968 157.3 183.583 157.353 183.149 157.353ZM183.149 156.145C183.499 156.145 183.765 156.065 183.947 155.904C184.136 155.736 184.23 155.505 184.23 155.211V155.001C184.23 154.707 184.136 154.479 183.947 154.318C183.765 154.15 183.499 154.066 183.149 154.066C182.799 154.066 182.529 154.15 182.34 154.318C182.158 154.479 182.067 154.707 182.067 155.001V155.211C182.067 155.505 182.158 155.736 182.34 155.904C182.529 156.065 182.799 156.145 183.149 156.145ZM183.149 152.911C183.485 152.911 183.74 152.834 183.915 152.68C184.09 152.519 184.178 152.302 184.178 152.029V151.861C184.178 151.588 184.09 151.375 183.915 151.221C183.74 151.06 183.485 150.979 183.149 150.979C182.813 150.979 182.557 151.06 182.382 151.221C182.207 151.375 182.12 151.588 182.12 151.861V152.029C182.12 152.302 182.207 152.519 182.382 152.68C182.557 152.834 182.813 152.911 183.149 152.911ZM189.486 157.353C189.052 157.353 188.664 157.286 188.321 157.153C187.978 157.013 187.687 156.817 187.449 156.565C187.218 156.306 187.04 155.998 186.914 155.641C186.795 155.284 186.735 154.885 186.735 154.444C186.735 153.933 186.812 153.45 186.966 152.995C187.127 152.533 187.33 152.11 187.575 151.725C187.827 151.333 188.107 150.983 188.415 150.675C188.73 150.367 189.045 150.108 189.36 149.898H191.534C191.086 150.22 190.683 150.528 190.326 150.822C189.969 151.109 189.658 151.399 189.392 151.693C189.133 151.987 188.916 152.288 188.741 152.596C188.573 152.897 188.454 153.223 188.384 153.573L188.478 153.604C188.541 153.464 188.615 153.328 188.699 153.195C188.79 153.062 188.898 152.946 189.024 152.848C189.157 152.743 189.311 152.659 189.486 152.596C189.661 152.533 189.864 152.502 190.095 152.502C190.396 152.502 190.676 152.558 190.935 152.67C191.201 152.775 191.429 152.925 191.618 153.121C191.814 153.317 191.964 153.559 192.069 153.846C192.181 154.126 192.237 154.437 192.237 154.78C192.237 155.158 192.171 155.505 192.038 155.82C191.912 156.135 191.726 156.408 191.481 156.639C191.243 156.863 190.956 157.038 190.62 157.164C190.284 157.29 189.906 157.353 189.486 157.353ZM189.486 156.124C189.836 156.124 190.109 156.03 190.305 155.841C190.501 155.645 190.599 155.368 190.599 155.011V154.822C190.599 154.465 190.501 154.192 190.305 154.003C190.109 153.807 189.836 153.709 189.486 153.709C189.136 153.709 188.863 153.807 188.667 154.003C188.471 154.192 188.373 154.465 188.373 154.822V155.011C188.373 155.368 188.471 155.645 188.667 155.841C188.863 156.03 189.136 156.124 189.486 156.124ZM193.577 157.227V155.956H195.551V151.042H195.457L193.966 152.995L192.958 152.208L194.711 149.898H197.126V155.956H198.68V157.227H193.577ZM203.772 157.227H202.176V149.898H205.652C205.988 149.898 206.292 149.954 206.565 150.066C206.838 150.178 207.069 150.339 207.258 150.549C207.454 150.752 207.605 150.997 207.71 151.284C207.815 151.571 207.867 151.889 207.867 152.239C207.867 152.736 207.755 153.17 207.531 153.541C207.314 153.912 206.982 154.182 206.534 154.35L207.972 157.227H206.198L204.917 154.539H203.772V157.227ZM205.452 153.195C205.69 153.195 205.876 153.135 206.009 153.016C206.149 152.89 206.219 152.708 206.219 152.47V152.008C206.219 151.77 206.149 151.592 206.009 151.473C205.876 151.347 205.69 151.284 205.452 151.284H203.772V153.195H205.452ZM211.313 157.353C210.893 157.353 210.519 157.286 210.19 157.153C209.861 157.013 209.581 156.821 209.35 156.576C209.126 156.324 208.954 156.019 208.835 155.662C208.723 155.305 208.667 154.906 208.667 154.465C208.667 154.031 208.723 153.639 208.835 153.289C208.947 152.932 209.112 152.628 209.329 152.376C209.553 152.124 209.826 151.931 210.148 151.798C210.47 151.658 210.837 151.588 211.25 151.588C211.705 151.588 212.094 151.665 212.416 151.819C212.745 151.973 213.011 152.18 213.214 152.439C213.424 152.698 213.574 152.999 213.665 153.342C213.763 153.678 213.812 154.031 213.812 154.402V154.864H210.274V154.948C210.274 155.312 210.372 155.603 210.568 155.82C210.764 156.03 211.072 156.135 211.492 156.135C211.814 156.135 212.076 156.072 212.279 155.946C212.482 155.813 212.671 155.655 212.846 155.473L213.623 156.439C213.378 156.726 213.056 156.95 212.657 157.111C212.265 157.272 211.817 157.353 211.313 157.353ZM211.282 152.733C210.967 152.733 210.718 152.838 210.536 153.048C210.361 153.251 210.274 153.524 210.274 153.867V153.951H212.206V153.856C212.206 153.52 212.129 153.251 211.975 153.048C211.828 152.838 211.597 152.733 211.282 152.733ZM216.779 157.353C216.247 157.353 215.799 157.269 215.435 157.101C215.071 156.926 214.745 156.681 214.458 156.366L215.372 155.442C215.568 155.659 215.785 155.83 216.023 155.956C216.261 156.082 216.53 156.145 216.831 156.145C217.139 156.145 217.353 156.1 217.472 156.009C217.591 155.911 217.65 155.781 217.65 155.62C217.65 155.361 217.465 155.207 217.094 155.158L216.495 155.085C215.256 154.931 214.637 154.364 214.637 153.384C214.637 153.118 214.686 152.876 214.784 152.659C214.889 152.435 215.032 152.246 215.214 152.092C215.403 151.931 215.627 151.809 215.886 151.725C216.152 151.634 216.45 151.588 216.779 151.588C217.066 151.588 217.318 151.609 217.535 151.651C217.759 151.686 217.955 151.742 218.123 151.819C218.298 151.889 218.455 151.98 218.595 152.092C218.742 152.197 218.886 152.316 219.026 152.449L218.133 153.363C217.958 153.188 217.759 153.051 217.535 152.953C217.318 152.848 217.094 152.796 216.863 152.796C216.597 152.796 216.408 152.838 216.296 152.922C216.184 153.006 216.128 153.118 216.128 153.258C216.128 153.405 216.166 153.52 216.243 153.604C216.327 153.681 216.481 153.737 216.705 153.772L217.325 153.856C218.536 154.017 219.141 154.57 219.141 155.515C219.141 155.781 219.085 156.026 218.973 156.25C218.861 156.474 218.7 156.67 218.49 156.838C218.287 156.999 218.039 157.125 217.745 157.216C217.458 157.307 217.136 157.353 216.779 157.353ZM220.201 151.714H221.755V152.638H221.807C221.884 152.33 222.059 152.078 222.332 151.882C222.612 151.686 222.931 151.588 223.288 151.588C223.988 151.588 224.516 151.833 224.873 152.323C225.23 152.813 225.409 153.527 225.409 154.465C225.409 155.403 225.23 156.121 224.873 156.618C224.516 157.108 223.988 157.353 223.288 157.353C223.106 157.353 222.934 157.325 222.773 157.269C222.612 157.22 222.465 157.15 222.332 157.059C222.206 156.961 222.098 156.849 222.007 156.723C221.916 156.59 221.849 156.45 221.807 156.303H221.755V159.327H220.201V151.714ZM222.773 156.093C223.067 156.093 223.309 155.991 223.498 155.788C223.694 155.578 223.792 155.298 223.792 154.948V153.993C223.792 153.643 223.694 153.366 223.498 153.163C223.309 152.953 223.067 152.848 222.773 152.848C222.479 152.848 222.234 152.922 222.038 153.069C221.849 153.209 221.755 153.405 221.755 153.657V155.284C221.755 155.536 221.849 155.736 222.038 155.883C222.234 156.023 222.479 156.093 222.773 156.093ZM228.825 157.353C228.419 157.353 228.055 157.286 227.733 157.153C227.418 157.02 227.149 156.828 226.925 156.576C226.708 156.324 226.54 156.019 226.421 155.662C226.302 155.305 226.242 154.906 226.242 154.465C226.242 154.024 226.302 153.625 226.421 153.268C226.54 152.911 226.708 152.61 226.925 152.365C227.149 152.113 227.418 151.921 227.733 151.788C228.055 151.655 228.419 151.588 228.825 151.588C229.231 151.588 229.592 151.655 229.907 151.788C230.229 151.921 230.498 152.113 230.715 152.365C230.939 152.61 231.111 152.911 231.23 153.268C231.349 153.625 231.408 154.024 231.408 154.465C231.408 154.906 231.349 155.305 231.23 155.662C231.111 156.019 230.939 156.324 230.715 156.576C230.498 156.828 230.229 157.02 229.907 157.153C229.592 157.286 229.231 157.353 228.825 157.353ZM228.825 156.124C229.133 156.124 229.371 156.03 229.539 155.841C229.707 155.652 229.791 155.382 229.791 155.032V153.909C229.791 153.559 229.707 153.289 229.539 153.1C229.371 152.911 229.133 152.817 228.825 152.817C228.517 152.817 228.279 152.911 228.111 153.1C227.943 153.289 227.859 153.559 227.859 153.909V155.032C227.859 155.382 227.943 155.652 228.111 155.841C228.279 156.03 228.517 156.124 228.825 156.124ZM232.516 157.227V151.714H234.07V152.649H234.133C234.231 152.362 234.402 152.113 234.647 151.903C234.892 151.693 235.232 151.588 235.666 151.588C236.233 151.588 236.66 151.777 236.947 152.155C237.241 152.533 237.388 153.072 237.388 153.772V157.227H235.834V153.898C235.834 153.541 235.778 153.279 235.666 153.111C235.554 152.936 235.354 152.848 235.067 152.848C234.941 152.848 234.819 152.866 234.7 152.901C234.581 152.929 234.472 152.978 234.374 153.048C234.283 153.118 234.21 153.205 234.154 153.31C234.098 153.408 234.07 153.524 234.07 153.657V157.227H232.516ZM242.151 156.303H242.099C242.057 156.45 241.99 156.59 241.899 156.723C241.808 156.849 241.696 156.961 241.563 157.059C241.437 157.15 241.29 157.22 241.122 157.269C240.961 157.325 240.793 157.353 240.618 157.353C239.918 157.353 239.39 157.108 239.033 156.618C238.676 156.121 238.497 155.403 238.497 154.465C238.497 153.527 238.676 152.813 239.033 152.323C239.39 151.833 239.918 151.588 240.618 151.588C240.975 151.588 241.29 151.686 241.563 151.882C241.843 152.078 242.022 152.33 242.099 152.638H242.151V149.457H243.705V157.227H242.151V156.303ZM241.133 156.093C241.427 156.093 241.668 156.023 241.857 155.883C242.053 155.736 242.151 155.536 242.151 155.284V153.657C242.151 153.405 242.053 153.209 241.857 153.069C241.668 152.922 241.427 152.848 241.133 152.848C240.839 152.848 240.594 152.953 240.398 153.163C240.209 153.366 240.114 153.643 240.114 153.993V154.948C240.114 155.298 240.209 155.578 240.398 155.788C240.594 155.991 240.839 156.093 241.133 156.093ZM247.458 157.353C247.038 157.353 246.664 157.286 246.335 157.153C246.006 157.013 245.726 156.821 245.495 156.576C245.271 156.324 245.099 156.019 244.98 155.662C244.868 155.305 244.812 154.906 244.812 154.465C244.812 154.031 244.868 153.639 244.98 153.289C245.092 152.932 245.257 152.628 245.474 152.376C245.698 152.124 245.971 151.931 246.293 151.798C246.615 151.658 246.982 151.588 247.395 151.588C247.85 151.588 248.239 151.665 248.561 151.819C248.89 151.973 249.156 152.18 249.359 152.439C249.569 152.698 249.719 152.999 249.81 153.342C249.908 153.678 249.957 154.031 249.957 154.402V154.864H246.419V154.948C246.419 155.312 246.517 155.603 246.713 155.82C246.909 156.03 247.217 156.135 247.637 156.135C247.959 156.135 248.221 156.072 248.424 155.946C248.627 155.813 248.816 155.655 248.991 155.473L249.768 156.439C249.523 156.726 249.201 156.95 248.802 157.111C248.41 157.272 247.962 157.353 247.458 157.353ZM247.427 152.733C247.112 152.733 246.863 152.838 246.681 153.048C246.506 153.251 246.419 153.524 246.419 153.867V153.951H248.351V153.856C248.351 153.52 248.274 153.251 248.12 153.048C247.973 152.838 247.742 152.733 247.427 152.733ZM251.055 157.227V151.714H252.609V152.649H252.672C252.77 152.362 252.941 152.113 253.186 151.903C253.431 151.693 253.771 151.588 254.205 151.588C254.772 151.588 255.199 151.777 255.486 152.155C255.78 152.533 255.927 153.072 255.927 153.772V157.227H254.373V153.898C254.373 153.541 254.317 153.279 254.205 153.111C254.093 152.936 253.893 152.848 253.606 152.848C253.48 152.848 253.358 152.866 253.239 152.901C253.12 152.929 253.011 152.978 252.913 153.048C252.822 153.118 252.749 153.205 252.693 153.31C252.637 153.408 252.609 153.524 252.609 153.657V157.227H251.055ZM259.241 157.227C258.702 157.227 258.293 157.09 258.013 156.817C257.74 156.544 257.603 156.145 257.603 155.62V152.922H256.826V151.714H257.215C257.425 151.714 257.568 151.665 257.645 151.567C257.722 151.462 257.761 151.315 257.761 151.126V150.223H259.157V151.714H260.249V152.922H259.157V156.019H260.165V157.227H259.241ZM263.198 157.353C262.666 157.353 262.218 157.269 261.854 157.101C261.49 156.926 261.164 156.681 260.877 156.366L261.791 155.442C261.987 155.659 262.204 155.83 262.442 155.956C262.68 156.082 262.949 156.145 263.25 156.145C263.558 156.145 263.772 156.1 263.891 156.009C264.01 155.911 264.069 155.781 264.069 155.62C264.069 155.361 263.884 155.207 263.513 155.158L262.914 155.085C261.675 154.931 261.056 154.364 261.056 153.384C261.056 153.118 261.105 152.876 261.203 152.659C261.308 152.435 261.451 152.246 261.633 152.092C261.822 151.931 262.046 151.809 262.305 151.725C262.571 151.634 262.869 151.588 263.198 151.588C263.485 151.588 263.737 151.609 263.954 151.651C264.178 151.686 264.374 151.742 264.542 151.819C264.717 151.889 264.874 151.98 265.014 152.092C265.161 152.197 265.305 152.316 265.445 152.449L264.552 153.363C264.377 153.188 264.178 153.051 263.954 152.953C263.737 152.848 263.513 152.796 263.282 152.796C263.016 152.796 262.827 152.838 262.715 152.922C262.603 153.006 262.547 153.118 262.547 153.258C262.547 153.405 262.585 153.52 262.662 153.604C262.746 153.681 262.9 153.737 263.124 153.772L263.744 153.856C264.955 154.017 265.56 154.57 265.56 155.515C265.56 155.781 265.504 156.026 265.392 156.25C265.28 156.474 265.119 156.67 264.909 156.838C264.706 156.999 264.458 157.125 264.164 157.216C263.877 157.307 263.555 157.353 263.198 157.353Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0 209.227C0 204.256 4.02944 200.227 9 200.227H127C131.971 200.227 136 204.256 136 209.227V379.227C136 384.197 131.971 388.227 127 388.227H9C4.02944 388.227 0 384.197 0 379.227V209.227Z",
                                                                fill: "#712398"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M0.5 209.227C0.5 204.532 4.30558 200.727 9 200.727H127C131.694 200.727 135.5 204.532 135.5 209.227V379.227C135.5 383.921 131.694 387.727 127 387.727H9C4.30558 387.727 0.5 383.921 0.5 379.227V209.227Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M50 224.227C50 220.913 52.6863 218.227 56 218.227H80C83.3137 218.227 86 220.913 86 224.227V248.227C86 251.54 83.3137 254.227 80 254.227H56C52.6863 254.227 50 251.54 50 248.227V224.227Z",
                                                                fill: "#F2D8FF"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M50.5 224.227C50.5 221.189 52.9624 218.727 56 218.727H80C83.0376 218.727 85.5 221.189 85.5 224.227V248.227C85.5 251.264 83.0376 253.727 80 253.727H56C52.9624 253.727 50.5 251.264 50.5 248.227V224.227Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                                                clipPath: "url(#clip2_5592_7504)",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M72.5 238.477C72.9142 238.477 73.25 238.141 73.25 237.727C73.25 237.312 72.9142 236.977 72.5 236.977C72.0858 236.977 71.75 237.312 71.75 237.727C71.75 238.141 72.0858 238.477 72.5 238.477Z",
                                                                        fill: "#972FCA"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M73.25 240.727C73.25 241.141 72.9142 241.477 72.5 241.477C72.0858 241.477 71.75 241.141 71.75 240.727C71.75 240.312 72.0858 239.977 72.5 239.977C72.9142 239.977 73.25 240.312 73.25 240.727Z",
                                                                        fill: "#972FCA"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M63.5 235.477C63.9142 235.477 64.25 235.141 64.25 234.727C64.25 234.312 63.9142 233.977 63.5 233.977C63.0858 233.977 62.75 234.312 62.75 234.727C62.75 235.141 63.0858 235.477 63.5 235.477Z",
                                                                        fill: "#972FCA"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M64.25 237.727C64.25 238.141 63.9142 238.477 63.5 238.477C63.0858 238.477 62.75 238.141 62.75 237.727C62.75 237.312 63.0858 236.977 63.5 236.977C63.9142 236.977 64.25 237.312 64.25 237.727Z",
                                                                        fill: "#972FCA"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M63.5 232.477C63.9142 232.477 64.25 232.141 64.25 231.727C64.25 231.312 63.9142 230.977 63.5 230.977C63.0858 230.977 62.75 231.312 62.75 231.727C62.75 232.141 63.0858 232.477 63.5 232.477Z",
                                                                        fill: "#972FCA"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M67.25 234.727C67.25 235.141 66.9142 235.477 66.5 235.477C66.0858 235.477 65.75 235.141 65.75 234.727C65.75 234.312 66.0858 233.977 66.5 233.977C66.9142 233.977 67.25 234.312 67.25 234.727Z",
                                                                        fill: "#972FCA"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M66.5 238.477C66.9142 238.477 67.25 238.141 67.25 237.727C67.25 237.312 66.9142 236.977 66.5 236.977C66.0858 236.977 65.75 237.312 65.75 237.727C65.75 238.141 66.0858 238.477 66.5 238.477Z",
                                                                        fill: "#972FCA"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        fillRule: "evenodd",
                                                                        clipRule: "evenodd",
                                                                        d: "M59.75 230.227C59.75 228.984 60.7574 227.977 62 227.977H68C69.2426 227.977 70.25 228.984 70.25 230.227V233.977H74C75.2426 233.977 76.25 234.984 76.25 236.227V243.727C76.25 244.141 75.9142 244.477 75.5 244.477H60.5C60.0858 244.477 59.75 244.141 59.75 243.727V230.227ZM70.25 242.977V235.477H74C74.4142 235.477 74.75 235.812 74.75 236.227V242.977H70.25ZM62 229.477C61.5858 229.477 61.25 229.812 61.25 230.227V242.977H68.75V230.227C68.75 229.812 68.4142 229.477 68 229.477H62Z",
                                                                        fill: "#972FCA"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M22.5324 277.337L21.0924 278.987V282.227H19.3974V271.757H21.0924V277.067H21.1524L22.6524 275.162L25.4724 271.757H27.4524L23.7174 276.167L27.7524 282.227H25.7124L22.5324 277.337ZM31.8589 282.407C31.2989 282.407 30.7989 282.312 30.3589 282.122C29.9189 281.932 29.5439 281.662 29.2339 281.312C28.9239 280.952 28.6839 280.522 28.5139 280.022C28.3539 279.512 28.2739 278.947 28.2739 278.327C28.2739 277.707 28.3539 277.147 28.5139 276.647C28.6839 276.137 28.9239 275.707 29.2339 275.357C29.5439 274.997 29.9189 274.722 30.3589 274.532C30.7989 274.342 31.2989 274.247 31.8589 274.247C32.4289 274.247 32.9289 274.347 33.3589 274.547C33.7989 274.747 34.1639 275.027 34.4539 275.387C34.7439 275.737 34.9589 276.147 35.0989 276.617C35.2489 277.087 35.3239 277.592 35.3239 278.132V278.747H29.9689V279.002C29.9689 279.602 30.1439 280.097 30.4939 280.487C30.8539 280.867 31.3639 281.057 32.0239 281.057C32.5039 281.057 32.9089 280.952 33.2389 280.742C33.5689 280.532 33.8489 280.247 34.0789 279.887L35.0389 280.832C34.7489 281.312 34.3289 281.697 33.7789 281.987C33.2289 282.267 32.5889 282.407 31.8589 282.407ZM31.8589 275.522C31.5789 275.522 31.3189 275.572 31.0789 275.672C30.8489 275.772 30.6489 275.912 30.4789 276.092C30.3189 276.272 30.1939 276.487 30.1039 276.737C30.0139 276.987 29.9689 277.262 29.9689 277.562V277.667H33.5989V277.517C33.5989 276.917 33.4439 276.437 33.1339 276.077C32.8239 275.707 32.3989 275.522 31.8589 275.522ZM41.831 274.427H43.406L40.121 283.772C40.031 284.032 39.926 284.252 39.806 284.432C39.696 284.622 39.561 284.772 39.401 284.882C39.251 285.002 39.066 285.087 38.846 285.137C38.626 285.197 38.366 285.227 38.066 285.227H37.121V283.892H38.441L38.891 282.572L36.056 274.427H37.691L39.251 279.017L39.701 280.712H39.776L40.271 279.017L41.831 274.427ZM47.966 282.227V280.847H49.391V273.137H47.966V271.757H52.526V273.137H51.086V280.847H52.526V282.227H47.966ZM54.5362 282.227V274.427H56.1712V275.717H56.2462C56.4162 275.297 56.6712 274.947 57.0112 274.667C57.3612 274.387 57.8362 274.247 58.4362 274.247C59.2362 274.247 59.8562 274.512 60.2962 275.042C60.7462 275.562 60.9712 276.307 60.9712 277.277V282.227H59.3362V277.487C59.3362 276.267 58.8462 275.657 57.8662 275.657C57.6562 275.657 57.4462 275.687 57.2362 275.747C57.0362 275.797 56.8562 275.877 56.6962 275.987C56.5362 276.097 56.4062 276.237 56.3062 276.407C56.2162 276.577 56.1712 276.777 56.1712 277.007V282.227H54.5362ZM68.1424 280.937H68.0674C67.8974 281.397 67.6174 281.757 67.2274 282.017C66.8474 282.277 66.3974 282.407 65.8774 282.407C64.8874 282.407 64.1224 282.052 63.5824 281.342C63.0424 280.622 62.7724 279.617 62.7724 278.327C62.7724 277.037 63.0424 276.037 63.5824 275.327C64.1224 274.607 64.8874 274.247 65.8774 274.247C66.3974 274.247 66.8474 274.377 67.2274 274.637C67.6174 274.887 67.8974 275.247 68.0674 275.717H68.1424V271.127H69.7774V282.227H68.1424V280.937ZM66.3724 280.997C66.8724 280.997 67.2924 280.877 67.6324 280.637C67.9724 280.387 68.1424 280.062 68.1424 279.662V276.992C68.1424 276.592 67.9724 276.272 67.6324 276.032C67.2924 275.782 66.8724 275.657 66.3724 275.657C65.8024 275.657 65.3474 275.842 65.0074 276.212C64.6674 276.572 64.4974 277.052 64.4974 277.652V279.002C64.4974 279.602 64.6674 280.087 65.0074 280.457C65.3474 280.817 65.8024 280.997 66.3724 280.997ZM76.8393 280.937H76.7793C76.7093 281.127 76.6143 281.312 76.4943 281.492C76.3843 281.672 76.2393 281.832 76.0593 281.972C75.8893 282.102 75.6793 282.207 75.4293 282.287C75.1893 282.367 74.9093 282.407 74.5893 282.407C73.7793 282.407 73.1493 282.147 72.6993 281.627C72.2593 281.107 72.0393 280.362 72.0393 279.392V274.427H73.6743V279.182C73.6743 280.392 74.1743 280.997 75.1743 280.997C75.3843 280.997 75.5893 280.972 75.7893 280.922C75.9893 280.862 76.1643 280.777 76.3143 280.667C76.4743 280.557 76.5993 280.417 76.6893 280.247C76.7893 280.077 76.8393 279.877 76.8393 279.647V274.427H78.4743V282.227H76.8393V280.937ZM83.2905 282.407C82.5505 282.407 81.9305 282.277 81.4305 282.017C80.9305 281.757 80.4955 281.397 80.1255 280.937L81.1755 279.977C81.4655 280.327 81.7855 280.602 82.1355 280.802C82.4955 280.992 82.9105 281.087 83.3805 281.087C83.8605 281.087 84.2155 280.997 84.4455 280.817C84.6855 280.627 84.8055 280.367 84.8055 280.037C84.8055 279.787 84.7205 279.577 84.5505 279.407C84.3905 279.227 84.1055 279.112 83.6955 279.062L82.9755 278.972C82.1755 278.872 81.5455 278.642 81.0855 278.282C80.6355 277.912 80.4105 277.367 80.4105 276.647C80.4105 276.267 80.4805 275.932 80.6205 275.642C80.7605 275.342 80.9555 275.092 81.2055 274.892C81.4655 274.682 81.7705 274.522 82.1205 274.412C82.4805 274.302 82.8755 274.247 83.3055 274.247C84.0055 274.247 84.5755 274.357 85.0155 274.577C85.4655 274.797 85.8655 275.102 86.2155 275.492L85.2105 276.452C85.0105 276.212 84.7455 276.007 84.4155 275.837C84.0955 275.657 83.7255 275.567 83.3055 275.567C82.8555 275.567 82.5205 275.657 82.3005 275.837C82.0905 276.017 81.9855 276.252 81.9855 276.542C81.9855 276.842 82.0805 277.067 82.2705 277.217C82.4605 277.367 82.7655 277.477 83.1855 277.547L83.9055 277.637C84.7655 277.767 85.3905 278.022 85.7805 278.402C86.1805 278.772 86.3805 279.272 86.3805 279.902C86.3805 280.282 86.3055 280.627 86.1555 280.937C86.0155 281.237 85.8105 281.497 85.5405 281.717C85.2705 281.937 84.9455 282.107 84.5655 282.227C84.1855 282.347 83.7605 282.407 83.2905 282.407ZM90.2851 282.227C89.7151 282.227 89.2851 282.082 88.9951 281.792C88.7051 281.492 88.5601 281.072 88.5601 280.532V275.762H87.3451V274.427H88.0051C88.2751 274.427 88.4601 274.367 88.5601 274.247C88.6701 274.127 88.7251 273.932 88.7251 273.662V272.297H90.1951V274.427H91.8301V275.762H90.1951V280.892H91.7101V282.227H90.2851ZM93.6036 282.227V274.427H95.2386V275.927H95.3136C95.4236 275.527 95.6536 275.177 96.0036 274.877C96.3536 274.577 96.8386 274.427 97.4586 274.427H97.8936V276.002H97.2486C96.5986 276.002 96.0986 276.107 95.7486 276.317C95.4086 276.527 95.2386 276.837 95.2386 277.247V282.227H93.6036ZM100.171 273.032C99.8308 273.032 99.5808 272.952 99.4208 272.792C99.2708 272.632 99.1958 272.427 99.1958 272.177V271.922C99.1958 271.672 99.2708 271.467 99.4208 271.307C99.5808 271.147 99.8308 271.067 100.171 271.067C100.511 271.067 100.756 271.147 100.906 271.307C101.056 271.467 101.131 271.672 101.131 271.922V272.177C101.131 272.427 101.056 272.632 100.906 272.792C100.756 272.952 100.511 273.032 100.171 273.032ZM99.3458 274.427H100.981V282.227H99.3458V274.427ZM106.376 282.407C105.816 282.407 105.316 282.312 104.876 282.122C104.436 281.932 104.061 281.662 103.751 281.312C103.441 280.952 103.201 280.522 103.031 280.022C102.871 279.512 102.791 278.947 102.791 278.327C102.791 277.707 102.871 277.147 103.031 276.647C103.201 276.137 103.441 275.707 103.751 275.357C104.061 274.997 104.436 274.722 104.876 274.532C105.316 274.342 105.816 274.247 106.376 274.247C106.946 274.247 107.446 274.347 107.876 274.547C108.316 274.747 108.681 275.027 108.971 275.387C109.261 275.737 109.476 276.147 109.616 276.617C109.766 277.087 109.841 277.592 109.841 278.132V278.747H104.486V279.002C104.486 279.602 104.661 280.097 105.011 280.487C105.371 280.867 105.881 281.057 106.541 281.057C107.021 281.057 107.426 280.952 107.756 280.742C108.086 280.532 108.366 280.247 108.596 279.887L109.556 280.832C109.266 281.312 108.846 281.697 108.296 281.987C107.746 282.267 107.106 282.407 106.376 282.407ZM106.376 275.522C106.096 275.522 105.836 275.572 105.596 275.672C105.366 275.772 105.166 275.912 104.996 276.092C104.836 276.272 104.711 276.487 104.621 276.737C104.531 276.987 104.486 277.262 104.486 277.562V277.667H108.116V277.517C108.116 276.917 107.961 276.437 107.651 276.077C107.341 275.707 106.916 275.522 106.376 275.522ZM114.125 282.407C113.385 282.407 112.765 282.277 112.265 282.017C111.765 281.757 111.33 281.397 110.96 280.937L112.01 279.977C112.3 280.327 112.62 280.602 112.97 280.802C113.33 280.992 113.745 281.087 114.215 281.087C114.695 281.087 115.05 280.997 115.28 280.817C115.52 280.627 115.64 280.367 115.64 280.037C115.64 279.787 115.555 279.577 115.385 279.407C115.225 279.227 114.94 279.112 114.53 279.062L113.81 278.972C113.01 278.872 112.38 278.642 111.92 278.282C111.47 277.912 111.245 277.367 111.245 276.647C111.245 276.267 111.315 275.932 111.455 275.642C111.595 275.342 111.79 275.092 112.04 274.892C112.3 274.682 112.605 274.522 112.955 274.412C113.315 274.302 113.71 274.247 114.14 274.247C114.84 274.247 115.41 274.357 115.85 274.577C116.3 274.797 116.7 275.102 117.05 275.492L116.045 276.452C115.845 276.212 115.58 276.007 115.25 275.837C114.93 275.657 114.56 275.567 114.14 275.567C113.69 275.567 113.355 275.657 113.135 275.837C112.925 276.017 112.82 276.252 112.82 276.542C112.82 276.842 112.915 277.067 113.105 277.217C113.295 277.367 113.6 277.477 114.02 277.547L114.74 277.637C115.6 277.767 116.225 278.022 116.615 278.402C117.015 278.772 117.215 279.272 117.215 279.902C117.215 280.282 117.14 280.627 116.99 280.937C116.85 281.237 116.645 281.497 116.375 281.717C116.105 281.937 115.78 282.107 115.4 282.227C115.02 282.347 114.595 282.407 114.125 282.407Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M45.0319 306.227V298.898H49.6099V299.948H46.2184V301.985H49.2319V303.035H46.2184V306.227H45.0319ZM51.5137 299.79C51.2757 299.79 51.1007 299.734 50.9887 299.622C50.8837 299.51 50.8312 299.367 50.8312 299.192V299.013C50.8312 298.838 50.8837 298.695 50.9887 298.583C51.1007 298.471 51.2757 298.415 51.5137 298.415C51.7517 298.415 51.9232 298.471 52.0282 298.583C52.1332 298.695 52.1857 298.838 52.1857 299.013V299.192C52.1857 299.367 52.1332 299.51 52.0282 299.622C51.9232 299.734 51.7517 299.79 51.5137 299.79ZM50.9362 300.767H52.0807V306.227H50.9362V300.767ZM53.715 306.227V300.767H54.8595V301.67H54.912C55.031 301.376 55.2095 301.131 55.4475 300.935C55.6925 300.739 56.025 300.641 56.445 300.641C57.005 300.641 57.439 300.826 57.747 301.197C58.062 301.561 58.2195 302.083 58.2195 302.762V306.227H57.075V302.909C57.075 302.055 56.732 301.628 56.046 301.628C55.899 301.628 55.752 301.649 55.605 301.691C55.465 301.726 55.339 301.782 55.227 301.859C55.115 301.936 55.024 302.034 54.954 302.153C54.891 302.272 54.8595 302.412 54.8595 302.573V306.227H53.715ZM63.8063 306.227C63.5053 306.227 63.2743 306.143 63.1133 305.975C62.9523 305.8 62.8543 305.579 62.8193 305.313H62.7668C62.6618 305.656 62.4693 305.915 62.1893 306.09C61.9093 306.265 61.5698 306.353 61.1708 306.353C60.6038 306.353 60.1663 306.206 59.8583 305.912C59.5573 305.618 59.4068 305.222 59.4068 304.725C59.4068 304.179 59.6028 303.77 59.9948 303.497C60.3938 303.224 60.9748 303.087 61.7378 303.087H62.7248V302.625C62.7248 302.289 62.6338 302.03 62.4518 301.848C62.2698 301.666 61.9863 301.575 61.6013 301.575C61.2793 301.575 61.0168 301.645 60.8138 301.785C60.6108 301.925 60.4393 302.104 60.2993 302.321L59.6168 301.701C59.7988 301.393 60.0543 301.141 60.3833 300.945C60.7123 300.742 61.1428 300.641 61.6748 300.641C62.3818 300.641 62.9243 300.805 63.3023 301.134C63.6803 301.463 63.8693 301.936 63.8693 302.552V305.292H64.4468V306.227H63.8063ZM61.4963 305.481C61.8533 305.481 62.1473 305.404 62.3783 305.25C62.6093 305.089 62.7248 304.876 62.7248 304.61V303.822H61.7588C60.9678 303.822 60.5723 304.067 60.5723 304.557V304.746C60.5723 304.991 60.6528 305.177 60.8138 305.303C60.9818 305.422 61.2093 305.481 61.4963 305.481ZM65.5685 306.227V300.767H66.713V301.67H66.7655C66.8845 301.376 67.063 301.131 67.301 300.935C67.546 300.739 67.8785 300.641 68.2985 300.641C68.8585 300.641 69.2925 300.826 69.6005 301.197C69.9155 301.561 70.073 302.083 70.073 302.762V306.227H68.9285V302.909C68.9285 302.055 68.5855 301.628 67.8995 301.628C67.7525 301.628 67.6055 301.649 67.4585 301.691C67.3185 301.726 67.1925 301.782 67.0805 301.859C66.9685 301.936 66.8775 302.034 66.8075 302.153C66.7445 302.272 66.713 302.412 66.713 302.573V306.227H65.5685ZM73.7698 306.353C73.3778 306.353 73.0278 306.286 72.7198 306.153C72.4118 306.02 72.1528 305.831 71.9428 305.586C71.7328 305.334 71.5718 305.033 71.4598 304.683C71.3478 304.326 71.2918 303.931 71.2918 303.497C71.2918 303.063 71.3478 302.671 71.4598 302.321C71.5718 301.964 71.7328 301.663 71.9428 301.418C72.1528 301.166 72.4118 300.973 72.7198 300.84C73.0278 300.707 73.3778 300.641 73.7698 300.641C74.3158 300.641 74.7638 300.763 75.1138 301.008C75.4638 301.253 75.7193 301.579 75.8803 301.985L74.9353 302.426C74.8583 302.174 74.7218 301.974 74.5258 301.827C74.3368 301.673 74.0848 301.596 73.7698 301.596C73.3498 301.596 73.0313 301.729 72.8143 301.995C72.6043 302.254 72.4993 302.594 72.4993 303.014V303.99C72.4993 304.41 72.6043 304.753 72.8143 305.019C73.0313 305.278 73.3498 305.408 73.7698 305.408C74.1058 305.408 74.3718 305.327 74.5678 305.166C74.7708 304.998 74.9318 304.778 75.0508 304.505L75.9223 304.967C75.7403 305.415 75.4673 305.758 75.1033 305.996C74.7393 306.234 74.2948 306.353 73.7698 306.353ZM79.0923 306.353C78.7003 306.353 78.3503 306.286 78.0423 306.153C77.7343 306.02 77.4718 305.831 77.2548 305.586C77.0378 305.334 76.8698 305.033 76.7508 304.683C76.6388 304.326 76.5828 303.931 76.5828 303.497C76.5828 303.063 76.6388 302.671 76.7508 302.321C76.8698 301.964 77.0378 301.663 77.2548 301.418C77.4718 301.166 77.7343 300.973 78.0423 300.84C78.3503 300.707 78.7003 300.641 79.0923 300.641C79.4913 300.641 79.8413 300.711 80.1423 300.851C80.4503 300.991 80.7058 301.187 80.9088 301.439C81.1118 301.684 81.2623 301.971 81.3603 302.3C81.4653 302.629 81.5178 302.982 81.5178 303.36V303.791H77.7693V303.969C77.7693 304.389 77.8918 304.736 78.1368 305.009C78.3888 305.275 78.7458 305.408 79.2078 305.408C79.5438 305.408 79.8273 305.334 80.0583 305.187C80.2893 305.04 80.4853 304.841 80.6463 304.589L81.3183 305.25C81.1153 305.586 80.8213 305.856 80.4363 306.059C80.0513 306.255 79.6033 306.353 79.0923 306.353ZM79.0923 301.533C78.8963 301.533 78.7143 301.568 78.5463 301.638C78.3853 301.708 78.2453 301.806 78.1263 301.932C78.0143 302.058 77.9268 302.209 77.8638 302.384C77.8008 302.559 77.7693 302.751 77.7693 302.961V303.035H80.3103V302.93C80.3103 302.51 80.2018 302.174 79.9848 301.922C79.7678 301.663 79.4703 301.533 79.0923 301.533ZM89.5818 305.481C89.4908 305.572 89.3788 305.67 89.2458 305.775C89.1198 305.873 88.9693 305.968 88.7943 306.059C88.6263 306.143 88.4303 306.213 88.2063 306.269C87.9893 306.325 87.7408 306.353 87.4608 306.353C87.0828 306.353 86.7468 306.3 86.4528 306.195C86.1588 306.09 85.9103 305.947 85.7073 305.765C85.5113 305.583 85.3608 305.369 85.2558 305.124C85.1578 304.872 85.1088 304.603 85.1088 304.316C85.1088 304.057 85.1473 303.826 85.2243 303.623C85.3083 303.413 85.4168 303.227 85.5498 303.066C85.6898 302.898 85.8473 302.751 86.0223 302.625C86.2043 302.492 86.3968 302.37 86.5998 302.258C86.3688 302.013 86.1728 301.747 86.0118 301.46C85.8508 301.173 85.7703 300.865 85.7703 300.536C85.7703 300.291 85.8158 300.06 85.9068 299.843C86.0048 299.626 86.1413 299.44 86.3163 299.286C86.4913 299.125 86.7013 298.999 86.9463 298.908C87.1983 298.817 87.4748 298.772 87.7758 298.772C88.0558 298.772 88.3148 298.81 88.5528 298.887C88.7908 298.964 88.9973 299.073 89.1723 299.213C89.3473 299.353 89.4803 299.524 89.5713 299.727C89.6693 299.923 89.7183 300.144 89.7183 300.389C89.7183 300.627 89.6763 300.844 89.5923 301.04C89.5083 301.229 89.3928 301.404 89.2458 301.565C89.0988 301.719 88.9273 301.866 88.7313 302.006C88.5423 302.139 88.3393 302.268 88.1223 302.394L89.5503 303.938C89.6483 303.686 89.7253 303.42 89.7813 303.14C89.8373 302.86 89.8723 302.576 89.8863 302.289H91.4508V303.255H90.7368C90.6318 303.787 90.4708 304.26 90.2538 304.673L91.6923 306.227H90.2643L89.5818 305.481ZM87.7758 299.685C87.5238 299.685 87.3103 299.762 87.1353 299.916C86.9603 300.063 86.8728 300.259 86.8728 300.504V300.588C86.8728 300.77 86.9288 300.952 87.0408 301.134C87.1598 301.316 87.3278 301.526 87.5448 301.764C87.8388 301.603 88.0908 301.425 88.3008 301.229C88.5108 301.026 88.6158 300.795 88.6158 300.536V300.452C88.6158 300.207 88.5388 300.018 88.3848 299.885C88.2308 299.752 88.0278 299.685 87.7758 299.685ZM87.5973 305.376C87.8913 305.376 88.1503 305.327 88.3743 305.229C88.5983 305.131 88.7943 304.995 88.9623 304.82L87.1773 302.898C86.9113 303.045 86.6943 303.21 86.5263 303.392C86.3653 303.574 86.2848 303.822 86.2848 304.137V304.274C86.2848 304.61 86.4003 304.879 86.6313 305.082C86.8623 305.278 87.1843 305.376 87.5973 305.376ZM43.0449 314.948V321.227H41.8584V314.948H39.6744V313.898H45.2289V314.948H43.0449ZM47.7564 321.353C47.3644 321.353 47.0144 321.286 46.7064 321.153C46.3984 321.02 46.1359 320.831 45.9189 320.586C45.7019 320.334 45.5339 320.033 45.4149 319.683C45.3029 319.326 45.2469 318.931 45.2469 318.497C45.2469 318.063 45.3029 317.671 45.4149 317.321C45.5339 316.964 45.7019 316.663 45.9189 316.418C46.1359 316.166 46.3984 315.973 46.7064 315.84C47.0144 315.707 47.3644 315.641 47.7564 315.641C48.1554 315.641 48.5054 315.711 48.8064 315.851C49.1144 315.991 49.3699 316.187 49.5729 316.439C49.7759 316.684 49.9264 316.971 50.0244 317.3C50.1294 317.629 50.1819 317.982 50.1819 318.36V318.791H46.4334V318.969C46.4334 319.389 46.5559 319.736 46.8009 320.009C47.0529 320.275 47.4099 320.408 47.8719 320.408C48.2079 320.408 48.4914 320.334 48.7224 320.187C48.9534 320.04 49.1494 319.841 49.3104 319.589L49.9824 320.25C49.7794 320.586 49.4854 320.856 49.1004 321.059C48.7154 321.255 48.2674 321.353 47.7564 321.353ZM47.7564 316.533C47.5604 316.533 47.3784 316.568 47.2104 316.638C47.0494 316.708 46.9094 316.806 46.7904 316.932C46.6784 317.058 46.5909 317.209 46.5279 317.384C46.4649 317.559 46.4334 317.751 46.4334 317.961V318.035H48.9744V317.93C48.9744 317.51 48.8659 317.174 48.6489 316.922C48.4319 316.663 48.1344 316.533 47.7564 316.533ZM53.5594 321.353C53.1674 321.353 52.8174 321.286 52.5094 321.153C52.2014 321.02 51.9424 320.831 51.7324 320.586C51.5224 320.334 51.3614 320.033 51.2494 319.683C51.1374 319.326 51.0814 318.931 51.0814 318.497C51.0814 318.063 51.1374 317.671 51.2494 317.321C51.3614 316.964 51.5224 316.663 51.7324 316.418C51.9424 316.166 52.2014 315.973 52.5094 315.84C52.8174 315.707 53.1674 315.641 53.5594 315.641C54.1054 315.641 54.5534 315.763 54.9034 316.008C55.2534 316.253 55.5089 316.579 55.6699 316.985L54.7249 317.426C54.6479 317.174 54.5114 316.974 54.3154 316.827C54.1264 316.673 53.8744 316.596 53.5594 316.596C53.1394 316.596 52.8209 316.729 52.6039 316.995C52.3939 317.254 52.2889 317.594 52.2889 318.014V318.99C52.2889 319.41 52.3939 319.753 52.6039 320.019C52.8209 320.278 53.1394 320.408 53.5594 320.408C53.8954 320.408 54.1614 320.327 54.3574 320.166C54.5604 319.998 54.7214 319.778 54.8404 319.505L55.7119 319.967C55.5299 320.415 55.2569 320.758 54.8929 320.996C54.5289 321.234 54.0844 321.353 53.5594 321.353ZM56.8014 313.457H57.9459V316.67H57.9984C58.1174 316.376 58.2959 316.131 58.5339 315.935C58.7789 315.739 59.1114 315.641 59.5314 315.641C60.0914 315.641 60.5254 315.826 60.8334 316.197C61.1484 316.561 61.3059 317.083 61.3059 317.762V321.227H60.1614V317.898C60.1614 317.051 59.8184 316.628 59.1324 316.628C58.9854 316.628 58.8384 316.649 58.6914 316.691C58.5514 316.726 58.4254 316.782 58.3134 316.859C58.2014 316.936 58.1104 317.034 58.0404 317.153C57.9774 317.272 57.9459 317.408 57.9459 317.562V321.227H56.8014V313.457ZM62.8922 321.227V315.767H64.0367V316.67H64.0892C64.2082 316.376 64.3867 316.131 64.6247 315.935C64.8697 315.739 65.2022 315.641 65.6222 315.641C66.1822 315.641 66.6162 315.826 66.9242 316.197C67.2392 316.561 67.3967 317.083 67.3967 317.762V321.227H66.2522V317.909C66.2522 317.055 65.9092 316.628 65.2232 316.628C65.0762 316.628 64.9292 316.649 64.7822 316.691C64.6422 316.726 64.5162 316.782 64.4042 316.859C64.2922 316.936 64.2012 317.034 64.1312 317.153C64.0682 317.272 64.0367 317.412 64.0367 317.573V321.227H62.8922ZM71.1251 321.353C70.7471 321.353 70.4006 321.286 70.0856 321.153C69.7776 321.02 69.5151 320.831 69.2981 320.586C69.0811 320.334 68.9131 320.033 68.7941 319.683C68.6751 319.326 68.6156 318.931 68.6156 318.497C68.6156 318.063 68.6751 317.671 68.7941 317.321C68.9131 316.964 69.0811 316.663 69.2981 316.418C69.5151 316.166 69.7776 315.973 70.0856 315.84C70.4006 315.707 70.7471 315.641 71.1251 315.641C71.5031 315.641 71.8461 315.707 72.1541 315.84C72.4691 315.973 72.7351 316.166 72.9521 316.418C73.1691 316.663 73.3371 316.964 73.4561 317.321C73.5751 317.671 73.6346 318.063 73.6346 318.497C73.6346 318.931 73.5751 319.326 73.4561 319.683C73.3371 320.033 73.1691 320.334 72.9521 320.586C72.7351 320.831 72.4691 321.02 72.1541 321.153C71.8461 321.286 71.5031 321.353 71.1251 321.353ZM71.1251 320.408C71.5171 320.408 71.8321 320.289 72.0701 320.051C72.3081 319.806 72.4271 319.442 72.4271 318.959V318.035C72.4271 317.552 72.3081 317.191 72.0701 316.953C71.8321 316.708 71.5171 316.586 71.1251 316.586C70.7331 316.586 70.4181 316.708 70.1801 316.953C69.9421 317.191 69.8231 317.552 69.8231 318.035V318.959C69.8231 319.442 69.9421 319.806 70.1801 320.051C70.4181 320.289 70.7331 320.408 71.1251 320.408ZM76.0753 321.227C75.6833 321.227 75.3893 321.129 75.1933 320.933C75.0043 320.73 74.9098 320.45 74.9098 320.093V313.457H76.0543V320.292H76.8103V321.227H76.0753ZM80.046 321.353C79.668 321.353 79.3215 321.286 79.0065 321.153C78.6985 321.02 78.436 320.831 78.219 320.586C78.002 320.334 77.834 320.033 77.715 319.683C77.596 319.326 77.5365 318.931 77.5365 318.497C77.5365 318.063 77.596 317.671 77.715 317.321C77.834 316.964 78.002 316.663 78.219 316.418C78.436 316.166 78.6985 315.973 79.0065 315.84C79.3215 315.707 79.668 315.641 80.046 315.641C80.424 315.641 80.767 315.707 81.075 315.84C81.39 315.973 81.656 316.166 81.873 316.418C82.09 316.663 82.258 316.964 82.377 317.321C82.496 317.671 82.5555 318.063 82.5555 318.497C82.5555 318.931 82.496 319.326 82.377 319.683C82.258 320.033 82.09 320.334 81.873 320.586C81.656 320.831 81.39 321.02 81.075 321.153C80.767 321.286 80.424 321.353 80.046 321.353ZM80.046 320.408C80.438 320.408 80.753 320.289 80.991 320.051C81.229 319.806 81.348 319.442 81.348 318.959V318.035C81.348 317.552 81.229 317.191 80.991 316.953C80.753 316.708 80.438 316.586 80.046 316.586C79.654 316.586 79.339 316.708 79.101 316.953C78.863 317.191 78.744 317.552 78.744 318.035V318.959C78.744 319.442 78.863 319.806 79.101 320.051C79.339 320.289 79.654 320.408 80.046 320.408ZM88.6187 321.741C88.6187 322.308 88.4017 322.735 87.9677 323.022C87.5337 323.309 86.8267 323.453 85.8467 323.453C85.3987 323.453 85.0172 323.421 84.7022 323.358C84.3942 323.302 84.1387 323.218 83.9357 323.106C83.7397 322.994 83.5962 322.858 83.5052 322.697C83.4142 322.536 83.3687 322.35 83.3687 322.14C83.3687 321.839 83.4492 321.605 83.6102 321.437C83.7782 321.269 84.0092 321.153 84.3032 321.09V320.975C83.8902 320.842 83.6837 320.562 83.6837 320.135C83.6837 319.855 83.7782 319.641 83.9672 319.494C84.1562 319.34 84.3837 319.232 84.6497 319.169V319.127C84.3277 318.973 84.0792 318.759 83.9042 318.486C83.7362 318.206 83.6522 317.881 83.6522 317.51C83.6522 316.95 83.8377 316.498 84.2087 316.155C84.5867 315.812 85.1257 315.641 85.8257 315.641C86.2107 315.641 86.5397 315.697 86.8127 315.809V315.662C86.8127 315.417 86.8687 315.228 86.9807 315.095C87.0997 314.955 87.2817 314.885 87.5267 314.885H88.3667V315.809H87.2537V316.029C87.4987 316.19 87.6877 316.4 87.8207 316.659C87.9537 316.911 88.0202 317.195 88.0202 317.51C88.0202 318.063 87.8312 318.511 87.4532 318.854C87.0752 319.19 86.5362 319.358 85.8362 319.358C85.5702 319.358 85.3322 319.33 85.1222 319.274C84.9822 319.323 84.8597 319.393 84.7547 319.484C84.6497 319.568 84.5972 319.68 84.5972 319.82C84.5972 319.967 84.6637 320.072 84.7967 320.135C84.9297 320.198 85.1187 320.229 85.3637 320.229H86.7077C87.3797 320.229 87.8662 320.366 88.1672 320.639C88.4682 320.905 88.6187 321.272 88.6187 321.741ZM87.5477 321.867C87.5477 321.678 87.4742 321.528 87.3272 321.416C87.1872 321.304 86.9282 321.248 86.5502 321.248H84.7022C84.4502 321.395 84.3242 321.605 84.3242 321.878C84.3242 322.102 84.4117 322.28 84.5867 322.413C84.7687 322.553 85.0732 322.623 85.5002 322.623H86.2142C87.1032 322.623 87.5477 322.371 87.5477 321.867ZM85.8362 318.528C86.1722 318.528 86.4312 318.455 86.6132 318.308C86.8022 318.154 86.8967 317.919 86.8967 317.604V317.394C86.8967 317.079 86.8022 316.848 86.6132 316.701C86.4312 316.547 86.1722 316.47 85.8362 316.47C85.5002 316.47 85.2377 316.547 85.0487 316.701C84.8667 316.848 84.7757 317.079 84.7757 317.394V317.604C84.7757 317.919 84.8667 318.154 85.0487 318.308C85.2377 318.455 85.5002 318.528 85.8362 318.528ZM92.8711 315.767H93.9736L91.6741 322.308C91.6111 322.49 91.5376 322.644 91.4536 322.77C91.3766 322.903 91.2821 323.008 91.1701 323.085C91.0651 323.169 90.9356 323.229 90.7816 323.264C90.6276 323.306 90.4456 323.327 90.2356 323.327H89.5741V322.392H90.4981L90.8131 321.468L88.8286 315.767H89.9731L91.0651 318.98L91.3801 320.166H91.4326L91.7791 318.98L92.8711 315.767ZM21.4039 336.353C21.0259 336.353 20.6794 336.286 20.3644 336.153C20.0564 336.02 19.7939 335.831 19.5769 335.586C19.3599 335.334 19.1919 335.033 19.0729 334.683C18.9539 334.326 18.8944 333.931 18.8944 333.497C18.8944 333.063 18.9539 332.671 19.0729 332.321C19.1919 331.964 19.3599 331.663 19.5769 331.418C19.7939 331.166 20.0564 330.973 20.3644 330.84C20.6794 330.707 21.0259 330.641 21.4039 330.641C21.7819 330.641 22.1249 330.707 22.4329 330.84C22.7479 330.973 23.0139 331.166 23.2309 331.418C23.4479 331.663 23.6159 331.964 23.7349 332.321C23.8539 332.671 23.9134 333.063 23.9134 333.497C23.9134 333.931 23.8539 334.326 23.7349 334.683C23.6159 335.033 23.4479 335.334 23.2309 335.586C23.0139 335.831 22.7479 336.02 22.4329 336.153C22.1249 336.286 21.7819 336.353 21.4039 336.353ZM21.4039 335.408C21.7959 335.408 22.1109 335.289 22.3489 335.051C22.5869 334.806 22.7059 334.442 22.7059 333.959V333.035C22.7059 332.552 22.5869 332.191 22.3489 331.953C22.1109 331.708 21.7959 331.586 21.4039 331.586C21.0119 331.586 20.6969 331.708 20.4589 331.953C20.2209 332.191 20.1019 332.552 20.1019 333.035V333.959C20.1019 334.442 20.2209 334.806 20.4589 335.051C20.6969 335.289 21.0119 335.408 21.4039 335.408ZM26.6699 336.227C26.2709 336.227 25.9699 336.125 25.7669 335.922C25.5639 335.712 25.4624 335.418 25.4624 335.04V331.701H24.6119V330.767H25.0739C25.2629 330.767 25.3924 330.725 25.4624 330.641C25.5394 330.557 25.5779 330.42 25.5779 330.231V329.276H26.6069V330.767H27.7514V331.701H26.6069V335.292H27.6674V336.227H26.6699ZM28.9928 328.457H30.1373V331.67H30.1898C30.3088 331.376 30.4873 331.131 30.7253 330.935C30.9703 330.739 31.3028 330.641 31.7228 330.641C32.2828 330.641 32.7168 330.826 33.0248 331.197C33.3398 331.561 33.4973 332.083 33.4973 332.762V336.227H32.3528V332.898C32.3528 332.051 32.0098 331.628 31.3238 331.628C31.1768 331.628 31.0298 331.649 30.8828 331.691C30.7428 331.726 30.6168 331.782 30.5048 331.859C30.3928 331.936 30.3018 332.034 30.2318 332.153C30.1688 332.272 30.1373 332.408 30.1373 332.562V336.227H28.9928V328.457ZM37.2256 336.353C36.8336 336.353 36.4836 336.286 36.1756 336.153C35.8676 336.02 35.6051 335.831 35.3881 335.586C35.1711 335.334 35.0031 335.033 34.8841 334.683C34.7721 334.326 34.7161 333.931 34.7161 333.497C34.7161 333.063 34.7721 332.671 34.8841 332.321C35.0031 331.964 35.1711 331.663 35.3881 331.418C35.6051 331.166 35.8676 330.973 36.1756 330.84C36.4836 330.707 36.8336 330.641 37.2256 330.641C37.6246 330.641 37.9746 330.711 38.2756 330.851C38.5836 330.991 38.8391 331.187 39.0421 331.439C39.2451 331.684 39.3956 331.971 39.4936 332.3C39.5986 332.629 39.6511 332.982 39.6511 333.36V333.791H35.9026V333.969C35.9026 334.389 36.0251 334.736 36.2701 335.009C36.5221 335.275 36.8791 335.408 37.3411 335.408C37.6771 335.408 37.9606 335.334 38.1916 335.187C38.4226 335.04 38.6186 334.841 38.7796 334.589L39.4516 335.25C39.2486 335.586 38.9546 335.856 38.5696 336.059C38.1846 336.255 37.7366 336.353 37.2256 336.353ZM37.2256 331.533C37.0296 331.533 36.8476 331.568 36.6796 331.638C36.5186 331.708 36.3786 331.806 36.2596 331.932C36.1476 332.058 36.0601 332.209 35.9971 332.384C35.9341 332.559 35.9026 332.751 35.9026 332.961V333.035H38.4436V332.93C38.4436 332.51 38.3351 332.174 38.1181 331.922C37.9011 331.663 37.6036 331.533 37.2256 331.533ZM40.9181 336.227V330.767H42.0626V331.817H42.1151C42.1921 331.537 42.3531 331.292 42.5981 331.082C42.8431 330.872 43.1826 330.767 43.6166 330.767H43.9211V331.869H43.4696C43.0146 331.869 42.6646 331.943 42.4196 332.09C42.1816 332.237 42.0626 332.454 42.0626 332.741V336.227H40.9181ZM46.6702 336.353C46.1522 336.353 45.7182 336.262 45.3682 336.08C45.0182 335.898 44.7137 335.646 44.4547 335.324L45.1897 334.652C45.3927 334.897 45.6167 335.089 45.8617 335.229C46.1137 335.362 46.4042 335.429 46.7332 335.429C47.0692 335.429 47.3177 335.366 47.4787 335.24C47.6467 335.107 47.7307 334.925 47.7307 334.694C47.7307 334.519 47.6712 334.372 47.5522 334.253C47.4402 334.127 47.2407 334.046 46.9537 334.011L46.4497 333.948C45.8897 333.878 45.4487 333.717 45.1267 333.465C44.8117 333.206 44.6542 332.825 44.6542 332.321C44.6542 332.055 44.7032 331.82 44.8012 331.617C44.8992 331.407 45.0357 331.232 45.2107 331.092C45.3927 330.945 45.6062 330.833 45.8512 330.756C46.1032 330.679 46.3797 330.641 46.6807 330.641C47.1707 330.641 47.5697 330.718 47.8777 330.872C48.1927 331.026 48.4727 331.239 48.7177 331.512L48.0142 332.184C47.8742 332.016 47.6887 331.873 47.4577 331.754C47.2337 331.628 46.9747 331.565 46.6807 331.565C46.3657 331.565 46.1312 331.628 45.9772 331.754C45.8302 331.88 45.7567 332.044 45.7567 332.247C45.7567 332.457 45.8232 332.615 45.9562 332.72C46.0892 332.825 46.3027 332.902 46.5967 332.951L47.1007 333.014C47.7027 333.105 48.1402 333.283 48.4132 333.549C48.6932 333.808 48.8332 334.158 48.8332 334.599C48.8332 334.865 48.7807 335.107 48.6757 335.324C48.5777 335.534 48.4342 335.716 48.2452 335.87C48.0562 336.024 47.8287 336.143 47.5627 336.227C47.2967 336.311 46.9992 336.353 46.6702 336.353ZM53.1851 329.79C52.9471 329.79 52.7721 329.734 52.6601 329.622C52.5551 329.51 52.5026 329.367 52.5026 329.192V329.013C52.5026 328.838 52.5551 328.695 52.6601 328.583C52.7721 328.471 52.9471 328.415 53.1851 328.415C53.4231 328.415 53.5946 328.471 53.6996 328.583C53.8046 328.695 53.8571 328.838 53.8571 329.013V329.192C53.8571 329.367 53.8046 329.51 53.6996 329.622C53.5946 329.734 53.4231 329.79 53.1851 329.79ZM52.6076 330.767H53.7521V336.227H52.6076V330.767ZM55.3864 336.227V330.767H56.5309V331.67H56.5834C56.7024 331.376 56.8809 331.131 57.1189 330.935C57.3639 330.739 57.6964 330.641 58.1164 330.641C58.6764 330.641 59.1104 330.826 59.4184 331.197C59.7334 331.561 59.8909 332.083 59.8909 332.762V336.227H58.7464V332.909C58.7464 332.055 58.4034 331.628 57.7174 331.628C57.5704 331.628 57.4234 331.649 57.2764 331.691C57.1364 331.726 57.0104 331.782 56.8984 331.859C56.7864 331.936 56.6954 332.034 56.6254 332.153C56.5624 332.272 56.5309 332.412 56.5309 332.573V336.227H55.3864ZM63.5877 336.353C63.1957 336.353 62.8457 336.286 62.5377 336.153C62.2297 336.02 61.9707 335.831 61.7607 335.586C61.5507 335.334 61.3897 335.033 61.2777 334.683C61.1657 334.326 61.1097 333.931 61.1097 333.497C61.1097 333.063 61.1657 332.671 61.2777 332.321C61.3897 331.964 61.5507 331.663 61.7607 331.418C61.9707 331.166 62.2297 330.973 62.5377 330.84C62.8457 330.707 63.1957 330.641 63.5877 330.641C64.1337 330.641 64.5817 330.763 64.9317 331.008C65.2817 331.253 65.5372 331.579 65.6982 331.985L64.7532 332.426C64.6762 332.174 64.5397 331.974 64.3437 331.827C64.1547 331.673 63.9027 331.596 63.5877 331.596C63.1677 331.596 62.8492 331.729 62.6322 331.995C62.4222 332.254 62.3172 332.594 62.3172 333.014V333.99C62.3172 334.41 62.4222 334.753 62.6322 335.019C62.8492 335.278 63.1677 335.408 63.5877 335.408C63.9237 335.408 64.1897 335.327 64.3857 335.166C64.5887 334.998 64.7497 334.778 64.8687 334.505L65.7402 334.967C65.5582 335.415 65.2852 335.758 64.9212 335.996C64.5572 336.234 64.1127 336.353 63.5877 336.353ZM67.9952 336.227C67.6032 336.227 67.3092 336.129 67.1132 335.933C66.9242 335.73 66.8297 335.45 66.8297 335.093V328.457H67.9742V335.292H68.7302V336.227H67.9952ZM73.1314 335.324H73.0894C73.0404 335.457 72.9739 335.586 72.8899 335.712C72.8129 335.838 72.7114 335.95 72.5854 336.048C72.4664 336.139 72.3194 336.213 72.1444 336.269C71.9764 336.325 71.7804 336.353 71.5564 336.353C70.9894 336.353 70.5484 336.171 70.2334 335.807C69.9254 335.443 69.7714 334.921 69.7714 334.242V330.767H70.9159V334.095C70.9159 334.942 71.2659 335.366 71.9659 335.366C72.1129 335.366 72.2564 335.348 72.3964 335.313C72.5364 335.271 72.6589 335.212 72.7639 335.135C72.8759 335.058 72.9634 334.96 73.0264 334.841C73.0964 334.722 73.1314 334.582 73.1314 334.421V330.767H74.2759V336.227H73.1314V335.324ZM79.3482 335.324H79.2957C79.1767 335.646 78.9807 335.898 78.7077 336.08C78.4417 336.262 78.1267 336.353 77.7627 336.353C77.0697 336.353 76.5342 336.104 76.1562 335.607C75.7782 335.103 75.5892 334.4 75.5892 333.497C75.5892 332.594 75.7782 331.894 76.1562 331.397C76.5342 330.893 77.0697 330.641 77.7627 330.641C78.1267 330.641 78.4417 330.732 78.7077 330.914C78.9807 331.089 79.1767 331.341 79.2957 331.67H79.3482V328.457H80.4927V336.227H79.3482V335.324ZM78.1092 335.366C78.4592 335.366 78.7532 335.282 78.9912 335.114C79.2292 334.939 79.3482 334.711 79.3482 334.431V332.562C79.3482 332.282 79.2292 332.058 78.9912 331.89C78.7532 331.715 78.4592 331.628 78.1092 331.628C77.7102 331.628 77.3917 331.757 77.1537 332.016C76.9157 332.268 76.7967 332.604 76.7967 333.024V333.969C76.7967 334.389 76.9157 334.729 77.1537 334.988C77.3917 335.24 77.7102 335.366 78.1092 335.366ZM84.2706 336.353C83.8786 336.353 83.5286 336.286 83.2206 336.153C82.9126 336.02 82.6501 335.831 82.4331 335.586C82.2161 335.334 82.0481 335.033 81.9291 334.683C81.8171 334.326 81.7611 333.931 81.7611 333.497C81.7611 333.063 81.8171 332.671 81.9291 332.321C82.0481 331.964 82.2161 331.663 82.4331 331.418C82.6501 331.166 82.9126 330.973 83.2206 330.84C83.5286 330.707 83.8786 330.641 84.2706 330.641C84.6696 330.641 85.0196 330.711 85.3206 330.851C85.6286 330.991 85.8841 331.187 86.0871 331.439C86.2901 331.684 86.4406 331.971 86.5386 332.3C86.6436 332.629 86.6961 332.982 86.6961 333.36V333.791H82.9476V333.969C82.9476 334.389 83.0701 334.736 83.3151 335.009C83.5671 335.275 83.9241 335.408 84.3861 335.408C84.7221 335.408 85.0056 335.334 85.2366 335.187C85.4676 335.04 85.6636 334.841 85.8246 334.589L86.4966 335.25C86.2936 335.586 85.9996 335.856 85.6146 336.059C85.2296 336.255 84.7816 336.353 84.2706 336.353ZM84.2706 331.533C84.0746 331.533 83.8926 331.568 83.7246 331.638C83.5636 331.708 83.4236 331.806 83.3046 331.932C83.1926 332.058 83.1051 332.209 83.0421 332.384C82.9791 332.559 82.9476 332.751 82.9476 332.961V333.035H85.4886V332.93C85.4886 332.51 85.3801 332.174 85.1631 331.922C84.9461 331.663 84.6486 331.533 84.2706 331.533ZM91.715 336.227H90.5285V328.898H93.689C94.347 328.898 94.865 329.097 95.243 329.496C95.621 329.888 95.81 330.424 95.81 331.103C95.81 331.628 95.6875 332.065 95.4425 332.415C95.2045 332.758 94.851 333 94.382 333.14L95.9675 336.227H94.6445L93.1745 333.266H91.715V336.227ZM93.605 332.268C93.906 332.268 94.1405 332.191 94.3085 332.037C94.4765 331.876 94.5605 331.649 94.5605 331.355V330.851C94.5605 330.557 94.4765 330.333 94.3085 330.179C94.1405 330.018 93.906 329.937 93.605 329.937H91.715V332.268H93.605ZM99.3131 336.353C98.9211 336.353 98.5711 336.286 98.2631 336.153C97.9551 336.02 97.6926 335.831 97.4756 335.586C97.2586 335.334 97.0906 335.033 96.9716 334.683C96.8596 334.326 96.8036 333.931 96.8036 333.497C96.8036 333.063 96.8596 332.671 96.9716 332.321C97.0906 331.964 97.2586 331.663 97.4756 331.418C97.6926 331.166 97.9551 330.973 98.2631 330.84C98.5711 330.707 98.9211 330.641 99.3131 330.641C99.7121 330.641 100.062 330.711 100.363 330.851C100.671 330.991 100.927 331.187 101.13 331.439C101.333 331.684 101.483 331.971 101.581 332.3C101.686 332.629 101.739 332.982 101.739 333.36V333.791H97.9901V333.969C97.9901 334.389 98.1126 334.736 98.3576 335.009C98.6096 335.275 98.9666 335.408 99.4286 335.408C99.7646 335.408 100.048 335.334 100.279 335.187C100.51 335.04 100.706 334.841 100.867 334.589L101.539 335.25C101.336 335.586 101.042 335.856 100.657 336.059C100.272 336.255 99.8241 336.353 99.3131 336.353ZM99.3131 331.533C99.1171 331.533 98.9351 331.568 98.7671 331.638C98.6061 331.708 98.4661 331.806 98.3471 331.932C98.2351 332.058 98.1476 332.209 98.0846 332.384C98.0216 332.559 97.9901 332.751 97.9901 332.961V333.035H100.531V332.93C100.531 332.51 100.423 332.174 100.206 331.922C99.9886 331.663 99.6911 331.533 99.3131 331.533ZM104.518 336.227C104.119 336.227 103.818 336.125 103.615 335.922C103.412 335.712 103.31 335.418 103.31 335.04V331.701H102.46V330.767H102.922C103.111 330.767 103.24 330.725 103.31 330.641C103.387 330.557 103.426 330.42 103.426 330.231V329.276H104.455V330.767H105.599V331.701H104.455V335.292H105.515V336.227H104.518ZM110.841 336.227C110.54 336.227 110.309 336.143 110.148 335.975C109.987 335.8 109.889 335.579 109.854 335.313H109.801C109.696 335.656 109.504 335.915 109.224 336.09C108.944 336.265 108.604 336.353 108.205 336.353C107.638 336.353 107.201 336.206 106.893 335.912C106.592 335.618 106.441 335.222 106.441 334.725C106.441 334.179 106.637 333.77 107.029 333.497C107.428 333.224 108.009 333.087 108.772 333.087H109.759V332.625C109.759 332.289 109.668 332.03 109.486 331.848C109.304 331.666 109.021 331.575 108.636 331.575C108.314 331.575 108.051 331.645 107.848 331.785C107.645 331.925 107.474 332.104 107.334 332.321L106.651 331.701C106.833 331.393 107.089 331.141 107.418 330.945C107.747 330.742 108.177 330.641 108.709 330.641C109.416 330.641 109.959 330.805 110.337 331.134C110.715 331.463 110.904 331.936 110.904 332.552V335.292H111.481V336.227H110.841ZM108.531 335.481C108.888 335.481 109.182 335.404 109.413 335.25C109.644 335.089 109.759 334.876 109.759 334.61V333.822H108.793C108.002 333.822 107.607 334.067 107.607 334.557V334.746C107.607 334.991 107.687 335.177 107.848 335.303C108.016 335.422 108.244 335.481 108.531 335.481ZM113.181 329.79C112.943 329.79 112.768 329.734 112.656 329.622C112.551 329.51 112.498 329.367 112.498 329.192V329.013C112.498 328.838 112.551 328.695 112.656 328.583C112.768 328.471 112.943 328.415 113.181 328.415C113.419 328.415 113.59 328.471 113.695 328.583C113.8 328.695 113.853 328.838 113.853 329.013V329.192C113.853 329.367 113.8 329.51 113.695 329.622C113.59 329.734 113.419 329.79 113.181 329.79ZM112.603 330.767H113.748V336.227H112.603V330.767ZM116.547 336.227C116.155 336.227 115.861 336.129 115.665 335.933C115.476 335.73 115.382 335.45 115.382 335.093V328.457H116.526V335.292H117.282V336.227H116.547ZM62.5451 351.227C62.2441 351.227 62.0131 351.143 61.8521 350.975C61.6911 350.8 61.5931 350.579 61.5581 350.313H61.5056C61.4006 350.656 61.2081 350.915 60.9281 351.09C60.6481 351.265 60.3086 351.353 59.9096 351.353C59.3426 351.353 58.9051 351.206 58.5971 350.912C58.2961 350.618 58.1456 350.222 58.1456 349.725C58.1456 349.179 58.3416 348.77 58.7336 348.497C59.1326 348.224 59.7136 348.087 60.4766 348.087H61.4636V347.625C61.4636 347.289 61.3726 347.03 61.1906 346.848C61.0086 346.666 60.7251 346.575 60.3401 346.575C60.0181 346.575 59.7556 346.645 59.5526 346.785C59.3496 346.925 59.1781 347.104 59.0381 347.321L58.3556 346.701C58.5376 346.393 58.7931 346.141 59.1221 345.945C59.4511 345.742 59.8816 345.641 60.4136 345.641C61.1206 345.641 61.6631 345.805 62.0411 346.134C62.4191 346.463 62.6081 346.936 62.6081 347.552V350.292H63.1856V351.227H62.5451ZM60.2351 350.481C60.5921 350.481 60.8861 350.404 61.1171 350.25C61.3481 350.089 61.4636 349.876 61.4636 349.61V348.822H60.4976C59.7066 348.822 59.3111 349.067 59.3111 349.557V349.746C59.3111 349.991 59.3916 350.177 59.5526 350.303C59.7206 350.422 59.9481 350.481 60.2351 350.481ZM64.3073 351.227V345.767H65.4518V346.67H65.5043C65.6233 346.376 65.8018 346.131 66.0398 345.935C66.2848 345.739 66.6173 345.641 67.0373 345.641C67.5973 345.641 68.0313 345.826 68.3393 346.197C68.6543 346.561 68.8118 347.083 68.8118 347.762V351.227H67.6673V347.909C67.6673 347.055 67.3243 346.628 66.6383 346.628C66.4913 346.628 66.3443 346.649 66.1973 346.691C66.0573 346.726 65.9313 346.782 65.8193 346.859C65.7073 346.936 65.6163 347.034 65.5463 347.153C65.4833 347.272 65.4518 347.412 65.4518 347.573V351.227H64.3073ZM73.8316 350.324H73.7791C73.6601 350.646 73.4641 350.898 73.1911 351.08C72.9251 351.262 72.6101 351.353 72.2461 351.353C71.5531 351.353 71.0176 351.104 70.6396 350.607C70.2616 350.103 70.0726 349.4 70.0726 348.497C70.0726 347.594 70.2616 346.894 70.6396 346.397C71.0176 345.893 71.5531 345.641 72.2461 345.641C72.6101 345.641 72.9251 345.732 73.1911 345.914C73.4641 346.089 73.6601 346.341 73.7791 346.67H73.8316V343.457H74.9761V351.227H73.8316V350.324ZM72.5926 350.366C72.9426 350.366 73.2366 350.282 73.4746 350.114C73.7126 349.939 73.8316 349.711 73.8316 349.431V347.562C73.8316 347.282 73.7126 347.058 73.4746 346.89C73.2366 346.715 72.9426 346.628 72.5926 346.628C72.1936 346.628 71.8751 346.757 71.6371 347.016C71.3991 347.268 71.2801 347.604 71.2801 348.024V348.969C71.2801 349.389 71.3991 349.729 71.6371 349.988C71.8751 350.24 72.1936 350.366 72.5926 350.366ZM48.7717 359.948V366.227H47.5852V359.948H45.4012V358.898H50.9557V359.948H48.7717ZM53.4832 366.353C53.0912 366.353 52.7412 366.286 52.4332 366.153C52.1252 366.02 51.8627 365.831 51.6457 365.586C51.4287 365.334 51.2607 365.033 51.1417 364.683C51.0297 364.326 50.9737 363.931 50.9737 363.497C50.9737 363.063 51.0297 362.671 51.1417 362.321C51.2607 361.964 51.4287 361.663 51.6457 361.418C51.8627 361.166 52.1252 360.973 52.4332 360.84C52.7412 360.707 53.0912 360.641 53.4832 360.641C53.8822 360.641 54.2322 360.711 54.5332 360.851C54.8412 360.991 55.0967 361.187 55.2997 361.439C55.5027 361.684 55.6532 361.971 55.7512 362.3C55.8562 362.629 55.9087 362.982 55.9087 363.36V363.791H52.1602V363.969C52.1602 364.389 52.2827 364.736 52.5277 365.009C52.7797 365.275 53.1367 365.408 53.5987 365.408C53.9347 365.408 54.2182 365.334 54.4492 365.187C54.6802 365.04 54.8762 364.841 55.0372 364.589L55.7092 365.25C55.5062 365.586 55.2122 365.856 54.8272 366.059C54.4422 366.255 53.9942 366.353 53.4832 366.353ZM53.4832 361.533C53.2872 361.533 53.1052 361.568 52.9372 361.638C52.7762 361.708 52.6362 361.806 52.5172 361.932C52.4052 362.058 52.3177 362.209 52.2547 362.384C52.1917 362.559 52.1602 362.751 52.1602 362.961V363.035H54.7012V362.93C54.7012 362.51 54.5927 362.174 54.3757 361.922C54.1587 361.663 53.8612 361.533 53.4832 361.533ZM58.3412 366.227C57.9492 366.227 57.6552 366.129 57.4592 365.933C57.2702 365.73 57.1757 365.45 57.1757 365.093V358.457H58.3202V365.292H59.0762V366.227H58.3412ZM62.3118 366.353C61.9198 366.353 61.5698 366.286 61.2618 366.153C60.9538 366.02 60.6913 365.831 60.4743 365.586C60.2573 365.334 60.0893 365.033 59.9703 364.683C59.8583 364.326 59.8023 363.931 59.8023 363.497C59.8023 363.063 59.8583 362.671 59.9703 362.321C60.0893 361.964 60.2573 361.663 60.4743 361.418C60.6913 361.166 60.9538 360.973 61.2618 360.84C61.5698 360.707 61.9198 360.641 62.3118 360.641C62.7108 360.641 63.0608 360.711 63.3618 360.851C63.6698 360.991 63.9253 361.187 64.1283 361.439C64.3313 361.684 64.4818 361.971 64.5798 362.3C64.6848 362.629 64.7373 362.982 64.7373 363.36V363.791H60.9888V363.969C60.9888 364.389 61.1113 364.736 61.3563 365.009C61.6083 365.275 61.9653 365.408 62.4273 365.408C62.7633 365.408 63.0468 365.334 63.2778 365.187C63.5088 365.04 63.7048 364.841 63.8658 364.589L64.5378 365.25C64.3348 365.586 64.0408 365.856 63.6558 366.059C63.2708 366.255 62.8228 366.353 62.3118 366.353ZM62.3118 361.533C62.1158 361.533 61.9338 361.568 61.7658 361.638C61.6048 361.708 61.4648 361.806 61.3458 361.932C61.2338 362.058 61.1463 362.209 61.0833 362.384C61.0203 362.559 60.9888 362.751 60.9888 362.961V363.035H63.5298V362.93C63.5298 362.51 63.4213 362.174 63.2043 361.922C62.9873 361.663 62.6898 361.533 62.3118 361.533ZM68.1148 366.353C67.7228 366.353 67.3728 366.286 67.0648 366.153C66.7568 366.02 66.4978 365.831 66.2878 365.586C66.0778 365.334 65.9168 365.033 65.8048 364.683C65.6928 364.326 65.6368 363.931 65.6368 363.497C65.6368 363.063 65.6928 362.671 65.8048 362.321C65.9168 361.964 66.0778 361.663 66.2878 361.418C66.4978 361.166 66.7568 360.973 67.0648 360.84C67.3728 360.707 67.7228 360.641 68.1148 360.641C68.6608 360.641 69.1088 360.763 69.4588 361.008C69.8088 361.253 70.0643 361.579 70.2253 361.985L69.2803 362.426C69.2033 362.174 69.0668 361.974 68.8708 361.827C68.6818 361.673 68.4298 361.596 68.1148 361.596C67.6948 361.596 67.3763 361.729 67.1593 361.995C66.9493 362.254 66.8443 362.594 66.8443 363.014V363.99C66.8443 364.41 66.9493 364.753 67.1593 365.019C67.3763 365.278 67.6948 365.408 68.1148 365.408C68.4508 365.408 68.7168 365.327 68.9128 365.166C69.1158 364.998 69.2768 364.778 69.3958 364.505L70.2673 364.967C70.0853 365.415 69.8123 365.758 69.4483 365.996C69.0843 366.234 68.6398 366.353 68.1148 366.353ZM73.4373 366.353C73.0593 366.353 72.7128 366.286 72.3978 366.153C72.0898 366.02 71.8273 365.831 71.6103 365.586C71.3933 365.334 71.2253 365.033 71.1063 364.683C70.9873 364.326 70.9278 363.931 70.9278 363.497C70.9278 363.063 70.9873 362.671 71.1063 362.321C71.2253 361.964 71.3933 361.663 71.6103 361.418C71.8273 361.166 72.0898 360.973 72.3978 360.84C72.7128 360.707 73.0593 360.641 73.4373 360.641C73.8153 360.641 74.1583 360.707 74.4663 360.84C74.7813 360.973 75.0473 361.166 75.2643 361.418C75.4813 361.663 75.6493 361.964 75.7683 362.321C75.8873 362.671 75.9468 363.063 75.9468 363.497C75.9468 363.931 75.8873 364.326 75.7683 364.683C75.6493 365.033 75.4813 365.334 75.2643 365.586C75.0473 365.831 74.7813 366.02 74.4663 366.153C74.1583 366.286 73.8153 366.353 73.4373 366.353ZM73.4373 365.408C73.8293 365.408 74.1443 365.289 74.3823 365.051C74.6203 364.806 74.7393 364.442 74.7393 363.959V363.035C74.7393 362.552 74.6203 362.191 74.3823 361.953C74.1443 361.708 73.8293 361.586 73.4373 361.586C73.0453 361.586 72.7303 361.708 72.4923 361.953C72.2543 362.191 72.1353 362.552 72.1353 363.035V363.959C72.1353 364.442 72.2543 364.806 72.4923 365.051C72.7303 365.289 73.0453 365.408 73.4373 365.408ZM77.2221 366.227V360.767H78.3666V361.67H78.4191C78.4751 361.53 78.5416 361.397 78.6186 361.271C78.7026 361.145 78.8006 361.036 78.9126 360.945C79.0316 360.847 79.1681 360.774 79.3221 360.725C79.4831 360.669 79.6686 360.641 79.8786 360.641C80.2496 360.641 80.5786 360.732 80.8656 360.914C81.1526 361.096 81.3626 361.376 81.4956 361.754H81.5271C81.6251 361.446 81.8141 361.183 82.0941 360.966C82.3741 360.749 82.7346 360.641 83.1756 360.641C83.7216 360.641 84.1451 360.826 84.4461 361.197C84.7471 361.561 84.8976 362.083 84.8976 362.762V366.227H83.7531V362.898C83.7531 362.478 83.6726 362.163 83.5116 361.953C83.3506 361.736 83.0951 361.628 82.7451 361.628C82.5981 361.628 82.4581 361.649 82.3251 361.691C82.1921 361.726 82.0731 361.782 81.9681 361.859C81.8701 361.936 81.7896 362.034 81.7266 362.153C81.6636 362.272 81.6321 362.408 81.6321 362.562V366.227H80.4876V362.898C80.4876 362.051 80.1551 361.628 79.4901 361.628C79.3501 361.628 79.2101 361.649 79.0701 361.691C78.9371 361.726 78.8181 361.782 78.7131 361.859C78.6081 361.936 78.5241 362.034 78.4611 362.153C78.3981 362.272 78.3666 362.408 78.3666 362.562V366.227H77.2221ZM88.2139 366.353C87.6959 366.353 87.2619 366.262 86.9119 366.08C86.5619 365.898 86.2574 365.646 85.9984 365.324L86.7334 364.652C86.9364 364.897 87.1604 365.089 87.4054 365.229C87.6574 365.362 87.9479 365.429 88.2769 365.429C88.6129 365.429 88.8614 365.366 89.0224 365.24C89.1904 365.107 89.2744 364.925 89.2744 364.694C89.2744 364.519 89.2149 364.372 89.0959 364.253C88.9839 364.127 88.7844 364.046 88.4974 364.011L87.9934 363.948C87.4334 363.878 86.9924 363.717 86.6704 363.465C86.3554 363.206 86.1979 362.825 86.1979 362.321C86.1979 362.055 86.2469 361.82 86.3449 361.617C86.4429 361.407 86.5794 361.232 86.7544 361.092C86.9364 360.945 87.1499 360.833 87.3949 360.756C87.6469 360.679 87.9234 360.641 88.2244 360.641C88.7144 360.641 89.1134 360.718 89.4214 360.872C89.7364 361.026 90.0164 361.239 90.2614 361.512L89.5579 362.184C89.4179 362.016 89.2324 361.873 89.0014 361.754C88.7774 361.628 88.5184 361.565 88.2244 361.565C87.9094 361.565 87.6749 361.628 87.5209 361.754C87.3739 361.88 87.3004 362.044 87.3004 362.247C87.3004 362.457 87.3669 362.615 87.4999 362.72C87.6329 362.825 87.8464 362.902 88.1404 362.951L88.6444 363.014C89.2464 363.105 89.6839 363.283 89.9569 363.549C90.2369 363.808 90.3769 364.158 90.3769 364.599C90.3769 364.865 90.3244 365.107 90.2194 365.324C90.1214 365.534 89.9779 365.716 89.7889 365.87C89.5999 366.024 89.3724 366.143 89.1064 366.227C88.8404 366.311 88.5429 366.353 88.2139 366.353Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M148 209.227C148 204.256 152.029 200.227 157 200.227H275C279.971 200.227 284 204.256 284 209.227V379.227C284 384.197 279.971 388.227 275 388.227H157C152.029 388.227 148 384.197 148 379.227V209.227Z",
                                                                fill: "#CC9200"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M148.5 209.227C148.5 204.532 152.306 200.727 157 200.727H275C279.694 200.727 283.5 204.532 283.5 209.227V379.227C283.5 383.921 279.694 387.727 275 387.727H157C152.306 387.727 148.5 383.921 148.5 379.227V209.227Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.04"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M198 224.227C198 220.913 200.686 218.227 204 218.227H228C231.314 218.227 234 220.913 234 224.227V248.227C234 251.54 231.314 254.227 228 254.227H204C200.686 254.227 198 251.54 198 248.227V224.227Z",
                                                                fill: "#FFF1CC"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M198.5 224.227C198.5 221.189 200.962 218.727 204 218.727H228C231.038 218.727 233.5 221.189 233.5 224.227V248.227C233.5 251.264 231.038 253.727 228 253.727H204C200.962 253.727 198.5 251.264 198.5 248.227V224.227Z",
                                                                stroke: "black",
                                                                strokeOpacity: "0.08"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                                                clipPath: "url(#clip3_5592_7504)",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M209.503 232.477H212.759C213.055 231.418 213.446 230.515 213.838 229.78C214.01 229.457 214.183 229.167 214.347 228.909C212.28 229.374 210.535 230.693 209.503 232.477ZM216 229.151C215.758 229.478 215.461 229.926 215.162 230.486C214.865 231.041 214.568 231.707 214.324 232.477H217.676C217.432 231.707 217.135 231.041 216.838 230.486C216.539 229.926 216.242 229.478 216 229.151ZM218.049 233.977H213.951C213.825 234.668 213.75 235.419 213.75 236.227C213.75 237.035 213.825 237.786 213.951 238.477H218.049C218.175 237.786 218.25 237.035 218.25 236.227C218.25 235.419 218.175 234.668 218.049 233.977ZM219.571 238.477C219.684 237.777 219.75 237.026 219.75 236.227C219.75 235.427 219.684 234.676 219.571 233.977H223.157C223.38 234.686 223.5 235.442 223.5 236.227C223.5 237.011 223.38 237.767 223.157 238.477H219.571ZM217.676 239.977H214.324C214.568 240.746 214.865 241.412 215.162 241.967C215.461 242.528 215.758 242.975 216 243.302C216.242 242.975 216.539 242.528 216.838 241.967C217.135 241.412 217.432 240.746 217.676 239.977ZM214.347 243.544C214.183 243.286 214.01 242.996 213.838 242.673C213.446 241.938 213.055 241.035 212.759 239.977H209.503C210.535 241.76 212.28 243.079 214.347 243.544ZM208.843 238.477H212.429C212.316 237.777 212.25 237.026 212.25 236.227C212.25 235.427 212.316 234.676 212.429 233.977H208.843C208.62 234.686 208.5 235.442 208.5 236.227C208.5 237.011 208.62 237.767 208.843 238.477ZM217.653 243.544C217.817 243.286 217.99 242.996 218.162 242.673C218.554 241.938 218.945 241.035 219.241 239.977H222.497C221.465 241.76 219.72 243.079 217.653 243.544ZM222.497 232.477H219.241C218.945 231.418 218.554 230.515 218.162 229.78C217.99 229.457 217.817 229.167 217.653 228.909C219.72 229.374 221.465 230.693 222.497 232.477ZM207.614 232.954C208.922 229.603 212.183 227.227 216 227.227C219.817 227.227 223.078 229.603 224.386 232.954C224.783 233.969 225 235.073 225 236.227C225 237.38 224.783 238.484 224.386 239.499C223.078 242.85 219.817 245.227 216 245.227C212.183 245.227 208.922 242.85 207.614 239.499C207.217 238.484 207 237.38 207 236.227C207 235.073 207.217 233.969 207.614 232.954Z",
                                                                    fill: "#CC9200"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M179.617 273.257V282.227H177.922V273.257H174.802V271.757H182.737V273.257H179.617ZM186.348 282.407C185.808 282.407 185.313 282.312 184.863 282.122C184.423 281.932 184.048 281.662 183.738 281.312C183.428 280.952 183.188 280.522 183.018 280.022C182.848 279.512 182.763 278.947 182.763 278.327C182.763 277.707 182.848 277.147 183.018 276.647C183.188 276.137 183.428 275.707 183.738 275.357C184.048 274.997 184.423 274.722 184.863 274.532C185.313 274.342 185.808 274.247 186.348 274.247C186.888 274.247 187.378 274.342 187.818 274.532C188.268 274.722 188.648 274.997 188.958 275.357C189.268 275.707 189.508 276.137 189.678 276.647C189.848 277.147 189.933 277.707 189.933 278.327C189.933 278.947 189.848 279.512 189.678 280.022C189.508 280.522 189.268 280.952 188.958 281.312C188.648 281.662 188.268 281.932 187.818 282.122C187.378 282.312 186.888 282.407 186.348 282.407ZM186.348 281.057C186.908 281.057 187.358 280.887 187.698 280.547C188.038 280.197 188.208 279.677 188.208 278.987V277.667C188.208 276.977 188.038 276.462 187.698 276.122C187.358 275.772 186.908 275.597 186.348 275.597C185.788 275.597 185.338 275.772 184.998 276.122C184.658 276.462 184.488 276.977 184.488 277.667V278.987C184.488 279.677 184.658 280.197 184.998 280.547C185.338 280.887 185.788 281.057 186.348 281.057ZM191.755 274.427H193.39V275.717H193.465C193.635 275.247 193.91 274.887 194.29 274.637C194.68 274.377 195.135 274.247 195.655 274.247C196.645 274.247 197.41 274.607 197.95 275.327C198.49 276.037 198.76 277.037 198.76 278.327C198.76 279.617 198.49 280.622 197.95 281.342C197.41 282.052 196.645 282.407 195.655 282.407C195.135 282.407 194.68 282.277 194.29 282.017C193.91 281.757 193.635 281.397 193.465 280.937H193.39V285.227H191.755V274.427ZM195.16 280.997C195.73 280.997 196.185 280.817 196.525 280.457C196.865 280.087 197.035 279.602 197.035 279.002V277.652C197.035 277.052 196.865 276.572 196.525 276.212C196.185 275.842 195.73 275.657 195.16 275.657C194.66 275.657 194.24 275.782 193.9 276.032C193.56 276.272 193.39 276.592 193.39 276.992V279.662C193.39 280.062 193.56 280.387 193.9 280.637C194.24 280.877 194.66 280.997 195.16 280.997ZM205.992 282.227H204.297V271.757H208.812C209.752 271.757 210.492 272.042 211.032 272.612C211.572 273.172 211.842 273.937 211.842 274.907C211.842 275.657 211.667 276.282 211.317 276.782C210.977 277.272 210.472 277.617 209.802 277.817L212.067 282.227H210.177L208.077 277.997H205.992V282.227ZM208.692 276.572C209.122 276.572 209.457 276.462 209.697 276.242C209.937 276.012 210.057 275.687 210.057 275.267V274.547C210.057 274.127 209.937 273.807 209.697 273.587C209.457 273.357 209.122 273.242 208.692 273.242H205.992V276.572H208.692ZM216.846 282.407C216.286 282.407 215.786 282.312 215.346 282.122C214.906 281.932 214.531 281.662 214.221 281.312C213.911 280.952 213.671 280.522 213.501 280.022C213.341 279.512 213.261 278.947 213.261 278.327C213.261 277.707 213.341 277.147 213.501 276.647C213.671 276.137 213.911 275.707 214.221 275.357C214.531 274.997 214.906 274.722 215.346 274.532C215.786 274.342 216.286 274.247 216.846 274.247C217.416 274.247 217.916 274.347 218.346 274.547C218.786 274.747 219.151 275.027 219.441 275.387C219.731 275.737 219.946 276.147 220.086 276.617C220.236 277.087 220.311 277.592 220.311 278.132V278.747H214.956V279.002C214.956 279.602 215.131 280.097 215.481 280.487C215.841 280.867 216.351 281.057 217.011 281.057C217.491 281.057 217.896 280.952 218.226 280.742C218.556 280.532 218.836 280.247 219.066 279.887L220.026 280.832C219.736 281.312 219.316 281.697 218.766 281.987C218.216 282.267 217.576 282.407 216.846 282.407ZM216.846 275.522C216.566 275.522 216.306 275.572 216.066 275.672C215.836 275.772 215.636 275.912 215.466 276.092C215.306 276.272 215.181 276.487 215.091 276.737C215.001 276.987 214.956 277.262 214.956 277.562V277.667H218.586V277.517C218.586 276.917 218.431 276.437 218.121 276.077C217.811 275.707 217.386 275.522 216.846 275.522ZM228.961 282.962C228.961 283.772 228.651 284.382 228.031 284.792C227.411 285.202 226.401 285.407 225.001 285.407C224.361 285.407 223.816 285.362 223.366 285.272C222.926 285.192 222.561 285.072 222.271 284.912C221.991 284.752 221.786 284.557 221.656 284.327C221.526 284.097 221.461 283.832 221.461 283.532C221.461 283.102 221.576 282.767 221.806 282.527C222.046 282.287 222.376 282.122 222.796 282.032V281.867C222.206 281.677 221.911 281.277 221.911 280.667C221.911 280.267 222.046 279.962 222.316 279.752C222.586 279.532 222.911 279.377 223.291 279.287V279.227C222.831 279.007 222.476 278.702 222.226 278.312C221.986 277.912 221.866 277.447 221.866 276.917C221.866 276.117 222.131 275.472 222.661 274.982C223.201 274.492 223.971 274.247 224.971 274.247C225.521 274.247 225.991 274.327 226.381 274.487V274.277C226.381 273.927 226.461 273.657 226.621 273.467C226.791 273.267 227.051 273.167 227.401 273.167H228.601V274.487H227.011V274.802C227.361 275.032 227.631 275.332 227.821 275.702C228.011 276.062 228.106 276.467 228.106 276.917C228.106 277.707 227.836 278.347 227.296 278.837C226.756 279.317 225.986 279.557 224.986 279.557C224.606 279.557 224.266 279.517 223.966 279.437C223.766 279.507 223.591 279.607 223.441 279.737C223.291 279.857 223.216 280.017 223.216 280.217C223.216 280.427 223.311 280.577 223.501 280.667C223.691 280.757 223.961 280.802 224.311 280.802H226.231C227.191 280.802 227.886 280.997 228.316 281.387C228.746 281.767 228.961 282.292 228.961 282.962ZM227.431 283.142C227.431 282.872 227.326 282.657 227.116 282.497C226.916 282.337 226.546 282.257 226.006 282.257H223.366C223.006 282.467 222.826 282.767 222.826 283.157C222.826 283.477 222.951 283.732 223.201 283.922C223.461 284.122 223.896 284.222 224.506 284.222H225.526C226.796 284.222 227.431 283.862 227.431 283.142ZM224.986 278.372C225.466 278.372 225.836 278.267 226.096 278.057C226.366 277.837 226.501 277.502 226.501 277.052V276.752C226.501 276.302 226.366 275.972 226.096 275.762C225.836 275.542 225.466 275.432 224.986 275.432C224.506 275.432 224.131 275.542 223.861 275.762C223.601 275.972 223.471 276.302 223.471 276.752V277.052C223.471 277.502 223.601 277.837 223.861 278.057C224.131 278.267 224.506 278.372 224.986 278.372ZM231.003 273.032C230.663 273.032 230.413 272.952 230.253 272.792C230.103 272.632 230.028 272.427 230.028 272.177V271.922C230.028 271.672 230.103 271.467 230.253 271.307C230.413 271.147 230.663 271.067 231.003 271.067C231.343 271.067 231.588 271.147 231.738 271.307C231.888 271.467 231.963 271.672 231.963 271.922V272.177C231.963 272.427 231.888 272.632 231.738 272.792C231.588 272.952 231.343 273.032 231.003 273.032ZM230.178 274.427H231.813V282.227H230.178V274.427ZM237.208 282.407C236.668 282.407 236.173 282.312 235.723 282.122C235.283 281.932 234.908 281.662 234.598 281.312C234.288 280.952 234.048 280.522 233.878 280.022C233.708 279.512 233.623 278.947 233.623 278.327C233.623 277.707 233.708 277.147 233.878 276.647C234.048 276.137 234.288 275.707 234.598 275.357C234.908 274.997 235.283 274.722 235.723 274.532C236.173 274.342 236.668 274.247 237.208 274.247C237.748 274.247 238.238 274.342 238.678 274.532C239.128 274.722 239.508 274.997 239.818 275.357C240.128 275.707 240.368 276.137 240.538 276.647C240.708 277.147 240.793 277.707 240.793 278.327C240.793 278.947 240.708 279.512 240.538 280.022C240.368 280.522 240.128 280.952 239.818 281.312C239.508 281.662 239.128 281.932 238.678 282.122C238.238 282.312 237.748 282.407 237.208 282.407ZM237.208 281.057C237.768 281.057 238.218 280.887 238.558 280.547C238.898 280.197 239.068 279.677 239.068 278.987V277.667C239.068 276.977 238.898 276.462 238.558 276.122C238.218 275.772 237.768 275.597 237.208 275.597C236.648 275.597 236.198 275.772 235.858 276.122C235.518 276.462 235.348 276.977 235.348 277.667V278.987C235.348 279.677 235.518 280.197 235.858 280.547C236.198 280.887 236.648 281.057 237.208 281.057ZM242.614 282.227V274.427H244.249V275.717H244.324C244.494 275.297 244.749 274.947 245.089 274.667C245.439 274.387 245.914 274.247 246.514 274.247C247.314 274.247 247.934 274.512 248.374 275.042C248.824 275.562 249.049 276.307 249.049 277.277V282.227H247.414V277.487C247.414 276.267 246.924 275.657 245.944 275.657C245.734 275.657 245.524 275.687 245.314 275.747C245.114 275.797 244.934 275.877 244.774 275.987C244.614 276.097 244.484 276.237 244.384 276.407C244.294 276.577 244.249 276.777 244.249 277.007V282.227H242.614ZM253.791 282.407C253.051 282.407 252.431 282.277 251.931 282.017C251.431 281.757 250.996 281.397 250.626 280.937L251.676 279.977C251.966 280.327 252.286 280.602 252.636 280.802C252.996 280.992 253.411 281.087 253.881 281.087C254.361 281.087 254.716 280.997 254.946 280.817C255.186 280.627 255.306 280.367 255.306 280.037C255.306 279.787 255.221 279.577 255.051 279.407C254.891 279.227 254.606 279.112 254.196 279.062L253.476 278.972C252.676 278.872 252.046 278.642 251.586 278.282C251.136 277.912 250.911 277.367 250.911 276.647C250.911 276.267 250.981 275.932 251.121 275.642C251.261 275.342 251.456 275.092 251.706 274.892C251.966 274.682 252.271 274.522 252.621 274.412C252.981 274.302 253.376 274.247 253.806 274.247C254.506 274.247 255.076 274.357 255.516 274.577C255.966 274.797 256.366 275.102 256.716 275.492L255.711 276.452C255.511 276.212 255.246 276.007 254.916 275.837C254.596 275.657 254.226 275.567 253.806 275.567C253.356 275.567 253.021 275.657 252.801 275.837C252.591 276.017 252.486 276.252 252.486 276.542C252.486 276.842 252.581 277.067 252.771 277.217C252.961 277.367 253.266 277.477 253.686 277.547L254.406 277.637C255.266 277.767 255.891 278.022 256.281 278.402C256.681 278.772 256.881 279.272 256.881 279.902C256.881 280.282 256.806 280.627 256.656 280.937C256.516 281.237 256.311 281.497 256.041 281.717C255.771 281.937 255.446 282.107 255.066 282.227C254.686 282.347 254.261 282.407 253.791 282.407Z",
                                                                fill: "white",
                                                                fillOpacity: "0.98"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M170.761 306.227V304.799H167.359V303.78L170.33 298.898H171.884V303.864H172.882V304.799H171.884V306.227H170.761ZM168.367 303.864H170.761V299.979H170.687L168.367 303.864ZM178.968 306.227H173.991V305.093L176.332 303.003C176.703 302.667 176.987 302.349 177.183 302.048C177.386 301.74 177.487 301.418 177.487 301.082V300.945C177.487 300.588 177.379 300.308 177.162 300.105C176.952 299.902 176.665 299.801 176.301 299.801C176.098 299.801 175.919 299.832 175.765 299.895C175.618 299.951 175.489 300.032 175.377 300.137C175.265 300.242 175.17 300.364 175.093 300.504C175.023 300.644 174.967 300.795 174.925 300.956L173.886 300.557C173.963 300.326 174.068 300.105 174.201 299.895C174.334 299.678 174.502 299.486 174.705 299.318C174.908 299.15 175.146 299.017 175.419 298.919C175.699 298.821 176.024 298.772 176.395 298.772C176.766 298.772 177.099 298.828 177.393 298.94C177.687 299.045 177.932 299.195 178.128 299.391C178.331 299.58 178.485 299.808 178.59 300.074C178.695 300.34 178.747 300.63 178.747 300.945C178.747 301.239 178.702 301.512 178.611 301.764C178.52 302.016 178.394 302.254 178.233 302.478C178.072 302.702 177.883 302.916 177.666 303.119C177.456 303.322 177.232 303.528 176.994 303.738L175.272 305.219H178.968V306.227ZM181.484 306.227L186.566 298.898H187.626L182.544 306.227H181.484ZM181.956 302.93C181.389 302.93 180.955 302.755 180.654 302.405C180.353 302.048 180.203 301.53 180.203 300.851C180.203 300.172 180.353 299.657 180.654 299.307C180.955 298.95 181.389 298.772 181.956 298.772C182.523 298.772 182.957 298.95 183.258 299.307C183.559 299.657 183.71 300.172 183.71 300.851C183.71 301.53 183.559 302.048 183.258 302.405C182.957 302.755 182.523 302.93 181.956 302.93ZM181.956 302.226C182.453 302.226 182.702 301.866 182.702 301.145V300.557C182.702 299.836 182.453 299.475 181.956 299.475C181.459 299.475 181.211 299.836 181.211 300.557V301.145C181.211 301.866 181.459 302.226 181.956 302.226ZM187.154 306.353C186.587 306.353 186.153 306.178 185.852 305.828C185.551 305.471 185.4 304.953 185.4 304.274C185.4 303.595 185.551 303.08 185.852 302.73C186.153 302.373 186.587 302.195 187.154 302.195C187.721 302.195 188.155 302.373 188.456 302.73C188.757 303.08 188.907 303.595 188.907 304.274C188.907 304.953 188.757 305.471 188.456 305.828C188.155 306.178 187.721 306.353 187.154 306.353ZM187.154 305.649C187.651 305.649 187.899 305.289 187.899 304.568V303.98C187.899 303.259 187.651 302.898 187.154 302.898C186.657 302.898 186.408 303.259 186.408 303.98V304.568C186.408 305.289 186.657 305.649 187.154 305.649ZM194.888 302.174L194.079 300.62H194.048V306.227H192.914V298.898H194.237L196.631 302.951L197.439 304.505H197.471V298.898H198.605V306.227H197.282L194.888 302.174ZM202.468 306.353C202.09 306.353 201.743 306.286 201.428 306.153C201.12 306.02 200.858 305.831 200.641 305.586C200.424 305.334 200.256 305.033 200.137 304.683C200.018 304.326 199.958 303.931 199.958 303.497C199.958 303.063 200.018 302.671 200.137 302.321C200.256 301.964 200.424 301.663 200.641 301.418C200.858 301.166 201.12 300.973 201.428 300.84C201.743 300.707 202.09 300.641 202.468 300.641C202.846 300.641 203.189 300.707 203.497 300.84C203.812 300.973 204.078 301.166 204.295 301.418C204.512 301.663 204.68 301.964 204.799 302.321C204.918 302.671 204.977 303.063 204.977 303.497C204.977 303.931 204.918 304.326 204.799 304.683C204.68 305.033 204.512 305.334 204.295 305.586C204.078 305.831 203.812 306.02 203.497 306.153C203.189 306.286 202.846 306.353 202.468 306.353ZM202.468 305.408C202.86 305.408 203.175 305.289 203.413 305.051C203.651 304.806 203.77 304.442 203.77 303.959V303.035C203.77 302.552 203.651 302.191 203.413 301.953C203.175 301.708 202.86 301.586 202.468 301.586C202.076 301.586 201.761 301.708 201.523 301.953C201.285 302.191 201.166 302.552 201.166 303.035V303.959C201.166 304.442 201.285 304.806 201.523 305.051C201.761 305.289 202.076 305.408 202.468 305.408ZM206.252 306.227V300.767H207.397V301.817H207.449C207.526 301.537 207.687 301.292 207.932 301.082C208.177 300.872 208.517 300.767 208.951 300.767H209.255V301.869H208.804C208.349 301.869 207.999 301.943 207.754 302.09C207.516 302.237 207.397 302.454 207.397 302.741V306.227H206.252ZM211.825 306.227C211.426 306.227 211.125 306.125 210.922 305.922C210.719 305.712 210.617 305.418 210.617 305.04V301.701H209.767V300.767H210.229C210.418 300.767 210.547 300.725 210.617 300.641C210.694 300.557 210.733 300.42 210.733 300.231V299.276H211.762V300.767H212.906V301.701H211.762V305.292H212.822V306.227H211.825ZM214.148 298.457H215.292V301.67H215.345C215.464 301.376 215.642 301.131 215.88 300.935C216.125 300.739 216.458 300.641 216.878 300.641C217.438 300.641 217.872 300.826 218.18 301.197C218.495 301.561 218.652 302.083 218.652 302.762V306.227H217.508V302.898C217.508 302.051 217.165 301.628 216.479 301.628C216.332 301.628 216.185 301.649 216.038 301.691C215.898 301.726 215.772 301.782 215.66 301.859C215.548 301.936 215.457 302.034 215.387 302.153C215.324 302.272 215.292 302.408 215.292 302.562V306.227H214.148V298.457ZM227.382 306.227L226.721 304.242H223.98L223.34 306.227H222.132L224.631 298.898H226.122L228.621 306.227H227.382ZM225.377 299.99H225.324L224.264 303.224H226.427L225.377 299.99ZM229.672 306.227V300.767H230.817V301.67H230.869C230.925 301.53 230.992 301.397 231.069 301.271C231.153 301.145 231.251 301.036 231.363 300.945C231.482 300.847 231.618 300.774 231.772 300.725C231.933 300.669 232.119 300.641 232.329 300.641C232.7 300.641 233.029 300.732 233.316 300.914C233.603 301.096 233.813 301.376 233.946 301.754H233.977C234.075 301.446 234.264 301.183 234.544 300.966C234.824 300.749 235.185 300.641 235.626 300.641C236.172 300.641 236.595 300.826 236.896 301.197C237.197 301.561 237.348 302.083 237.348 302.762V306.227H236.203V302.898C236.203 302.478 236.123 302.163 235.962 301.953C235.801 301.736 235.545 301.628 235.195 301.628C235.048 301.628 234.908 301.649 234.775 301.691C234.642 301.726 234.523 301.782 234.418 301.859C234.32 301.936 234.24 302.034 234.177 302.153C234.114 302.272 234.082 302.408 234.082 302.562V306.227H232.938V302.898C232.938 302.051 232.605 301.628 231.94 301.628C231.8 301.628 231.66 301.649 231.52 301.691C231.387 301.726 231.268 301.782 231.163 301.859C231.058 301.936 230.974 302.034 230.911 302.153C230.848 302.272 230.817 302.408 230.817 302.562V306.227H229.672ZM241.074 306.353C240.682 306.353 240.332 306.286 240.024 306.153C239.716 306.02 239.453 305.831 239.236 305.586C239.019 305.334 238.851 305.033 238.732 304.683C238.62 304.326 238.564 303.931 238.564 303.497C238.564 303.063 238.62 302.671 238.732 302.321C238.851 301.964 239.019 301.663 239.236 301.418C239.453 301.166 239.716 300.973 240.024 300.84C240.332 300.707 240.682 300.641 241.074 300.641C241.473 300.641 241.823 300.711 242.124 300.851C242.432 300.991 242.687 301.187 242.89 301.439C243.093 301.684 243.244 301.971 243.342 302.3C243.447 302.629 243.499 302.982 243.499 303.36V303.791H239.751V303.969C239.751 304.389 239.873 304.736 240.118 305.009C240.37 305.275 240.727 305.408 241.189 305.408C241.525 305.408 241.809 305.334 242.04 305.187C242.271 305.04 242.467 304.841 242.628 304.589L243.3 305.25C243.097 305.586 242.803 305.856 242.418 306.059C242.033 306.255 241.585 306.353 241.074 306.353ZM241.074 301.533C240.878 301.533 240.696 301.568 240.528 301.638C240.367 301.708 240.227 301.806 240.108 301.932C239.996 302.058 239.908 302.209 239.845 302.384C239.782 302.559 239.751 302.751 239.751 302.961V303.035H242.292V302.93C242.292 302.51 242.183 302.174 241.966 301.922C241.749 301.663 241.452 301.533 241.074 301.533ZM244.766 306.227V300.767H245.911V301.817H245.963C246.04 301.537 246.201 301.292 246.446 301.082C246.691 300.872 247.031 300.767 247.465 300.767H247.769V301.869H247.318C246.863 301.869 246.513 301.943 246.268 302.09C246.03 302.237 245.911 302.454 245.911 302.741V306.227H244.766ZM249.363 299.79C249.125 299.79 248.95 299.734 248.838 299.622C248.733 299.51 248.681 299.367 248.681 299.192V299.013C248.681 298.838 248.733 298.695 248.838 298.583C248.95 298.471 249.125 298.415 249.363 298.415C249.601 298.415 249.773 298.471 249.878 298.583C249.983 298.695 250.035 298.838 250.035 299.013V299.192C250.035 299.367 249.983 299.51 249.878 299.622C249.773 299.734 249.601 299.79 249.363 299.79ZM248.786 300.767H249.93V306.227H248.786V300.767ZM253.675 306.353C253.283 306.353 252.933 306.286 252.625 306.153C252.317 306.02 252.058 305.831 251.848 305.586C251.638 305.334 251.477 305.033 251.365 304.683C251.253 304.326 251.197 303.931 251.197 303.497C251.197 303.063 251.253 302.671 251.365 302.321C251.477 301.964 251.638 301.663 251.848 301.418C252.058 301.166 252.317 300.973 252.625 300.84C252.933 300.707 253.283 300.641 253.675 300.641C254.221 300.641 254.669 300.763 255.019 301.008C255.369 301.253 255.624 301.579 255.785 301.985L254.84 302.426C254.763 302.174 254.627 301.974 254.431 301.827C254.242 301.673 253.99 301.596 253.675 301.596C253.255 301.596 252.936 301.729 252.719 301.995C252.509 302.254 252.404 302.594 252.404 303.014V303.99C252.404 304.41 252.509 304.753 252.719 305.019C252.936 305.278 253.255 305.408 253.675 305.408C254.011 305.408 254.277 305.327 254.473 305.166C254.676 304.998 254.837 304.778 254.956 304.505L255.827 304.967C255.645 305.415 255.372 305.758 255.008 305.996C254.644 306.234 254.2 306.353 253.675 306.353ZM260.917 306.227C260.616 306.227 260.385 306.143 260.224 305.975C260.063 305.8 259.965 305.579 259.93 305.313H259.878C259.773 305.656 259.58 305.915 259.3 306.09C259.02 306.265 258.681 306.353 258.282 306.353C257.715 306.353 257.277 306.206 256.969 305.912C256.668 305.618 256.518 305.222 256.518 304.725C256.518 304.179 256.714 303.77 257.106 303.497C257.505 303.224 258.086 303.087 258.849 303.087H259.836V302.625C259.836 302.289 259.745 302.03 259.563 301.848C259.381 301.666 259.097 301.575 258.712 301.575C258.39 301.575 258.128 301.645 257.925 301.785C257.722 301.925 257.55 302.104 257.41 302.321L256.728 301.701C256.91 301.393 257.165 301.141 257.494 300.945C257.823 300.742 258.254 300.641 258.786 300.641C259.493 300.641 260.035 300.805 260.413 301.134C260.791 301.463 260.98 301.936 260.98 302.552V305.292H261.558V306.227H260.917ZM258.607 305.481C258.964 305.481 259.258 305.404 259.489 305.25C259.72 305.089 259.836 304.876 259.836 304.61V303.822H258.87C258.079 303.822 257.683 304.067 257.683 304.557V304.746C257.683 304.991 257.764 305.177 257.925 305.303C258.093 305.422 258.32 305.481 258.607 305.481ZM263.486 304.767C263.745 304.767 263.937 304.834 264.063 304.967C264.189 305.1 264.252 305.271 264.252 305.481V305.649C264.252 305.992 264.158 306.349 263.969 306.72C263.787 307.098 263.538 307.417 263.223 307.676H262.373C262.597 307.452 262.782 307.235 262.929 307.025C263.076 306.815 263.188 306.58 263.265 306.321C263.083 306.286 262.947 306.209 262.856 306.09C262.765 305.964 262.719 305.817 262.719 305.649V305.481C262.719 305.271 262.782 305.1 262.908 304.967C263.034 304.834 263.227 304.767 263.486 304.767ZM189.37 321.227H184.393V320.093L186.735 318.003C187.106 317.667 187.389 317.349 187.585 317.048C187.788 316.74 187.89 316.418 187.89 316.082V315.945C187.89 315.588 187.781 315.308 187.564 315.105C187.354 314.902 187.067 314.801 186.703 314.801C186.5 314.801 186.322 314.832 186.168 314.895C186.021 314.951 185.891 315.032 185.779 315.137C185.667 315.242 185.573 315.364 185.496 315.504C185.426 315.644 185.37 315.795 185.328 315.956L184.288 315.557C184.365 315.326 184.47 315.105 184.603 314.895C184.736 314.678 184.904 314.486 185.107 314.318C185.31 314.15 185.548 314.017 185.821 313.919C186.101 313.821 186.427 313.772 186.798 313.772C187.169 313.772 187.501 313.828 187.795 313.94C188.089 314.045 188.334 314.195 188.53 314.391C188.733 314.58 188.887 314.808 188.992 315.074C189.097 315.34 189.15 315.63 189.15 315.945C189.15 316.239 189.104 316.512 189.013 316.764C188.922 317.016 188.796 317.254 188.635 317.478C188.474 317.702 188.285 317.916 188.068 318.119C187.858 318.322 187.634 318.528 187.396 318.738L185.674 320.219H189.37V321.227ZM193.157 321.353C192.751 321.353 192.387 321.286 192.065 321.153C191.75 321.02 191.48 320.831 191.256 320.586C191.039 320.334 190.871 320.033 190.752 319.683C190.633 319.333 190.574 318.938 190.574 318.497C190.574 317.965 190.654 317.464 190.815 316.995C190.976 316.526 191.183 316.096 191.435 315.704C191.687 315.312 191.967 314.965 192.275 314.664C192.59 314.356 192.898 314.101 193.199 313.898H194.774C194.361 314.199 193.99 314.489 193.661 314.769C193.332 315.049 193.045 315.336 192.8 315.63C192.555 315.924 192.348 316.236 192.18 316.565C192.019 316.894 191.893 317.254 191.802 317.646L191.876 317.667C191.953 317.52 192.04 317.384 192.138 317.258C192.243 317.125 192.362 317.009 192.495 316.911C192.635 316.813 192.793 316.736 192.968 316.68C193.143 316.624 193.346 316.596 193.577 316.596C193.885 316.596 194.168 316.649 194.427 316.754C194.693 316.859 194.921 317.013 195.11 317.216C195.306 317.412 195.456 317.65 195.561 317.93C195.673 318.21 195.729 318.521 195.729 318.864C195.729 319.235 195.666 319.575 195.54 319.883C195.421 320.184 195.25 320.443 195.026 320.66C194.802 320.877 194.529 321.048 194.207 321.174C193.892 321.293 193.542 321.353 193.157 321.353ZM193.157 320.387C193.584 320.387 193.916 320.275 194.154 320.051C194.392 319.82 194.511 319.484 194.511 319.043V318.896C194.511 318.455 194.392 318.122 194.154 317.898C193.916 317.667 193.584 317.552 193.157 317.552C192.73 317.552 192.397 317.667 192.159 317.898C191.921 318.122 191.802 318.455 191.802 318.896V319.043C191.802 319.484 191.921 319.82 192.159 320.051C192.397 320.275 192.73 320.387 193.157 320.387ZM198.182 321.227L203.264 313.898H204.325L199.243 321.227H198.182ZM198.655 317.93C198.088 317.93 197.654 317.755 197.353 317.405C197.052 317.048 196.901 316.53 196.901 315.851C196.901 315.172 197.052 314.657 197.353 314.307C197.654 313.95 198.088 313.772 198.655 313.772C199.222 313.772 199.656 313.95 199.957 314.307C200.258 314.657 200.408 315.172 200.408 315.851C200.408 316.53 200.258 317.048 199.957 317.405C199.656 317.755 199.222 317.93 198.655 317.93ZM198.655 317.226C199.152 317.226 199.4 316.866 199.4 316.145V315.557C199.4 314.836 199.152 314.475 198.655 314.475C198.158 314.475 197.909 314.836 197.909 315.557V316.145C197.909 316.866 198.158 317.226 198.655 317.226ZM203.852 321.353C203.285 321.353 202.851 321.178 202.55 320.828C202.249 320.471 202.099 319.953 202.099 319.274C202.099 318.595 202.249 318.08 202.55 317.73C202.851 317.373 203.285 317.195 203.852 317.195C204.419 317.195 204.853 317.373 205.154 317.73C205.455 318.08 205.606 318.595 205.606 319.274C205.606 319.953 205.455 320.471 205.154 320.828C204.853 321.178 204.419 321.353 203.852 321.353ZM203.852 320.649C204.349 320.649 204.598 320.289 204.598 319.568V318.98C204.598 318.259 204.349 317.898 203.852 317.898C203.355 317.898 203.107 318.259 203.107 318.98V319.568C203.107 320.289 203.355 320.649 203.852 320.649ZM209.612 321.227V313.898H214.306V314.948H210.799V316.985H213.98V318.035H210.799V320.177H214.306V321.227H209.612ZM219.06 320.324H219.018C218.969 320.457 218.903 320.586 218.819 320.712C218.742 320.838 218.64 320.95 218.514 321.048C218.395 321.139 218.248 321.213 218.073 321.269C217.905 321.325 217.709 321.353 217.485 321.353C216.918 321.353 216.477 321.171 216.162 320.807C215.854 320.443 215.7 319.921 215.7 319.242V315.767H216.845V319.095C216.845 319.942 217.195 320.366 217.895 320.366C218.042 320.366 218.185 320.348 218.325 320.313C218.465 320.271 218.588 320.212 218.693 320.135C218.805 320.058 218.892 319.96 218.955 319.841C219.025 319.722 219.06 319.582 219.06 319.421V315.767H220.205V321.227H219.06V320.324ZM221.843 321.227V315.767H222.988V316.817H223.04C223.117 316.537 223.278 316.292 223.523 316.082C223.768 315.872 224.108 315.767 224.542 315.767H224.846V316.869H224.395C223.94 316.869 223.59 316.943 223.345 317.09C223.107 317.237 222.988 317.454 222.988 317.741V321.227H221.843ZM227.954 321.353C227.576 321.353 227.229 321.286 226.914 321.153C226.606 321.02 226.344 320.831 226.127 320.586C225.91 320.334 225.742 320.033 225.623 319.683C225.504 319.326 225.444 318.931 225.444 318.497C225.444 318.063 225.504 317.671 225.623 317.321C225.742 316.964 225.91 316.663 226.127 316.418C226.344 316.166 226.606 315.973 226.914 315.84C227.229 315.707 227.576 315.641 227.954 315.641C228.332 315.641 228.675 315.707 228.983 315.84C229.298 315.973 229.564 316.166 229.781 316.418C229.998 316.663 230.166 316.964 230.285 317.321C230.404 317.671 230.463 318.063 230.463 318.497C230.463 318.931 230.404 319.326 230.285 319.683C230.166 320.033 229.998 320.334 229.781 320.586C229.564 320.831 229.298 321.02 228.983 321.153C228.675 321.286 228.332 321.353 227.954 321.353ZM227.954 320.408C228.346 320.408 228.661 320.289 228.899 320.051C229.137 319.806 229.256 319.442 229.256 318.959V318.035C229.256 317.552 229.137 317.191 228.899 316.953C228.661 316.708 228.346 316.586 227.954 316.586C227.562 316.586 227.247 316.708 227.009 316.953C226.771 317.191 226.652 317.552 226.652 318.035V318.959C226.652 319.442 226.771 319.806 227.009 320.051C227.247 320.289 227.562 320.408 227.954 320.408ZM231.738 315.767H232.883V316.67H232.935C233.054 316.341 233.247 316.089 233.513 315.914C233.786 315.732 234.104 315.641 234.468 315.641C235.161 315.641 235.697 315.893 236.075 316.397C236.453 316.894 236.642 317.594 236.642 318.497C236.642 319.4 236.453 320.103 236.075 320.607C235.697 321.104 235.161 321.353 234.468 321.353C234.104 321.353 233.786 321.262 233.513 321.08C233.247 320.898 233.054 320.646 232.935 320.324H232.883V323.327H231.738V315.767ZM234.122 320.366C234.521 320.366 234.839 320.24 235.077 319.988C235.315 319.729 235.434 319.389 235.434 318.969V318.024C235.434 317.604 235.315 317.268 235.077 317.016C234.839 316.757 234.521 316.628 234.122 316.628C233.772 316.628 233.478 316.715 233.24 316.89C233.002 317.058 232.883 317.282 232.883 317.562V319.431C232.883 319.711 233.002 319.939 233.24 320.114C233.478 320.282 233.772 320.366 234.122 320.366ZM240.094 321.353C239.702 321.353 239.352 321.286 239.044 321.153C238.736 321.02 238.474 320.831 238.257 320.586C238.04 320.334 237.872 320.033 237.753 319.683C237.641 319.326 237.585 318.931 237.585 318.497C237.585 318.063 237.641 317.671 237.753 317.321C237.872 316.964 238.04 316.663 238.257 316.418C238.474 316.166 238.736 315.973 239.044 315.84C239.352 315.707 239.702 315.641 240.094 315.641C240.493 315.641 240.843 315.711 241.144 315.851C241.452 315.991 241.708 316.187 241.911 316.439C242.114 316.684 242.264 316.971 242.362 317.3C242.467 317.629 242.52 317.982 242.52 318.36V318.791H238.771V318.969C238.771 319.389 238.894 319.736 239.139 320.009C239.391 320.275 239.748 320.408 240.21 320.408C240.546 320.408 240.829 320.334 241.06 320.187C241.291 320.04 241.487 319.841 241.648 319.589L242.32 320.25C242.117 320.586 241.823 320.856 241.438 321.059C241.053 321.255 240.605 321.353 240.094 321.353ZM240.094 316.533C239.898 316.533 239.716 316.568 239.548 316.638C239.387 316.708 239.247 316.806 239.128 316.932C239.016 317.058 238.929 317.209 238.866 317.384C238.803 317.559 238.771 317.751 238.771 317.961V318.035H241.312V317.93C241.312 317.51 241.204 317.174 240.987 316.922C240.77 316.663 240.472 316.533 240.094 316.533ZM244.306 319.767C244.565 319.767 244.757 319.834 244.883 319.967C245.009 320.1 245.072 320.271 245.072 320.481V320.649C245.072 320.992 244.978 321.349 244.789 321.72C244.607 322.098 244.358 322.417 244.043 322.676H243.193C243.417 322.452 243.602 322.235 243.749 322.025C243.896 321.815 244.008 321.58 244.085 321.321C243.903 321.286 243.767 321.209 243.676 321.09C243.585 320.964 243.539 320.817 243.539 320.649V320.481C243.539 320.271 243.602 320.1 243.728 319.967C243.854 319.834 244.047 319.767 244.306 319.767ZM185.352 336.227V335.24H187.41V329.759H187.326L185.625 331.575L184.901 330.924L186.77 328.898H188.576V335.24H190.361V336.227H185.352ZM196.058 329.927H192.803L192.614 332.52H192.688C192.772 332.373 192.859 332.244 192.95 332.132C193.041 332.013 193.146 331.911 193.265 331.827C193.384 331.743 193.521 331.68 193.675 331.638C193.829 331.589 194.011 331.565 194.221 331.565C194.536 331.565 194.826 331.617 195.092 331.722C195.365 331.827 195.6 331.978 195.796 332.174C195.999 332.37 196.156 332.611 196.268 332.898C196.38 333.178 196.436 333.497 196.436 333.854C196.436 334.218 196.377 334.554 196.258 334.862C196.146 335.17 195.978 335.436 195.754 335.66C195.53 335.877 195.253 336.048 194.924 336.174C194.602 336.293 194.235 336.353 193.822 336.353C193.493 336.353 193.202 336.314 192.95 336.237C192.698 336.167 192.474 336.073 192.278 335.954C192.089 335.828 191.921 335.688 191.774 335.534C191.634 335.373 191.508 335.208 191.396 335.04L192.257 334.358C192.348 334.505 192.443 334.638 192.541 334.757C192.639 334.876 192.751 334.981 192.877 335.072C193.003 335.163 193.143 335.233 193.297 335.282C193.458 335.331 193.64 335.355 193.843 335.355C194.277 335.355 194.609 335.236 194.84 334.998C195.078 334.76 195.197 334.431 195.197 334.011V333.885C195.197 333.465 195.078 333.136 194.84 332.898C194.609 332.66 194.277 332.541 193.843 332.541C193.528 332.541 193.276 332.601 193.087 332.72C192.898 332.839 192.737 332.972 192.604 333.119L191.627 332.982L191.9 328.898H196.058V329.927ZM198.921 336.227L204.003 328.898H205.063L199.981 336.227H198.921ZM199.393 332.93C198.826 332.93 198.392 332.755 198.091 332.405C197.79 332.048 197.64 331.53 197.64 330.851C197.64 330.172 197.79 329.657 198.091 329.307C198.392 328.95 198.826 328.772 199.393 328.772C199.96 328.772 200.394 328.95 200.695 329.307C200.996 329.657 201.147 330.172 201.147 330.851C201.147 331.53 200.996 332.048 200.695 332.405C200.394 332.755 199.96 332.93 199.393 332.93ZM199.393 332.226C199.89 332.226 200.139 331.866 200.139 331.145V330.557C200.139 329.836 199.89 329.475 199.393 329.475C198.896 329.475 198.648 329.836 198.648 330.557V331.145C198.648 331.866 198.896 332.226 199.393 332.226ZM204.591 336.353C204.024 336.353 203.59 336.178 203.289 335.828C202.988 335.471 202.837 334.953 202.837 334.274C202.837 333.595 202.988 333.08 203.289 332.73C203.59 332.373 204.024 332.195 204.591 332.195C205.158 332.195 205.592 332.373 205.893 332.73C206.194 333.08 206.344 333.595 206.344 334.274C206.344 334.953 206.194 335.471 205.893 335.828C205.592 336.178 205.158 336.353 204.591 336.353ZM204.591 335.649C205.088 335.649 205.336 335.289 205.336 334.568V333.98C205.336 333.259 205.088 332.898 204.591 332.898C204.094 332.898 203.845 333.259 203.845 333.98V334.568C203.845 335.289 204.094 335.649 204.591 335.649ZM212.545 336.353C211.929 336.353 211.404 336.241 210.97 336.017C210.543 335.793 210.176 335.492 209.868 335.114L210.687 334.347C210.946 334.662 211.229 334.9 211.537 335.061C211.852 335.222 212.209 335.303 212.608 335.303C213.077 335.303 213.431 335.198 213.669 334.988C213.907 334.778 214.026 334.494 214.026 334.137C214.026 333.85 213.942 333.623 213.774 333.455C213.606 333.287 213.308 333.161 212.881 333.077L212.23 332.961C211.516 332.828 210.981 332.594 210.624 332.258C210.267 331.922 210.088 331.46 210.088 330.872C210.088 330.55 210.148 330.259 210.267 330C210.393 329.734 210.564 329.514 210.781 329.339C211.005 329.157 211.275 329.017 211.59 328.919C211.905 328.821 212.258 328.772 212.65 328.772C213.203 328.772 213.683 328.87 214.089 329.066C214.495 329.255 214.841 329.531 215.128 329.895L214.299 330.63C214.11 330.385 213.879 330.189 213.606 330.042C213.333 329.895 212.993 329.822 212.587 329.822C212.167 329.822 211.842 329.906 211.611 330.074C211.38 330.242 211.264 330.487 211.264 330.809C211.264 331.117 211.359 331.348 211.548 331.502C211.737 331.649 212.031 331.761 212.43 331.838L213.081 331.974C213.816 332.114 214.351 332.352 214.687 332.688C215.03 333.024 215.202 333.486 215.202 334.074C215.202 334.417 215.142 334.729 215.023 335.009C214.904 335.289 214.729 335.53 214.498 335.733C214.274 335.929 213.998 336.083 213.669 336.195C213.34 336.3 212.965 336.353 212.545 336.353ZM218.684 336.353C218.306 336.353 217.96 336.286 217.645 336.153C217.337 336.02 217.074 335.831 216.857 335.586C216.64 335.334 216.472 335.033 216.353 334.683C216.234 334.326 216.175 333.931 216.175 333.497C216.175 333.063 216.234 332.671 216.353 332.321C216.472 331.964 216.64 331.663 216.857 331.418C217.074 331.166 217.337 330.973 217.645 330.84C217.96 330.707 218.306 330.641 218.684 330.641C219.062 330.641 219.405 330.707 219.713 330.84C220.028 330.973 220.294 331.166 220.511 331.418C220.728 331.663 220.896 331.964 221.015 332.321C221.134 332.671 221.194 333.063 221.194 333.497C221.194 333.931 221.134 334.326 221.015 334.683C220.896 335.033 220.728 335.334 220.511 335.586C220.294 335.831 220.028 336.02 219.713 336.153C219.405 336.286 219.062 336.353 218.684 336.353ZM218.684 335.408C219.076 335.408 219.391 335.289 219.629 335.051C219.867 334.806 219.986 334.442 219.986 333.959V333.035C219.986 332.552 219.867 332.191 219.629 331.953C219.391 331.708 219.076 331.586 218.684 331.586C218.292 331.586 217.977 331.708 217.739 331.953C217.501 332.191 217.382 332.552 217.382 333.035V333.959C217.382 334.442 217.501 334.806 217.739 335.051C217.977 335.289 218.292 335.408 218.684 335.408ZM225.776 335.324H225.734C225.685 335.457 225.619 335.586 225.535 335.712C225.458 335.838 225.356 335.95 225.23 336.048C225.111 336.139 224.964 336.213 224.789 336.269C224.621 336.325 224.425 336.353 224.201 336.353C223.634 336.353 223.193 336.171 222.878 335.807C222.57 335.443 222.416 334.921 222.416 334.242V330.767H223.561V334.095C223.561 334.942 223.911 335.366 224.611 335.366C224.758 335.366 224.901 335.348 225.041 335.313C225.181 335.271 225.304 335.212 225.409 335.135C225.521 335.058 225.608 334.96 225.671 334.841C225.741 334.722 225.776 334.582 225.776 334.421V330.767H226.921V336.227H225.776V335.324ZM230.072 336.227C229.673 336.227 229.372 336.125 229.169 335.922C228.966 335.712 228.864 335.418 228.864 335.04V331.701H228.014V330.767H228.476C228.665 330.767 228.794 330.725 228.864 330.641C228.941 330.557 228.98 330.42 228.98 330.231V329.276H230.009V330.767H231.153V331.701H230.009V335.292H231.069V336.227H230.072ZM232.395 328.457H233.539V331.67H233.592C233.711 331.376 233.889 331.131 234.127 330.935C234.372 330.739 234.705 330.641 235.125 330.641C235.685 330.641 236.119 330.826 236.427 331.197C236.742 331.561 236.899 332.083 236.899 332.762V336.227H235.755V332.898C235.755 332.051 235.412 331.628 234.726 331.628C234.579 331.628 234.432 331.649 234.285 331.691C234.145 331.726 234.019 331.782 233.907 331.859C233.795 331.936 233.704 332.034 233.634 332.153C233.571 332.272 233.539 332.408 233.539 332.562V336.227H232.395V328.457ZM245.282 335.481C245.191 335.572 245.079 335.67 244.946 335.775C244.82 335.873 244.67 335.968 244.495 336.059C244.327 336.143 244.131 336.213 243.907 336.269C243.69 336.325 243.441 336.353 243.161 336.353C242.783 336.353 242.447 336.3 242.153 336.195C241.859 336.09 241.611 335.947 241.408 335.765C241.212 335.583 241.061 335.369 240.956 335.124C240.858 334.872 240.809 334.603 240.809 334.316C240.809 334.057 240.848 333.826 240.925 333.623C241.009 333.413 241.117 333.227 241.25 333.066C241.39 332.898 241.548 332.751 241.723 332.625C241.905 332.492 242.097 332.37 242.3 332.258C242.069 332.013 241.873 331.747 241.712 331.46C241.551 331.173 241.471 330.865 241.471 330.536C241.471 330.291 241.516 330.06 241.607 329.843C241.705 329.626 241.842 329.44 242.017 329.286C242.192 329.125 242.402 328.999 242.647 328.908C242.899 328.817 243.175 328.772 243.476 328.772C243.756 328.772 244.015 328.81 244.253 328.887C244.491 328.964 244.698 329.073 244.873 329.213C245.048 329.353 245.181 329.524 245.272 329.727C245.37 329.923 245.419 330.144 245.419 330.389C245.419 330.627 245.377 330.844 245.293 331.04C245.209 331.229 245.093 331.404 244.946 331.565C244.799 331.719 244.628 331.866 244.432 332.006C244.243 332.139 244.04 332.268 243.823 332.394L245.251 333.938C245.349 333.686 245.426 333.42 245.482 333.14C245.538 332.86 245.573 332.576 245.587 332.289H247.151V333.255H246.437C246.332 333.787 246.171 334.26 245.954 334.673L247.393 336.227H245.965L245.282 335.481ZM243.476 329.685C243.224 329.685 243.011 329.762 242.836 329.916C242.661 330.063 242.573 330.259 242.573 330.504V330.588C242.573 330.77 242.629 330.952 242.741 331.134C242.86 331.316 243.028 331.526 243.245 331.764C243.539 331.603 243.791 331.425 244.001 331.229C244.211 331.026 244.316 330.795 244.316 330.536V330.452C244.316 330.207 244.239 330.018 244.085 329.885C243.931 329.752 243.728 329.685 243.476 329.685ZM243.298 335.376C243.592 335.376 243.851 335.327 244.075 335.229C244.299 335.131 244.495 334.995 244.663 334.82L242.878 332.898C242.612 333.045 242.395 333.21 242.227 333.392C242.066 333.574 241.985 333.822 241.985 334.137V334.274C241.985 334.61 242.101 334.879 242.332 335.082C242.563 335.278 242.885 335.376 243.298 335.376ZM175.926 351.353C174.967 351.353 174.215 351.031 173.669 350.387C173.123 349.736 172.85 348.794 172.85 347.562C172.85 346.946 172.92 346.404 173.06 345.935C173.2 345.466 173.403 345.07 173.669 344.748C173.935 344.426 174.257 344.185 174.635 344.024C175.02 343.856 175.45 343.772 175.926 343.772C176.563 343.772 177.095 343.912 177.522 344.192C177.956 344.472 178.296 344.885 178.541 345.431L177.543 345.977C177.417 345.627 177.221 345.35 176.955 345.147C176.696 344.937 176.353 344.832 175.926 344.832C175.359 344.832 174.915 345.025 174.593 345.41C174.271 345.795 174.11 346.327 174.11 347.006V348.119C174.11 348.798 174.271 349.33 174.593 349.715C174.915 350.1 175.359 350.292 175.926 350.292C176.367 350.292 176.724 350.18 176.997 349.956C177.277 349.725 177.484 349.431 177.617 349.074L178.572 349.652C178.327 350.184 177.984 350.6 177.543 350.901C177.102 351.202 176.563 351.353 175.926 351.353ZM181.888 351.353C181.496 351.353 181.146 351.286 180.838 351.153C180.53 351.02 180.268 350.831 180.051 350.586C179.834 350.334 179.666 350.033 179.547 349.683C179.435 349.326 179.379 348.931 179.379 348.497C179.379 348.063 179.435 347.671 179.547 347.321C179.666 346.964 179.834 346.663 180.051 346.418C180.268 346.166 180.53 345.973 180.838 345.84C181.146 345.707 181.496 345.641 181.888 345.641C182.287 345.641 182.637 345.711 182.938 345.851C183.246 345.991 183.502 346.187 183.705 346.439C183.908 346.684 184.058 346.971 184.156 347.3C184.261 347.629 184.314 347.982 184.314 348.36V348.791H180.565V348.969C180.565 349.389 180.688 349.736 180.933 350.009C181.185 350.275 181.542 350.408 182.004 350.408C182.34 350.408 182.623 350.334 182.854 350.187C183.085 350.04 183.281 349.841 183.442 349.589L184.114 350.25C183.911 350.586 183.617 350.856 183.232 351.059C182.847 351.255 182.399 351.353 181.888 351.353ZM181.888 346.533C181.692 346.533 181.51 346.568 181.342 346.638C181.181 346.708 181.041 346.806 180.922 346.932C180.81 347.058 180.723 347.209 180.66 347.384C180.597 347.559 180.565 347.751 180.565 347.961V348.035H183.106V347.93C183.106 347.51 182.998 347.174 182.781 346.922C182.564 346.663 182.266 346.533 181.888 346.533ZM185.58 351.227V345.767H186.725V346.67H186.777C186.896 346.376 187.075 346.131 187.313 345.935C187.558 345.739 187.89 345.641 188.31 345.641C188.87 345.641 189.304 345.826 189.612 346.197C189.927 346.561 190.085 347.083 190.085 347.762V351.227H188.94V347.909C188.94 347.055 188.597 346.628 187.911 346.628C187.764 346.628 187.617 346.649 187.47 346.691C187.33 346.726 187.204 346.782 187.092 346.859C186.98 346.936 186.889 347.034 186.819 347.153C186.756 347.272 186.725 347.412 186.725 347.573V351.227H185.58ZM193.183 351.227C192.784 351.227 192.483 351.125 192.28 350.922C192.077 350.712 191.976 350.418 191.976 350.04V346.701H191.125V345.767H191.587C191.776 345.767 191.906 345.725 191.976 345.641C192.053 345.557 192.091 345.42 192.091 345.231V344.276H193.12V345.767H194.265V346.701H193.12V350.292H194.181V351.227H193.183ZM195.506 351.227V345.767H196.651V346.817H196.703C196.78 346.537 196.941 346.292 197.186 346.082C197.431 345.872 197.771 345.767 198.205 345.767H198.509V346.869H198.058C197.603 346.869 197.253 346.943 197.008 347.09C196.77 347.237 196.651 347.454 196.651 347.741V351.227H195.506ZM203.444 351.227C203.143 351.227 202.912 351.143 202.751 350.975C202.59 350.8 202.492 350.579 202.457 350.313H202.405C202.3 350.656 202.107 350.915 201.827 351.09C201.547 351.265 201.208 351.353 200.809 351.353C200.242 351.353 199.804 351.206 199.496 350.912C199.195 350.618 199.045 350.222 199.045 349.725C199.045 349.179 199.241 348.77 199.633 348.497C200.032 348.224 200.613 348.087 201.376 348.087H202.363V347.625C202.363 347.289 202.272 347.03 202.09 346.848C201.908 346.666 201.624 346.575 201.239 346.575C200.917 346.575 200.655 346.645 200.452 346.785C200.249 346.925 200.077 347.104 199.937 347.321L199.255 346.701C199.437 346.393 199.692 346.141 200.021 345.945C200.35 345.742 200.781 345.641 201.313 345.641C202.02 345.641 202.562 345.805 202.94 346.134C203.318 346.463 203.507 346.936 203.507 347.552V350.292H204.085V351.227H203.444ZM201.134 350.481C201.491 350.481 201.785 350.404 202.016 350.25C202.247 350.089 202.363 349.876 202.363 349.61V348.822H201.397C200.606 348.822 200.21 349.067 200.21 349.557V349.746C200.21 349.991 200.291 350.177 200.452 350.303C200.62 350.422 200.847 350.481 201.134 350.481ZM206.372 351.227C205.98 351.227 205.686 351.129 205.49 350.933C205.301 350.73 205.206 350.45 205.206 350.093V343.457H206.351V350.292H207.107V351.227H206.372ZM215.344 351.227L214.683 349.242H211.942L211.302 351.227H210.094L212.593 343.898H214.084L216.583 351.227H215.344ZM213.339 344.99H213.286L212.226 348.224H214.389L213.339 344.99ZM217.634 351.227V345.767H218.779V346.67H218.831C218.887 346.53 218.954 346.397 219.031 346.271C219.115 346.145 219.213 346.036 219.325 345.945C219.444 345.847 219.58 345.774 219.734 345.725C219.895 345.669 220.081 345.641 220.291 345.641C220.662 345.641 220.991 345.732 221.278 345.914C221.565 346.096 221.775 346.376 221.908 346.754H221.939C222.037 346.446 222.226 346.183 222.506 345.966C222.786 345.749 223.147 345.641 223.588 345.641C224.134 345.641 224.557 345.826 224.858 346.197C225.159 346.561 225.31 347.083 225.31 347.762V351.227H224.165V347.898C224.165 347.478 224.085 347.163 223.924 346.953C223.763 346.736 223.507 346.628 223.157 346.628C223.01 346.628 222.87 346.649 222.737 346.691C222.604 346.726 222.485 346.782 222.38 346.859C222.282 346.936 222.202 347.034 222.139 347.153C222.076 347.272 222.044 347.408 222.044 347.562V351.227H220.9V347.898C220.9 347.051 220.567 346.628 219.902 346.628C219.762 346.628 219.622 346.649 219.482 346.691C219.349 346.726 219.23 346.782 219.125 346.859C219.02 346.936 218.936 347.034 218.873 347.153C218.81 347.272 218.779 347.408 218.779 347.562V351.227H217.634ZM229.035 351.353C228.643 351.353 228.293 351.286 227.985 351.153C227.677 351.02 227.415 350.831 227.198 350.586C226.981 350.334 226.813 350.033 226.694 349.683C226.582 349.326 226.526 348.931 226.526 348.497C226.526 348.063 226.582 347.671 226.694 347.321C226.813 346.964 226.981 346.663 227.198 346.418C227.415 346.166 227.677 345.973 227.985 345.84C228.293 345.707 228.643 345.641 229.035 345.641C229.434 345.641 229.784 345.711 230.085 345.851C230.393 345.991 230.649 346.187 230.852 346.439C231.055 346.684 231.205 346.971 231.303 347.3C231.408 347.629 231.461 347.982 231.461 348.36V348.791H227.712V348.969C227.712 349.389 227.835 349.736 228.08 350.009C228.332 350.275 228.689 350.408 229.151 350.408C229.487 350.408 229.77 350.334 230.001 350.187C230.232 350.04 230.428 349.841 230.589 349.589L231.261 350.25C231.058 350.586 230.764 350.856 230.379 351.059C229.994 351.255 229.546 351.353 229.035 351.353ZM229.035 346.533C228.839 346.533 228.657 346.568 228.489 346.638C228.328 346.708 228.188 346.806 228.069 346.932C227.957 347.058 227.87 347.209 227.807 347.384C227.744 347.559 227.712 347.751 227.712 347.961V348.035H230.253V347.93C230.253 347.51 230.145 347.174 229.928 346.922C229.711 346.663 229.413 346.533 229.035 346.533ZM232.728 351.227V345.767H233.872V346.817H233.925C234.002 346.537 234.163 346.292 234.408 346.082C234.653 345.872 234.992 345.767 235.426 345.767H235.731V346.869H235.279C234.824 346.869 234.474 346.943 234.229 347.09C233.991 347.237 233.872 347.454 233.872 347.741V351.227H232.728ZM237.325 344.79C237.087 344.79 236.912 344.734 236.8 344.622C236.695 344.51 236.642 344.367 236.642 344.192V344.013C236.642 343.838 236.695 343.695 236.8 343.583C236.912 343.471 237.087 343.415 237.325 343.415C237.563 343.415 237.734 343.471 237.839 343.583C237.944 343.695 237.997 343.838 237.997 344.013V344.192C237.997 344.367 237.944 344.51 237.839 344.622C237.734 344.734 237.563 344.79 237.325 344.79ZM236.747 345.767H237.892V351.227H236.747V345.767ZM241.637 351.353C241.245 351.353 240.895 351.286 240.587 351.153C240.279 351.02 240.02 350.831 239.81 350.586C239.6 350.334 239.439 350.033 239.327 349.683C239.215 349.326 239.159 348.931 239.159 348.497C239.159 348.063 239.215 347.671 239.327 347.321C239.439 346.964 239.6 346.663 239.81 346.418C240.02 346.166 240.279 345.973 240.587 345.84C240.895 345.707 241.245 345.641 241.637 345.641C242.183 345.641 242.631 345.763 242.981 346.008C243.331 346.253 243.586 346.579 243.747 346.985L242.802 347.426C242.725 347.174 242.589 346.974 242.393 346.827C242.204 346.673 241.952 346.596 241.637 346.596C241.217 346.596 240.898 346.729 240.681 346.995C240.471 347.254 240.366 347.594 240.366 348.014V348.99C240.366 349.41 240.471 349.753 240.681 350.019C240.898 350.278 241.217 350.408 241.637 350.408C241.973 350.408 242.239 350.327 242.435 350.166C242.638 349.998 242.799 349.778 242.918 349.505L243.789 349.967C243.607 350.415 243.334 350.758 242.97 350.996C242.606 351.234 242.162 351.353 241.637 351.353ZM248.879 351.227C248.578 351.227 248.347 351.143 248.186 350.975C248.025 350.8 247.927 350.579 247.892 350.313H247.84C247.735 350.656 247.542 350.915 247.262 351.09C246.982 351.265 246.643 351.353 246.244 351.353C245.677 351.353 245.239 351.206 244.931 350.912C244.63 350.618 244.48 350.222 244.48 349.725C244.48 349.179 244.676 348.77 245.068 348.497C245.467 348.224 246.048 348.087 246.811 348.087H247.798V347.625C247.798 347.289 247.707 347.03 247.525 346.848C247.343 346.666 247.059 346.575 246.674 346.575C246.352 346.575 246.09 346.645 245.887 346.785C245.684 346.925 245.512 347.104 245.372 347.321L244.69 346.701C244.872 346.393 245.127 346.141 245.456 345.945C245.785 345.742 246.216 345.641 246.748 345.641C247.455 345.641 247.997 345.805 248.375 346.134C248.753 346.463 248.942 346.936 248.942 347.552V350.292H249.52V351.227H248.879ZM246.569 350.481C246.926 350.481 247.22 350.404 247.451 350.25C247.682 350.089 247.798 349.876 247.798 349.61V348.822H246.832C246.041 348.822 245.645 349.067 245.645 349.557V349.746C245.645 349.991 245.726 350.177 245.887 350.303C246.055 350.422 246.282 350.481 246.569 350.481ZM257.438 350.481C257.347 350.572 257.235 350.67 257.102 350.775C256.976 350.873 256.826 350.968 256.651 351.059C256.483 351.143 256.287 351.213 256.063 351.269C255.846 351.325 255.597 351.353 255.317 351.353C254.939 351.353 254.603 351.3 254.309 351.195C254.015 351.09 253.767 350.947 253.564 350.765C253.368 350.583 253.217 350.369 253.112 350.124C253.014 349.872 252.965 349.603 252.965 349.316C252.965 349.057 253.004 348.826 253.081 348.623C253.165 348.413 253.273 348.227 253.406 348.066C253.546 347.898 253.704 347.751 253.879 347.625C254.061 347.492 254.253 347.37 254.456 347.258C254.225 347.013 254.029 346.747 253.868 346.46C253.707 346.173 253.627 345.865 253.627 345.536C253.627 345.291 253.672 345.06 253.763 344.843C253.861 344.626 253.998 344.44 254.173 344.286C254.348 344.125 254.558 343.999 254.803 343.908C255.055 343.817 255.331 343.772 255.632 343.772C255.912 343.772 256.171 343.81 256.409 343.887C256.647 343.964 256.854 344.073 257.029 344.213C257.204 344.353 257.337 344.524 257.428 344.727C257.526 344.923 257.575 345.144 257.575 345.389C257.575 345.627 257.533 345.844 257.449 346.04C257.365 346.229 257.249 346.404 257.102 346.565C256.955 346.719 256.784 346.866 256.588 347.006C256.399 347.139 256.196 347.268 255.979 347.394L257.407 348.938C257.505 348.686 257.582 348.42 257.638 348.14C257.694 347.86 257.729 347.576 257.743 347.289H259.307V348.255H258.593C258.488 348.787 258.327 349.26 258.11 349.673L259.549 351.227H258.121L257.438 350.481ZM255.632 344.685C255.38 344.685 255.167 344.762 254.992 344.916C254.817 345.063 254.729 345.259 254.729 345.504V345.588C254.729 345.77 254.785 345.952 254.897 346.134C255.016 346.316 255.184 346.526 255.401 346.764C255.695 346.603 255.947 346.425 256.157 346.229C256.367 346.026 256.472 345.795 256.472 345.536V345.452C256.472 345.207 256.395 345.018 256.241 344.885C256.087 344.752 255.884 344.685 255.632 344.685ZM255.454 350.376C255.748 350.376 256.007 350.327 256.231 350.229C256.455 350.131 256.651 349.995 256.819 349.82L255.034 347.898C254.768 348.045 254.551 348.21 254.383 348.392C254.222 348.574 254.141 348.822 254.141 349.137V349.274C254.141 349.61 254.257 349.879 254.488 350.082C254.719 350.278 255.041 350.376 255.454 350.376ZM194.073 366.227V365.24H196.131V359.759H196.047L194.346 361.575L193.622 360.924L195.491 358.898H197.297V365.24H199.082V366.227H194.073ZM202.595 366.353C202.14 366.353 201.745 366.269 201.409 366.101C201.073 365.926 200.796 365.677 200.579 365.355C200.362 365.033 200.201 364.638 200.096 364.169C199.991 363.7 199.939 363.164 199.939 362.562C199.939 361.967 199.991 361.435 200.096 360.966C200.201 360.49 200.362 360.091 200.579 359.769C200.796 359.447 201.073 359.202 201.409 359.034C201.745 358.859 202.14 358.772 202.595 358.772C203.505 358.772 204.174 359.104 204.601 359.769C205.035 360.434 205.252 361.365 205.252 362.562C205.252 363.759 205.035 364.69 204.601 365.355C204.174 366.02 203.505 366.353 202.595 366.353ZM202.595 365.345C202.847 365.345 203.061 365.296 203.236 365.198C203.418 365.093 203.565 364.946 203.677 364.757C203.789 364.568 203.869 364.344 203.918 364.085C203.967 363.819 203.992 363.525 203.992 363.203V361.922C203.992 361.6 203.967 361.309 203.918 361.05C203.869 360.784 203.789 360.557 203.677 360.368C203.565 360.179 203.418 360.035 203.236 359.937C203.061 359.832 202.847 359.78 202.595 359.78C202.343 359.78 202.126 359.832 201.944 359.937C201.769 360.035 201.626 360.179 201.514 360.368C201.402 360.557 201.321 360.784 201.272 361.05C201.223 361.309 201.199 361.6 201.199 361.922V363.203C201.199 363.525 201.223 363.819 201.272 364.085C201.321 364.344 201.402 364.568 201.514 364.757C201.626 364.946 201.769 365.093 201.944 365.198C202.126 365.296 202.343 365.345 202.595 365.345ZM207.641 366.227L212.723 358.898H213.784L208.702 366.227H207.641ZM208.114 362.93C207.547 362.93 207.113 362.755 206.812 362.405C206.511 362.048 206.36 361.53 206.36 360.851C206.36 360.172 206.511 359.657 206.812 359.307C207.113 358.95 207.547 358.772 208.114 358.772C208.681 358.772 209.115 358.95 209.416 359.307C209.717 359.657 209.867 360.172 209.867 360.851C209.867 361.53 209.717 362.048 209.416 362.405C209.115 362.755 208.681 362.93 208.114 362.93ZM208.114 362.226C208.611 362.226 208.859 361.866 208.859 361.145V360.557C208.859 359.836 208.611 359.475 208.114 359.475C207.617 359.475 207.368 359.836 207.368 360.557V361.145C207.368 361.866 207.617 362.226 208.114 362.226ZM213.311 366.353C212.744 366.353 212.31 366.178 212.009 365.828C211.708 365.471 211.558 364.953 211.558 364.274C211.558 363.595 211.708 363.08 212.009 362.73C212.31 362.373 212.744 362.195 213.311 362.195C213.878 362.195 214.312 362.373 214.613 362.73C214.914 363.08 215.065 363.595 215.065 364.274C215.065 364.953 214.914 365.471 214.613 365.828C214.312 366.178 213.878 366.353 213.311 366.353ZM213.311 365.649C213.808 365.649 214.057 365.289 214.057 364.568V363.98C214.057 363.259 213.808 362.898 213.311 362.898C212.814 362.898 212.566 363.259 212.566 363.98V364.568C212.566 365.289 212.814 365.649 213.311 365.649ZM223.65 366.227L222.988 364.242H220.248L219.607 366.227H218.4L220.899 358.898H222.39L224.889 366.227H223.65ZM221.644 359.99H221.592L220.531 363.224H222.694L221.644 359.99ZM227.672 366.353C227.154 366.353 226.72 366.262 226.37 366.08C226.02 365.898 225.716 365.646 225.457 365.324L226.192 364.652C226.395 364.897 226.619 365.089 226.864 365.229C227.116 365.362 227.406 365.429 227.735 365.429C228.071 365.429 228.32 365.366 228.481 365.24C228.649 365.107 228.733 364.925 228.733 364.694C228.733 364.519 228.673 364.372 228.554 364.253C228.442 364.127 228.243 364.046 227.956 364.011L227.452 363.948C226.892 363.878 226.451 363.717 226.129 363.465C225.814 363.206 225.656 362.825 225.656 362.321C225.656 362.055 225.705 361.82 225.803 361.617C225.901 361.407 226.038 361.232 226.213 361.092C226.395 360.945 226.608 360.833 226.853 360.756C227.105 360.679 227.382 360.641 227.683 360.641C228.173 360.641 228.572 360.718 228.88 360.872C229.195 361.026 229.475 361.239 229.72 361.512L229.016 362.184C228.876 362.016 228.691 361.873 228.46 361.754C228.236 361.628 227.977 361.565 227.683 361.565C227.368 361.565 227.133 361.628 226.979 361.754C226.832 361.88 226.759 362.044 226.759 362.247C226.759 362.457 226.825 362.615 226.958 362.72C227.091 362.825 227.305 362.902 227.599 362.951L228.103 363.014C228.705 363.105 229.142 363.283 229.415 363.549C229.695 363.808 229.835 364.158 229.835 364.599C229.835 364.865 229.783 365.107 229.678 365.324C229.58 365.534 229.436 365.716 229.247 365.87C229.058 366.024 228.831 366.143 228.565 366.227C228.299 366.311 228.001 366.353 227.672 366.353ZM231.706 359.79C231.468 359.79 231.293 359.734 231.181 359.622C231.076 359.51 231.023 359.367 231.023 359.192V359.013C231.023 358.838 231.076 358.695 231.181 358.583C231.293 358.471 231.468 358.415 231.706 358.415C231.944 358.415 232.115 358.471 232.22 358.583C232.325 358.695 232.378 358.838 232.378 359.013V359.192C232.378 359.367 232.325 359.51 232.22 359.622C232.115 359.734 231.944 359.79 231.706 359.79ZM231.128 360.767H232.273V366.227H231.128V360.767ZM237.908 366.227C237.607 366.227 237.376 366.143 237.215 365.975C237.054 365.8 236.956 365.579 236.921 365.313H236.868C236.763 365.656 236.571 365.915 236.291 366.09C236.011 366.265 235.671 366.353 235.272 366.353C234.705 366.353 234.268 366.206 233.96 365.912C233.659 365.618 233.508 365.222 233.508 364.725C233.508 364.179 233.704 363.77 234.096 363.497C234.495 363.224 235.076 363.087 235.839 363.087H236.826V362.625C236.826 362.289 236.735 362.03 236.553 361.848C236.371 361.666 236.088 361.575 235.703 361.575C235.381 361.575 235.118 361.645 234.915 361.785C234.712 361.925 234.541 362.104 234.401 362.321L233.718 361.701C233.9 361.393 234.156 361.141 234.485 360.945C234.814 360.742 235.244 360.641 235.776 360.641C236.483 360.641 237.026 360.805 237.404 361.134C237.782 361.463 237.971 361.936 237.971 362.552V365.292H238.548V366.227H237.908ZM235.598 365.481C235.955 365.481 236.249 365.404 236.48 365.25C236.711 365.089 236.826 364.876 236.826 364.61V363.822H235.86C235.069 363.822 234.674 364.067 234.674 364.557V364.746C234.674 364.991 234.754 365.177 234.915 365.303C235.083 365.422 235.311 365.481 235.598 365.481Z",
                                                                fill: "white",
                                                                fillOpacity: "0.72"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                                        id: "clip0_5592_7504",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                            width: "18",
                                                                            height: "18",
                                                                            fill: "white",
                                                                            transform: "translate(59 27.2266)"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                                        id: "clip1_5592_7504",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                            width: "18",
                                                                            height: "18",
                                                                            fill: "white",
                                                                            transform: "translate(207 27.2266)"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                                        id: "clip2_5592_7504",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                            width: "18",
                                                                            height: "18",
                                                                            fill: "white",
                                                                            transform: "translate(59 227.227)"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                                                        id: "clip3_5592_7504",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                                            width: "18",
                                                                            height: "18",
                                                                            fill: "white",
                                                                            transform: "translate(207 227.227)"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: 'lg:col-span-10',
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "This year respondents include large enterprise organizations with 31% currently spending more than $50 million dollars a year in public cloud, 20% spending more than $100m/yr and over 20 $1bn/yr. 41% are from organizations with more than 20,000 employees, 15% are over 100k people."
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-start-1 lg:col-span-6",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: frame2,
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: 'lg:col-span-6',
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: frame3,
                                                    alt: ""
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: 'priorities',
                        className: "home-section bg-gray-25",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "container px-6  mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 lg:grid-cols-12 gap-12 ",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-3xl font-medium",
                                                children: "Workload Optimization and Waste Reduction: the clear current top priority for FinOps Practitioners"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lg:col-span-4 lg:col-start-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "Workload optimization and waste reduction is the top priority by a clear margin for FinOps practitioners, followed by Full Allocation of cloud Spending, and Accurate Forecasting of spend."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "Optimization was also a ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            target: '_blank',
                                                            href: "https://www.finops.org/insights/key-priorities-shift-in-2024/",
                                                            children: "top priority for 2024"
                                                        }),
                                                        " and has remained a priority for 50% of practitioner respondents, while other FinOps Capabilities have declined in priority compared to last year. This shows that organizations continue to look for ways to reduce spending without reducing the value they are getting from their cloud investments."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "graph-wrap",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: frame4,
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 mt-20 lg:grid-cols-12 gap-12 ",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-3xl font-medium",
                                                children: "In the next 12 months, governance and optimization are top for future priorities, but managing additional Scopes of spending is increasing"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lg:col-span-4 lg:col-start-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "For future priorities over the next 12 months, workload optimization drops a significant 21% to second, while implementing governance and policy at scale becomes the top priority."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "This could be related to the maturity of the previous optimization efforts, as the longer you have done optimization the more you realize you need governance policies to further those efforts. As the low-effort optimizations are easy to tackle first, while policies, processes, and automation are aligned to more maturity as a practice."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "The highest changes in priorities are Managing AI/ML spend (+4 places), Managing costs beyond public cloud (+5 places), and Getting to unit economics (+5 places)."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "graph-wrap",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: frame5,
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 mt-20 lg:grid-cols-12 gap-12 ",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-3xl font-medium",
                                                children: "\u201COrganizational Alignment\u201D still the top way to achieve priorities but \u201CInvestment and Tooling\u201D has risen significantly"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lg:col-span-6 lg:col-start-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "By categorizing freeform responses we can see trends to understand what practitioners need to achieve their priority. Organizational Alignment (e.g., leadership buy in) has reduced from last year (-9%) which is a positive indicator but it still remains the most needed path to achieve priorities. Investment and Tooling had a large increase (+20%), example responses for this was time, upskilling, tooling and specific call outs for automation."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "With organizational buy-in starting to take effect and reduce, the focus is shifting on resourcing and productivity, especially where FinOps practitioners' workload has increased."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-6 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame6,
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: 'scopes',
                        className: "home-section bg-white",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "container px-6  mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 lg:grid-cols-12 gap-12 ",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-3xl font-medium",
                                                children: "Practitioners are increasing effort in many capabilities while reducing effort in very few"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lg:col-span-6 lg:col-start-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "We asked practitioners what areas they are actively trying to improve and just maintain in the next 12 months with responses indicating the level of planned effort."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "Responses showed that the average number of capabilities practitioners were looking to increase effort was close to 12 and only decreasing effort in 1 to 2"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "This is a sign practitioners have a full workload and supports the previous sentiment of increasing investment into the practice. Currently practitioners risk stretching themselves thin across efforts, practitioners have to be willing to reduce effort in certain capabilities to maximize impact from the most valuable opportunities."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-6 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame7,
                                                alt: ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 lg:grid-cols-12 mt-20 gap-12 ",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-3xl font-medium",
                                                children: "FinOps Teams are managing additional scopes (Cloud+) of technology spend"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lg:col-span-6 lg:col-start-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "When asked about ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                            children: "what additional areas of technology spend does the FinOps team manage today and planning to in the next 12-months"
                                                        }),
                                                        ". We saw the highest was managing SaaS spend with a combined total of 65% of responses, this includes the highest predicted increase in the next 12 months of 25%."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "It is good to understand what types of spend FinOps practitioners are managing and planning to manage but we wanted to dig a bit deeper into what capabilities are they applying to these areas."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-6 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame8,
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "lg:col-span-10 lg:col-start-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        "The responses showed that practitioners are applying fundamental capabilities to the additional scopes of spend. These are capabilities under the ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            target: "_blank",
                                                            rel: "noopener noreferrer nofollow",
                                                            href: "https://www.finops.org/framework/domains/understand-cloud-usage-cost/",
                                                            children: "Understand Cloud Usage and Cost"
                                                        }),
                                                        " and ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            target: "_blank",
                                                            rel: "noopener noreferrer nofollow",
                                                            href: "https://www.finops.org/framework/domains/quantify-business-value/",
                                                            children: "Quantify Business Value"
                                                        }),
                                                        " Domains from the FinOps Framework that are key to strengthening their understanding. These capabilities enable practitioners to get their arms around these new areas of spend."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "Our expectation, as maturity grows in these areas, we will start seeing optimization also appearing in these top capabilities across the Scopes of spend as optimization opportunities appear over time at specific financial moments which are related to that scope."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:col-span-12",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame9,
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: 'focus',
                        className: "home-section bg-gray-25",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "container px-6  mx-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-12 gap-12 ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-8",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-3xl font-medium",
                                            children: "More than half of practitioners have plans to use FOCUS in the next 12-months but there are challenges to overcome"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-6 lg:col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    "When asked \u2018How are you planning to use ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: "https://focus.finops.org/",
                                                        target: '_blank',
                                                        children: "FOCUS"
                                                    }),
                                                    " in the next 12 months?\u2019 Only 18% are not planning to adopt FOCUS at all, 24% are still figuring out their plans, while 57% answered they have plans to use FOCUS."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Of those planning to use FOCUS, more than half are looking to automatically integrate it into their data pipeline, 1/3 plan to use a 3rd party tool or service when available and 16% plan to use it for manual data analysis."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "In freeform answers, practitioners also raised the challenges to FOCUS adoption: time, skills available were raised again, while others were awaiting adoption from billing generators and vendors. Example responses included: \u2018Time and resource capacity\u2019, \u2018Tech debt & lack of SaaS providers natively exporting it\u2019 or limitations such as \u2018Internal IT restrictions\u2019."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "There was a clear desire for the open-source billing specification but hurdles still exist to wider adoption. With the inclusion of SaaS data in the upcoming 1.2 release of FOCUS, we expect to see an increase in demand and adoption of FOCUS as more SaaS providers begin to output their billing data in the unified format."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-6",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "graph-wrap",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame10,
                                                alt: ""
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: 'cloud',
                        className: "home-section bg-white",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "container px-6  mx-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-12 gap-12 ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-8",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-3xl font-medium",
                                            children: "Sustainability reporting remains flat focusing on visibility with optimizations primarily driven by cost."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-4 lg:col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "When we look at how many practitioners report metrics on Cloud Sustainability we see that overall globally it has remained very similar to last year with a 1% difference."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "53% of European practices (an 18% increase from last year) are now reporting carbon, but this increase is slower than was predicted in 2024. North America, which had the largest segment of respondents, remained flat YoY at 29% of those reporting cloud carbon."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "15% of global practices are making optimizations based on cost. Only 3% of FinOps practices are making optimizations based on carbon considerations."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-8",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame11,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "graph-wrap",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: frame12,
                                                    alt: ""
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: 'intersecting',
                        className: "home-section bg-gray-25",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "container px-6  mx-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-12 gap-12 ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-8",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-3xl font-medium",
                                            children: "Intersecting disciplines: ITFM and ITSM are top partners; while TBM, ITAM, and SAM increasingly integrate with FinOps"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-4 lg:col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "When comparing the current data with 2023 data on intersecting disciplines, we see separate team collaboration is increasing in most areas, with the biggest increases being in ITFM and ITSM."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "ITAM and TBM have both seen increases in integrated teams merging with FinOps since 2023 (purple bars). ITAM also saw a growth in separate team collaboration (green bars), whereas separate TBM team collaboration was nearly flat, with the data showing the integrated team approach growing more quickly."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Sustainability/ESG teams also saw limited overall growth in separate team collaboration and a reduction in integrated teams, bucking expectations from previous surveys of large scale integration coming to fruition."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-8",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "graph-wrap",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame15,
                                                alt: ""
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: 'ai',
                        className: "home-section bg-white",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "container px-6  mx-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-12 gap-12 ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-8",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-3xl font-medium",
                                            children: "Planned AI investment is weighted towards public cloud, Financial Services plan to invest more heavily in AI in the Data center and Private Cloud than other industries"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-8 col-start-1 ",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "graph-wrap",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: frame13,
                                                alt: ""
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-4 col-start-1 lg:col-start-9",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "When asked \u2018What is your organization's planned investment in AI in the next 12 months?\u2019 The large majority is weighted towards public cloud offerings, 69% investing in SaaS and 30% planning investment in Data center and/or private cloud."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "97% of respondents are investing in multiple infrastructure areas for AI, this reinforces and is accelerating how managing an organization's AI spend will require taking on new spend areas for FinOps practitioners."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "When looking at this data by the Financial Services industry segment, there is increased investment overall and heavier investment into Data Center and Private cloud."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    "The most important activities to managing AI fall under the FinOps Domains of ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        href: "https://www.finops.org/framework/domains/understand-cloud-usage-cost/",
                                                        children: "Understand Cloud Usage and Cost"
                                                    }),
                                                    " and ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        href: "https://www.finops.org/framework/domains/quantify-business-value/",
                                                        children: "Quantify Business Value"
                                                    }),
                                                    ". Capabilities like Allocation, Data Ingestion, Reporting, Anomaly Detection and Planning and Forecasting indicated a strong need to simply understand AI spending."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "For AI, optimization activities are a much lower priority. We expect optimization to become more important as organizations get the fundamentals of cost visibility in place and start to align AI spend to overall business value."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-8",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: frame14,
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        id: 'conclusion',
                        className: "home-section bg-gray-25",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "container px-6  mx-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-12 gap-12 ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "lg:col-span-7",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-3xl font-medium",
                                            children: "Conclusion"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "It is no surprise that cost optimization has been a consistent top priority over the years. Gaining efficiencies within technology spend will always likely be a priority for organizations. However, practitioners are being asked to look at a wider scope of technology spending, and are investing first into activities related to cost visibility and business value."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "The majority of FinOps practices now manage AI costs, further driving an expansion of scopes as AI investments are spread across multiple infrastructure categories. As practitioners add these areas of spend they are early on the maturity curve so most of the effort is placed into capabilities that help them understand the spending: estimation of plans, forecasting, understanding existing costs and working with finance partners to allocate them to teams."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "It is likely that optimization and efficiency will become more important for AI once maturity in cost visibility, allocation and forecasting is established and confidence in the underlying value for each AI use case exists. More investment in upskilling is needed to achieve that maturity and move into AI optimization."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "FinOps practitioners have established strong financial accountability through collaboration across engineering, business, and finance, positioning them well to tackle cloud plus additional technology types\u2014including Saas, Datacenter, and AI."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "As practitioners take on the responsibility of additional spend areas they risk spreading themselves thin. They are being asked to achieve more by increasing productivity through operational efficiencies."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Practitioners are reporting that they need investments into upskilling, staff augmentation, tooling and automation. The most successful FinOps practices are balancing their efforts by continually aligning their activities to the business strategy and applying the most relevant FinOps Capabilities to each new scope of technology spend."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    "There were 861 survey respondents representing ~$69B in public cloud spend, further data can be found in the ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: "/library",
                                                        children: "State of FinOps data library"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "lg:col-span-4 lg:col-start-8",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "graph-wrap",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: "Join the discussion and discover best practices"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                        className: "list-disc pl-5 text-green-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: 'underline',
                                                                    target: '_blank',
                                                                    href: "https://www.finops.org/topic/finops-for-ai/",
                                                                    children: "FinOps for AI"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: 'underline',
                                                                    target: '_blank',
                                                                    href: "https://www.finops.org/topic/scopes/",
                                                                    children: "FinOps Scopes"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: 'underline',
                                                                    target: '_blank',
                                                                    href: "https://www.finops.org/topic/value-through-optimization/",
                                                                    children: "Value through Optimization"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: 'underline',
                                                                    target: '_blank',
                                                                    href: "https://www.finops.org/topic/finops-is-everyones-job/",
                                                                    children: "FinOps is everyone's job"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: 'underline',
                                                                    target: '_blank',
                                                                    href: "https://www.finops.org/topic/finops-aware-product-decisions/",
                                                                    children: "FinOps-aware Product Decisions"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    className: 'underline',
                                                                    target: '_blank',
                                                                    href: "https://www.finops.org/topic/cloud-sustainability/ target={'_blank} ",
                                                                    children: "Cloud Sustainability"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: 'text-xl mt-10 mb-3',
                                                children: "Continue the Conversation"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                href: "https://x.finops.org/",
                                                target: '_blank',
                                                className: "f2card-v2 stacked fixed-footer",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "w-full",
                                                        src: "https://events.finops.org/wp-content/uploads/2024/11/X25-Featured-v1.png",
                                                        alt: "FinOps X 2025"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "content",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                className: 'mb-2',
                                                                children: "FinOps X 2025"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: "Join the largest gathering of FinOps professionals at FinOps X on June 2-5 in the beautiful San Diego."
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "footer",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "text-sm font-medium ml-auto",
                                                                    children: "June 2, 2025"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid xl:grid-cols-2 container px-4 mx-auto pt-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    width: "183",
                                    height: "48",
                                    viewBox: "0 0 183 48",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M57.0537 20.2699V1.15211H68.4484V3.17797H59.3547V9.58695H67.654V11.6142H59.3547V20.2699H57.0537Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M72.3374 2.82079C72.1521 2.83911 71.9649 2.81843 71.7881 2.76006C71.6112 2.7017 71.4486 2.60694 71.3106 2.4819C71.0941 2.23732 70.9812 1.91827 70.9954 1.59199V1.23278C70.9815 0.906349 71.0944 0.587198 71.3106 0.342189C71.6069 0.120064 71.9673 0 72.3377 0C72.7081 0 73.0685 0.120064 73.3649 0.342189C73.5807 0.587379 73.6936 0.906402 73.68 1.23278V1.58861C73.694 1.91483 73.5811 2.23379 73.3649 2.47852C73.227 2.6041 73.0643 2.69944 72.8874 2.75839C72.7104 2.81733 72.5231 2.83859 72.3374 2.82079ZM71.2414 6.13576H73.4333V20.2699H71.2414V6.13576Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M75.9533 20.27V6.13576H78.1445V8.41103H78.2543C78.5664 7.65999 79.072 7.00514 79.7197 6.51328C80.4654 6.00914 81.3549 5.76148 82.2539 5.80772C82.8993 5.77624 83.5438 5.88622 84.1423 6.12997C84.7408 6.37372 85.2788 6.74535 85.7186 7.21884C86.629 8.33993 87.0837 9.76283 86.9921 11.2041V20.27H84.8009V11.5681C84.8009 9.02373 83.7325 7.75179 81.5957 7.75224C81.1659 7.75123 80.7377 7.8066 80.3222 7.91694C79.9279 8.01931 79.5532 8.18627 79.2134 8.41103C78.8903 8.62401 78.6226 8.91096 78.4326 9.24808C78.2339 9.61415 78.1346 10.0259 78.1445 10.4423V20.27H75.9533Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M97.648 20.5993C96.4969 20.6167 95.3546 20.3975 94.2917 19.9555C93.3064 19.5335 92.4339 18.886 91.7446 18.0652C90.9994 17.1535 90.4461 16.1006 90.118 14.9698C89.7134 13.587 89.5195 12.1512 89.5425 10.7107C89.5187 9.27434 89.7127 7.84268 90.118 6.46447C90.45 5.33541 91.0029 4.28351 91.7446 3.36978C92.4306 2.54215 93.3037 1.88958 94.2917 1.46593C96.4417 0.607406 98.8393 0.607406 100.989 1.46593C101.983 1.8869 102.861 2.53973 103.551 3.36978C104.293 4.28373 104.847 5.33549 105.181 6.46447C105.586 7.84203 105.78 9.27294 105.757 10.7087C105.78 12.1491 105.587 13.5849 105.183 14.9678C104.853 16.0985 104.298 17.1512 103.553 18.0631C102.86 18.8864 101.982 19.5341 100.991 19.9534C99.9324 20.3938 98.7948 20.6135 97.648 20.5993ZM97.648 18.5715C98.4276 18.5796 99.2007 18.4302 99.9212 18.1323C100.604 17.8465 101.217 17.4149 101.715 16.8675C102.232 16.2926 102.628 15.6195 102.88 14.8885C103.164 14.0571 103.303 13.1832 103.29 12.3048V9.1159C103.303 8.23752 103.164 7.36358 102.88 6.53225C102.628 5.80118 102.232 5.12815 101.715 4.55316C101.217 4.00603 100.604 3.5746 99.9212 3.28913C98.4624 2.70173 96.8329 2.70173 95.3741 3.28913C94.6909 3.57443 94.0786 4.00588 93.58 4.55316C93.0629 5.12797 92.6669 5.80106 92.4156 6.53225C92.1317 7.36358 91.9928 8.23752 92.0049 9.1159V12.3048C91.9928 13.1832 92.1317 14.0571 92.4156 14.8885C92.6669 15.6197 93.0629 16.2927 93.58 16.8675C94.0785 17.415 94.6909 17.8467 95.3741 18.1323C96.0947 18.4301 96.8682 18.5793 97.648 18.5708V18.5715Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M107.892 6.13576H110.084V8.41103H110.193C110.498 7.5983 111.061 6.90793 111.796 6.4455C112.565 6.00359 113.442 5.78309 114.329 5.8084C115.153 5.7971 115.968 5.97519 116.712 6.32893C117.425 6.67636 118.048 7.18252 118.534 7.8085C119.064 8.50321 119.456 9.2937 119.686 10.1366C119.963 11.1353 120.096 12.1681 120.083 13.2042C120.096 14.2406 119.963 15.2735 119.686 16.2725C119.456 17.1154 119.064 17.9059 118.534 18.6006C118.048 19.2264 117.425 19.7323 116.712 20.0795C115.968 20.4338 115.153 20.6121 114.329 20.6007C113.457 20.6402 112.593 20.412 111.854 19.9465C111.115 19.4811 110.536 18.8007 110.195 17.9967H110.086V25.7484H107.894L107.892 6.13576ZM113.727 18.6542C114.271 18.6824 114.814 18.5925 115.32 18.3905C115.826 18.1886 116.282 17.8794 116.657 17.4843C117.394 16.6362 117.777 15.5371 117.726 14.4147V11.9917C117.777 10.8693 117.394 9.77012 116.657 8.92207C116.282 8.52698 115.826 8.21783 115.32 8.01589C114.814 7.81394 114.271 7.724 113.727 7.75224C113.249 7.74866 112.773 7.81721 112.316 7.95557C111.899 8.07772 111.506 8.26828 111.152 8.51947C110.832 8.74834 110.565 9.04415 110.371 9.38634C110.182 9.71753 110.083 10.0926 110.084 10.4742V15.7608C110.076 16.187 110.175 16.6085 110.371 16.9868C110.562 17.3431 110.828 17.6531 111.152 17.8951C111.502 18.1531 111.896 18.3442 112.316 18.459C112.774 18.59 113.249 18.6557 113.727 18.6542Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M127.247 20.5993C126.1 20.6391 124.962 20.3793 123.946 19.8457C123.054 19.338 122.275 18.6526 121.659 17.832L123.218 16.572C123.716 17.2234 124.34 17.7682 125.052 18.1743C125.776 18.5608 126.588 18.7543 127.408 18.7361C128.181 18.7825 128.947 18.5705 129.586 18.1336C129.808 17.9469 129.991 17.7179 130.124 17.4599C130.257 17.2019 130.337 16.9201 130.36 16.6308C130.383 16.3415 130.348 16.0505 130.257 15.7748C130.167 15.4991 130.022 15.2441 129.833 15.0247C129.295 14.5503 128.616 14.2663 127.901 14.2168L126.778 14.0521C126.163 13.9707 125.557 13.8286 124.97 13.6278C124.452 13.4517 123.967 13.1926 123.532 12.8606C123.124 12.544 122.795 12.1359 122.574 11.6691C122.334 11.1357 122.218 10.555 122.235 9.97057C122.22 9.34213 122.352 8.71888 122.618 8.1494C122.864 7.63995 123.225 7.19453 123.673 6.84809C124.152 6.48578 124.697 6.22075 125.277 6.06797C125.929 5.88984 126.601 5.80204 127.277 5.80703C128.274 5.77386 129.265 5.98073 130.167 6.41025C130.954 6.82139 131.649 7.3898 132.207 8.08027L130.756 9.39514C130.334 8.83331 129.782 8.38263 129.147 8.08209C128.512 7.78154 127.814 7.64018 127.112 7.67022C126.375 7.61683 125.643 7.82516 125.044 8.25852C124.813 8.45479 124.63 8.70126 124.509 8.97909C124.388 9.25691 124.332 9.55872 124.346 9.86144C124.322 10.1515 124.373 10.4429 124.495 10.707C124.618 10.9711 124.807 11.1987 125.044 11.3674C125.661 11.7319 126.347 11.9652 127.058 12.0527L128.153 12.2167C129.382 12.3072 130.551 12.7814 131.495 13.5722C131.827 13.9194 132.086 14.3301 132.255 14.7796C132.425 15.2292 132.502 15.7084 132.481 16.1884C132.51 16.798 132.399 17.4062 132.157 17.9664C131.915 18.5266 131.548 19.024 131.084 19.4207C129.988 20.2604 128.626 20.6786 127.247 20.5993Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M57.0537 47.662V28.5428H68.4484V30.5673H59.3547V36.979H67.654V39.0062H59.3547V47.662H57.0537Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M76.5673 47.9907C75.6728 48.002 74.786 47.8246 73.9647 47.4702C73.19 47.131 72.5019 46.6213 71.9517 45.9791C71.3726 45.2925 70.9304 44.5012 70.649 43.6482C70.0282 41.6642 70.0282 39.5378 70.649 37.5537C70.928 36.6964 71.3698 35.9011 71.9504 35.2114C72.5004 34.569 73.1886 34.0593 73.9633 33.7203C74.7848 33.3661 75.6715 33.1888 76.566 33.1997C77.4559 33.1881 78.3381 33.3655 79.1544 33.7203C79.9265 34.0638 80.6137 34.5729 81.1673 35.2114C81.7553 35.8981 82.2022 36.6941 82.4822 37.5537C83.104 39.5377 83.104 41.6643 82.4822 43.6482C82.1998 44.5025 81.7531 45.2934 81.1673 45.9764C80.6136 46.6147 79.9264 47.1237 79.1544 47.4675C78.3389 47.8233 77.457 48.0017 76.5673 47.9907ZM76.5673 46.0462C77.1 46.0671 77.6315 45.9809 78.1303 45.7927C78.629 45.6044 79.0849 45.3179 79.4709 44.9502C79.8744 44.4981 80.182 43.9688 80.3751 43.3943C80.5681 42.8199 80.6426 42.2122 80.5939 41.6081V39.5816C80.6424 38.9776 80.5679 38.3699 80.3749 37.7955C80.1819 37.2211 79.8743 36.6917 79.4709 36.2395C78.6686 35.5332 77.6363 35.1435 76.5673 35.1435C75.4984 35.1435 74.4661 35.5332 73.6638 36.2395C73.2602 36.6916 72.9526 37.221 72.7595 37.7954C72.5665 38.3699 72.492 38.9775 72.5407 39.5816V41.6081C72.4919 42.2122 72.5663 42.8199 72.7594 43.3944C72.9524 43.9689 73.2601 44.4982 73.6638 44.9502C74.0497 45.318 74.5056 45.6046 75.0043 45.7928C75.5031 45.9811 76.0346 46.0672 76.5673 46.0462Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M93.9602 45.3874H93.8511C93.699 45.7222 93.5202 46.0443 93.3164 46.3505C93.1028 46.6707 92.8392 46.9544 92.5356 47.1909C92.1978 47.4488 91.8178 47.646 91.4125 47.7738C90.9163 47.9271 90.3987 48.0004 89.8794 47.9907C89.2319 48.0217 88.5855 47.9116 87.9848 47.6681C87.3841 47.4245 86.8435 47.0534 86.4004 46.5803C85.4809 45.4632 85.0205 44.0382 85.1127 42.5943V33.5278H87.3039V42.2297C87.3039 44.774 88.3813 46.0462 90.5362 46.0462C90.966 46.047 91.3942 45.9916 91.8097 45.8815C92.2006 45.7806 92.5713 45.6135 92.9056 45.3874C93.2223 45.1708 93.4849 44.8841 93.6729 44.5497C93.8733 44.175 93.9723 43.7544 93.9602 43.3297V33.5278H96.1522V47.662H93.9602V45.3874Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M99.2197 47.662V33.5278H101.412V35.803H101.521C101.833 35.0521 102.339 34.3973 102.986 33.9053C103.732 33.4009 104.621 33.1532 105.52 33.1997C106.166 33.1684 106.81 33.2784 107.409 33.5221C108.007 33.7657 108.545 34.137 108.985 34.6102C109.896 35.7313 110.35 37.1546 110.259 38.5961V47.662H108.067V38.9601C108.067 36.4167 106.999 35.1445 104.863 35.1436C104.433 35.1427 104.004 35.1983 103.589 35.309C103.194 35.411 102.819 35.578 102.48 35.803C102.157 36.0162 101.889 36.3031 101.699 36.6401C101.501 37.006 101.402 37.4175 101.412 37.8336V47.6613L99.2197 47.662Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M122.503 45.3874H122.393C122.048 46.1883 121.468 46.8659 120.73 47.3306C119.992 47.7953 119.13 48.0255 118.259 47.9907C117.435 48.0023 116.62 47.8242 115.876 47.4702C115.163 47.1231 114.54 46.6169 114.055 45.9906C113.524 45.2963 113.132 44.5057 112.903 43.6625C112.373 41.6517 112.373 39.5381 112.903 37.5273C113.133 36.6842 113.524 35.8936 114.055 35.1992C114.541 34.5731 115.164 34.0669 115.876 33.7196C116.62 33.3659 117.435 33.1878 118.259 33.1991C119.146 33.1738 120.023 33.3946 120.793 33.8368C121.528 34.2993 122.09 34.9897 122.395 35.8024H122.505V27.3919H124.696V47.662H122.505L122.503 45.3874ZM118.86 46.0462C119.337 46.0482 119.812 45.9834 120.271 45.8537C120.69 45.7387 121.084 45.5473 121.434 45.2891C121.758 45.0471 122.025 44.7368 122.215 44.3802C122.412 44.0025 122.511 43.5814 122.503 43.1555V37.8689C122.504 37.4873 122.405 37.112 122.215 36.7811C122.021 36.439 121.754 36.1432 121.434 35.9142C121.08 35.6633 120.687 35.4727 120.271 35.3503C119.814 35.2107 119.338 35.1407 118.86 35.1429C118.316 35.1147 117.772 35.2048 117.266 35.407C116.76 35.6092 116.304 35.9187 115.929 36.3141C115.192 37.162 114.809 38.2608 114.861 39.383V41.8054C114.809 42.928 115.192 44.0273 115.929 44.8757C116.304 45.2709 116.76 45.5802 117.266 45.7822C117.772 45.9843 118.316 46.0743 118.86 46.0462Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M138.773 47.662C138.448 47.6938 138.12 47.6511 137.814 47.5372C137.508 47.4233 137.232 47.2411 137.007 47.0045C136.635 46.5296 136.403 45.9609 136.335 45.3616H136.199C135.935 46.1786 135.392 46.8768 134.666 47.3339C133.895 47.7874 133.012 48.0149 132.118 47.9907C130.849 48.0685 129.599 47.656 128.625 46.8385C128.206 46.438 127.877 45.9518 127.662 45.413C127.447 44.8743 127.35 44.2955 127.378 43.716C127.348 43.123 127.466 42.5318 127.722 41.996C127.978 41.4603 128.363 40.9968 128.844 40.6477C129.821 39.9352 131.341 39.5791 133.405 39.5796H136.199V38.1841C136.227 37.7647 136.169 37.3439 136.027 36.9481C135.886 36.5523 135.664 36.1899 135.376 35.8837C134.671 35.3005 133.767 35.0155 132.855 35.0894C132.097 35.062 131.348 35.2625 130.705 35.6648C130.117 36.0617 129.626 36.5856 129.267 37.1979L127.952 35.9657C128.374 35.1579 129.009 34.4806 129.788 34.007C130.747 33.4366 131.85 33.156 132.965 33.1991C134.408 33.109 135.833 33.5569 136.964 34.4563C137.445 34.8983 137.822 35.4412 138.068 36.0461C138.314 36.651 138.423 37.3029 138.387 37.955V45.7168H140.004V47.662H138.773ZM132.473 46.1282C132.981 46.1331 133.488 46.0685 133.979 45.9364C134.401 45.8251 134.8 45.6394 135.157 45.3881C135.468 45.171 135.729 44.8912 135.924 44.5666C136.105 44.2596 136.198 43.9094 136.195 43.5533V41.2252H133.292C132.342 41.1571 131.391 41.346 130.539 41.7722C130.266 41.9349 130.041 42.1685 129.889 42.4482C129.737 42.7279 129.664 43.0434 129.676 43.3615V43.9363C129.661 44.2467 129.722 44.5561 129.853 44.8377C129.984 45.1194 130.182 45.3648 130.43 45.5528C131.028 45.9658 131.747 46.1682 132.473 46.1282Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M145.678 47.662C145.359 47.6851 145.039 47.6397 144.739 47.5291C144.439 47.4184 144.166 47.2448 143.938 47.0201C143.533 46.5566 143.322 45.9545 143.349 45.3393V35.473H141.021V33.5278H142.336C142.509 33.548 142.685 33.5329 142.852 33.4835C143.019 33.4341 143.174 33.3514 143.309 33.2404C143.512 32.9488 143.604 32.5943 143.569 32.2407V29.611H145.54V33.5278H148.636V35.473H145.54V45.7168H148.417V47.662H145.678Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M153.171 30.2135C152.986 30.2312 152.799 30.2099 152.622 30.151C152.445 30.092 152.282 29.9967 152.145 29.8712C151.928 29.6263 151.816 29.3071 151.83 28.9806V28.6248C151.816 28.2984 151.929 27.9792 152.145 27.7342C152.441 27.5121 152.801 27.392 153.172 27.392C153.542 27.392 153.903 27.5121 154.199 27.7342C154.415 27.9794 154.528 28.2984 154.514 28.6248V28.9806C154.528 29.307 154.415 29.6261 154.199 29.8712C154.061 29.9967 153.898 30.0919 153.721 30.1509C153.544 30.2098 153.357 30.2311 153.171 30.2135ZM152.076 33.5278H154.267V47.662H152.076V33.5278Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M162.961 47.9907C162.067 48.0019 161.18 47.8245 160.359 47.4702C159.584 47.1313 158.896 46.6216 158.346 45.9791C157.768 45.2933 157.326 44.503 157.045 43.6509C156.424 41.6669 156.424 39.5405 157.045 37.5564C157.324 36.699 157.765 35.9036 158.346 35.2141C158.896 34.5714 159.584 34.0616 160.359 33.723C161.18 33.3689 162.067 33.1916 162.961 33.2025C163.851 33.1907 164.733 33.3681 165.55 33.723C166.322 34.0663 167.01 34.5753 167.563 35.2141C168.151 35.901 168.598 36.6969 168.878 37.5564C169.499 39.5405 169.499 41.6669 168.878 43.6509C168.595 44.5051 168.149 45.2959 167.563 45.9791C167.009 46.6176 166.322 47.1266 165.55 47.4702C164.733 47.8254 163.851 48.0028 162.961 47.9907ZM162.961 46.0462C163.494 46.0671 164.025 45.9809 164.524 45.7927C165.023 45.6044 165.479 45.3179 165.865 44.9502C166.268 44.4982 166.576 43.9689 166.769 43.3944C166.962 42.8199 167.037 42.2122 166.988 41.6081V39.5816C167.036 38.9775 166.962 38.3699 166.769 37.7954C166.576 37.221 166.268 36.6916 165.865 36.2395C165.063 35.5332 164.03 35.1436 162.962 35.1436C161.893 35.1436 160.86 35.5332 160.058 36.2395C159.655 36.6916 159.347 37.221 159.154 37.7954C158.961 38.3699 158.887 38.9775 158.935 39.5816V41.6081C158.886 42.2122 158.961 42.8199 159.154 43.3944C159.347 43.9689 159.655 44.4982 160.058 44.9502C160.444 45.318 160.9 45.6045 161.399 45.7928C161.897 45.9811 162.429 46.0672 162.961 46.0462Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M171.067 47.662V33.5278H173.259V35.803H173.368C173.681 35.0523 174.186 34.3975 174.834 33.9053C175.579 33.4009 176.469 33.1532 177.368 33.1997C178.013 33.1684 178.658 33.2784 179.256 33.5221C179.855 33.7657 180.393 34.137 180.833 34.6102C181.744 35.7312 182.199 37.1545 182.107 38.5961V47.662H179.916V38.9601C179.916 36.4167 178.847 35.1445 176.71 35.1436C176.28 35.1427 175.852 35.1983 175.436 35.309C175.042 35.4112 174.667 35.5781 174.327 35.803C174.004 36.0162 173.737 36.3031 173.547 36.6401C173.348 37.006 173.249 37.4175 173.259 37.8336V47.6613L171.067 47.662Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18.4629 47.662L0.5 37.6208V16.9753L18.4629 27.0158V47.662Z",
                                            fill: "#1EA482"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M24.6049 47.662L42.5678 37.6208V16.9753L24.6049 27.0158V47.662Z",
                                            fill: "#1EA482"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M21.5311 1.15077L3.58179 11.806L21.5311 21.839L39.4805 11.806L21.5311 1.15077Z",
                                            fill: "#1EA482"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-6 mt-6 xl:mt-0 xl:justify-end",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-800 font-normal mt-0 mb-0",
                                        children: "Follow Us:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "https://www.linkedin.com/company/finops-foundation",
                                        className: "h-[24px] social-link text-gray-700 hover:text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Linkedin"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                className: "h-6 w-6",
                                                fill: "currentColor",
                                                viewBox: "0 0 24 24",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    className: "hover",
                                                    fill: "#979FA6",
                                                    d: "M21.8,0H2.2C1,0,0,1,0,2.2v19.7C0,23,1,24,2.2,24h19.7c1.2,0,2.2-1,2.2-2.2V2.2C24,1,23,0,21.8,0z M7.4,20.7 c0,0.3-0.3,0.6-0.6,0.6H4.1c-0.3,0-0.6-0.3-0.6-0.6V9.4c0-0.3,0.3-0.6,0.6-0.6h2.7c0.3,0,0.6,0.3,0.6,0.6V20.7z M5.5,7.8 C4,7.8,2.9,6.6,2.9,5.2S4,2.6,5.5,2.6S8,3.8,8,5.2S6.9,7.8,5.5,7.8z M21.5,20.8c0,0.3-0.3,0.6-0.6,0.6H18c-0.3,0-0.6-0.3-0.6-0.6 v-5.3c0-0.8,0.2-3.5-2.1-3.5c-1.8,0-2.1,1.8-2.2,2.6v6.1c0,0.3-0.3,0.6-0.6,0.6H9.8c-0.3,0-0.6-0.3-0.6-0.6V9.4 c0-0.3,0.3-0.6,0.6-0.6h2.8c0.3,0,0.6,0.3,0.6,0.6v1c0.7-1,1.6-1.8,3.7-1.8c4.6,0,4.6,4.3,4.6,6.7L21.5,20.8L21.5,20.8z"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "https://github.com/finopsfoundation",
                                        className: "h-[24px] social-link text-gray-700 hover:text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "GitHub"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                className: "h-6 w-6",
                                                fill: "currentColor",
                                                viewBox: "0 0 24 24",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    className: "hover",
                                                    fill: "#979FA6",
                                                    fillRule: "evenodd",
                                                    d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
                                                    clipRule: "evenodd"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "https://www.youtube.com/channel/UCyl26lvnoySlGWlF5oNHvYA",
                                        className: "h-[24px] social-link top-[-4px] relative text-gray-700 hover:text-gray-600 -mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "YouTube"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                className: "h-10 w-10 mt-px",
                                                fill: "currentColor",
                                                viewBox: "0 0 512 512",
                                                "aria-hidden": "true",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        className: "hover",
                                                        fill: "#979FA6",
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "m427 169c-4-15-17-27-32-31-34-9-239-10-278 0-15 4-28 16-32 31-9 38-10 135 0 174 4 15 17 27 32 31 36 10 241 10 278 0 15-4 28-16 32-31 9-36 9-137 0-174"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "m220 203v106l93-53",
                                                        fill: "#FFF"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "container px-6  px-4 mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pt-12 xl:pt-24 md:w-8/12 lg:w-7/12 xl:w-6/12",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid md:grid-cols-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-4 md:m-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-xs text-gray-400 font-normal m-0 mb-5",
                                                    children: "FinOps Foundation"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "m-0 plain-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/about/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "About"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/about/media/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Media Resources"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://github.com/finopsfoundation/tac/blob/master/charter.md",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Technical Charter"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://github.com/finopsfoundation/foundation/blob/main/03-code_of_conduct.md",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Code of Conduct"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-4 md:m-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-xs text-gray-400 font-normal  m-0 mb-5",
                                                    children: "Resources"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "m-0 plain-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/resources/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "FinOps Assets"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/community/events/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Events"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/community/finops-book",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "O\u2019Reilly FinOps Book"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-xs text-gray-400 font-normal  m-0 mb-5",
                                                    children: "Training and Certification"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "m-0 plain-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://learn.finops.org/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Full Course Catalog"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://learn.finops.org/page/finops-certified-practitioner",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "FinOps Certified Practitioner"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://learn.finops.org/path/finops-certified-professional",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "FinOps Certified Professional"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/partner-certifications/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Member Certification"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-12 pb-8 container mx-auto px-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-500 mb-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "text-gray-500 no-underline font-normal",
                                    href: "https://finops.org/introduction/how-to-use/",
                                    target: "_blank",
                                    rel: "license noopener noreferrer",
                                    children: "This work is licensed under Attribution 4.0 International"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-500 mb-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "\xa9 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("script", {
                                            children: "document.write(new Date().getFullYear())"
                                        }),
                                        "2025 FinOps Foundation Project a Series of LF Projects, LLC."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-500 mb-2",
                                children: [
                                    "For web site terms of use, trademark policy and other project policies please see ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        className: "text-gray-500 no-underline font-normal",
                                        href: "https://lfprojects.org",
                                        children: "https://lfprojects.org"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    "For the technical charter of FinOps Project a Series of LF Projects, LLC, please see the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        className: "text-gray-500 no-underline font-normal",
                                        href: "https://github.com/finopsfoundation/tac/blob/master/charter.md",
                                        children: "Technical Charter"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $08ddbbee6dff0102$exports = {};
'use client';

var $acw62 = parcelRequire("acw62");
var $08ddbbee6dff0102$require$createElement = $acw62.createElement;
var $08ddbbee6dff0102$require$useEffect = $acw62.useEffect;
var $08ddbbee6dff0102$require$useRef = $acw62.useRef;
function $08ddbbee6dff0102$var$DangerouslySetHtmlContent({ html: html, dangerouslySetInnerHTML: dangerouslySetInnerHTML, allowRerender: allowRerender, ...rest }) {
    // We remove 'dangerouslySetInnerHTML' from props passed to the div
    const divRef = $08ddbbee6dff0102$require$useRef(null);
    const isFirstRender = $08ddbbee6dff0102$require$useRef(true);
    $08ddbbee6dff0102$require$useEffect(()=>{
        if (!html || !divRef.current) throw new Error("html prop can't be null");
        if (!isFirstRender.current) return;
        isFirstRender.current = Boolean(allowRerender);
        const slotHtml = document.createRange().createContextualFragment(html) // Create a 'tiny' document and parse the html string
        ;
        divRef.current.innerHTML = '' // Clear the container
        ;
        divRef.current.appendChild(slotHtml) // Append the new content
        ;
    }, [
        html,
        divRef
    ]);
    return $08ddbbee6dff0102$require$createElement('div', {
        ...rest,
        ref: divRef
    });
}
$08ddbbee6dff0102$exports = $08ddbbee6dff0102$var$DangerouslySetHtmlContent;


class $61772e5691137147$export$ea466aac2a3f8f30 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(){
        super();
        this.state = {
            loaded: false
        };
    }
    componentDidMount() {
        window.requestAnimationFrame(()=>this.setState({
                loaded: true
            }));
    }
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    onClick: ()=>{
                        this.props.toggleOpen();
                    },
                    className: "bg-gray-800 opacity-50 h-[100vh] w-[100vw] fixed top-0 left-0 z-10"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "card open-card fixed top-0 z-11 h-full left-0 card-full bg-white col-span-3 rounded-lg  " + (this.state.loaded ? 'active' : ''),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: 'grid grid-cols-12',
                        style: {
                            height: 720
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "graph bg-gray-50 col-span-12 lg:col-span-7 flex items-center justify-center p-8",
                                children: [
                                    this.props.hit.chart_image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: this.props.hit.chart_image,
                                        alt: ""
                                    }),
                                    this.props.hit.chart_code && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($08ddbbee6dff0102$exports))), {
                                        className: 'canvas-container',
                                        html: this.props.hit.chart_code.replace('id=""', 'id="large_' + this.props.hit.objectID + '"').replace('getElementById("")', 'getElementById("large_' + this.props.hit.objectID + '")')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "p-8 pb-[9rem] relative col-span-12 lg:col-span-5",
                                children: [
                                    this.props.hit.years.map((year, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "bg-gray-100 mr-2 inline-block mb-2 px-2 rounded-xs text-sm text-gray-600",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: year
                                            }, index)
                                        })),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-2xl mb-3 md:mt-5 mt-3 font-medium",
                                        dangerouslySetInnerHTML: {
                                            __html: this.props.hit.title
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: this.props.hit.content
                                        }
                                    }),
                                    !!this.props.hit.related_capabilities && this.props.hit.related_capabilities.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "mt-10 font-semibold text-xl text-gray-800",
                                                children: "Related Framework Capabilities"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "View maturity information, benchmarks and key performance indicators."
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                children: !!this.props.hit.related_capabilities && this.props.hit.related_capabilities.map((capability, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            className: 'text-green-500',
                                                            href: capability.url,
                                                            children: capability.title
                                                        })
                                                    }, index))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                        className: "lg:absolute mt-4 text-gray-600 text-sm bottom-[6rem] block left-8",
                                        children: [
                                            "Source: ",
                                            this.props.hit.source,
                                            this.props.hit.show_how_to_attribute_link ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    " - ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        class: "text-green-500",
                                                        href: "https://finops.org/introduction/how-to-use/?__hstc=181257784.74da63e6b63b6d8f44ef9bdb24a14c42.1693312584865.1708450572284.1708524956564.222&__hssc=181257784.1.1708524956564&__hsfp=4031198360",
                                                        target: "_blank",
                                                        children: "How to attribute."
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    this.props.hit.n_number ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                        className: "lg:absolute block text-gray-600 text-sm bottom-[6rem] right-8",
                                        children: [
                                            "n=",
                                            this.props.hit.n_number
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "absolute bottom-8 right-8",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>this.props.toggleOpen(),
                                                className: "inline-flex justify-center py-2 px-5 text-md font-medium rounded border border-gray-100 hover:border-gray-300 font-normal mr-2",
                                                children: "Close"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>this.props.copyToClipboard(this.props.hit.objectID),
                                                className: "inline-flex justify-center py-2 text-green-900 px-5 text-md ml-4 font-medium rounded border border-green-500 bg-green-500 hover:bg-green-300 hover:border-green-300 font-normal",
                                                children: "Copy Link"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}



const $158450ec41bac1dc$var$useHash = ()=>{
    const [hash, setHash] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>window.location.hash);
    const hashChangeHandler = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setHash(window.location.hash);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        window.addEventListener('hashchange', hashChangeHandler);
        return ()=>{
            window.removeEventListener('hashchange', hashChangeHandler);
        };
    }, []);
    const updateHash = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((newHash)=>{
        if (newHash !== hash) window.location.hash = newHash;
    }, [
        hash
    ]);
    return [
        hash,
        updateHash
    ];
};
const $158450ec41bac1dc$export$60332b2344f7fe41 = ({ hit: hit })=>{
    const [isOpen, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [hash, setHash] = $158450ec41bac1dc$var$useHash();
    const copyToClipboard = (ID = null)=>{
        let card = document.getElementById('card-' + ID);
        let aux = document.createElement("div");
        aux.setAttribute("contentEditable", true);
        aux.innerHTML = location.protocol + '//' + location.host + location.pathname + '#' + ID;
        aux.style.position = "absolute";
        aux.style.left = "-9999px";
        aux.setAttribute("onfocus", "document.execCommand('selectAll',false,null)");
        card.appendChild(aux);
        aux.focus();
        document.execCommand("copy");
        // document.body.removeChild(aux);
        return false;
    };
    const toggleOpen = (ID = null)=>{
        if (ID) {
            history.pushState("", document.title, window.location.pathname + window.location.search + '#' + ID);
            const element = document.getElementById('card-' + ID);
            if (element) element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
        } else history.pushState("", document.title, window.location.pathname + window.location.search);
        setOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        if (window.location.hash.length > 0 && window.location.hash.replace('#', '') === hit.objectID) setTimeout(()=>{
            const element = document.getElementById(window.location.hash.replace('#', 'card-'));
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
                setOpen(true);
            }
        }, 100);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: 'card-' + hit.objectID,
                className: "card md:pb-20 h-full relative bg-white rounded-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "graph relative p-5 md:p-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-gray-50 h-[350px]",
                            children: [
                                hit.chart_image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center justify-center h-full",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: ' h-[250px]',
                                        src: hit.chart_image,
                                        alt: ""
                                    })
                                }),
                                hit.chart_code && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center justify-center h-full",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($08ddbbee6dff0102$exports))), {
                                        className: 'w-11/12 h-[250px]',
                                        html: hit.chart_code.replace('id=""', 'id="small_' + hit.objectID + '"').replace('getElementById("")', 'getElementById("small_' + hit.objectID + '")')
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pt-0 p-5 md:p-8",
                        children: [
                            hit.years.map((year, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-gray-100 mr-2 inline-block mb-2 px-2 rounded-xs text-sm text-gray-600",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: year
                                    }, index)
                                })),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-2xl text-slate-100 font-bold mb-3",
                                dangerouslySetInnerHTML: {
                                    __html: hit.title
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: '',
                                dangerouslySetInnerHTML: {
                                    __html: hit.excerpt + (hit.excerpt !== hit.content ? '...' : '')
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "md:absolute mt-5 md:mt-5 bottom-8 left-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>toggleOpen(hit.objectID),
                                        className: "inline-flex justify-center py-2 text-green-900 px-5 text-md font-medium rounded border border-green-500 bg-green-500 hover:bg-green-300 hover:border-green-300 font-normal",
                                        children: "Expand"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>copyToClipboard(hit.objectID),
                                        className: "inline-flex justify-center py-2 px-5 text-md font-medium rounded border border-gray-100 hover:border-gray-300 font-normal ml-4",
                                        children: "Copy Link"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61772e5691137147$export$ea466aac2a3f8f30), {
                hit: hit,
                copyToClipboard: (ID)=>copyToClipboard(ID),
                toggleOpen: ()=>toggleOpen()
            })
        ]
    });
};




parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== 'undefined';
var $77ddc6be16b1d7de$var$hasMap = typeof Map === 'function';
var $77ddc6be16b1d7de$var$hasSet = typeof Set === 'function';
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $acw62 = parcelRequire("acw62");
var $47b0e931f98d53f4$export$ff81ba61a8eb8836 = /*#__PURE__*/ (0, $acw62.createContext)({
    onInternalStateUpdate: function onInternalStateUpdate() {
        return undefined;
    },
    createHrefForState: function createHrefForState() {
        return '#';
    },
    onSearchForFacetValues: function onSearchForFacetValues() {
        return undefined;
    },
    onSearchStateChange: function onSearchStateChange() {
        return undefined;
    },
    onSearchParameters: function onSearchParameters() {
        return undefined;
    },
    store: {},
    widgetsManager: {},
    mainTargetedIndex: ''
});
var $47b0e931f98d53f4$export$d6a52d81667faed0 = $47b0e931f98d53f4$export$ff81ba61a8eb8836.Consumer, $47b0e931f98d53f4$export$1d7b3f5181886950 = $47b0e931f98d53f4$export$ff81ba61a8eb8836.Provider;
var $47b0e931f98d53f4$var$_createContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined), $47b0e931f98d53f4$export$3f2d2afcc6b19a5e = $47b0e931f98d53f4$var$_createContext.Consumer, $47b0e931f98d53f4$export$c8316afa5154342c = $47b0e931f98d53f4$var$_createContext.Provider;


function $f89bd5ce2595ad4c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f89bd5ce2595ad4c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f89bd5ce2595ad4c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f89bd5ce2595ad4c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f89bd5ce2595ad4c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f89bd5ce2595ad4c$var$_defineProperty(obj, key, value) {
    key = $f89bd5ce2595ad4c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f89bd5ce2595ad4c$var$_toPropertyKey(arg) {
    var key = $f89bd5ce2595ad4c$var$_toPrimitive(arg, "string");
    return $f89bd5ce2595ad4c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f89bd5ce2595ad4c$var$_toPrimitive(input, hint) {
    if ($f89bd5ce2595ad4c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f89bd5ce2595ad4c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f89bd5ce2595ad4c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f89bd5ce2595ad4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f89bd5ce2595ad4c$var$_typeof(obj);
}
// eslint-disable-next-line @typescript-eslint/unbound-method
var $f89bd5ce2595ad4c$var$hasOwn = Object.prototype.hasOwnProperty;
var $f89bd5ce2595ad4c$export$d36bdfa510afb180 = function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(var i = 0; i < keysA.length; i++){
        if (!$f89bd5ce2595ad4c$var$hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
};
var $f89bd5ce2595ad4c$export$be63e0664592e141 = function getDisplayName(Component) {
    return Component.displayName || Component.name || 'UnknownComponent';
};
var $f89bd5ce2595ad4c$var$resolved = Promise.resolve();
var $f89bd5ce2595ad4c$export$260e5c0943f31606 = function defer(f) {
    $f89bd5ce2595ad4c$var$resolved.then(f);
};
var $f89bd5ce2595ad4c$var$isPlainObject = function isPlainObject(value) {
    return $f89bd5ce2595ad4c$var$_typeof(value) === 'object' && value !== null && !Array.isArray(value);
};
var $f89bd5ce2595ad4c$export$a6eed9ac762cbbd3 = function removeEmptyKey(obj) {
    Object.keys(obj).forEach(function(key) {
        var value = obj[key];
        if (!$f89bd5ce2595ad4c$var$isPlainObject(value)) return;
        if (!$f89bd5ce2595ad4c$export$f6de9748f8da7bed(value)) delete obj[key];
        else removeEmptyKey(value);
    });
    return obj;
};
var $f89bd5ce2595ad4c$export$b70593b048b9902c = function removeEmptyArraysFromObject(obj) {
    Object.keys(obj).forEach(function(key) {
        var value = obj[key];
        if (Array.isArray(value) && value.length === 0) delete obj[key];
    });
    return obj;
};
function $f89bd5ce2595ad4c$export$d6716b2aedb78d9e(hits, hitsPerPage, page) {
    return hits.map(function(hit, index) {
        return $f89bd5ce2595ad4c$var$_objectSpread($f89bd5ce2595ad4c$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + index + 1
        });
    });
}
function $f89bd5ce2595ad4c$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $f89bd5ce2595ad4c$var$_objectSpread($f89bd5ce2595ad4c$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}
function $f89bd5ce2595ad4c$export$71aa6c912b956294(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
}
function $f89bd5ce2595ad4c$export$f6de9748f8da7bed(object) {
    return object && Object.keys(object).length > 0;
}
function $f89bd5ce2595ad4c$export$30a06c8d3562193f(source, excluded) {
    if (source === null || source === undefined) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    for(var i = 0; i < sourceKeys.length; i++){
        var key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f89bd5ce2595ad4c$export$d14846335956eefa = function getPropertyByPath(object, path) {
    return (Array.isArray(path) ? path : path.replace(/\[(\d+)]/g, '.$1').split('.')).reduce(function(current, key) {
        return current ? current[key] : undefined;
    }, object);
};
function $f89bd5ce2595ad4c$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}
function $f89bd5ce2595ad4c$export$ad628980c7383a99(value) {
    return value.replace(/^\\-/, '-');
}


var $d7c20ea8341de50d$var$_excluded = [
    "contextValue"
];
function $d7c20ea8341de50d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d7c20ea8341de50d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d7c20ea8341de50d$var$_typeof(obj);
}
function $d7c20ea8341de50d$var$_extends() {
    $d7c20ea8341de50d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d7c20ea8341de50d$var$_extends.apply(this, arguments);
}
function $d7c20ea8341de50d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d7c20ea8341de50d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d7c20ea8341de50d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d7c20ea8341de50d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d7c20ea8341de50d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d7c20ea8341de50d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d7c20ea8341de50d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d7c20ea8341de50d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d7c20ea8341de50d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d7c20ea8341de50d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d7c20ea8341de50d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d7c20ea8341de50d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d7c20ea8341de50d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d7c20ea8341de50d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d7c20ea8341de50d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d7c20ea8341de50d$var$_setPrototypeOf(subClass, superClass);
}
function $d7c20ea8341de50d$var$_setPrototypeOf(o, p) {
    $d7c20ea8341de50d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d7c20ea8341de50d$var$_setPrototypeOf(o, p);
}
function $d7c20ea8341de50d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d7c20ea8341de50d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d7c20ea8341de50d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d7c20ea8341de50d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d7c20ea8341de50d$var$_possibleConstructorReturn(this, result);
    };
}
function $d7c20ea8341de50d$var$_possibleConstructorReturn(self, call) {
    if (call && ($d7c20ea8341de50d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d7c20ea8341de50d$var$_assertThisInitialized(self);
}
function $d7c20ea8341de50d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d7c20ea8341de50d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d7c20ea8341de50d$var$_getPrototypeOf(o) {
    $d7c20ea8341de50d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d7c20ea8341de50d$var$_getPrototypeOf(o);
}
function $d7c20ea8341de50d$var$_defineProperty(obj, key, value) {
    key = $d7c20ea8341de50d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d7c20ea8341de50d$var$_toPropertyKey(arg) {
    var key = $d7c20ea8341de50d$var$_toPrimitive(arg, "string");
    return $d7c20ea8341de50d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d7c20ea8341de50d$var$_toPrimitive(input, hint) {
    if ($d7c20ea8341de50d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d7c20ea8341de50d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d7c20ea8341de50d$export$1b8ac54304d7be60(connectorDesc) {
    if (!connectorDesc.displayName) throw new Error('`createConnector` requires you to provide a `displayName` property.');
    var isWidget = typeof connectorDesc.getSearchParameters === 'function' || typeof connectorDesc.getMetadata === 'function' || typeof connectorDesc.transitionState === 'function';
    return function(Composed) {
        var additionalWidgetProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var Connector = /*#__PURE__*/ function(_Component) {
            $d7c20ea8341de50d$var$_inherits(Connector, _Component);
            var _super = $d7c20ea8341de50d$var$_createSuper(Connector);
            function Connector(props) {
                var _this;
                $d7c20ea8341de50d$var$_classCallCheck(this, Connector);
                _this = _super.call(this, props);
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "unsubscribe", void 0);
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "unregisterWidget", void 0);
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "cleanupTimerRef", null);
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "isUnmounting", false);
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "state", {
                    providedProps: _this.getProvidedProps(_this.props)
                });
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "refine", function() {
                    var _ref;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    _this.props.contextValue.onInternalStateUpdate(// refine will always be defined here because the prop is only given conditionally
                    (_ref = connectorDesc.refine).call.apply(_ref, [
                        $d7c20ea8341de50d$var$_assertThisInitialized(_this),
                        _this.props,
                        _this.props.contextValue.store.getState().widgets
                    ].concat(args)));
                });
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "createURL", function() {
                    var _ref2;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    return _this.props.contextValue.createHrefForState(// refine will always be defined here because the prop is only given conditionally
                    (_ref2 = connectorDesc.refine).call.apply(_ref2, [
                        $d7c20ea8341de50d$var$_assertThisInitialized(_this),
                        _this.props,
                        _this.props.contextValue.store.getState().widgets
                    ].concat(args)));
                });
                $d7c20ea8341de50d$var$_defineProperty($d7c20ea8341de50d$var$_assertThisInitialized(_this), "searchForFacetValues", function() {
                    var _ref3;
                    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                    _this.props.contextValue.onSearchForFacetValues(// searchForFacetValues will always be defined here because the prop is only given conditionally
                    (_ref3 = connectorDesc.searchForFacetValues).call.apply(_ref3, [
                        $d7c20ea8341de50d$var$_assertThisInitialized(_this),
                        _this.props,
                        _this.props.contextValue.store.getState().widgets
                    ].concat(args)));
                });
                if (connectorDesc.getSearchParameters) _this.props.contextValue.onSearchParameters(connectorDesc.getSearchParameters.bind($d7c20ea8341de50d$var$_assertThisInitialized(_this)), {
                    ais: _this.props.contextValue,
                    multiIndexContext: _this.props.indexContextValue
                }, _this.props, connectorDesc.getMetadata && connectorDesc.getMetadata.bind($d7c20ea8341de50d$var$_assertThisInitialized(_this)), connectorDesc.displayName);
                return _this;
            }
            $d7c20ea8341de50d$var$_createClass(Connector, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        var _this2 = this;
                        if (this.cleanupTimerRef) {
                            clearTimeout(this.cleanupTimerRef);
                            this.cleanupTimerRef = null;
                        }
                        this.unsubscribe = this.props.contextValue.store.subscribe(function() {
                            if (!_this2.isUnmounting) _this2.setState({
                                providedProps: _this2.getProvidedProps(_this2.props)
                            });
                        });
                        if (isWidget) this.unregisterWidget = this.props.contextValue.widgetsManager.registerWidget(this);
                    }
                },
                {
                    key: "shouldComponentUpdate",
                    value: function shouldComponentUpdate(nextProps, nextState) {
                        if (typeof connectorDesc.shouldComponentUpdate === 'function') return connectorDesc.shouldComponentUpdate.call(this, this.props, nextProps, this.state, nextState);
                        var propsEqual = (0, $f89bd5ce2595ad4c$export$d36bdfa510afb180)(this.props, nextProps);
                        if (this.state.providedProps === null || nextState.providedProps === null) {
                            if (this.state.providedProps === nextState.providedProps) return !propsEqual;
                            return true;
                        }
                        return !propsEqual || !(0, $f89bd5ce2595ad4c$export$d36bdfa510afb180)(this.state.providedProps, nextState.providedProps);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate(prevProps) {
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(prevProps, this.props)) {
                            this.setState({
                                providedProps: this.getProvidedProps(this.props)
                            });
                            if (isWidget) {
                                this.props.contextValue.widgetsManager.update();
                                if (typeof connectorDesc.transitionState === 'function') this.props.contextValue.onSearchStateChange(connectorDesc.transitionState.call(this, this.props, this.props.contextValue.store.getState().widgets, this.props.contextValue.store.getState().widgets));
                            }
                        }
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        var _this3 = this;
                        this.cleanupTimerRef = setTimeout(function() {
                            _this3.isUnmounting = true;
                            if (_this3.unsubscribe) _this3.unsubscribe();
                            if (_this3.unregisterWidget) {
                                _this3.unregisterWidget();
                                if (typeof connectorDesc.cleanUp === 'function') {
                                    var nextState = connectorDesc.cleanUp.call(_this3, _this3.props, _this3.props.contextValue.store.getState().widgets);
                                    _this3.props.contextValue.store.setState($d7c20ea8341de50d$var$_objectSpread($d7c20ea8341de50d$var$_objectSpread({}, _this3.props.contextValue.store.getState()), {}, {
                                        widgets: nextState
                                    }));
                                    _this3.props.contextValue.onSearchStateChange((0, $f89bd5ce2595ad4c$export$a6eed9ac762cbbd3)(nextState));
                                }
                            }
                        });
                    }
                },
                {
                    key: "getProvidedProps",
                    value: function getProvidedProps(props) {
                        var _this$props$contextVa = this.props.contextValue.store.getState(), widgets = _this$props$contextVa.widgets, results = _this$props$contextVa.results, resultsFacetValues = _this$props$contextVa.resultsFacetValues, searching = _this$props$contextVa.searching, searchingForFacetValues = _this$props$contextVa.searchingForFacetValues, isSearchStalled = _this$props$contextVa.isSearchStalled, metadata = _this$props$contextVa.metadata, error = _this$props$contextVa.error;
                        var searchResults = {
                            results: results,
                            searching: searching,
                            searchingForFacetValues: searchingForFacetValues,
                            isSearchStalled: isSearchStalled,
                            error: error
                        };
                        return connectorDesc.getProvidedProps.call(this, props, widgets, searchResults, metadata, // @MAJOR: move this attribute on the `searchResults` it doesn't
                        // makes sense to have it into a separate argument. The search
                        // flags are on the object why not the results?
                        resultsFacetValues);
                    }
                },
                {
                    key: "getSearchParameters",
                    value: function getSearchParameters(searchParameters) {
                        if (typeof connectorDesc.getSearchParameters === 'function') return connectorDesc.getSearchParameters.call(this, searchParameters, this.props, this.props.contextValue.store.getState().widgets);
                        return null;
                    }
                },
                {
                    key: "getMetadata",
                    value: function getMetadata(nextWidgetsState) {
                        if (typeof connectorDesc.getMetadata === 'function') return connectorDesc.getMetadata.call(this, this.props, nextWidgetsState);
                        return {};
                    }
                },
                {
                    key: "transitionState",
                    value: function transitionState(prevWidgetsState, nextWidgetsState) {
                        if (typeof connectorDesc.transitionState === 'function') return connectorDesc.transitionState.call(this, this.props, prevWidgetsState, nextWidgetsState);
                        return nextWidgetsState;
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var _this$props = this.props, contextValue = _this$props.contextValue, props = $d7c20ea8341de50d$var$_objectWithoutProperties(_this$props, $d7c20ea8341de50d$var$_excluded);
                        var providedProps = this.state.providedProps;
                        if (providedProps === null) return null;
                        var refineProps = typeof connectorDesc.refine === 'function' ? {
                            refine: this.refine,
                            createURL: this.createURL
                        } : {};
                        var searchForFacetValuesProps = typeof connectorDesc.searchForFacetValues === 'function' ? {
                            searchForItems: this.searchForFacetValues
                        } : {};
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Composed, $d7c20ea8341de50d$var$_extends({}, props, providedProps, refineProps, searchForFacetValuesProps));
                    }
                }
            ]);
            return Connector;
        }((0, $acw62.Component));
        $d7c20ea8341de50d$var$_defineProperty(Connector, "displayName", "".concat(connectorDesc.displayName, "(").concat((0, $f89bd5ce2595ad4c$export$be63e0664592e141)(Composed), ")"));
        $d7c20ea8341de50d$var$_defineProperty(Connector, "$$type", connectorDesc.$$type);
        $d7c20ea8341de50d$var$_defineProperty(Connector, "$$widgetType", additionalWidgetProperties.$$widgetType);
        $d7c20ea8341de50d$var$_defineProperty(Connector, "propTypes", connectorDesc.propTypes);
        $d7c20ea8341de50d$var$_defineProperty(Connector, "defaultProps", connectorDesc.defaultProps);
        $d7c20ea8341de50d$var$_defineProperty(Connector, "_connectorDesc", connectorDesc);
        return Connector;
    };
}
var $d7c20ea8341de50d$var$createConnectorWithContext = function createConnectorWithContext(connectorDesc) {
    return function(Composed, additionalWidgetProperties) {
        var Connector = $d7c20ea8341de50d$export$1b8ac54304d7be60(connectorDesc)(Composed, additionalWidgetProperties);
        var ConnectorWrapper = function ConnectorWrapper(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47b0e931f98d53f4$export$d6a52d81667faed0), null, function(contextValue) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47b0e931f98d53f4$export$3f2d2afcc6b19a5e), null, function(indexContextValue) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Connector, $d7c20ea8341de50d$var$_extends({
                        contextValue: contextValue,
                        indexContextValue: indexContextValue
                    }, props));
                });
            });
        };
        return ConnectorWrapper;
    };
};
var $d7c20ea8341de50d$export$2e2bcd8739ae039 = $d7c20ea8341de50d$var$createConnectorWithContext;



function $b555487d9d656607$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b555487d9d656607$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b555487d9d656607$var$_typeof(obj);
}
function $b555487d9d656607$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b555487d9d656607$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b555487d9d656607$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b555487d9d656607$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b555487d9d656607$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b555487d9d656607$var$_defineProperty(obj, key, value) {
    key = $b555487d9d656607$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b555487d9d656607$var$_toPropertyKey(arg) {
    var key = $b555487d9d656607$var$_toPrimitive(arg, "string");
    return $b555487d9d656607$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b555487d9d656607$var$_toPrimitive(input, hint) {
    if ($b555487d9d656607$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b555487d9d656607$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b555487d9d656607$export$10baced437766f6d(context) {
    return $b555487d9d656607$export$e4d66c7d4e09a359(context) ? context.multiIndexContext.targetedIndex : context.ais.mainTargetedIndex;
}
function $b555487d9d656607$export$7e34e99eb2ee781b(searchResults, context) {
    if (searchResults.results) {
        if (searchResults.results.hits) return searchResults.results;
        var indexId = $b555487d9d656607$export$10baced437766f6d(context);
        if (searchResults.results[indexId]) return searchResults.results[indexId];
    }
    return null;
}
function $b555487d9d656607$export$e4d66c7d4e09a359(context) {
    return context && context.multiIndexContext;
}
function $b555487d9d656607$export$db9cc326d27ee2ef(searchState, nextRefinement, context, resetPage, namespace) {
    if ($b555487d9d656607$export$e4d66c7d4e09a359(context)) {
        var indexId = $b555487d9d656607$export$10baced437766f6d(context);
        return namespace ? $b555487d9d656607$var$refineMultiIndexWithNamespace(searchState, nextRefinement, indexId, resetPage, namespace) : $b555487d9d656607$var$refineMultiIndex(searchState, nextRefinement, indexId, resetPage);
    } else {
        // When we have a multi index page with shared widgets we should also
        // reset their page to 1 if the resetPage is provided. Otherwise the
        // indices will always be reset
        // see: https://github.com/algolia/react-instantsearch/issues/310
        // see: https://github.com/algolia/react-instantsearch/issues/637
        if (searchState.indices && resetPage) Object.keys(searchState.indices).forEach(function(targetedIndex) {
            searchState = $b555487d9d656607$export$db9cc326d27ee2ef(searchState, {
                page: 1
            }, {
                multiIndexContext: {
                    targetedIndex: targetedIndex
                }
            }, true, namespace);
        });
        return namespace ? $b555487d9d656607$var$refineSingleIndexWithNamespace(searchState, nextRefinement, resetPage, namespace) : $b555487d9d656607$var$refineSingleIndex(searchState, nextRefinement, resetPage);
    }
}
function $b555487d9d656607$var$refineMultiIndex(searchState, nextRefinement, indexId, resetPage) {
    var page = resetPage ? {
        page: 1
    } : undefined;
    var state = searchState.indices && searchState.indices[indexId] ? $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices), {}, $b555487d9d656607$var$_defineProperty({}, indexId, $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices[indexId]), nextRefinement), page))) : $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices), {}, $b555487d9d656607$var$_defineProperty({}, indexId, $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, nextRefinement), page)));
    return $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState), {}, {
        indices: state
    });
}
function $b555487d9d656607$var$refineSingleIndex(searchState, nextRefinement, resetPage) {
    var page = resetPage ? {
        page: 1
    } : undefined;
    return $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState), nextRefinement), page);
}
function $b555487d9d656607$var$refineMultiIndexWithNamespace(searchState, nextRefinement, indexId, resetPage, namespace) {
    var _objectSpread4;
    var page = resetPage ? {
        page: 1
    } : undefined;
    var state = searchState.indices && searchState.indices[indexId] ? $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices), {}, $b555487d9d656607$var$_defineProperty({}, indexId, $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices[indexId]), {}, (_objectSpread4 = {}, $b555487d9d656607$var$_defineProperty(_objectSpread4, namespace, $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices[indexId][namespace]), nextRefinement)), $b555487d9d656607$var$_defineProperty(_objectSpread4, "page", 1), _objectSpread4)))) : $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices), {}, $b555487d9d656607$var$_defineProperty({}, indexId, $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_defineProperty({}, namespace, nextRefinement), page)));
    return $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState), {}, {
        indices: state
    });
}
function $b555487d9d656607$var$refineSingleIndexWithNamespace(searchState, nextRefinement, resetPage, namespace) {
    var page = resetPage ? {
        page: 1
    } : undefined;
    return $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState), {}, $b555487d9d656607$var$_defineProperty({}, namespace, $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState[namespace]), nextRefinement)), page);
}
function $b555487d9d656607$var$getNamespaceAndAttributeName(id) {
    var parts = id.match(/^([^.]*)\.(.*)/);
    var namespace = parts && parts[1];
    var attributeName = parts && parts[2];
    return {
        namespace: namespace,
        attributeName: attributeName
    };
}
function $b555487d9d656607$var$hasRefinements(_ref) {
    var multiIndex = _ref.multiIndex, indexId = _ref.indexId, namespace = _ref.namespace, attributeName = _ref.attributeName, id = _ref.id, searchState = _ref.searchState;
    if (multiIndex && namespace) return searchState.indices && searchState.indices[indexId] && searchState.indices[indexId][namespace] && Object.hasOwnProperty.call(searchState.indices[indexId][namespace], attributeName);
    if (multiIndex) return searchState.indices && searchState.indices[indexId] && Object.hasOwnProperty.call(searchState.indices[indexId], id);
    if (namespace) return searchState[namespace] && Object.hasOwnProperty.call(searchState[namespace], attributeName);
    return Object.hasOwnProperty.call(searchState, id);
}
function $b555487d9d656607$var$getRefinements(_ref2) {
    var multiIndex = _ref2.multiIndex, indexId = _ref2.indexId, namespace = _ref2.namespace, attributeName = _ref2.attributeName, id = _ref2.id, searchState = _ref2.searchState;
    if (multiIndex && namespace) return searchState.indices[indexId][namespace][attributeName];
    if (multiIndex) return searchState.indices[indexId][id];
    if (namespace) return searchState[namespace][attributeName];
    return searchState[id];
}
function $b555487d9d656607$export$81243241d3b44d2(props, searchState, context, id, defaultValue) {
    var indexId = $b555487d9d656607$export$10baced437766f6d(context);
    var _getNamespaceAndAttri = $b555487d9d656607$var$getNamespaceAndAttributeName(id), namespace = _getNamespaceAndAttri.namespace, attributeName = _getNamespaceAndAttri.attributeName;
    var multiIndex = $b555487d9d656607$export$e4d66c7d4e09a359(context);
    var args = {
        multiIndex: multiIndex,
        indexId: indexId,
        namespace: namespace,
        attributeName: attributeName,
        id: id,
        searchState: searchState
    };
    var hasRefinementsValue = $b555487d9d656607$var$hasRefinements(args);
    if (hasRefinementsValue) return $b555487d9d656607$var$getRefinements(args);
    if (props.defaultRefinement) return props.defaultRefinement;
    return defaultValue;
}
function $b555487d9d656607$export$9350332ae92d76dc(searchState, context, id) {
    var indexId = $b555487d9d656607$export$10baced437766f6d(context);
    var _getNamespaceAndAttri2 = $b555487d9d656607$var$getNamespaceAndAttributeName(id), namespace = _getNamespaceAndAttri2.namespace, attributeName = _getNamespaceAndAttri2.attributeName;
    if ($b555487d9d656607$export$e4d66c7d4e09a359(context) && Boolean(searchState.indices)) return $b555487d9d656607$var$cleanUpValueWithMultiIndex({
        attribute: attributeName,
        searchState: searchState,
        indexId: indexId,
        id: id,
        namespace: namespace
    });
    return $b555487d9d656607$var$cleanUpValueWithSingleIndex({
        attribute: attributeName,
        searchState: searchState,
        id: id,
        namespace: namespace
    });
}
function $b555487d9d656607$var$cleanUpValueWithSingleIndex(_ref3) {
    var searchState = _ref3.searchState, id = _ref3.id, namespace = _ref3.namespace, attribute = _ref3.attribute;
    if (namespace) return $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState), {}, $b555487d9d656607$var$_defineProperty({}, namespace, (0, $f89bd5ce2595ad4c$export$30a06c8d3562193f)(searchState[namespace], [
        attribute
    ])));
    return (0, $f89bd5ce2595ad4c$export$30a06c8d3562193f)(searchState, [
        id
    ]);
}
function $b555487d9d656607$var$cleanUpValueWithMultiIndex(_ref4) {
    var searchState = _ref4.searchState, indexId = _ref4.indexId, id = _ref4.id, namespace = _ref4.namespace, attribute = _ref4.attribute;
    var indexSearchState = searchState.indices[indexId];
    if (namespace && indexSearchState) return $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState), {}, {
        indices: $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices), {}, $b555487d9d656607$var$_defineProperty({}, indexId, $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, indexSearchState), {}, $b555487d9d656607$var$_defineProperty({}, namespace, (0, $f89bd5ce2595ad4c$export$30a06c8d3562193f)(indexSearchState[namespace], [
            attribute
        ])))))
    });
    if (indexSearchState) return $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState), {}, {
        indices: $b555487d9d656607$var$_objectSpread($b555487d9d656607$var$_objectSpread({}, searchState.indices), {}, $b555487d9d656607$var$_defineProperty({}, indexId, (0, $f89bd5ce2595ad4c$export$30a06c8d3562193f)(indexSearchState, [
            id
        ])))
    });
    return searchState;
}



function $49bfc081a9e2abf8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $49bfc081a9e2abf8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $49bfc081a9e2abf8$var$_typeof(obj);
}
function $49bfc081a9e2abf8$var$_defineProperty(obj, key, value) {
    key = $49bfc081a9e2abf8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $49bfc081a9e2abf8$var$_toPropertyKey(arg) {
    var key = $49bfc081a9e2abf8$var$_toPrimitive(arg, "string");
    return $49bfc081a9e2abf8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $49bfc081a9e2abf8$var$_toPrimitive(input, hint) {
    if ($49bfc081a9e2abf8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($49bfc081a9e2abf8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $49bfc081a9e2abf8$var$namespace = 'menu';
function $49bfc081a9e2abf8$var$getId(props) {
    return props.attribute;
}
function $49bfc081a9e2abf8$var$getCurrentRefinement(props, searchState, context) {
    var currentRefinement = (0, $b555487d9d656607$export$81243241d3b44d2)(props, searchState, context, "".concat($49bfc081a9e2abf8$var$namespace, ".").concat($49bfc081a9e2abf8$var$getId(props)), null);
    if (currentRefinement === '') return null;
    return currentRefinement;
}
function $49bfc081a9e2abf8$var$getValue(value, props, searchState, context) {
    var currentRefinement = $49bfc081a9e2abf8$var$getCurrentRefinement(props, searchState, context);
    return value === currentRefinement ? '' : value;
}
function $49bfc081a9e2abf8$var$getLimit(_ref) {
    var showMore = _ref.showMore, limit = _ref.limit, showMoreLimit = _ref.showMoreLimit;
    return showMore ? showMoreLimit : limit;
}
function $49bfc081a9e2abf8$var$_refine(props, searchState, nextRefinement, context) {
    var id = $49bfc081a9e2abf8$var$getId(props);
    var nextValue = $49bfc081a9e2abf8$var$_defineProperty({}, id, nextRefinement ? nextRefinement : '');
    var resetPage = true;
    return (0, $b555487d9d656607$export$db9cc326d27ee2ef)(searchState, nextValue, context, resetPage, $49bfc081a9e2abf8$var$namespace);
}
function $49bfc081a9e2abf8$var$_cleanUp(props, searchState, context) {
    return (0, $b555487d9d656607$export$9350332ae92d76dc)(searchState, context, "".concat($49bfc081a9e2abf8$var$namespace, ".").concat($49bfc081a9e2abf8$var$getId(props)));
}
var $49bfc081a9e2abf8$var$defaultSortBy = [
    'count:desc',
    'name:asc'
];
var /**
 * connectMenu connector provides the logic to build a widget that will
 * give the user the ability to choose a single value for a specific facet.
 * @name connectMenu
 * @requirements The attribute passed to the `attribute` prop must be present in "attributes for faceting"
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 * @kind connector
 * @propType {string} attribute - the name of the attribute in the record
 * @propType {boolean} [showMore=false] - true if the component should display a button that will expand the number of items
 * @propType {number} [limit=10] - the minimum number of diplayed items
 * @propType {number} [showMoreLimit=20] - the maximun number of displayed items. Only used when showMore is set to `true`
 * @propType {string} [defaultRefinement] - the value of the item selected by default
 * @propType {boolean} [searchable=false] - allow search inside values
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{count: number, isRefined: boolean, label: string, value: string}>} items - the list of items the Menu can display.
 * @providedPropType {function} searchForItems - a function to toggle a search inside items values
 * @providedPropType {boolean} isFromSearch - a boolean that says if the `items` props contains facet values from the global search or from the search inside items.
 */ $49bfc081a9e2abf8$export$2e2bcd8739ae039 = (0, $d7c20ea8341de50d$export$2e2bcd8739ae039)({
    displayName: 'AlgoliaMenu',
    $$type: 'ais.menu',
    propTypes: {
        attribute: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        showMore: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        limit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        showMoreLimit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        defaultRefinement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        transformItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        searchable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        facetOrdering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    },
    defaultProps: {
        showMore: false,
        limit: 10,
        showMoreLimit: 20,
        facetOrdering: true
    },
    getProvidedProps: function getProvidedProps(props, searchState, searchResults, meta, searchForFacetValuesResults) {
        var attribute = props.attribute, searchable = props.searchable, indexContextValue = props.indexContextValue, facetOrdering = props.facetOrdering;
        var results = (0, $b555487d9d656607$export$7e34e99eb2ee781b)(searchResults, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var canRefine = Boolean(results) && Boolean(results.getFacetByName(attribute));
        var isFromSearch = Boolean(searchForFacetValuesResults && searchForFacetValuesResults[attribute] && searchForFacetValuesResults.query !== '');
        // Search For Facet Values is not available with derived helper (used for multi index search)
        if (searchable && indexContextValue) throw new Error("react-instantsearch: searching in *List is not available when used inside a multi index context");
        if (!canRefine) return {
            items: [],
            currentRefinement: $49bfc081a9e2abf8$var$getCurrentRefinement(props, searchState, {
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            isFromSearch: isFromSearch,
            searchable: searchable,
            canRefine: canRefine
        };
        var items;
        if (isFromSearch) items = searchForFacetValuesResults[attribute].map(function(v) {
            return {
                label: v.value,
                value: $49bfc081a9e2abf8$var$getValue(v.escapedValue, props, searchState, {
                    ais: props.contextValue,
                    multiIndexContext: props.indexContextValue
                }),
                _highlightResult: {
                    label: {
                        value: v.highlighted
                    }
                },
                count: v.count,
                isRefined: v.isRefined
            };
        });
        else items = results.getFacetValues(attribute, {
            sortBy: searchable ? undefined : $49bfc081a9e2abf8$var$defaultSortBy,
            facetOrdering: facetOrdering
        }).map(function(v) {
            return {
                label: v.name,
                value: $49bfc081a9e2abf8$var$getValue(v.escapedValue, props, searchState, {
                    ais: props.contextValue,
                    multiIndexContext: props.indexContextValue
                }),
                count: v.count,
                isRefined: v.isRefined
            };
        });
        var transformedItems = props.transformItems ? props.transformItems(items) : items;
        return {
            items: transformedItems.slice(0, $49bfc081a9e2abf8$var$getLimit(props)),
            currentRefinement: $49bfc081a9e2abf8$var$getCurrentRefinement(props, searchState, {
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            isFromSearch: isFromSearch,
            searchable: searchable,
            canRefine: transformedItems.length > 0
        };
    },
    refine: function refine(props, searchState, nextRefinement) {
        return $49bfc081a9e2abf8$var$_refine(props, searchState, nextRefinement, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    searchForFacetValues: function searchForFacetValues(props, searchState, nextRefinement) {
        return {
            facetName: props.attribute,
            query: nextRefinement,
            maxFacetHits: $49bfc081a9e2abf8$var$getLimit(props)
        };
    },
    cleanUp: function cleanUp(props, searchState) {
        return $49bfc081a9e2abf8$var$_cleanUp(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
        var attribute = props.attribute;
        searchParameters = searchParameters.setQueryParameters({
            maxValuesPerFacet: Math.max(searchParameters.maxValuesPerFacet || 0, $49bfc081a9e2abf8$var$getLimit(props))
        });
        searchParameters = searchParameters.addDisjunctiveFacet(attribute);
        var currentRefinement = $49bfc081a9e2abf8$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        if (currentRefinement !== null) searchParameters = searchParameters.addDisjunctiveFacetRefinement(attribute, currentRefinement);
        return searchParameters;
    },
    getMetadata: function getMetadata(props, searchState) {
        var id = $49bfc081a9e2abf8$var$getId(props);
        var currentRefinement = $49bfc081a9e2abf8$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        return {
            id: id,
            index: (0, $b555487d9d656607$export$10baced437766f6d)({
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            items: currentRefinement === null ? [] : [
                {
                    label: "".concat(props.attribute, ": ").concat((0, $f89bd5ce2595ad4c$export$ad628980c7383a99)(currentRefinement)),
                    attribute: props.attribute,
                    value: function value(nextState) {
                        return $49bfc081a9e2abf8$var$_refine(props, nextState, '', {
                            ais: props.contextValue,
                            multiIndexContext: props.indexContextValue
                        });
                    },
                    currentRefinement: currentRefinement
                }
            ]
        };
    }
});



var /**
 * connectStats connector provides the logic to build a widget that will
 *  displays algolia search statistics (hits number and processing time).
 * @name connectStats
 * @kind connector
 * @providedPropType {number} nbHits - number of hits returned by Algolia.
 * @providedPropType {number} nbSortedHits - number of sorted hits returned by Algolia.
 * @providedPropType {number} processingTimeMS - the time in ms took by Algolia to search for results.
 */ $3ef4e1c949eea652$export$2e2bcd8739ae039 = (0, $d7c20ea8341de50d$export$2e2bcd8739ae039)({
    displayName: 'AlgoliaStats',
    $$type: 'ais.stats',
    getProvidedProps: function getProvidedProps(props, _searchState, searchResults) {
        var results = (0, $b555487d9d656607$export$7e34e99eb2ee781b)(searchResults, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        if (!results) return null;
        return {
            areHitsSorted: results.appliedRelevancyStrictness !== undefined && results.appliedRelevancyStrictness > 0 && results.nbHits !== results.nbSortedHits,
            nbHits: results.nbHits,
            nbSortedHits: results.nbSortedHits,
            processingTimeMS: results.processingTimeMS
        };
    }
});


var $c9Z8w = parcelRequire("c9Z8w");


function $834168bbfb34ae49$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $834168bbfb34ae49$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $834168bbfb34ae49$var$_typeof(obj);
}
function $834168bbfb34ae49$var$_defineProperty(obj, key, value) {
    key = $834168bbfb34ae49$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $834168bbfb34ae49$var$_toPropertyKey(arg) {
    var key = $834168bbfb34ae49$var$_toPrimitive(arg, "string");
    return $834168bbfb34ae49$var$_typeof(key) === "symbol" ? key : String(key);
}
function $834168bbfb34ae49$var$_toPrimitive(input, hint) {
    if ($834168bbfb34ae49$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($834168bbfb34ae49$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $834168bbfb34ae49$var$getId() {
    return 'query';
}
function $834168bbfb34ae49$var$getCurrentRefinement(props, searchState, context) {
    var id = $834168bbfb34ae49$var$getId(props);
    var currentRefinement = (0, $b555487d9d656607$export$81243241d3b44d2)(props, searchState, context, id, '');
    if (currentRefinement) return currentRefinement;
    return '';
}
function $834168bbfb34ae49$var$_refine(props, searchState, nextRefinement, context) {
    var id = $834168bbfb34ae49$var$getId();
    var nextValue = $834168bbfb34ae49$var$_defineProperty({}, id, nextRefinement);
    var resetPage = true;
    return (0, $b555487d9d656607$export$db9cc326d27ee2ef)(searchState, nextValue, context, resetPage);
}
function $834168bbfb34ae49$var$_cleanUp(props, searchState, context) {
    return (0, $b555487d9d656607$export$9350332ae92d76dc)(searchState, context, $834168bbfb34ae49$var$getId());
}
var /**
 * connectSearchBox connector provides the logic to build a widget that will
 * let the user search for a query
 * @name connectSearchBox
 * @kind connector
 * @propType {string} [defaultRefinement] - Provide a default value for the query
 * @providedPropType {function} refine - a function to change the current query
 * @providedPropType {string} currentRefinement - the current query used
 * @providedPropType {boolean} isSearchStalled - a flag that indicates if InstantSearch has detected that searches are stalled
 */ $834168bbfb34ae49$export$2e2bcd8739ae039 = (0, $d7c20ea8341de50d$export$2e2bcd8739ae039)({
    displayName: 'AlgoliaSearchBox',
    $$type: 'ais.searchBox',
    propTypes: {
        defaultRefinement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    },
    getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
        return {
            currentRefinement: $834168bbfb34ae49$var$getCurrentRefinement(props, searchState, {
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            isSearchStalled: searchResults.isSearchStalled
        };
    },
    refine: function refine(props, searchState, nextRefinement) {
        return $834168bbfb34ae49$var$_refine(props, searchState, nextRefinement, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    cleanUp: function cleanUp(props, searchState) {
        return $834168bbfb34ae49$var$_cleanUp(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
        return searchParameters.setQuery($834168bbfb34ae49$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        }));
    },
    getMetadata: function getMetadata(props, searchState) {
        var id = $834168bbfb34ae49$var$getId(props);
        var currentRefinement = $834168bbfb34ae49$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        return {
            id: id,
            index: (0, $b555487d9d656607$export$10baced437766f6d)({
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            items: currentRefinement === null ? [] : [
                {
                    label: "".concat(id, ": ").concat(currentRefinement),
                    value: function value(nextState) {
                        return $834168bbfb34ae49$var$_refine(props, nextState, '', {
                            ais: props.contextValue,
                            multiIndexContext: props.indexContextValue
                        });
                    },
                    currentRefinement: currentRefinement
                }
            ]
        };
    }
});


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $951a0c5c58e57605$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $951a0c5c58e57605$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $951a0c5c58e57605$var$_typeof(obj);
}
function $951a0c5c58e57605$var$_extends() {
    $951a0c5c58e57605$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $951a0c5c58e57605$var$_extends.apply(this, arguments);
}
function $951a0c5c58e57605$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $951a0c5c58e57605$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $951a0c5c58e57605$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $951a0c5c58e57605$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $951a0c5c58e57605$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $951a0c5c58e57605$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $951a0c5c58e57605$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $951a0c5c58e57605$var$_setPrototypeOf(subClass, superClass);
}
function $951a0c5c58e57605$var$_setPrototypeOf(o, p) {
    $951a0c5c58e57605$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $951a0c5c58e57605$var$_setPrototypeOf(o, p);
}
function $951a0c5c58e57605$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $951a0c5c58e57605$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $951a0c5c58e57605$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $951a0c5c58e57605$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $951a0c5c58e57605$var$_possibleConstructorReturn(this, result);
    };
}
function $951a0c5c58e57605$var$_possibleConstructorReturn(self, call) {
    if (call && ($951a0c5c58e57605$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $951a0c5c58e57605$var$_assertThisInitialized(self);
}
function $951a0c5c58e57605$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $951a0c5c58e57605$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $951a0c5c58e57605$var$_getPrototypeOf(o) {
    $951a0c5c58e57605$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $951a0c5c58e57605$var$_getPrototypeOf(o);
}
function $951a0c5c58e57605$var$_defineProperty(obj, key, value) {
    key = $951a0c5c58e57605$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $951a0c5c58e57605$var$_toPropertyKey(arg) {
    var key = $951a0c5c58e57605$var$_toPrimitive(arg, "string");
    return $951a0c5c58e57605$var$_typeof(key) === "symbol" ? key : String(key);
}
function $951a0c5c58e57605$var$_toPrimitive(input, hint) {
    if ($951a0c5c58e57605$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($951a0c5c58e57605$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $951a0c5c58e57605$var$withKeysPropType = function withKeysPropType(keys) {
    return function(props, propName, componentName) {
        var prop = props[propName];
        if (prop) // eslint-disable-next-line no-restricted-syntax
        for(var _i = 0, _Object$keys = Object.keys(prop); _i < _Object$keys.length; _i++){
            var key = _Object$keys[_i];
            if (keys.indexOf(key) === -1) return new Error("Unknown `".concat(propName, "` key `").concat(key, "`. Check the render method ") + "of `".concat(componentName, "`."));
        }
        return undefined;
    };
};
function $951a0c5c58e57605$export$2e2bcd8739ae039(defaultTranslations) {
    return function(Composed) {
        var Translatable = /*#__PURE__*/ function(_Component) {
            $951a0c5c58e57605$var$_inherits(Translatable, _Component);
            var _super = $951a0c5c58e57605$var$_createSuper(Translatable);
            function Translatable() {
                var _this;
                $951a0c5c58e57605$var$_classCallCheck(this, Translatable);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _super.call.apply(_super, [
                    this
                ].concat(args));
                $951a0c5c58e57605$var$_defineProperty($951a0c5c58e57605$var$_assertThisInitialized(_this), "translate", function(key) {
                    var translations = _this.props.translations;
                    var translation = translations && translations.hasOwnProperty(key) ? translations[key] : defaultTranslations[key];
                    if (typeof translation === 'function') {
                        for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                        return translation.apply(void 0, params);
                    }
                    return translation;
                });
                return _this;
            }
            $951a0c5c58e57605$var$_createClass(Translatable, [
                {
                    key: "render",
                    value: function render() {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Composed, $951a0c5c58e57605$var$_extends({
                            translate: this.translate
                        }, this.props));
                    }
                }
            ]);
            return Translatable;
        }((0, $acw62.Component));
        var name = Composed.displayName || Composed.name || 'UnknownComponent';
        Translatable.displayName = "Translatable(".concat(name, ")");
        Translatable.propTypes = {
            translations: $951a0c5c58e57605$var$withKeysPropType(Object.keys(defaultTranslations))
        };
        return Translatable;
    };
}



function $ae4a5bb540cf85e9$var$_toConsumableArray(arr) {
    return $ae4a5bb540cf85e9$var$_arrayWithoutHoles(arr) || $ae4a5bb540cf85e9$var$_iterableToArray(arr) || $ae4a5bb540cf85e9$var$_unsupportedIterableToArray(arr) || $ae4a5bb540cf85e9$var$_nonIterableSpread();
}
function $ae4a5bb540cf85e9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ae4a5bb540cf85e9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ae4a5bb540cf85e9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ae4a5bb540cf85e9$var$_arrayLikeToArray(o, minLen);
}
function $ae4a5bb540cf85e9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ae4a5bb540cf85e9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ae4a5bb540cf85e9$var$_arrayLikeToArray(arr);
}
function $ae4a5bb540cf85e9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ae4a5bb540cf85e9$export$1b8f751d16a9aaf7 = function createClassNames(block) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ais';
    return function() {
        for(var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++)elements[_key] = arguments[_key];
        var suitElements = elements.filter(function(element) {
            return element || element === '';
        }).map(function(element) {
            var baseClassName = "".concat(prefix, "-").concat(block);
            return element ? "".concat(baseClassName, "-").concat(element) : baseClassName;
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(suitElements);
    };
};
var $ae4a5bb540cf85e9$export$5b1771037ab7c451 = function isSpecialClick(event) {
    var isMiddleClick = event.button === 1;
    return Boolean(isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
};
var $ae4a5bb540cf85e9$export$9a00dee1beb8f576 = function capitalize(key) {
    return key.length === 0 ? '' : "".concat(key[0].toUpperCase()).concat(key.slice(1));
};
function $ae4a5bb540cf85e9$export$d02631cccf789723(_ref) {
    var _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref.end, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step;
    // We can't divide by 0 so we re-assign the step to 1 if it happens.
    var limitStep = step === 0 ? 1 : step;
    // In some cases the array to create has a decimal length.
    // We therefore need to round the value.
    // Example:
    //   { start: 1, end: 5000, step: 500 }
    //   => Array length = (5000 - 1) / 500 = 9.998
    var arrayLength = Math.round((end - start) / limitStep);
    return $ae4a5bb540cf85e9$var$_toConsumableArray(Array(arrayLength)).map(function(_, current) {
        return (start + current) * limitStep;
    });
}
function $ae4a5bb540cf85e9$export$71aa6c912b956294(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
}


function $d6da8a1c3a680c18$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d6da8a1c3a680c18$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d6da8a1c3a680c18$var$_typeof(obj);
}
function $d6da8a1c3a680c18$var$_extends() {
    $d6da8a1c3a680c18$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d6da8a1c3a680c18$var$_extends.apply(this, arguments);
}
function $d6da8a1c3a680c18$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d6da8a1c3a680c18$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d6da8a1c3a680c18$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d6da8a1c3a680c18$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d6da8a1c3a680c18$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d6da8a1c3a680c18$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d6da8a1c3a680c18$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d6da8a1c3a680c18$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d6da8a1c3a680c18$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d6da8a1c3a680c18$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d6da8a1c3a680c18$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d6da8a1c3a680c18$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d6da8a1c3a680c18$var$_setPrototypeOf(subClass, superClass);
}
function $d6da8a1c3a680c18$var$_setPrototypeOf(o, p) {
    $d6da8a1c3a680c18$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d6da8a1c3a680c18$var$_setPrototypeOf(o, p);
}
function $d6da8a1c3a680c18$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d6da8a1c3a680c18$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d6da8a1c3a680c18$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d6da8a1c3a680c18$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d6da8a1c3a680c18$var$_possibleConstructorReturn(this, result);
    };
}
function $d6da8a1c3a680c18$var$_possibleConstructorReturn(self, call) {
    if (call && ($d6da8a1c3a680c18$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d6da8a1c3a680c18$var$_assertThisInitialized(self);
}
function $d6da8a1c3a680c18$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d6da8a1c3a680c18$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d6da8a1c3a680c18$var$_getPrototypeOf(o) {
    $d6da8a1c3a680c18$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d6da8a1c3a680c18$var$_getPrototypeOf(o);
}
function $d6da8a1c3a680c18$var$_defineProperty(obj, key, value) {
    key = $d6da8a1c3a680c18$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d6da8a1c3a680c18$var$_toPropertyKey(arg) {
    var key = $d6da8a1c3a680c18$var$_toPrimitive(arg, "string");
    return $d6da8a1c3a680c18$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d6da8a1c3a680c18$var$_toPrimitive(input, hint) {
    if ($d6da8a1c3a680c18$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d6da8a1c3a680c18$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d6da8a1c3a680c18$var$cx = (0, $ae4a5bb540cf85e9$export$1b8f751d16a9aaf7)('SearchBox');
var $d6da8a1c3a680c18$var$defaultLoadingIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#444",
    className: $d6da8a1c3a680c18$var$cx('loadingIcon'),
    "aria-hidden": "true"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    fill: "none",
    fillRule: "evenodd"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
})))));
var $d6da8a1c3a680c18$var$defaultReset = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: $d6da8a1c3a680c18$var$cx('resetIcon'),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "10",
    height: "10",
    "aria-hidden": "true"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
}));
var $d6da8a1c3a680c18$var$defaultSubmit = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: $d6da8a1c3a680c18$var$cx('submitIcon'),
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 40 40",
    "aria-hidden": "true"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
}));
var $d6da8a1c3a680c18$var$SearchBox = /*#__PURE__*/ function(_Component) {
    $d6da8a1c3a680c18$var$_inherits(SearchBox, _Component);
    var _super = $d6da8a1c3a680c18$var$_createSuper(SearchBox);
    function SearchBox(props) {
        var _this;
        $d6da8a1c3a680c18$var$_classCallCheck(this, SearchBox);
        _this = _super.call(this);
        $d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$_assertThisInitialized(_this), "getQuery", function() {
            return _this.props.searchAsYouType ? _this.props.currentRefinement : _this.state.query;
        });
        $d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$_assertThisInitialized(_this), "onInputMount", function(input) {
            _this.input = input;
            if (!_this.props.inputRef) return;
            if (typeof _this.props.inputRef === 'function') _this.props.inputRef(input);
            else _this.props.inputRef.current = input;
        });
        $d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$_assertThisInitialized(_this), "onKeyDown", function(e) {
            if (!_this.props.focusShortcuts) return;
            var shortcuts = _this.props.focusShortcuts.map(function(key) {
                return typeof key === 'string' ? key.toUpperCase().charCodeAt(0) : key;
            });
            var elt = e.target || e.srcElement;
            var tagName = elt.tagName;
            if (elt.isContentEditable || tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA') // already in an input
            return;
            var which = e.which || e.keyCode;
            if (shortcuts.indexOf(which) === -1) // not the right shortcut
            return;
            _this.input.focus();
            e.stopPropagation();
            e.preventDefault();
        });
        $d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$_assertThisInitialized(_this), "onSubmit", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.input.blur();
            var _this$props = _this.props, refine = _this$props.refine, searchAsYouType = _this$props.searchAsYouType;
            if (!searchAsYouType) refine(_this.getQuery());
            return false;
        });
        $d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$_assertThisInitialized(_this), "onChange", function(event) {
            var _this$props2 = _this.props, searchAsYouType = _this$props2.searchAsYouType, refine = _this$props2.refine, onChange = _this$props2.onChange;
            var value = event.target.value;
            if (searchAsYouType) refine(value);
            else _this.setState({
                query: value
            });
            if (onChange) onChange(event);
        });
        $d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$_assertThisInitialized(_this), "onReset", function(event) {
            var _this$props3 = _this.props, searchAsYouType = _this$props3.searchAsYouType, refine = _this$props3.refine, onReset = _this$props3.onReset;
            refine('');
            _this.input.focus();
            if (!searchAsYouType) _this.setState({
                query: ''
            });
            if (onReset) onReset(event);
        });
        _this.state = {
            query: props.searchAsYouType ? null : props.currentRefinement
        };
        return _this;
    }
    $d6da8a1c3a680c18$var$_createClass(SearchBox, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.onKeyDown);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.onKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!this.props.searchAsYouType && prevProps.currentRefinement !== this.props.currentRefinement) this.setState({
                    query: this.props.currentRefinement
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, className = _this$props4.className, inputId = _this$props4.inputId, translate = _this$props4.translate, autoFocus = _this$props4.autoFocus, loadingIndicator = _this$props4.loadingIndicator, submit = _this$props4.submit, reset = _this$props4.reset;
                var query = this.getQuery();
                var searchInputEvents = Object.keys(this.props).reduce(function(props, prop) {
                    if ([
                        'onsubmit',
                        'onreset',
                        'onchange'
                    ].indexOf(prop.toLowerCase()) === -1 && prop.indexOf('on') === 0) return $d6da8a1c3a680c18$var$_objectSpread($d6da8a1c3a680c18$var$_objectSpread({}, props), {}, $d6da8a1c3a680c18$var$_defineProperty({}, prop, _this2.props[prop]));
                    return props;
                }, {});
                var isSearchStalled = this.props.showLoadingIndicator && this.props.isSearchStalled;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($d6da8a1c3a680c18$var$cx(''), className)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
                    ref: this.props.formRef,
                    noValidate: true,
                    onSubmit: this.props.onSubmit ? this.props.onSubmit : this.onSubmit,
                    onReset: this.onReset,
                    className: $d6da8a1c3a680c18$var$cx('form', isSearchStalled && 'form--stalledSearch'),
                    action: "",
                    role: "search"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $d6da8a1c3a680c18$var$_extends({
                    ref: this.onInputMount,
                    id: inputId,
                    type: "search",
                    placeholder: translate('placeholder'),
                    autoFocus: autoFocus,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false",
                    required: true,
                    maxLength: "512",
                    value: query,
                    onChange: this.onChange
                }, searchInputEvents, {
                    className: $d6da8a1c3a680c18$var$cx('input')
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                    type: "submit",
                    title: translate('submitTitle'),
                    className: $d6da8a1c3a680c18$var$cx('submit')
                }, submit), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                    type: "reset",
                    title: translate('resetTitle'),
                    className: $d6da8a1c3a680c18$var$cx('reset'),
                    hidden: !query || isSearchStalled
                }, reset), this.props.showLoadingIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    hidden: !isSearchStalled,
                    className: $d6da8a1c3a680c18$var$cx('loadingIndicator')
                }, loadingIndicator)));
            }
        }
    ]);
    return SearchBox;
}((0, $acw62.Component));
$d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$SearchBox, "propTypes", {
    currentRefinement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    refine: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    translate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    loadingIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    reset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    submit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    focusShortcuts: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ])),
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    searchAsYouType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onReset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isSearchStalled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showLoadingIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).exact({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        })
    ]),
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).exact({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        })
    ]),
    inputId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
});
$d6da8a1c3a680c18$var$_defineProperty($d6da8a1c3a680c18$var$SearchBox, "defaultProps", {
    currentRefinement: '',
    className: '',
    focusShortcuts: [
        's',
        '/'
    ],
    autoFocus: false,
    searchAsYouType: true,
    showLoadingIndicator: false,
    isSearchStalled: false,
    loadingIndicator: $d6da8a1c3a680c18$var$defaultLoadingIndicator,
    reset: $d6da8a1c3a680c18$var$defaultReset,
    submit: $d6da8a1c3a680c18$var$defaultSubmit
});
var $d6da8a1c3a680c18$export$2e2bcd8739ae039 = (0, $951a0c5c58e57605$export$2e2bcd8739ae039)({
    resetTitle: 'Clear the search query.',
    submitTitle: 'Submit your search query.',
    placeholder: "Search here\u2026"
})($d6da8a1c3a680c18$var$SearchBox);


var /**
 * The SearchBox component displays a search box that lets the user search for a specific query.
 * @name SearchBox
 * @kind widget
 * @propType {string[]} [focusShortcuts=['s','/']] - List of keyboard shortcuts that focus the search box. Accepts key names and key codes.
 * @propType {boolean} [autoFocus=false] - Should the search box be focused on render?
 * @propType {boolean} [searchAsYouType=true] - Should we search on every change to the query? If you disable this option, new searches will only be triggered by clicking the search button or by pressing the enter key while the search box is focused.
 * @propType {function} [onSubmit] - Intercept submit event sent from the SearchBox form container.
 * @propType {function} [onReset] - Listen to `reset` event sent from the SearchBox form container.
 * @propType {function} [on*] - Listen to any events sent from the search input itself.
 * @propType {node} [submit] - Change the apparence of the default submit button (magnifying glass).
 * @propType {node} [reset] - Change the apparence of the default reset button (cross).
 * @propType {node} [loadingIndicator] - Change the apparence of the default loading indicator (spinning circle).
 * @propType {string} [defaultRefinement] - Provide default refinement value when component is mounted.
 * @propType {string} [inputId] - The id of the search input
 * @propType {boolean} [showLoadingIndicator=false] - Display that the search is loading. This only happens after a certain amount of time to avoid a blinking effect. This timer can be configured with `stalledSearchDelay` props on <InstantSearch>. By default, the value is 200ms.
 * @themeKey ais-SearchBox - the root div of the widget
 * @themeKey ais-SearchBox-form - the wrapping form
 * @themeKey ais-SearchBox-input - the search input
 * @themeKey ais-SearchBox-submit - the submit button
 * @themeKey ais-SearchBox-submitIcon - the default magnifier icon used with the search input
 * @themeKey ais-SearchBox-reset - the reset button used to clear the content of the input
 * @themeKey ais-SearchBox-resetIcon - the default reset icon used inside the reset button
 * @themeKey ais-SearchBox-loadingIndicator - the loading indicator container
 * @themeKey ais-SearchBox-loadingIcon - the default loading icon
 * @translationkey submitTitle - The submit button title
 * @translationkey resetTitle - The reset button title
 * @translationkey placeholder - The label of the input placeholder
 * @example
 * import React from 'react';
 * import algoliasearch from 'algoliasearch/lite';
 * import { InstantSearch, SearchBox } from 'react-instantsearch-dom';
 *
 * const searchClient = algoliasearch(
 *   'latency',
 *   '6be0576ff61c053d5f9a3225e2a90f76'
 * );
 *
 * const App = () => (
 *   <InstantSearch
 *     searchClient={searchClient}
 *     indexName="instant_search"
 *   >
 *     <SearchBox />
 *   </InstantSearch>
 * );
 */ $d7b8d8edd9d0da1e$export$2e2bcd8739ae039 = (0, $834168bbfb34ae49$export$2e2bcd8739ae039)((0, $d6da8a1c3a680c18$export$2e2bcd8739ae039), {
    $$widgetType: 'ais.searchBox'
});


function $eb9cbc363cee6449$var$getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
const $eb9cbc363cee6449$var$Stats = ({ nbHits: nbHits })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            "Showing ",
            nbHits,
            " Data Point",
            nbHits > 1 ? 's' : ''
        ]
    });
const $eb9cbc363cee6449$var$CustomStats = (0, $3ef4e1c949eea652$export$2e2bcd8739ae039)($eb9cbc363cee6449$var$Stats);
const $eb9cbc363cee6449$var$MenuSelect = ({ items: items, currentRefinement: currentRefinement, refine: refine, emptyText: emptyText })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
        value: currentRefinement || '',
        onChange: (event)=>refine(event.currentTarget.value),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: "",
                children: emptyText
            }),
            items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                    value: item.isRefined ? currentRefinement : item.value,
                    children: item.label
                }, item.label))
        ]
    });
const $eb9cbc363cee6449$var$CustomMenuSelect = (0, $49bfc081a9e2abf8$export$2e2bcd8739ae039)($eb9cbc363cee6449$var$MenuSelect);
const $eb9cbc363cee6449$export$ec91da630f36d5ea = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "filters bg-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: " py-4 px-10 mx-auto",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: 'select w-[240px]',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eb9cbc363cee6449$var$CustomMenuSelect, {
                                limit: 100,
                                emptyText: 'All Capabilities',
                                defaultRefinement: $eb9cbc363cee6449$var$getParameterByName('capability'),
                                attribute: "related_capabilities.title"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "hidden text-gray-600 text-sm mt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eb9cbc363cee6449$var$CustomStats, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                style: {
                                    pointerEvents: 'none'
                                },
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M2.19526 5.52827C2.45561 5.26792 2.87772 5.26792 3.13807 5.52827L8 10.3902L12.8619 5.52827C13.1223 5.26792 13.5444 5.26792 13.8047 5.52827C14.0651 5.78862 14.0651 6.21073 13.8047 6.47108L8.4714 11.8044C8.21106 12.0648 7.78895 12.0648 7.5286 11.8044L2.19526 6.47108C1.93491 6.21073 1.93491 5.78862 2.19526 5.52827Z",
                                    fill: "black",
                                    "fill-opacity": "0.92"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: 'select w-[240px]',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eb9cbc363cee6449$var$CustomMenuSelect, {
                                emptyText: 'All Years',
                                attribute: "years"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                style: {
                                    pointerEvents: 'none'
                                },
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M2.19526 5.52827C2.45561 5.26792 2.87772 5.26792 3.13807 5.52827L8 10.3902L12.8619 5.52827C13.1223 5.26792 13.5444 5.26792 13.8047 5.52827C14.0651 5.78862 14.0651 6.21073 13.8047 6.47108L8.4714 11.8044C8.21106 12.0648 7.78895 12.0648 7.5286 11.8044L2.19526 6.47108C1.93491 6.21073 1.93491 5.78862 2.19526 5.52827Z",
                                    fill: "black",
                                    "fill-opacity": "0.92"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: 'w-[240px] search',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7b8d8edd9d0da1e$export$2e2bcd8739ae039), {
                                className: 'w-full'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                style: {
                                    pointerEvents: 'none'
                                },
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M12.2191 12.4956C11.0698 13.4361 9.60076 14.0003 7.99992 14.0003C4.31802 14.0003 1.33325 11.0156 1.33325 7.33366C1.33325 3.65176 4.31802 0.666992 7.99992 0.666992C11.6818 0.666992 14.6666 3.65176 14.6666 7.33366C14.6666 8.93452 14.1023 10.4036 13.1619 11.5528L15.138 13.529C15.3983 13.7893 15.3983 14.2114 15.138 14.4718C14.8777 14.7321 14.4555 14.7321 14.1952 14.4718L12.2191 12.4956ZM13.3333 7.33366C13.3333 10.2792 10.9454 12.667 7.99992 12.667C5.0544 12.667 2.66659 10.2792 2.66659 7.33366C2.66659 4.38814 5.0544 2.00033 7.99992 2.00033C10.9454 2.00033 13.3333 4.38814 13.3333 7.33366Z",
                                    fill: "black",
                                    "fill-opacity": "0.92"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


var $53d2806546eb2c71$exports = {};
$53d2806546eb2c71$exports = new URL("Fix top left.28e39702.svg", import.meta.url).toString();


var $05ea811ff2142c36$exports = {};
$05ea811ff2142c36$exports = new URL("Fix Bottom right.635459ac.svg", import.meta.url).toString();





var /**
 * connectHits connector provides the logic to create connected
 * components that will render the results retrieved from
 * Algolia.
 *
 * To configure the number of hits retrieved, use [HitsPerPage widget](widgets/HitsPerPage.html),
 * [connectHitsPerPage connector](connectors/connectHitsPerPage.html) or pass the hitsPerPage
 * prop to a [Configure](guide/Search_parameters.html) widget.
 *
 * **Warning:** you will need to use the **objectID** property available on every hit as a key
 * when iterating over them. This will ensure you have the best possible UI experience
 * especially on slow networks.
 * @name connectHits
 * @kind connector
 * @providedPropType {array.<object>} hits - the records that matched the search state
 * @example
 * import React from 'react';
 * import algoliasearch from 'algoliasearch/lite';
 * import { InstantSearch, Highlight, connectHits } from 'react-instantsearch-dom';
 *
 * const searchClient = algoliasearch(
 *   'latency',
 *   '6be0576ff61c053d5f9a3225e2a90f76'
 * );
 * const CustomHits = connectHits(({ hits }) => (
 *   <div>
 *     {hits.map(hit =>
 *       <p key={hit.objectID}>
 *         <Highlight attribute="name" hit={hit} />
 *       </p>
 *     )}
 *   </div>
 * ));
 *
 * const App = () => (
 *   <InstantSearch
 *     searchClient={searchClient}
 *     indexName="instant_search"
 *   >
 *     <CustomHits />
 *   </InstantSearch>
 * );
 */ $254a1c4d94eeb07d$export$2e2bcd8739ae039 = (0, $d7c20ea8341de50d$export$2e2bcd8739ae039)({
    displayName: 'AlgoliaHits',
    $$type: 'ais.hits',
    getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
        var results = (0, $b555487d9d656607$export$7e34e99eb2ee781b)(searchResults, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        if (!results) return {
            hits: []
        };
        var hitsWithPositions = (0, $f89bd5ce2595ad4c$export$d6716b2aedb78d9e)(results.hits, results.hitsPerPage, results.page);
        var hitsWithPositionsAndQueryID = (0, $f89bd5ce2595ad4c$export$b8f834386ea30952)(hitsWithPositions, results.queryID);
        return {
            hits: hitsWithPositionsAndQueryID
        };
    },
    /*
   * Hits needs to be considered as a widget to trigger a search,
   * even if no other widgets are used.
   *
   * To be considered as a widget you need either:
   * - getSearchParameters
   * - getMetadata
   * - transitionState
   *
   * See: createConnector.tsx
   */ getSearchParameters: function getSearchParameters(searchParameters) {
        return searchParameters;
    }
});


const $efff4cf968573785$var$Hits = ({ hits: hits })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: 'grid relative grid-cols-1 lg:grid-cols-2 gap-9',
        children: hits.map((hit)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $158450ec41bac1dc$export$60332b2344f7fe41), {
                hit: hit
            }, hit.ObjectID))
    });
const $efff4cf968573785$var$CustomHits = (0, $254a1c4d94eeb07d$export$2e2bcd8739ae039)($efff4cf968573785$var$Hits);
function $efff4cf968573785$export$cf5e27b88d55fab4() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($046f159811fdd774$exports))), {
                smoothScroll: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    className: "relative left-[calc(50%-11rem)] -z-10 h-[21.1875rem] max-w-none -translate-x-1/2 rotate-[30deg] sm:left-[calc(50%-30rem)] sm:h-[42.375rem]",
                    viewBox: "0 0 1155 678",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            fill: "url(#45de2b6b-92d5-4d68-a6a0-9b9b2abad533)",
                            fillOpacity: ".3",
                            d: "M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                id: "45de2b6b-92d5-4d68-a6a0-9b9b2abad533",
                                x1: "1155.49",
                                x2: "-78.208",
                                y1: ".177",
                                y2: "474.645",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        "stop-color": "#9089FC"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        offset: "1",
                                        "stop-color": "#FF80B5"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "home-hero hidden lg:block",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inner lg:flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "State Of FinOps"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "max-w-[730px] text-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/",
                                className: "inline-flex justify-center mt-12 py-2 text-green-900 px-5 lg:text-lg font-medium rounded border border-green-500 bg-green-500 hover:bg-green-300 hover:border-green-300 font-normal",
                                children: "View the 2025 Report"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                className: 'w-full lg:hidden',
                viewBox: "0 0 320 216",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        clipPath: "url(#clip0_5592_7363)",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                width: "320",
                                height: "216",
                                fill: "#00281D"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                width: "320",
                                height: "216",
                                fill: "url(#paint0_linear_5592_7363)",
                                fillOpacity: "0.3"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                width: "203",
                                height: "71",
                                transform: "translate(58.5 48)",
                                fill: "#004F3B"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M90.852 102.576C87.972 102.576 85.524 102.064 83.508 101.04C81.524 100.016 79.812 98.672 78.372 97.008L82.644 92.88C83.796 94.224 85.076 95.248 86.484 95.952C87.924 96.656 89.508 97.008 91.236 97.008C93.188 97.008 94.66 96.592 95.652 95.76C96.644 94.896 97.14 93.744 97.14 92.304C97.14 91.184 96.82 90.272 96.18 89.568C95.54 88.864 94.34 88.352 92.58 88.032L89.412 87.552C82.724 86.496 79.38 83.248 79.38 77.808C79.38 76.304 79.652 74.944 80.196 73.728C80.772 72.512 81.588 71.472 82.644 70.608C83.7 69.744 84.964 69.088 86.436 68.64C87.94 68.16 89.636 67.92 91.524 67.92C94.052 67.92 96.26 68.336 98.148 69.168C100.036 70 101.652 71.232 102.996 72.864L98.676 76.944C97.844 75.92 96.836 75.088 95.652 74.448C94.468 73.808 92.98 73.488 91.188 73.488C89.364 73.488 87.988 73.84 87.06 74.544C86.164 75.216 85.716 76.176 85.716 77.424C85.716 78.704 86.084 79.648 86.82 80.256C87.556 80.864 88.74 81.312 90.372 81.6L93.492 82.176C96.884 82.784 99.38 83.872 100.98 85.44C102.612 86.976 103.428 89.136 103.428 91.92C103.428 93.52 103.14 94.976 102.564 96.288C102.02 97.568 101.204 98.688 100.116 99.648C99.06 100.576 97.748 101.296 96.18 101.808C94.644 102.32 92.868 102.576 90.852 102.576ZM115.032 102C112.92 102 111.304 101.456 110.184 100.368C109.096 99.248 108.552 97.664 108.552 95.616V81.84H104.856V76.944H106.776C107.704 76.944 108.328 76.736 108.648 76.32C109 75.872 109.176 75.216 109.176 74.352V70.08H114.696V76.944H119.832V81.84H114.696V97.104H119.448V102H115.032ZM141.593 102C140.249 102 139.177 101.616 138.377 100.848C137.609 100.048 137.129 98.992 136.937 97.68H136.649C136.233 99.312 135.385 100.544 134.105 101.376C132.825 102.176 131.241 102.576 129.353 102.576C126.793 102.576 124.825 101.904 123.449 100.56C122.073 99.216 121.385 97.424 121.385 95.184C121.385 92.592 122.313 90.672 124.169 89.424C126.025 88.144 128.665 87.504 132.089 87.504H136.361V85.68C136.361 84.272 135.993 83.184 135.257 82.416C134.521 81.648 133.337 81.264 131.705 81.264C130.265 81.264 129.097 81.584 128.201 82.224C127.337 82.832 126.601 83.568 125.993 84.432L122.345 81.168C123.273 79.728 124.505 78.576 126.041 77.712C127.577 76.816 129.609 76.368 132.137 76.368C135.529 76.368 138.105 77.136 139.865 78.672C141.625 80.208 142.505 82.416 142.505 85.296V97.104H145.001V102H141.593ZM131.417 98.112C132.793 98.112 133.961 97.808 134.921 97.2C135.881 96.592 136.361 95.696 136.361 94.512V91.2H132.425C129.225 91.2 127.625 92.224 127.625 94.272V95.088C127.625 96.112 127.945 96.88 128.585 97.392C129.257 97.872 130.201 98.112 131.417 98.112ZM155.61 102C153.498 102 151.882 101.456 150.762 100.368C149.674 99.248 149.13 97.664 149.13 95.616V81.84H145.434V76.944H147.354C148.282 76.944 148.906 76.736 149.226 76.32C149.578 75.872 149.754 75.216 149.754 74.352V70.08H155.274V76.944H160.41V81.84H155.274V97.104H160.026V102H155.61ZM173.68 102.576C171.824 102.576 170.16 102.272 168.688 101.664C167.248 101.024 166.016 100.144 164.992 99.024C164 97.872 163.232 96.496 162.688 94.896C162.144 93.264 161.872 91.44 161.872 89.424C161.872 87.44 162.128 85.648 162.64 84.048C163.184 82.448 163.952 81.088 164.944 79.968C165.936 78.816 167.152 77.936 168.592 77.328C170.032 76.688 171.664 76.368 173.488 76.368C175.44 76.368 177.136 76.704 178.576 77.376C180.016 78.048 181.2 78.96 182.128 80.112C183.056 81.264 183.744 82.608 184.192 84.144C184.672 85.648 184.912 87.264 184.912 88.992V91.008H168.256V91.632C168.256 93.456 168.768 94.928 169.792 96.048C170.816 97.136 172.336 97.68 174.352 97.68C175.888 97.68 177.136 97.36 178.096 96.72C179.088 96.08 179.968 95.264 180.736 94.272L184.048 97.968C183.024 99.408 181.616 100.544 179.824 101.376C178.064 102.176 176.016 102.576 173.68 102.576ZM173.584 80.976C171.952 80.976 170.656 81.52 169.696 82.608C168.736 83.696 168.256 85.104 168.256 86.832V87.216H178.528V86.784C178.528 85.056 178.096 83.664 177.232 82.608C176.4 81.52 175.184 80.976 173.584 80.976ZM211.197 102.576C208.989 102.576 206.989 102.208 205.197 101.472C203.405 100.736 201.869 99.632 200.589 98.16C199.341 96.688 198.365 94.88 197.661 92.736C196.957 90.592 196.605 88.096 196.605 85.248C196.605 82.432 196.957 79.952 197.661 77.808C198.365 75.632 199.341 73.808 200.589 72.336C201.869 70.864 203.405 69.76 205.197 69.024C206.989 68.288 208.989 67.92 211.197 67.92C213.405 67.92 215.405 68.288 217.197 69.024C218.989 69.76 220.525 70.864 221.805 72.336C223.085 73.808 224.061 75.632 224.733 77.808C225.437 79.952 225.789 82.432 225.789 85.248C225.789 88.096 225.437 90.592 224.733 92.736C224.061 94.88 223.085 96.688 221.805 98.16C220.525 99.632 218.989 100.736 217.197 101.472C215.405 102.208 213.405 102.576 211.197 102.576ZM211.197 96.96C213.597 96.96 215.501 96.16 216.909 94.56C218.349 92.96 219.069 90.72 219.069 87.84V82.656C219.069 79.776 218.349 77.536 216.909 75.936C215.501 74.336 213.597 73.536 211.197 73.536C208.797 73.536 206.877 74.336 205.437 75.936C204.029 77.536 203.325 79.776 203.325 82.656V87.84C203.325 90.72 204.029 92.96 205.437 94.56C206.877 96.16 208.797 96.96 211.197 96.96ZM231.081 81.792H227.385V76.944H231.081V73.344C231.081 71.136 231.657 69.44 232.809 68.256C233.993 67.072 235.721 66.48 237.993 66.48H242.361V71.376H237.225V76.944H242.361V81.792H237.225V102H231.081V81.792Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                width: "183",
                                height: "65",
                                transform: "translate(68.5 103)",
                                fill: "#004F3B"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M90.436 148V114.496H111.988V120.112H96.772V128.224H110.02V133.84H96.772V148H90.436ZM118.827 119.296C117.547 119.296 116.619 119.008 116.043 118.432C115.499 117.856 115.227 117.12 115.227 116.224V115.264C115.227 114.368 115.499 113.632 116.043 113.056C116.619 112.48 117.547 112.192 118.827 112.192C120.075 112.192 120.987 112.48 121.563 113.056C122.139 113.632 122.427 114.368 122.427 115.264V116.224C122.427 117.12 122.139 117.856 121.563 118.432C120.987 119.008 120.075 119.296 118.827 119.296ZM115.755 122.944H121.899V148H115.755V122.944ZM127.021 148V122.944H133.165V127.12H133.405C133.917 125.776 134.717 124.656 135.805 123.76C136.925 122.832 138.461 122.368 140.413 122.368C143.005 122.368 144.989 123.216 146.365 124.912C147.741 126.608 148.429 129.024 148.429 132.16V148H142.285V132.784C142.285 130.992 141.965 129.648 141.325 128.752C140.685 127.856 139.629 127.408 138.157 127.408C137.517 127.408 136.893 127.504 136.285 127.696C135.709 127.856 135.181 128.112 134.701 128.464C134.253 128.784 133.885 129.2 133.597 129.712C133.309 130.192 133.165 130.768 133.165 131.44V148H127.021ZM166.776 148.576C164.568 148.576 162.568 148.208 160.776 147.472C158.984 146.736 157.448 145.632 156.168 144.16C154.92 142.688 153.944 140.88 153.24 138.736C152.536 136.592 152.184 134.096 152.184 131.248C152.184 128.432 152.536 125.952 153.24 123.808C153.944 121.632 154.92 119.808 156.168 118.336C157.448 116.864 158.984 115.76 160.776 115.024C162.568 114.288 164.568 113.92 166.776 113.92C168.984 113.92 170.984 114.288 172.776 115.024C174.568 115.76 176.104 116.864 177.384 118.336C178.664 119.808 179.64 121.632 180.312 123.808C181.016 125.952 181.368 128.432 181.368 131.248C181.368 134.096 181.016 136.592 180.312 138.736C179.64 140.88 178.664 142.688 177.384 144.16C176.104 145.632 174.568 146.736 172.776 147.472C170.984 148.208 168.984 148.576 166.776 148.576ZM166.776 142.96C169.176 142.96 171.08 142.16 172.488 140.56C173.928 138.96 174.648 136.72 174.648 133.84V128.656C174.648 125.776 173.928 123.536 172.488 121.936C171.08 120.336 169.176 119.536 166.776 119.536C164.376 119.536 162.456 120.336 161.016 121.936C159.608 123.536 158.904 125.776 158.904 128.656V133.84C158.904 136.72 159.608 138.96 161.016 140.56C162.456 142.16 164.376 142.96 166.776 142.96ZM185.411 122.944H191.555V127.072H191.747C192.195 125.632 193.043 124.496 194.291 123.664C195.539 122.8 196.995 122.368 198.659 122.368C201.859 122.368 204.291 123.504 205.955 125.776C207.651 128.016 208.499 131.232 208.499 135.424C208.499 139.648 207.651 142.896 205.955 145.168C204.291 147.44 201.859 148.576 198.659 148.576C196.995 148.576 195.539 148.144 194.291 147.28C193.075 146.416 192.227 145.264 191.747 143.824H191.555V157.6H185.411V122.944ZM196.691 143.488C198.291 143.488 199.587 142.96 200.579 141.904C201.571 140.848 202.067 139.424 202.067 137.632V133.312C202.067 131.52 201.571 130.096 200.579 129.04C199.587 127.952 198.291 127.408 196.691 127.408C195.219 127.408 193.987 127.776 192.995 128.512C192.035 129.248 191.555 130.224 191.555 131.44V139.408C191.555 140.72 192.035 141.728 192.995 142.432C193.987 143.136 195.219 143.488 196.691 143.488ZM220.401 148.576C218.001 148.576 215.985 148.176 214.353 147.376C212.721 146.544 211.281 145.408 210.033 143.968L213.777 140.32C214.705 141.376 215.713 142.208 216.801 142.816C217.921 143.424 219.201 143.728 220.641 143.728C222.113 143.728 223.169 143.472 223.809 142.96C224.481 142.448 224.817 141.744 224.817 140.848C224.817 140.112 224.577 139.536 224.097 139.12C223.649 138.672 222.865 138.368 221.745 138.208L219.249 137.872C216.529 137.52 214.449 136.752 213.009 135.568C211.601 134.352 210.897 132.592 210.897 130.288C210.897 129.072 211.121 127.984 211.569 127.024C212.017 126.032 212.657 125.2 213.489 124.528C214.321 123.824 215.313 123.296 216.465 122.944C217.649 122.56 218.961 122.368 220.401 122.368C221.617 122.368 222.689 122.464 223.617 122.656C224.577 122.816 225.441 123.072 226.209 123.424C226.977 123.744 227.681 124.16 228.321 124.672C228.961 125.152 229.585 125.696 230.193 126.304L226.593 129.904C225.857 129.136 224.977 128.496 223.953 127.984C222.929 127.472 221.809 127.216 220.593 127.216C219.249 127.216 218.273 127.456 217.665 127.936C217.089 128.416 216.801 129.04 216.801 129.808C216.801 130.64 217.041 131.28 217.521 131.728C218.033 132.144 218.881 132.448 220.065 132.64L222.609 132.976C228.017 133.744 230.721 136.208 230.721 140.368C230.721 141.584 230.465 142.704 229.953 143.728C229.473 144.72 228.785 145.584 227.889 146.32C226.993 147.024 225.905 147.584 224.625 148C223.377 148.384 221.969 148.576 220.401 148.576Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "45",
                                y: "180",
                                width: "27",
                                height: "27",
                                rx: "13.5",
                                fill: "black",
                                fillOpacity: "0.24"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "45.5",
                                y: "180.5",
                                width: "26",
                                height: "26",
                                rx: "13",
                                stroke: "black",
                                strokeOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                clipPath: "url(#clip1_5592_7363)",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M54.23 186.903C54.3459 186.729 54.541 186.625 54.75 186.625H62.25C62.459 186.625 62.6541 186.729 62.77 186.903L65.27 190.653C65.4141 190.869 65.4095 191.152 65.2586 191.363L59.0086 200.113C58.8913 200.278 58.7018 200.375 58.5 200.375C58.2982 200.375 58.1087 200.278 57.9914 200.113L51.7414 191.363C51.5905 191.152 51.5859 190.869 51.73 190.653L54.23 186.903ZM55.0845 187.875L53.4178 190.375H55.5495L56.3829 187.875H55.0845ZM57.7005 187.875L56.8671 190.375H60.1329L59.2995 187.875H57.7005ZM60.6171 187.875L61.4505 190.375H63.5822L61.9155 187.875H60.6171ZM63.5355 191.625H61.4714L60.0954 196.441L63.5355 191.625ZM58.5 197.475L60.1714 191.625H56.8286L58.5 197.475ZM55.5286 191.625L56.9046 196.441L53.4645 191.625H55.5286Z",
                                    fill: "#FF6B00"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "18",
                                y: "44",
                                width: "27",
                                height: "27",
                                rx: "13.5",
                                fill: "black",
                                fillOpacity: "0.24"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "18.5",
                                y: "44.5",
                                width: "26",
                                height: "26",
                                rx: "13",
                                stroke: "black",
                                strokeOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                clipPath: "url(#clip2_5592_7363)",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M30.875 51.2809C27.7167 51.5944 25.25 54.2592 25.25 57.5C25.25 60.7408 27.7167 63.4056 30.875 63.7191V51.2809ZM32.125 51.2809V57.2411L36.3394 61.4555C37.2215 60.3777 37.75 59.001 37.75 57.5C37.75 54.2592 35.2833 51.5944 32.125 51.2809ZM35.4555 62.3394L32.125 59.0089V63.7192C33.3821 63.5945 34.5292 63.0975 35.4555 62.3394ZM24 57.5C24 53.3579 27.3579 50 31.5 50C35.6421 50 39 53.3579 39 57.5C39 59.5709 38.1598 61.4468 36.8033 62.8033C35.4468 64.1598 33.5709 65 31.5 65C27.3579 65 24 61.6421 24 57.5Z",
                                    fill: "#FFB700"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "87",
                                y: "13",
                                width: "27",
                                height: "27",
                                rx: "13.5",
                                fill: "black",
                                fillOpacity: "0.24"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "87.5",
                                y: "13.5",
                                width: "26",
                                height: "26",
                                rx: "13",
                                stroke: "black",
                                strokeOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                clipPath: "url(#clip3_5592_7363)",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M99.875 20.2809C96.7167 20.5944 94.25 23.2592 94.25 26.5C94.25 29.9518 97.0482 32.75 100.5 32.75C102.001 32.75 103.378 32.2215 104.455 31.3394L100.058 26.9419C99.9408 26.8247 99.875 26.6658 99.875 26.5V20.2809ZM101.125 20.2808V20.875H103.228C102.581 20.5608 101.873 20.355 101.125 20.2808ZM104.963 22.125H101.125V23.375H105.914C105.65 22.9189 105.33 22.4991 104.963 22.125ZM106.464 24.625H101.125V25.875H106.719C106.676 25.4436 106.59 25.0255 106.464 24.625ZM106.719 27.125H102.009L103.259 28.375H106.464C106.59 27.9745 106.676 27.5564 106.719 27.125ZM105.914 29.625H104.509L105.339 30.4555C105.552 30.1952 105.745 29.9176 105.914 29.625ZM93 26.5C93 22.3579 96.3579 19 100.5 19C102.493 19 104.305 19.778 105.648 21.0455C106.447 21.8002 107.081 22.7293 107.489 23.7726C107.819 24.6188 108 25.539 108 26.5C108 27.461 107.819 28.3812 107.489 29.2274C107.108 30.2021 106.53 31.0771 105.803 31.8033C104.447 33.1598 102.571 34 100.5 34C96.3579 34 93 30.6421 93 26.5Z",
                                    fill: "#0080AF"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "207",
                                y: "7",
                                width: "27",
                                height: "27",
                                rx: "13.5",
                                fill: "black",
                                fillOpacity: "0.24"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "207.5",
                                y: "7.5",
                                width: "26",
                                height: "26",
                                rx: "13",
                                stroke: "black",
                                strokeOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M218.183 18.1831C218.427 17.939 218.823 17.939 219.067 18.1831L222.375 21.4911L225.683 18.1831C225.927 17.939 226.323 17.939 226.567 18.1831C226.811 18.4271 226.811 18.8229 226.567 19.0669L222.82 22.8143L222.818 22.8157L222.818 22.8163L222.817 22.8168C222.573 23.0609 222.177 23.061 221.933 22.8169L218.625 19.5089L215.317 22.8169C215.073 23.061 214.677 23.061 214.433 22.8169C214.189 22.5729 214.189 22.1771 214.433 21.9331L218.183 18.1831Z",
                                fill: "#00C693"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "273",
                                y: "52",
                                width: "27",
                                height: "27",
                                rx: "13.5",
                                fill: "black",
                                fillOpacity: "0.24"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "273.5",
                                y: "52.5",
                                width: "26",
                                height: "26",
                                rx: "13",
                                stroke: "black",
                                strokeOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M292.125 60.5C291.089 60.5 290.25 61.3395 290.25 62.375C290.25 62.7296 290.348 63.0612 290.52 63.344L289.009 65.6099C288.811 65.5388 288.597 65.5 288.375 65.5C288.123 65.5 287.882 65.5498 287.663 65.6401L286.27 63.8998C286.417 63.6327 286.5 63.3261 286.5 63C286.5 61.9645 285.661 61.125 284.625 61.125C283.589 61.125 282.75 61.9645 282.75 63C282.75 63.3772 282.861 63.7284 283.053 64.0225L281.444 66.838C281.265 66.7808 281.073 66.75 280.875 66.75C279.839 66.75 279 67.5895 279 68.625C279 69.6605 279.839 70.5 280.875 70.5C281.911 70.5 282.75 69.6605 282.75 68.625C282.75 68.2478 282.639 67.8967 282.447 67.6026L284.056 64.7871C284.235 64.8442 284.427 64.875 284.625 64.875C284.877 64.875 285.118 64.8252 285.338 64.7348L286.73 66.475C286.583 66.7422 286.5 67.0489 286.5 67.375C286.5 68.4105 287.339 69.25 288.375 69.25C289.411 69.25 290.25 68.4105 290.25 67.375C290.25 67.0204 290.152 66.6888 289.981 66.406L291.491 64.1401C291.689 64.2113 291.903 64.25 292.125 64.25C293.161 64.25 294 63.4105 294 62.375C294 61.3395 293.161 60.5 292.125 60.5ZM291.5 62.375C291.5 62.0298 291.78 61.75 292.125 61.75C292.47 61.75 292.75 62.0298 292.75 62.375C292.75 62.7202 292.47 63 292.125 63C291.78 63 291.5 62.7202 291.5 62.375ZM284 63C284 62.6548 284.28 62.375 284.625 62.375C284.97 62.375 285.25 62.6548 285.25 63C285.25 63.3452 284.97 63.625 284.625 63.625C284.28 63.625 284 63.3452 284 63ZM280.25 68.625C280.25 68.2798 280.53 68 280.875 68C281.22 68 281.5 68.2798 281.5 68.625C281.5 68.9702 281.22 69.25 280.875 69.25C280.53 69.25 280.25 68.9702 280.25 68.625ZM288.375 66.75C288.03 66.75 287.75 67.0298 287.75 67.375C287.75 67.7202 288.03 68 288.375 68C288.72 68 289 67.7202 289 67.375C289 67.0298 288.72 66.75 288.375 66.75Z",
                                fill: "#BD3BFD"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "257",
                                y: "183",
                                width: "27",
                                height: "27",
                                rx: "13.5",
                                fill: "black",
                                fillOpacity: "0.24"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: "257.5",
                                y: "183.5",
                                width: "26",
                                height: "26",
                                rx: "13",
                                stroke: "black",
                                strokeOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M266.75 191.812C266.75 192.503 266.19 193.062 265.5 193.062C264.81 193.062 264.25 192.503 264.25 191.812C264.25 191.122 264.81 190.562 265.5 190.562C266.19 190.562 266.75 191.122 266.75 191.812Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M271.75 191.812C271.75 192.503 271.19 193.062 270.5 193.062C269.81 193.062 269.25 192.503 269.25 191.812C269.25 191.122 269.81 190.562 270.5 190.562C271.19 190.562 271.75 191.122 271.75 191.812Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M274.25 191.812C274.25 192.503 273.69 193.062 273 193.062C272.31 193.062 271.75 192.503 271.75 191.812C271.75 191.122 272.31 190.562 273 190.562C273.69 190.562 274.25 191.122 274.25 191.812Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M276.75 191.812C276.75 192.503 276.19 193.062 275.5 193.062C274.81 193.062 274.25 192.503 274.25 191.812C274.25 191.122 274.81 190.562 275.5 190.562C276.19 190.562 276.75 191.122 276.75 191.812Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M266.75 194.938C266.75 195.628 266.19 196.188 265.5 196.188C264.81 196.188 264.25 195.628 264.25 194.938C264.25 194.247 264.81 193.688 265.5 193.688C266.19 193.688 266.75 194.247 266.75 194.938Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M269.25 194.938C269.25 195.628 268.69 196.188 268 196.188C267.31 196.188 266.75 195.628 266.75 194.938C266.75 194.247 267.31 193.688 268 193.688C268.69 193.688 269.25 194.247 269.25 194.938Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M274.25 194.938C274.25 195.628 273.69 196.188 273 196.188C272.31 196.188 271.75 195.628 271.75 194.938C271.75 194.247 272.31 193.688 273 193.688C273.69 193.688 274.25 194.247 274.25 194.938Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M276.75 194.938C276.75 195.628 276.19 196.188 275.5 196.188C274.81 196.188 274.25 195.628 274.25 194.938C274.25 194.247 274.81 193.688 275.5 193.688C276.19 193.688 276.75 194.247 276.75 194.938Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M266.75 198.062C266.75 198.753 266.19 199.312 265.5 199.312C264.81 199.312 264.25 198.753 264.25 198.062C264.25 197.372 264.81 196.812 265.5 196.812C266.19 196.812 266.75 197.372 266.75 198.062Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M269.25 198.062C269.25 198.753 268.69 199.312 268 199.312C267.31 199.312 266.75 198.753 266.75 198.062C266.75 197.372 267.31 196.812 268 196.812C268.69 196.812 269.25 197.372 269.25 198.062Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M271.75 198.062C271.75 198.753 271.19 199.312 270.5 199.312C269.81 199.312 269.25 198.753 269.25 198.062C269.25 197.372 269.81 196.812 270.5 196.812C271.19 196.812 271.75 197.372 271.75 198.062Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M274.25 198.062C274.25 198.753 273.69 199.312 273 199.312C272.31 199.312 271.75 198.753 271.75 198.062C271.75 197.372 272.31 196.812 273 196.812C273.69 196.812 274.25 197.372 274.25 198.062Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M266.75 201.188C266.75 201.878 266.19 202.438 265.5 202.438C264.81 202.438 264.25 201.878 264.25 201.188C264.25 200.497 264.81 199.938 265.5 199.938C266.19 199.938 266.75 200.497 266.75 201.188Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M269.25 201.188C269.25 201.878 268.69 202.438 268 202.438C267.31 202.438 266.75 201.878 266.75 201.188C266.75 200.497 267.31 199.938 268 199.938C268.69 199.938 269.25 200.497 269.25 201.188Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M271.75 201.188C271.75 201.878 271.19 202.438 270.5 202.438C269.81 202.438 269.25 201.878 269.25 201.188C269.25 200.497 269.81 199.938 270.5 199.938C271.19 199.938 271.75 200.497 271.75 201.188Z",
                                fill: "#0080AF"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M276.75 201.188C276.75 201.878 276.19 202.438 275.5 202.438C274.81 202.438 274.25 201.878 274.25 201.188C274.25 200.497 274.81 199.938 275.5 199.938C276.19 199.938 276.75 200.497 276.75 201.188Z",
                                fill: "#0080AF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                id: "paint0_linear_5592_7363",
                                x1: "160",
                                y1: "216",
                                x2: "160",
                                y2: "-4.39234e-06",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        "stop-color": "#007758"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        offset: "1",
                                        "stop-color": "#009E76",
                                        "stop-opacity": "0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                id: "clip0_5592_7363",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    width: "320",
                                    height: "216",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                id: "clip1_5592_7363",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    width: "15",
                                    height: "15",
                                    fill: "white",
                                    transform: "translate(51 186)"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                id: "clip2_5592_7363",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    width: "15",
                                    height: "15",
                                    fill: "white",
                                    transform: "translate(24 50)"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                id: "clip3_5592_7363",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    width: "15",
                                    height: "15",
                                    fill: "white",
                                    transform: "translate(93 19)"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb9cbc363cee6449$export$ec91da630f36d5ea), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "py-10 results",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mx-auto container 2xl:mx-auto py-9",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efff4cf968573785$var$CustomHits, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid xl:grid-cols-2 container px-4 mx-auto pt-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                    width: "183",
                                    height: "48",
                                    viewBox: "0 0 183 48",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M57.0537 20.2699V1.15211H68.4484V3.17797H59.3547V9.58695H67.654V11.6142H59.3547V20.2699H57.0537Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M72.3374 2.82079C72.1521 2.83911 71.9649 2.81843 71.7881 2.76006C71.6112 2.7017 71.4486 2.60694 71.3106 2.4819C71.0941 2.23732 70.9812 1.91827 70.9954 1.59199V1.23278C70.9815 0.906349 71.0944 0.587198 71.3106 0.342189C71.6069 0.120064 71.9673 0 72.3377 0C72.7081 0 73.0685 0.120064 73.3649 0.342189C73.5807 0.587379 73.6936 0.906402 73.68 1.23278V1.58861C73.694 1.91483 73.5811 2.23379 73.3649 2.47852C73.227 2.6041 73.0643 2.69944 72.8874 2.75839C72.7104 2.81733 72.5231 2.83859 72.3374 2.82079ZM71.2414 6.13576H73.4333V20.2699H71.2414V6.13576Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M75.9533 20.27V6.13576H78.1445V8.41103H78.2543C78.5664 7.65999 79.072 7.00514 79.7197 6.51328C80.4654 6.00914 81.3549 5.76148 82.2539 5.80772C82.8993 5.77624 83.5438 5.88622 84.1423 6.12997C84.7408 6.37372 85.2788 6.74535 85.7186 7.21884C86.629 8.33993 87.0837 9.76283 86.9921 11.2041V20.27H84.8009V11.5681C84.8009 9.02373 83.7325 7.75179 81.5957 7.75224C81.1659 7.75123 80.7377 7.8066 80.3222 7.91694C79.9279 8.01931 79.5532 8.18627 79.2134 8.41103C78.8903 8.62401 78.6226 8.91096 78.4326 9.24808C78.2339 9.61415 78.1346 10.0259 78.1445 10.4423V20.27H75.9533Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M97.648 20.5993C96.4969 20.6167 95.3546 20.3975 94.2917 19.9555C93.3064 19.5335 92.4339 18.886 91.7446 18.0652C90.9994 17.1535 90.4461 16.1006 90.118 14.9698C89.7134 13.587 89.5195 12.1512 89.5425 10.7107C89.5187 9.27434 89.7127 7.84268 90.118 6.46447C90.45 5.33541 91.0029 4.28351 91.7446 3.36978C92.4306 2.54215 93.3037 1.88958 94.2917 1.46593C96.4417 0.607406 98.8393 0.607406 100.989 1.46593C101.983 1.8869 102.861 2.53973 103.551 3.36978C104.293 4.28373 104.847 5.33549 105.181 6.46447C105.586 7.84203 105.78 9.27294 105.757 10.7087C105.78 12.1491 105.587 13.5849 105.183 14.9678C104.853 16.0985 104.298 17.1512 103.553 18.0631C102.86 18.8864 101.982 19.5341 100.991 19.9534C99.9324 20.3938 98.7948 20.6135 97.648 20.5993ZM97.648 18.5715C98.4276 18.5796 99.2007 18.4302 99.9212 18.1323C100.604 17.8465 101.217 17.4149 101.715 16.8675C102.232 16.2926 102.628 15.6195 102.88 14.8885C103.164 14.0571 103.303 13.1832 103.29 12.3048V9.1159C103.303 8.23752 103.164 7.36358 102.88 6.53225C102.628 5.80118 102.232 5.12815 101.715 4.55316C101.217 4.00603 100.604 3.5746 99.9212 3.28913C98.4624 2.70173 96.8329 2.70173 95.3741 3.28913C94.6909 3.57443 94.0786 4.00588 93.58 4.55316C93.0629 5.12797 92.6669 5.80106 92.4156 6.53225C92.1317 7.36358 91.9928 8.23752 92.0049 9.1159V12.3048C91.9928 13.1832 92.1317 14.0571 92.4156 14.8885C92.6669 15.6197 93.0629 16.2927 93.58 16.8675C94.0785 17.415 94.6909 17.8467 95.3741 18.1323C96.0947 18.4301 96.8682 18.5793 97.648 18.5708V18.5715Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M107.892 6.13576H110.084V8.41103H110.193C110.498 7.5983 111.061 6.90793 111.796 6.4455C112.565 6.00359 113.442 5.78309 114.329 5.8084C115.153 5.7971 115.968 5.97519 116.712 6.32893C117.425 6.67636 118.048 7.18252 118.534 7.8085C119.064 8.50321 119.456 9.2937 119.686 10.1366C119.963 11.1353 120.096 12.1681 120.083 13.2042C120.096 14.2406 119.963 15.2735 119.686 16.2725C119.456 17.1154 119.064 17.9059 118.534 18.6006C118.048 19.2264 117.425 19.7323 116.712 20.0795C115.968 20.4338 115.153 20.6121 114.329 20.6007C113.457 20.6402 112.593 20.412 111.854 19.9465C111.115 19.4811 110.536 18.8007 110.195 17.9967H110.086V25.7484H107.894L107.892 6.13576ZM113.727 18.6542C114.271 18.6824 114.814 18.5925 115.32 18.3905C115.826 18.1886 116.282 17.8794 116.657 17.4843C117.394 16.6362 117.777 15.5371 117.726 14.4147V11.9917C117.777 10.8693 117.394 9.77012 116.657 8.92207C116.282 8.52698 115.826 8.21783 115.32 8.01589C114.814 7.81394 114.271 7.724 113.727 7.75224C113.249 7.74866 112.773 7.81721 112.316 7.95557C111.899 8.07772 111.506 8.26828 111.152 8.51947C110.832 8.74834 110.565 9.04415 110.371 9.38634C110.182 9.71753 110.083 10.0926 110.084 10.4742V15.7608C110.076 16.187 110.175 16.6085 110.371 16.9868C110.562 17.3431 110.828 17.6531 111.152 17.8951C111.502 18.1531 111.896 18.3442 112.316 18.459C112.774 18.59 113.249 18.6557 113.727 18.6542Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M127.247 20.5993C126.1 20.6391 124.962 20.3793 123.946 19.8457C123.054 19.338 122.275 18.6526 121.659 17.832L123.218 16.572C123.716 17.2234 124.34 17.7682 125.052 18.1743C125.776 18.5608 126.588 18.7543 127.408 18.7361C128.181 18.7825 128.947 18.5705 129.586 18.1336C129.808 17.9469 129.991 17.7179 130.124 17.4599C130.257 17.2019 130.337 16.9201 130.36 16.6308C130.383 16.3415 130.348 16.0505 130.257 15.7748C130.167 15.4991 130.022 15.2441 129.833 15.0247C129.295 14.5503 128.616 14.2663 127.901 14.2168L126.778 14.0521C126.163 13.9707 125.557 13.8286 124.97 13.6278C124.452 13.4517 123.967 13.1926 123.532 12.8606C123.124 12.544 122.795 12.1359 122.574 11.6691C122.334 11.1357 122.218 10.555 122.235 9.97057C122.22 9.34213 122.352 8.71888 122.618 8.1494C122.864 7.63995 123.225 7.19453 123.673 6.84809C124.152 6.48578 124.697 6.22075 125.277 6.06797C125.929 5.88984 126.601 5.80204 127.277 5.80703C128.274 5.77386 129.265 5.98073 130.167 6.41025C130.954 6.82139 131.649 7.3898 132.207 8.08027L130.756 9.39514C130.334 8.83331 129.782 8.38263 129.147 8.08209C128.512 7.78154 127.814 7.64018 127.112 7.67022C126.375 7.61683 125.643 7.82516 125.044 8.25852C124.813 8.45479 124.63 8.70126 124.509 8.97909C124.388 9.25691 124.332 9.55872 124.346 9.86144C124.322 10.1515 124.373 10.4429 124.495 10.707C124.618 10.9711 124.807 11.1987 125.044 11.3674C125.661 11.7319 126.347 11.9652 127.058 12.0527L128.153 12.2167C129.382 12.3072 130.551 12.7814 131.495 13.5722C131.827 13.9194 132.086 14.3301 132.255 14.7796C132.425 15.2292 132.502 15.7084 132.481 16.1884C132.51 16.798 132.399 17.4062 132.157 17.9664C131.915 18.5266 131.548 19.024 131.084 19.4207C129.988 20.2604 128.626 20.6786 127.247 20.5993Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M57.0537 47.662V28.5428H68.4484V30.5673H59.3547V36.979H67.654V39.0062H59.3547V47.662H57.0537Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M76.5673 47.9907C75.6728 48.002 74.786 47.8246 73.9647 47.4702C73.19 47.131 72.5019 46.6213 71.9517 45.9791C71.3726 45.2925 70.9304 44.5012 70.649 43.6482C70.0282 41.6642 70.0282 39.5378 70.649 37.5537C70.928 36.6964 71.3698 35.9011 71.9504 35.2114C72.5004 34.569 73.1886 34.0593 73.9633 33.7203C74.7848 33.3661 75.6715 33.1888 76.566 33.1997C77.4559 33.1881 78.3381 33.3655 79.1544 33.7203C79.9265 34.0638 80.6137 34.5729 81.1673 35.2114C81.7553 35.8981 82.2022 36.6941 82.4822 37.5537C83.104 39.5377 83.104 41.6643 82.4822 43.6482C82.1998 44.5025 81.7531 45.2934 81.1673 45.9764C80.6136 46.6147 79.9264 47.1237 79.1544 47.4675C78.3389 47.8233 77.457 48.0017 76.5673 47.9907ZM76.5673 46.0462C77.1 46.0671 77.6315 45.9809 78.1303 45.7927C78.629 45.6044 79.0849 45.3179 79.4709 44.9502C79.8744 44.4981 80.182 43.9688 80.3751 43.3943C80.5681 42.8199 80.6426 42.2122 80.5939 41.6081V39.5816C80.6424 38.9776 80.5679 38.3699 80.3749 37.7955C80.1819 37.2211 79.8743 36.6917 79.4709 36.2395C78.6686 35.5332 77.6363 35.1435 76.5673 35.1435C75.4984 35.1435 74.4661 35.5332 73.6638 36.2395C73.2602 36.6916 72.9526 37.221 72.7595 37.7954C72.5665 38.3699 72.492 38.9775 72.5407 39.5816V41.6081C72.4919 42.2122 72.5663 42.8199 72.7594 43.3944C72.9524 43.9689 73.2601 44.4982 73.6638 44.9502C74.0497 45.318 74.5056 45.6046 75.0043 45.7928C75.5031 45.9811 76.0346 46.0672 76.5673 46.0462Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M93.9602 45.3874H93.8511C93.699 45.7222 93.5202 46.0443 93.3164 46.3505C93.1028 46.6707 92.8392 46.9544 92.5356 47.1909C92.1978 47.4488 91.8178 47.646 91.4125 47.7738C90.9163 47.9271 90.3987 48.0004 89.8794 47.9907C89.2319 48.0217 88.5855 47.9116 87.9848 47.6681C87.3841 47.4245 86.8435 47.0534 86.4004 46.5803C85.4809 45.4632 85.0205 44.0382 85.1127 42.5943V33.5278H87.3039V42.2297C87.3039 44.774 88.3813 46.0462 90.5362 46.0462C90.966 46.047 91.3942 45.9916 91.8097 45.8815C92.2006 45.7806 92.5713 45.6135 92.9056 45.3874C93.2223 45.1708 93.4849 44.8841 93.6729 44.5497C93.8733 44.175 93.9723 43.7544 93.9602 43.3297V33.5278H96.1522V47.662H93.9602V45.3874Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M99.2197 47.662V33.5278H101.412V35.803H101.521C101.833 35.0521 102.339 34.3973 102.986 33.9053C103.732 33.4009 104.621 33.1532 105.52 33.1997C106.166 33.1684 106.81 33.2784 107.409 33.5221C108.007 33.7657 108.545 34.137 108.985 34.6102C109.896 35.7313 110.35 37.1546 110.259 38.5961V47.662H108.067V38.9601C108.067 36.4167 106.999 35.1445 104.863 35.1436C104.433 35.1427 104.004 35.1983 103.589 35.309C103.194 35.411 102.819 35.578 102.48 35.803C102.157 36.0162 101.889 36.3031 101.699 36.6401C101.501 37.006 101.402 37.4175 101.412 37.8336V47.6613L99.2197 47.662Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M122.503 45.3874H122.393C122.048 46.1883 121.468 46.8659 120.73 47.3306C119.992 47.7953 119.13 48.0255 118.259 47.9907C117.435 48.0023 116.62 47.8242 115.876 47.4702C115.163 47.1231 114.54 46.6169 114.055 45.9906C113.524 45.2963 113.132 44.5057 112.903 43.6625C112.373 41.6517 112.373 39.5381 112.903 37.5273C113.133 36.6842 113.524 35.8936 114.055 35.1992C114.541 34.5731 115.164 34.0669 115.876 33.7196C116.62 33.3659 117.435 33.1878 118.259 33.1991C119.146 33.1738 120.023 33.3946 120.793 33.8368C121.528 34.2993 122.09 34.9897 122.395 35.8024H122.505V27.3919H124.696V47.662H122.505L122.503 45.3874ZM118.86 46.0462C119.337 46.0482 119.812 45.9834 120.271 45.8537C120.69 45.7387 121.084 45.5473 121.434 45.2891C121.758 45.0471 122.025 44.7368 122.215 44.3802C122.412 44.0025 122.511 43.5814 122.503 43.1555V37.8689C122.504 37.4873 122.405 37.112 122.215 36.7811C122.021 36.439 121.754 36.1432 121.434 35.9142C121.08 35.6633 120.687 35.4727 120.271 35.3503C119.814 35.2107 119.338 35.1407 118.86 35.1429C118.316 35.1147 117.772 35.2048 117.266 35.407C116.76 35.6092 116.304 35.9187 115.929 36.3141C115.192 37.162 114.809 38.2608 114.861 39.383V41.8054C114.809 42.928 115.192 44.0273 115.929 44.8757C116.304 45.2709 116.76 45.5802 117.266 45.7822C117.772 45.9843 118.316 46.0743 118.86 46.0462Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M138.773 47.662C138.448 47.6938 138.12 47.6511 137.814 47.5372C137.508 47.4233 137.232 47.2411 137.007 47.0045C136.635 46.5296 136.403 45.9609 136.335 45.3616H136.199C135.935 46.1786 135.392 46.8768 134.666 47.3339C133.895 47.7874 133.012 48.0149 132.118 47.9907C130.849 48.0685 129.599 47.656 128.625 46.8385C128.206 46.438 127.877 45.9518 127.662 45.413C127.447 44.8743 127.35 44.2955 127.378 43.716C127.348 43.123 127.466 42.5318 127.722 41.996C127.978 41.4603 128.363 40.9968 128.844 40.6477C129.821 39.9352 131.341 39.5791 133.405 39.5796H136.199V38.1841C136.227 37.7647 136.169 37.3439 136.027 36.9481C135.886 36.5523 135.664 36.1899 135.376 35.8837C134.671 35.3005 133.767 35.0155 132.855 35.0894C132.097 35.062 131.348 35.2625 130.705 35.6648C130.117 36.0617 129.626 36.5856 129.267 37.1979L127.952 35.9657C128.374 35.1579 129.009 34.4806 129.788 34.007C130.747 33.4366 131.85 33.156 132.965 33.1991C134.408 33.109 135.833 33.5569 136.964 34.4563C137.445 34.8983 137.822 35.4412 138.068 36.0461C138.314 36.651 138.423 37.3029 138.387 37.955V45.7168H140.004V47.662H138.773ZM132.473 46.1282C132.981 46.1331 133.488 46.0685 133.979 45.9364C134.401 45.8251 134.8 45.6394 135.157 45.3881C135.468 45.171 135.729 44.8912 135.924 44.5666C136.105 44.2596 136.198 43.9094 136.195 43.5533V41.2252H133.292C132.342 41.1571 131.391 41.346 130.539 41.7722C130.266 41.9349 130.041 42.1685 129.889 42.4482C129.737 42.7279 129.664 43.0434 129.676 43.3615V43.9363C129.661 44.2467 129.722 44.5561 129.853 44.8377C129.984 45.1194 130.182 45.3648 130.43 45.5528C131.028 45.9658 131.747 46.1682 132.473 46.1282Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M145.678 47.662C145.359 47.6851 145.039 47.6397 144.739 47.5291C144.439 47.4184 144.166 47.2448 143.938 47.0201C143.533 46.5566 143.322 45.9545 143.349 45.3393V35.473H141.021V33.5278H142.336C142.509 33.548 142.685 33.5329 142.852 33.4835C143.019 33.4341 143.174 33.3514 143.309 33.2404C143.512 32.9488 143.604 32.5943 143.569 32.2407V29.611H145.54V33.5278H148.636V35.473H145.54V45.7168H148.417V47.662H145.678Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M153.171 30.2135C152.986 30.2312 152.799 30.2099 152.622 30.151C152.445 30.092 152.282 29.9967 152.145 29.8712C151.928 29.6263 151.816 29.3071 151.83 28.9806V28.6248C151.816 28.2984 151.929 27.9792 152.145 27.7342C152.441 27.5121 152.801 27.392 153.172 27.392C153.542 27.392 153.903 27.5121 154.199 27.7342C154.415 27.9794 154.528 28.2984 154.514 28.6248V28.9806C154.528 29.307 154.415 29.6261 154.199 29.8712C154.061 29.9967 153.898 30.0919 153.721 30.1509C153.544 30.2098 153.357 30.2311 153.171 30.2135ZM152.076 33.5278H154.267V47.662H152.076V33.5278Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M162.961 47.9907C162.067 48.0019 161.18 47.8245 160.359 47.4702C159.584 47.1313 158.896 46.6216 158.346 45.9791C157.768 45.2933 157.326 44.503 157.045 43.6509C156.424 41.6669 156.424 39.5405 157.045 37.5564C157.324 36.699 157.765 35.9036 158.346 35.2141C158.896 34.5714 159.584 34.0616 160.359 33.723C161.18 33.3689 162.067 33.1916 162.961 33.2025C163.851 33.1907 164.733 33.3681 165.55 33.723C166.322 34.0663 167.01 34.5753 167.563 35.2141C168.151 35.901 168.598 36.6969 168.878 37.5564C169.499 39.5405 169.499 41.6669 168.878 43.6509C168.595 44.5051 168.149 45.2959 167.563 45.9791C167.009 46.6176 166.322 47.1266 165.55 47.4702C164.733 47.8254 163.851 48.0028 162.961 47.9907ZM162.961 46.0462C163.494 46.0671 164.025 45.9809 164.524 45.7927C165.023 45.6044 165.479 45.3179 165.865 44.9502C166.268 44.4982 166.576 43.9689 166.769 43.3944C166.962 42.8199 167.037 42.2122 166.988 41.6081V39.5816C167.036 38.9775 166.962 38.3699 166.769 37.7954C166.576 37.221 166.268 36.6916 165.865 36.2395C165.063 35.5332 164.03 35.1436 162.962 35.1436C161.893 35.1436 160.86 35.5332 160.058 36.2395C159.655 36.6916 159.347 37.221 159.154 37.7954C158.961 38.3699 158.887 38.9775 158.935 39.5816V41.6081C158.886 42.2122 158.961 42.8199 159.154 43.3944C159.347 43.9689 159.655 44.4982 160.058 44.9502C160.444 45.318 160.9 45.6045 161.399 45.7928C161.897 45.9811 162.429 46.0672 162.961 46.0462Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M171.067 47.662V33.5278H173.259V35.803H173.368C173.681 35.0523 174.186 34.3975 174.834 33.9053C175.579 33.4009 176.469 33.1532 177.368 33.1997C178.013 33.1684 178.658 33.2784 179.256 33.5221C179.855 33.7657 180.393 34.137 180.833 34.6102C181.744 35.7312 182.199 37.1545 182.107 38.5961V47.662H179.916V38.9601C179.916 36.4167 178.847 35.1445 176.71 35.1436C176.28 35.1427 175.852 35.1983 175.436 35.309C175.042 35.4112 174.667 35.5781 174.327 35.803C174.004 36.0162 173.737 36.3031 173.547 36.6401C173.348 37.006 173.249 37.4175 173.259 37.8336V47.6613L171.067 47.662Z",
                                            fill: "#343D53"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18.4629 47.662L0.5 37.6208V16.9753L18.4629 27.0158V47.662Z",
                                            fill: "#1EA482"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M24.6049 47.662L42.5678 37.6208V16.9753L24.6049 27.0158V47.662Z",
                                            fill: "#1EA482"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M21.5311 1.15077L3.58179 11.806L21.5311 21.839L39.4805 11.806L21.5311 1.15077Z",
                                            fill: "#1EA482"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center space-x-6 mt-6 xl:mt-0 xl:justify-end",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-800 font-normal mt-0 mb-0",
                                        children: "Follow Us:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "https://www.linkedin.com/company/finops-foundation",
                                        className: "h-[24px] social-link text-gray-700 hover:text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Linkedin"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                className: "h-6 w-6",
                                                fill: "currentColor",
                                                viewBox: "0 0 24 24",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    className: "hover",
                                                    fill: "#979FA6",
                                                    className: "st0",
                                                    d: "M21.8,0H2.2C1,0,0,1,0,2.2v19.7C0,23,1,24,2.2,24h19.7c1.2,0,2.2-1,2.2-2.2V2.2C24,1,23,0,21.8,0z M7.4,20.7 c0,0.3-0.3,0.6-0.6,0.6H4.1c-0.3,0-0.6-0.3-0.6-0.6V9.4c0-0.3,0.3-0.6,0.6-0.6h2.7c0.3,0,0.6,0.3,0.6,0.6V20.7z M5.5,7.8 C4,7.8,2.9,6.6,2.9,5.2S4,2.6,5.5,2.6S8,3.8,8,5.2S6.9,7.8,5.5,7.8z M21.5,20.8c0,0.3-0.3,0.6-0.6,0.6H18c-0.3,0-0.6-0.3-0.6-0.6 v-5.3c0-0.8,0.2-3.5-2.1-3.5c-1.8,0-2.1,1.8-2.2,2.6v6.1c0,0.3-0.3,0.6-0.6,0.6H9.8c-0.3,0-0.6-0.3-0.6-0.6V9.4 c0-0.3,0.3-0.6,0.6-0.6h2.8c0.3,0,0.6,0.3,0.6,0.6v1c0.7-1,1.6-1.8,3.7-1.8c4.6,0,4.6,4.3,4.6,6.7L21.5,20.8L21.5,20.8z"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "https://github.com/finopsfoundation",
                                        className: "h-[24px] social-link text-gray-700 hover:text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "GitHub"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                className: "h-6 w-6",
                                                fill: "currentColor",
                                                viewBox: "0 0 24 24",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    className: "hover",
                                                    fill: "#979FA6",
                                                    "fill-rule": "evenodd",
                                                    d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
                                                    "clip-rule": "evenodd"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: "https://www.youtube.com/channel/UCyl26lvnoySlGWlF5oNHvYA",
                                        className: "h-[24px] social-link top-[-4px] relative text-gray-700 hover:text-gray-600 -mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "YouTube"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                className: "h-10 w-10 mt-px",
                                                fill: "currentColor",
                                                viewBox: "0 0 512 512",
                                                "aria-hidden": "true",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        className: "hover",
                                                        fill: "#979FA6",
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "m427 169c-4-15-17-27-32-31-34-9-239-10-278 0-15 4-28 16-32 31-9 38-10 135 0 174 4 15 17 27 32 31 36 10 241 10 278 0 15-4 28-16 32-31 9-36 9-137 0-174"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        d: "m220 203v106l93-53",
                                                        fill: "#FFF"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "container px-4 mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pt-12 xl:pt-24 md:w-8/12 lg:w-7/12 xl:w-6/12",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "grid md:grid-cols-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-4 md:m-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-xs text-gray-400 font-normal m-0 mb-5",
                                                    children: "FinOps Foundation"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "m-0 plain-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/about/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "About"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/about/media/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Media Resources"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://github.com/finopsfoundation/tac/blob/master/charter.md",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Technical Charter"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://github.com/finopsfoundation/foundation/blob/main/03-code_of_conduct.md",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Code of Conduct"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-4 md:m-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-xs text-gray-400 font-normal  m-0 mb-5",
                                                    children: "Resources"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "m-0 plain-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/resources/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "FinOps Assets"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/community/events/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Events"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/community/finops-book",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "O\u2019Reilly FinOps Book"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "text-xs text-gray-400 font-normal  m-0 mb-5",
                                                    children: "Certification"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "m-0 plain-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://learn.finops.org/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "FinOps Certified Practitioner"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://learn.finops.org/path/finops-certified-professional",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "FinOps Certified Professional"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "m-0 mb-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                href: "https://finops.org/partner-certifications/",
                                                                className: "font-medium text-gray-400 hover:text-gray-800 text-md",
                                                                children: "Member Certification"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-12 pb-8 container mx-auto px-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-500 mb-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "text-gray-500 no-underline font-normal",
                                    href: "https://finops.org/introduction/how-to-use/",
                                    target: "_blank",
                                    rel: "license noopener noreferrer",
                                    children: "This work is licensed under Attribution 4.0 International"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-gray-500 mb-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "\xa9 ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("script", {
                                            children: "document.write(new Date().getFullYear())"
                                        }),
                                        " FinOps Foundation Project a Series of LF Projects, LLC."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-500 mb-2",
                                children: [
                                    "For web site terms of use, trademark policy and other project policies please see ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        className: "text-gray-500 no-underline font-normal",
                                        href: "https://lfprojects.org",
                                        children: "https://lfprojects.org"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    "For the technical charter of FinOps Project a Series of LF Projects, LLC, please see the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        className: "text-gray-500 no-underline font-normal",
                                        href: "https://github.com/finopsfoundation/tac/blob/master/charter.md",
                                        children: "Technical Charter"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


var $44f3a3b8f746079c$exports = {};
/*! algoliasearch-lite.umd.js | 4.24.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ !function(e, t) {
    $44f3a3b8f746079c$exports = t();
}($44f3a3b8f746079c$exports, function() {
    "use strict";
    function e(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function t(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function r(r) {
        for(var n = 1; n < arguments.length; n++){
            var o = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t(Object(o), !0).forEach(function(t) {
                e(r, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function(e) {
                Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
            });
        }
        return r;
    }
    function n(e, t) {
        if (null == e) return {};
        var r, n, o = function(e, t) {
            if (null == e) return {};
            var r, n, o = {}, a = Object.keys(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
            return o;
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
        return o;
    }
    function o(e, t) {
        return function(e) {
            if (Array.isArray(e)) return e;
        }(e) || function(e, t) {
            if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
            var r = [], n = !0, o = !1, a = void 0;
            try {
                for(var u, i = e[Symbol.iterator](); !(n = (u = i.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0);
            } catch (e) {
                o = !0, a = e;
            } finally{
                try {
                    n || null == i.return || i.return();
                } finally{
                    if (o) throw a;
                }
            }
            return r;
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
    }
    function a(e) {
        return function(e) {
            if (Array.isArray(e)) {
                for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                return r;
            }
        }(e) || function(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
    }
    function u(e) {
        var t, r = "algoliasearch-client-js-".concat(e.key), n = function() {
            return void 0 === t && (t = e.localStorage || window.localStorage), t;
        }, a = function() {
            return JSON.parse(n().getItem(r) || "{}");
        }, u = function(e) {
            n().setItem(r, JSON.stringify(e));
        }, i = function() {
            var t = e.timeToLive ? 1e3 * e.timeToLive : null, r = a(), n = Object.fromEntries(Object.entries(r).filter(function(e) {
                return void 0 !== o(e, 2)[1].timestamp;
            }));
            if (u(n), t) {
                var i = Object.fromEntries(Object.entries(n).filter(function(e) {
                    var r = o(e, 2)[1], n = (new Date).getTime();
                    return !(r.timestamp + t < n);
                }));
                u(i);
            }
        };
        return {
            get: function(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return Promise.resolve().then(function() {
                    i();
                    var t = JSON.stringify(e);
                    return a()[t];
                }).then(function(e) {
                    return Promise.all([
                        e ? e.value : t(),
                        void 0 !== e
                    ]);
                }).then(function(e) {
                    var t = o(e, 2), n = t[0], a = t[1];
                    return Promise.all([
                        n,
                        a || r.miss(n)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function(e, t) {
                return Promise.resolve().then(function() {
                    var o = a();
                    return o[JSON.stringify(e)] = {
                        timestamp: (new Date).getTime(),
                        value: t
                    }, n().setItem(r, JSON.stringify(o)), t;
                });
            },
            delete: function(e) {
                return Promise.resolve().then(function() {
                    var t = a();
                    delete t[JSON.stringify(e)], n().setItem(r, JSON.stringify(t));
                });
            },
            clear: function() {
                return Promise.resolve().then(function() {
                    n().removeItem(r);
                });
            }
        };
    }
    function i(e) {
        var t = a(e.caches), r = t.shift();
        return void 0 === r ? {
            get: function(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, n = t();
                return n.then(function(e) {
                    return Promise.all([
                        e,
                        r.miss(e)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function(e, t) {
                return Promise.resolve(t);
            },
            delete: function(e) {
                return Promise.resolve();
            },
            clear: function() {
                return Promise.resolve();
            }
        } : {
            get: function(e, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return r.get(e, n, o).catch(function() {
                    return i({
                        caches: t
                    }).get(e, n, o);
                });
            },
            set: function(e, n) {
                return r.set(e, n).catch(function() {
                    return i({
                        caches: t
                    }).set(e, n);
                });
            },
            delete: function(e) {
                return r.delete(e).catch(function() {
                    return i({
                        caches: t
                    }).delete(e);
                });
            },
            clear: function() {
                return r.clear().catch(function() {
                    return i({
                        caches: t
                    }).clear();
                });
            }
        };
    }
    function s() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            serializable: !0
        }, t = {};
        return {
            get: function(r, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, a = JSON.stringify(r);
                if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
                var u = n(), i = o && o.miss || function() {
                    return Promise.resolve();
                };
                return u.then(function(e) {
                    return i(e);
                }).then(function() {
                    return u;
                });
            },
            set: function(r, n) {
                return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
            },
            delete: function(e) {
                return delete t[JSON.stringify(e)], Promise.resolve();
            },
            clear: function() {
                return t = {}, Promise.resolve();
            }
        };
    }
    function c(e) {
        for(var t = e.length - 1; t > 0; t--){
            var r = Math.floor(Math.random() * (t + 1)), n = e[t];
            e[t] = e[r], e[r] = n;
        }
        return e;
    }
    function l(e, t) {
        return t ? (Object.keys(t).forEach(function(r) {
            e[r] = t[r](e);
        }), e) : e;
    }
    function f(e) {
        for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
        var o = 0;
        return e.replace(/%s/g, function() {
            return encodeURIComponent(r[o++]);
        });
    }
    var h = {
        WithinQueryParameters: 0,
        WithinHeaders: 1
    };
    function m(e, t) {
        var r = e || {}, n = r.data || {};
        return Object.keys(r).forEach(function(e) {
            -1 === [
                "timeout",
                "headers",
                "queryParameters",
                "data",
                "cacheable"
            ].indexOf(e) && (n[e] = r[e]);
        }), {
            data: Object.entries(n).length > 0 ? n : void 0,
            timeout: r.timeout || t,
            headers: r.headers || {},
            queryParameters: r.queryParameters || {},
            cacheable: r.cacheable
        };
    }
    var d = {
        Read: 1,
        Write: 2,
        Any: 3
    }, p = 1, v = 2, g = 3;
    function y(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
        return r(r({}, e), {}, {
            status: t,
            lastUpdate: Date.now()
        });
    }
    function b(e) {
        return "string" == typeof e ? {
            protocol: "https",
            url: e,
            accept: d.Any
        } : {
            protocol: e.protocol || "https",
            url: e.url,
            accept: e.accept || d.Any
        };
    }
    var O = "GET", P = "POST";
    function q(e, t) {
        return Promise.all(t.map(function(t) {
            return e.get(t, function() {
                return Promise.resolve(y(t));
            });
        })).then(function(e) {
            var r = e.filter(function(e) {
                return function(e) {
                    return e.status === p || Date.now() - e.lastUpdate > 12e4;
                }(e);
            }), n = e.filter(function(e) {
                return function(e) {
                    return e.status === g && Date.now() - e.lastUpdate <= 12e4;
                }(e);
            }), o = [].concat(a(r), a(n));
            return {
                getTimeout: function(e, t) {
                    return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t;
                },
                statelessHosts: o.length > 0 ? o.map(function(e) {
                    return b(e);
                }) : t
            };
        });
    }
    function j(e, t, n, o) {
        var u = [], i = function(e, t) {
            if (e.method === O || void 0 === e.data && void 0 === t.data) return;
            var n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
            return JSON.stringify(n);
        }(n, o), s = function(e, t) {
            var n = r(r({}, e.headers), t.headers), o = {};
            return Object.keys(n).forEach(function(e) {
                var t = n[e];
                o[e.toLowerCase()] = t;
            }), o;
        }(e, o), c = n.method, l = n.method !== O ? {} : r(r({}, n.data), o.data), f = r(r(r({
            "x-algolia-agent": e.userAgent.value
        }, e.queryParameters), l), o.queryParameters), h = 0, m = function t(r, a) {
            var l = r.pop();
            if (void 0 === l) throw {
                name: "RetryError",
                message: "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .",
                transporterStackTrace: A(u)
            };
            var m = {
                data: i,
                headers: s,
                method: c,
                url: S(l, n.path, f),
                connectTimeout: a(h, e.timeouts.connect),
                responseTimeout: a(h, o.timeout)
            }, d = function(e) {
                var t = {
                    request: m,
                    response: e,
                    host: l,
                    triesLeft: r.length
                };
                return u.push(t), t;
            }, p = {
                onSuccess: function(e) {
                    return function(e) {
                        try {
                            return JSON.parse(e.content);
                        } catch (t) {
                            throw function(e, t) {
                                return {
                                    name: "DeserializationError",
                                    message: e,
                                    response: t
                                };
                            }(t.message, e);
                        }
                    }(e);
                },
                onRetry: function(n) {
                    var o = d(n);
                    return n.isTimedOut && h++, Promise.all([
                        e.logger.info("Retryable failure", x(o)),
                        e.hostsCache.set(l, y(l, n.isTimedOut ? g : v))
                    ]).then(function() {
                        return t(r, a);
                    });
                },
                onFail: function(e) {
                    throw d(e), function(e, t) {
                        var r = e.content, n = e.status, o = r;
                        try {
                            o = JSON.parse(r).message;
                        } catch (e) {}
                        return function(e, t, r) {
                            return {
                                name: "ApiError",
                                message: e,
                                status: t,
                                transporterStackTrace: r
                            };
                        }(o, n, t);
                    }(e, A(u));
                }
            };
            return e.requester.send(m).then(function(e) {
                return function(e, t) {
                    return function(e) {
                        var t = e.status;
                        return e.isTimedOut || function(e) {
                            var t = e.isTimedOut, r = e.status;
                            return !t && 0 == ~~r;
                        }(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100);
                    }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e);
                }(e, p);
            });
        };
        return q(e.hostsCache, t).then(function(e) {
            return m(a(e.statelessHosts).reverse(), e.getTimeout);
        });
    }
    function w(e) {
        var t = {
            value: "Algolia for JavaScript (".concat(e, ")"),
            add: function(e) {
                var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
                return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t;
            }
        };
        return t;
    }
    function S(e, t, r) {
        var n = T(r), o = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
        return n.length && (o += "?".concat(n)), o;
    }
    function T(e) {
        return Object.keys(e).map(function(t) {
            var r;
            return f("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
        }).join("&");
    }
    function A(e) {
        return e.map(function(e) {
            return x(e);
        });
    }
    function x(e) {
        var t = e.request.headers["x-algolia-api-key"] ? {
            "x-algolia-api-key": "*****"
        } : {};
        return r(r({}, e), {}, {
            request: r(r({}, e.request), {}, {
                headers: r(r({}, e.request.headers), t)
            })
        });
    }
    var N = function(e) {
        var t = e.appId, n = function(e, t, r) {
            var n = {
                "x-algolia-api-key": r,
                "x-algolia-application-id": t
            };
            return {
                headers: function() {
                    return e === h.WithinHeaders ? n : {};
                },
                queryParameters: function() {
                    return e === h.WithinQueryParameters ? n : {};
                }
            };
        }(void 0 !== e.authMode ? e.authMode : h.WithinHeaders, t, e.apiKey), a = function(e) {
            var t = e.hostsCache, r = e.logger, n = e.requester, a = e.requestsCache, u = e.responsesCache, i = e.timeouts, s = e.userAgent, c = e.hosts, l = e.queryParameters, f = {
                hostsCache: t,
                logger: r,
                requester: n,
                requestsCache: a,
                responsesCache: u,
                timeouts: i,
                userAgent: s,
                headers: e.headers,
                queryParameters: l,
                hosts: c.map(function(e) {
                    return b(e);
                }),
                read: function(e, t) {
                    var r = m(t, f.timeouts.read), n = function() {
                        return j(f, f.hosts.filter(function(e) {
                            return 0 != (e.accept & d.Read);
                        }), e, r);
                    };
                    if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable)) return n();
                    var a = {
                        request: e,
                        mappedRequestOptions: r,
                        transporter: {
                            queryParameters: f.queryParameters,
                            headers: f.headers
                        }
                    };
                    return f.responsesCache.get(a, function() {
                        return f.requestsCache.get(a, function() {
                            return f.requestsCache.set(a, n()).then(function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    e
                                ]);
                            }, function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    Promise.reject(e)
                                ]);
                            }).then(function(e) {
                                var t = o(e, 2);
                                t[0];
                                return t[1];
                            });
                        });
                    }, {
                        miss: function(e) {
                            return f.responsesCache.set(a, e);
                        }
                    });
                },
                write: function(e, t) {
                    return j(f, f.hosts.filter(function(e) {
                        return 0 != (e.accept & d.Write);
                    }), e, m(t, f.timeouts.write));
                }
            };
            return f;
        }(r(r({
            hosts: [
                {
                    url: "".concat(t, "-dsn.algolia.net"),
                    accept: d.Read
                },
                {
                    url: "".concat(t, ".algolia.net"),
                    accept: d.Write
                }
            ].concat(c([
                {
                    url: "".concat(t, "-1.algolianet.com")
                },
                {
                    url: "".concat(t, "-2.algolianet.com")
                },
                {
                    url: "".concat(t, "-3.algolianet.com")
                }
            ]))
        }, e), {}, {
            headers: r(r(r({}, n.headers()), {
                "content-type": "application/x-www-form-urlencoded"
            }), e.headers),
            queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
        }));
        return l({
            transporter: a,
            appId: t,
            addAlgoliaAgent: function(e, t) {
                a.userAgent.add({
                    segment: e,
                    version: t
                });
            },
            clearCache: function() {
                return Promise.all([
                    a.requestsCache.clear(),
                    a.responsesCache.clear()
                ]).then(function() {});
            }
        }, e.methods);
    }, C = function(e) {
        return function(t, r) {
            return t.method === O ? e.transporter.read(t, r) : e.transporter.write(t, r);
        };
    }, E = function(e) {
        return function(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {
                transporter: e.transporter,
                appId: e.appId,
                indexName: t
            };
            return l(n, r.methods);
        };
    }, J = function(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    params: T(e.params || {})
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/queries",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    }, k = function(e) {
        return function(t, o) {
            return Promise.all(t.map(function(t) {
                var a = t.params, u = a.facetName, i = a.facetQuery, s = n(a, [
                    "facetName",
                    "facetQuery"
                ]);
                return E(e)(t.indexName, {
                    methods: {
                        searchForFacetValues: F
                    }
                }).searchForFacetValues(u, i, r(r({}, o), s));
            }));
        };
    }, I = function(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/answers/%s/prediction", e.indexName),
                data: {
                    query: t,
                    queryLanguages: r
                },
                cacheable: !0
            }, n);
        };
    }, R = function(e) {
        return function(t, r) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/query", e.indexName),
                data: {
                    query: t
                },
                cacheable: !0
            }, r);
        };
    }, F = function(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
                data: {
                    facetQuery: r
                },
                cacheable: !0
            }, n);
        };
    }, D = 1, W = 2, H = 3;
    var Q = function(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    threshold: e.threshold || 0
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/recommendations",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    };
    function L(e, t, n) {
        var o, a = {
            appId: e,
            apiKey: t,
            timeouts: {
                connect: 1,
                read: 2,
                write: 30
            },
            requester: {
                send: function(e) {
                    return new Promise(function(t) {
                        var r = new XMLHttpRequest;
                        r.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function(t) {
                            return r.setRequestHeader(t, e.headers[t]);
                        });
                        var n, o = function(e, n) {
                            return setTimeout(function() {
                                r.abort(), t({
                                    status: 0,
                                    content: n,
                                    isTimedOut: !0
                                });
                            }, 1e3 * e);
                        }, a = o(e.connectTimeout, "Connection timeout");
                        r.onreadystatechange = function() {
                            r.readyState > r.OPENED && void 0 === n && (clearTimeout(a), n = o(e.responseTimeout, "Socket timeout"));
                        }, r.onerror = function() {
                            0 === r.status && (clearTimeout(a), clearTimeout(n), t({
                                content: r.responseText || "Network request failed",
                                status: r.status,
                                isTimedOut: !1
                            }));
                        }, r.onload = function() {
                            clearTimeout(a), clearTimeout(n), t({
                                content: r.responseText,
                                status: r.status,
                                isTimedOut: !1
                            });
                        }, r.send(e.data);
                    });
                }
            },
            logger: (o = H, {
                debug: function(e, t) {
                    return D >= o && console.debug(e, t), Promise.resolve();
                },
                info: function(e, t) {
                    return W >= o && console.info(e, t), Promise.resolve();
                },
                error: function(e, t) {
                    return console.error(e, t), Promise.resolve();
                }
            }),
            responsesCache: s(),
            requestsCache: s({
                serializable: !1
            }),
            hostsCache: i({
                caches: [
                    u({
                        key: "".concat("4.24.0", "-").concat(e)
                    }),
                    s()
                ]
            }),
            userAgent: w("4.24.0").add({
                segment: "Browser",
                version: "lite"
            }),
            authMode: h.WithinQueryParameters
        };
        return N(r(r(r({}, a), n), {}, {
            methods: {
                search: J,
                searchForFacetValues: k,
                multipleQueries: J,
                multipleSearchForFacetValues: k,
                customRequest: C,
                initIndex: function(e) {
                    return function(t) {
                        return E(e)(t, {
                            methods: {
                                search: R,
                                searchForFacetValues: F,
                                findAnswers: I
                            }
                        });
                    };
                },
                getRecommendations: Q
            }
        }));
    }
    return L.version = "4.24.0", L;
});



var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");


var $2621fca0bea18d29$exports = {};
'use strict';
var $c131641798835750$exports = {};
'use strict';
var $dff42e9643699667$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $dff42e9643699667$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$dff42e9643699667$exports = $dff42e9643699667$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$dff42e9643699667$var$EventEmitter.prototype._events = undefined;
$dff42e9643699667$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$dff42e9643699667$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$dff42e9643699667$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$dff42e9643699667$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $dff42e9643699667$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($dff42e9643699667$var$isUndefined(handler)) return false;
    if ($dff42e9643699667$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($dff42e9643699667$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$dff42e9643699667$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$dff42e9643699667$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $dff42e9643699667$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($dff42e9643699667$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($dff42e9643699667$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$dff42e9643699667$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $dff42e9643699667$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.on = $dff42e9643699667$var$EventEmitter.prototype.addListener;
$dff42e9643699667$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$dff42e9643699667$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$dff42e9643699667$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$dff42e9643699667$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $dff42e9643699667$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($dff42e9643699667$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($dff42e9643699667$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($dff42e9643699667$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$dff42e9643699667$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($dff42e9643699667$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$dff42e9643699667$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $dff42e9643699667$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $dff42e9643699667$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $dff42e9643699667$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $dff42e9643699667$var$isUndefined(arg) {
    return arg === void 0;
}


var $601be386601458f9$exports = {};
'use strict';

var $0a80729110afa025$exports = {};
'use strict';
function $0a80729110afa025$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$0a80729110afa025$exports = $0a80729110afa025$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state
 */ function $601be386601458f9$var$DerivedHelper(mainHelper, fn) {
    this.main = mainHelper;
    this.fn = fn;
    this.lastResults = null;
}
$0a80729110afa025$exports($601be386601458f9$var$DerivedHelper, $dff42e9643699667$exports);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $601be386601458f9$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$601be386601458f9$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$601be386601458f9$exports = $601be386601458f9$var$DerivedHelper;


var $71300e2cf2e578b3$exports = {};
'use strict';
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $71300e2cf2e578b3$var$escapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $71300e2cf2e578b3$var$unescapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return value.replace(/^\\-/, '-');
}
$71300e2cf2e578b3$exports = {
    escapeFacetValue: $71300e2cf2e578b3$var$escapeFacetValue,
    unescapeFacetValue: $71300e2cf2e578b3$var$unescapeFacetValue
};


var $c131641798835750$require$escapeFacetValue = $71300e2cf2e578b3$exports.escapeFacetValue;

var $9502336ac3aed1e4$exports = {};
'use strict';
function $9502336ac3aed1e4$var$clone(value) {
    if (typeof value === 'object' && value !== null) return $9502336ac3aed1e4$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $9502336ac3aed1e4$var$isObjectOrArrayOrFunction(value) {
    return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}
function $9502336ac3aed1e4$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__' || key === 'constructor') continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') continue;
        if ($9502336ac3aed1e4$var$isObjectOrArrayOrFunction(targetVal) && $9502336ac3aed1e4$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $9502336ac3aed1e4$var$_merge(targetVal, sourceVal);
        else target[key] = $9502336ac3aed1e4$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $9502336ac3aed1e4$var$merge(target) {
    if (!$9502336ac3aed1e4$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($9502336ac3aed1e4$var$isObjectOrArrayOrFunction(source)) $9502336ac3aed1e4$var$_merge(target, source);
    }
    return target;
}
$9502336ac3aed1e4$exports = $9502336ac3aed1e4$var$merge;


var $cfa548e7659f4e9f$exports = {};
'use strict';
function $cfa548e7659f4e9f$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$cfa548e7659f4e9f$exports = $cfa548e7659f4e9f$var$objectHasKeys;


var $2178c71501384235$exports = {};
'use strict';
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $2178c71501384235$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$2178c71501384235$exports = $2178c71501384235$var$_objectWithoutPropertiesLoose;


var $a26d92fd1efb8e0d$exports = {};
'use strict';

function $a26d92fd1efb8e0d$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $a26d92fd1efb8e0d$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $a26d92fd1efb8e0d$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $a26d92fd1efb8e0d$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $a26d92fd1efb8e0d$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(':')[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
                    else params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($a26d92fd1efb8e0d$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $a26d92fd1efb8e0d$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $a26d92fd1efb8e0d$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $a26d92fd1efb8e0d$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets.indexOf('*') > -1 ? [
                '*'
            ] : facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $a26d92fd1efb8e0d$var$sortObject($9502336ac3aed1e4$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $a26d92fd1efb8e0d$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $a26d92fd1efb8e0d$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $a26d92fd1efb8e0d$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $a26d92fd1efb8e0d$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $a26d92fd1efb8e0d$var$sortObject($9502336ac3aed1e4$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(',');
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':' + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':-' + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.sort().forEach(function(facetValue) {
                orFilters.push(facetName + ':' + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ':' + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === 'number') searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $a26d92fd1efb8e0d$var$sortObject($9502336ac3aed1e4$exports({}, $a26d92fd1efb8e0d$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
$a26d92fd1efb8e0d$exports = $a26d92fd1efb8e0d$var$requestBuilder;


var $c4bce0c9191240d9$exports = {};
'use strict';
var $e559b438caa51bfb$exports = {};
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$e559b438caa51bfb$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $ca2c6606a95c2f7b$exports = {};
'use strict';
// @MAJOR can be replaced by native Array#find when we change support
$ca2c6606a95c2f7b$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};


var $5b157c0ff2ad7fc0$exports = {};
'use strict';
function $5b157c0ff2ad7fc0$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$5b157c0ff2ad7fc0$exports = $5b157c0ff2ad7fc0$var$intersection;





var $86564e7d3ef2e569$exports = {};
'use strict';
function $86564e7d3ef2e569$var$valToNumber(v) {
    if (typeof v === 'number') return v;
    else if (typeof v === 'string') return parseFloat(v);
    else if (Array.isArray(v)) return v.map($86564e7d3ef2e569$var$valToNumber);
    throw new Error('The value should be a number, a parsable string or an array of those.');
}
$86564e7d3ef2e569$exports = $86564e7d3ef2e569$var$valToNumber;


var $e5a76b9b071b078a$exports = {};
'use strict';
$e5a76b9b071b078a$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $3f850d57f0daaad2$exports = {};
'use strict';



var $3f850d57f0daaad2$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($3f850d57f0daaad2$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = '' + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $e559b438caa51bfb$exports({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $3f850d57f0daaad2$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = '' + value;
        return $3f850d57f0daaad2$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error('toggleRefinement should be used with a value');
        if ($3f850d57f0daaad2$var$lib.isRefined(refinementList, attribute, value)) return $3f850d57f0daaad2$var$lib.removeRefinement(refinementList, attribute, value);
        return $3f850d57f0daaad2$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$cfa548e7659f4e9f$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === 'string') return $2178c71501384235$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = '' + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$3f850d57f0daaad2$exports = $3f850d57f0daaad2$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $c4bce0c9191240d9$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $c4bce0c9191240d9$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $c4bce0c9191240d9$var$findArray(array, searchedValue) {
    return $ca2c6606a95c2f7b$exports(array, function(currentValue) {
        return $c4bce0c9191240d9$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $c4bce0c9191240d9$var$SearchParameters(newParameters) {
    var params = newParameters ? $c4bce0c9191240d9$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$e5a76b9b071b078a$exports(params.userToken)) // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $c4bce0c9191240d9$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $c4bce0c9191240d9$var$SearchParameters.PARAMETERS = Object.keys(new $c4bce0c9191240d9$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $c4bce0c9191240d9$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $c4bce0c9191240d9$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        'aroundPrecision',
        'aroundRadius',
        'getRankingInfo',
        'minWordSizefor2Typos',
        'minWordSizefor1Typo',
        'page',
        'maxValuesPerFacet',
        'distinct',
        'minimumAroundRadius',
        'hitsPerPage',
        'minProximity'
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === 'string') {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === 'string') return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === 'string') return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $9502336ac3aed1e4$exports({}, partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $c4bce0c9191240d9$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $c4bce0c9191240d9$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $c4bce0c9191240d9$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $cfa548e7659f4e9f$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($cfa548e7659f4e9f$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$c4bce0c9191240d9$var$SearchParameters.prototype = {
    constructor: $c4bce0c9191240d9$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $3f850d57f0daaad2$exports.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
            facetsExcludes: $3f850d57f0daaad2$exports.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
            disjunctiveFacetsRefinements: $3f850d57f0daaad2$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: $3f850d57f0daaad2$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $86564e7d3ef2e569$exports(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $9502336ac3aed1e4$exports({}, this.numericRefinements);
        mod[attribute] = $9502336ac3aed1e4$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $c4bce0c9191240d9$var$isEqualNumericRefinement(value.val, $86564e7d3ef2e569$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$cfa548e7659f4e9f$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === 'string') return $2178c71501384235$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, 'numeric');
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($3f850d57f0daaad2$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $3f850d57f0daaad2$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($3f850d57f0daaad2$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $3f850d57f0daaad2$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if ($3f850d57f0daaad2$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $3f850d57f0daaad2$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$3f850d57f0daaad2$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $3f850d57f0daaad2$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$3f850d57f0daaad2$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $3f850d57f0daaad2$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if (!$3f850d57f0daaad2$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $3f850d57f0daaad2$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsRefinements: $3f850d57f0daaad2$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsExcludes: $3f850d57f0daaad2$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $3f850d57f0daaad2$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $e559b438caa51bfb$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + ' is already refined.');
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $e559b438caa51bfb$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $e559b438caa51bfb$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $3f850d57f0daaad2$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $3f850d57f0daaad2$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $3f850d57f0daaad2$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $86564e7d3ef2e569$exports(value);
        var isAttributeValueDefined = $c4bce0c9191240d9$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $5b157c0ff2ad7fc0$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $5b157c0ff2ad7fc0$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        'index',
        'facets',
        'disjunctiveFacets',
        'facetsRefinements',
        'hierarchicalFacets',
        'facetsExcludes',
        'disjunctiveFacetsRefinements',
        'numericRefinements',
        'tagRefinements',
        'hierarchicalFacetsRefinements'
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $c4bce0c9191240d9$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $c4bce0c9191240d9$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $2178c71501384235$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            'isRefined:desc',
            'name:asc'
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || ' > ';
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === 'boolean') return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $ca2c6606a95c2f7b$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $c4bce0c9191240d9$exports = $c4bce0c9191240d9$var$SearchParameters;


var $8ab3966607d77b84$exports = {};
'use strict';
var $e2e2dca9584bb08b$exports = {};
'use strict';
$e2e2dca9584bb08b$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};





var $07664941672e18b6$exports = {};
'use strict';
// @MAJOR can be replaced by native Array#findIndex when we change support
$07664941672e18b6$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $0ccf2badc4dd1a49$exports = {};
'use strict';

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $0ccf2badc4dd1a49$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(':');
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(':');
        var matchingDefault = $ca2c6606a95c2f7b$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};



var $1a854a4d6e961755$exports = {};
'use strict';
function $1a854a4d6e961755$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $1a854a4d6e961755$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $1a854a4d6e961755$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === 'desc') return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$1a854a4d6e961755$exports = $1a854a4d6e961755$var$orderBy;


var $8ab3966607d77b84$var$escapeFacetValue = $71300e2cf2e578b3$exports.escapeFacetValue;
var $8ab3966607d77b84$var$unescapeFacetValue = $71300e2cf2e578b3$exports.unescapeFacetValue;
var $735d7df0be1ead43$exports = {};
'use strict';
$735d7df0be1ead43$exports = $735d7df0be1ead43$var$generateTrees;




var $735d7df0be1ead43$var$escapeFacetValue = $71300e2cf2e578b3$exports.escapeFacetValue;
var $735d7df0be1ead43$var$unescapeFacetValue = $71300e2cf2e578b3$exports.unescapeFacetValue;
function $735d7df0be1ead43$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $0ccf2badc4dd1a49$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $735d7df0be1ead43$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $735d7df0be1ead43$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $ca2c6606a95c2f7b$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $735d7df0be1ead43$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $1a854a4d6e961755$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $735d7df0be1ead43$var$format(facetCount, facetValue, hierarchicalSeparator, $735d7df0be1ead43$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $735d7df0be1ead43$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $735d7df0be1ead43$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $735d7df0be1ead43$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $8ab3966607d77b84$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $8ab3966607d77b84$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $8ab3966607d77b84$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $ca2c6606a95c2f7b$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
// eslint-disable-next-line valid-jsdoc
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $8ab3966607d77b84$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    Object.keys(options || {}).forEach(function(key) {
        self[key] = options[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $8ab3966607d77b84$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $8ab3966607d77b84$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $8ab3966607d77b84$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $07664941672e18b6$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $8ab3966607d77b84$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $8ab3966607d77b84$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $e2e2dca9584bb08b$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $07664941672e18b6$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $07664941672e18b6$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $9502336ac3aed1e4$exports({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $e559b438caa51bfb$exports({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $8ab3966607d77b84$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($8ab3966607d77b84$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $07664941672e18b6$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $07664941672e18b6$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                var defaultData = {};
                if (currentRefinement.length > 0) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $e559b438caa51bfb$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($735d7df0be1ead43$exports(state));
    /**
   * @type {Array}
   */ this.facets = $e2e2dca9584bb08b$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $e2e2dca9584bb08b$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $8ab3966607d77b84$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $ca2c6606a95c2f7b$exports(this.facets, predicate) || $ca2c6606a95c2f7b$exports(this.disjunctiveFacets, predicate) || $ca2c6606a95c2f7b$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $8ab3966607d77b84$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $ca2c6606a95c2f7b$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $8ab3966607d77b84$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $ca2c6606a95c2f7b$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $8ab3966607d77b84$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $ca2c6606a95c2f7b$exports(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $8ab3966607d77b84$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || '');
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, '');
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $8ab3966607d77b84$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $8ab3966607d77b84$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === currentRefinement[depth];
    if (item.data) item.data.forEach(function(child) {
        $8ab3966607d77b84$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $8ab3966607d77b84$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $8ab3966607d77b84$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $e559b438caa51bfb$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$8ab3966607d77b84$var$SearchResults.DEFAULT_SORT = [
    'isRefined:desc',
    'count:desc',
    'name:asc'
];
function $8ab3966607d77b84$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $8ab3966607d77b84$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === 'hidden') return orderedFacets;
    else if (sortRemainingBy === 'alpha') ordering = [
        [
            'path',
            'name'
        ],
        [
            'asc',
            'asc'
        ]
    ];
    else ordering = [
        [
            'count'
        ],
        [
            'desc'
        ]
    ];
    return orderedFacets.concat($1a854a4d6e961755$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $8ab3966607d77b84$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $8ab3966607d77b84$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $8ab3966607d77b84$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $e559b438caa51bfb$exports({}, opts, {
        sortBy: $8ab3966607d77b84$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $8ab3966607d77b84$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $8ab3966607d77b84$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $8ab3966607d77b84$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $0ccf2badc4dd1a49$exports(options.sortBy, $8ab3966607d77b84$var$SearchResults.DEFAULT_SORT);
            return $1a854a4d6e961755$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === 'function') return $8ab3966607d77b84$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $8ab3966607d77b84$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $8ab3966607d77b84$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $8ab3966607d77b84$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $8ab3966607d77b84$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $ca2c6606a95c2f7b$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $8ab3966607d77b84$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getRefinement(state, 'facet', attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getRefinement(state, 'exclude', attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: 'numeric',
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: 'tag',
            attributeName: '_tags',
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $8ab3966607d77b84$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $ca2c6606a95c2f7b$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $8ab3966607d77b84$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $ca2c6606a95c2f7b$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $ca2c6606a95c2f7b$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || '';
    return {
        type: 'hierarchical',
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$8ab3966607d77b84$exports = $8ab3966607d77b84$var$SearchResults;



var $4kbyH = parcelRequire("4kbyH");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 */ function $c131641798835750$var$AlgoliaSearchHelper(client, index, options) {
    if (typeof client.addAlgoliaAgent === 'function') client.addAlgoliaAgent('JS Helper (' + $4kbyH + ')');
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $c4bce0c9191240d9$exports.make(opts);
    this.lastResults = null;
    this._queryId = 0;
    this._lastQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
}
$0a80729110afa025$exports($c131641798835750$var$AlgoliaSearchHelper, $dff42e9643699667$exports);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$c131641798835750$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $a26d92fd1efb8e0d$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $a26d92fd1efb8e0d$exports._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit('searchOnce', {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(null, new $8ab3966607d77b84$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        return {
            content: new $8ab3966607d77b84$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] answers is no longer supported');
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $9502336ac3aed1e4$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $2178c71501384235$exports($a26d92fd1efb8e0d$exports._getHitsSearchParams(derivedState), [
            'attributesToSnippet',
            'hitsPerPage',
            'restrictSearchableAttributes',
            'snippetEllipsisText'
        ])
    });
    var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
    if (typeof this.client.initIndex !== 'function') throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== 'function') throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === 'function';
    var clientHasInitIndex = typeof this.client.initIndex === 'function';
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $a26d92fd1efb8e0d$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: 'facet',
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $c131641798835750$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $c131641798835750$var$setCurrentPage(page) {
    if (page < 0) throw new Error('Page requested below 0.');
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setCurrentPage = $c131641798835750$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setPage = $c131641798835750$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $c4bce0c9191240d9$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $c4bce0c9191240d9$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($cfa548e7659f4e9f$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $c131641798835750$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getCurrentPage = $c131641798835750$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getPage = $c131641798835750$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'conjunctive'
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'exclude'
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'disjunctive'
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: 'numeric'
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $a26d92fd1efb8e0d$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit('search', {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $a26d92fd1efb8e0d$exports._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit('result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $8ab3966607d77b84$exports(state, specificResults);
        helper.emit('result', {
            results: helper.lastResults,
            state: state
        });
    });
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};
$c131641798835750$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit('change', {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === 'function') newClient.addAlgoliaAgent('JS Helper (' + $4kbyH + ')');
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.derive = function(fn) {
    var derivedHelper = new $601be386601458f9$exports(this, fn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error('Derived helper already detached');
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $c131641798835750$exports = $c131641798835750$var$AlgoliaSearchHelper;




/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $2621fca0bea18d29$var$algoliasearchHelper(client, index, opts) {
    return new $c131641798835750$exports(client, index, opts);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $2621fca0bea18d29$var$algoliasearchHelper.version = (parcelRequire("4kbyH"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $2621fca0bea18d29$var$algoliasearchHelper.AlgoliaSearchHelper = $c131641798835750$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $2621fca0bea18d29$var$algoliasearchHelper.SearchParameters = $c4bce0c9191240d9$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $2621fca0bea18d29$var$algoliasearchHelper.SearchResults = $8ab3966607d77b84$exports;
$2621fca0bea18d29$exports = $2621fca0bea18d29$var$algoliasearchHelper;



var $acw62 = parcelRequire("acw62");
function $46b615ab92539291$export$2e2bcd8739ae039(initialState) {
    var state = initialState;
    var listeners = [];
    return {
        getState: function getState() {
            return state;
        },
        setState: function setState(nextState) {
            state = nextState;
            listeners.forEach(function(listener) {
                return listener();
            });
        },
        subscribe: function subscribe(listener) {
            listeners.push(listener);
            return function unsubscribe() {
                listeners.splice(listeners.indexOf(listener), 1);
            };
        }
    };
}



function $ed086dd51949d69a$export$2e2bcd8739ae039(onWidgetsUpdate) {
    var widgets = [];
    // Is an update scheduled?
    var scheduled = false;
    // The state manager's updates need to be batched since more than one
    // component can register or unregister widgets during the same tick.
    function scheduleUpdate() {
        if (scheduled) return;
        scheduled = true;
        (0, $f89bd5ce2595ad4c$export$260e5c0943f31606)(function() {
            scheduled = false;
            onWidgetsUpdate();
        });
    }
    return {
        registerWidget: function registerWidget(widget) {
            widgets.push(widget);
            scheduleUpdate();
            return function unregisterWidget() {
                widgets.splice(widgets.indexOf(widget), 1);
                scheduleUpdate();
            };
        },
        update: scheduleUpdate,
        getWidgets: function getWidgets() {
            return widgets;
        }
    };
}



var $8bee5ca35c2f43fb$export$daa7b3b51232683c = {
    highlightPreTag: "<ais-highlight-0000000000>",
    highlightPostTag: "</ais-highlight-0000000000>"
};
/**
 * Parses an highlighted attribute into an array of objects with the string value, and
 * a boolean that indicated if this part is highlighted.
 *
 * @param {string} preTag - string used to identify the start of an highlighted value
 * @param {string} postTag - string used to identify the end of an highlighted value
 * @param {string} highlightedValue - highlighted attribute as returned by Algolia highlight feature
 * @return {object[]} - An array of {value: string, isHighlighted: boolean}.
 */ function $8bee5ca35c2f43fb$var$parseHighlightedAttribute(_ref) {
    var preTag = _ref.preTag, postTag = _ref.postTag, _ref$highlightedValue = _ref.highlightedValue, highlightedValue = _ref$highlightedValue === void 0 ? '' : _ref$highlightedValue;
    var splitByPreTag = highlightedValue.split(preTag);
    var firstValue = splitByPreTag.shift();
    var elements = firstValue === '' ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    if (postTag === preTag) {
        var isHighlighted = true;
        splitByPreTag.forEach(function(split) {
            elements.push({
                value: split,
                isHighlighted: isHighlighted
            });
            isHighlighted = !isHighlighted;
        });
    } else splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(postTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== '') elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}
function $8bee5ca35c2f43fb$export$ce1b251d416ea443(_ref2) {
    var _ref2$preTag = _ref2.preTag, preTag = _ref2$preTag === void 0 ? '<em>' : _ref2$preTag, _ref2$postTag = _ref2.postTag, postTag = _ref2$postTag === void 0 ? '</em>' : _ref2$postTag, highlightProperty = _ref2.highlightProperty, attribute = _ref2.attribute, hit = _ref2.hit;
    if (!hit) throw new Error('`hit`, the matching record, must be provided');
    var highlightObject = (0, $f89bd5ce2595ad4c$export$d14846335956eefa)(hit[highlightProperty], attribute) || {};
    if (Array.isArray(highlightObject)) return highlightObject.map(function(item) {
        return $8bee5ca35c2f43fb$var$parseHighlightedAttribute({
            preTag: preTag,
            postTag: postTag,
            highlightedValue: item.value
        });
    });
    return $8bee5ca35c2f43fb$var$parseHighlightedAttribute({
        preTag: preTag,
        postTag: postTag,
        highlightedValue: highlightObject.value
    });
}



var $9e3c5fbe3b25bbee$export$2e2bcd8739ae039 = '6.40.4';


var $610e831f588413ff$var$_excluded = [
    "resultsFacetValues"
], $610e831f588413ff$var$_excluded2 = [
    "resultsFacetValues"
], $610e831f588413ff$var$_excluded3 = [
    "resultsFacetValues"
];
function $610e831f588413ff$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $610e831f588413ff$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $610e831f588413ff$var$_typeof(obj);
}
function $610e831f588413ff$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $610e831f588413ff$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $610e831f588413ff$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $610e831f588413ff$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $610e831f588413ff$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $610e831f588413ff$var$ownKeys(Object(source), !0).forEach(function(key) {
            $610e831f588413ff$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $610e831f588413ff$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $610e831f588413ff$var$_defineProperty(obj, key, value) {
    key = $610e831f588413ff$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $610e831f588413ff$var$_toPropertyKey(arg) {
    var key = $610e831f588413ff$var$_toPrimitive(arg, "string");
    return $610e831f588413ff$var$_typeof(key) === "symbol" ? key : String(key);
}
function $610e831f588413ff$var$_toPrimitive(input, hint) {
    if ($610e831f588413ff$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($610e831f588413ff$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $610e831f588413ff$var$addAlgoliaAgents(searchClient) {
    if (typeof searchClient.addAlgoliaAgent === 'function') {
        searchClient.addAlgoliaAgent("react (".concat((0, $acw62.version), ")"));
        searchClient.addAlgoliaAgent("react-instantsearch (".concat((0, $9e3c5fbe3b25bbee$export$2e2bcd8739ae039), ")"));
    }
}
var $610e831f588413ff$var$isMultiIndexContext = function isMultiIndexContext(widget) {
    return (0, $b555487d9d656607$export$e4d66c7d4e09a359)({
        ais: widget.props.contextValue,
        multiIndexContext: widget.props.indexContextValue
    });
};
var $610e831f588413ff$var$isTargetedIndexEqualIndex = function isTargetedIndexEqualIndex(widget, indexId) {
    return widget.props.indexContextValue.targetedIndex === indexId;
};
// Relying on the `indexId` is a bit brittle to detect the `Index` widget.
// Since it's a class we could rely on `instanceof` or similar. We never
// had an issue though. Works for now.
var $610e831f588413ff$var$isIndexWidget = function isIndexWidget(widget) {
    return Boolean(widget.props.indexId);
};
var $610e831f588413ff$var$isIndexWidgetEqualIndex = function isIndexWidgetEqualIndex(widget, indexId) {
    return widget.props.indexId === indexId;
};
var $610e831f588413ff$var$sortIndexWidgetsFirst = function sortIndexWidgetsFirst(firstWidget, secondWidget) {
    var isFirstWidgetIndex = $610e831f588413ff$var$isIndexWidget(firstWidget);
    var isSecondWidgetIndex = $610e831f588413ff$var$isIndexWidget(secondWidget);
    if (isFirstWidgetIndex && !isSecondWidgetIndex) return -1;
    if (!isFirstWidgetIndex && isSecondWidgetIndex) return 1;
    return 0;
};
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $610e831f588413ff$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]';
    };
    var encode = function encode(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode('%s=%s', key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join('&');
}
function $610e831f588413ff$export$2e2bcd8739ae039(_ref) {
    var indexName = _ref.indexName, _ref$initialState = _ref.initialState, initialState = _ref$initialState === void 0 ? {} : _ref$initialState, searchClient = _ref.searchClient, resultsState = _ref.resultsState, stalledSearchDelay = _ref.stalledSearchDelay;
    var helper = (0, (/*@__PURE__*/$parcel$interopDefault($2621fca0bea18d29$exports)))(searchClient, indexName, $610e831f588413ff$var$_objectSpread({}, (0, $8bee5ca35c2f43fb$export$daa7b3b51232683c)));
    $610e831f588413ff$var$addAlgoliaAgents(searchClient);
    helper.on('search', handleNewSearch).on('result', handleSearchSuccess({
        indexId: indexName
    })).on('error', handleSearchError);
    var skip = false;
    var stalledSearchTimer = null;
    var initialSearchParameters = helper.state;
    var searchCounter;
    var widgetsManager = (0, $ed086dd51949d69a$export$2e2bcd8739ae039)(onWidgetsUpdate);
    hydrateSearchClient(searchClient, resultsState);
    var store = (0, $46b615ab92539291$export$2e2bcd8739ae039)({
        widgets: initialState,
        metadata: $610e831f588413ff$var$hydrateMetadata(resultsState),
        results: hydrateResultsState(resultsState),
        error: null,
        searching: false,
        isSearchStalled: true,
        searchingForFacetValues: false
    });
    function skipSearch() {
        skip = true;
    }
    function updateClient(client) {
        $610e831f588413ff$var$addAlgoliaAgents(client);
        helper.setClient(client);
        search();
    }
    function clearCache() {
        helper.clearCache();
        search();
    }
    function getMetadata(state) {
        return widgetsManager.getWidgets().filter(function(widget) {
            return Boolean(widget.getMetadata);
        }).map(function(widget) {
            return widget.getMetadata(state);
        });
    }
    function getSearchParameters() {
        var sharedParameters = widgetsManager.getWidgets().filter(function(widget) {
            return Boolean(widget.getSearchParameters);
        }).filter(function(widget) {
            return !$610e831f588413ff$var$isMultiIndexContext(widget) && !$610e831f588413ff$var$isIndexWidget(widget);
        }).reduce(function(res, widget) {
            return widget.getSearchParameters(res);
        }, initialSearchParameters);
        var mainParameters = widgetsManager.getWidgets().filter(function(widget) {
            return Boolean(widget.getSearchParameters);
        }).filter(function(widget) {
            var targetedIndexEqualMainIndex = $610e831f588413ff$var$isMultiIndexContext(widget) && $610e831f588413ff$var$isTargetedIndexEqualIndex(widget, indexName);
            var subIndexEqualMainIndex = $610e831f588413ff$var$isIndexWidget(widget) && $610e831f588413ff$var$isIndexWidgetEqualIndex(widget, indexName);
            return targetedIndexEqualMainIndex || subIndexEqualMainIndex;
        })// We have to sort the `Index` widgets first so the `index` parameter
        // is correctly set in the `reduce` function for the following widgets
        .sort($610e831f588413ff$var$sortIndexWidgetsFirst).reduce(function(res, widget) {
            return widget.getSearchParameters(res);
        }, sharedParameters);
        var derivedIndices = widgetsManager.getWidgets().filter(function(widget) {
            return Boolean(widget.getSearchParameters);
        }).filter(function(widget) {
            var targetedIndexNotEqualMainIndex = $610e831f588413ff$var$isMultiIndexContext(widget) && !$610e831f588413ff$var$isTargetedIndexEqualIndex(widget, indexName);
            var subIndexNotEqualMainIndex = $610e831f588413ff$var$isIndexWidget(widget) && !$610e831f588413ff$var$isIndexWidgetEqualIndex(widget, indexName);
            return targetedIndexNotEqualMainIndex || subIndexNotEqualMainIndex;
        })// We have to sort the `Index` widgets first so the `index` parameter
        // is correctly set in the `reduce` function for the following widgets
        .sort($610e831f588413ff$var$sortIndexWidgetsFirst).reduce(function(indices, widget) {
            var indexId = $610e831f588413ff$var$isMultiIndexContext(widget) ? widget.props.indexContextValue.targetedIndex : widget.props.indexId;
            var widgets = indices[indexId] || [];
            return $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, indices), {}, $610e831f588413ff$var$_defineProperty({}, indexId, widgets.concat(widget)));
        }, {});
        var derivedParameters = Object.keys(derivedIndices).map(function(indexId) {
            return {
                parameters: derivedIndices[indexId].reduce(function(res, widget) {
                    return widget.getSearchParameters(res);
                }, sharedParameters),
                indexId: indexId
            };
        });
        return {
            mainParameters: mainParameters,
            derivedParameters: derivedParameters
        };
    }
    function search() {
        if (!skip) {
            var _getSearchParameters = getSearchParameters(helper.state), mainParameters = _getSearchParameters.mainParameters, derivedParameters = _getSearchParameters.derivedParameters;
            searchCounter = derivedParameters.length + 1;
            // We have to call `slice` because the method `detach` on the derived
            // helpers mutates the value `derivedHelpers`. The `forEach` loop does
            // not iterate on each value and we're not able to correctly clear the
            // previous derived helpers (memory leak + useless requests).
            helper.derivedHelpers.slice().forEach(function(derivedHelper) {
                // Since we detach the derived helpers on **every** new search they
                // won't receive intermediate results in case of a stalled search.
                // Only the last result is dispatched by the derived helper because
                // they are not detached yet:
                //
                // - a -> main helper receives results
                // - ap -> main helper receives results
                // - app -> main helper + derived helpers receive results
                //
                // The quick fix is to avoid to detach them on search but only once they
                // received the results. But it means that in case of a stalled search
                // all the derived helpers not detached yet register a new search inside
                // the helper. The number grows fast in case of a bad network and it's
                // not deterministic.
                derivedHelper.detach();
            });
            derivedParameters.forEach(function(_ref2) {
                var indexId = _ref2.indexId, parameters = _ref2.parameters;
                var derivedHelper = helper.derive(function() {
                    return parameters;
                });
                derivedHelper.on('result', handleSearchSuccess({
                    indexId: indexId
                })).on('error', handleSearchError);
            });
            helper.setState(mainParameters);
            helper.search();
        }
    }
    function handleSearchSuccess(_ref3) {
        var indexId = _ref3.indexId;
        return function(event) {
            searchCounter--;
            var state = store.getState();
            var isDerivedHelpersEmpty = !helper.derivedHelpers.length;
            var results = state.results ? state.results : {};
            // Switching from mono index to multi index and vice versa must reset the
            // results to an empty object, otherwise we keep reference of stalled and
            // unused results.
            results = !isDerivedHelpersEmpty && results.getFacetByName ? {} : results;
            if (!isDerivedHelpersEmpty) results = $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, results), {}, $610e831f588413ff$var$_defineProperty({}, indexId, event.results));
            else results = event.results;
            var currentState = store.getState();
            var nextIsSearchStalled = currentState.isSearchStalled;
            if (!helper.hasPendingRequests()) {
                clearTimeout(stalledSearchTimer);
                stalledSearchTimer = null;
                nextIsSearchStalled = false;
            }
            var resultsFacetValues = currentState.resultsFacetValues, partialState = $610e831f588413ff$var$_objectWithoutProperties(currentState, $610e831f588413ff$var$_excluded);
            store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, partialState), {}, {
                results: results,
                isSearchStalled: nextIsSearchStalled,
                searching: searchCounter > 0,
                error: null
            }));
        };
    }
    function handleSearchError(_ref4) {
        var error = _ref4.error;
        var currentState = store.getState();
        var nextIsSearchStalled = currentState.isSearchStalled;
        if (!helper.hasPendingRequests()) {
            clearTimeout(stalledSearchTimer);
            nextIsSearchStalled = false;
        }
        var resultsFacetValues = currentState.resultsFacetValues, partialState = $610e831f588413ff$var$_objectWithoutProperties(currentState, $610e831f588413ff$var$_excluded2);
        store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, partialState), {}, {
            isSearchStalled: nextIsSearchStalled,
            error: error,
            searching: false
        }));
    }
    function handleNewSearch() {
        if (!stalledSearchTimer) stalledSearchTimer = setTimeout(function() {
            var _store$getState = store.getState(), resultsFacetValues = _store$getState.resultsFacetValues, partialState = $610e831f588413ff$var$_objectWithoutProperties(_store$getState, $610e831f588413ff$var$_excluded3);
            store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, partialState), {}, {
                isSearchStalled: true
            }));
        }, stalledSearchDelay);
    }
    function hydrateSearchClient(client, results) {
        if (!results) return;
        // Disable cache hydration on:
        // - Algoliasearch API Client < v4 with cache disabled
        // - Third party clients (detected by the `addAlgoliaAgent` function missing)
        if ((!client.transporter || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== 'function')) return;
        // Algoliasearch API Client >= v4
        // To hydrate the client we need to populate the cache with the data from
        // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
        // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
        // for us to compute the key the same way as `algoliasearch-client` we need
        // to populate it on a custom key and override the `search` method to
        // search on it first.
        if (client.transporter && !client._cacheHydrated) {
            client._cacheHydrated = true;
            var baseMethod = client.search;
            client.search = function(requests) {
                for(var _len2 = arguments.length, methodArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)methodArgs[_key2 - 1] = arguments[_key2];
                var requestsWithSerializedParams = requests.map(function(request) {
                    return $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, request), {}, {
                        params: $610e831f588413ff$var$serializeQueryParameters(request.params)
                    });
                });
                return client.transporter.responsesCache.get({
                    method: 'search',
                    args: [
                        requestsWithSerializedParams
                    ].concat(methodArgs)
                }, function() {
                    return baseMethod.apply(void 0, [
                        requests
                    ].concat(methodArgs));
                });
            };
        }
        if (Array.isArray(results.results)) {
            hydrateSearchClientWithMultiIndexRequest(client, results.results);
            return;
        }
        hydrateSearchClientWithSingleIndexRequest(client, results);
    }
    function hydrateSearchClientWithMultiIndexRequest(client, results) {
        // Algoliasearch API Client >= v4
        // Populate the cache with the data from the server
        if (client.transporter) {
            client.transporter.responsesCache.set({
                method: 'search',
                args: [
                    results.reduce(function(acc, result) {
                        return acc.concat(result.rawResults.map(function(request) {
                            return {
                                indexName: request.index,
                                params: request.params
                            };
                        }));
                    }, [])
                ]
            }, {
                results: results.reduce(function(acc, result) {
                    return acc.concat(result.rawResults);
                }, [])
            });
            return;
        }
        // Algoliasearch API Client < v4
        // Prior to client v4 we didn't have a proper API to hydrate the client
        // cache from the outside. The following code populates the cache with
        // a single-index result. You can find more information about the
        // computation of the key inside the client (see link below).
        // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
        var key = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: results.reduce(function(acc, result) {
                return acc.concat(result.rawResults.map(function(request) {
                    return {
                        indexName: request.index,
                        params: request.params
                    };
                }));
            }, [])
        }));
        client.cache = $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, client.cache), {}, $610e831f588413ff$var$_defineProperty({}, key, JSON.stringify({
            results: results.reduce(function(acc, result) {
                return acc.concat(result.rawResults);
            }, [])
        })));
    }
    function hydrateSearchClientWithSingleIndexRequest(client, results) {
        // Algoliasearch API Client >= v4
        // Populate the cache with the data from the server
        if (client.transporter) {
            client.transporter.responsesCache.set({
                method: 'search',
                args: [
                    results.rawResults.map(function(request) {
                        return {
                            indexName: request.index,
                            params: request.params
                        };
                    })
                ]
            }, {
                results: results.rawResults
            });
            return;
        }
        // Algoliasearch API Client < v4
        // Prior to client v4 we didn't have a proper API to hydrate the client
        // cache from the outside. The following code populates the cache with
        // a single-index result. You can find more information about the
        // computation of the key inside the client (see link below).
        // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
        var key = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: results.rawResults.map(function(request) {
                return {
                    indexName: request.index,
                    params: request.params
                };
            })
        }));
        client.cache = $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, client.cache), {}, $610e831f588413ff$var$_defineProperty({}, key, JSON.stringify({
            results: results.rawResults
        })));
    }
    function hydrateResultsState(results) {
        if (!results) return null;
        if (Array.isArray(results.results)) return results.results.reduce(function(acc, result) {
            return $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, acc), {}, $610e831f588413ff$var$_defineProperty({}, result._internalIndexId, new (0, (/*@__PURE__*/$parcel$interopDefault($2621fca0bea18d29$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($2621fca0bea18d29$exports))).SearchParameters(result.state), result.rawResults)));
        }, {});
        return new (0, (/*@__PURE__*/$parcel$interopDefault($2621fca0bea18d29$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($2621fca0bea18d29$exports))).SearchParameters(results.state), results.rawResults);
    }
    // Called whenever a widget has been rendered with new props.
    function onWidgetsUpdate() {
        var metadata = getMetadata(store.getState().widgets);
        store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, store.getState()), {}, {
            metadata: metadata,
            searching: true
        }));
        // Since the `getSearchParameters` method of widgets also depends on props,
        // the result search parameters might have changed.
        search();
    }
    function transitionState(nextSearchState) {
        var searchState = store.getState().widgets;
        return widgetsManager.getWidgets().filter(function(widget) {
            return Boolean(widget.transitionState);
        }).reduce(function(res, widget) {
            return widget.transitionState(searchState, res);
        }, nextSearchState);
    }
    function onExternalStateUpdate(nextSearchState) {
        var metadata = getMetadata(nextSearchState);
        store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, store.getState()), {}, {
            widgets: nextSearchState,
            metadata: metadata,
            searching: true
        }));
        search();
    }
    function onSearchForFacetValues(_ref5) {
        var facetName = _ref5.facetName, query = _ref5.query, _ref5$maxFacetHits = _ref5.maxFacetHits, maxFacetHits = _ref5$maxFacetHits === void 0 ? 10 : _ref5$maxFacetHits;
        // The values 1, 100 are the min / max values that the engine accepts.
        // see: https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits
        var maxFacetHitsWithinRange = Math.max(1, Math.min(maxFacetHits, 100));
        store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, store.getState()), {}, {
            searchingForFacetValues: true
        }));
        helper.searchForFacetValues(facetName, query, maxFacetHitsWithinRange).then(function(content) {
            var _objectSpread7;
            store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, store.getState()), {}, {
                error: null,
                searchingForFacetValues: false,
                resultsFacetValues: $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, store.getState().resultsFacetValues), {}, (_objectSpread7 = {}, $610e831f588413ff$var$_defineProperty(_objectSpread7, facetName, content.facetHits), $610e831f588413ff$var$_defineProperty(_objectSpread7, "query", query), _objectSpread7))
            }));
        }, function(error) {
            store.setState($610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({}, store.getState()), {}, {
                searchingForFacetValues: false,
                error: error
            }));
        }).catch(function(error) {
            // Since setState is synchronous, any error that occurs in the render of a
            // component will be swallowed by this promise.
            // This is a trick to make the error show up correctly in the console.
            // See http://stackoverflow.com/a/30741722/969302
            setTimeout(function() {
                throw error;
            });
        });
    }
    function updateIndex(newIndex) {
        initialSearchParameters = initialSearchParameters.setIndex(newIndex);
    // No need to trigger a new search here as the widgets will also update and trigger it if needed.
    }
    function getWidgetsIds() {
        return store.getState().metadata.reduce(function(res, meta) {
            return typeof meta.id !== 'undefined' ? res.concat(meta.id) : res;
        }, []);
    }
    return {
        store: store,
        widgetsManager: widgetsManager,
        getWidgetsIds: getWidgetsIds,
        getSearchParameters: getSearchParameters,
        onSearchForFacetValues: onSearchForFacetValues,
        onExternalStateUpdate: onExternalStateUpdate,
        transitionState: transitionState,
        updateClient: updateClient,
        updateIndex: updateIndex,
        clearCache: clearCache,
        skipSearch: skipSearch
    };
}
function $610e831f588413ff$var$hydrateMetadata(resultsState) {
    if (!resultsState) return [];
    // add a value noop, which gets replaced once the widgets are mounted
    return resultsState.metadata.map(function(datum) {
        return $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({
            value: function value() {
                return {};
            }
        }, datum), {}, {
            items: datum.items && datum.items.map(function(item) {
                return $610e831f588413ff$var$_objectSpread($610e831f588413ff$var$_objectSpread({
                    value: function value() {
                        return {};
                    }
                }, item), {}, {
                    items: item.items && item.items.map(function(nestedItem) {
                        return $610e831f588413ff$var$_objectSpread({
                            value: function value() {
                                return {};
                            }
                        }, nestedItem);
                    })
                });
            })
        });
    });
}


function $203cc883a80cb72b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $203cc883a80cb72b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $203cc883a80cb72b$var$_typeof(obj);
}
function $203cc883a80cb72b$export$4b4254890acf93e7() {
    return (typeof window === "undefined" ? "undefined" : $203cc883a80cb72b$var$_typeof(window)) === 'object' && $203cc883a80cb72b$var$_typeof(window.navigator) === 'object' && typeof window.navigator.userAgent === 'string' && window.navigator.userAgent.includes('Algolia Crawler') && $203cc883a80cb72b$var$_typeof(window.document) === 'object';
}
function $203cc883a80cb72b$export$f709aa23d3ddcb1(widgets, searchClient) {
    var internalProps = [
        'contextValue',
        'indexContextValue'
    ];
    var widgetsPayload = widgets.map(function(_ref) {
        var props = _ref.props, constructor = _ref.constructor;
        var _ref2 = constructor._connectorDesc || {}, _ref2$defaultProps = _ref2.defaultProps, defaultProps = _ref2$defaultProps === void 0 ? {} : _ref2$defaultProps, _ref2$displayName = _ref2.displayName, displayName = _ref2$displayName === void 0 ? constructor.displayName : _ref2$displayName;
        return {
            displayName: displayName,
            $$type: constructor.$$type,
            $$widgetType: constructor.$$widgetType,
            params: Object.keys(props).filter(function(prop) {
                return !internalProps.includes(prop) && defaultProps[prop] !== props[prop] && props[prop] !== undefined;
            })
        };
    });
    var client = searchClient;
    var ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
    return {
        ua: ua,
        widgets: widgetsPayload
    };
}
function $203cc883a80cb72b$export$404feeb97c870f44(widgets, searchClient) {
    var payloadContainer = document.createElement('meta');
    var refNode = document.querySelector('head');
    payloadContainer.name = 'algolia:metadata';
    var payload = $203cc883a80cb72b$export$f709aa23d3ddcb1(widgets, searchClient);
    payloadContainer.content = JSON.stringify(payload);
    refNode.appendChild(payloadContainer);
}


function $8e5f7835a5ca2069$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8e5f7835a5ca2069$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8e5f7835a5ca2069$var$_typeof(obj);
}
function $8e5f7835a5ca2069$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8e5f7835a5ca2069$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8e5f7835a5ca2069$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8e5f7835a5ca2069$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8e5f7835a5ca2069$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8e5f7835a5ca2069$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8e5f7835a5ca2069$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8e5f7835a5ca2069$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8e5f7835a5ca2069$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8e5f7835a5ca2069$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8e5f7835a5ca2069$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8e5f7835a5ca2069$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8e5f7835a5ca2069$var$_setPrototypeOf(subClass, superClass);
}
function $8e5f7835a5ca2069$var$_setPrototypeOf(o, p) {
    $8e5f7835a5ca2069$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8e5f7835a5ca2069$var$_setPrototypeOf(o, p);
}
function $8e5f7835a5ca2069$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8e5f7835a5ca2069$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8e5f7835a5ca2069$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8e5f7835a5ca2069$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8e5f7835a5ca2069$var$_possibleConstructorReturn(this, result);
    };
}
function $8e5f7835a5ca2069$var$_possibleConstructorReturn(self, call) {
    if (call && ($8e5f7835a5ca2069$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8e5f7835a5ca2069$var$_assertThisInitialized(self);
}
function $8e5f7835a5ca2069$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8e5f7835a5ca2069$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8e5f7835a5ca2069$var$_getPrototypeOf(o) {
    $8e5f7835a5ca2069$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8e5f7835a5ca2069$var$_getPrototypeOf(o);
}
function $8e5f7835a5ca2069$var$_defineProperty(obj, key, value) {
    key = $8e5f7835a5ca2069$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8e5f7835a5ca2069$var$_toPropertyKey(arg) {
    var key = $8e5f7835a5ca2069$var$_toPrimitive(arg, "string");
    return $8e5f7835a5ca2069$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8e5f7835a5ca2069$var$_toPrimitive(input, hint) {
    if ($8e5f7835a5ca2069$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8e5f7835a5ca2069$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8e5f7835a5ca2069$var$isControlled(props) {
    return Boolean(props.searchState);
}
/**
 * @description
 * `<InstantSearch>` is the root component of all React InstantSearch implementations.
 * It provides all the connected components (aka widgets) a means to interact
 * with the searchState.
 * @kind widget
 * @name <InstantSearch>
 * @requirements You will need to have an Algolia account to be able to use this widget.
 * [Create one now](https://www.algolia.com/users/sign_up).
 * @propType {string} indexName - Main index in which to search.
 * @propType {boolean} [refresh=false] - Flag to activate when the cache needs to be cleared so that the front-end is updated when a change occurs in the index.
 * @propType {object} [searchClient] - Provide a custom search client.
 * @propType {func} [onSearchStateChange] - Function to be called everytime a new search is done. Useful for [URL Routing](guide/Routing.html).
 * @propType {object} [searchState] - Object to inject some search state. Switches the InstantSearch component in controlled mode. Useful for [URL Routing](guide/Routing.html).
 * @propType {func} [createURL] - Function to call when creating links, useful for [URL Routing](guide/Routing.html).
 * @propType {SearchResults|SearchResults[]} [resultsState] - Use this to inject the results that will be used at first rendering. Those results are found by using the `findResultsState` function. Useful for [Server Side Rendering](guide/Server-side_rendering.html).
 * @propType {number} [stalledSearchDelay=200] - The amount of time before considering that the search takes too much time. The time is expressed in milliseconds.
 * @propType {{ Root: string|function, props: object }} [root] - Use this to customize the root element. Default value: `{ Root: 'div' }`
 * @example
 * import React from 'react';
 * import algoliasearch from 'algoliasearch/lite';
 * import { InstantSearch, SearchBox, Hits } from 'react-instantsearch-dom';
 *
 * const searchClient = algoliasearch(
 *   'latency',
 *   '6be0576ff61c053d5f9a3225e2a90f76'
 * );
 *
 * const App = () => (
 *   <InstantSearch
 *     searchClient={searchClient}
 *     indexName="instant_search"
 *   >
 *     <SearchBox />
 *     <Hits />
 *   </InstantSearch>
 * );
 */ var $8e5f7835a5ca2069$var$InstantSearch = /*#__PURE__*/ function(_Component) {
    $8e5f7835a5ca2069$var$_inherits(InstantSearch, _Component);
    var _super = $8e5f7835a5ca2069$var$_createSuper(InstantSearch);
    function InstantSearch(props) {
        var _this;
        $8e5f7835a5ca2069$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this, props);
        $8e5f7835a5ca2069$var$_defineProperty($8e5f7835a5ca2069$var$_assertThisInitialized(_this), "cleanupTimerRef", null);
        $8e5f7835a5ca2069$var$_defineProperty($8e5f7835a5ca2069$var$_assertThisInitialized(_this), "isUnmounting", false);
        var instantSearchManager = (0, $610e831f588413ff$export$2e2bcd8739ae039)({
            indexName: _this.props.indexName,
            searchClient: _this.props.searchClient,
            initialState: _this.props.searchState || {},
            resultsState: _this.props.resultsState,
            stalledSearchDelay: _this.props.stalledSearchDelay
        });
        var contextValue = {
            store: instantSearchManager.store,
            widgetsManager: instantSearchManager.widgetsManager,
            mainTargetedIndex: _this.props.indexName,
            onInternalStateUpdate: _this.onWidgetsInternalStateUpdate.bind($8e5f7835a5ca2069$var$_assertThisInitialized(_this)),
            createHrefForState: _this.createHrefForState.bind($8e5f7835a5ca2069$var$_assertThisInitialized(_this)),
            onSearchForFacetValues: _this.onSearchForFacetValues.bind($8e5f7835a5ca2069$var$_assertThisInitialized(_this)),
            onSearchStateChange: _this.onSearchStateChange.bind($8e5f7835a5ca2069$var$_assertThisInitialized(_this)),
            onSearchParameters: _this.onSearchParameters.bind($8e5f7835a5ca2069$var$_assertThisInitialized(_this))
        };
        _this.state = {
            isControlled: $8e5f7835a5ca2069$var$isControlled(_this.props),
            instantSearchManager: instantSearchManager,
            contextValue: contextValue
        };
        return _this;
    }
    $8e5f7835a5ca2069$var$_createClass(InstantSearch, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var prevIsControlled = $8e5f7835a5ca2069$var$isControlled(prevProps);
                if (prevIsControlled && !this.state.isControlled) throw new Error("You can't switch <InstantSearch> from being controlled to uncontrolled");
                if (!prevIsControlled && this.state.isControlled) throw new Error("You can't switch <InstantSearch> from being uncontrolled to controlled");
                if (this.props.refresh !== prevProps.refresh && this.props.refresh) this.state.instantSearchManager.clearCache();
                if (prevProps.indexName !== this.props.indexName) this.state.instantSearchManager.updateIndex(this.props.indexName);
                if (prevProps.searchClient !== this.props.searchClient) this.state.instantSearchManager.updateClient(this.props.searchClient);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.cleanupTimerRef) {
                    clearTimeout(this.cleanupTimerRef);
                    this.cleanupTimerRef = null;
                }
                if ((0, $203cc883a80cb72b$export$4b4254890acf93e7)()) (0, $203cc883a80cb72b$export$404feeb97c870f44)(this.state.instantSearchManager.widgetsManager.getWidgets(), this.props.searchClient);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this2 = this;
                this.cleanupTimerRef = setTimeout(function() {
                    _this2.isUnmounting = true;
                    _this2.state.instantSearchManager.skipSearch();
                });
            }
        },
        {
            key: "createHrefForState",
            value: function createHrefForState(searchState) {
                searchState = this.state.instantSearchManager.transitionState(searchState);
                return this.state.isControlled && this.props.createURL ? this.props.createURL(searchState, this.getKnownKeys()) : '#';
            }
        },
        {
            key: "onWidgetsInternalStateUpdate",
            value: function onWidgetsInternalStateUpdate(searchState) {
                searchState = this.state.instantSearchManager.transitionState(searchState);
                this.onSearchStateChange(searchState);
                if (!this.state.isControlled) this.state.instantSearchManager.onExternalStateUpdate(searchState);
            }
        },
        {
            key: "onSearchStateChange",
            value: function onSearchStateChange(searchState) {
                if (this.props.onSearchStateChange && !this.isUnmounting) this.props.onSearchStateChange(searchState);
            }
        },
        {
            key: "onSearchParameters",
            value: function onSearchParameters(getSearchParameters, context, props, getMetadata, displayName) {
                if (this.props.onSearchParameters) {
                    var _searchState = this.props.searchState ? this.props.searchState : {};
                    this.props.onSearchParameters(getSearchParameters, context, props, _searchState);
                }
                if (this.props.widgetsCollector) {
                    var _searchState2 = this.props.searchState ? this.props.searchState : {};
                    this.props.widgetsCollector({
                        getSearchParameters: getSearchParameters,
                        getMetadata: getMetadata,
                        context: context,
                        props: props,
                        searchState: _searchState2,
                        displayName: displayName
                    });
                }
            }
        },
        {
            key: "onSearchForFacetValues",
            value: function onSearchForFacetValues(searchState) {
                this.state.instantSearchManager.onSearchForFacetValues(searchState);
            }
        },
        {
            key: "getKnownKeys",
            value: function getKnownKeys() {
                return this.state.instantSearchManager.getWidgetsIds();
            }
        },
        {
            key: "render",
            value: function render() {
                if ((0, $acw62.Children).count(this.props.children) === 0) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47b0e931f98d53f4$export$1d7b3f5181886950), {
                    value: this.state.contextValue
                }, this.props.children);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var nextIsControlled = $8e5f7835a5ca2069$var$isControlled(nextProps);
                var previousSearchState = prevState.instantSearchManager.store.getState().widgets;
                var nextSearchState = nextProps.searchState;
                if (nextIsControlled && !(0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(previousSearchState, nextSearchState)) prevState.instantSearchManager.onExternalStateUpdate(nextProps.searchState);
                return {
                    isControlled: nextIsControlled,
                    contextValue: $8e5f7835a5ca2069$var$_objectSpread($8e5f7835a5ca2069$var$_objectSpread({}, prevState.contextValue), {}, {
                        mainTargetedIndex: nextProps.indexName
                    })
                };
            }
        }
    ]);
    return InstantSearch;
}((0, $acw62.Component));
$8e5f7835a5ca2069$var$_defineProperty($8e5f7835a5ca2069$var$InstantSearch, "defaultProps", {
    stalledSearchDelay: 200,
    refresh: false
});
$8e5f7835a5ca2069$var$_defineProperty($8e5f7835a5ca2069$var$InstantSearch, "propTypes", {
    // @TODO: These props are currently constant.
    indexName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    searchClient: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        search: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        searchForFacetValues: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        addAlgoliaAgent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        clearCache: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }).isRequired,
    createURL: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    refresh: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    searchState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onSearchStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSearchParameters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    widgetsCollector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    resultsState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    stalledSearchDelay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
});
var $8e5f7835a5ca2069$export$2e2bcd8739ae039 = $8e5f7835a5ca2069$var$InstantSearch;


/**
 * react-router v7.2.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $acw62 = parcelRequire("acw62");
var $413e902c144ded2c$exports = {};
"use strict";
Object.defineProperty($413e902c144ded2c$exports, "__esModule", {
    value: true
});
$413e902c144ded2c$exports.encode = $413e902c144ded2c$exports.decode = void 0;
var $ae2d30592eda6ba7$exports = {};
"use strict";
Object.defineProperty($ae2d30592eda6ba7$exports, "__esModule", {
    value: true
});
$ae2d30592eda6ba7$exports.flatten = void 0;
var $e81dbde66bf3e10c$exports = {};
"use strict";
Object.defineProperty($e81dbde66bf3e10c$exports, "__esModule", {
    value: true
});
$e81dbde66bf3e10c$exports.createLineSplittingTransform = $e81dbde66bf3e10c$exports.Deferred = $e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED = $e81dbde66bf3e10c$exports.TYPE_URL = $e81dbde66bf3e10c$exports.TYPE_SYMBOL = $e81dbde66bf3e10c$exports.TYPE_SET = $e81dbde66bf3e10c$exports.TYPE_REGEXP = $e81dbde66bf3e10c$exports.TYPE_PROMISE = $e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT = $e81dbde66bf3e10c$exports.TYPE_MAP = $e81dbde66bf3e10c$exports.TYPE_ERROR = $e81dbde66bf3e10c$exports.TYPE_DATE = $e81dbde66bf3e10c$exports.TYPE_BIGINT = $e81dbde66bf3e10c$exports.UNDEFINED = $e81dbde66bf3e10c$exports.POSITIVE_INFINITY = $e81dbde66bf3e10c$exports.NULL = $e81dbde66bf3e10c$exports.NEGATIVE_ZERO = $e81dbde66bf3e10c$exports.NEGATIVE_INFINITY = $e81dbde66bf3e10c$exports.NAN = $e81dbde66bf3e10c$exports.HOLE = void 0;
$e81dbde66bf3e10c$exports.HOLE = -1;
$e81dbde66bf3e10c$exports.NAN = -2;
$e81dbde66bf3e10c$exports.NEGATIVE_INFINITY = -3;
$e81dbde66bf3e10c$exports.NEGATIVE_ZERO = -4;
$e81dbde66bf3e10c$exports.NULL = -5;
$e81dbde66bf3e10c$exports.POSITIVE_INFINITY = -6;
$e81dbde66bf3e10c$exports.UNDEFINED = -7;
$e81dbde66bf3e10c$exports.TYPE_BIGINT = "B";
$e81dbde66bf3e10c$exports.TYPE_DATE = "D";
$e81dbde66bf3e10c$exports.TYPE_ERROR = "E";
$e81dbde66bf3e10c$exports.TYPE_MAP = "M";
$e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT = "N";
$e81dbde66bf3e10c$exports.TYPE_PROMISE = "P";
$e81dbde66bf3e10c$exports.TYPE_REGEXP = "R";
$e81dbde66bf3e10c$exports.TYPE_SET = "S";
$e81dbde66bf3e10c$exports.TYPE_SYMBOL = "Y";
$e81dbde66bf3e10c$exports.TYPE_URL = "U";
$e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED = "Z";
class $e81dbde66bf3e10c$var$Deferred {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
$e81dbde66bf3e10c$exports.Deferred = $e81dbde66bf3e10c$var$Deferred;
function $e81dbde66bf3e10c$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            // The last part might be a partial line, so keep it for the next chunk.
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            // If there's any leftover data, enqueue it before closing.
            if (leftover) controller.enqueue(leftover);
        }
    });
}
$e81dbde66bf3e10c$exports.createLineSplittingTransform = $e81dbde66bf3e10c$var$createLineSplittingTransform;


function $ae2d30592eda6ba7$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === undefined) return $e81dbde66bf3e10c$exports.UNDEFINED;
    if (input === null) return $e81dbde66bf3e10c$exports.NULL;
    if (Number.isNaN(input)) return $e81dbde66bf3e10c$exports.NAN;
    if (input === Number.POSITIVE_INFINITY) return $e81dbde66bf3e10c$exports.POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $e81dbde66bf3e10c$exports.NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $e81dbde66bf3e10c$exports.NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $ae2d30592eda6ba7$var$stringify.call(this, input, index);
    return index;
}
$ae2d30592eda6ba7$exports.flatten = $ae2d30592eda6ba7$var$flatten;
function $ae2d30592eda6ba7$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$ae2d30592eda6ba7$var$flatten.call(this, k)}":${$ae2d30592eda6ba7$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$e81dbde66bf3e10c$exports.NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$ae2d30592eda6ba7$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? $ae2d30592eda6ba7$var$flatten.call(this, input[i]) : $e81dbde66bf3e10c$exports.HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_DATE}",${input.getTime()}]`;
                        else if (input instanceof URL) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_SET}",${[
                                ...input
                            ].map((val)=>$ae2d30592eda6ba7$var$flatten.call(this, val)).join(",")}]`;
                            else str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    $ae2d30592eda6ba7$var$flatten.call(this, k),
                                    $ae2d30592eda6ba7$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($ae2d30592eda6ba7$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$ae2d30592eda6ba7$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>$ae2d30592eda6ba7$var$flatten.call(this, v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $ae2d30592eda6ba7$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $ae2d30592eda6ba7$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $ae2d30592eda6ba7$var$objectProtoNames;
}


var $a0100cdae301b2b2$exports = {};
"use strict";
Object.defineProperty($a0100cdae301b2b2$exports, "__esModule", {
    value: true
});
$a0100cdae301b2b2$exports.unflatten = void 0;

const $a0100cdae301b2b2$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : undefined;
function $a0100cdae301b2b2$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $a0100cdae301b2b2$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $a0100cdae301b2b2$var$hydrate.call(this, startIndex);
}
$a0100cdae301b2b2$exports.unflatten = $a0100cdae301b2b2$var$unflatten;
function $a0100cdae301b2b2$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case $e81dbde66bf3e10c$exports.UNDEFINED:
                set(undefined);
                continue;
            case $e81dbde66bf3e10c$exports.NULL:
                set(null);
                continue;
            case $e81dbde66bf3e10c$exports.NAN:
                set(NaN);
                continue;
            case $e81dbde66bf3e10c$exports.POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $e81dbde66bf3e10c$exports.NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $e81dbde66bf3e10c$exports.NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $e81dbde66bf3e10c$exports.TYPE_DATE:
                        set(hydrated[index] = new Date(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_URL:
                        set(hydrated[index] = new URL(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_BIGINT:
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_REGEXP:
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_SYMBOL:
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_SET:
                        const newSet = new Set();
                        hydrated[index] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_MAP:
                        const map = new Map();
                        hydrated[index] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT:
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new $e81dbde66bf3e10c$exports.Deferred();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $a0100cdae301b2b2$var$globalObj && $a0100cdae301b2b2$var$globalObj[errorType] ? new $a0100cdae301b2b2$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        // Run plugins at the end so we have a chance to resolve primitives
                        // without running into a loop
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $e81dbde66bf3e10c$exports.HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}



async function $413e902c144ded2c$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $e81dbde66bf3e10c$exports.Deferred();
    const reader = readable.pipeThrough((0, $e81dbde66bf3e10c$exports.createLineSplittingTransform)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $413e902c144ded2c$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $413e902c144ded2c$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
$413e902c144ded2c$exports.decode = $413e902c144ded2c$var$decode;
async function $413e902c144ded2c$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $a0100cdae301b2b2$exports.unflatten.call(this, line)
    };
}
async function $413e902c144ded2c$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $e81dbde66bf3e10c$exports.TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $a0100cdae301b2b2$exports.unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $e81dbde66bf3e10c$exports.TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $a0100cdae301b2b2$exports.unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $413e902c144ded2c$var$encode(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $ae2d30592eda6ba7$exports.flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = $413e902c144ded2c$var$raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id = $ae2d30592eda6ba7$exports.flatten.call(encoder, resolved);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_PROMISE}${deferredId}:[["${$e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_PROMISE}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_PROMISE}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id = $ae2d30592eda6ba7$exports.flatten.call(encoder, reason);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_ERROR}${deferredId}:[["${$e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_ERROR}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_ERROR}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
$413e902c144ded2c$exports.encode = $413e902c144ded2c$var$encode;
function $413e902c144ded2c$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}


var $9fd38747d73cb940$exports = {};
"use strict";
Object.defineProperty($9fd38747d73cb940$exports, "__esModule", {
    value: true
});
$9fd38747d73cb940$exports.parse = $9fd38747d73cb940$var$parse;
$9fd38747d73cb940$exports.serialize = $9fd38747d73cb940$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $9fd38747d73cb940$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $9fd38747d73cb940$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $9fd38747d73cb940$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $9fd38747d73cb940$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $9fd38747d73cb940$var$__toString = Object.prototype.toString;
const $9fd38747d73cb940$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $9fd38747d73cb940$var$parse(str, options) {
    const obj = new $9fd38747d73cb940$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $9fd38747d73cb940$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $9fd38747d73cb940$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $9fd38747d73cb940$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $9fd38747d73cb940$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $9fd38747d73cb940$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $9fd38747d73cb940$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $9fd38747d73cb940$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $9fd38747d73cb940$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$9fd38747d73cb940$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$9fd38747d73cb940$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$9fd38747d73cb940$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$9fd38747d73cb940$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$9fd38747d73cb940$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $9fd38747d73cb940$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $9fd38747d73cb940$var$isDate(val) {
    return $9fd38747d73cb940$var$__toString.call(val) === "[object Date]";
}


var $e4a96bcce5e8f1ac$exports = {};
"use strict";
var $e4a96bcce5e8f1ac$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $e4a96bcce5e8f1ac$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $e4a96bcce5e8f1ac$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($e4a96bcce5e8f1ac$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $e4a96bcce5e8f1ac$var$parse(input, options) {
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).map(function(str) {
        return $e4a96bcce5e8f1ac$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $e4a96bcce5e8f1ac$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $e4a96bcce5e8f1ac$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$e4a96bcce5e8f1ac$exports = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parse = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parseString = $e4a96bcce5e8f1ac$var$parseString;
$e4a96bcce5e8f1ac$exports.splitCookiesString = $e4a96bcce5e8f1ac$var$splitCookiesString;


var $ad33ab710a499f5f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-HA7DTUK3.mjs"
});
var $ad33ab710a499f5f$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($ad33ab710a499f5f$export$e19cd5f9376f8cee || {});
var $ad33ab710a499f5f$var$PopStateEventType = "popstate";
function $ad33ab710a499f5f$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $ad33ab710a499f5f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $ad33ab710a499f5f$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $ad33ab710a499f5f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $ad33ab710a499f5f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $ad33ab710a499f5f$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $ad33ab710a499f5f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $ad33ab710a499f5f$export$fe53371bee54353d(to);
    }
    return $ad33ab710a499f5f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $ad33ab710a499f5f$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $ad33ab710a499f5f$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $ad33ab710a499f5f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href2 = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href2 = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href2 + "#" + (typeof to === "string" ? to : $ad33ab710a499f5f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $ad33ab710a499f5f$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $ad33ab710a499f5f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $ad33ab710a499f5f$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $ad33ab710a499f5f$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $ad33ab710a499f5f$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $ad33ab710a499f5f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $ad33ab710a499f5f$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $ad33ab710a499f5f$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $ad33ab710a499f5f$var$createKey()
    };
    return location;
}
function $ad33ab710a499f5f$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $ad33ab710a499f5f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $ad33ab710a499f5f$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $ad33ab710a499f5f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $ad33ab710a499f5f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $ad33ab710a499f5f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $ad33ab710a499f5f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href2 = typeof to === "string" ? to : $ad33ab710a499f5f$export$fe53371bee54353d(to);
        href2 = href2.replace(/ $/, "%20");
        $ad33ab710a499f5f$export$f5708dca728d7177(base, `No window.location.(origin|href) available to create URL for href: ${href2}`);
        return new URL(href2, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($ad33ab710a499f5f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($ad33ab710a499f5f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var $ad33ab710a499f5f$var$immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $ad33ab710a499f5f$var$isIndexRoute(route) {
    return route.index === true;
}
function $ad33ab710a499f5f$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $ad33ab710a499f5f$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $ad33ab710a499f5f$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($ad33ab710a499f5f$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $ad33ab710a499f5f$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $ad33ab710a499f5f$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $ad33ab710a499f5f$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $ad33ab710a499f5f$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $ad33ab710a499f5f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $ad33ab710a499f5f$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $ad33ab710a499f5f$var$flattenRoutes(routes);
    $ad33ab710a499f5f$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $ad33ab710a499f5f$var$decodePath(pathname);
        matches = $ad33ab710a499f5f$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $ad33ab710a499f5f$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $ad33ab710a499f5f$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $ad33ab710a499f5f$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $ad33ab710a499f5f$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $ad33ab710a499f5f$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $ad33ab710a499f5f$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $ad33ab710a499f5f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $ad33ab710a499f5f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $ad33ab710a499f5f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $ad33ab710a499f5f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $ad33ab710a499f5f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $ad33ab710a499f5f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $ad33ab710a499f5f$var$paramRe = /^:[\w-]+$/;
var $ad33ab710a499f5f$var$dynamicSegmentValue = 3;
var $ad33ab710a499f5f$var$indexRouteValue = 2;
var $ad33ab710a499f5f$var$emptySegmentValue = 1;
var $ad33ab710a499f5f$var$staticSegmentValue = 10;
var $ad33ab710a499f5f$var$splatPenalty = -2;
var $ad33ab710a499f5f$var$isSplat = (s)=>s === "*";
function $ad33ab710a499f5f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($ad33ab710a499f5f$var$isSplat)) initialScore += $ad33ab710a499f5f$var$splatPenalty;
    if (index) initialScore += $ad33ab710a499f5f$var$indexRouteValue;
    return segments.filter((s)=>!$ad33ab710a499f5f$var$isSplat(s)).reduce((score, segment)=>score + ($ad33ab710a499f5f$var$paramRe.test(segment) ? $ad33ab710a499f5f$var$dynamicSegmentValue : segment === "" ? $ad33ab710a499f5f$var$emptySegmentValue : $ad33ab710a499f5f$var$staticSegmentValue), initialScore);
}
function $ad33ab710a499f5f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $ad33ab710a499f5f$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $ad33ab710a499f5f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $ad33ab710a499f5f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $ad33ab710a499f5f$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $ad33ab710a499f5f$var$normalizePathname($ad33ab710a499f5f$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $ad33ab710a499f5f$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $ad33ab710a499f5f$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $ad33ab710a499f5f$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $ad33ab710a499f5f$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $ad33ab710a499f5f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $ad33ab710a499f5f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $ad33ab710a499f5f$var$compilePath(path, caseSensitive = false, end = true) {
    $ad33ab710a499f5f$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $ad33ab710a499f5f$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $ad33ab710a499f5f$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $ad33ab710a499f5f$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $ad33ab710a499f5f$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $ad33ab710a499f5f$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $ad33ab710a499f5f$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $ad33ab710a499f5f$var$normalizeSearch(search),
        hash: $ad33ab710a499f5f$var$normalizeHash(hash)
    };
}
function $ad33ab710a499f5f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $ad33ab710a499f5f$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $ad33ab710a499f5f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $ad33ab710a499f5f$var$getResolveToMatches(matches) {
    let pathMatches = $ad33ab710a499f5f$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $ad33ab710a499f5f$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $ad33ab710a499f5f$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $ad33ab710a499f5f$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $ad33ab710a499f5f$var$getInvalidPathError("?", "pathname", "search", to));
        $ad33ab710a499f5f$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $ad33ab710a499f5f$var$getInvalidPathError("#", "pathname", "hash", to));
        $ad33ab710a499f5f$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $ad33ab710a499f5f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $ad33ab710a499f5f$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $ad33ab710a499f5f$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $ad33ab710a499f5f$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $ad33ab710a499f5f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $ad33ab710a499f5f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $ad33ab710a499f5f$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $ad33ab710a499f5f$export$4051a07651545597(data2, init) {
    return new $ad33ab710a499f5f$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $ad33ab710a499f5f$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $ad33ab710a499f5f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $ad33ab710a499f5f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $ad33ab710a499f5f$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $ad33ab710a499f5f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $ad33ab710a499f5f$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $ad33ab710a499f5f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $ad33ab710a499f5f$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $ad33ab710a499f5f$var$validMutationMethods = new Set($ad33ab710a499f5f$var$validMutationMethodsArr);
var $ad33ab710a499f5f$var$validRequestMethodsArr = [
    "GET",
    ...$ad33ab710a499f5f$var$validMutationMethodsArr
];
var $ad33ab710a499f5f$var$validRequestMethods = new Set($ad33ab710a499f5f$var$validRequestMethodsArr);
var $ad33ab710a499f5f$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $ad33ab710a499f5f$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $ad33ab710a499f5f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $ad33ab710a499f5f$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $ad33ab710a499f5f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ad33ab710a499f5f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $ad33ab710a499f5f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $ad33ab710a499f5f$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $ad33ab710a499f5f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $ad33ab710a499f5f$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || $ad33ab710a499f5f$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $ad33ab710a499f5f$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $ad33ab710a499f5f$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $ad33ab710a499f5f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = $ad33ab710a499f5f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $ad33ab710a499f5f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) {
            initialMatchesIsFOW = true;
            initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$ad33ab710a499f5f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$ad33ab710a499f5f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $ad33ab710a499f5f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $ad33ab710a499f5f$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $ad33ab710a499f5f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $ad33ab710a499f5f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$ad33ab710a499f5f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $ad33ab710a499f5f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $ad33ab710a499f5f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $ad33ab710a499f5f$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $ad33ab710a499f5f$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $ad33ab710a499f5f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $ad33ab710a499f5f$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $ad33ab710a499f5f$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $ad33ab710a499f5f$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $ad33ab710a499f5f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $ad33ab710a499f5f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $ad33ab710a499f5f$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $ad33ab710a499f5f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $ad33ab710a499f5f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $ad33ab710a499f5f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $ad33ab710a499f5f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $ad33ab710a499f5f$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $ad33ab710a499f5f$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($ad33ab710a499f5f$var$isErrorResult(result) && $ad33ab710a499f5f$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $ad33ab710a499f5f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $ad33ab710a499f5f$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$ad33ab710a499f5f$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = $ad33ab710a499f5f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $ad33ab710a499f5f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $ad33ab710a499f5f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $ad33ab710a499f5f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($ad33ab710a499f5f$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $ad33ab710a499f5f$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($ad33ab710a499f5f$var$isErrorResult(result)) {
            let boundaryMatch = $ad33ab710a499f5f$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $ad33ab710a499f5f$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $ad33ab710a499f5f$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $ad33ab710a499f5f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $ad33ab710a499f5f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$ad33ab710a499f5f$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $ad33ab710a499f5f$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $ad33ab710a499f5f$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $ad33ab710a499f5f$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $ad33ab710a499f5f$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href2, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $ad33ab710a499f5f$var$normalizeTo(state.location, state.matches, basename, href2, routeId, opts?.relative);
        let matches = $ad33ab710a499f5f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $ad33ab710a499f5f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $ad33ab710a499f5f$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $ad33ab710a499f5f$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $ad33ab710a499f5f$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $ad33ab710a499f5f$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ad33ab710a499f5f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ad33ab710a499f5f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ad33ab710a499f5f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $ad33ab710a499f5f$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($ad33ab710a499f5f$var$isRedirectResult(actionResult) || $ad33ab710a499f5f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $ad33ab710a499f5f$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($ad33ab710a499f5f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $ad33ab710a499f5f$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $ad33ab710a499f5f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($ad33ab710a499f5f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $ad33ab710a499f5f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $ad33ab710a499f5f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $ad33ab710a499f5f$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $ad33ab710a499f5f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $ad33ab710a499f5f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $ad33ab710a499f5f$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = $ad33ab710a499f5f$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $ad33ab710a499f5f$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $ad33ab710a499f5f$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = $ad33ab710a499f5f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $ad33ab710a499f5f$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $ad33ab710a499f5f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ad33ab710a499f5f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ad33ab710a499f5f$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ad33ab710a499f5f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $ad33ab710a499f5f$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $ad33ab710a499f5f$var$getDoneFetcher(void 0));
            return;
        }
        if ($ad33ab710a499f5f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $ad33ab710a499f5f$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($ad33ab710a499f5f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $ad33ab710a499f5f$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $ad33ab710a499f5f$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $ad33ab710a499f5f$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $ad33ab710a499f5f$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $ad33ab710a499f5f$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $ad33ab710a499f5f$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($ad33ab710a499f5f$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $ad33ab710a499f5f$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $ad33ab710a499f5f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $ad33ab710a499f5f$var$callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($ad33ab710a499f5f$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $ad33ab710a499f5f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $ad33ab710a499f5f$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, $ad33ab710a499f5f$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $ad33ab710a499f5f$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $ad33ab710a499f5f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $ad33ab710a499f5f$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $ad33ab710a499f5f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $ad33ab710a499f5f$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $ad33ab710a499f5f$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $ad33ab710a499f5f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $ad33ab710a499f5f$export$386d57f03f0b2883;
        $ad33ab710a499f5f$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $ad33ab710a499f5f$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $ad33ab710a499f5f$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $ad33ab710a499f5f$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $ad33ab710a499f5f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$ad33ab710a499f5f$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $ad33ab710a499f5f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $ad33ab710a499f5f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $ad33ab710a499f5f$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $ad33ab710a499f5f$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $ad33ab710a499f5f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $ad33ab710a499f5f$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $ad33ab710a499f5f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $ad33ab710a499f5f$var$createStaticHandler(routes, opts) {
    $ad33ab710a499f5f$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $ad33ab710a499f5f$var$defaultMapRouteProperties;
    let dataRoutes = $ad33ab710a499f5f$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $ad33ab710a499f5f$var$createLocation("", $ad33ab710a499f5f$export$fe53371bee54353d(url), null, "default");
        let matches = $ad33ab710a499f5f$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$ad33ab710a499f5f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $ad33ab710a499f5f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $ad33ab710a499f5f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $ad33ab710a499f5f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ad33ab710a499f5f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($ad33ab710a499f5f$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $ad33ab710a499f5f$var$createLocation("", $ad33ab710a499f5f$export$fe53371bee54353d(url), null, "default");
        let matches = $ad33ab710a499f5f$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$ad33ab710a499f5f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $ad33ab710a499f5f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $ad33ab710a499f5f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $ad33ab710a499f5f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $ad33ab710a499f5f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $ad33ab710a499f5f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($ad33ab710a499f5f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $ad33ab710a499f5f$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($ad33ab710a499f5f$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $ad33ab710a499f5f$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $ad33ab710a499f5f$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($ad33ab710a499f5f$var$isDataStrategyResult(e) && $ad33ab710a499f5f$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($ad33ab710a499f5f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $ad33ab710a499f5f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $ad33ab710a499f5f$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($ad33ab710a499f5f$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($ad33ab710a499f5f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($ad33ab710a499f5f$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $ad33ab710a499f5f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: $ad33ab710a499f5f$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $ad33ab710a499f5f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1]) ? $ad33ab710a499f5f$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $ad33ab710a499f5f$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = $ad33ab710a499f5f$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches: matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $ad33ab710a499f5f$var$callDataStrategyImpl(dataStrategy || $ad33ab710a499f5f$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($ad33ab710a499f5f$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $ad33ab710a499f5f$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($ad33ab710a499f5f$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $ad33ab710a499f5f$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $ad33ab710a499f5f$var$getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: $ad33ab710a499f5f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function $ad33ab710a499f5f$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $ad33ab710a499f5f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $ad33ab710a499f5f$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $ad33ab710a499f5f$var$resolveTo(to ? to : ".", $ad33ab710a499f5f$var$getResolveToMatches(contextualMatches), $ad33ab710a499f5f$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $ad33ab710a499f5f$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $ad33ab710a499f5f$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $ad33ab710a499f5f$export$fe53371bee54353d(path);
}
function $ad33ab710a499f5f$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$ad33ab710a499f5f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$ad33ab710a499f5f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $ad33ab710a499f5f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $ad33ab710a499f5f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $ad33ab710a499f5f$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$ad33ab710a499f5f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$ad33ab710a499f5f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $ad33ab710a499f5f$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $ad33ab710a499f5f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $ad33ab710a499f5f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $ad33ab710a499f5f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $ad33ab710a499f5f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($ad33ab710a499f5f$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $ad33ab710a499f5f$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $ad33ab710a499f5f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $ad33ab710a499f5f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $ad33ab710a499f5f$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $ad33ab710a499f5f$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = $ad33ab710a499f5f$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1])) boundaryMatches = $ad33ab710a499f5f$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return $ad33ab710a499f5f$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if ($ad33ab710a499f5f$var$isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $ad33ab710a499f5f$var$shouldRevalidateLoader(match, {
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $ad33ab710a499f5f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $ad33ab710a499f5f$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $ad33ab710a499f5f$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = $ad33ab710a499f5f$var$shouldRevalidateLoader(fetcherMatch, {
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $ad33ab710a499f5f$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $ad33ab710a499f5f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $ad33ab710a499f5f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $ad33ab710a499f5f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $ad33ab710a499f5f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $ad33ab710a499f5f$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$ad33ab710a499f5f$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $ad33ab710a499f5f$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $ad33ab710a499f5f$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$ad33ab710a499f5f$var$isSameRoute(aChild, bChild)));
}
async function $ad33ab710a499f5f$var$loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $ad33ab710a499f5f$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $ad33ab710a499f5f$var$warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !$ad33ab710a499f5f$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function $ad33ab710a499f5f$var$defaultDataStrategy({ matches: matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $ad33ab710a499f5f$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $ad33ab710a499f5f$var$loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $ad33ab710a499f5f$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad: shouldLoad,
            resolve: resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function $ad33ab710a499f5f$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $ad33ab710a499f5f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $ad33ab710a499f5f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $ad33ab710a499f5f$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($ad33ab710a499f5f$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $ad33ab710a499f5f$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($ad33ab710a499f5f$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $ad33ab710a499f5f$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $ad33ab710a499f5f$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $ad33ab710a499f5f$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($ad33ab710a499f5f$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $ad33ab710a499f5f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $ad33ab710a499f5f$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $ad33ab710a499f5f$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $ad33ab710a499f5f$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $ad33ab710a499f5f$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $ad33ab710a499f5f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($ad33ab710a499f5f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $ad33ab710a499f5f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $ad33ab710a499f5f$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $ad33ab710a499f5f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $ad33ab710a499f5f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $ad33ab710a499f5f$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $ad33ab710a499f5f$export$f5708dca728d7177(!$ad33ab710a499f5f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($ad33ab710a499f5f$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $ad33ab710a499f5f$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $ad33ab710a499f5f$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $ad33ab710a499f5f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $ad33ab710a499f5f$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $ad33ab710a499f5f$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $ad33ab710a499f5f$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($ad33ab710a499f5f$var$isErrorResult(result)) {
            let boundaryMatch = $ad33ab710a499f5f$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($ad33ab710a499f5f$var$isRedirectResult(result)) $ad33ab710a499f5f$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $ad33ab710a499f5f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $ad33ab710a499f5f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $ad33ab710a499f5f$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $ad33ab710a499f5f$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $ad33ab710a499f5f$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $ad33ab710a499f5f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $ad33ab710a499f5f$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $ad33ab710a499f5f$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $ad33ab710a499f5f$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $ad33ab710a499f5f$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($ad33ab710a499f5f$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $ad33ab710a499f5f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $ad33ab710a499f5f$export$8ccf933b0513f8d0(path) : path;
    return $ad33ab710a499f5f$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $ad33ab710a499f5f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $ad33ab710a499f5f$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $ad33ab710a499f5f$var$isRedirectDataStrategyResult(result) {
    return $ad33ab710a499f5f$var$isResponse(result.result) && $ad33ab710a499f5f$var$redirectStatusCodes.has(result.result.status);
}
function $ad33ab710a499f5f$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $ad33ab710a499f5f$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $ad33ab710a499f5f$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $ad33ab710a499f5f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $ad33ab710a499f5f$var$isRedirectStatusCode(statusCode) {
    return $ad33ab710a499f5f$var$redirectStatusCodes.has(statusCode);
}
function $ad33ab710a499f5f$var$isRedirectResponse(result) {
    return $ad33ab710a499f5f$var$isResponse(result) && $ad33ab710a499f5f$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $ad33ab710a499f5f$var$isValidMethod(method) {
    return $ad33ab710a499f5f$var$validRequestMethods.has(method.toUpperCase());
}
function $ad33ab710a499f5f$var$isMutationMethod(method) {
    return $ad33ab710a499f5f$var$validMutationMethods.has(method.toUpperCase());
}
function $ad33ab710a499f5f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $ad33ab710a499f5f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $ad33ab710a499f5f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $ad33ab710a499f5f$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $ad33ab710a499f5f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $ad33ab710a499f5f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $ad33ab710a499f5f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $ad33ab710a499f5f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $ad33ab710a499f5f$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $ad33ab710a499f5f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $ad33ab710a499f5f$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $ad33ab710a499f5f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($ad33ab710a499f5f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $ad33ab710a499f5f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($ad33ab710a499f5f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $ad33ab710a499f5f$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $ad33ab710a499f5f$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $ad33ab710a499f5f$export$2eeee58951ff3c1c = $acw62.createContext(null);
$ad33ab710a499f5f$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $ad33ab710a499f5f$export$315e3ffb01f217 = $acw62.createContext(null);
$ad33ab710a499f5f$export$315e3ffb01f217.displayName = "DataRouterState";
var $ad33ab710a499f5f$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$ad33ab710a499f5f$export$3681f408decb40d1.displayName = "ViewTransition";
var $ad33ab710a499f5f$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$ad33ab710a499f5f$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $ad33ab710a499f5f$var$AwaitContext = $acw62.createContext(null);
$ad33ab710a499f5f$var$AwaitContext.displayName = "Await";
var $ad33ab710a499f5f$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$ad33ab710a499f5f$export$3044ab7fdabeaee6.displayName = "Navigation";
var $ad33ab710a499f5f$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$ad33ab710a499f5f$export$e6a44b110a0c44d3.displayName = "Location";
var $ad33ab710a499f5f$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$ad33ab710a499f5f$export$aac280ed165a4397.displayName = "Route";
var $ad33ab710a499f5f$var$RouteErrorContext = $acw62.createContext(null);
$ad33ab710a499f5f$var$RouteErrorContext.displayName = "RouteError";
var $ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS = true;
function $ad33ab710a499f5f$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $ad33ab710a499f5f$export$f5708dca728d7177($ad33ab710a499f5f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator2 } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $ad33ab710a499f5f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $ad33ab710a499f5f$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $ad33ab710a499f5f$export$9c954a9d03d32f4a() {
    return $acw62.useContext($ad33ab710a499f5f$export$e6a44b110a0c44d3) != null;
}
function $ad33ab710a499f5f$export$45d76561a5302f2b() {
    $ad33ab710a499f5f$export$f5708dca728d7177($ad33ab710a499f5f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($ad33ab710a499f5f$export$e6a44b110a0c44d3).location;
}
function $ad33ab710a499f5f$export$1b3f31771c5d07c() {
    return $acw62.useContext($ad33ab710a499f5f$export$e6a44b110a0c44d3).navigationType;
}
function $ad33ab710a499f5f$export$6c330e8992e8a295(pattern) {
    $ad33ab710a499f5f$export$f5708dca728d7177($ad33ab710a499f5f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $ad33ab710a499f5f$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$ad33ab710a499f5f$export$81336c211d5ff295(pattern, $ad33ab710a499f5f$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $ad33ab710a499f5f$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $ad33ab710a499f5f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $ad33ab710a499f5f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    return isDataRoute ? $ad33ab710a499f5f$var$useNavigateStable() : $ad33ab710a499f5f$var$useNavigateUnstable();
}
function $ad33ab710a499f5f$var$useNavigateUnstable() {
    $ad33ab710a499f5f$export$f5708dca728d7177($ad33ab710a499f5f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($ad33ab710a499f5f$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator2 } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($ad33ab710a499f5f$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $ad33ab710a499f5f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $ad33ab710a499f5f$var$warning(activeRef.current, $ad33ab710a499f5f$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = $ad33ab710a499f5f$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $ad33ab710a499f5f$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $ad33ab710a499f5f$var$OutletContext = $acw62.createContext(null);
function $ad33ab710a499f5f$export$4138103a3ae699cc() {
    return $acw62.useContext($ad33ab710a499f5f$var$OutletContext);
}
function $ad33ab710a499f5f$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $ad33ab710a499f5f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $ad33ab710a499f5f$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($ad33ab710a499f5f$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$ad33ab710a499f5f$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $ad33ab710a499f5f$export$5d3fca4a98652595(routes, locationArg) {
    return $ad33ab710a499f5f$var$useRoutesImpl(routes, locationArg);
}
function $ad33ab710a499f5f$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $ad33ab710a499f5f$export$f5708dca728d7177($ad33ab710a499f5f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2, static: isStatic } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $ad33ab710a499f5f$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $ad33ab710a499f5f$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $ad33ab710a499f5f$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : $ad33ab710a499f5f$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS) {
        $ad33ab710a499f5f$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $ad33ab710a499f5f$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $ad33ab710a499f5f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $ad33ab710a499f5f$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $ad33ab710a499f5f$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $ad33ab710a499f5f$var$DefaultErrorComponent() {
    let error = $ad33ab710a499f5f$export$ed527bf60f6e05f2();
    let message = $ad33ab710a499f5f$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $ad33ab710a499f5f$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$DefaultErrorComponent, null);
var $ad33ab710a499f5f$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $ad33ab710a499f5f$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($ad33ab710a499f5f$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $ad33ab710a499f5f$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $ad33ab710a499f5f$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $ad33ab710a499f5f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $ad33ab710a499f5f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $ad33ab710a499f5f$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $ad33ab710a499f5f$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($ad33ab710a499f5f$export$2eeee58951ff3c1c);
    $ad33ab710a499f5f$export$f5708dca728d7177(ctx, $ad33ab710a499f5f$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $ad33ab710a499f5f$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($ad33ab710a499f5f$export$315e3ffb01f217);
    $ad33ab710a499f5f$export$f5708dca728d7177(state, $ad33ab710a499f5f$var$getDataRouterConsoleError(hookName));
    return state;
}
function $ad33ab710a499f5f$var$useRouteContext(hookName) {
    let route = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    $ad33ab710a499f5f$export$f5708dca728d7177(route, $ad33ab710a499f5f$var$getDataRouterConsoleError(hookName));
    return route;
}
function $ad33ab710a499f5f$var$useCurrentRouteId(hookName) {
    let route = $ad33ab710a499f5f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $ad33ab710a499f5f$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $ad33ab710a499f5f$var$useRouteId() {
    return $ad33ab710a499f5f$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $ad33ab710a499f5f$export$d0fd4b7106de2769() {
    let state = $ad33ab710a499f5f$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $ad33ab710a499f5f$export$600dc272ed516c15() {
    let dataRouterContext = $ad33ab710a499f5f$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $ad33ab710a499f5f$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $acw62.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function $ad33ab710a499f5f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $ad33ab710a499f5f$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$ad33ab710a499f5f$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $ad33ab710a499f5f$export$1448a5050d252c4d() {
    let state = $ad33ab710a499f5f$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $ad33ab710a499f5f$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $ad33ab710a499f5f$export$fd5d37484eab868d(routeId) {
    let state = $ad33ab710a499f5f$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $ad33ab710a499f5f$export$fdc00f3f26066d5e() {
    let state = $ad33ab710a499f5f$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $ad33ab710a499f5f$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $ad33ab710a499f5f$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($ad33ab710a499f5f$var$RouteErrorContext);
    let state = $ad33ab710a499f5f$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $ad33ab710a499f5f$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $ad33ab710a499f5f$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($ad33ab710a499f5f$var$AwaitContext);
    return value?._data;
}
function $ad33ab710a499f5f$export$17f53340677d5831() {
    let value = $acw62.useContext($ad33ab710a499f5f$var$AwaitContext);
    return value?._error;
}
var $ad33ab710a499f5f$var$blockerId = 0;
function $ad33ab710a499f5f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $ad33ab710a499f5f$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $ad33ab710a499f5f$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $ad33ab710a499f5f$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $ad33ab710a499f5f$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$ad33ab710a499f5f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $ad33ab710a499f5f$export$386d57f03f0b2883;
}
function $ad33ab710a499f5f$var$useNavigateStable() {
    let { router: router } = $ad33ab710a499f5f$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $ad33ab710a499f5f$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $ad33ab710a499f5f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $ad33ab710a499f5f$var$warning(activeRef.current, $ad33ab710a499f5f$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $ad33ab710a499f5f$var$alreadyWarned = {};
function $ad33ab710a499f5f$var$warningOnce(key, cond, message) {
    if (!cond && !$ad33ab710a499f5f$var$alreadyWarned[key]) {
        $ad33ab710a499f5f$var$alreadyWarned[key] = true;
        $ad33ab710a499f5f$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $ad33ab710a499f5f$var$alreadyWarned2 = {};
function $ad33ab710a499f5f$var$warnOnce(condition, message) {
    if (!condition && !$ad33ab710a499f5f$var$alreadyWarned2[message]) {
        $ad33ab710a499f5f$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS2 = true;
function $ad33ab710a499f5f$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS2) {
            if (route.element) $ad33ab710a499f5f$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) $ad33ab710a499f5f$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($ad33ab710a499f5f$var$ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) $ad33ab710a499f5f$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function $ad33ab710a499f5f$export$f30f7e456d254e83(routes, opts) {
    return $ad33ab710a499f5f$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $ad33ab710a499f5f$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: $ad33ab710a499f5f$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $ad33ab710a499f5f$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $ad33ab710a499f5f$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $ad33ab710a499f5f$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $ad33ab710a499f5f$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $acw62.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ad33ab710a499f5f$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $acw62.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $ad33ab710a499f5f$var$MemoizedDataRoutes = $acw62.memo($ad33ab710a499f5f$var$DataRoutes);
function $ad33ab710a499f5f$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $ad33ab710a499f5f$var$useRoutesImpl(routes, void 0, state, future);
}
function $ad33ab710a499f5f$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $ad33ab710a499f5f$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ad33ab710a499f5f$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $ad33ab710a499f5f$export$f5708dca728d7177($ad33ab710a499f5f$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    $ad33ab710a499f5f$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let navigate = $ad33ab710a499f5f$export$9770f232ac06a008();
    let path = $ad33ab710a499f5f$var$resolveTo(to, $ad33ab710a499f5f$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $ad33ab710a499f5f$export$910ae8079b2c2852(props) {
    return $ad33ab710a499f5f$export$a3be3530d8e40d0b(props.context);
}
function $ad33ab710a499f5f$export$e7b0ac011bb776c6(_props) {
    $ad33ab710a499f5f$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $ad33ab710a499f5f$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    $ad33ab710a499f5f$export$f5708dca728d7177(!$ad33ab710a499f5f$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $ad33ab710a499f5f$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $ad33ab710a499f5f$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $ad33ab710a499f5f$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $ad33ab710a499f5f$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $ad33ab710a499f5f$export$5d3fca4a98652595($ad33ab710a499f5f$export$16da398f5434bdec(children), location);
}
function $ad33ab710a499f5f$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$ResolveAwait, null, children));
}
var $ad33ab710a499f5f$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $ad33ab710a499f5f$var$ResolveAwait({ children: children }) {
    let data2 = $ad33ab710a499f5f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $ad33ab710a499f5f$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $ad33ab710a499f5f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $ad33ab710a499f5f$export$f5708dca728d7177(element.type === $ad33ab710a499f5f$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $ad33ab710a499f5f$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $ad33ab710a499f5f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $ad33ab710a499f5f$export$9b5b6d122dea0c88 = $ad33ab710a499f5f$export$16da398f5434bdec;
function $ad33ab710a499f5f$export$daf73786167a7f72(matches) {
    return $ad33ab710a499f5f$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $ad33ab710a499f5f$var$defaultMethod = "get";
var $ad33ab710a499f5f$var$defaultEncType = "application/x-www-form-urlencoded";
function $ad33ab710a499f5f$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ad33ab710a499f5f$var$isButtonElement(object) {
    return $ad33ab710a499f5f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ad33ab710a499f5f$var$isFormElement(object) {
    return $ad33ab710a499f5f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ad33ab710a499f5f$var$isInputElement(object) {
    return $ad33ab710a499f5f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ad33ab710a499f5f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ad33ab710a499f5f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ad33ab710a499f5f$var$isModifiedEvent(event);
}
function $ad33ab710a499f5f$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ad33ab710a499f5f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ad33ab710a499f5f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $ad33ab710a499f5f$var$_formDataSupportsSubmitter = null;
function $ad33ab710a499f5f$var$isFormDataSubmitterSupported() {
    if ($ad33ab710a499f5f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ad33ab710a499f5f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ad33ab710a499f5f$var$_formDataSupportsSubmitter = true;
    }
    return $ad33ab710a499f5f$var$_formDataSupportsSubmitter;
}
var $ad33ab710a499f5f$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ad33ab710a499f5f$var$getFormEncType(encType) {
    if (encType != null && !$ad33ab710a499f5f$var$supportedFormEncTypes.has(encType)) {
        $ad33ab710a499f5f$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$ad33ab710a499f5f$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $ad33ab710a499f5f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ad33ab710a499f5f$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $ad33ab710a499f5f$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $ad33ab710a499f5f$var$defaultMethod;
        encType = $ad33ab710a499f5f$var$getFormEncType(target.getAttribute("enctype")) || $ad33ab710a499f5f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ad33ab710a499f5f$var$isButtonElement(target) || $ad33ab710a499f5f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $ad33ab710a499f5f$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ad33ab710a499f5f$var$defaultMethod;
        encType = $ad33ab710a499f5f$var$getFormEncType(target.getAttribute("formenctype")) || $ad33ab710a499f5f$var$getFormEncType(form.getAttribute("enctype")) || $ad33ab710a499f5f$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$ad33ab710a499f5f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ad33ab710a499f5f$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $ad33ab710a499f5f$var$defaultMethod;
        action = null;
        encType = $ad33ab710a499f5f$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $ad33ab710a499f5f$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $ad33ab710a499f5f$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $ad33ab710a499f5f$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $ad33ab710a499f5f$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href2)=>({
                    rel: "stylesheet",
                    href: href2
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $ad33ab710a499f5f$var$getModuleLinkHrefs(matches, manifest);
    return $ad33ab710a499f5f$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $ad33ab710a499f5f$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href2)=>({
            rel: "stylesheet",
            href: href2
        }));
}
async function $ad33ab710a499f5f$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $ad33ab710a499f5f$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($ad33ab710a499f5f$var$prefetchStyleLink));
}
async function $ad33ab710a499f5f$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$ad33ab710a499f5f$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$ad33ab710a499f5f$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$ad33ab710a499f5f$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($ad33ab710a499f5f$var$prefetchStyleLink));
}
async function $ad33ab710a499f5f$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $ad33ab710a499f5f$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $ad33ab710a499f5f$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $ad33ab710a499f5f$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $ad33ab710a499f5f$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $ad33ab710a499f5f$var$dedupeLinkDescriptors(links.flat(1).filter($ad33ab710a499f5f$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $ad33ab710a499f5f$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $ad33ab710a499f5f$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $ad33ab710a499f5f$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $ad33ab710a499f5f$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $ad33ab710a499f5f$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $ad33ab710a499f5f$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$ad33ab710a499f5f$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($ad33ab710a499f5f$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $ad33ab710a499f5f$var$_isPreloadSupported;
function $ad33ab710a499f5f$var$isPreloadSupported() {
    if ($ad33ab710a499f5f$var$_isPreloadSupported !== void 0) return $ad33ab710a499f5f$var$_isPreloadSupported;
    let el = document.createElement("link");
    $ad33ab710a499f5f$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $ad33ab710a499f5f$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $ad33ab710a499f5f$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $ad33ab710a499f5f$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $ad33ab710a499f5f$var$escapeHtml(html) {
    return html.replace($ad33ab710a499f5f$var$ESCAPE_REGEX, (match)=>$ad33ab710a499f5f$var$ESCAPE_LOOKUP[match]);
}
function $ad33ab710a499f5f$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function $ad33ab710a499f5f$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $ad33ab710a499f5f$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
function $ad33ab710a499f5f$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$ad33ab710a499f5f$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $ad33ab710a499f5f$export$c7c51be9b423c4d6(manifest, routeModules, ssr, getRouter) {
    return async ({ request: request, matches: matches, fetcherKey: fetcherKey })=>{
        if (request.method !== "GET") return $ad33ab710a499f5f$var$singleFetchActionStrategy(request, matches);
        if (!ssr) {
            let foundRevalidatingServerLoader = matches.some((m)=>m.shouldLoad && manifest.routes[m.route.id]?.hasLoader && !manifest.routes[m.route.id]?.hasClientLoader);
            if (!foundRevalidatingServerLoader) {
                let matchesToLoad = matches.filter((m)=>m.shouldLoad);
                let url = $ad33ab710a499f5f$var$stripIndexParam($ad33ab710a499f5f$var$singleFetchUrl(request.url));
                let init = await $ad33ab710a499f5f$var$createRequestInit(request);
                let results = {};
                await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
                        try {
                            let result = manifest.routes[m.route.id]?.hasClientLoader ? await $ad33ab710a499f5f$var$fetchSingleLoader(handler, url, init, m.route.id) : await handler();
                            results[m.route.id] = {
                                type: "data",
                                result: result
                            };
                        } catch (e) {
                            results[m.route.id] = {
                                type: "error",
                                result: e
                            };
                        }
                    })));
                return results;
            }
        }
        if (fetcherKey) return $ad33ab710a499f5f$var$singleFetchLoaderFetcherStrategy(request, matches);
        return $ad33ab710a499f5f$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, ssr, getRouter(), request, matches);
    };
}
async function $ad33ab710a499f5f$var$singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    $ad33ab710a499f5f$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = $ad33ab710a499f5f$var$singleFetchUrl(request.url);
            let init = await $ad33ab710a499f5f$var$createRequestInit(request);
            let { data: data2, status: status } = await $ad33ab710a499f5f$var$fetchAndDecode(url, init);
            actionStatus = status;
            return $ad33ab710a499f5f$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($ad33ab710a499f5f$var$isResponse(result.result) || $ad33ab710a499f5f$export$972111febbeef05b(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $ad33ab710a499f5f$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $ad33ab710a499f5f$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, ssr, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>$ad33ab710a499f5f$var$createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = $ad33ab710a499f5f$var$createDeferred2();
    let url = $ad33ab710a499f5f$var$stripIndexParam($ad33ab710a499f5f$var$singleFetchUrl(request.url));
    let init = await $ad33ab710a499f5f$var$createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await $ad33ab710a499f5f$var$fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $ad33ab710a499f5f$var$unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (ssr && foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await $ad33ab710a499f5f$var$fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function $ad33ab710a499f5f$var$singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    $ad33ab710a499f5f$var$invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = $ad33ab710a499f5f$var$stripIndexParam($ad33ab710a499f5f$var$singleFetchUrl(request.url));
        let init = await $ad33ab710a499f5f$var$createRequestInit(request);
        return $ad33ab710a499f5f$var$fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function $ad33ab710a499f5f$var$fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await $ad33ab710a499f5f$var$fetchAndDecode(singleLoaderUrl, init);
        return $ad33ab710a499f5f$var$unwrapSingleFetchResults(data2, routeId);
    });
}
function $ad33ab710a499f5f$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $ad33ab710a499f5f$var$singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $ad33ab710a499f5f$var$fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $ad33ab710a499f5f$export$f2680fa305b734ca(404, "Not Found", true);
    const NO_BODY_STATUS_CODES2 = /* @__PURE__ */ new Set([
        100,
        101,
        204,
        205
    ]);
    if (NO_BODY_STATUS_CODES2.has(res.status)) {
        if (!init.method || init.method === "GET") return {
            status: res.status,
            data: {}
        };
        else return {
            status: res.status,
            data: {
                data: void 0
            }
        };
    }
    $ad33ab710a499f5f$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $ad33ab710a499f5f$export$4023ad4ecd4126a2(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $ad33ab710a499f5f$export$4023ad4ecd4126a2(body, global2) {
    return (0, $413e902c144ded2c$exports.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $ad33ab710a499f5f$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$ad33ab710a499f5f$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $ad33ab710a499f5f$var$unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[$ad33ab710a499f5f$export$60644022b8b46aaa];
    if (redirect2) return $ad33ab710a499f5f$var$unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? $ad33ab710a499f5f$var$unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function $ad33ab710a499f5f$var$unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        throw $ad33ab710a499f5f$export$89e12c5b50f7529d(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function $ad33ab710a499f5f$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $ad33ab710a499f5f$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $ad33ab710a499f5f$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if ($ad33ab710a499f5f$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $ad33ab710a499f5f$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $ad33ab710a499f5f$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$ff0bf87698939488, null) : null)));
}
function $ad33ab710a499f5f$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function $ad33ab710a499f5f$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $ad33ab710a499f5f$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $ad33ab710a499f5f$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $ad33ab710a499f5f$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$RemixRootDefaultErrorBoundary, {
            error: $ad33ab710a499f5f$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $ad33ab710a499f5f$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $ad33ab710a499f5f$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $ad33ab710a499f5f$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$ad33ab710a499f5f$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $ad33ab710a499f5f$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $ad33ab710a499f5f$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $ad33ab710a499f5f$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $ad33ab710a499f5f$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $ad33ab710a499f5f$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $ad33ab710a499f5f$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $ad33ab710a499f5f$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $ad33ab710a499f5f$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $ad33ab710a499f5f$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $ad33ab710a499f5f$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $ad33ab710a499f5f$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $ad33ab710a499f5f$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $ad33ab710a499f5f$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$ad33ab710a499f5f$var$getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: $ad33ab710a499f5f$var$getShouldRevalidateFunction(routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $ad33ab710a499f5f$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            async serverLoader () {
                                $ad33ab710a499f5f$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $ad33ab710a499f5f$export$6ac68922d4e92125(route, routeModule, isSpaMode);
            dataRoute.action = ({ request: request, params: params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $ad33ab710a499f5f$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $ad33ab710a499f5f$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        async serverAction () {
                            $ad33ab710a499f5f$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            else if (route.clientLoaderModule) dataRoute.loader = async (args, singleFetch)=>{
                $ad33ab710a499f5f$var$invariant2(route.clientLoaderModule);
                let { clientLoader: clientLoader } = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule);
                return clientLoader({
                    ...args,
                    async serverLoader () {
                        $ad33ab710a499f5f$var$preventInvalidServerHandlerCall("loader", route);
                        return fetchServerLoader(singleFetch);
                    }
                });
            };
            if (!route.hasClientAction) dataRoute.action = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $ad33ab710a499f5f$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            else if (route.clientActionModule) dataRoute.action = async (args, singleFetch)=>{
                $ad33ab710a499f5f$var$invariant2(route.clientActionModule);
                prefetchRouteModuleChunks(route);
                let { clientAction: clientAction } = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule);
                return clientAction({
                    ...args,
                    async serverAction () {
                        $ad33ab710a499f5f$var$preventInvalidServerHandlerCall("action", route);
                        return fetchServerAction(singleFetch);
                    }
                });
            };
            dataRoute.lazy = async ()=>{
                if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                let modPromise = $ad33ab710a499f5f$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                prefetchRouteModuleChunks(route);
                let mod = await modPromise;
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $ad33ab710a499f5f$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $ad33ab710a499f5f$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: $ad33ab710a499f5f$var$getShouldRevalidateFunction(lazyRoute, route, ssr, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = $ad33ab710a499f5f$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $ad33ab710a499f5f$var$getShouldRevalidateFunction(route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $ad33ab710a499f5f$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: false
                });
        } else return ()=>false;
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $ad33ab710a499f5f$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $ad33ab710a499f5f$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $ad33ab710a499f5f$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $ad33ab710a499f5f$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $ad33ab710a499f5f$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $ad33ab710a499f5f$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $ad33ab710a499f5f$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $ad33ab710a499f5f$export$6ac68922d4e92125(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $ad33ab710a499f5f$var$nextPaths = /* @__PURE__ */ new Set();
var $ad33ab710a499f5f$var$discoveredPathsMaxSize = 1e3;
var $ad33ab710a499f5f$var$discoveredPaths = /* @__PURE__ */ new Set();
var $ad33ab710a499f5f$var$URL_LIMIT = 7680;
function $ad33ab710a499f5f$var$isFogOfWarEnabled(ssr) {
    return ssr === true;
}
function $ad33ab710a499f5f$var$getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $ad33ab710a499f5f$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function $ad33ab710a499f5f$export$72ab377a1030deb9(manifest, routeModules, ssr, isSpaMode, basename) {
    if (!$ad33ab710a499f5f$var$isFogOfWarEnabled(ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal })=>{
        if ($ad33ab710a499f5f$var$discoveredPaths.has(path)) return;
        await $ad33ab710a499f5f$var$fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, ssr, isSpaMode, basename, patch, signal);
    };
}
function $ad33ab710a499f5f$export$5ef046b23d96090d(router, manifest, routeModules, ssr, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$ad33ab710a499f5f$var$isFogOfWarEnabled(ssr) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$ad33ab710a499f5f$var$discoveredPaths.has(pathname)) $ad33ab710a499f5f$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($ad33ab710a499f5f$var$nextPaths.keys()).filter((path)=>{
                if ($ad33ab710a499f5f$var$discoveredPaths.has(path)) {
                    $ad33ab710a499f5f$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $ad33ab710a499f5f$var$fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, ssr, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $ad33ab710a499f5f$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function $ad33ab710a499f5f$var$fetchAndApplyManifestPatches(paths, manifest, routeModules, ssr, isSpaMode, basename, patchRoutes, signal) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $ad33ab710a499f5f$var$URL_LIMIT) {
        $ad33ab710a499f5f$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status >= 400) throw new Error(await res.text());
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$ad33ab710a499f5f$var$addToFifoQueue(p, $ad33ab710a499f5f$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $ad33ab710a499f5f$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $ad33ab710a499f5f$var$addToFifoQueue(path, queue) {
    if (queue.size >= $ad33ab710a499f5f$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $ad33ab710a499f5f$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $ad33ab710a499f5f$var$useDataRouterContext2() {
    let context = $acw62.useContext($ad33ab710a499f5f$export$2eeee58951ff3c1c);
    $ad33ab710a499f5f$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $ad33ab710a499f5f$var$useDataRouterStateContext() {
    let context = $acw62.useContext($ad33ab710a499f5f$export$315e3ffb01f217);
    $ad33ab710a499f5f$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $ad33ab710a499f5f$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$ad33ab710a499f5f$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $ad33ab710a499f5f$var$useFrameworkContext() {
    let context = $acw62.useContext($ad33ab710a499f5f$export$208d6a3bc3aa62bd);
    $ad33ab710a499f5f$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $ad33ab710a499f5f$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($ad33ab710a499f5f$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $ad33ab710a499f5f$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $ad33ab710a499f5f$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $ad33ab710a499f5f$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $ad33ab710a499f5f$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $ad33ab710a499f5f$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $ad33ab710a499f5f$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $ad33ab710a499f5f$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$ad33ab710a499f5f$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $ad33ab710a499f5f$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $ad33ab710a499f5f$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $ad33ab710a499f5f$var$useDataRouterStateContext();
    let matches = $ad33ab710a499f5f$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$ad33ab710a499f5f$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, criticalCss ? /* @__PURE__ */ $acw62.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key: key, link: link })=>$ad33ab710a499f5f$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $ad33ab710a499f5f$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $ad33ab710a499f5f$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$ad33ab710a499f5f$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $ad33ab710a499f5f$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $ad33ab710a499f5f$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $ad33ab710a499f5f$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $ad33ab710a499f5f$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $ad33ab710a499f5f$var$useFrameworkContext();
    let { loaderData: loaderData, matches: matches } = $ad33ab710a499f5f$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$ad33ab710a499f5f$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$ad33ab710a499f5f$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $ad33ab710a499f5f$var$singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$ad33ab710a499f5f$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $ad33ab710a499f5f$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href2)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href2,
            rel: "prefetch",
            as: "fetch",
            href: href2,
            ...linkProps
        })), moduleHrefs.map((href2)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href2,
            rel: "modulepreload",
            href: href2,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $ad33ab710a499f5f$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $ad33ab710a499f5f$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $ad33ab710a499f5f$var$useDataRouterStateContext();
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let _matches = $ad33ab710a499f5f$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$ad33ab710a499f5f$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $ad33ab710a499f5f$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $ad33ab710a499f5f$var$isHydrated = false;
function $ad33ab710a499f5f$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, ssr: ssr, renderMeta: renderMeta } = $ad33ab710a499f5f$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $ad33ab710a499f5f$var$useDataRouterContext2();
    let { matches: routerMatches } = $ad33ab710a499f5f$var$useDataRouterStateContext();
    let enableFogOfWar = $ad33ab710a499f5f$var$isFogOfWarEnabled(ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $ad33ab710a499f5f$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $ad33ab710a499f5f$var$isHydrated = true;
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $ad33ab710a499f5f$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($ad33ab710a499f5f$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $ad33ab710a499f5f$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $ad33ab710a499f5f$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $ad33ab710a499f5f$var$isHydrated ? [] : manifest.entry.imports.concat($ad33ab710a499f5f$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    }));
    return $ad33ab710a499f5f$var$isHydrated ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), $ad33ab710a499f5f$var$dedupe(preloads).map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function $ad33ab710a499f5f$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $ad33ab710a499f5f$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $ad33ab710a499f5f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($ad33ab710a499f5f$var$isBrowser) window.__reactRouterVersion = "7.2.0";
} catch (e) {}
function $ad33ab710a499f5f$export$1f3f55432a00e06d(routes, opts) {
    return $ad33ab710a499f5f$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $ad33ab710a499f5f$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $ad33ab710a499f5f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $ad33ab710a499f5f$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $ad33ab710a499f5f$export$1ba7ed8a3a7b3765(routes, opts) {
    return $ad33ab710a499f5f$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $ad33ab710a499f5f$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $ad33ab710a499f5f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $ad33ab710a499f5f$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $ad33ab710a499f5f$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $ad33ab710a499f5f$var$deserializeErrors(state.errors)
    };
    return state;
}
function $ad33ab710a499f5f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $ad33ab710a499f5f$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $ad33ab710a499f5f$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $ad33ab710a499f5f$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ad33ab710a499f5f$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $ad33ab710a499f5f$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ad33ab710a499f5f$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$ad33ab710a499f5f$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ad33ab710a499f5f$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($ad33ab710a499f5f$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $ad33ab710a499f5f$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $ad33ab710a499f5f$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href2 = $ad33ab710a499f5f$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $ad33ab710a499f5f$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $ad33ab710a499f5f$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href2,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $ad33ab710a499f5f$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$60dcec93e67386bd, {
        page: href2
    })) : link;
});
$ad33ab710a499f5f$export$a6c7ac8248d6e38a.displayName = "Link";
var $ad33ab710a499f5f$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $ad33ab710a499f5f$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($ad33ab710a499f5f$export$315e3ffb01f217);
    let { navigator: navigator2, basename: basename } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ad33ab710a499f5f$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $ad33ab710a499f5f$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$ad33ab710a499f5f$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $ad33ab710a499f5f$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $ad33ab710a499f5f$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $ad33ab710a499f5f$export$47c85c6e3a081d3();
    let formAction = $ad33ab710a499f5f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$ad33ab710a499f5f$export$a7fed597f4b8afd8.displayName = "Form";
function $ad33ab710a499f5f$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($ad33ab710a499f5f$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let matches = $ad33ab710a499f5f$export$2378eb7f5ff86053();
    $ad33ab710a499f5f$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $ad33ab710a499f5f$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $ad33ab710a499f5f$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$ad33ab710a499f5f$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $ad33ab710a499f5f$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $ad33ab710a499f5f$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($ad33ab710a499f5f$export$2eeee58951ff3c1c);
    $ad33ab710a499f5f$export$f5708dca728d7177(ctx, $ad33ab710a499f5f$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $ad33ab710a499f5f$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($ad33ab710a499f5f$export$315e3ffb01f217);
    $ad33ab710a499f5f$export$f5708dca728d7177(state, $ad33ab710a499f5f$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $ad33ab710a499f5f$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $ad33ab710a499f5f$export$9770f232ac06a008();
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let path = $ad33ab710a499f5f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($ad33ab710a499f5f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $ad33ab710a499f5f$export$fe53371bee54353d(location) === $ad33ab710a499f5f$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $ad33ab710a499f5f$export$f1a78c17382fe22a(defaultInit) {
    $ad33ab710a499f5f$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($ad33ab710a499f5f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ad33ab710a499f5f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $ad33ab710a499f5f$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ad33ab710a499f5f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $ad33ab710a499f5f$var$fetcherId = 0;
var $ad33ab710a499f5f$var$getUniqueFetcherId = ()=>`__${String(++$ad33ab710a499f5f$var$fetcherId)}__`;
function $ad33ab710a499f5f$export$47c85c6e3a081d3() {
    let { router: router } = $ad33ab710a499f5f$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let currentRouteId = $ad33ab710a499f5f$var$useRouteId();
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ad33ab710a499f5f$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ad33ab710a499f5f$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $ad33ab710a499f5f$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    $ad33ab710a499f5f$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$ad33ab710a499f5f$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $ad33ab710a499f5f$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $ad33ab710a499f5f$export$fe53371bee54353d(path);
}
function $ad33ab710a499f5f$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $ad33ab710a499f5f$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $ad33ab710a499f5f$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($ad33ab710a499f5f$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($ad33ab710a499f5f$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $ad33ab710a499f5f$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $ad33ab710a499f5f$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $ad33ab710a499f5f$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href2, opts)=>{
        $ad33ab710a499f5f$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href2, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ad33ab710a499f5f$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $ad33ab710a499f5f$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $ad33ab710a499f5f$export$fa996778a3a31087() {
    let state = $ad33ab710a499f5f$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $ad33ab710a499f5f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $ad33ab710a499f5f$var$savedScrollPositions = {};
function $ad33ab710a499f5f$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $ad33ab710a499f5f$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $ad33ab710a499f5f$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $ad33ab710a499f5f$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ad33ab710a499f5f$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($ad33ab710a499f5f$export$3044ab7fdabeaee6);
    let location = $ad33ab710a499f5f$export$45d76561a5302f2b();
    let matches = $ad33ab710a499f5f$export$2378eb7f5ff86053();
    let navigation = $ad33ab710a499f5f$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $ad33ab710a499f5f$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $ad33ab710a499f5f$var$getScrollRestorationKey(location, matches, basename, getKey);
            $ad33ab710a499f5f$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ad33ab710a499f5f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ad33ab710a499f5f$var$savedScrollPositions));
        } catch (error) {
            $ad33ab710a499f5f$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ad33ab710a499f5f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ad33ab710a499f5f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($ad33ab710a499f5f$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$ad33ab710a499f5f$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $ad33ab710a499f5f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $ad33ab710a499f5f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $ad33ab710a499f5f$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $ad33ab710a499f5f$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $ad33ab710a499f5f$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $acw62.useContext($ad33ab710a499f5f$export$3681f408decb40d1);
    $ad33ab710a499f5f$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $ad33ab710a499f5f$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $ad33ab710a499f5f$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $ad33ab710a499f5f$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $ad33ab710a499f5f$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $ad33ab710a499f5f$export$81336c211d5ff295(path.pathname, nextPath) != null || $ad33ab710a499f5f$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $ad33ab710a499f5f$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $ad33ab710a499f5f$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $ad33ab710a499f5f$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $ad33ab710a499f5f$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    $ad33ab710a499f5f$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $ad33ab710a499f5f$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $ad33ab710a499f5f$var$serializeErrors(context.errors)
        };
        let json = $ad33ab710a499f5f$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $ad33ab710a499f5f$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $ad33ab710a499f5f$var$useRoutesImpl(routes, void 0, state, future);
}
function $ad33ab710a499f5f$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($ad33ab710a499f5f$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $ad33ab710a499f5f$var$getStatelessNavigator() {
    return {
        createHref: $ad33ab710a499f5f$var$createHref,
        encodeLocation: $ad33ab710a499f5f$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $ad33ab710a499f5f$export$3336b097a6fbc59a(routes, opts) {
    return $ad33ab710a499f5f$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $ad33ab710a499f5f$export$9269a41d8c4635e
    });
}
function $ad33ab710a499f5f$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $ad33ab710a499f5f$var$convertRoutesToDataRoutes(routes, $ad33ab710a499f5f$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $ad33ab710a499f5f$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $ad33ab710a499f5f$var$createHref,
        encodeLocation: $ad33ab710a499f5f$var$encodeLocation,
        getFetcher () {
            return $ad33ab710a499f5f$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $ad33ab710a499f5f$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $ad33ab710a499f5f$var$createHref(to) {
    return typeof to === "string" ? to : $ad33ab710a499f5f$export$fe53371bee54353d(to);
}
function $ad33ab710a499f5f$var$encodeLocation(to) {
    let href2 = typeof to === "string" ? to : $ad33ab710a499f5f$export$fe53371bee54353d(to);
    href2 = href2.replace(/ $/, "%20");
    let encoded = $ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX3.test(href2) ? new URL(href2) : new URL(href2, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $ad33ab710a499f5f$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ad33ab710a499f5f$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $ad33ab710a499f5f$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $ad33ab710a499f5f$var$htmlEscape(str) {
    return str.replace($ad33ab710a499f5f$var$ESCAPE_REGEX2, (match)=>$ad33ab710a499f5f$var$ESCAPE_LOOKUP2[match]);
}
function $ad33ab710a499f5f$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $ad33ab710a499f5f$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $ad33ab710a499f5f$export$6ac68922d4e92125(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $ad33ab710a499f5f$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $ad33ab710a499f5f$export$bea31554c7dfd2ad(routes, context = {}) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $acw62.useRef();
        let remixContextRef = $acw62.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false
            };
            let patched = $ad33ab710a499f5f$var$processRoutes(// @ts-expect-error loader/action context types don't match :/
            $ad33ab710a499f5f$var$convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $ad33ab710a499f5f$export$f30f7e456d254e83(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $acw62.createElement($ad33ab710a499f5f$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $ad33ab710a499f5f$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader: loader, action: action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context: context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context: context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || $ad33ab710a499f5f$export$910ae8079b2c2852,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $ad33ab710a499f5f$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $ad33ab710a499f5f$var$encoder = new TextEncoder();
var $ad33ab710a499f5f$var$sign = async (value, secret)=>{
    let data2 = $ad33ab710a499f5f$var$encoder.encode(value);
    let key = await $ad33ab710a499f5f$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $ad33ab710a499f5f$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $ad33ab710a499f5f$var$encoder.encode(value);
    let key = await $ad33ab710a499f5f$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $ad33ab710a499f5f$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $ad33ab710a499f5f$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $ad33ab710a499f5f$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $ad33ab710a499f5f$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $ad33ab710a499f5f$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $ad33ab710a499f5f$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $9fd38747d73cb940$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $ad33ab710a499f5f$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $9fd38747d73cb940$exports.serialize)(name, value === "" ? "" : await $ad33ab710a499f5f$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $ad33ab710a499f5f$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $ad33ab710a499f5f$var$encodeCookieValue(value, secrets) {
    let encoded = $ad33ab710a499f5f$var$encodeData(value);
    if (secrets.length > 0) encoded = await $ad33ab710a499f5f$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $ad33ab710a499f5f$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $ad33ab710a499f5f$var$unsign(value, secret);
            if (unsignedValue !== false) return $ad33ab710a499f5f$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $ad33ab710a499f5f$var$decodeData(value);
}
function $ad33ab710a499f5f$var$encodeData(value) {
    return btoa($ad33ab710a499f5f$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $ad33ab710a499f5f$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($ad33ab710a499f5f$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $ad33ab710a499f5f$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $ad33ab710a499f5f$var$hex(code, 2);
            else result += "%u" + $ad33ab710a499f5f$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $ad33ab710a499f5f$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $ad33ab710a499f5f$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $ad33ab710a499f5f$var$warnOnceAboutExpiresCookie(name, expires) {
    $ad33ab710a499f5f$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $ad33ab710a499f5f$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $ad33ab710a499f5f$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($ad33ab710a499f5f$export$e7973f87fd96e4f2 || {});
function $ad33ab710a499f5f$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $ad33ab710a499f5f$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $ad33ab710a499f5f$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $ad33ab710a499f5f$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $ad33ab710a499f5f$var$serializeError(error, serverMode) {
    let sanitized = $ad33ab710a499f5f$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $ad33ab710a499f5f$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($ad33ab710a499f5f$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $ad33ab710a499f5f$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $ad33ab710a499f5f$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $ad33ab710a499f5f$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $ad33ab710a499f5f$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $ad33ab710a499f5f$var$stripRoutesParam($ad33ab710a499f5f$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($ad33ab710a499f5f$var$isDataWithResponseInit(result) && result.init && result.init.status && $ad33ab710a499f5f$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $ad33ab710a499f5f$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $ad33ab710a499f5f$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $ad33ab710a499f5f$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function $ad33ab710a499f5f$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $ad33ab710a499f5f$var$createRoutes(manifest, parentId = "", routesByParentId = $ad33ab710a499f5f$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $ad33ab710a499f5f$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $ad33ab710a499f5f$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $ad33ab710a499f5f$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $ad33ab710a499f5f$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $ad33ab710a499f5f$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    $ad33ab710a499f5f$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    $ad33ab710a499f5f$var$invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await $ad33ab710a499f5f$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$ad33ab710a499f5f$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $ad33ab710a499f5f$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $ad33ab710a499f5f$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $ad33ab710a499f5f$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $ad33ab710a499f5f$var$escapeHtml2(html) {
    return html.replace($ad33ab710a499f5f$var$ESCAPE_REGEX3, (match)=>$ad33ab710a499f5f$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $ad33ab710a499f5f$var$createServerHandoffString(serverHandoff) {
    return $ad33ab710a499f5f$var$escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var $ad33ab710a499f5f$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $ad33ab710a499f5f$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$ad33ab710a499f5f$var$globalDevServerHooksKey] = devServerHooks;
}
function $ad33ab710a499f5f$var$getDevServerHooks() {
    return globalThis[$ad33ab710a499f5f$var$globalDevServerHooksKey];
}
function $ad33ab710a499f5f$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $ad33ab710a499f5f$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $ad33ab710a499f5f$var$prependCookies(errorHeaders, headers2);
            $ad33ab710a499f5f$var$prependCookies(actionHeaders, headers2);
            $ad33ab710a499f5f$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $ad33ab710a499f5f$var$prependCookies(errorHeaders, headers);
        $ad33ab710a499f5f$var$prependCookies(actionHeaders, headers);
        $ad33ab710a499f5f$var$prependCookies(loaderHeaders, headers);
        $ad33ab710a499f5f$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $ad33ab710a499f5f$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $e4a96bcce5e8f1ac$exports.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $ad33ab710a499f5f$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
function $ad33ab710a499f5f$var$getSingleFetchDataStrategy2({ isActionDataRequest: isActionDataRequest, loadRouteIds: loadRouteIds } = {}) {
    return async ({ request: request, matches: matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function $ad33ab710a499f5f$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $ad33ab710a499f5f$var$getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if ($ad33ab710a499f5f$var$isResponse(result)) return {
            result: $ad33ab710a499f5f$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $ad33ab710a499f5f$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $ad33ab710a499f5f$var$getDocumentHeaders(build, context);
        if ($ad33ab710a499f5f$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: $ad33ab710a499f5f$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers: headers,
            status: $ad33ab710a499f5f$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$ad33ab710a499f5f$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $ad33ab710a499f5f$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function $ad33ab710a499f5f$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $ad33ab710a499f5f$var$getSingleFetchDataStrategy2({
                loadRouteIds: loadRouteIds
            })
        });
        if ($ad33ab710a499f5f$var$isResponse(result)) return {
            result: {
                [$ad33ab710a499f5f$export$60644022b8b46aaa]: $ad33ab710a499f5f$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $ad33ab710a499f5f$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $ad33ab710a499f5f$var$getDocumentHeaders(build, context);
        if ($ad33ab710a499f5f$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [$ad33ab710a499f5f$export$60644022b8b46aaa]: $ad33ab710a499f5f$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers: headers,
            status: $ad33ab710a499f5f$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$ad33ab710a499f5f$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $ad33ab710a499f5f$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id: id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function $ad33ab710a499f5f$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $ad33ab710a499f5f$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $ad33ab710a499f5f$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $413e902c144ded2c$exports.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $ad33ab710a499f5f$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $ad33ab710a499f5f$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $ad33ab710a499f5f$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$ad33ab710a499f5f$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
var $ad33ab710a499f5f$var$NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205,
    304
]);
function $ad33ab710a499f5f$var$derive(build, mode) {
    let routes = $ad33ab710a499f5f$var$createRoutes(build.routes);
    let dataRoutes = $ad33ab710a499f5f$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $ad33ab710a499f5f$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $ad33ab710a499f5f$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $ad33ab710a499f5f$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $ad33ab710a499f5f$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $ad33ab710a499f5f$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $ad33ab710a499f5f$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let normalizedPath = url.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
        if (normalizedPath !== "/" && normalizedPath.endsWith("/")) normalizedPath = normalizedPath.slice(0, -1);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $ad33ab710a499f5f$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (!_build.ssr) {
            if (_build.prerender.length === 0) request.headers.set("X-React-Router-SPA-Mode", "yes");
            else if (!_build.prerender.includes(normalizedPath) && !_build.prerender.includes(normalizedPath + "/")) {
                if (url.pathname.endsWith(".data")) {
                    errorHandler(new $ad33ab710a499f5f$export$f2680fa305b734ca(404, "Not Found", `Refusing to SSR the path \`${normalizedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else request.headers.set("X-React-Router-SPA-Mode", "yes");
            }
        }
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await $ad33ab710a499f5f$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $ad33ab710a499f5f$var$matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = normalizedPath;
            let singleFetchMatches = $ad33ab710a499f5f$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $ad33ab710a499f5f$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($ad33ab710a499f5f$var$isRedirectResponse(response)) {
                    let result = $ad33ab710a499f5f$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$ad33ab710a499f5f$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($ad33ab710a499f5f$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $ad33ab710a499f5f$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $ad33ab710a499f5f$var$handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await $ad33ab710a499f5f$var$getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await $ad33ab710a499f5f$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $ad33ab710a499f5f$var$handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = $ad33ab710a499f5f$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $ad33ab710a499f5f$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result: result, headers: headers, status: status } = request.method !== "GET" ? await $ad33ab710a499f5f$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $ad33ab710a499f5f$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($ad33ab710a499f5f$var$NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($ad33ab710a499f5f$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function $ad33ab710a499f5f$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let isSpaMode = request.headers.has("X-React-Router-SPA-Mode");
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if ($ad33ab710a499f5f$var$isResponse(context)) return context;
    let headers = $ad33ab710a499f5f$var$getDocumentHeaders(build, context);
    if ($ad33ab710a499f5f$var$NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
        status: context.statusCode,
        headers: headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!$ad33ab710a499f5f$export$972111febbeef05b(err) || err.error) handleError(err);
        });
        context.errors = $ad33ab710a499f5f$var$sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: $ad33ab710a499f5f$var$serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: $ad33ab710a499f5f$var$createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss: criticalCss,
        serverHandoffString: $ad33ab710a499f5f$var$createServerHandoffString({
            basename: build.basename,
            criticalCss: criticalCss,
            future: build.future,
            ssr: build.ssr,
            isSpaMode: isSpaMode
        }),
        serverHandoffStream: $ad33ab710a499f5f$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        ssr: build.ssr,
        isSpaMode: isSpaMode,
        serializeError: (err)=>$ad33ab710a499f5f$var$serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if ($ad33ab710a499f5f$var$isResponse(error)) try {
            let data2 = await $ad33ab710a499f5f$var$unwrapResponse(error);
            errorForSecondRender = new $ad33ab710a499f5f$export$f2680fa305b734ca(error.status, error.statusText, data2);
        } catch (e) {}
        context = $ad33ab710a499f5f$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = $ad33ab710a499f5f$var$sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $ad33ab710a499f5f$var$serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: $ad33ab710a499f5f$var$createServerHandoffString({
                basename: build.basename,
                future: build.future,
                ssr: build.ssr,
                isSpaMode: isSpaMode
            }),
            serverHandoffStream: $ad33ab710a499f5f$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return $ad33ab710a499f5f$var$returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function $ad33ab710a499f5f$var$handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext
        });
        if ($ad33ab710a499f5f$var$isResponse(response)) return response;
        if (typeof response === "string") return new Response(response);
        return Response.json(response);
    } catch (error) {
        if ($ad33ab710a499f5f$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($ad33ab710a499f5f$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $ad33ab710a499f5f$var$errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return $ad33ab710a499f5f$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $ad33ab710a499f5f$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($ad33ab710a499f5f$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $ad33ab710a499f5f$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $ad33ab710a499f5f$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $ad33ab710a499f5f$var$flash(name) {
    return `__flash_${name}__`;
}
var $ad33ab710a499f5f$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($ad33ab710a499f5f$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $ad33ab710a499f5f$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($ad33ab710a499f5f$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $ad33ab710a499f5f$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $ad33ab710a499f5f$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $ad33ab710a499f5f$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $ad33ab710a499f5f$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $ad33ab710a499f5f$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $ad33ab710a499f5f$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $ad33ab710a499f5f$var$warnOnceAboutSigningSessionCookie(cookie) {
    $ad33ab710a499f5f$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $ad33ab710a499f5f$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $ad33ab710a499f5f$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $ad33ab710a499f5f$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $ad33ab710a499f5f$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $ad33ab710a499f5f$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $ad33ab710a499f5f$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $ad33ab710a499f5f$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $ad33ab710a499f5f$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    return path.split("/").map((segment)=>{
        const match = segment.match(/^:([\w-]+)(\?)?/);
        if (!match) return segment;
        const param = match[1];
        const value = params ? params[param] : void 0;
        const isRequired = match[2] === void 0;
        if (isRequired && value === void 0) throw Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value;
    }).filter((segment)=>segment !== void 0).join("/");
}
// lib/dom/ssr/errors.ts
function $ad33ab710a499f5f$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $ad33ab710a499f5f$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}


const $e73bf42412feb220$var$searchClient = (0, (/*@__PURE__*/$parcel$interopDefault($44f3a3b8f746079c$exports)))('64LMXTN0XN', '79c4a700b51a2af70dd807fb5a61decb');
const $e73bf42412feb220$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e5f7835a5ca2069$export$2e2bcd8739ae039), {
        searchClient: $e73bf42412feb220$var$searchClient,
        indexName: "prod_state-of-finops",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad33ab710a499f5f$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ad33ab710a499f5f$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad33ab710a499f5f$export$e7b0ac011bb776c6), {
                        path: '/',
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05850e1a23ee861e$export$b94310965bed44e6), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad33ab710a499f5f$export$e7b0ac011bb776c6), {
                        path: '/library',
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efff4cf968573785$export$cf5e27b88d55fab4), {})
                    })
                ]
            })
        })
    });
};
(0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("dataApp")).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e73bf42412feb220$var$App, {}));


//# sourceMappingURL=index.0509314f.js.map
